function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e282) { throw _e282; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e283) { didErr = true; err = _e283; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function (t) {
  t.en = Object.assign(t.en || {}, {
    a: "Cannot upload file:",
    b: "Image toolbar",
    c: "Table toolbar",
    d: "Bold",
    e: "Italic",
    f: "Block quote",
    g: "Insert image or file",
    h: "Choose heading",
    i: "Heading",
    j: "image widget",
    k: "Full size image",
    l: "Side image",
    m: "Left aligned image",
    n: "Centered image",
    o: "Right aligned image",
    p: "Insert image",
    q: "Numbered List",
    r: "Bulleted List",
    s: "Insert table",
    t: "Header column",
    u: "Insert column left",
    v: "Insert column right",
    w: "Delete column",
    x: "Column",
    y: "Header row",
    z: "Insert row below",
    aa: "Insert row above",
    ab: "Delete row",
    ac: "Row",
    ad: "Merge cell up",
    ae: "Merge cell right",
    af: "Merge cell down",
    ag: "Merge cell left",
    ah: "Split cell vertically",
    ai: "Split cell horizontally",
    aj: "Merge cells",
    ak: "Enter image caption",
    al: "Upload failed",
    am: "media widget",
    an: "Insert media",
    ao: "The URL must not be empty.",
    ap: "This media URL is not supported.",
    aq: "Link",
    ar: "Could not obtain resized image URL.",
    as: "Selecting resized image failed",
    at: "Could not insert image at the current position.",
    au: "Inserting image failed",
    av: "Widget toolbar",
    aw: "Upload in progress",
    ax: "Open in a new tab",
    ay: "Downloadable",
    az: "Unlink",
    ba: "Edit link",
    bb: "Open link in new tab",
    bc: "This link has no URL",
    bd: "Save",
    be: "Cancel",
    bf: "Link URL",
    bg: "Paste the media URL in the input.",
    bh: "Tip: Paste the URL into the content to embed faster.",
    bi: "Media URL",
    bj: "Undo",
    bk: "Redo",
    bl: "Editor toolbar",
    bm: "Rich Text Editor, %0",
    bn: "Rich Text Editor",
    bo: "Dropdown toolbar",
    bp: "%0 of %1",
    bq: "Previous",
    br: "Next",
    bs: "Change image text alternative",
    bt: "Paragraph",
    bu: "Heading 1",
    bv: "Heading 2",
    bw: "Heading 3",
    bx: "Heading 4",
    by: "Heading 5",
    bz: "Heading 6",
    ca: "Text alternative"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ClassicEditor = e() : t.ClassicEditor = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(i) {
      if (e[i]) return e[i].exports;
      var o = e[i] = {
        i: i,
        l: !1,
        exports: {}
      };
      return t[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: i
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var i = Object.create(null);
      if (n.r(i), Object.defineProperty(i, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(i, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return i;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 91);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "b", function () {
      return o;
    }), n.d(e, "a", function () {
      return r;
    });
    var i = "https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html";

    var o = /*#__PURE__*/function (_Error) {
      _inherits(o, _Error);

      var _super = _createSuper(o);

      function o(t, e, n) {
        var _this;

        _classCallCheck(this, o);

        t = r(t), n && (t += " " + JSON.stringify(n)), _this = _super.call(this, t), _this.name = "CKEditorError", _this.context = e, _this.data = n;
        return _this;
      }

      _createClass(o, [{
        key: "is",
        value: function is(t) {
          return "CKEditorError" === t;
        }
      }]);

      return o;
    }( /*#__PURE__*/_wrapNativeSuper(Error));

    function r(t) {
      var e = t.match(/^([^:]+):/);
      return e ? t + " Read more: ".concat(i, "#error-").concat(e[1], "\n") : t;
    }
  }, function (t, e, n) {
    "use strict";

    var i = {},
        o = function () {
      var t;
      return function () {
        return void 0 === t && (t = Boolean(window && document && document.all && !window.atob)), t;
      };
    }(),
        r = function () {
      var t = {};
      return function (e) {
        if (void 0 === t[e]) {
          var n = document.querySelector(e);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }();

    function s(t, e) {
      for (var n = [], i = {}, o = 0; o < t.length; o++) {
        var r = t[o],
            s = e.base ? r[0] + e.base : r[0],
            a = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        i[s] ? i[s].parts.push(a) : n.push(i[s] = {
          id: s,
          parts: [a]
        });
      }

      return n;
    }

    function a(t, e) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n],
            r = i[o.id],
            s = 0;

        if (r) {
          for (r.refs++; s < r.parts.length; s++) {
            r.parts[s](o.parts[s]);
          }

          for (; s < o.parts.length; s++) {
            r.parts.push(f(o.parts[s], e));
          }
        } else {
          for (var a = []; s < o.parts.length; s++) {
            a.push(f(o.parts[s], e));
          }

          i[o.id] = {
            id: o.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function c(t) {
      var e = document.createElement("style");

      if (void 0 === t.attributes.nonce) {
        var i = n.nc;
        i && (t.attributes.nonce = i);
      }

      if (Object.keys(t.attributes).forEach(function (n) {
        e.setAttribute(n, t.attributes[n]);
      }), "function" == typeof t.insert) t.insert(e);else {
        var o = r(t.insert || "head");
        if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        o.appendChild(e);
      }
      return e;
    }

    var l = function () {
      var t = [];
      return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();

    function d(t, e, n, i) {
      var o = n ? "" : i.css;
      if (t.styleSheet) t.styleSheet.cssText = l(e, o);else {
        var r = document.createTextNode(o),
            s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(r, s[e]) : t.appendChild(r);
      }
    }

    var h = null,
        u = 0;

    function f(t, e) {
      var n, i, o;

      if (e.singleton) {
        var r = u++;
        n = h || (h = c(e)), i = d.bind(null, n, r, !1), o = d.bind(null, n, r, !0);
      } else n = c(e), i = function (t, e, n) {
        var i = n.css,
            o = n.media,
            r = n.sourceMap;
        if (o && t.setAttribute("media", o), r && btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), t.styleSheet) t.styleSheet.cssText = i;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(i));
        }
      }.bind(null, n, e), o = function o() {
        !function (t) {
          if (null === t.parentNode) return !1;
          t.parentNode.removeChild(t);
        }(n);
      };

      return i(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          i(t = e);
        } else o();
      };
    }

    t.exports = function (t, e) {
      (e = e || {}).attributes = "object" == _typeof(e.attributes) ? e.attributes : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = o());
      var n = s(t, e);
      return a(n, e), function (t) {
        for (var o = [], r = 0; r < n.length; r++) {
          var c = n[r],
              l = i[c.id];
          l && (l.refs--, o.push(l));
        }

        t && a(s(t, e), e);

        for (var d = 0; d < o.length; d++) {
          var h = o[d];

          if (0 === h.refs) {
            for (var u = 0; u < h.parts.length; u++) {
              h.parts[u]();
            }

            delete i[h.id];
          }
        }
      };
    };
  },, function (t, e, n) {
    "use strict";

    var i = n(7),
        o = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
        r = i.a || o || Function("return this")();
    e.a = r;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(7),
          o = "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && exports && !exports.nodeType && exports,
          r = o && "object" == _typeof(t) && t && !t.nodeType && t,
          s = r && r.exports === o && i.a.process,
          a = function () {
        try {
          var t = r && r.require && r.require("util").types;

          return t || s && s.binding && s.binding("util");
        } catch (t) {}
      }();

      e.a = a;
    }).call(this, n(8)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(3),
          o = n(11),
          r = "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && exports && !exports.nodeType && exports,
          s = r && "object" == _typeof(t) && t && !t.nodeType && t,
          a = s && s.exports === r ? i.a.Buffer : void 0,
          c = (a ? a.isBuffer : void 0) || o.a;
      e.a = c;
    }).call(this, n(8)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var e = n(13),
          i = n(0);
      var o = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? window : t;
      if (o.CKEDITOR_VERSION) throw new i.b("ckeditor-duplicated-modules: Some CKEditor 5 modules are duplicated.", null);
      o.CKEDITOR_VERSION = e.a;
    }).call(this, n(9));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = "object" == _typeof(t) && t && t.Object === Object && t;
      e.a = n;
    }).call(this, n(9));
  }, function (t, e) {
    t.exports = function (t) {
      if (!t.webpackPolyfill) {
        var e = Object.create(t);
        e.children || (e.children = []), Object.defineProperty(e, "loaded", {
          enumerable: !0,
          get: function get() {
            return e.l;
          }
        }), Object.defineProperty(e, "id", {
          enumerable: !0,
          get: function get() {
            return e.i;
          }
        }), Object.defineProperty(e, "exports", {
          enumerable: !0
        }), e.webpackPolyfill = 1;
      }

      return e;
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    var i = n(68);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e, n) {
    "use strict";

    e.a = function () {
      return !1;
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var i = n(3),
          o = "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && exports && !exports.nodeType && exports,
          r = o && "object" == _typeof(t) && t && !t.nodeType && t,
          s = r && r.exports === o ? i.a.Buffer : void 0,
          a = s ? s.allocUnsafe : void 0;

      e.a = function (t, e) {
        if (e) return t.slice();
        var n = t.length,
            i = a ? a(n) : new t.constructor(n);
        return t.copy(i), i;
      };
    }).call(this, n(8)(t));
  }, function (t) {
    t.exports = JSON.parse('{"a":"12.4.0"}');
  }, function (t, e, n) {
    var i = n(15);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none;cursor:text;color:var(--ck-color-engine-placeholder-text)}";
  }, function (t, e, n) {
    var i = n(17);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999);--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border:#47a4f5;--ck-color-focus-shadow:rgba(119,186,248,0.5);--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#5c5c5c;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}";
  }, function (t, e, n) {
    var i = n(19);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}";
  }, function (t, e, n) {
    var i = n(21);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}";
  }, function (t, e, n) {
    var i = n(23);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}";
  }, function (t, e, n) {
    var i = n(25);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row wrap;align-items:center}.ck.ck-toolbar.ck-toolbar_vertical{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating{flex-wrap:nowrap}.ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar__newline{display:block;width:100%}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar>*{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-toolbar>*{margin-left:var(--ck-spacing-small);margin-right:0}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck{width:100%;margin:0;border-radius:0;border:0}[dir=ltr] .ck.ck-toolbar>:last-child{margin-right:0}[dir=rtl] .ck.ck-toolbar>:last-child{margin-left:0}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar__separator{align-self:stretch;width:1px;margin-top:0;margin-bottom:0;background:var(--ck-color-toolbar-border)}.ck.ck-toolbar__newline{margin:0}";
  }, function (t, e, n) {
    var i = n(27);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}";
  }, function (t, e, n) {
    var i = n(29);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}";
  }, function (t, e, n) {
    var i = n(31);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck-tooltip .ck-tooltip__text{display:inline-block}.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0}.ck.ck-tooltip.ck-tooltip_s{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_n{top:calc(-1*var(--ck-tooltip-arrow-size));transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(-1*var(--ck-tooltip-arrow-size));transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{border-style:solid;left:50%}.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s}';
  }, function (t, e, n) {
    var i = n(33);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button .ck-button__label,.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button .ck-button__label,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;border-color:transparent}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(-1*var(--ck-spacing-small));margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(-1*var(--ck-spacing-small));margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}";
  }, function (t, e, n) {
    var i = n(35);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}";
  }, function (t, e, n) {
    var i = n(37);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0;outline:1px solid var(--ck-color-resizer)}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all;width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nesw-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nesw-resize}.ck .ck-widget.ck-widget_with-selection-handler{position:relative}.ck .ck-widget.ck-widget_with-selection-handler:hover .ck-widget__selection-handler{visibility:visible}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{position:absolute}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck-editor__editable>.ck-widget.ck-widget_with-selection-handler:first-child,.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handler:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler,.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected:hover .ck-widget__selection-handler{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handler.ck-widget_selected:hover .ck-widget__selection-handler .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handler:hover .ck-widget__selection-handler{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handler .ck-widget__selection-handler{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected .ck-widget__selection-handler,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected .ck-widget__selection-handler:hover,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover .ck-widget__selection-handler,.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover .ck-widget__selection-handler:hover{background:var(--ck-color-widget-blurred-border)}.ck-editor__editable.ck-read-only .ck-widget{--ck-widget-outline-thickness:0}";
  }, function (t, e, n) {
    var i = n(39);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-labeled-input .ck-labeled-input__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-input .ck-labeled-input__status_error{color:var(--ck-color-base-error)}";
  }, function (t, e, n) {
    var i = n(41);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{box-shadow:var(--ck-inner-shadow),0 0;background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition-property:box-shadow,border;transition:.2s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),var(--ck-inner-shadow)}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),var(--ck-inner-shadow)}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}";
  }, function (t, e, n) {
    var i = n(43);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-input{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-input{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}.ck.ck-text-alternative-form{padding:var(--ck-spacing-standard)}.ck.ck-text-alternative-form:focus{outline:none}[dir=ltr] .ck.ck-text-alternative-form>:not(:first-child),[dir=rtl] .ck.ck-text-alternative-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-text-alternative-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-text-alternative-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-text-alternative-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-text-alternative-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-text-alternative-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-text-alternative-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-text-alternative-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(45);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(2*var(--ck-balloon-arrow-half-width));top:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(-1*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(2*var(--ck-balloon-arrow-half-width));bottom:calc(-1*var(--ck-balloon-arrow-height))}';
  }, function (t, e, n) {
    var i = n(47);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}";
  }, function (t, e, n) {
    var i = n(49);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}";
  }, function (t, e, n) {
    var i = n(51);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image>img{display:block;margin:0 auto;max-width:100%;min-width:50px}";
  }, function (t, e, n) {
    var i = n(53);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}";
  }, function (t, e, n) {
    var i = n(55);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}';
  }, function (t, e, n) {
    var i = n(57);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}';
  }, function (t, e, n) {
    var i = n(59);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block;will-change:transform}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{transform:translate3d(0,100%,0)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}:root{--ck-dropdown-arrow-size:calc(0.5*var(--ck-icon-size))}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}";
  }, function (t, e, n) {
    var i = n(61);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;border:0;padding:calc(0.2*var(--ck-line-height-base)*var(--ck-font-size-base)) calc(0.4*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(1.2*var(--ck-line-height-base)*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:hover:not(ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}";
  }, function (t, e, n) {
    var i = n(63);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:1.3846153847em}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(2*var(--ck-spacing-large))}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(2*var(--ck-spacing-large))}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(0.5*var(--ck-border-radius))}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(-1*var(--ck-switch-button-translation)))}";
  }, function (t, e, n) {
    var i = n(65);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-toolbar-dropdown .ck-toolbar{flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}";
  }, function (t, e, n) {
    var i = n(67);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}";
  }, function (t, e) {
    t.exports = ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}";
  }, function (t, e, n) {
    var i = n(70);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}";
  }, function (t, e, n) {
    var i = n(72);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-align-center:not(.image_resized),.ck-content .image-style-align-left:not(.image_resized),.ck-content .image-style-align-right:not(.image_resized),.ck-content .image-style-side:not(.image_resized){max-width:50%}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}";
  }, function (t, e, n) {
    var i = n(74);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}";
  }, function (t, e, n) {
    var i = n(76);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-input{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form{padding:var(--ck-spacing-standard)}.ck.ck-link-form:focus{outline:none}[dir=ltr] .ck.ck-link-form>:not(:first-child),[dir=rtl] .ck.ck-link-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin-left:0}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}";
  }, function (t, e, n) {
    var i = n(78);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions{padding:var(--ck-spacing-standard)}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions:focus{outline:none}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview):last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(80);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(3*var(--ck-spacing-standard));background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c8,#b900b4,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}';
  }, function (t, e, n) {
    var i = n(82);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-input{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-input{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}.ck.ck-media-form{padding:var(--ck-spacing-standard)}.ck.ck-media-form:focus{outline:none}[dir=ltr] .ck.ck-media-form>:not(:first-child),[dir=rtl] .ck.ck-media-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-media-form{padding:0;width:calc(0.8*var(--ck-input-text-width))}.ck.ck-media-form .ck-labeled-input{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-media-form .ck-labeled-input .ck-input-text{min-width:0;width:100%}.ck.ck-media-form .ck-labeled-input .ck-labeled-input__error{white-space:normal}.ck.ck-media-form .ck-button{padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-standard);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-media-form .ck-button{margin-left:0}[dir=ltr] .ck.ck-media-form .ck-button:first-of-type{border-right:1px solid var(--ck-color-base-border)}[dir=rtl] .ck.ck-media-form .ck-button{margin-left:0}[dir=rtl] .ck.ck-media-form .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}}";
  }, function (t, e, n) {
    var i = n(84);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}";
  }, function (t, e, n) {
    var i = n(86);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-color-table-focused-cell-background:#f5fafe}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}";
  }, function (t, e, n) {
    var i = n(88);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ":root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px;--ck-insert-table-dropdown-box-border-color:#bfbfbf;--ck-insert-table-dropdown-box-border-active-color:#53a0e4;--ck-insert-table-dropdown-box-active-background:#c7e5ff}.ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-insert-table-dropdown-box-border-color);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-insert-table-dropdown-box-border-active-color);background:var(--ck-insert-table-dropdown-box-active-background)}";
  }, function (t, e, n) {
    var i = n(90);
    "string" == typeof i && (i = [[t.i, i, ""]]);
    var o = {
      injectType: "singletonStyleTag",
      insert: "head",
      singleton: !0
    };
    n(1)(i, o);
    i.locals && (t.exports = i.locals);
  }, function (t, e) {
    t.exports = ".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border-color:#d9d9d9}.ck-content .table table th{font-weight:700;background:#fafafa}";
  }, function (t, e, n) {
    "use strict";

    var _marked = /*#__PURE__*/_regeneratorRuntime.mark(Ga),
        _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(Qa),
        _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(id);

    n.r(e);
    var i = n(3),
        o = i.a.Symbol,
        r = Object.prototype,
        s = r.hasOwnProperty,
        a = r.toString,
        c = o ? o.toStringTag : void 0;

    var l = function l(t) {
      var e = s.call(t, c),
          n = t[c];

      try {
        t[c] = void 0;
        var i = !0;
      } catch (t) {}

      var o = a.call(t);
      return i && (e ? t[c] = n : delete t[c]), o;
    },
        d = Object.prototype.toString;

    var h = function h(t) {
      return d.call(t);
    },
        u = "[object Null]",
        f = "[object Undefined]",
        m = o ? o.toStringTag : void 0;

    var g = function g(t) {
      return null == t ? void 0 === t ? f : u : m && m in Object(t) ? l(t) : h(t);
    };

    var p = function p(t, e) {
      return function (n) {
        return t(e(n));
      };
    },
        b = p(Object.getPrototypeOf, Object);

    var w = function w(t) {
      return null != t && "object" == _typeof(t);
    },
        k = "[object Object]",
        _ = Function.prototype,
        v = Object.prototype,
        y = _.toString,
        x = v.hasOwnProperty,
        A = y.call(Object);

    var T = function T(t) {
      if (!w(t) || g(t) != k) return !1;
      var e = b(t);
      if (null === e) return !0;
      var n = x.call(e, "constructor") && e.constructor;
      return "function" == typeof n && n instanceof n && y.call(n) == A;
    };

    var C = function C() {
      this.__data__ = [], this.size = 0;
    };

    var P = function P(t, e) {
      return t === e || t != t && e != e;
    };

    var S = function S(t, e) {
      for (var n = t.length; n--;) {
        if (P(t[n][0], e)) return n;
      }

      return -1;
    },
        M = Array.prototype.splice;

    var E = function E(t) {
      var e = this.__data__,
          n = S(e, t);
      return !(n < 0 || (n == e.length - 1 ? e.pop() : M.call(e, n, 1), --this.size, 0));
    };

    var I = function I(t) {
      var e = this.__data__,
          n = S(e, t);
      return n < 0 ? void 0 : e[n][1];
    };

    var N = function N(t) {
      return S(this.__data__, t) > -1;
    };

    var O = function O(t, e) {
      var n = this.__data__,
          i = S(n, t);
      return i < 0 ? (++this.size, n.push([t, e])) : n[i][1] = e, this;
    };

    function R(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    R.prototype.clear = C, R.prototype.delete = E, R.prototype.get = I, R.prototype.has = N, R.prototype.set = O;
    var D = R;

    var L = function L() {
      this.__data__ = new D(), this.size = 0;
    };

    var j = function j(t) {
      var e = this.__data__,
          n = e.delete(t);
      return this.size = e.size, n;
    };

    var V = function V(t) {
      return this.__data__.get(t);
    };

    var z = function z(t) {
      return this.__data__.has(t);
    };

    var B = function B(t) {
      var e = _typeof(t);

      return null != t && ("object" == e || "function" == e);
    },
        F = "[object AsyncFunction]",
        U = "[object Function]",
        H = "[object GeneratorFunction]",
        q = "[object Proxy]";

    var W = function W(t) {
      if (!B(t)) return !1;
      var e = g(t);
      return e == U || e == H || e == F || e == q;
    },
        Y = i.a["__core-js_shared__"],
        $ = function () {
      var t = /[^.]+$/.exec(Y && Y.keys && Y.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();

    var G = function G(t) {
      return !!$ && $ in t;
    },
        Q = Function.prototype.toString;

    var K = function K(t) {
      if (null != t) {
        try {
          return Q.call(t);
        } catch (t) {}

        try {
          return t + "";
        } catch (t) {}
      }

      return "";
    },
        J = /^\[object .+?Constructor\]$/,
        Z = Function.prototype,
        X = Object.prototype,
        tt = Z.toString,
        et = X.hasOwnProperty,
        nt = RegExp("^" + tt.call(et).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    var it = function it(t) {
      return !(!B(t) || G(t)) && (W(t) ? nt : J).test(K(t));
    };

    var ot = function ot(t, e) {
      return null == t ? void 0 : t[e];
    };

    var rt = function rt(t, e) {
      var n = ot(t, e);
      return it(n) ? n : void 0;
    },
        st = rt(i.a, "Map"),
        at = rt(Object, "create");

    var ct = function ct() {
      this.__data__ = at ? at(null) : {}, this.size = 0;
    };

    var lt = function lt(t) {
      var e = this.has(t) && delete this.__data__[t];
      return this.size -= e ? 1 : 0, e;
    },
        dt = "__lodash_hash_undefined__",
        ht = Object.prototype.hasOwnProperty;

    var ut = function ut(t) {
      var e = this.__data__;

      if (at) {
        var n = e[t];
        return n === dt ? void 0 : n;
      }

      return ht.call(e, t) ? e[t] : void 0;
    },
        ft = Object.prototype.hasOwnProperty;

    var mt = function mt(t) {
      var e = this.__data__;
      return at ? void 0 !== e[t] : ft.call(e, t);
    },
        gt = "__lodash_hash_undefined__";

    var pt = function pt(t, e) {
      var n = this.__data__;
      return this.size += this.has(t) ? 0 : 1, n[t] = at && void 0 === e ? gt : e, this;
    };

    function bt(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    bt.prototype.clear = ct, bt.prototype.delete = lt, bt.prototype.get = ut, bt.prototype.has = mt, bt.prototype.set = pt;
    var wt = bt;

    var kt = function kt() {
      this.size = 0, this.__data__ = {
        hash: new wt(),
        map: new (st || D)(),
        string: new wt()
      };
    };

    var _t = function _t(t) {
      var e = _typeof(t);

      return "string" == e || "number" == e || "symbol" == e || "boolean" == e ? "__proto__" !== t : null === t;
    };

    var vt = function vt(t, e) {
      var n = t.__data__;
      return _t(e) ? n["string" == typeof e ? "string" : "hash"] : n.map;
    };

    var yt = function yt(t) {
      var e = vt(this, t).delete(t);
      return this.size -= e ? 1 : 0, e;
    };

    var xt = function xt(t) {
      return vt(this, t).get(t);
    };

    var At = function At(t) {
      return vt(this, t).has(t);
    };

    var Tt = function Tt(t, e) {
      var n = vt(this, t),
          i = n.size;
      return n.set(t, e), this.size += n.size == i ? 0 : 1, this;
    };

    function Ct(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.clear(); ++e < n;) {
        var i = t[e];
        this.set(i[0], i[1]);
      }
    }

    Ct.prototype.clear = kt, Ct.prototype.delete = yt, Ct.prototype.get = xt, Ct.prototype.has = At, Ct.prototype.set = Tt;
    var Pt = Ct,
        St = 200;

    var Mt = function Mt(t, e) {
      var n = this.__data__;

      if (n instanceof D) {
        var i = n.__data__;
        if (!st || i.length < St - 1) return i.push([t, e]), this.size = ++n.size, this;
        n = this.__data__ = new Pt(i);
      }

      return n.set(t, e), this.size = n.size, this;
    };

    function Et(t) {
      var e = this.__data__ = new D(t);
      this.size = e.size;
    }

    Et.prototype.clear = L, Et.prototype.delete = j, Et.prototype.get = V, Et.prototype.has = z, Et.prototype.set = Mt;
    var It = Et;

    var Nt = function Nt(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i && !1 !== e(t[n], n, t);) {
        ;
      }

      return t;
    },
        Ot = function () {
      try {
        var t = rt(Object, "defineProperty");
        return t({}, "", {}), t;
      } catch (t) {}
    }();

    var Rt = function Rt(t, e, n) {
      "__proto__" == e && Ot ? Ot(t, e, {
        configurable: !0,
        enumerable: !0,
        value: n,
        writable: !0
      }) : t[e] = n;
    },
        Dt = Object.prototype.hasOwnProperty;

    var Lt = function Lt(t, e, n) {
      var i = t[e];
      Dt.call(t, e) && P(i, n) && (void 0 !== n || e in t) || Rt(t, e, n);
    };

    var jt = function jt(t, e, n, i) {
      var o = !n;
      n || (n = {});

      for (var r = -1, s = e.length; ++r < s;) {
        var a = e[r],
            c = i ? i(n[a], t[a], a, n, t) : void 0;
        void 0 === c && (c = t[a]), o ? Rt(n, a, c) : Lt(n, a, c);
      }

      return n;
    };

    var Vt = function Vt(t, e) {
      for (var n = -1, i = Array(t); ++n < t;) {
        i[n] = e(n);
      }

      return i;
    },
        zt = "[object Arguments]";

    var Bt = function Bt(t) {
      return w(t) && g(t) == zt;
    },
        Ft = Object.prototype,
        Ut = Ft.hasOwnProperty,
        Ht = Ft.propertyIsEnumerable,
        qt = Bt(function () {
      return arguments;
    }()) ? Bt : function (t) {
      return w(t) && Ut.call(t, "callee") && !Ht.call(t, "callee");
    },
        Wt = Array.isArray,
        Yt = n(5),
        $t = 9007199254740991,
        Gt = /^(?:0|[1-9]\d*)$/;

    var Qt = function Qt(t, e) {
      var n = _typeof(t);

      return !!(e = null == e ? $t : e) && ("number" == n || "symbol" != n && Gt.test(t)) && t > -1 && t % 1 == 0 && t < e;
    },
        Kt = 9007199254740991;

    var Jt = function Jt(t) {
      return "number" == typeof t && t > -1 && t % 1 == 0 && t <= Kt;
    },
        Zt = {};

    Zt["[object Float32Array]"] = Zt["[object Float64Array]"] = Zt["[object Int8Array]"] = Zt["[object Int16Array]"] = Zt["[object Int32Array]"] = Zt["[object Uint8Array]"] = Zt["[object Uint8ClampedArray]"] = Zt["[object Uint16Array]"] = Zt["[object Uint32Array]"] = !0, Zt["[object Arguments]"] = Zt["[object Array]"] = Zt["[object ArrayBuffer]"] = Zt["[object Boolean]"] = Zt["[object DataView]"] = Zt["[object Date]"] = Zt["[object Error]"] = Zt["[object Function]"] = Zt["[object Map]"] = Zt["[object Number]"] = Zt["[object Object]"] = Zt["[object RegExp]"] = Zt["[object Set]"] = Zt["[object String]"] = Zt["[object WeakMap]"] = !1;

    var Xt = function Xt(t) {
      return w(t) && Jt(t.length) && !!Zt[g(t)];
    };

    var te = function te(t) {
      return function (e) {
        return t(e);
      };
    },
        ee = n(4),
        ne = ee.a && ee.a.isTypedArray,
        ie = ne ? te(ne) : Xt,
        oe = Object.prototype.hasOwnProperty;

    var re = function re(t, e) {
      var n = Wt(t),
          i = !n && qt(t),
          o = !n && !i && Object(Yt.a)(t),
          r = !n && !i && !o && ie(t),
          s = n || i || o || r,
          a = s ? Vt(t.length, String) : [],
          c = a.length;

      for (var l in t) {
        !e && !oe.call(t, l) || s && ("length" == l || o && ("offset" == l || "parent" == l) || r && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || Qt(l, c)) || a.push(l);
      }

      return a;
    },
        se = Object.prototype;

    var ae = function ae(t) {
      var e = t && t.constructor;
      return t === ("function" == typeof e && e.prototype || se);
    },
        ce = p(Object.keys, Object),
        le = Object.prototype.hasOwnProperty;

    var de = function de(t) {
      if (!ae(t)) return ce(t);
      var e = [];

      for (var n in Object(t)) {
        le.call(t, n) && "constructor" != n && e.push(n);
      }

      return e;
    };

    var he = function he(t) {
      return null != t && Jt(t.length) && !W(t);
    };

    var ue = function ue(t) {
      return he(t) ? re(t) : de(t);
    };

    var fe = function fe(t, e) {
      return t && jt(e, ue(e), t);
    };

    var me = function me(t) {
      var e = [];
      if (null != t) for (var n in Object(t)) {
        e.push(n);
      }
      return e;
    },
        ge = Object.prototype.hasOwnProperty;

    var pe = function pe(t) {
      if (!B(t)) return me(t);
      var e = ae(t),
          n = [];

      for (var i in t) {
        ("constructor" != i || !e && ge.call(t, i)) && n.push(i);
      }

      return n;
    };

    var be = function be(t) {
      return he(t) ? re(t, !0) : pe(t);
    };

    var we = function we(t, e) {
      return t && jt(e, be(e), t);
    },
        ke = n(12);

    var _e = function _e(t, e) {
      var n = -1,
          i = t.length;

      for (e || (e = Array(i)); ++n < i;) {
        e[n] = t[n];
      }

      return e;
    };

    var ve = function ve(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = 0, r = []; ++n < i;) {
        var s = t[n];
        e(s, n, t) && (r[o++] = s);
      }

      return r;
    };

    var ye = function ye() {
      return [];
    },
        xe = Object.prototype.propertyIsEnumerable,
        Ae = Object.getOwnPropertySymbols,
        Te = Ae ? function (t) {
      return null == t ? [] : (t = Object(t), ve(Ae(t), function (e) {
        return xe.call(t, e);
      }));
    } : ye;

    var Ce = function Ce(t, e) {
      return jt(t, Te(t), e);
    };

    var Pe = function Pe(t, e) {
      for (var n = -1, i = e.length, o = t.length; ++n < i;) {
        t[o + n] = e[n];
      }

      return t;
    },
        Se = Object.getOwnPropertySymbols ? function (t) {
      for (var e = []; t;) {
        Pe(e, Te(t)), t = b(t);
      }

      return e;
    } : ye;

    var Me = function Me(t, e) {
      return jt(t, Se(t), e);
    };

    var Ee = function Ee(t, e, n) {
      var i = e(t);
      return Wt(t) ? i : Pe(i, n(t));
    };

    var Ie = function Ie(t) {
      return Ee(t, ue, Te);
    };

    var Ne = function Ne(t) {
      return Ee(t, be, Se);
    },
        Oe = rt(i.a, "DataView"),
        Re = rt(i.a, "Promise"),
        De = rt(i.a, "Set"),
        Le = rt(i.a, "WeakMap"),
        je = K(Oe),
        Ve = K(st),
        ze = K(Re),
        Be = K(De),
        Fe = K(Le),
        Ue = g;

    (Oe && "[object DataView]" != Ue(new Oe(new ArrayBuffer(1))) || st && "[object Map]" != Ue(new st()) || Re && "[object Promise]" != Ue(Re.resolve()) || De && "[object Set]" != Ue(new De()) || Le && "[object WeakMap]" != Ue(new Le())) && (Ue = function Ue(t) {
      var e = g(t),
          n = "[object Object]" == e ? t.constructor : void 0,
          i = n ? K(n) : "";
      if (i) switch (i) {
        case je:
          return "[object DataView]";

        case Ve:
          return "[object Map]";

        case ze:
          return "[object Promise]";

        case Be:
          return "[object Set]";

        case Fe:
          return "[object WeakMap]";
      }
      return e;
    });
    var He = Ue,
        qe = Object.prototype.hasOwnProperty;

    var We = function We(t) {
      var e = t.length,
          n = new t.constructor(e);
      return e && "string" == typeof t[0] && qe.call(t, "index") && (n.index = t.index, n.input = t.input), n;
    },
        Ye = i.a.Uint8Array;

    var $e = function $e(t) {
      var e = new t.constructor(t.byteLength);
      return new Ye(e).set(new Ye(t)), e;
    };

    var Ge = function Ge(t, e) {
      var n = e ? $e(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    },
        Qe = /\w*$/;

    var Ke = function Ke(t) {
      var e = new t.constructor(t.source, Qe.exec(t));
      return e.lastIndex = t.lastIndex, e;
    },
        Je = o ? o.prototype : void 0,
        Ze = Je ? Je.valueOf : void 0;

    var Xe = function Xe(t) {
      return Ze ? Object(Ze.call(t)) : {};
    };

    var tn = function tn(t, e) {
      var n = e ? $e(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    },
        en = "[object Boolean]",
        nn = "[object Date]",
        on = "[object Map]",
        rn = "[object Number]",
        sn = "[object RegExp]",
        an = "[object Set]",
        cn = "[object String]",
        ln = "[object Symbol]",
        dn = "[object ArrayBuffer]",
        hn = "[object DataView]",
        un = "[object Float32Array]",
        fn = "[object Float64Array]",
        mn = "[object Int8Array]",
        gn = "[object Int16Array]",
        pn = "[object Int32Array]",
        bn = "[object Uint8Array]",
        wn = "[object Uint8ClampedArray]",
        kn = "[object Uint16Array]",
        _n = "[object Uint32Array]";

    var vn = function vn(t, e, n) {
      var i = t.constructor;

      switch (e) {
        case dn:
          return $e(t);

        case en:
        case nn:
          return new i(+t);

        case hn:
          return Ge(t, n);

        case un:
        case fn:
        case mn:
        case gn:
        case pn:
        case bn:
        case wn:
        case kn:
        case _n:
          return tn(t, n);

        case on:
          return new i();

        case rn:
        case cn:
          return new i(t);

        case sn:
          return Ke(t);

        case an:
          return new i();

        case ln:
          return Xe(t);
      }
    },
        yn = Object.create,
        xn = function () {
      function t() {}

      return function (e) {
        if (!B(e)) return {};
        if (yn) return yn(e);
        t.prototype = e;
        var n = new t();
        return t.prototype = void 0, n;
      };
    }();

    var An = function An(t) {
      return "function" != typeof t.constructor || ae(t) ? {} : xn(b(t));
    },
        Tn = "[object Map]";

    var Cn = function Cn(t) {
      return w(t) && He(t) == Tn;
    },
        Pn = ee.a && ee.a.isMap,
        Sn = Pn ? te(Pn) : Cn,
        Mn = "[object Set]";

    var En = function En(t) {
      return w(t) && He(t) == Mn;
    },
        In = ee.a && ee.a.isSet,
        Nn = In ? te(In) : En,
        On = 1,
        Rn = 2,
        Dn = 4,
        Ln = "[object Arguments]",
        jn = "[object Function]",
        Vn = "[object GeneratorFunction]",
        zn = "[object Object]",
        Bn = {};

    Bn[Ln] = Bn["[object Array]"] = Bn["[object ArrayBuffer]"] = Bn["[object DataView]"] = Bn["[object Boolean]"] = Bn["[object Date]"] = Bn["[object Float32Array]"] = Bn["[object Float64Array]"] = Bn["[object Int8Array]"] = Bn["[object Int16Array]"] = Bn["[object Int32Array]"] = Bn["[object Map]"] = Bn["[object Number]"] = Bn[zn] = Bn["[object RegExp]"] = Bn["[object Set]"] = Bn["[object String]"] = Bn["[object Symbol]"] = Bn["[object Uint8Array]"] = Bn["[object Uint8ClampedArray]"] = Bn["[object Uint16Array]"] = Bn["[object Uint32Array]"] = !0, Bn["[object Error]"] = Bn[jn] = Bn["[object WeakMap]"] = !1;

    var Fn = function t(e, n, i, o, r, s) {
      var a,
          c = n & On,
          l = n & Rn,
          d = n & Dn;
      if (i && (a = r ? i(e, o, r, s) : i(e)), void 0 !== a) return a;
      if (!B(e)) return e;
      var h = Wt(e);

      if (h) {
        if (a = We(e), !c) return _e(e, a);
      } else {
        var u = He(e),
            f = u == jn || u == Vn;
        if (Object(Yt.a)(e)) return Object(ke.a)(e, c);

        if (u == zn || u == Ln || f && !r) {
          if (a = l || f ? {} : An(e), !c) return l ? Me(e, we(a, e)) : Ce(e, fe(a, e));
        } else {
          if (!Bn[u]) return r ? e : {};
          a = vn(e, u, c);
        }
      }

      s || (s = new It());
      var m = s.get(e);
      if (m) return m;
      s.set(e, a), Nn(e) ? e.forEach(function (o) {
        a.add(t(o, n, i, o, e, s));
      }) : Sn(e) && e.forEach(function (o, r) {
        a.set(r, t(o, n, i, r, e, s));
      });
      var g = d ? l ? Ne : Ie : l ? keysIn : ue,
          p = h ? void 0 : g(e);
      return Nt(p || e, function (o, r) {
        p && (o = e[r = o]), Lt(a, r, t(o, n, i, r, e, s));
      }), a;
    },
        Un = 1,
        Hn = 4;

    var qn = function qn(t, e) {
      return Fn(t, Un | Hn, e = "function" == typeof e ? e : void 0);
    };

    var Wn = function Wn(t) {
      return w(t) && 1 === t.nodeType && !T(t);
    };

    var Yn = /*#__PURE__*/function () {
      function Yn(t, e) {
        _classCallCheck(this, Yn);

        this._config = {}, e && this.define(e), t && this._setObjectToTarget(this._config, t);
      }

      _createClass(Yn, [{
        key: "set",
        value: function set(t, e) {
          this._setToTarget(this._config, t, e);
        }
      }, {
        key: "define",
        value: function define(t, e) {
          this._setToTarget(this._config, t, e, !0);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._getFromSource(this._config, t);
        }
      }, {
        key: "_setToTarget",
        value: function _setToTarget(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
          if (T(e)) return void this._setObjectToTarget(t, e, i);
          var o = e.split(".");
          e = o.pop();

          var _iterator = _createForOfIteratorHelper(o),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _e2 = _step.value;
              T(t[_e2]) || (t[_e2] = {}), t = t[_e2];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (T(n)) return T(t[e]) || (t[e] = {}), t = t[e], void this._setObjectToTarget(t, n, i);
          i && void 0 !== t[e] || (t[e] = n);
        }
      }, {
        key: "_getFromSource",
        value: function _getFromSource(t, e) {
          var n = e.split(".");
          e = n.pop();

          var _iterator2 = _createForOfIteratorHelper(n),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _e3 = _step2.value;

              if (!T(t[_e3])) {
                t = null;
                break;
              }

              t = t[_e3];
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return t ? function (t) {
            return qn(t, $n);
          }(t[e]) : void 0;
        }
      }, {
        key: "_setObjectToTarget",
        value: function _setObjectToTarget(t, e, n) {
          var _this2 = this;

          Object.keys(e).forEach(function (i) {
            _this2._setToTarget(t, i, e[i], n);
          });
        }
      }]);

      return Yn;
    }();

    function $n(t) {
      return Wn(t) ? t : void 0;
    }

    var Gn = n(0);

    var Qn = function Qn() {
      return function t() {
        t.called = !0;
      };
    };

    var Kn = function Kn(t, e) {
      _classCallCheck(this, Kn);

      this.source = t, this.name = e, this.path = [], this.stop = Qn(), this.off = Qn();
    };

    function Jn() {
      var t = "e";

      for (var _e4 = 0; _e4 < 8; _e4++) {
        t += Math.floor(65536 * (1 + Math.random())).toString(16).substring(1);
      }

      return t;
    }

    var Zn = {
      get: function get(t) {
        return "number" != typeof t ? this[t] || this.normal : t;
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    n(6);
    var Xn = Symbol("listeningTo"),
        ti = Symbol("emitterId");
    var ei = {
      on: function on(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.listenTo(this, t, e, n);
      },
      once: function once(t, e, n) {
        var i = !1;
        this.listenTo(this, t, function (t) {
          for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            n[_key - 1] = arguments[_key];
          }

          i || (i = !0, t.off(), e.call.apply(e, [this, t].concat(n)));
        }, n);
      },
      off: function off(t, e) {
        this.stopListening(this, t, e);
      },
      listenTo: function listenTo(t, e, n) {
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var o, r;
        this[Xn] || (this[Xn] = {});
        var s = this[Xn];
        ii(t) || ni(t);
        var a = ii(t);
        (o = s[a]) || (o = s[a] = {
          emitter: t,
          callbacks: {}
        }), (r = o.callbacks[e]) || (r = o.callbacks[e] = []), r.push(n), function (t, e) {
          var n = oi(t);
          if (n[e]) return;
          var i = e,
              o = null;
          var r = [];

          for (; "" !== i && !n[i];) {
            n[i] = {
              callbacks: [],
              childEvents: []
            }, r.push(n[i]), o && n[i].childEvents.push(o), o = i, i = i.substr(0, i.lastIndexOf(":"));
          }

          if ("" !== i) {
            var _iterator3 = _createForOfIteratorHelper(r),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _t2 = _step3.value;
                _t2.callbacks = n[i].callbacks.slice();
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }

            n[i].childEvents.push(o);
          }
        }(t, e);
        var c = ri(t, e),
            l = Zn.get(i.priority),
            d = {
          callback: n,
          priority: l
        };

        var _iterator4 = _createForOfIteratorHelper(c),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t3 = _step4.value;

            var _e5 = !1;

            for (var _n2 = 0; _n2 < _t3.length; _n2++) {
              if (_t3[_n2].priority < l) {
                _t3.splice(_n2, 0, d), _e5 = !0;
                break;
              }
            }

            _e5 || _t3.push(d);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      },
      stopListening: function stopListening(t, e, n) {
        var i = this[Xn];
        var o = t && ii(t);
        var r = i && o && i[o],
            s = r && e && r.callbacks[e];
        if (!(!i || t && !r || e && !s)) if (n) ai(t, e, n);else if (s) {
          for (; n = s.pop();) {
            ai(t, e, n);
          }

          delete r.callbacks[e];
        } else if (r) {
          for (e in r.callbacks) {
            this.stopListening(t, e);
          }

          delete i[o];
        } else {
          for (o in i) {
            this.stopListening(i[o].emitter);
          }

          delete this[Xn];
        }
      },
      fire: function fire(t) {
        var n = t instanceof Kn ? t : new Kn(this, t),
            i = n.name;

        var o = function t(e, n) {
          var i;
          if (!e._events || !(i = e._events[n]) || !i.callbacks.length) return n.indexOf(":") > -1 ? t(e, n.substr(0, n.lastIndexOf(":"))) : null;
          return i.callbacks;
        }(this, i);

        for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          e[_key2 - 1] = arguments[_key2];
        }

        if (n.path.push(this), o) {
          var _t4 = [n].concat(e);

          o = Array.from(o);

          for (var _e6 = 0; _e6 < o.length && (o[_e6].callback.apply(this, _t4), n.off.called && (delete n.off.called, ai(this, i, o[_e6].callback)), !n.stop.called); _e6++) {
            ;
          }
        }

        if (this._delegations) {
          var _t5 = this._delegations.get(i),
              _o2 = this._delegations.get("*");

          _t5 && si(_t5, n, e), _o2 && si(_o2, n, e);
        }

        return n.return;
      },
      delegate: function delegate() {
        var _this3 = this;

        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }

        return {
          to: function to(e, n) {
            _this3._delegations || (_this3._delegations = new Map()), t.forEach(function (t) {
              var i = _this3._delegations.get(t);

              i ? i.set(e, n) : _this3._delegations.set(t, new Map([[e, n]]));
            });
          }
        };
      },
      stopDelegating: function stopDelegating(t, e) {
        if (this._delegations) if (t) {
          if (e) {
            var _n3 = this._delegations.get(t);

            _n3 && _n3.delete(e);
          } else this._delegations.delete(t);
        } else this._delegations.clear();
      }
    };

    function ni(t, e) {
      t[ti] || (t[ti] = e || Jn());
    }

    function ii(t) {
      return t[ti];
    }

    function oi(t) {
      return t._events || Object.defineProperty(t, "_events", {
        value: {}
      }), t._events;
    }

    function ri(t, e) {
      var n = oi(t)[e];
      if (!n) return [];
      var i = [n.callbacks];

      for (var _e7 = 0; _e7 < n.childEvents.length; _e7++) {
        var _o3 = ri(t, n.childEvents[_e7]);

        i = i.concat(_o3);
      }

      return i;
    }

    function si(t, e, n) {
      var _iterator5 = _createForOfIteratorHelper(t),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref3 = _step5.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var _i2 = _ref2[0];
          var _o4 = _ref2[1];
          _o4 ? "function" == typeof _o4 && (_o4 = _o4(e.name)) : _o4 = e.name;

          var _t6 = new Kn(e.source, _o4);

          _t6.path = _toConsumableArray(e.path), _i2.fire.apply(_i2, [_t6].concat(_toConsumableArray(n)));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }

    function ai(t, e, n) {
      var i = ri(t, e);

      var _iterator6 = _createForOfIteratorHelper(i),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t7 = _step6.value;

          for (var _e8 = 0; _e8 < _t7.length; _e8++) {
            _t7[_e8].callback == n && (_t7.splice(_e8, 1), _e8--);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }

    function ci(t) {
      for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        e[_key4 - 1] = arguments[_key4];
      }

      e.forEach(function (e) {
        Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(function (n) {
          if (n in t.prototype) return;
          var i = Object.getOwnPropertyDescriptor(e, n);
          i.enumerable = !1, Object.defineProperty(t.prototype, n, i);
        });
      });
    }

    function li(t, e) {
      var n = Math.min(t.length, e.length);

      for (var _i3 = 0; _i3 < n; _i3++) {
        if (t[_i3] != e[_i3]) return _i3;
      }

      return t.length == e.length ? "same" : t.length < e.length ? "prefix" : "extension";
    }

    var di = 4;

    var hi = function hi(t) {
      return Fn(t, di);
    };

    var ui = /*#__PURE__*/function () {
      function ui() {
        _classCallCheck(this, ui);

        this.parent = null;
      }

      _createClass(ui, [{
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (-1 == (t = this.parent.getChildIndex(this))) throw new Gn.b("view-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;

          for (; t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "document",
        get: function get() {
          return this.parent instanceof ui ? this.parent.document : null;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;

          for (; e.parent;) {
            t.unshift(e.index), e = e.parent;
          }

          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
              i = t.getAncestors(e);
          var o = 0;

          for (; n[o] == i[o] && n[o];) {
            o++;
          }

          return 0 === o ? null : n[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
              n = t.getPath(),
              i = li(e, n);

          switch (i) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return e[i] < n[i];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e), this.parent && this.parent._fireChange(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = hi(this);
          return delete t.parent, t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" == t || "view:node" == t;
        }
      }]);

      return ui;
    }();

    ci(ui, ei);

    var fi = /*#__PURE__*/function (_ui) {
      _inherits(fi, _ui);

      var _super2 = _createSuper(fi);

      function fi(t) {
        var _this4;

        _classCallCheck(this, fi);

        _this4 = _super2.call(this), _this4._textData = t;
        return _this4;
      }

      _createClass(fi, [{
        key: "is",
        value: function is(t) {
          return "text" == t || "view:text" == t || _get(_getPrototypeOf(fi.prototype), "is", this).call(this, t);
        }
      }, {
        key: "data",
        get: function get() {
          return this._textData;
        }
      }, {
        key: "_data",
        get: function get() {
          return this.data;
        },
        set: function set(t) {
          this._fireChange("text", this), this._textData = t;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return t instanceof fi && (this === t || this.data === t.data);
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new fi(this.data);
        }
      }]);

      return fi;
    }(ui);

    var mi = /*#__PURE__*/function () {
      function mi(t, e, n) {
        _classCallCheck(this, mi);

        if (this.textNode = t, e < 0 || e > t.data.length) throw new Gn.b("view-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
        if (n < 0 || e + n > t.data.length) throw new Gn.b("view-textproxy-wrong-length: Given length value is incorrect.", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }

      _createClass(mi, [{
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.data.length !== this.textNode.data.length;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "textProxy" == t || "view:textProxy" == t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this.textNode : this.parent;

          for (; null !== n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }]);

      return mi;
    }();

    function gi(t) {
      var e = new Map();

      for (var _n4 in t) {
        e.set(_n4, t[_n4]);
      }

      return e;
    }

    function pi(t) {
      return !(!t || !t[Symbol.iterator]);
    }

    var bi = /*#__PURE__*/function () {
      function bi() {
        _classCallCheck(this, bi);

        this._patterns = [], this.add.apply(this, arguments);
      }

      _createClass(bi, [{
        key: "add",
        value: function add() {
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }

          for (var _i4 = 0, _t8 = t; _i4 < _t8.length; _i4++) {
            var _e9 = _t8[_i4];
            ("string" == typeof _e9 || _e9 instanceof RegExp) && (_e9 = {
              name: _e9
            }), _e9.classes && ("string" == typeof _e9.classes || _e9.classes instanceof RegExp) && (_e9.classes = [_e9.classes]), this._patterns.push(_e9);
          }
        }
      }, {
        key: "match",
        value: function match() {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }

          for (var _i5 = 0, _t9 = t; _i5 < _t9.length; _i5++) {
            var _e10 = _t9[_i5];

            var _iterator7 = _createForOfIteratorHelper(this._patterns),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _t10 = _step7.value;

                var _n5 = wi(_e10, _t10);

                if (_n5) return {
                  element: _e10,
                  pattern: _t10,
                  match: _n5
                };
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }

          return null;
        }
      }, {
        key: "matchAll",
        value: function matchAll() {
          var e = [];

          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }

          for (var _i6 = 0, _t11 = t; _i6 < _t11.length; _i6++) {
            var _n6 = _t11[_i6];

            var _iterator8 = _createForOfIteratorHelper(this._patterns),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _t12 = _step8.value;

                var _i7 = wi(_n6, _t12);

                _i7 && e.push({
                  element: _n6,
                  pattern: _t12,
                  match: _i7
                });
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }

          return e.length > 0 ? e : null;
        }
      }, {
        key: "getElementName",
        value: function getElementName() {
          if (1 !== this._patterns.length) return null;
          var t = this._patterns[0],
              e = t.name;
          return "function" == typeof t || !e || e instanceof RegExp ? null : e;
        }
      }]);

      return bi;
    }();

    function wi(t, e) {
      if ("function" == typeof e) return e(t);
      var n = {};
      return e.name && (n.name = function (t, e) {
        if (t instanceof RegExp) return t.test(e);
        return t === e;
      }(e.name, t.name), !n.name) ? null : e.attributes && (n.attributes = function (t, e) {
        var n = [];

        for (var _i8 in t) {
          var _o5 = t[_i8];
          if (!e.hasAttribute(_i8)) return null;
          {
            var _t13 = e.getAttribute(_i8);

            if (!0 === _o5) n.push(_i8);else if (_o5 instanceof RegExp) {
              if (!_o5.test(_t13)) return null;
              n.push(_i8);
            } else {
              if (_t13 !== _o5) return null;
              n.push(_i8);
            }
          }
        }

        return n;
      }(e.attributes, t), !n.attributes) ? null : !(e.classes && (n.classes = function (t, e) {
        var n = [];

        var _iterator9 = _createForOfIteratorHelper(t),
            _step9;

        try {
          for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
            var _i9 = _step9.value;

            if (_i9 instanceof RegExp) {
              var _t14 = e.getClassNames();

              var _iterator10 = _createForOfIteratorHelper(_t14),
                  _step10;

              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var _e11 = _step10.value;
                  _i9.test(_e11) && n.push(_e11);
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }

              if (0 === n.length) return null;
            } else {
              if (!e.hasClass(_i9)) return null;
              n.push(_i9);
            }
          }
        } catch (err) {
          _iterator9.e(err);
        } finally {
          _iterator9.f();
        }

        return n;
      }(e.classes, t), !n.classes)) && !(e.styles && (n.styles = function (t, e) {
        var n = [];

        for (var _i10 in t) {
          var _o6 = t[_i10];
          if (!e.hasStyle(_i10)) return null;
          {
            var _t15 = e.getStyle(_i10);

            if (_o6 instanceof RegExp) {
              if (!_o6.test(_t15)) return null;
              n.push(_i10);
            } else {
              if (_t15 !== _o6) return null;
              n.push(_i10);
            }
          }
        }

        return n;
      }(e.styles, t), !n.styles)) && n;
    }

    var ki = /*#__PURE__*/function (_ui2) {
      _inherits(ki, _ui2);

      var _super3 = _createSuper(ki);

      function ki(t, e, n) {
        var _this5;

        _classCallCheck(this, ki);

        if (_this5 = _super3.call(this), _this5.name = t, _this5._attrs = function (t) {
          t = T(t) ? gi(t) : new Map(t);

          var _iterator11 = _createForOfIteratorHelper(t),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _ref6 = _step11.value;

              var _ref5 = _slicedToArray(_ref6, 2);

              var _e12 = _ref5[0];
              var _n7 = _ref5[1];
              null === _n7 ? t.delete(_e12) : "string" != typeof _n7 && t.set(_e12, String(_n7));
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }

          return t;
        }(e), _this5._children = [], n && _this5._insertChild(0, n), _this5._classes = new Set(), _this5._attrs.has("class")) {
          var _t16 = _this5._attrs.get("class");

          vi(_this5._classes, _t16), _this5._attrs.delete("class");
        }

        _this5._styles = new Map(), _this5._attrs.has("style") && (_i(_this5._styles, _this5._attrs.get("style")), _this5._attrs.delete("style")), _this5._customProperties = new Map();
        return _possibleConstructorReturn(_this5);
      }

      _createClass(ki, [{
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this._children.length;
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "element" == n && e == this.name : "element" == n || n == this.name || _get(_getPrototypeOf(ki.prototype), "is", this).call(this, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getAttributeKeys",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getAttributeKeys() {
          return _regeneratorRuntime.wrap(function getAttributeKeys$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = this._classes.size > 0;

                  if (!_context.t0) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 4;
                  return "class";

                case 4:
                  _context.t1 = this._styles.size > 0;

                  if (!_context.t1) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 8;
                  return "style";

                case 8:
                  return _context.delegateYield(this._attrs.keys(), "t2", 9);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, getAttributeKeys, this);
        })
      }, {
        key: "getAttributes",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getAttributes() {
          return _regeneratorRuntime.wrap(function getAttributes$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.delegateYield(this._attrs.entries(), "t0", 1);

                case 1:
                  _context2.t1 = this._classes.size > 0;

                  if (!_context2.t1) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return ["class", this.getAttribute("class")];

                case 5:
                  _context2.t2 = this._styles.size > 0;

                  if (!_context2.t2) {
                    _context2.next = 9;
                    break;
                  }

                  _context2.next = 9;
                  return ["style", this.getAttribute("style")];

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, getAttributes, this);
        })
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          if ("class" == t) return this._classes.size > 0 ? _toConsumableArray(this._classes).join(" ") : void 0;
          if ("style" != t) return this._attrs.get(t);

          if (this._styles.size > 0) {
            var _t17 = "";

            var _iterator12 = _createForOfIteratorHelper(this._styles),
                _step12;

            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var _ref9 = _step12.value;

                var _ref8 = _slicedToArray(_ref9, 2);

                var _e13 = _ref8[0];
                var _n8 = _ref8[1];
                _t17 += "".concat(_e13, ":").concat(_n8, ";");
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }

            return _t17;
          }
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return "class" == t ? this._classes.size > 0 : "style" == t ? this._styles.size > 0 : this._attrs.has(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (!(t instanceof ki)) return !1;
          if (this === t) return !0;
          if (this.name != t.name) return !1;
          if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return !1;

          var _iterator13 = _createForOfIteratorHelper(this._attrs),
              _step13;

          try {
            for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
              var _ref14 = _step13.value;

              var _ref11 = _slicedToArray(_ref14, 2);

              var _e14 = _ref11[0];
              var _n9 = _ref11[1];
              if (!t._attrs.has(_e14) || t._attrs.get(_e14) !== _n9) return !1;
            }
          } catch (err) {
            _iterator13.e(err);
          } finally {
            _iterator13.f();
          }

          var _iterator14 = _createForOfIteratorHelper(this._classes),
              _step14;

          try {
            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _e15 = _step14.value;
              if (!t._classes.has(_e15)) return !1;
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }

          var _iterator15 = _createForOfIteratorHelper(this._styles),
              _step15;

          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _ref15 = _step15.value;

              var _ref13 = _slicedToArray(_ref15, 2);

              var _e16 = _ref13[0];
              var _n10 = _ref13[1];
              if (!t._styles.has(_e16) || t._styles.get(_e16) !== _n10) return !1;
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }

          return !0;
        }
      }, {
        key: "hasClass",
        value: function hasClass() {
          for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            t[_key8] = arguments[_key8];
          }

          for (var _i11 = 0, _t18 = t; _i11 < _t18.length; _i11++) {
            var _e17 = _t18[_i11];
            if (!this._classes.has(_e17)) return !1;
          }

          return !0;
        }
      }, {
        key: "getClassNames",
        value: function getClassNames() {
          return this._classes.keys();
        }
      }, {
        key: "getStyle",
        value: function getStyle(t) {
          return this._styles.get(t);
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          return this._styles.keys();
        }
      }, {
        key: "hasStyle",
        value: function hasStyle() {
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }

          for (var _i12 = 0, _t19 = t; _i12 < _t19.length; _i12++) {
            var _e18 = _t19[_i12];
            if (!this._styles.has(_e18)) return !1;
          }

          return !0;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor() {
          for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            t[_key10] = arguments[_key10];
          }

          var e = _construct(bi, t);

          var n = this.parent;

          for (; n;) {
            if (e.match(n)) return n;
            n = n.parent;
          }

          return null;
        }
      }, {
        key: "getCustomProperty",
        value: function getCustomProperty(t) {
          return this._customProperties.get(t);
        }
      }, {
        key: "getCustomProperties",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getCustomProperties() {
          return _regeneratorRuntime.wrap(function getCustomProperties$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.delegateYield(this._customProperties.entries(), "t0", 1);

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, getCustomProperties, this);
        })
      }, {
        key: "getIdentity",
        value: function getIdentity() {
          var t = Array.from(this._classes).sort().join(","),
              e = Array.from(this._styles).map(function (t) {
            return "".concat(t[0], ":").concat(t[1]);
          }).sort().join(";"),
              n = Array.from(this._attrs).map(function (t) {
            return "".concat(t[0], "=\"").concat(t[1], "\"");
          }).sort().join(" ");
          return this.name + ("" == t ? "" : " class=\"".concat(t, "\"")) + ("" == e ? "" : " style=\"".concat(e, "\"")) + ("" == n ? "" : " ".concat(n));
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = [];

          if (t) {
            var _iterator16 = _createForOfIteratorHelper(this.getChildren()),
                _step16;

            try {
              for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                var _n11 = _step16.value;
                e.push(_n11._clone(t));
              }
            } catch (err) {
              _iterator16.e(err);
            } finally {
              _iterator16.f();
            }
          }

          var n = new this.constructor(this.name, this._attrs, e);
          return n._classes = new Set(this._classes), n._styles = new Map(this._styles), n._customProperties = new Map(this._customProperties), n.getFillerOffset = this.getFillerOffset, n;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);

          var n = 0;

          var i = function (t) {
            if ("string" == typeof t) return [new fi(t)];
            pi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new fi(t) : t instanceof mi ? new fi(t.data) : t;
            });
          }(e);

          var _iterator17 = _createForOfIteratorHelper(i),
              _step17;

          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _e19 = _step17.value;
              null !== _e19.parent && _e19._remove(), _e19.parent = this, this._children.splice(t, 0, _e19), t++, n++;
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }

          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _n12 = t; _n12 < t + e; _n12++) {
            this._children[_n12].parent = null;
          }

          return this._children.splice(t, e);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          e = String(e), this._fireChange("attributes", this), "class" == t ? vi(this._classes, e) : "style" == t ? _i(this._styles, e) : this._attrs.set(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._fireChange("attributes", this), "class" == t ? this._classes.size > 0 && (this._classes.clear(), !0) : "style" == t ? this._styles.size > 0 && (this._styles.clear(), !0) : this._attrs.delete(t);
        }
      }, {
        key: "_addClass",
        value: function _addClass(t) {
          var _this6 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this6._classes.add(t);
          });
        }
      }, {
        key: "_removeClass",
        value: function _removeClass(t) {
          var _this7 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this7._classes.delete(t);
          });
        }
      }, {
        key: "_setStyle",
        value: function _setStyle(t, e) {
          if (this._fireChange("attributes", this), T(t)) {
            var _e20 = Object.keys(t);

            for (var _i13 = 0, _e21 = _e20; _i13 < _e21.length; _i13++) {
              var _n13 = _e21[_i13];

              this._styles.set(_n13, t[_n13]);
            }
          } else this._styles.set(t, e);
        }
      }, {
        key: "_removeStyle",
        value: function _removeStyle(t) {
          var _this8 = this;

          this._fireChange("attributes", this), (t = Array.isArray(t) ? t : [t]).forEach(function (t) {
            return _this8._styles.delete(t);
          });
        }
      }, {
        key: "_setCustomProperty",
        value: function _setCustomProperty(t, e) {
          this._customProperties.set(t, e);
        }
      }, {
        key: "_removeCustomProperty",
        value: function _removeCustomProperty(t) {
          return this._customProperties.delete(t);
        }
      }]);

      return ki;
    }(ui);

    function _i(t, e) {
      var n = null,
          i = 0,
          o = 0,
          r = null;

      if (t.clear(), "" !== e) {
        ";" != e.charAt(e.length - 1) && (e += ";");

        for (var _s2 = 0; _s2 < e.length; _s2++) {
          var _a2 = e.charAt(_s2);

          if (null === n) switch (_a2) {
            case ":":
              r || (r = e.substr(i, _s2 - i), o = _s2 + 1);
              break;

            case '"':
            case "'":
              n = _a2;
              break;

            case ";":
              {
                var _n14 = e.substr(o, _s2 - o);

                r && t.set(r.trim(), _n14.trim()), r = null, i = _s2 + 1;
                break;
              }
          } else _a2 === n && (n = null);
        }
      }
    }

    function vi(t, e) {
      var n = e.split(/\s+/);
      t.clear(), n.forEach(function (e) {
        return t.add(e);
      });
    }

    var yi = /*#__PURE__*/function (_ki) {
      _inherits(yi, _ki);

      var _super4 = _createSuper(yi);

      function yi(t, e, n) {
        var _this9;

        _classCallCheck(this, yi);

        _this9 = _super4.call(this, t, e, n), _this9.getFillerOffset = xi;
        return _this9;
      }

      _createClass(yi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t && t.replace(/^view:/, "");
          return e ? "containerElement" == n && e == this.name || _get(_getPrototypeOf(yi.prototype), "is", this).call(this, t, e) : "containerElement" == n || _get(_getPrototypeOf(yi.prototype), "is", this).call(this, t);
        }
      }]);

      return yi;
    }(ki);

    function xi() {
      var t = _toConsumableArray(this.getChildren()),
          e = t[this.childCount - 1];

      if (e && e.is("element", "br")) return this.childCount;

      var _iterator18 = _createForOfIteratorHelper(t),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var _e22 = _step18.value;
          if (!_e22.is("uiElement")) return null;
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }

      return this.childCount;
    }

    var Ai = function Ai(t) {
      return t;
    };

    var Ti = function Ti(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);

        case 1:
          return t.call(e, n[0]);

        case 2:
          return t.call(e, n[0], n[1]);

        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }

      return t.apply(e, n);
    },
        Ci = Math.max;

    var Pi = function Pi(t, e, n) {
      return e = Ci(void 0 === e ? t.length - 1 : e, 0), function () {
        for (var i = arguments, o = -1, r = Ci(i.length - e, 0), s = Array(r); ++o < r;) {
          s[o] = i[e + o];
        }

        o = -1;

        for (var a = Array(e + 1); ++o < e;) {
          a[o] = i[o];
        }

        return a[e] = n(s), Ti(t, this, a);
      };
    };

    var Si = function Si(t) {
      return function () {
        return t;
      };
    },
        Mi = Ot ? function (t, e) {
      return Ot(t, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Si(e),
        writable: !0
      });
    } : Ai,
        Ei = 800,
        Ii = 16,
        Ni = Date.now;

    var Oi = function (t) {
      var e = 0,
          n = 0;
      return function () {
        var i = Ni(),
            o = Ii - (i - n);

        if (n = i, o > 0) {
          if (++e >= Ei) return arguments[0];
        } else e = 0;

        return t.apply(void 0, arguments);
      };
    }(Mi);

    var Ri = function Ri(t, e) {
      return Oi(Pi(t, e, Ai), t + "");
    };

    var Di = function Di(t, e, n) {
      if (!B(n)) return !1;

      var i = _typeof(e);

      return !!("number" == i ? he(n) && Qt(e, n.length) : "string" == i && e in n) && P(n[e], t);
    };

    var Li = function (t) {
      return Ri(function (e, n) {
        var i = -1,
            o = n.length,
            r = o > 1 ? n[o - 1] : void 0,
            s = o > 2 ? n[2] : void 0;

        for (r = t.length > 3 && "function" == typeof r ? (o--, r) : void 0, s && Di(n[0], n[1], s) && (r = o < 3 ? void 0 : r, o = 1), e = Object(e); ++i < o;) {
          var a = n[i];
          a && t(e, a, i, r);
        }

        return e;
      });
    }(function (t, e) {
      jt(e, be(e), t);
    });

    var ji = Symbol("observableProperties"),
        Vi = Symbol("boundObservables"),
        zi = Symbol("boundProperties"),
        Bi = {
      set: function set(t, e) {
        var _this10 = this;

        if (B(t)) return void Object.keys(t).forEach(function (e) {
          _this10.set(e, t[e]);
        }, this);
        Ui(this);
        var n = this[ji];
        if (t in this && !n.has(t)) throw new Gn.b("observable-set-cannot-override: Cannot override an existing property.", this);
        Object.defineProperty(this, t, {
          enumerable: !0,
          configurable: !0,
          get: function get() {
            return n.get(t);
          },
          set: function set(e) {
            var i = n.get(t);
            var o = this.fire("set:" + t, t, e, i);
            void 0 === o && (o = e), i === o && n.has(t) || (n.set(t, o), this.fire("change:" + t, t, o, i));
          }
        }), this[t] = e;
      },
      bind: function bind() {
        var _this11 = this;

        for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          t[_key11] = arguments[_key11];
        }

        if (!t.length || !Wi(t)) throw new Gn.b("observable-bind-wrong-properties: All properties must be strings.", this);
        if (new Set(t).size !== t.length) throw new Gn.b("observable-bind-duplicate-properties: Properties must be unique.", this);
        Ui(this);
        var e = this[zi];
        t.forEach(function (t) {
          if (e.has(t)) throw new Gn.b("observable-bind-rebind: Cannot bind the same property more that once.", _this11);
        });
        var n = new Map();
        return t.forEach(function (t) {
          var i = {
            property: t,
            to: []
          };
          e.set(t, i), n.set(t, i);
        }), {
          to: Hi,
          toMany: qi,
          _observable: this,
          _bindProperties: t,
          _to: [],
          _bindings: n
        };
      },
      unbind: function unbind() {
        var _this12 = this;

        if (!(ji in this)) return;
        var e = this[zi],
            n = this[Vi];

        for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          t[_key12] = arguments[_key12];
        }

        if (t.length) {
          if (!Wi(t)) throw new Gn.b("observable-unbind-wrong-properties: Properties must be strings.", this);
          t.forEach(function (t) {
            var i = e.get(t);
            if (!i) return;
            var o, r, s, a;
            i.to.forEach(function (t) {
              o = t[0], r = t[1], s = n.get(o), (a = s[r]).delete(i), a.size || delete s[r], Object.keys(s).length || (n.delete(o), _this12.stopListening(o, "change"));
            }), e.delete(t);
          });
        } else n.forEach(function (t, e) {
          _this12.stopListening(e, "change");
        }), n.clear(), e.clear();
      },
      decorate: function decorate(t) {
        var _this13 = this;

        var e = this[t];
        if (!e) throw new Gn.b("observablemixin-cannot-decorate-undefined: Cannot decorate an undefined method.", this, {
          object: this,
          methodName: t
        });
        this.on(t, function (t, n) {
          t.return = e.apply(_this13, n);
        }), this[t] = function () {
          for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            e[_key13] = arguments[_key13];
          }

          return this.fire(t, e);
        };
      }
    };
    Li(Bi, ei);
    var Fi = Bi;

    function Ui(t) {
      ji in t || (Object.defineProperty(t, ji, {
        value: new Map()
      }), Object.defineProperty(t, Vi, {
        value: new Map()
      }), Object.defineProperty(t, zi, {
        value: new Map()
      }));
    }

    function Hi() {
      var _this14 = this;

      var e = function () {
        for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
          t[_key14] = arguments[_key14];
        }

        if (!t.length) throw new Gn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
        var e = {
          to: []
        };
        var n;
        "function" == typeof t[t.length - 1] && (e.callback = t.pop());
        return t.forEach(function (t) {
          if ("string" == typeof t) n.properties.push(t);else {
            if ("object" != _typeof(t)) throw new Gn.b("observable-bind-to-parse-error: Invalid argument syntax in `to()`.", null);
            n = {
              observable: t,
              properties: []
            }, e.to.push(n);
          }
        }), e;
      }.apply(void 0, arguments),
          n = Array.from(this._bindings.keys()),
          i = n.length;

      if (!e.callback && e.to.length > 1) throw new Gn.b("observable-bind-to-no-callback: Binding multiple observables only possible with callback.", this);
      if (i > 1 && e.callback) throw new Gn.b("observable-bind-to-extra-callback: Cannot bind multiple properties and use a callback in one binding.", this);
      e.to.forEach(function (t) {
        if (t.properties.length && t.properties.length !== i) throw new Gn.b("observable-bind-to-properties-length: The number of properties must match.", _this14);
        t.properties.length || (t.properties = _this14._bindProperties);
      }), this._to = e.to, e.callback && (this._bindings.get(n[0]).callback = e.callback), function (t, e) {
        e.forEach(function (e) {
          var n = t[Vi];
          var i;
          n.get(e.observable) || t.listenTo(e.observable, "change", function (o, r) {
            (i = n.get(e.observable)[r]) && i.forEach(function (e) {
              Yi(t, e.property);
            });
          });
        });
      }(this._observable, this._to), function (t) {
        var e;

        t._bindings.forEach(function (n, i) {
          t._to.forEach(function (o) {
            e = o.properties[n.callback ? 0 : t._bindProperties.indexOf(i)], n.to.push([o.observable, e]), function (t, e, n, i) {
              var o = t[Vi],
                  r = o.get(n),
                  s = r || {};
              s[i] || (s[i] = new Set());
              s[i].add(e), r || o.set(n, s);
            }(t._observable, n, o.observable, e);
          });
        });
      }(this), this._bindProperties.forEach(function (t) {
        Yi(_this14._observable, t);
      });
    }

    function qi(t, e, n) {
      if (this._bindings.size > 1) throw new Gn.b("observable-bind-to-many-not-one-binding: Cannot bind multiple properties with toMany().", this);
      this.to.apply(this, _toConsumableArray(function (t, e) {
        var n = t.map(function (t) {
          return [t, e];
        });
        return Array.prototype.concat.apply([], n);
      }(t, e)).concat([n]));
    }

    function Wi(t) {
      return t.every(function (t) {
        return "string" == typeof t;
      });
    }

    function Yi(t, e) {
      var n = t[zi].get(e);
      var i;
      i = n.callback ? n.callback.apply(t, n.to.map(function (t) {
        return t[0][t[1]];
      })) : (i = n.to[0])[0][i[1]], t.hasOwnProperty(e) ? t[e] = i : t.set(e, i);
    }

    var $i = Symbol("document");

    var Gi = /*#__PURE__*/function (_yi) {
      _inherits(Gi, _yi);

      var _super5 = _createSuper(Gi);

      function Gi(t, e, n) {
        var _this15;

        _classCallCheck(this, Gi);

        _this15 = _super5.call(this, t, e, n), _this15.set("isReadOnly", !1), _this15.set("isFocused", !1);
        return _this15;
      }

      _createClass(Gi, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t && t.replace(/^view:/, "");
          return e ? "editableElement" == n && e == this.name || _get(_getPrototypeOf(Gi.prototype), "is", this).call(this, t, e) : "editableElement" == n || _get(_getPrototypeOf(Gi.prototype), "is", this).call(this, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "document",
        get: function get() {
          return this.getCustomProperty($i);
        }
      }, {
        key: "_document",
        set: function set(t) {
          var _this16 = this;

          if (this.getCustomProperty($i)) throw new Gn.b("view-editableelement-document-already-set: View document is already set.", this);
          this._setCustomProperty($i, t), this.bind("isReadOnly").to(t), this.bind("isFocused").to(t, "isFocused", function (e) {
            return e && t.selection.editableElement == _this16;
          }), this.listenTo(t.selection, "change", function () {
            _this16.isFocused = t.isFocused && t.selection.editableElement == _this16;
          });
        }
      }]);

      return Gi;
    }(yi);

    ci(Gi, Fi);
    var Qi = Symbol("rootName");

    var Ki = /*#__PURE__*/function (_Gi) {
      _inherits(Ki, _Gi);

      var _super6 = _createSuper(Ki);

      function Ki(t) {
        var _this17;

        _classCallCheck(this, Ki);

        _this17 = _super6.call(this, t), _this17.rootName = "main";
        return _this17;
      }

      _createClass(Ki, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "rootElement" == n && e == this.name || _get(_getPrototypeOf(Ki.prototype), "is", this).call(this, t, e) : "rootElement" == n || _get(_getPrototypeOf(Ki.prototype), "is", this).call(this, t);
        }
      }, {
        key: "rootName",
        get: function get() {
          return this.getCustomProperty(Qi);
        },
        set: function set(t) {
          this._setCustomProperty(Qi, t);
        }
      }, {
        key: "_name",
        set: function set(t) {
          this.name = t;
        }
      }]);

      return Ki;
    }(Gi);

    var Ji = /*#__PURE__*/function (_Symbol$iterator) {
      function Ji() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Ji);

        if (!t.boundaries && !t.startPosition) throw new Gn.b("view-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
        if (t.direction && "forward" != t.direction && "backward" != t.direction) throw new Gn.b("view-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", t.startPosition, {
          direction: t.direction
        });
        this.boundaries = t.boundaries || null, t.startPosition ? this.position = Zi._createAt(t.startPosition) : this.position = Zi._createAt(t.boundaries["backward" == t.direction ? "end" : "start"]), this.direction = t.direction || "forward", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }

      _createClass(Ji, [{
        key: _Symbol$iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, i;

          do {
            var _this$next;

            i = this.position, (_this$next = this.next(), e = _this$next.done, n = _this$next.value, _this$next);
          } while (!e && t(n));

          e || (this.position = i);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position.clone();
          var e = this.position,
              n = t.parent;
          if (null === n.parent && t.offset === n.childCount) return {
            done: !0
          };
          if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var i;

          if (n instanceof fi) {
            if (t.isAtEnd) return this.position = Zi._createAfter(n), this._next();
            i = n.data[t.offset];
          } else i = n.getChild(t.offset);

          if (i instanceof ki) return this.shallow ? t.offset++ : t = new Zi(i, 0), this.position = t, this._formatReturnValue("elementStart", i, e, t, 1);

          if (i instanceof fi) {
            if (this.singleCharacters) return t = new Zi(i, 0), this.position = t, this._next();
            {
              var _n15,
                  _o7 = i.data.length;

              return i == this._boundaryEndParent ? (_o7 = this.boundaries.end.offset, _n15 = new mi(i, 0, _o7), t = Zi._createAfter(_n15)) : (_n15 = new mi(i, 0, i.data.length), t.offset++), this.position = t, this._formatReturnValue("text", _n15, e, t, _o7);
            }
          }

          if ("string" == typeof i) {
            var _i14;

            if (this.singleCharacters) _i14 = 1;else {
              _i14 = (n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length) - t.offset;
            }

            var _o8 = new mi(n, t.offset, _i14);

            return t.offset += _i14, this.position = t, this._formatReturnValue("text", _o8, e, t, _i14);
          }

          return t = Zi._createAfter(n), this.position = t, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n, e, t);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position.clone();
          var e = this.position,
              n = t.parent;
          if (null === n.parent && 0 === t.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var i;

          if (n instanceof fi) {
            if (t.isAtStart) return this.position = Zi._createBefore(n), this._previous();
            i = n.data[t.offset - 1];
          } else i = n.getChild(t.offset - 1);

          if (i instanceof ki) return this.shallow ? (t.offset--, this.position = t, this._formatReturnValue("elementStart", i, e, t, 1)) : (t = new Zi(i, i.childCount), this.position = t, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", i, e, t));

          if (i instanceof fi) {
            if (this.singleCharacters) return t = new Zi(i, i.data.length), this.position = t, this._previous();
            {
              var _n16,
                  _o9 = i.data.length;

              if (i == this._boundaryStartParent) {
                var _e23 = this.boundaries.start.offset;
                _o9 = (_n16 = new mi(i, _e23, i.data.length - _e23)).data.length, t = Zi._createBefore(_n16);
              } else _n16 = new mi(i, 0, i.data.length), t.offset--;

              return this.position = t, this._formatReturnValue("text", _n16, e, t, _o9);
            }
          }

          if ("string" == typeof i) {
            var _i15;

            if (this.singleCharacters) _i15 = 1;else {
              var _e24 = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;

              _i15 = t.offset - _e24;
            }
            t.offset -= _i15;

            var _o10 = new mi(n, t.offset, _i15);

            return this.position = t, this._formatReturnValue("text", _o10, e, t, _i15);
          }

          return t = Zi._createBefore(n), this.position = t, this._formatReturnValue("elementStart", n, e, t, 1);
        }
      }, {
        key: "_formatReturnValue",
        value: function _formatReturnValue(t, e, n, i, o) {
          return e instanceof mi && (e.offsetInText + e.data.length == e.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n = Zi._createAfter(e.textNode) : (i = Zi._createAfter(e.textNode), this.position = i)), 0 === e.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n = Zi._createBefore(e.textNode) : (i = Zi._createBefore(e.textNode), this.position = i))), {
            done: !1,
            value: {
              type: t,
              item: e,
              previousPosition: n,
              nextPosition: i,
              length: o
            }
          };
        }
      }]);

      return Ji;
    }(Symbol.iterator);

    var Zi = /*#__PURE__*/function () {
      function Zi(t, e) {
        _classCallCheck(this, Zi);

        this.parent = t, this.offset = e;
      }

      _createClass(Zi, [{
        key: "nodeAfter",
        get: function get() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset) || null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return this.parent.is("text") ? null : this.parent.getChild(this.offset - 1) || null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          var t = this.parent.is("text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === t;
        }
      }, {
        key: "root",
        get: function get() {
          return this.parent.root;
        }
      }, {
        key: "editableElement",
        get: function get() {
          var t = this.parent;

          for (; !(t instanceof Gi);) {
            if (!t.parent) return null;
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = Zi._createAt(this),
              n = e.offset + t;

          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new Ji(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
              n = t.getAncestors();
          var i = 0;

          for (; e[i] == n[i] && e[i];) {
            i++;
          }

          return 0 === i ? null : e[i - 1];
        }
      }, {
        key: "is",
        value: function is(t) {
          return "position" == t || "view:position" == t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset;
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root !== t.root) return "different";
          if (this.isEqual(t)) return "same";
          var e = this.parent.is("node") ? this.parent.getPath() : [],
              n = t.parent.is("node") ? t.parent.getPath() : [];
          e.push(this.offset), n.push(t.offset);
          var i = li(e, n);

          switch (i) {
            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return e[i] < n[i] ? "before" : "after";
          }
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.startPosition = this, new Ji(t);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Zi(this.parent, this.offset);
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          if (t instanceof Zi) return new this(t.parent, t.offset);
          {
            var _n17 = t;
            if ("end" == e) e = _n17.is("text") ? _n17.data.length : _n17.childCount;else {
              if ("before" == e) return this._createBefore(_n17);
              if ("after" == e) return this._createAfter(_n17);
              if (0 !== e && !e) throw new Gn.b("view-createPositionAt-offset-required: View#createPositionAt() requires the offset when the first parameter is a view item.", _n17);
            }
            return new Zi(_n17, e);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t) {
          if (t.is("textProxy")) return new Zi(t.textNode, t.offsetInText + t.data.length);
          if (!t.parent) throw new Gn.b("view-position-after-root: You can not make position after root.", t, {
            root: t
          });
          return new Zi(t.parent, t.index + 1);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t) {
          if (t.is("textProxy")) return new Zi(t.textNode, t.offsetInText);
          if (!t.parent) throw new Gn.b("view-position-before-root: You can not make position before root.", t, {
            root: t
          });
          return new Zi(t.parent, t.index);
        }
      }]);

      return Zi;
    }();

    var Xi = /*#__PURE__*/function (_Symbol$iterator2) {
      function Xi(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Xi);

        this.start = t.clone(), this.end = e ? e.clone() : t.clone();
      }

      _createClass(Xi, [{
        key: _Symbol$iterator2,
        value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.delegateYield(new Ji({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return this.start.parent === this.end.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }, {
        key: "getEnlarged",
        value: function getEnlarged() {
          var t = this.start.getLastMatchingPosition(to, {
            direction: "backward"
          }),
              e = this.end.getLastMatchingPosition(to);
          return t.parent.is("text") && t.isAtStart && (t = Zi._createBefore(t.parent)), e.parent.is("text") && e.isAtEnd && (e = Zi._createAfter(e.parent)), new Xi(t, e);
        }
      }, {
        key: "getTrimmed",
        value: function getTrimmed() {
          var t = this.start.getLastMatchingPosition(to);
          if (t.isAfter(this.end) || t.isEqual(this.end)) return new Xi(t, t);
          var e = this.end.getLastMatchingPosition(to, {
            direction: "backward"
          });
          var n = t.nodeAfter,
              i = e.nodeBefore;
          return n && n.is("text") && (t = new Zi(n, 0)), i && i.is("text") && (e = new Zi(i, i.data.length)), new Xi(t, e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
              i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && i;
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Xi(this.start, t.start)), this.containsPosition(t.end) && e.push(new Xi(t.end, this.end))) : e.push(this.clone()), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e25 = this.start,
                _n18 = this.end;
            return this.containsPosition(t.start) && (_e25 = t.start), this.containsPosition(t.end) && (_n18 = t.end), new Xi(_e25, _n18);
          }

          return null;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new Ji(t);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Xi(this.start, this.end);
        }
      }, {
        key: "getItems",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getItems() {
          var t,
              e,
              _iterator19,
              _step19,
              _t20,
              _args5 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  t = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {};
                  t.boundaries = this, t.ignoreElementEnd = !0;
                  e = new Ji(t);
                  _iterator19 = _createForOfIteratorHelper(e);
                  _context5.prev = 4;

                  _iterator19.s();

                case 6:
                  if ((_step19 = _iterator19.n()).done) {
                    _context5.next = 12;
                    break;
                  }

                  _t20 = _step19.value;
                  _context5.next = 10;
                  return _t20.item;

                case 10:
                  _context5.next = 6;
                  break;

                case 12:
                  _context5.next = 17;
                  break;

                case 14:
                  _context5.prev = 14;
                  _context5.t0 = _context5["catch"](4);

                  _iterator19.e(_context5.t0);

                case 17:
                  _context5.prev = 17;

                  _iterator19.f();

                  return _context5.finish(17);

                case 20:
                case "end":
                  return _context5.stop();
              }
            }
          }, getItems, this, [[4, 14, 17, 20]]);
        })
      }, {
        key: "getPositions",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getPositions() {
          var t,
              e,
              _iterator20,
              _step20,
              _t21,
              _args6 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  t = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                  t.boundaries = this;
                  e = new Ji(t);
                  _context6.next = 5;
                  return e.position;

                case 5:
                  _iterator20 = _createForOfIteratorHelper(e);
                  _context6.prev = 6;

                  _iterator20.s();

                case 8:
                  if ((_step20 = _iterator20.n()).done) {
                    _context6.next = 14;
                    break;
                  }

                  _t21 = _step20.value;
                  _context6.next = 12;
                  return _t21.nextPosition;

                case 12:
                  _context6.next = 8;
                  break;

                case 14:
                  _context6.next = 19;
                  break;

                case 16:
                  _context6.prev = 16;
                  _context6.t0 = _context6["catch"](6);

                  _iterator20.e(_context6.t0);

                case 19:
                  _context6.prev = 19;

                  _iterator20.f();

                  return _context6.finish(19);

                case 22:
                case "end":
                  return _context6.stop();
              }
            }
          }, getPositions, this, [[6, 16, 19, 22]]);
        })
      }, {
        key: "is",
        value: function is(t) {
          return "range" == t || "view:range" == t;
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }], [{
        key: "_createFromParentsAndOffsets",
        value: function _createFromParentsAndOffsets(t, e, n, i) {
          return new this(new Zi(t, e), new Zi(n, i));
        }
      }, {
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
              i = t.getShiftedBy(e);
          return e > 0 ? new this(n, i) : new this(i, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          var e = t.is("textProxy") ? t.offsetSize : 1;
          return this._createFromPositionAndShift(Zi._createBefore(t), e);
        }
      }]);

      return Xi;
    }(Symbol.iterator);

    function to(t) {
      return !(!t.item.is("attributeElement") && !t.item.is("uiElement"));
    }

    function eo(t) {
      var e = 0;

      var _iterator21 = _createForOfIteratorHelper(t),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _n19 = _step21.value;
          e++;
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      return e;
    }

    var no = /*#__PURE__*/function () {
      function no() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, no);

        this._ranges = [], this._lastRangeBackward = !1, this._isFake = !1, this._fakeSelectionLabel = "", this.setTo(t, e, n);
      }

      _createClass(no, [{
        key: "isFake",
        get: function get() {
          return this._isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.end : t.start).clone();
        }
      }, {
        key: "focus",
        get: function get() {
          if (!this._ranges.length) return null;
          var t = this._ranges[this._ranges.length - 1];
          return (this._lastRangeBackward ? t.start : t.end).clone();
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this.rangeCount && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this.anchor ? this.anchor.editableElement : null;
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
          var _iterator22, _step22, _t22;

          return _regeneratorRuntime.wrap(function getRanges$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _iterator22 = _createForOfIteratorHelper(this._ranges);
                  _context7.prev = 1;

                  _iterator22.s();

                case 3:
                  if ((_step22 = _iterator22.n()).done) {
                    _context7.next = 9;
                    break;
                  }

                  _t22 = _step22.value;
                  _context7.next = 7;
                  return _t22.clone();

                case 7:
                  _context7.next = 3;
                  break;

                case 9:
                  _context7.next = 14;
                  break;

                case 11:
                  _context7.prev = 11;
                  _context7.t0 = _context7["catch"](1);

                  _iterator22.e(_context7.t0);

                case 14:
                  _context7.prev = 14;

                  _iterator22.f();

                  return _context7.finish(14);

                case 17:
                case "end":
                  return _context7.stop();
              }
            }
          }, getRanges, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;

          var _iterator23 = _createForOfIteratorHelper(this._ranges),
              _step23;

          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var _e26 = _step23.value;
              t && !_e26.start.isBefore(t.start) || (t = _e26);
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }

          return t ? t.clone() : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;

          var _iterator24 = _createForOfIteratorHelper(this._ranges),
              _step24;

          try {
            for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
              var _e27 = _step24.value;
              t && !_e27.end.isAfter(t.end) || (t = _e27);
            }
          } catch (err) {
            _iterator24.e(err);
          } finally {
            _iterator24.f();
          }

          return t ? t.clone() : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          if (this.isFake != t.isFake) return !1;
          if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return !1;
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;

          var _iterator25 = _createForOfIteratorHelper(this._ranges),
              _step25;

          try {
            for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
              var _e28 = _step25.value;

              var _n20 = !1;

              var _iterator26 = _createForOfIteratorHelper(t._ranges),
                  _step26;

              try {
                for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                  var _i16 = _step26.value;

                  if (_e28.isEqual(_i16)) {
                    _n20 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator26.e(err);
              } finally {
                _iterator26.f();
              }

              if (!_n20) return !1;
            }
          } catch (err) {
            _iterator25.e(err);
          } finally {
            _iterator25.f();
          }

          return !0;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (this.isBackward != t.isBackward) return !1;
          var e = eo(this.getRanges());
          if (e != eo(t.getRanges())) return !1;
          if (0 == e) return !0;

          var _iterator27 = _createForOfIteratorHelper(this.getRanges()),
              _step27;

          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var _e29 = _step27.value;
              _e29 = _e29.getTrimmed();

              var _n21 = !1;

              var _iterator28 = _createForOfIteratorHelper(t.getRanges()),
                  _step28;

              try {
                for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                  var _i17 = _step28.value;

                  if (_i17 = _i17.getTrimmed(), _e29.start.isEqual(_i17.start) && _e29.end.isEqual(_i17.end)) {
                    _n21 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator28.e(err);
              } finally {
                _iterator28.f();
              }

              if (!_n21) return !1;
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }

          return !0;
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (1 !== this.rangeCount) return null;
          var t = this.getFirstRange();
          var e = t.start.nodeAfter,
              n = t.end.nodeBefore;
          return t.start.parent.is("text") && t.start.isAtEnd && t.start.parent.nextSibling && (e = t.start.parent.nextSibling), t.end.parent.is("text") && t.end.isAtStart && t.end.parent.previousSibling && (n = t.end.parent.previousSibling), e instanceof ki && e == n ? e : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]), this._setFakeOptions(e);else if (t instanceof no || t instanceof io) this._setRanges(t.getRanges(), t.isBackward), this._setFakeOptions({
            fake: t.isFake,
            label: t.fakeSelectionLabel
          });else if (t instanceof Xi) this._setRanges([t], e && e.backward), this._setFakeOptions(e);else if (t instanceof Zi) this._setRanges([new Xi(t)]), this._setFakeOptions(e);else if (t instanceof ui) {
            var _i18 = !!n && !!n.backward;

            var _o11;

            if (void 0 === e) throw new Gn.b("view-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", this);
            _o11 = "in" == e ? Xi._createIn(t) : "on" == e ? Xi._createOn(t) : new Xi(Zi._createAt(t, e)), this._setRanges([_o11], _i18), this._setFakeOptions(n);
          } else {
            if (!pi(t)) throw new Gn.b("view-selection-setTo-not-selectable: Cannot set selection to given place.", this);
            this._setRanges(t, e && e.backward), this._setFakeOptions(e);
          }
          this.fire("change");
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new Gn.b("view-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", this);

          var n = Zi._createAt(t, e);

          if ("same" == n.compareWith(this.focus)) return;
          var i = this.anchor;
          this._ranges.pop(), "before" == n.compareWith(i) ? this._addRange(new Xi(n, i), !0) : this._addRange(new Xi(i, n)), this.fire("change");
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "view:selection" == t;
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t = Array.from(t), this._ranges = [];

          var _iterator29 = _createForOfIteratorHelper(t),
              _step29;

          try {
            for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
              var _e30 = _step29.value;

              this._addRange(_e30);
            }
          } catch (err) {
            _iterator29.e(err);
          } finally {
            _iterator29.f();
          }

          this._lastRangeBackward = !!e;
        }
      }, {
        key: "_setFakeOptions",
        value: function _setFakeOptions() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this._isFake = !!t.fake, this._fakeSelectionLabel = t.fake && t.label || "";
        }
      }, {
        key: "_addRange",
        value: function _addRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          if (!(t instanceof Xi)) throw new Gn.b("view-selection-add-range-not-range: Selection range set to an object that is not an instance of view.Range", this);
          this._pushRange(t), this._lastRangeBackward = !!e;
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var _iterator30 = _createForOfIteratorHelper(this._ranges),
              _step30;

          try {
            for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
              var _e31 = _step30.value;
              if (t.isIntersecting(_e31)) throw new Gn.b("view-selection-range-intersects: Trying to add a range that intersects with another range from selection.", this, {
                addedRange: t,
                intersectingRange: _e31
              });
            }
          } catch (err) {
            _iterator30.e(err);
          } finally {
            _iterator30.f();
          }

          this._ranges.push(new Xi(t.start, t.end));
        }
      }]);

      return no;
    }();

    ci(no, ei);

    var io = /*#__PURE__*/function () {
      function io() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        _classCallCheck(this, io);

        this._selection = new no(), this._selection.delegate("change").to(this), this._selection.setTo(t, e, n);
      }

      _createClass(io, [{
        key: "isFake",
        get: function get() {
          return this._selection.isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._selection.fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this._selection.editableElement;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.delegateYield(this._selection.getRanges(), "t0", 1);

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this._selection.isEqual(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return this._selection.isSimilar(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "documentSelection" == t || "view:selection" == t || "view:documentSelection" == t;
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }]);

      return io;
    }();

    ci(io, ei);

    var oo = /*#__PURE__*/function (_Symbol$iterator3) {
      function oo() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, oo);

        this._items = [], this._itemMap = new Map(), this._idProperty = t.idProperty || "id", this._bindToExternalToInternalMap = new WeakMap(), this._bindToInternalToExternalMap = new WeakMap(), this._skippedIndexesFromExternal = [];
      }

      _createClass(oo, [{
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._items[0] || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this.length - 1] || null;
        }
      }, {
        key: "add",
        value: function add(t, e) {
          var n;
          var i = this._idProperty;

          if (i in t) {
            if ("string" != typeof (n = t[i])) throw new Gn.b("collection-add-invalid-id", this);
            if (this.get(n)) throw new Gn.b("collection-add-item-already-exists", this);
          } else t[i] = n = Jn();

          if (void 0 === e) e = this._items.length;else if (e > this._items.length || e < 0) throw new Gn.b("collection-add-item-invalid-index", this);
          return this._items.splice(e, 0, t), this._itemMap.set(n, t), this.fire("add", t, e), this;
        }
      }, {
        key: "get",
        value: function get(t) {
          var e;
          if ("string" == typeof t) e = this._itemMap.get(t);else {
            if ("number" != typeof t) throw new Gn.b("collection-get-invalid-arg: Index or id must be given.", this);
            e = this._items[t];
          }
          return e || null;
        }
      }, {
        key: "has",
        value: function has(t) {
          if ("string" == typeof t) return this._itemMap.has(t);
          {
            var _e32 = t[this._idProperty];
            return this._itemMap.has(_e32);
          }
        }
      }, {
        key: "getIndex",
        value: function getIndex(t) {
          var e;
          return e = "string" == typeof t ? this._itemMap.get(t) : t, this._items.indexOf(e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e,
              n,
              i,
              o = !1;
          var r = this._idProperty;
          if ("string" == typeof t ? (n = t, o = !(i = this._itemMap.get(n)), i && (e = this._items.indexOf(i))) : "number" == typeof t ? (e = t, o = !(i = this._items[e]), i && (n = i[r])) : (n = (i = t)[r], o = -1 == (e = this._items.indexOf(i)) || !this._itemMap.get(n)), o) throw new Gn.b("collection-remove-404: Item not found.", this);
          this._items.splice(e, 1), this._itemMap.delete(n);

          var s = this._bindToInternalToExternalMap.get(i);

          return this._bindToInternalToExternalMap.delete(i), this._bindToExternalToInternalMap.delete(s), this.fire("remove", i, e), i;
        }
      }, {
        key: "map",
        value: function map(t, e) {
          return this._items.map(t, e);
        }
      }, {
        key: "find",
        value: function find(t, e) {
          return this._items.find(t, e);
        }
      }, {
        key: "filter",
        value: function filter(t, e) {
          return this._items.filter(t, e);
        }
      }, {
        key: "clear",
        value: function clear() {
          for (this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null); this.length;) {
            this.remove(0);
          }
        }
      }, {
        key: "bindTo",
        value: function bindTo(t) {
          var _this18 = this;

          if (this._bindToCollection) throw new Gn.b("collection-bind-to-rebind: The collection cannot be bound more than once.", this);
          return this._bindToCollection = t, {
            as: function as(t) {
              _this18._setUpBindToBinding(function (e) {
                return new t(e);
              });
            },
            using: function using(t) {
              "function" == typeof t ? _this18._setUpBindToBinding(function (e) {
                return t(e);
              }) : _this18._setUpBindToBinding(function (e) {
                return e[t];
              });
            }
          };
        }
      }, {
        key: "_setUpBindToBinding",
        value: function _setUpBindToBinding(t) {
          var _this19 = this;

          var e = this._bindToCollection,
              n = function n(_n23, i, o) {
            var r = e._bindToCollection == _this19,
                s = e._bindToInternalToExternalMap.get(i);

            if (r && s) _this19._bindToExternalToInternalMap.set(i, s), _this19._bindToInternalToExternalMap.set(s, i);else {
              var _n22 = t(i);

              if (!_n22) return void _this19._skippedIndexesFromExternal.push(o);
              var _r2 = o;

              var _iterator31 = _createForOfIteratorHelper(_this19._skippedIndexesFromExternal),
                  _step31;

              try {
                for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                  var _t24 = _step31.value;
                  o > _t24 && _r2--;
                }
              } catch (err) {
                _iterator31.e(err);
              } finally {
                _iterator31.f();
              }

              var _iterator32 = _createForOfIteratorHelper(e._skippedIndexesFromExternal),
                  _step32;

              try {
                for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                  var _t25 = _step32.value;
                  _r2 >= _t25 && _r2++;
                }
              } catch (err) {
                _iterator32.e(err);
              } finally {
                _iterator32.f();
              }

              _this19._bindToExternalToInternalMap.set(i, _n22), _this19._bindToInternalToExternalMap.set(_n22, i), _this19.add(_n22, _r2);

              for (var _t23 = 0; _t23 < e._skippedIndexesFromExternal.length; _t23++) {
                _r2 <= e._skippedIndexesFromExternal[_t23] && e._skippedIndexesFromExternal[_t23]++;
              }
            }
          };

          var _iterator33 = _createForOfIteratorHelper(e),
              _step33;

          try {
            for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
              var _t26 = _step33.value;
              n(0, _t26, e.getIndex(_t26));
            }
          } catch (err) {
            _iterator33.e(err);
          } finally {
            _iterator33.f();
          }

          this.listenTo(e, "add", n), this.listenTo(e, "remove", function (t, e, n) {
            var i = _this19._bindToExternalToInternalMap.get(e);

            i && _this19.remove(i), _this19._skippedIndexesFromExternal = _this19._skippedIndexesFromExternal.reduce(function (t, e) {
              return n < e && t.push(e - 1), n > e && t.push(e), t;
            }, []);
          });
        }
      }, {
        key: _Symbol$iterator3,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }]);

      return oo;
    }(Symbol.iterator);

    ci(oo, ei);

    var ro = /*#__PURE__*/function () {
      function ro() {
        _classCallCheck(this, ro);

        this.selection = new io(), this.roots = new oo({
          idProperty: "rootName"
        }), this.set("isReadOnly", !1), this.set("isFocused", !1), this.set("isComposing", !1), this._postFixers = new Set();
      }

      _createClass(ro, [{
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.roots.map(function (t) {
            return t.destroy();
          }), this.stopListening();
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;

          do {
            var _iterator34 = _createForOfIteratorHelper(this._postFixers),
                _step34;

            try {
              for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                var _n24 = _step34.value;
                if (e = _n24(t)) break;
              }
            } catch (err) {
              _iterator34.e(err);
            } finally {
              _iterator34.f();
            }
          } while (e);
        }
      }]);

      return ro;
    }();

    ci(ro, Fi);
    var so = 10;

    var ao = /*#__PURE__*/function (_ki2) {
      _inherits(ao, _ki2);

      var _super7 = _createSuper(ao);

      function ao(t, e, n) {
        var _this20;

        _classCallCheck(this, ao);

        _this20 = _super7.call(this, t, e, n), _this20.getFillerOffset = co, _this20._priority = so, _this20._id = null, _this20._clonesGroup = null;
        return _this20;
      }

      _createClass(ao, [{
        key: "priority",
        get: function get() {
          return this._priority;
        }
      }, {
        key: "id",
        get: function get() {
          return this._id;
        }
      }, {
        key: "getElementsWithSameId",
        value: function getElementsWithSameId() {
          if (null === this.id) throw new Gn.b("attribute-element-get-elements-with-same-id-no-id: Cannot get elements with the same id for an attribute element without id.", this);
          return new Set(this._clonesGroup);
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t && t.replace(/^view:/, "");
          return e ? "attributeElement" == n && e == this.name || _get(_getPrototypeOf(ao.prototype), "is", this).call(this, t, e) : "attributeElement" == n || _get(_getPrototypeOf(ao.prototype), "is", this).call(this, t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return null !== this.id || null !== t.id ? this.id === t.id : _get(_getPrototypeOf(ao.prototype), "isSimilar", this).call(this, t) && this.priority == t.priority;
        }
      }, {
        key: "_clone",
        value: function _clone(t) {
          var e = _get(_getPrototypeOf(ao.prototype), "_clone", this).call(this, t);

          return e._priority = this._priority, e._id = this._id, e;
        }
      }]);

      return ao;
    }(ki);

    function co() {
      if (lo(this)) return null;
      var t = this.parent;

      for (; t && t.is("attributeElement");) {
        if (lo(t) > 1) return null;
        t = t.parent;
      }

      return !t || lo(t) > 1 ? null : this.childCount;
    }

    function lo(t) {
      return Array.from(t.getChildren()).filter(function (t) {
        return !t.is("uiElement");
      }).length;
    }

    ao.DEFAULT_PRIORITY = so;

    var ho = /*#__PURE__*/function (_ki3) {
      _inherits(ho, _ki3);

      var _super8 = _createSuper(ho);

      function ho(t, e, n) {
        var _this21;

        _classCallCheck(this, ho);

        _this21 = _super8.call(this, t, e, n), _this21.getFillerOffset = uo;
        return _this21;
      }

      _createClass(ho, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "emptyElement" == n && e == this.name || _get(_getPrototypeOf(ho.prototype), "is", this).call(this, t, e) : "emptyElement" == n || _get(_getPrototypeOf(ho.prototype), "is", this).call(this, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof ui || Array.from(e).length > 0)) throw new Gn.b("view-emptyelement-cannot-add: Cannot add child nodes to EmptyElement instance.", [this, e]);
        }
      }]);

      return ho;
    }(ki);

    function uo() {
      return null;
    }

    var fo = navigator.userAgent.toLowerCase();
    var mo = {
      isMac: function (t) {
        return t.indexOf("macintosh") > -1;
      }(fo),
      isEdge: function (t) {
        return !!t.match(/edge\/(\d+.?\d*)/);
      }(fo),
      isGecko: function (t) {
        return !!t.match(/gecko\/\d+/);
      }(fo),
      isSafari: function (t) {
        return t.indexOf(" applewebkit/") > -1 && -1 === t.indexOf("chrome");
      }(fo),
      isAndroid: function (t) {
        return t.indexOf("android") > -1;
      }(fo),
      features: {
        isRegExpUnicodePropertySupported: function () {
          var t = !1;

          try {
            t = 0 === "ć".search(new RegExp("[\\p{L}]", "u"));
          } catch (t) {}

          return t;
        }()
      }
    };

    var go = {
      "⌘": "ctrl",
      "⇧": "shift",
      "⌥": "alt"
    },
        po = {
      ctrl: "⌘",
      shift: "⇧",
      alt: "⌥"
    },
        bo = function () {
      var t = {
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        backspace: 8,
        delete: 46,
        enter: 13,
        space: 32,
        esc: 27,
        tab: 9,
        ctrl: 1114112,
        cmd: 1114112,
        shift: 2228224,
        alt: 4456448
      };

      for (var _e33 = 65; _e33 <= 90; _e33++) {
        var _n25 = String.fromCharCode(_e33);

        t[_n25.toLowerCase()] = _e33;
      }

      for (var _e34 = 48; _e34 <= 57; _e34++) {
        t[_e34 - 48] = _e34;
      }

      for (var _e35 = 112; _e35 <= 123; _e35++) {
        t["f" + (_e35 - 111)] = _e35;
      }

      return t;
    }();

    function wo(t) {
      var e;

      if ("string" == typeof t) {
        if (!(e = bo[t.toLowerCase()])) throw new Gn.b("keyboard-unknown-key: Unknown key name.", null, {
          key: t
        });
      } else e = t.keyCode + (t.altKey ? bo.alt : 0) + (t.ctrlKey ? bo.ctrl : 0) + (t.shiftKey ? bo.shift : 0);

      return e;
    }

    function ko(t) {
      return "string" == typeof t && (t = _o(t)), t.map(function (t) {
        return "string" == typeof t ? wo(t) : t;
      }).reduce(function (t, e) {
        return e + t;
      }, 0);
    }

    function _o(t) {
      return t.split(/\s*\+\s*/);
    }

    var vo = /*#__PURE__*/function (_ki4) {
      _inherits(vo, _ki4);

      var _super9 = _createSuper(vo);

      function vo(t, e, n) {
        var _this22;

        _classCallCheck(this, vo);

        _this22 = _super9.call(this, t, e, n), _this22.getFillerOffset = xo;
        return _this22;
      }

      _createClass(vo, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^view:/, "");
          return e ? "uiElement" == n && e == this.name || _get(_getPrototypeOf(vo.prototype), "is", this).call(this, t, e) : "uiElement" == n || _get(_getPrototypeOf(vo.prototype), "is", this).call(this, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof ui || Array.from(e).length > 0)) throw new Gn.b("view-uielement-cannot-add: Cannot add child nodes to UIElement instance.", this);
        }
      }, {
        key: "render",
        value: function render(t) {
          return this.toDomElement(t);
        }
      }, {
        key: "toDomElement",
        value: function toDomElement(t) {
          var e = t.createElement(this.name);

          var _iterator35 = _createForOfIteratorHelper(this.getAttributeKeys()),
              _step35;

          try {
            for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
              var _t27 = _step35.value;
              e.setAttribute(_t27, this.getAttribute(_t27));
            }
          } catch (err) {
            _iterator35.e(err);
          } finally {
            _iterator35.f();
          }

          return e;
        }
      }]);

      return vo;
    }(ki);

    function yo(t) {
      t.document.on("keydown", function (e, n) {
        return function (t, e, n) {
          if (e.keyCode == bo.arrowright) {
            var _t28 = e.domTarget.ownerDocument.defaultView.getSelection(),
                _i19 = 1 == _t28.rangeCount && _t28.getRangeAt(0).collapsed;

            if (_i19 || e.shiftKey) {
              var _e36 = _t28.focusNode,
                  _o12 = _t28.focusOffset,
                  _r3 = n.domPositionToView(_e36, _o12);

              if (null === _r3) return;

              var _s3 = !1;

              var _a3 = _r3.getLastMatchingPosition(function (t) {
                return t.item.is("uiElement") && (_s3 = !0), !(!t.item.is("uiElement") && !t.item.is("attributeElement"));
              });

              if (_s3) {
                var _e37 = n.viewPositionToDom(_a3);

                _i19 ? _t28.collapse(_e37.parent, _e37.offset) : _t28.extend(_e37.parent, _e37.offset);
              }
            }
          }
        }(0, n, t.domConverter);
      });
    }

    function xo() {
      return null;
    }

    var Ao = /*#__PURE__*/function (_Symbol$iterator4) {
      function Ao(t) {
        _classCallCheck(this, Ao);

        this._children = [], t && this._insertChild(0, t);
      }

      _createClass(Ao, [{
        key: _Symbol$iterator4,
        value: function value() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" == t || "view:documentFragment" == t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);

          var n = 0;

          var i = function (t) {
            if ("string" == typeof t) return [new fi(t)];
            pi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new fi(t) : t instanceof mi ? new fi(t.data) : t;
            });
          }(e);

          var _iterator36 = _createForOfIteratorHelper(i),
              _step36;

          try {
            for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
              var _e38 = _step36.value;
              null !== _e38.parent && _e38._remove(), _e38.parent = this, this._children.splice(t, 0, _e38), t++, n++;
            }
          } catch (err) {
            _iterator36.e(err);
          } finally {
            _iterator36.f();
          }

          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          this._fireChange("children", this);

          for (var _n26 = t; _n26 < t + e; _n26++) {
            this._children[_n26].parent = null;
          }

          return this._children.splice(t, e);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e);
        }
      }]);

      return Ao;
    }(Symbol.iterator);

    ci(Ao, ei);

    var To = /*#__PURE__*/function () {
      function To(t) {
        _classCallCheck(this, To);

        this.document = t, this._cloneGroups = new Map();
      }

      _createClass(To, [{
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this.document.selection._setFocus(t, e);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new fi(t);
        }
      }, {
        key: "createAttributeElement",
        value: function createAttributeElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = new ao(t, e);
          return n.priority && (i._priority = n.priority), n.id && (i._id = n.id), i;
        }
      }, {
        key: "createContainerElement",
        value: function createContainerElement(t, e) {
          return new yi(t, e);
        }
      }, {
        key: "createEditableElement",
        value: function createEditableElement(t, e) {
          var n = new Gi(t, e);
          return n._document = this.document, n;
        }
      }, {
        key: "createEmptyElement",
        value: function createEmptyElement(t, e) {
          return new ho(t, e);
        }
      }, {
        key: "createUIElement",
        value: function createUIElement(t, e, n) {
          var i = new vo(t, e);
          return n && (i.render = n), i;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          T(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "breakAttributes",
        value: function breakAttributes(t) {
          return t instanceof Zi ? this._breakAttributes(t) : this._breakAttributesRange(t);
        }
      }, {
        key: "breakContainer",
        value: function breakContainer(t) {
          var e = t.parent;
          if (!e.is("containerElement")) throw new Gn.b("view-writer-break-non-container-element: Trying to break an element which is not a container element.", this.document);
          if (!e.parent) throw new Gn.b("view-writer-break-root: Trying to break root element.", this.document);
          if (t.isAtStart) return Zi._createBefore(e);

          if (!t.isAtEnd) {
            var _n27 = e._clone(!1);

            this.insert(Zi._createAfter(e), _n27);

            var _i20 = new Xi(t, Zi._createAt(e, "end")),
                _o13 = new Zi(_n27, 0);

            this.move(_i20, _o13);
          }

          return Zi._createAfter(e);
        }
      }, {
        key: "mergeAttributes",
        value: function mergeAttributes(t) {
          var e = t.offset,
              n = t.parent;
          if (n.is("text")) return t;

          if (n.is("attributeElement") && 0 === n.childCount) {
            var _t29 = n.parent,
                _e39 = n.index;
            return n._remove(), this._removeFromClonedElementsGroup(n), this.mergeAttributes(new Zi(_t29, _e39));
          }

          var i = n.getChild(e - 1),
              o = n.getChild(e);
          if (!i || !o) return t;
          if (i.is("text") && o.is("text")) return Eo(i, o);

          if (i.is("attributeElement") && o.is("attributeElement") && i.isSimilar(o)) {
            var _t30 = i.childCount;
            return i._appendChild(o.getChildren()), o._remove(), this._removeFromClonedElementsGroup(o), this.mergeAttributes(new Zi(i, _t30));
          }

          return t;
        }
      }, {
        key: "mergeContainers",
        value: function mergeContainers(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          if (!(e && n && e.is("containerElement") && n.is("containerElement"))) throw new Gn.b("view-writer-merge-containers-invalid-position: Element before and after given position cannot be merged.", this.document);
          var i = e.getChild(e.childCount - 1),
              o = i instanceof fi ? Zi._createAt(i, "end") : Zi._createAt(e, "end");
          return this.move(Xi._createIn(n), Zi._createAt(e, "end")), this.remove(Xi._createOn(n)), o;
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          (function t(e, n) {
            var _iterator37 = _createForOfIteratorHelper(e),
                _step37;

            try {
              var _loop = function _loop() {
                var i = _step37.value;
                if (!Io.some(function (t) {
                  return i instanceof t;
                })) throw new Gn.b("view-writer-insert-invalid-node", n);
                i.is("text") || t(i.getChildren(), n);
              };

              for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
                _loop();
              }
            } catch (err) {
              _iterator37.e(err);
            } finally {
              _iterator37.f();
            }
          })(e = pi(e) ? _toConsumableArray(e) : [e], this.document);

          var n = Co(t);
          if (!n) throw new Gn.b("view-writer-invalid-position-container", this.document);

          var i = this._breakAttributes(t, !0),
              o = n._insertChild(i.offset, e);

          var _iterator38 = _createForOfIteratorHelper(e),
              _step38;

          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _t32 = _step38.value;

              this._addToClonedElementsGroup(_t32);
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }

          var r = i.getShiftedBy(o),
              s = this.mergeAttributes(i);
          if (0 === o) return new Xi(s, s);
          {
            s.isEqual(i) || r.offset--;

            var _t31 = this.mergeAttributes(r);

            return new Xi(s, _t31);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t instanceof Xi ? t : Xi._createOn(t);
          if (Oo(e, this.document), e.isCollapsed) return new Ao();

          var _this$_breakAttribute = this._breakAttributesRange(e, !0),
              n = _this$_breakAttribute.start,
              i = _this$_breakAttribute.end,
              o = n.parent,
              r = i.offset - n.offset,
              s = o._removeChildren(n.offset, r);

          var _iterator39 = _createForOfIteratorHelper(s),
              _step39;

          try {
            for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
              var _t33 = _step39.value;

              this._removeFromClonedElementsGroup(_t33);
            }
          } catch (err) {
            _iterator39.e(err);
          } finally {
            _iterator39.f();
          }

          var a = this.mergeAttributes(n);
          return e.start = a, e.end = a.clone(), new Ao(s);
        }
      }, {
        key: "clear",
        value: function clear(t, e) {
          Oo(t, this.document);
          var n = t.getWalker({
            direction: "backward",
            ignoreElementEnd: !0
          });

          var _iterator40 = _createForOfIteratorHelper(n),
              _step40;

          try {
            for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
              var _i21 = _step40.value;
              var _n28 = _i21.item;

              var _o14 = void 0;

              if (_n28.is("element") && e.isSimilar(_n28)) _o14 = Xi._createOn(_n28);else if (!_i21.nextPosition.isAfter(t.start) && _n28.is("textProxy")) {
                var _t34 = _n28.getAncestors().find(function (t) {
                  return t.is("element") && e.isSimilar(t);
                });

                _t34 && (_o14 = Xi._createIn(_t34));
              }
              _o14 && (_o14.end.isAfter(t.end) && (_o14.end = t.end), _o14.start.isBefore(t.start) && (_o14.start = t.start), this.remove(_o14));
            }
          } catch (err) {
            _iterator40.e(err);
          } finally {
            _iterator40.f();
          }
        }
      }, {
        key: "move",
        value: function move(t, e) {
          var n;

          if (e.isAfter(t.end)) {
            var _i22 = (e = this._breakAttributes(e, !0)).parent,
                _o15 = _i22.childCount;

            t = this._breakAttributesRange(t, !0), n = this.remove(t), e.offset += _i22.childCount - _o15;
          } else n = this.remove(t);

          return this.insert(e, n);
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (!(e instanceof ao)) throw new Gn.b("view-writer-wrap-invalid-attribute", this.document);

          if (Oo(t, this.document), t.isCollapsed) {
            var _n29 = t.start;
            _n29.parent.is("element") && !function (t) {
              return Array.from(t.getChildren()).some(function (t) {
                return !t.is("uiElement");
              });
            }(_n29.parent) && (_n29 = _n29.getLastMatchingPosition(function (t) {
              return t.item.is("uiElement");
            })), _n29 = this._wrapPosition(_n29, e);
            var _i23 = this.document.selection;
            return _i23.isCollapsed && _i23.getFirstPosition().isEqual(t.start) && this.setSelection(_n29), new Xi(_n29);
          }

          return this._wrapRange(t, e);
        }
      }, {
        key: "unwrap",
        value: function unwrap(t, e) {
          if (!(e instanceof ao)) throw new Gn.b("view-writer-unwrap-invalid-attribute", this.document);
          if (Oo(t, this.document), t.isCollapsed) return t;

          var _this$_breakAttribute2 = this._breakAttributesRange(t, !0),
              n = _this$_breakAttribute2.start,
              i = _this$_breakAttribute2.end,
              o = n.parent,
              r = this._unwrapChildren(o, n.offset, i.offset, e),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new Xi(s, a);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new yi(t, e.getAttributes());
          return this.insert(Zi._createAfter(e), n), this.move(Xi._createIn(e), Zi._createAt(n, 0)), this.remove(Xi._createOn(e)), n;
        }
      }, {
        key: "clearClonedElementsGroup",
        value: function clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Xi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Xi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Xi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new no(t, e, n);
        }
      }, {
        key: "_wrapChildren",
        value: function _wrapChildren(t, e, n, i) {
          var o = e;
          var r = [];

          for (; o < n;) {
            var _e40 = t.getChild(o),
                _n30 = _e40.is("text"),
                _s4 = _e40.is("attributeElement"),
                _a4 = _e40.is("emptyElement"),
                _c2 = _e40.is("uiElement");

            if (_s4 && this._wrapAttributeElement(i, _e40)) r.push(new Zi(t, o));else if (_n30 || _a4 || _c2 || _s4 && Po(i, _e40)) {
              var _n31 = i._clone();

              _e40._remove(), _n31._appendChild(_e40), t._insertChild(o, _n31), this._addToClonedElementsGroup(_n31), r.push(new Zi(t, o));
            } else _s4 && this._wrapChildren(_e40, 0, _e40.childCount, i);
            o++;
          }

          var s = 0;

          for (var _i24 = 0, _r4 = r; _i24 < _r4.length; _i24++) {
            var _t35 = _r4[_i24];
            if (_t35.offset -= s, _t35.offset == e) continue;
            this.mergeAttributes(_t35).isEqual(_t35) || (s++, n--);
          }

          return Xi._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_unwrapChildren",
        value: function _unwrapChildren(t, e, n, i) {
          var o = e;
          var r = [];

          for (; o < n;) {
            var _e41 = t.getChild(o);

            if (_e41.is("attributeElement")) {
              if (_e41.isSimilar(i)) {
                var _i25 = _e41.getChildren(),
                    _s5 = _e41.childCount;

                _e41._remove(), t._insertChild(o, _i25), this._removeFromClonedElementsGroup(_e41), r.push(new Zi(t, o), new Zi(t, o + _s5)), o += _s5, n += _s5 - 1;
              } else this._unwrapAttributeElement(i, _e41) ? (r.push(new Zi(t, o), new Zi(t, o + 1)), o++) : (this._unwrapChildren(_e41, 0, _e41.childCount, i), o++);
            } else o++;
          }

          var s = 0;

          for (var _i26 = 0, _r5 = r; _i26 < _r5.length; _i26++) {
            var _t36 = _r5[_i26];
            if (_t36.offset -= s, _t36.offset == e || _t36.offset == n) continue;
            this.mergeAttributes(_t36).isEqual(_t36) || (s++, n--);
          }

          return Xi._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_wrapRange",
        value: function _wrapRange(t, e) {
          var _this$_breakAttribute3 = this._breakAttributesRange(t, !0),
              n = _this$_breakAttribute3.start,
              i = _this$_breakAttribute3.end,
              o = n.parent,
              r = this._wrapChildren(o, n.offset, i.offset, e),
              s = this.mergeAttributes(r.start);

          s.isEqual(r.start) || r.end.offset--;
          var a = this.mergeAttributes(r.end);
          return new Xi(s, a);
        }
      }, {
        key: "_wrapPosition",
        value: function _wrapPosition(t, e) {
          if (e.isSimilar(t.parent)) return So(t.clone());
          t.parent.is("text") && (t = Mo(t));
          var n = this.createAttributeElement();
          n._priority = Number.POSITIVE_INFINITY, n.isSimilar = function () {
            return !1;
          }, t.parent._insertChild(t.offset, n);
          var i = new Xi(t, t.getShiftedBy(1));
          this.wrap(i, e);
          var o = new Zi(n.parent, n.index);

          n._remove();

          var r = o.nodeBefore,
              s = o.nodeAfter;
          return r instanceof fi && s instanceof fi ? Eo(r, s) : So(o);
        }
      }, {
        key: "_wrapAttributeElement",
        value: function _wrapAttributeElement(t, e) {
          if (!Ro(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;

          var _iterator41 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step41;

          try {
            for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
              var _n32 = _step41.value;
              if ("class" !== _n32 && "style" !== _n32 && e.hasAttribute(_n32) && e.getAttribute(_n32) !== t.getAttribute(_n32)) return !1;
            }
          } catch (err) {
            _iterator41.e(err);
          } finally {
            _iterator41.f();
          }

          var _iterator42 = _createForOfIteratorHelper(t.getStyleNames()),
              _step42;

          try {
            for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
              var _n33 = _step42.value;
              if (e.hasStyle(_n33) && e.getStyle(_n33) !== t.getStyle(_n33)) return !1;
            }
          } catch (err) {
            _iterator42.e(err);
          } finally {
            _iterator42.f();
          }

          var _iterator43 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step43;

          try {
            for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
              var _n34 = _step43.value;
              "class" !== _n34 && "style" !== _n34 && (e.hasAttribute(_n34) || this.setAttribute(_n34, t.getAttribute(_n34), e));
            }
          } catch (err) {
            _iterator43.e(err);
          } finally {
            _iterator43.f();
          }

          var _iterator44 = _createForOfIteratorHelper(t.getStyleNames()),
              _step44;

          try {
            for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
              var _n35 = _step44.value;
              e.hasStyle(_n35) || this.setStyle(_n35, t.getStyle(_n35), e);
            }
          } catch (err) {
            _iterator44.e(err);
          } finally {
            _iterator44.f();
          }

          var _iterator45 = _createForOfIteratorHelper(t.getClassNames()),
              _step45;

          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var _n36 = _step45.value;
              e.hasClass(_n36) || this.addClass(_n36, e);
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }

          return !0;
        }
      }, {
        key: "_unwrapAttributeElement",
        value: function _unwrapAttributeElement(t, e) {
          if (!Ro(t, e)) return !1;
          if (t.name !== e.name || t.priority !== e.priority) return !1;

          var _iterator46 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step46;

          try {
            for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
              var _n37 = _step46.value;
              if ("class" !== _n37 && "style" !== _n37 && (!e.hasAttribute(_n37) || e.getAttribute(_n37) !== t.getAttribute(_n37))) return !1;
            }
          } catch (err) {
            _iterator46.e(err);
          } finally {
            _iterator46.f();
          }

          if (!e.hasClass.apply(e, _toConsumableArray(t.getClassNames()))) return !1;

          var _iterator47 = _createForOfIteratorHelper(t.getStyleNames()),
              _step47;

          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var _n38 = _step47.value;
              if (!e.hasStyle(_n38) || e.getStyle(_n38) !== t.getStyle(_n38)) return !1;
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }

          var _iterator48 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step48;

          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _n39 = _step48.value;
              "class" !== _n39 && "style" !== _n39 && this.removeAttribute(_n39, e);
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }

          return this.removeClass(Array.from(t.getClassNames()), e), this.removeStyle(Array.from(t.getStyleNames()), e), !0;
        }
      }, {
        key: "_breakAttributesRange",
        value: function _breakAttributesRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.start,
              i = t.end;

          if (Oo(t, this.document), t.isCollapsed) {
            var _n40 = this._breakAttributes(t.start, e);

            return new Xi(_n40, _n40);
          }

          var o = this._breakAttributes(i, e),
              r = o.parent.childCount,
              s = this._breakAttributes(n, e);

          return o.offset += o.parent.childCount - r, new Xi(s, o);
        }
      }, {
        key: "_breakAttributes",
        value: function _breakAttributes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.offset,
              i = t.parent;
          if (t.parent.is("emptyElement")) throw new Gn.b("view-writer-cannot-break-empty-element", this.document);
          if (t.parent.is("uiElement")) throw new Gn.b("view-writer-cannot-break-ui-element", this.document);
          if (!e && i.is("text") && No(i.parent)) return t.clone();
          if (No(i)) return t.clone();
          if (i.is("text")) return this._breakAttributes(Mo(t), e);

          if (n == i.childCount) {
            var _t37 = new Zi(i.parent, i.index + 1);

            return this._breakAttributes(_t37, e);
          }

          if (0 === n) {
            var _t38 = new Zi(i.parent, i.index);

            return this._breakAttributes(_t38, e);
          }

          {
            var _t39 = i.index + 1,
                _o16 = i._clone();

            i.parent._insertChild(_t39, _o16), this._addToClonedElementsGroup(_o16);

            var _r6 = i.childCount - n,
                _s6 = i._removeChildren(n, _r6);

            _o16._appendChild(_s6);

            var _a5 = new Zi(i.parent, _t39);

            return this._breakAttributes(_a5, e);
          }
        }
      }, {
        key: "_addToClonedElementsGroup",
        value: function _addToClonedElementsGroup(t) {
          if (!t.root.is("rootElement")) return;

          if (t.is("element")) {
            var _iterator49 = _createForOfIteratorHelper(t.getChildren()),
                _step49;

            try {
              for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
                var _e42 = _step49.value;

                this._addToClonedElementsGroup(_e42);
              }
            } catch (err) {
              _iterator49.e(err);
            } finally {
              _iterator49.f();
            }
          }

          var e = t.id;
          if (!e) return;

          var n = this._cloneGroups.get(e);

          n || (n = new Set(), this._cloneGroups.set(e, n)), n.add(t), t._clonesGroup = n;
        }
      }, {
        key: "_removeFromClonedElementsGroup",
        value: function _removeFromClonedElementsGroup(t) {
          if (t.is("element")) {
            var _iterator50 = _createForOfIteratorHelper(t.getChildren()),
                _step50;

            try {
              for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                var _e43 = _step50.value;

                this._removeFromClonedElementsGroup(_e43);
              }
            } catch (err) {
              _iterator50.e(err);
            } finally {
              _iterator50.f();
            }
          }

          var e = t.id;
          if (!e) return;

          var n = this._cloneGroups.get(e);

          n && n.delete(t);
        }
      }]);

      return To;
    }();

    function Co(t) {
      var e = t.parent;

      for (; !No(e);) {
        if (!e) return;
        e = e.parent;
      }

      return e;
    }

    function Po(t, e) {
      return t.priority < e.priority || !(t.priority > e.priority) && t.getIdentity() < e.getIdentity();
    }

    function So(t) {
      var e = t.nodeBefore;
      if (e && e.is("text")) return new Zi(e, e.data.length);
      var n = t.nodeAfter;
      return n && n.is("text") ? new Zi(n, 0) : t;
    }

    function Mo(t) {
      if (t.offset == t.parent.data.length) return new Zi(t.parent.parent, t.parent.index + 1);
      if (0 === t.offset) return new Zi(t.parent.parent, t.parent.index);
      var e = t.parent.data.slice(t.offset);
      return t.parent._data = t.parent.data.slice(0, t.offset), t.parent.parent._insertChild(t.parent.index + 1, new fi(e)), new Zi(t.parent.parent, t.parent.index + 1);
    }

    function Eo(t, e) {
      var n = t.data.length;
      return t._data += e.data, e._remove(), new Zi(t, n);
    }

    var Io = [fi, ao, yi, ho, vo];

    function No(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }

    function Oo(t, e) {
      var n = Co(t.start),
          i = Co(t.end);
      if (!n || !i || n !== i) throw new Gn.b("view-writer-invalid-range-container", e);
    }

    function Ro(t, e) {
      return null === t.id && null === e.id;
    }

    function Do(t) {
      return "[object Text]" == Object.prototype.toString.call(t);
    }

    var Lo = function Lo(t) {
      var e = t.createElement("br");
      return e.dataset.ckeFiller = !0, e;
    },
        jo = function jo(t) {
      return t.createTextNode(" ");
    },
        Vo = 7;

    var zo = "";

    for (var _t40 = 0; _t40 < Vo; _t40++) {
      zo += "​";
    }

    function Bo(t) {
      return Do(t) && t.data.substr(0, Vo) === zo;
    }

    function Fo(t) {
      return t.data.length == Vo && Bo(t);
    }

    function Uo(t) {
      return Bo(t) ? t.data.slice(Vo) : t.data;
    }

    var Ho = new WeakMap();

    function qo(t, e) {
      var n = Ho.get(e);
      return n || (n = e(window.document), Ho.set(e, n)), t.isEqualNode(n);
    }

    function Wo(t, e) {
      if (e.keyCode == bo.arrowleft) {
        var _t41 = e.domTarget.ownerDocument.defaultView.getSelection();

        if (1 == _t41.rangeCount && _t41.getRangeAt(0).collapsed) {
          var _e44 = _t41.getRangeAt(0).startContainer,
              _n41 = _t41.getRangeAt(0).startOffset;

          Bo(_e44) && _n41 <= Vo && _t41.collapse(_e44, 0);
        }
      }
    }

    function Yo(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      n = n || function (t, e) {
        return t === e;
      }, Array.isArray(t) || (t = Array.from(t)), Array.isArray(e) || (e = Array.from(e));

      var o = function (t, e, n) {
        var i = $o(t, e, n);
        if (-1 === i) return {
          firstIndex: -1,
          lastIndexOld: -1,
          lastIndexNew: -1
        };
        var o = Go(t, i),
            r = Go(e, i),
            s = $o(o, r, n),
            a = t.length - s,
            c = e.length - s;
        return {
          firstIndex: i,
          lastIndexOld: a,
          lastIndexNew: c
        };
      }(t, e, n);

      return i ? function (t, e) {
        var n = t.firstIndex,
            i = t.lastIndexOld,
            o = t.lastIndexNew;
        if (-1 === n) return Array(e).fill("equal");
        var r = [];
        n > 0 && (r = r.concat(Array(n).fill("equal")));
        o - n > 0 && (r = r.concat(Array(o - n).fill("insert")));
        i - n > 0 && (r = r.concat(Array(i - n).fill("delete")));
        o < e && (r = r.concat(Array(e - o).fill("equal")));
        return r;
      }(o, e.length) : function (t, e) {
        var n = [],
            i = e.firstIndex,
            o = e.lastIndexOld,
            r = e.lastIndexNew;
        r - i > 0 && n.push({
          index: i,
          type: "insert",
          values: t.slice(i, r)
        });
        o - i > 0 && n.push({
          index: i + (r - i),
          type: "delete",
          howMany: o - i
        });
        return n;
      }(e, o);
    }

    function $o(t, e, n) {
      for (var _i27 = 0; _i27 < Math.max(t.length, e.length); _i27++) {
        if (void 0 === t[_i27] || void 0 === e[_i27] || !n(t[_i27], e[_i27])) return _i27;
      }

      return -1;
    }

    function Go(t, e) {
      return t.slice(e).reverse();
    }

    function Qo(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };

      var i = t.length,
          o = e.length;
      if (i > 200 || o > 200 || i + o > 300) return Qo.fastDiff(t, e, n, !0);
      var r, s;

      if (o < i) {
        var _n42 = t;
        t = e, e = _n42, r = "delete", s = "insert";
      } else r = "insert", s = "delete";

      var a = t.length,
          c = e.length,
          l = c - a,
          d = {},
          h = {};

      function u(i) {
        var o = (void 0 !== h[i - 1] ? h[i - 1] : -1) + 1,
            l = void 0 !== h[i + 1] ? h[i + 1] : -1,
            u = o > l ? -1 : 1;
        d[i + u] && (d[i] = d[i + u].slice(0)), d[i] || (d[i] = []), d[i].push(o > l ? r : s);
        var f = Math.max(o, l),
            m = f - i;

        for (; m < a && f < c && n(t[m], e[f]);) {
          m++, f++, d[i].push("equal");
        }

        return f;
      }

      var f,
          m = 0;

      do {
        for (f = -m; f < l; f++) {
          h[f] = u(f);
        }

        for (f = l + m; f > l; f--) {
          h[f] = u(f);
        }

        h[l] = u(l), m++;
      } while (h[l] !== c);

      return d[l].slice(1);
    }

    function Ko(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }

    function Jo(t) {
      var e = t.parentNode;
      e && e.removeChild(t);
    }

    function Zo(t) {
      if (t) {
        if (t.defaultView) return t instanceof t.defaultView.Document;
        if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
      }

      return !1;
    }

    Qo.fastDiff = Yo;

    var Xo = /*#__PURE__*/function () {
      function Xo(t, e) {
        _classCallCheck(this, Xo);

        this.domDocuments = new Set(), this.domConverter = t, this.markedAttributes = new Set(), this.markedChildren = new Set(), this.markedTexts = new Set(), this.selection = e, this.isFocused = !1, this._inlineFiller = null, this._fakeSelectionContainer = null;
      }

      _createClass(Xo, [{
        key: "markToSync",
        value: function markToSync(t, e) {
          if ("text" === t) this.domConverter.mapViewToDom(e.parent) && this.markedTexts.add(e);else {
            if (!this.domConverter.mapViewToDom(e)) return;
            if ("attributes" === t) this.markedAttributes.add(e);else {
              if ("children" !== t) throw new Gn.b("view-renderer-unknown-type: Unknown type passed to Renderer.markToSync.", this);
              this.markedChildren.add(e);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var t;

          var _iterator51 = _createForOfIteratorHelper(this.markedChildren),
              _step51;

          try {
            for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
              var _t42 = _step51.value;

              this._updateChildrenMappings(_t42);
            }
          } catch (err) {
            _iterator51.e(err);
          } finally {
            _iterator51.f();
          }

          this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t = this.selection.getFirstPosition(), this.markedChildren.add(t.parent));

          var _iterator52 = _createForOfIteratorHelper(this.markedAttributes),
              _step52;

          try {
            for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
              var _t43 = _step52.value;

              this._updateAttrs(_t43);
            }
          } catch (err) {
            _iterator52.e(err);
          } finally {
            _iterator52.f();
          }

          var _iterator53 = _createForOfIteratorHelper(this.markedChildren),
              _step53;

          try {
            for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
              var _e46 = _step53.value;

              this._updateChildren(_e46, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _iterator53.e(err);
          } finally {
            _iterator53.f();
          }

          var _iterator54 = _createForOfIteratorHelper(this.markedTexts),
              _step54;

          try {
            for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
              var _e47 = _step54.value;
              !this.markedChildren.has(_e47.parent) && this.domConverter.mapViewToDom(_e47.parent) && this._updateText(_e47, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _iterator54.e(err);
          } finally {
            _iterator54.f();
          }

          if (t) {
            var _e45 = this.domConverter.viewPositionToDom(t),
                _n43 = _e45.parent.ownerDocument;

            Bo(_e45.parent) ? this._inlineFiller = _e45.parent : this._inlineFiller = tr(_n43, _e45.parent, _e45.offset);
          } else this._inlineFiller = null;

          this._updateSelection(), this._updateFocus(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
        }
      }, {
        key: "_updateChildrenMappings",
        value: function _updateChildrenMappings(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;

          var n = this.domConverter.mapViewToDom(t).childNodes,
              i = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
            withChildren: !1
          })),
              o = this._diffNodeLists(n, i),
              r = this._findReplaceActions(o, n, i);

          if (-1 !== r.indexOf("replace")) {
            var _e48 = {
              equal: 0,
              insert: 0,
              delete: 0
            };

            var _iterator55 = _createForOfIteratorHelper(r),
                _step55;

            try {
              for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
                var _o17 = _step55.value;

                if ("replace" === _o17) {
                  var _o18 = _e48.equal + _e48.insert,
                      _r7 = _e48.equal + _e48.delete,
                      _s7 = t.getChild(_o18);

                  _s7 && !_s7.is("uiElement") && this._updateElementMappings(_s7, n[_r7]), Jo(i[_o18]), _e48.equal++;
                } else _e48[_o17]++;
              }
            } catch (err) {
              _iterator55.e(err);
            } finally {
              _iterator55.f();
            }
          }
        }
      }, {
        key: "_updateElementMappings",
        value: function _updateElementMappings(t, e) {
          this.domConverter.unbindDomElement(e), this.domConverter.bindElements(e, t), this.markedChildren.add(t), this.markedAttributes.add(t);
        }
      }, {
        key: "_getInlineFillerPosition",
        value: function _getInlineFillerPosition() {
          var t = this.selection.getFirstPosition();
          return t.parent.is("text") ? Zi._createBefore(this.selection.getFirstPosition().parent) : t;
        }
      }, {
        key: "_isSelectionInInlineFiller",
        value: function _isSelectionInInlineFiller() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
              e = this.domConverter.viewPositionToDom(t);
          return !!(e && Do(e.parent) && Bo(e.parent));
        }
      }, {
        key: "_removeInlineFiller",
        value: function _removeInlineFiller() {
          var t = this._inlineFiller;
          if (!Bo(t)) throw new Gn.b("view-renderer-filler-was-lost: The inline filler node was lost.", this);
          Fo(t) ? t.parentNode.removeChild(t) : t.data = t.data.substr(Vo), this._inlineFiller = null;
        }
      }, {
        key: "_needsInlineFillerAtSelection",
        value: function _needsInlineFillerAtSelection() {
          if (1 != this.selection.rangeCount || !this.selection.isCollapsed) return !1;
          var t = this.selection.getFirstPosition(),
              e = t.parent,
              n = t.offset;
          if (!this.domConverter.mapViewToDom(e.root)) return !1;
          if (!e.is("element")) return !1;
          if (!function (t) {
            if ("false" == t.getAttribute("contenteditable")) return !1;
            var e = t.findAncestor(function (t) {
              return t.hasAttribute("contenteditable");
            });
            return !e || "true" == e.getAttribute("contenteditable");
          }(e)) return !1;
          if (n === e.getFillerOffset()) return !1;
          var i = t.nodeBefore,
              o = t.nodeAfter;
          return !(i instanceof fi || o instanceof fi);
        }
      }, {
        key: "_updateText",
        value: function _updateText(t, e) {
          var n = this.domConverter.findCorrespondingDomText(t),
              i = this.domConverter.viewToDom(t, n.ownerDocument),
              o = n.data;
          var r = i.data;
          var s = e.inlineFillerPosition;

          if (s && s.parent == t.parent && s.offset == t.index && (r = zo + r), o != r) {
            var _t44 = Yo(o, r);

            var _iterator56 = _createForOfIteratorHelper(_t44),
                _step56;

            try {
              for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
                var _e49 = _step56.value;
                "insert" === _e49.type ? n.insertData(_e49.index, _e49.values.join("")) : n.deleteData(_e49.index, _e49.howMany);
              }
            } catch (err) {
              _iterator56.e(err);
            } finally {
              _iterator56.f();
            }
          }
        }
      }, {
        key: "_updateAttrs",
        value: function _updateAttrs(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) return;
          var n = Array.from(e.attributes).map(function (t) {
            return t.name;
          }),
              i = t.getAttributeKeys();

          var _iterator57 = _createForOfIteratorHelper(i),
              _step57;

          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var _n44 = _step57.value;
              e.setAttribute(_n44, t.getAttribute(_n44));
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }

          var _iterator58 = _createForOfIteratorHelper(n),
              _step58;

          try {
            for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
              var _i28 = _step58.value;
              t.hasAttribute(_i28) || e.removeAttribute(_i28);
            }
          } catch (err) {
            _iterator58.e(err);
          } finally {
            _iterator58.f();
          }
        }
      }, {
        key: "_updateChildren",
        value: function _updateChildren(t, e) {
          var n = this.domConverter.mapViewToDom(t);
          if (!n) return;
          var i = e.inlineFillerPosition,
              o = this.domConverter.mapViewToDom(t).childNodes,
              r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, {
            bind: !0,
            inlineFillerPosition: i
          }));
          i && i.parent === t && tr(n.ownerDocument, r, i.offset);

          var s = this._diffNodeLists(o, r);

          var a = 0;
          var c = new Set();

          var _iterator59 = _createForOfIteratorHelper(s),
              _step59;

          try {
            for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
              var _t45 = _step59.value;
              "insert" === _t45 ? (Ko(n, a, r[a]), a++) : "delete" === _t45 ? (c.add(o[a]), Jo(o[a])) : (this._markDescendantTextToSync(this.domConverter.domToView(r[a])), a++);
            }
          } catch (err) {
            _iterator59.e(err);
          } finally {
            _iterator59.f();
          }

          var _iterator60 = _createForOfIteratorHelper(c),
              _step60;

          try {
            for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
              var _t46 = _step60.value;
              _t46.parentNode || this.domConverter.unbindDomElement(_t46);
            }
          } catch (err) {
            _iterator60.e(err);
          } finally {
            _iterator60.f();
          }
        }
      }, {
        key: "_diffNodeLists",
        value: function _diffNodeLists(t, e) {
          return Qo(t = function (t, e) {
            var n = Array.from(t);
            if (0 == n.length || !e) return n;
            n[n.length - 1] == e && n.pop();
            return n;
          }(t, this._fakeSelectionContainer), e, function (t, e, n) {
            if (e === n) return !0;
            if (Do(e) && Do(n)) return e.data === n.data;
            if (qo(e, t) && qo(n, t)) return !0;
            return !1;
          }.bind(null, this.domConverter.blockFiller));
        }
      }, {
        key: "_findReplaceActions",
        value: function _findReplaceActions(t, e, n) {
          if (-1 === t.indexOf("insert") || -1 === t.indexOf("delete")) return t;
          var i = [],
              o = [],
              r = [];
          var s = {
            equal: 0,
            insert: 0,
            delete: 0
          };

          var _iterator61 = _createForOfIteratorHelper(t),
              _step61;

          try {
            for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
              var _a6 = _step61.value;
              "insert" === _a6 ? r.push(n[s.equal + s.insert]) : "delete" === _a6 ? o.push(e[s.equal + s.delete]) : ((i = i.concat(Qo(o, r, er).map(function (t) {
                return "equal" === t ? "replace" : t;
              }))).push("equal"), o = [], r = []), s[_a6]++;
            }
          } catch (err) {
            _iterator61.e(err);
          } finally {
            _iterator61.f();
          }

          return i.concat(Qo(o, r, er).map(function (t) {
            return "equal" === t ? "replace" : t;
          }));
        }
      }, {
        key: "_markDescendantTextToSync",
        value: function _markDescendantTextToSync(t) {
          if (t) if (t.is("text")) this.markedTexts.add(t);else if (t.is("element")) {
            var _iterator62 = _createForOfIteratorHelper(t.getChildren()),
                _step62;

            try {
              for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
                var _e50 = _step62.value;

                this._markDescendantTextToSync(_e50);
              }
            } catch (err) {
              _iterator62.e(err);
            } finally {
              _iterator62.f();
            }
          }
        }
      }, {
        key: "_updateSelection",
        value: function _updateSelection() {
          if (0 === this.selection.rangeCount) return this._removeDomSelection(), void this._removeFakeSelection();
          var t = this.domConverter.mapViewToDom(this.selection.editableElement);
          this.isFocused && t && (this.selection.isFake ? this._updateFakeSelection(t) : (this._removeFakeSelection(), this._updateDomSelection(t)));
        }
      }, {
        key: "_updateFakeSelection",
        value: function _updateFakeSelection(t) {
          var e = t.ownerDocument;
          var n = this._fakeSelectionContainer;
          n || (this._fakeSelectionContainer = n = e.createElement("div"), Object.assign(n.style, {
            position: "fixed",
            top: 0,
            left: "-9999px",
            width: "42px"
          }), n.textContent = " "), n.parentElement && n.parentElement == t || t.appendChild(n), n.textContent = this.selection.fakeSelectionLabel || " ";
          var i = e.getSelection(),
              o = e.createRange();
          i.removeAllRanges(), o.selectNodeContents(n), i.addRange(o), this.domConverter.bindFakeSelection(n, this.selection);
        }
      }, {
        key: "_updateDomSelection",
        value: function _updateDomSelection(t) {
          var e = t.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(e)) return;
          var n = this.domConverter.viewPositionToDom(this.selection.anchor),
              i = this.domConverter.viewPositionToDom(this.selection.focus);
          t.focus(), e.collapse(n.parent, n.offset), e.extend(i.parent, i.offset), mo.isGecko && function (t, e) {
            var n = t.parent;
            if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) return;
            var i = n.childNodes[t.offset];
            i && "BR" == i.tagName && e.addRange(e.getRangeAt(0));
          }(i, e);
        }
      }, {
        key: "_domSelectionNeedsUpdate",
        value: function _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t)) return !0;
          var e = t && this.domConverter.domSelectionToView(t);
          return (!e || !this.selection.isEqual(e)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e));
        }
      }, {
        key: "_removeDomSelection",
        value: function _removeDomSelection() {
          var _iterator63 = _createForOfIteratorHelper(this.domDocuments),
              _step63;

          try {
            for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
              var _t47 = _step63.value;

              if (_t47.getSelection().rangeCount) {
                var _e51 = _t47.activeElement,
                    _n45 = this.domConverter.mapDomToView(_e51);

                _e51 && _n45 && _t47.getSelection().removeAllRanges();
              }
            }
          } catch (err) {
            _iterator63.e(err);
          } finally {
            _iterator63.f();
          }
        }
      }, {
        key: "_removeFakeSelection",
        value: function _removeFakeSelection() {
          var t = this._fakeSelectionContainer;
          t && t.remove();
        }
      }, {
        key: "_updateFocus",
        value: function _updateFocus() {
          if (this.isFocused) {
            var _t48 = this.selection.editableElement;
            _t48 && this.domConverter.focus(_t48);
          }
        }
      }]);

      return Xo;
    }();

    function tr(t, e, n) {
      var i = e instanceof Array ? e : e.childNodes,
          o = i[n];
      if (Do(o)) return o.data = zo + o.data, o;
      {
        var _o19 = t.createTextNode(zo);

        return Array.isArray(e) ? i.splice(n, 0, _o19) : Ko(e, n, _o19), _o19;
      }
    }

    function er(t, e) {
      return Zo(t) && Zo(e) && !Do(t) && !Do(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }

    ci(Xo, Fi);
    var nr = {
      window: window,
      document: document
    };

    function ir(t) {
      var e = 0;

      for (; t.previousSibling;) {
        t = t.previousSibling, e++;
      }

      return e;
    }

    function or(t) {
      var e = [];

      for (; t && t.nodeType != Node.DOCUMENT_NODE;) {
        e.unshift(t), t = t.parentNode;
      }

      return e;
    }

    var rr = /*#__PURE__*/function () {
      function rr() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, rr);

        this.blockFiller = t.blockFiller || Lo, this.preElements = ["pre"], this.blockElements = ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"], this._domToViewMapping = new WeakMap(), this._viewToDomMapping = new WeakMap(), this._fakeSelectionMapping = new WeakMap();
      }

      _createClass(rr, [{
        key: "bindFakeSelection",
        value: function bindFakeSelection(t, e) {
          this._fakeSelectionMapping.set(t, new no(e));
        }
      }, {
        key: "fakeSelectionToView",
        value: function fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t);
        }
      }, {
        key: "bindElements",
        value: function bindElements(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "unbindDomElement",
        value: function unbindDomElement(t) {
          var e = this._domToViewMapping.get(t);

          if (e) {
            this._domToViewMapping.delete(t), this._viewToDomMapping.delete(e);

            for (var _i29 = 0, _Array$from = Array.from(t.childNodes); _i29 < _Array$from.length; _i29++) {
              var _e52 = _Array$from[_i29];
              this.unbindDomElement(_e52);
            }
          }
        }
      }, {
        key: "bindDocumentFragments",
        value: function bindDocumentFragments(t, e) {
          this._domToViewMapping.set(t, e), this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "viewToDom",
        value: function viewToDom(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if (t.is("text")) {
            var _n46 = this._processDataFromViewText(t);

            return e.createTextNode(_n46);
          }

          {
            if (this.mapViewToDom(t)) return this.mapViewToDom(t);

            var _i30;

            if (t.is("documentFragment")) _i30 = e.createDocumentFragment(), n.bind && this.bindDocumentFragments(_i30, t);else {
              if (t.is("uiElement")) return _i30 = t.render(e), n.bind && this.bindElements(_i30, t), _i30;
              _i30 = e.createElement(t.name), n.bind && this.bindElements(_i30, t);

              var _iterator64 = _createForOfIteratorHelper(t.getAttributeKeys()),
                  _step64;

              try {
                for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
                  var _e53 = _step64.value;

                  _i30.setAttribute(_e53, t.getAttribute(_e53));
                }
              } catch (err) {
                _iterator64.e(err);
              } finally {
                _iterator64.f();
              }
            }

            if (n.withChildren || void 0 === n.withChildren) {
              var _iterator65 = _createForOfIteratorHelper(this.viewChildrenToDom(t, e, n)),
                  _step65;

              try {
                for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
                  var _o20 = _step65.value;

                  _i30.appendChild(_o20);
                }
              } catch (err) {
                _iterator65.e(err);
              } finally {
                _iterator65.f();
              }
            }

            return _i30;
          }
        }
      }, {
        key: "viewChildrenToDom",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function viewChildrenToDom(t, e) {
          var n,
              i,
              o,
              _iterator66,
              _step66,
              _r8,
              _args9 = arguments;

          return _regeneratorRuntime.wrap(function viewChildrenToDom$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  n = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
                  i = t.getFillerOffset && t.getFillerOffset();
                  o = 0;
                  _iterator66 = _createForOfIteratorHelper(t.getChildren());
                  _context9.prev = 4;

                  _iterator66.s();

                case 6:
                  if ((_step66 = _iterator66.n()).done) {
                    _context9.next = 17;
                    break;
                  }

                  _r8 = _step66.value;
                  _context9.t0 = i === o;

                  if (!_context9.t0) {
                    _context9.next = 12;
                    break;
                  }

                  _context9.next = 12;
                  return this.blockFiller(e);

                case 12:
                  _context9.next = 14;
                  return this.viewToDom(_r8, e, n);

                case 14:
                  o++;

                case 15:
                  _context9.next = 6;
                  break;

                case 17:
                  _context9.next = 22;
                  break;

                case 19:
                  _context9.prev = 19;
                  _context9.t1 = _context9["catch"](4);

                  _iterator66.e(_context9.t1);

                case 22:
                  _context9.prev = 22;

                  _iterator66.f();

                  return _context9.finish(22);

                case 25:
                  _context9.t2 = i === o;

                  if (!_context9.t2) {
                    _context9.next = 29;
                    break;
                  }

                  _context9.next = 29;
                  return this.blockFiller(e);

                case 29:
                case "end":
                  return _context9.stop();
              }
            }
          }, viewChildrenToDom, this, [[4, 19, 22, 25]]);
        })
      }, {
        key: "viewRangeToDom",
        value: function viewRangeToDom(t) {
          var e = this.viewPositionToDom(t.start),
              n = this.viewPositionToDom(t.end),
              i = document.createRange();
          return i.setStart(e.parent, e.offset), i.setEnd(n.parent, n.offset), i;
        }
      }, {
        key: "viewPositionToDom",
        value: function viewPositionToDom(t) {
          var e = t.parent;

          if (e.is("text")) {
            var _n47 = this.findCorrespondingDomText(e);

            if (!_n47) return null;
            var _i31 = t.offset;
            return Bo(_n47) && (_i31 += Vo), {
              parent: _n47,
              offset: _i31
            };
          }

          {
            var _n48, _i32, _o21;

            if (0 === t.offset) {
              if (!(_n48 = this.mapViewToDom(e))) return null;
              _o21 = _n48.childNodes[0];
            } else {
              var _e54 = t.nodeBefore;
              if (!(_i32 = _e54.is("text") ? this.findCorrespondingDomText(_e54) : this.mapViewToDom(t.nodeBefore))) return null;
              _n48 = _i32.parentNode, _o21 = _i32.nextSibling;
            }

            if (Do(_o21) && Bo(_o21)) return {
              parent: _o21,
              offset: Vo
            };
            return {
              parent: _n48,
              offset: _i32 ? ir(_i32) + 1 : 0
            };
          }
        }
      }, {
        key: "domToView",
        value: function domToView(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (qo(t, this.blockFiller)) return null;
          var n = this.getParentUIElement(t, this._domToViewMapping);
          if (n) return n;

          if (Do(t)) {
            if (Fo(t)) return null;
            {
              var _e55 = this._processDataFromDomText(t);

              return "" === _e55 ? null : new fi(_e55);
            }
          }

          if (this.isComment(t)) return null;
          {
            if (this.mapDomToView(t)) return this.mapDomToView(t);

            var _n49;

            if (this.isDocumentFragment(t)) _n49 = new Ao(), e.bind && this.bindDocumentFragments(t, _n49);else {
              var _i33 = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();

              _n49 = new ki(_i33), e.bind && this.bindElements(t, _n49);
              var _o22 = t.attributes;

              for (var _t49 = _o22.length - 1; _t49 >= 0; _t49--) {
                _n49._setAttribute(_o22[_t49].name, _o22[_t49].value);
              }
            }

            if (e.withChildren || void 0 === e.withChildren) {
              var _iterator67 = _createForOfIteratorHelper(this.domChildrenToView(t, e)),
                  _step67;

              try {
                for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                  var _i34 = _step67.value;

                  _n49._appendChild(_i34);
                }
              } catch (err) {
                _iterator67.e(err);
              } finally {
                _iterator67.f();
              }
            }

            return _n49;
          }
        }
      }, {
        key: "domChildrenToView",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function domChildrenToView(t) {
          var e,
              _n50,
              _i35,
              _o23,
              _args10 = arguments;

          return _regeneratorRuntime.wrap(function domChildrenToView$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  e = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
                  _n50 = 0;

                case 2:
                  if (!(_n50 < t.childNodes.length)) {
                    _context10.next = 11;
                    break;
                  }

                  _i35 = t.childNodes[_n50], _o23 = this.domToView(_i35, e);
                  _context10.t0 = null !== _o23;

                  if (!_context10.t0) {
                    _context10.next = 8;
                    break;
                  }

                  _context10.next = 8;
                  return _o23;

                case 8:
                  _n50++;
                  _context10.next = 2;
                  break;

                case 11:
                case "end":
                  return _context10.stop();
              }
            }
          }, domChildrenToView, this);
        })
      }, {
        key: "domSelectionToView",
        value: function domSelectionToView(t) {
          if (1 === t.rangeCount) {
            var _e56 = t.getRangeAt(0).startContainer;
            Do(_e56) && (_e56 = _e56.parentNode);

            var _n51 = this.fakeSelectionToView(_e56);

            if (_n51) return _n51;
          }

          var e = this.isDomSelectionBackward(t),
              n = [];

          for (var _e57 = 0; _e57 < t.rangeCount; _e57++) {
            var _i36 = t.getRangeAt(_e57),
                _o24 = this.domRangeToView(_i36);

            _o24 && n.push(_o24);
          }

          return new no(n, {
            backward: e
          });
        }
      }, {
        key: "domRangeToView",
        value: function domRangeToView(t) {
          var e = this.domPositionToView(t.startContainer, t.startOffset),
              n = this.domPositionToView(t.endContainer, t.endOffset);
          return e && n ? new Xi(e, n) : null;
        }
      }, {
        key: "domPositionToView",
        value: function domPositionToView(t, e) {
          if (qo(t, this.blockFiller)) return this.domPositionToView(t.parentNode, ir(t));
          var n = this.mapDomToView(t);
          if (n && n.is("uiElement")) return Zi._createBefore(n);

          if (Do(t)) {
            if (Fo(t)) return this.domPositionToView(t.parentNode, ir(t));

            var _n52 = this.findCorrespondingViewText(t);

            var _i37 = e;
            return _n52 ? (Bo(t) && (_i37 = (_i37 -= Vo) < 0 ? 0 : _i37), new Zi(_n52, _i37)) : null;
          }

          if (0 === e) {
            var _e58 = this.mapDomToView(t);

            if (_e58) return new Zi(_e58, 0);
          } else {
            var _n53 = t.childNodes[e - 1],
                _i38 = Do(_n53) ? this.findCorrespondingViewText(_n53) : this.mapDomToView(_n53);

            if (_i38 && _i38.parent) return new Zi(_i38.parent, _i38.index + 1);
          }

          return null;
        }
      }, {
        key: "mapDomToView",
        value: function mapDomToView(t) {
          return this.getParentUIElement(t) || this._domToViewMapping.get(t);
        }
      }, {
        key: "findCorrespondingViewText",
        value: function findCorrespondingViewText(t) {
          if (Fo(t)) return null;
          var e = this.getParentUIElement(t);
          if (e) return e;
          var n = t.previousSibling;

          if (n) {
            if (!this.isElement(n)) return null;

            var _t50 = this.mapDomToView(n);

            if (_t50) {
              return _t50.nextSibling instanceof fi ? _t50.nextSibling : null;
            }
          } else {
            var _e59 = this.mapDomToView(t.parentNode);

            if (_e59) {
              var _t51 = _e59.getChild(0);

              return _t51 instanceof fi ? _t51 : null;
            }
          }

          return null;
        }
      }, {
        key: "mapViewToDom",
        value: function mapViewToDom(t) {
          return this._viewToDomMapping.get(t);
        }
      }, {
        key: "findCorrespondingDomText",
        value: function findCorrespondingDomText(t) {
          var e = t.previousSibling;
          return e && this.mapViewToDom(e) ? this.mapViewToDom(e).nextSibling : !e && t.parent && this.mapViewToDom(t.parent) ? this.mapViewToDom(t.parent).childNodes[0] : null;
        }
      }, {
        key: "focus",
        value: function focus(t) {
          var e = this.mapViewToDom(t);

          if (e && e.ownerDocument.activeElement !== e) {
            var _nr$window = nr.window,
                _t52 = _nr$window.scrollX,
                _n54 = _nr$window.scrollY,
                _i39 = [];
            ar(e, function (t) {
              var e = t.scrollLeft,
                  n = t.scrollTop;

              _i39.push([e, n]);
            }), e.focus(), ar(e, function (t) {
              var _i39$shift = _i39.shift(),
                  _i39$shift2 = _slicedToArray(_i39$shift, 2),
                  e = _i39$shift2[0],
                  n = _i39$shift2[1];

              t.scrollLeft = e, t.scrollTop = n;
            }), nr.window.scrollTo(_t52, _n54);
          }
        }
      }, {
        key: "isElement",
        value: function isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE;
        }
      }, {
        key: "isDocumentFragment",
        value: function isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
      }, {
        key: "isComment",
        value: function isComment(t) {
          return t && t.nodeType == Node.COMMENT_NODE;
        }
      }, {
        key: "isDomSelectionBackward",
        value: function isDomSelectionBackward(t) {
          if (t.isCollapsed) return !1;
          var e = document.createRange();
          e.setStart(t.anchorNode, t.anchorOffset), e.setEnd(t.focusNode, t.focusOffset);
          var n = e.collapsed;
          return e.detach(), n;
        }
      }, {
        key: "getParentUIElement",
        value: function getParentUIElement(t) {
          var e = or(t);

          for (e.pop(); e.length;) {
            var _t53 = e.pop(),
                _n55 = this._domToViewMapping.get(_t53);

            if (_n55 && _n55.is("uiElement")) return _n55;
          }

          return null;
        }
      }, {
        key: "isDomSelectionCorrect",
        value: function isDomSelectionCorrect(t) {
          return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
        }
      }, {
        key: "_isDomSelectionPositionCorrect",
        value: function _isDomSelectionPositionCorrect(t, e) {
          if (Do(t) && Bo(t) && e < Vo) return !1;
          if (this.isElement(t) && Bo(t.childNodes[e])) return !1;
          var n = this.mapDomToView(t);
          return !n || !n.is("uiElement");
        }
      }, {
        key: "_processDataFromViewText",
        value: function _processDataFromViewText(t) {
          var _this23 = this;

          var e = t.data;
          if (t.getAncestors().some(function (t) {
            return _this23.preElements.includes(t.name);
          })) return e;

          if (" " == e.charAt(0)) {
            var _n56 = this._getTouchingViewTextNode(t, !1);

            !(_n56 && this._nodeEndsWithSpace(_n56)) && _n56 || (e = " " + e.substr(1));
          }

          if (" " == e.charAt(e.length - 1)) {
            var _n57 = this._getTouchingViewTextNode(t, !0);

            " " != e.charAt(e.length - 2) && _n57 && " " != _n57.data.charAt(0) || (e = e.substr(0, e.length - 1) + " ");
          }

          return e.replace(/ {2}/g, "  ");
        }
      }, {
        key: "_nodeEndsWithSpace",
        value: function _nodeEndsWithSpace(t) {
          var _this24 = this;

          if (t.getAncestors().some(function (t) {
            return _this24.preElements.includes(t.name);
          })) return !1;

          var e = this._processDataFromViewText(t);

          return " " == e.charAt(e.length - 1);
        }
      }, {
        key: "_processDataFromDomText",
        value: function _processDataFromDomText(t) {
          var e = t.data;
          if (sr(t, this.preElements)) return Uo(t);
          e = e.replace(/[ \n\t\r]{1,}/g, " ");

          var n = this._getTouchingInlineDomNode(t, !1),
              i = this._getTouchingInlineDomNode(t, !0),
              o = this._checkShouldLeftTrimDomText(n),
              r = this._checkShouldRightTrimDomText(t, i);

          return o && (e = e.replace(/^ /, "")), r && (e = e.replace(/ $/, "")), e = (e = Uo(new Text(e))).replace(/ \u00A0/g, "  "), (/( |\u00A0)\u00A0$/.test(e) || !i || i.data && " " == i.data.charAt(0)) && (e = e.replace(/\u00A0$/, " ")), o && (e = e.replace(/^\u00A0/, " ")), e;
        }
      }, {
        key: "_checkShouldLeftTrimDomText",
        value: function _checkShouldLeftTrimDomText(t) {
          return !t || !!Wn(t) || /[^\S\u00A0]/.test(t.data.charAt(t.data.length - 1));
        }
      }, {
        key: "_checkShouldRightTrimDomText",
        value: function _checkShouldRightTrimDomText(t, e) {
          return !e && !Bo(t);
        }
      }, {
        key: "_getTouchingViewTextNode",
        value: function _getTouchingViewTextNode(t, e) {
          var n = new Ji({
            startPosition: e ? Zi._createAfter(t) : Zi._createBefore(t),
            direction: e ? "forward" : "backward"
          });

          var _iterator68 = _createForOfIteratorHelper(n),
              _step68;

          try {
            for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
              var _t54 = _step68.value;
              if (_t54.item.is("containerElement")) return null;
              if (_t54.item.is("br")) return null;
              if (_t54.item.is("textProxy")) return _t54.item;
            }
          } catch (err) {
            _iterator68.e(err);
          } finally {
            _iterator68.f();
          }

          return null;
        }
      }, {
        key: "_getTouchingInlineDomNode",
        value: function _getTouchingInlineDomNode(t, e) {
          if (!t.parentNode) return null;
          var n = e ? "nextNode" : "previousNode",
              i = t.ownerDocument,
              o = or(t)[0],
              r = i.createTreeWalker(o, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
            acceptNode: function acceptNode(t) {
              return Do(t) ? NodeFilter.FILTER_ACCEPT : "BR" == t.tagName ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          });
          r.currentNode = t;
          var s = r[n]();

          if (null !== s) {
            var _e60 = function (t, e) {
              var n = or(t),
                  i = or(e);
              var o = 0;

              for (; n[o] == i[o] && n[o];) {
                o++;
              }

              return 0 === o ? null : n[o - 1];
            }(t, s);

            if (_e60 && !sr(t, this.blockElements, _e60) && !sr(s, this.blockElements, _e60)) return s;
          }

          return null;
        }
      }]);

      return rr;
    }();

    function sr(t, e, n) {
      var i = or(t);
      return n && (i = i.slice(i.indexOf(n) + 1)), i.some(function (t) {
        return t.tagName && e.includes(t.tagName.toLowerCase());
      });
    }

    function ar(t, e) {
      for (; t && t != nr.document;) {
        e(t), t = t.parentNode;
      }
    }

    function cr(t) {
      var e = Object.prototype.toString.apply(t);
      return "[object Window]" == e || "[object global]" == e;
    }

    var lr = Li({}, ei, {
      listenTo: function listenTo(t) {
        var _ei$listenTo;

        for (var _len15 = arguments.length, e = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
          e[_key15 - 1] = arguments[_key15];
        }

        if (Zo(t) || cr(t)) {
          var _n58 = this._getProxyEmitter(t) || new dr(t);

          _n58.attach.apply(_n58, e), t = _n58;
        }

        (_ei$listenTo = ei.listenTo).call.apply(_ei$listenTo, [this, t].concat(e));
      },
      stopListening: function stopListening(t, e, n) {
        if (Zo(t) || cr(t)) {
          var _e61 = this._getProxyEmitter(t);

          if (!_e61) return;
          t = _e61;
        }

        ei.stopListening.call(this, t, e, n), t instanceof dr && t.detach(e);
      },
      _getProxyEmitter: function _getProxyEmitter(t) {
        return function (t, e) {
          return t[Xn] && t[Xn][e] ? t[Xn][e].emitter : null;
        }(this, hr(t));
      }
    });

    var dr = function dr(t) {
      _classCallCheck(this, dr);

      ni(this, hr(t)), this._domNode = t;
    };

    function hr(t) {
      return t["data-ck-expando"] || (t["data-ck-expando"] = Jn());
    }

    Li(dr.prototype, ei, {
      attach: function attach(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (this._domListeners && this._domListeners[t]) return;

        var i = this._createDomListener(t, !!n.useCapture);

        this._domNode.addEventListener(t, i, !!n.useCapture), this._domListeners || (this._domListeners = {}), this._domListeners[t] = i;
      },
      detach: function detach(t) {
        var e;
        !this._domListeners[t] || (e = this._events[t]) && e.callbacks.length || this._domListeners[t].removeListener();
      },
      _createDomListener: function _createDomListener(t, e) {
        var _this25 = this;

        var n = function n(e) {
          _this25.fire(t, e);
        };

        return n.removeListener = function () {
          _this25._domNode.removeEventListener(t, n, e), delete _this25._domListeners[t];
        }, n;
      }
    });

    var ur = /*#__PURE__*/function () {
      function ur(t) {
        _classCallCheck(this, ur);

        this.view = t, this.document = t.document, this.isEnabled = !1;
      }

      _createClass(ur, [{
        key: "enable",
        value: function enable() {
          this.isEnabled = !0;
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.disable(), this.stopListening();
        }
      }]);

      return ur;
    }();

    ci(ur, lr);
    var fr = "__lodash_hash_undefined__";

    var mr = function mr(t) {
      return this.__data__.set(t, fr), this;
    };

    var gr = function gr(t) {
      return this.__data__.has(t);
    };

    function pr(t) {
      var e = -1,
          n = null == t ? 0 : t.length;

      for (this.__data__ = new Pt(); ++e < n;) {
        this.add(t[e]);
      }
    }

    pr.prototype.add = pr.prototype.push = mr, pr.prototype.has = gr;
    var br = pr;

    var wr = function wr(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length; ++n < i;) {
        if (e(t[n], n, t)) return !0;
      }

      return !1;
    };

    var kr = function kr(t, e) {
      return t.has(e);
    },
        _r = 1,
        vr = 2;

    var yr = function yr(t, e, n, i, o, r) {
      var s = n & _r,
          a = t.length,
          c = e.length;
      if (a != c && !(s && c > a)) return !1;
      var l = r.get(t);
      if (l && r.get(e)) return l == e;
      var d = -1,
          h = !0,
          u = n & vr ? new br() : void 0;

      for (r.set(t, e), r.set(e, t); ++d < a;) {
        var f = t[d],
            m = e[d];
        if (i) var g = s ? i(m, f, d, e, t, r) : i(f, m, d, t, e, r);

        if (void 0 !== g) {
          if (g) continue;
          h = !1;
          break;
        }

        if (u) {
          if (!wr(e, function (t, e) {
            if (!kr(u, e) && (f === t || o(f, t, n, i, r))) return u.push(e);
          })) {
            h = !1;
            break;
          }
        } else if (f !== m && !o(f, m, n, i, r)) {
          h = !1;
          break;
        }
      }

      return r.delete(t), r.delete(e), h;
    };

    var xr = function xr(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t, i) {
        n[++e] = [i, t];
      }), n;
    };

    var Ar = function Ar(t) {
      var e = -1,
          n = Array(t.size);
      return t.forEach(function (t) {
        n[++e] = t;
      }), n;
    },
        Tr = 1,
        Cr = 2,
        Pr = "[object Boolean]",
        Sr = "[object Date]",
        Mr = "[object Error]",
        Er = "[object Map]",
        Ir = "[object Number]",
        Nr = "[object RegExp]",
        Or = "[object Set]",
        Rr = "[object String]",
        Dr = "[object Symbol]",
        Lr = "[object ArrayBuffer]",
        jr = "[object DataView]",
        Vr = o ? o.prototype : void 0,
        zr = Vr ? Vr.valueOf : void 0;

    var Br = function Br(t, e, n, i, o, r, s) {
      switch (n) {
        case jr:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return !1;
          t = t.buffer, e = e.buffer;

        case Lr:
          return !(t.byteLength != e.byteLength || !r(new Ye(t), new Ye(e)));

        case Pr:
        case Sr:
        case Ir:
          return P(+t, +e);

        case Mr:
          return t.name == e.name && t.message == e.message;

        case Nr:
        case Rr:
          return t == e + "";

        case Er:
          var a = xr;

        case Or:
          var c = i & Tr;
          if (a || (a = Ar), t.size != e.size && !c) return !1;
          var l = s.get(t);
          if (l) return l == e;
          i |= Cr, s.set(t, e);
          var d = yr(a(t), a(e), i, o, r, s);
          return s.delete(t), d;

        case Dr:
          if (zr) return zr.call(t) == zr.call(e);
      }

      return !1;
    },
        Fr = 1,
        Ur = Object.prototype.hasOwnProperty;

    var Hr = function Hr(t, e, n, i, o, r) {
      var s = n & Fr,
          a = Ie(t),
          c = a.length;
      if (c != Ie(e).length && !s) return !1;

      for (var l = c; l--;) {
        var d = a[l];
        if (!(s ? d in e : Ur.call(e, d))) return !1;
      }

      var h = r.get(t);
      if (h && r.get(e)) return h == e;
      var u = !0;
      r.set(t, e), r.set(e, t);

      for (var f = s; ++l < c;) {
        var m = t[d = a[l]],
            g = e[d];
        if (i) var p = s ? i(g, m, d, e, t, r) : i(m, g, d, t, e, r);

        if (!(void 0 === p ? m === g || o(m, g, n, i, r) : p)) {
          u = !1;
          break;
        }

        f || (f = "constructor" == d);
      }

      if (u && !f) {
        var b = t.constructor,
            w = e.constructor;
        b != w && "constructor" in t && "constructor" in e && !("function" == typeof b && b instanceof b && "function" == typeof w && w instanceof w) && (u = !1);
      }

      return r.delete(t), r.delete(e), u;
    },
        qr = 1,
        Wr = "[object Arguments]",
        Yr = "[object Array]",
        $r = "[object Object]",
        Gr = Object.prototype.hasOwnProperty;

    var Qr = function Qr(t, e, n, i, o, r) {
      var s = Wt(t),
          a = Wt(e),
          c = s ? Yr : He(t),
          l = a ? Yr : He(e),
          d = (c = c == Wr ? $r : c) == $r,
          h = (l = l == Wr ? $r : l) == $r,
          u = c == l;

      if (u && Object(Yt.a)(t)) {
        if (!Object(Yt.a)(e)) return !1;
        s = !0, d = !1;
      }

      if (u && !d) return r || (r = new It()), s || ie(t) ? yr(t, e, n, i, o, r) : Br(t, e, c, n, i, o, r);

      if (!(n & qr)) {
        var f = d && Gr.call(t, "__wrapped__"),
            m = h && Gr.call(e, "__wrapped__");

        if (f || m) {
          var g = f ? t.value() : t,
              p = m ? e.value() : e;
          return r || (r = new It()), o(g, p, n, i, r);
        }
      }

      return !!u && (r || (r = new It()), Hr(t, e, n, i, o, r));
    };

    var Kr = function t(e, n, i, o, r) {
      return e === n || (null == e || null == n || !w(e) && !w(n) ? e != e && n != n : Qr(e, n, i, o, t, r));
    };

    var Jr = function Jr(t, e, n) {
      var i = (n = "function" == typeof n ? n : void 0) ? n(t, e) : void 0;
      return void 0 === i ? Kr(t, e, void 0, n) : !!i;
    };

    var Zr = /*#__PURE__*/function (_ur) {
      _inherits(Zr, _ur);

      var _super10 = _createSuper(Zr);

      function Zr(t) {
        var _this26;

        _classCallCheck(this, Zr);

        _this26 = _super10.call(this, t), _this26._config = {
          childList: !0,
          characterData: !0,
          characterDataOldValue: !0,
          subtree: !0
        }, _this26.domConverter = t.domConverter, _this26.renderer = t._renderer, _this26._domElements = [], _this26._mutationObserver = new window.MutationObserver(_this26._onMutations.bind(_assertThisInitialized(_this26)));
        return _this26;
      }

      _createClass(Zr, [{
        key: "flush",
        value: function flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
      }, {
        key: "observe",
        value: function observe(t) {
          this._domElements.push(t), this.isEnabled && this._mutationObserver.observe(t, this._config);
        }
      }, {
        key: "enable",
        value: function enable() {
          _get(_getPrototypeOf(Zr.prototype), "enable", this).call(this);

          var _iterator69 = _createForOfIteratorHelper(this._domElements),
              _step69;

          try {
            for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
              var _t55 = _step69.value;

              this._mutationObserver.observe(_t55, this._config);
            }
          } catch (err) {
            _iterator69.e(err);
          } finally {
            _iterator69.f();
          }
        }
      }, {
        key: "disable",
        value: function disable() {
          _get(_getPrototypeOf(Zr.prototype), "disable", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Zr.prototype), "destroy", this).call(this), this._mutationObserver.disconnect();
        }
      }, {
        key: "_onMutations",
        value: function _onMutations(t) {
          if (0 === t.length) return;
          var e = this.domConverter,
              n = new Map(),
              i = new Set();

          var _iterator70 = _createForOfIteratorHelper(t),
              _step70;

          try {
            for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
              var _n60 = _step70.value;

              if ("childList" === _n60.type) {
                var _t57 = e.mapDomToView(_n60.target);

                if (_t57 && _t57.is("uiElement")) continue;
                _t57 && !this._isBogusBrMutation(_n60) && i.add(_t57);
              }
            }
          } catch (err) {
            _iterator70.e(err);
          } finally {
            _iterator70.f();
          }

          var _iterator71 = _createForOfIteratorHelper(t),
              _step71;

          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _o25 = _step71.value;

              var _t58 = e.mapDomToView(_o25.target);

              if ((!_t58 || !_t58.is("uiElement")) && "characterData" === _o25.type) {
                var _t59 = e.findCorrespondingViewText(_o25.target);

                _t59 && !i.has(_t59.parent) ? n.set(_t59, {
                  type: "text",
                  oldText: _t59.data,
                  newText: Uo(_o25.target),
                  node: _t59
                }) : !_t59 && Bo(_o25.target) && i.add(e.mapDomToView(_o25.target.parentNode));
              }
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }

          var o = [];

          var _iterator72 = _createForOfIteratorHelper(n.values()),
              _step72;

          try {
            for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
              var _t60 = _step72.value;
              this.renderer.markToSync("text", _t60.node), o.push(_t60);
            }
          } catch (err) {
            _iterator72.e(err);
          } finally {
            _iterator72.f();
          }

          var _iterator73 = _createForOfIteratorHelper(i),
              _step73;

          try {
            for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
              var _t61 = _step73.value;

              var _n61 = e.mapViewToDom(_t61),
                  _i40 = Array.from(_t61.getChildren()),
                  _r9 = Array.from(e.domChildrenToView(_n61, {
                withChildren: !1
              }));

              Jr(_i40, _r9, a) || (this.renderer.markToSync("children", _t61), o.push({
                type: "children",
                oldChildren: _i40,
                newChildren: _r9,
                node: _t61
              }));
            }
          } catch (err) {
            _iterator73.e(err);
          } finally {
            _iterator73.f();
          }

          var r = t[0].target.ownerDocument.getSelection();
          var s = null;

          if (r && r.anchorNode) {
            var _t56 = e.domPositionToView(r.anchorNode, r.anchorOffset),
                _n59 = e.domPositionToView(r.focusNode, r.focusOffset);

            _t56 && _n59 && (s = new no(_t56)).setFocus(_n59);
          }

          function a(t, e) {
            if (!Array.isArray(t)) return t === e || !(!t.is("text") || !e.is("text")) && t.data === e.data;
          }

          this.document.fire("mutations", o, s), this.view.forceRender();
        }
      }, {
        key: "_isBogusBrMutation",
        value: function _isBogusBrMutation(t) {
          var e = null;
          return null === t.nextSibling && 0 === t.removedNodes.length && 1 == t.addedNodes.length && (e = this.domConverter.domToView(t.addedNodes[0], {
            withChildren: !1
          })), e && e.is("element", "br");
        }
      }]);

      return Zr;
    }(ur);

    var Xr = /*#__PURE__*/function () {
      function Xr(t, e, n) {
        _classCallCheck(this, Xr);

        this.view = t, this.document = t.document, this.domEvent = e, this.domTarget = e.target, Li(this, n);
      }

      _createClass(Xr, [{
        key: "target",
        get: function get() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
      }, {
        key: "preventDefault",
        value: function preventDefault() {
          this.domEvent.preventDefault();
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }]);

      return Xr;
    }();

    var ts = /*#__PURE__*/function (_ur2) {
      _inherits(ts, _ur2);

      var _super11 = _createSuper(ts);

      function ts(t) {
        var _this27;

        _classCallCheck(this, ts);

        _this27 = _super11.call(this, t), _this27.useCapture = !1;
        return _this27;
      }

      _createClass(ts, [{
        key: "observe",
        value: function observe(t) {
          var _this28 = this;

          ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach(function (e) {
            _this28.listenTo(t, e, function (t, e) {
              _this28.isEnabled && _this28.onDomEvent(e);
            }, {
              useCapture: _this28.useCapture
            });
          });
        }
      }, {
        key: "fire",
        value: function fire(t, e, n) {
          this.isEnabled && this.document.fire(t, new Xr(this.view, e, n));
        }
      }]);

      return ts;
    }(ur);

    var es = /*#__PURE__*/function (_ts) {
      _inherits(es, _ts);

      var _super12 = _createSuper(es);

      function es(t) {
        var _this29;

        _classCallCheck(this, es);

        _this29 = _super12.call(this, t), _this29.domEventType = ["keydown", "keyup"];
        return _this29;
      }

      _createClass(es, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t, {
            keyCode: t.keyCode,
            altKey: t.altKey,
            ctrlKey: t.ctrlKey || t.metaKey,
            shiftKey: t.shiftKey,

            get keystroke() {
              return wo(this);
            }

          });
        }
      }]);

      return es;
    }(ts);

    var ns = function ns() {
      return i.a.Date.now();
    },
        is = "[object Symbol]";

    var os = function os(t) {
      return "symbol" == _typeof(t) || w(t) && g(t) == is;
    },
        rs = NaN,
        ss = /^\s+|\s+$/g,
        as = /^[-+]0x[0-9a-f]+$/i,
        cs = /^0b[01]+$/i,
        ls = /^0o[0-7]+$/i,
        ds = parseInt;

    var hs = function hs(t) {
      if ("number" == typeof t) return t;
      if (os(t)) return rs;

      if (B(t)) {
        var e = "function" == typeof t.valueOf ? t.valueOf() : t;
        t = B(e) ? e + "" : e;
      }

      if ("string" != typeof t) return 0 === t ? t : +t;
      t = t.replace(ss, "");
      var n = cs.test(t);
      return n || ls.test(t) ? ds(t.slice(2), n ? 2 : 8) : as.test(t) ? rs : +t;
    },
        us = "Expected a function",
        fs = Math.max,
        ms = Math.min;

    var gs = function gs(t, e, n) {
      var i,
          o,
          r,
          s,
          a,
          c,
          l = 0,
          d = !1,
          h = !1,
          u = !0;
      if ("function" != typeof t) throw new TypeError(us);

      function f(e) {
        var n = i,
            r = o;
        return i = o = void 0, l = e, s = t.apply(r, n);
      }

      function m(t) {
        var n = t - c;
        return void 0 === c || n >= e || n < 0 || h && t - l >= r;
      }

      function g() {
        var t = ns();
        if (m(t)) return p(t);
        a = setTimeout(g, function (t) {
          var n = e - (t - c);
          return h ? ms(n, r - (t - l)) : n;
        }(t));
      }

      function p(t) {
        return a = void 0, u && i ? f(t) : (i = o = void 0, s);
      }

      function b() {
        var t = ns(),
            n = m(t);

        if (i = arguments, o = this, c = t, n) {
          if (void 0 === a) return function (t) {
            return l = t, a = setTimeout(g, e), d ? f(t) : s;
          }(c);
          if (h) return clearTimeout(a), a = setTimeout(g, e), f(c);
        }

        return void 0 === a && (a = setTimeout(g, e)), s;
      }

      return e = hs(e) || 0, B(n) && (d = !!n.leading, r = (h = "maxWait" in n) ? fs(hs(n.maxWait) || 0, e) : r, u = "trailing" in n ? !!n.trailing : u), b.cancel = function () {
        void 0 !== a && clearTimeout(a), l = 0, i = c = o = a = void 0;
      }, b.flush = function () {
        return void 0 === a ? s : p(ns());
      }, b;
    };

    var ps = /*#__PURE__*/function (_ur3) {
      _inherits(ps, _ur3);

      var _super13 = _createSuper(ps);

      function ps(t) {
        var _this30;

        _classCallCheck(this, ps);

        _this30 = _super13.call(this, t), _this30._fireSelectionChangeDoneDebounced = gs(function (t) {
          return _this30.document.fire("selectionChangeDone", t);
        }, 200);
        return _this30;
      }

      _createClass(ps, [{
        key: "observe",
        value: function observe() {
          var _this31 = this;

          var t = this.document;
          t.on("keydown", function (e, n) {
            t.selection.isFake && function (t) {
              return t == bo.arrowright || t == bo.arrowleft || t == bo.arrowup || t == bo.arrowdown;
            }(n.keyCode) && _this31.isEnabled && (n.preventDefault(), _this31._handleSelectionMove(n.keyCode));
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(ps.prototype), "destroy", this).call(this), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionMove",
        value: function _handleSelectionMove(t) {
          var e = this.document.selection,
              n = new no(e.getRanges(), {
            backward: e.isBackward,
            fake: !1
          });
          t != bo.arrowleft && t != bo.arrowup || n.setTo(n.getFirstPosition()), t != bo.arrowright && t != bo.arrowdown || n.setTo(n.getLastPosition());
          var i = {
            oldSelection: e,
            newSelection: n,
            domSelection: null
          };
          this.document.fire("selectionChange", i), this._fireSelectionChangeDoneDebounced(i);
        }
      }]);

      return ps;
    }(ur);

    var bs = /*#__PURE__*/function (_ur4) {
      _inherits(bs, _ur4);

      var _super14 = _createSuper(bs);

      function bs(t) {
        var _this32;

        _classCallCheck(this, bs);

        _this32 = _super14.call(this, t), _this32.mutationObserver = t.getObserver(Zr), _this32.selection = _this32.document.selection, _this32.domConverter = t.domConverter, _this32._documents = new WeakSet(), _this32._fireSelectionChangeDoneDebounced = gs(function (t) {
          return _this32.document.fire("selectionChangeDone", t);
        }, 200), _this32._clearInfiniteLoopInterval = setInterval(function () {
          return _this32._clearInfiniteLoop();
        }, 1e3), _this32._loopbackCounter = 0;
        return _this32;
      }

      _createClass(bs, [{
        key: "observe",
        value: function observe(t) {
          var _this33 = this;

          var e = t.ownerDocument;
          this._documents.has(e) || (this.listenTo(e, "selectionchange", function () {
            _this33._handleSelectionChange(e);
          }), this._documents.add(e));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(bs.prototype), "destroy", this).call(this), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionChange",
        value: function _handleSelectionChange(t) {
          if (!this.isEnabled || !this.document.isFocused && !this.document.isReadOnly) return;
          this.mutationObserver.flush();
          var e = t.defaultView.getSelection(),
              n = this.domConverter.domSelectionToView(e);
          if (!(this.selection.isEqual(n) && this.domConverter.isDomSelectionCorrect(e) || ++this._loopbackCounter > 60)) if (this.selection.isSimilar(n)) this.view.forceRender();else {
            var _t62 = {
              oldSelection: this.selection,
              newSelection: n,
              domSelection: e
            };
            this.document.fire("selectionChange", _t62), this._fireSelectionChangeDoneDebounced(_t62);
          }
        }
      }, {
        key: "_clearInfiniteLoop",
        value: function _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }]);

      return bs;
    }(ur);

    var ws = /*#__PURE__*/function (_ts2) {
      _inherits(ws, _ts2);

      var _super15 = _createSuper(ws);

      function ws(t) {
        var _this34;

        _classCallCheck(this, ws);

        _this34 = _super15.call(this, t), _this34.domEventType = ["focus", "blur"], _this34.useCapture = !0;
        var e = _this34.document;
        e.on("focus", function () {
          e.isFocused = !0, _this34._renderTimeoutId = setTimeout(function () {
            return t.forceRender();
          }, 50);
        }), e.on("blur", function (n, i) {
          var o = e.selection.editableElement;
          null !== o && o !== i.target || (e.isFocused = !1, t.forceRender());
        });
        return _this34;
      }

      _createClass(ws, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._renderTimeoutId && clearTimeout(this._renderTimeoutId), _get(_getPrototypeOf(ws.prototype), "destroy", this).call(this);
        }
      }]);

      return ws;
    }(ts);

    var ks = /*#__PURE__*/function (_ts3) {
      _inherits(ks, _ts3);

      var _super16 = _createSuper(ks);

      function ks(t) {
        var _this35;

        _classCallCheck(this, ks);

        _this35 = _super16.call(this, t), _this35.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        var e = _this35.document;
        e.on("compositionstart", function () {
          e.isComposing = !0;
        }), e.on("compositionend", function () {
          e.isComposing = !1;
        });
        return _this35;
      }

      _createClass(ks, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return ks;
    }(ts);

    var _s = /*#__PURE__*/function (_ts4) {
      _inherits(_s, _ts4);

      var _super17 = _createSuper(_s);

      function _s(t) {
        var _this36;

        _classCallCheck(this, _s);

        _this36 = _super17.call(this, t), _this36.domEventType = ["beforeinput"];
        return _this36;
      }

      _createClass(_s, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return _s;
    }(ts);

    function vs(t) {
      return "[object Range]" == Object.prototype.toString.apply(t);
    }

    function ys(t) {
      var e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }

    var xs = ["top", "right", "bottom", "left", "width", "height"];

    var As = /*#__PURE__*/function () {
      function As(t) {
        _classCallCheck(this, As);

        var e = vs(t);
        if (Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: !0,
          enumerable: !1
        }), Wn(t) || e) Ts(this, e ? As.getDomRangeRects(t)[0] : t.getBoundingClientRect());else if (cr(t)) {
          var _e62 = t.innerWidth,
              _n62 = t.innerHeight;
          Ts(this, {
            top: 0,
            right: _e62,
            bottom: _n62,
            left: 0,
            width: _e62,
            height: _n62
          });
        } else Ts(this, t);
      }

      _createClass(As, [{
        key: "clone",
        value: function clone() {
          return new As(this);
        }
      }, {
        key: "moveTo",
        value: function moveTo(t, e) {
          return this.top = e, this.right = t + this.width, this.bottom = e + this.height, this.left = t, this;
        }
      }, {
        key: "moveBy",
        value: function moveBy(t, e) {
          return this.top += e, this.right += t, this.left += t, this.bottom += e, this;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          var e = {
            top: Math.max(this.top, t.top),
            right: Math.min(this.right, t.right),
            bottom: Math.min(this.bottom, t.bottom),
            left: Math.max(this.left, t.left)
          };
          return e.width = e.right - e.left, e.height = e.bottom - e.top, e.width < 0 || e.height < 0 ? null : new As(e);
        }
      }, {
        key: "getIntersectionArea",
        value: function getIntersectionArea(t) {
          var e = this.getIntersection(t);
          return e ? e.getArea() : 0;
        }
      }, {
        key: "getArea",
        value: function getArea() {
          return this.width * this.height;
        }
      }, {
        key: "getVisible",
        value: function getVisible() {
          var t = this._source;
          var e = this.clone();

          if (!Cs(t)) {
            var _n63 = t.parentNode || t.commonAncestorContainer;

            for (; _n63 && !Cs(_n63);) {
              var _t63 = new As(_n63),
                  _i41 = e.getIntersection(_t63);

              if (!_i41) return null;
              _i41.getArea() < e.getArea() && (e = _i41), _n63 = _n63.parentNode;
            }
          }

          return e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          var _iterator74 = _createForOfIteratorHelper(xs),
              _step74;

          try {
            for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
              var _e63 = _step74.value;
              if (this[_e63] !== t[_e63]) return !1;
            }
          } catch (err) {
            _iterator74.e(err);
          } finally {
            _iterator74.f();
          }

          return !0;
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var e = this.getIntersection(t);
          return !(!e || !e.isEqual(t));
        }
      }, {
        key: "excludeScrollbarsAndBorders",
        value: function excludeScrollbarsAndBorders() {
          var t = this._source;
          var e, n;
          if (cr(t)) e = t.innerWidth - t.document.documentElement.clientWidth, n = t.innerHeight - t.document.documentElement.clientHeight;else {
            var _i42 = ys(this._source);

            e = t.offsetWidth - t.clientWidth, n = t.offsetHeight - t.clientHeight, this.moveBy(_i42.left, _i42.top);
          }
          return this.width -= e, this.right -= e, this.height -= n, this.bottom -= n, this;
        }
      }], [{
        key: "getDomRangeRects",
        value: function getDomRangeRects(t) {
          var e = [],
              n = Array.from(t.getClientRects());

          if (n.length) {
            var _iterator75 = _createForOfIteratorHelper(n),
                _step75;

            try {
              for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
                var _t64 = _step75.value;
                e.push(new As(_t64));
              }
            } catch (err) {
              _iterator75.e(err);
            } finally {
              _iterator75.f();
            }
          } else {
            var _n64 = t.startContainer;
            Do(_n64) && (_n64 = _n64.parentNode);

            var _i43 = new As(_n64.getBoundingClientRect());

            _i43.right = _i43.left, _i43.width = 0, e.push(_i43);
          }

          return e;
        }
      }]);

      return As;
    }();

    function Ts(t, e) {
      var _iterator76 = _createForOfIteratorHelper(xs),
          _step76;

      try {
        for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
          var _n65 = _step76.value;
          t[_n65] = e[_n65];
        }
      } catch (err) {
        _iterator76.e(err);
      } finally {
        _iterator76.f();
      }
    }

    function Cs(t) {
      return !!Wn(t) && t === t.ownerDocument.body;
    }

    function Ps(_ref16) {
      var t = _ref16.target,
          _ref16$viewportOffset = _ref16.viewportOffset,
          e = _ref16$viewportOffset === void 0 ? 0 : _ref16$viewportOffset;
      var n = Rs(t);
      var i = n,
          o = null;

      for (; i;) {
        var _r10 = void 0;

        Ms(_r10 = Ds(i == n ? t : o), function () {
          return Ls(t, i);
        });

        var _s8 = Ls(t, i);

        if (Ss(i, _s8, e), i.parent != i) {
          if (o = i.frameElement, i = i.parent, !o) return;
        } else i = null;
      }
    }

    function Ss(t, e, n) {
      var i = e.clone().moveBy(0, n),
          o = e.clone().moveBy(0, -n),
          r = new As(t).excludeScrollbarsAndBorders();

      if (![o, i].every(function (t) {
        return r.contains(t);
      })) {
        var _s9 = t.scrollX,
            _a7 = t.scrollY;
        Is(o, r) ? _a7 -= r.top - e.top + n : Es(i, r) && (_a7 += e.bottom - r.bottom + n), Ns(e, r) ? _s9 -= r.left - e.left + n : Os(e, r) && (_s9 += e.right - r.right + n), t.scrollTo(_s9, _a7);
      }
    }

    function Ms(t, e) {
      var n = Rs(t);
      var i, o;

      for (; t != n.document.body;) {
        o = e(), (i = new As(t).excludeScrollbarsAndBorders()).contains(o) || (Is(o, i) ? t.scrollTop -= i.top - o.top : Es(o, i) && (t.scrollTop += o.bottom - i.bottom), Ns(o, i) ? t.scrollLeft -= i.left - o.left : Os(o, i) && (t.scrollLeft += o.right - i.right)), t = t.parentNode;
      }
    }

    function Es(t, e) {
      return t.bottom > e.bottom;
    }

    function Is(t, e) {
      return t.top < e.top;
    }

    function Ns(t, e) {
      return t.left < e.left;
    }

    function Os(t, e) {
      return t.right > e.right;
    }

    function Rs(t) {
      return vs(t) ? t.startContainer.ownerDocument.defaultView : t.ownerDocument.defaultView;
    }

    function Ds(t) {
      if (vs(t)) {
        var _e64 = t.commonAncestorContainer;
        return Do(_e64) && (_e64 = _e64.parentNode), _e64;
      }

      return t.parentNode;
    }

    function Ls(t, e) {
      var n = Rs(t),
          i = new As(t);
      if (n === e) return i;
      {
        var _t65 = n;

        for (; _t65 != e;) {
          var _e65 = _t65.frameElement,
              _n66 = new As(_e65).excludeScrollbarsAndBorders();

          i.moveBy(_n66.left, _n66.top), _t65 = _t65.parent;
        }
      }
      return i;
    }

    Object.assign({}, {
      scrollViewportToShowTarget: Ps,
      scrollAncestorsToShowTarget: function scrollAncestorsToShowTarget(t) {
        Ms(Ds(t), function () {
          return new As(t);
        });
      }
    });

    var js = /*#__PURE__*/function () {
      function js() {
        var _this37 = this;

        _classCallCheck(this, js);

        this.document = new ro(), this.domConverter = new rr(), this.domRoots = new Map(), this.set("isRenderingInProgress", !1), this._renderer = new Xo(this.domConverter, this.document.selection), this._renderer.bind("isFocused").to(this.document), this._initialDomRootAttributes = new WeakMap(), this._observers = new Map(), this._ongoingChange = !1, this._postFixersInProgress = !1, this._renderingDisabled = !1, this._hasChangedSinceTheLastRendering = !1, this._writer = new To(this.document), this.addObserver(Zr), this.addObserver(bs), this.addObserver(ws), this.addObserver(es), this.addObserver(ps), this.addObserver(ks), mo.isAndroid && this.addObserver(_s), function (t) {
          t.document.on("keydown", Wo);
        }(this), yo(this), this.on("render", function () {
          _this37._render(), _this37.document.fire("layoutChanged"), _this37._hasChangedSinceTheLastRendering = !1;
        }), this.listenTo(this.document.selection, "change", function () {
          _this37._hasChangedSinceTheLastRendering = !0;
        });
      }

      _createClass(js, [{
        key: "attachDomRoot",
        value: function attachDomRoot(t) {
          var _this38 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          var n = this.document.getRoot(e);
          n._name = t.tagName.toLowerCase();
          var i = {};

          for (var _i44 = 0, _Array$from2 = Array.from(t.attributes); _i44 < _Array$from2.length; _i44++) {
            var _ref18 = _Array$from2[_i44];
            var _e66 = _ref18.name;
            var _o26 = _ref18.value;
            i[_e66] = _o26, "class" === _e66 ? this._writer.addClass(_o26.split(" "), n) : this._writer.setAttribute(_e66, _o26, n);
          }

          this._initialDomRootAttributes.set(t, i);

          var o = function o() {
            _this38._writer.setAttribute("contenteditable", !n.isReadOnly, n), n.isReadOnly ? _this38._writer.addClass("ck-read-only", n) : _this38._writer.removeClass("ck-read-only", n);
          };

          o(), this.domRoots.set(e, t), this.domConverter.bindElements(t, n), this._renderer.markToSync("children", n), this._renderer.markToSync("attributes", n), this._renderer.domDocuments.add(t.ownerDocument), n.on("change:children", function (t, e) {
            return _this38._renderer.markToSync("children", e);
          }), n.on("change:attributes", function (t, e) {
            return _this38._renderer.markToSync("attributes", e);
          }), n.on("change:text", function (t, e) {
            return _this38._renderer.markToSync("text", e);
          }), n.on("change:isReadOnly", function () {
            return _this38.change(o);
          }), n.on("change", function () {
            _this38._hasChangedSinceTheLastRendering = !0;
          });

          var _iterator77 = _createForOfIteratorHelper(this._observers.values()),
              _step77;

          try {
            for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
              var _n67 = _step77.value;

              _n67.observe(t, e);
            }
          } catch (err) {
            _iterator77.e(err);
          } finally {
            _iterator77.f();
          }
        }
      }, {
        key: "detachDomRoot",
        value: function detachDomRoot(t) {
          var e = this.domRoots.get(t);
          Array.from(e.attributes).forEach(function (_ref19) {
            var t = _ref19.name;
            return e.removeAttribute(t);
          });

          var n = this._initialDomRootAttributes.get(e);

          for (var _t66 in n) {
            e.setAttribute(_t66, n[_t66]);
          }

          this.domRoots.delete(t), this.domConverter.unbindDomElement(e);
        }
      }, {
        key: "getDomRoot",
        value: function getDomRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.domRoots.get(t);
        }
      }, {
        key: "addObserver",
        value: function addObserver(t) {
          var e = this._observers.get(t);

          if (e) return e;
          e = new t(this), this._observers.set(t, e);

          var _iterator78 = _createForOfIteratorHelper(this.domRoots),
              _step78;

          try {
            for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
              var _ref22 = _step78.value;

              var _ref21 = _slicedToArray(_ref22, 2);

              var _t67 = _ref21[0];
              var _n68 = _ref21[1];
              e.observe(_n68, _t67);
            }
          } catch (err) {
            _iterator78.e(err);
          } finally {
            _iterator78.f();
          }

          return e.enable(), e;
        }
      }, {
        key: "getObserver",
        value: function getObserver(t) {
          return this._observers.get(t);
        }
      }, {
        key: "disableObservers",
        value: function disableObservers() {
          var _iterator79 = _createForOfIteratorHelper(this._observers.values()),
              _step79;

          try {
            for (_iterator79.s(); !(_step79 = _iterator79.n()).done;) {
              var _t68 = _step79.value;

              _t68.disable();
            }
          } catch (err) {
            _iterator79.e(err);
          } finally {
            _iterator79.f();
          }
        }
      }, {
        key: "enableObservers",
        value: function enableObservers() {
          var _iterator80 = _createForOfIteratorHelper(this._observers.values()),
              _step80;

          try {
            for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
              var _t69 = _step80.value;

              _t69.enable();
            }
          } catch (err) {
            _iterator80.e(err);
          } finally {
            _iterator80.f();
          }
        }
      }, {
        key: "scrollToTheSelection",
        value: function scrollToTheSelection() {
          var t = this.document.selection.getFirstRange();
          t && Ps({
            target: this.domConverter.viewRangeToDom(t),
            viewportOffset: 20
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          if (!this.document.isFocused) {
            var _t70 = this.document.selection.editableElement;
            _t70 && (this.domConverter.focus(_t70), this.forceRender());
          }
        }
      }, {
        key: "change",
        value: function change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress) throw new Gn.b("cannot-change-view-tree: Attempting to make changes to the view when it is in an incorrect state: rendering or post-fixers are in progress. This may cause some unexpected behavior and inconsistency between the DOM and the view.", this);
          if (this._ongoingChange) return t(this._writer);
          this._ongoingChange = !0;
          var e = t(this._writer);
          return this._ongoingChange = !1, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = !0, this.document._callPostFixers(this._writer), this._postFixersInProgress = !1, this.fire("render")), e;
        }
      }, {
        key: "forceRender",
        value: function forceRender() {
          this._hasChangedSinceTheLastRendering = !0, this.change(function () {});
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator81 = _createForOfIteratorHelper(this._observers.values()),
              _step81;

          try {
            for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
              var _t71 = _step81.value;

              _t71.destroy();
            }
          } catch (err) {
            _iterator81.e(err);
          } finally {
            _iterator81.f();
          }

          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Xi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Xi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Xi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new no(t, e, n);
        }
      }, {
        key: "_disableRendering",
        value: function _disableRendering(t) {
          this._renderingDisabled = t, 0 == t && this.change(function () {});
        }
      }, {
        key: "_render",
        value: function _render() {
          this.isRenderingInProgress = !0, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = !1;
        }
      }]);

      return js;
    }();

    function Vs(t) {
      return T(t) ? gi(t) : new Map(t);
    }

    ci(js, Fi);

    var zs = /*#__PURE__*/function () {
      function zs(t) {
        _classCallCheck(this, zs);

        this.parent = null, this._attrs = Vs(t);
      }

      _createClass(zs, [{
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildIndex(this))) throw new Gn.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "startOffset",
        get: function get() {
          var t;
          if (!this.parent) return null;
          if (null === (t = this.parent.getChildStartOffset(this))) throw new Gn.b("model-node-not-found-in-parent: The node's parent does not contain this node.", this);
          return t;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return 1;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return this.parent ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return null !== t && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;

          for (; t.parent;) {
            t = t.parent;
          }

          return t;
        }
      }, {
        key: "document",
        get: function get() {
          return this.root == this ? null : this.root.document || null;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;

          for (; e.parent;) {
            t.unshift(e.startOffset), e = e.parent;
          }

          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e),
              i = t.getAncestors(e);
          var o = 0;

          for (; n[o] == i[o] && n[o];) {
            o++;
          }

          return 0 === o ? null : n[o - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) return !1;
          if (this.root !== t.root) return !1;
          var e = this.getPath(),
              n = t.getPath(),
              i = li(e, n);

          switch (i) {
            case "prefix":
              return !0;

            case "extension":
              return !1;

            default:
              return e[i] < n[i];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this != t && this.root === t.root && !this.isBefore(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = {};
          return this._attrs.size && (t.attributes = Array.from(this._attrs).reduce(function (t, e) {
            return t[e[0]] = e[1], t;
          }, {})), t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "node" == t || "model:node" == t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new zs(this._attrs);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._attrs.set(t, e);
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          this._attrs = Vs(t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._attrs.delete(t);
        }
      }, {
        key: "_clearAttributes",
        value: function _clearAttributes() {
          this._attrs.clear();
        }
      }]);

      return zs;
    }();

    var Bs = /*#__PURE__*/function (_zs) {
      _inherits(Bs, _zs);

      var _super18 = _createSuper(Bs);

      function Bs(t, e) {
        var _this39;

        _classCallCheck(this, Bs);

        _this39 = _super18.call(this, e), _this39._data = t || "";
        return _this39;
      }

      _createClass(Bs, [{
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "text" == t || "model:text" == t || _get(_getPrototypeOf(Bs.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Bs.prototype), "toJSON", this).call(this);

          return t.data = this.data, t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Bs(this.data, this.getAttributes());
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new Bs(t.data, t.attributes);
        }
      }]);

      return Bs;
    }(zs);

    var Fs = /*#__PURE__*/function () {
      function Fs(t, e, n) {
        _classCallCheck(this, Fs);

        if (this.textNode = t, e < 0 || e > t.offsetSize) throw new Gn.b("model-textproxy-wrong-offsetintext: Given offsetInText value is incorrect.", this);
        if (n < 0 || e + n > t.offsetSize) throw new Gn.b("model-textproxy-wrong-length: Given length value is incorrect.", this);
        this.data = t.data.substring(e, e + n), this.offsetInText = e;
      }

      _createClass(Fs, [{
        key: "startOffset",
        get: function get() {
          return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "textProxy" == t || "model:textProxy" == t;
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = this.textNode.getPath();
          return t.length > 0 && (t[t.length - 1] += this.offsetInText), t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: !1,
            parentFirst: !1
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;

          for (; n;) {
            e[t.parentFirst ? "push" : "unshift"](n), n = n.parent;
          }

          return e;
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this.textNode.hasAttribute(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this.textNode.getAttribute(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this.textNode.getAttributes();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }]);

      return Fs;
    }();

    var Us = /*#__PURE__*/function (_Symbol$iterator5) {
      function Us(t) {
        _classCallCheck(this, Us);

        this._nodes = [], t && this._insertNodes(0, t);
      }

      _createClass(Us, [{
        key: _Symbol$iterator5,
        value: function value() {
          return this._nodes[Symbol.iterator]();
        }
      }, {
        key: "length",
        get: function get() {
          return this._nodes.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._nodes.reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }, {
        key: "getNode",
        value: function getNode(t) {
          return this._nodes[t] || null;
        }
      }, {
        key: "getNodeIndex",
        value: function getNodeIndex(t) {
          var e = this._nodes.indexOf(t);

          return -1 == e ? null : e;
        }
      }, {
        key: "getNodeStartOffset",
        value: function getNodeStartOffset(t) {
          var e = this.getNodeIndex(t);
          return null === e ? null : this._nodes.slice(0, e).reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }, {
        key: "indexToOffset",
        value: function indexToOffset(t) {
          if (t == this._nodes.length) return this.maxOffset;
          var e = this._nodes[t];
          if (!e) throw new Gn.b("model-nodelist-index-out-of-bounds: Given index cannot be found in the node list.", this);
          return this.getNodeStartOffset(e);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          var e = 0;

          var _iterator82 = _createForOfIteratorHelper(this._nodes),
              _step82;

          try {
            for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
              var _n69 = _step82.value;
              if (t >= e && t < e + _n69.offsetSize) return this.getNodeIndex(_n69);
              e += _n69.offsetSize;
            }
          } catch (err) {
            _iterator82.e(err);
          } finally {
            _iterator82.f();
          }

          if (e != t) throw new Gn.b("model-nodelist-offset-out-of-bounds: Given offset cannot be found in the node list.", this, {
            offset: t,
            nodeList: this
          });
          return this.length;
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(t, e) {
          var _this$_nodes;

          var _iterator83 = _createForOfIteratorHelper(e),
              _step83;

          try {
            for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
              var _t72 = _step83.value;
              if (!(_t72 instanceof zs)) throw new Gn.b("model-nodelist-insertNodes-not-node: Trying to insert an object which is not a Node instance.", this);
            }
          } catch (err) {
            _iterator83.e(err);
          } finally {
            _iterator83.f();
          }

          (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [t, 0].concat(_toConsumableArray(e)));
        }
      }, {
        key: "_removeNodes",
        value: function _removeNodes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return this._nodes.splice(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this._nodes.map(function (t) {
            return t.toJSON();
          });
        }
      }]);

      return Us;
    }(Symbol.iterator);

    var Hs = /*#__PURE__*/function (_zs2) {
      _inherits(Hs, _zs2);

      var _super19 = _createSuper(Hs);

      function Hs(t, e, n) {
        var _this40;

        _classCallCheck(this, Hs);

        _this40 = _super19.call(this, e), _this40.name = t, _this40._children = new Us(), n && _this40._insertChild(0, n);
        return _this40;
      }

      _createClass(Hs, [{
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = t.replace(/^model:/, "");
          return e ? "element" == n && e == this.name : "element" == n || n == this.name || _get(_getPrototypeOf(Hs.prototype), "is", this).call(this, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;

          var _iterator84 = _createForOfIteratorHelper(t),
              _step84;

          try {
            for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
              var _n70 = _step84.value;
              e = e.getChild(e.offsetToIndex(_n70));
            }
          } catch (err) {
            _iterator84.e(err);
          } finally {
            _iterator84.f();
          }

          return e;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Hs.prototype), "toJSON", this).call(this);

          if (t.name = this.name, this._children.length > 0) {
            t.children = [];

            var _iterator85 = _createForOfIteratorHelper(this._children),
                _step85;

            try {
              for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
                var _e67 = _step85.value;
                t.children.push(_e67.toJSON());
              }
            } catch (err) {
              _iterator85.e(err);
            } finally {
              _iterator85.f();
            }
          }

          return t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          var e = t ? Array.from(this._children).map(function (t) {
            return t._clone(!0);
          }) : null;
          return new Hs(this.name, this.getAttributes(), e);
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new Bs(t)];
            pi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new Bs(t) : t instanceof Fs ? new Bs(t.data, t.getAttributes()) : t;
            });
          }(e);

          var _iterator86 = _createForOfIteratorHelper(n),
              _step86;

          try {
            for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
              var _t73 = _step86.value;
              null !== _t73.parent && _t73._remove(), _t73.parent = this;
            }
          } catch (err) {
            _iterator86.e(err);
          } finally {
            _iterator86.f();
          }

          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var n = this._children._removeNodes(t, e);

          var _iterator87 = _createForOfIteratorHelper(n),
              _step87;

          try {
            for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
              var _t74 = _step87.value;
              _t74.parent = null;
            }
          } catch (err) {
            _iterator87.e(err);
          } finally {
            _iterator87.f();
          }

          return n;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = null;

          if (t.children) {
            e = [];

            var _iterator88 = _createForOfIteratorHelper(t.children),
                _step88;

            try {
              for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
                var _n71 = _step88.value;
                _n71.name ? e.push(Hs.fromJSON(_n71)) : e.push(Bs.fromJSON(_n71));
              }
            } catch (err) {
              _iterator88.e(err);
            } finally {
              _iterator88.f();
            }
          }

          return new Hs(t.name, t.attributes, e);
        }
      }]);

      return Hs;
    }(zs);

    var qs = /*#__PURE__*/function (_Symbol$iterator6) {
      function qs() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, qs);

        if (!t.boundaries && !t.startPosition) throw new Gn.b("model-tree-walker-no-start-position: Neither boundaries nor starting position have been defined.", null);
        var e = t.direction || "forward";
        if ("forward" != e && "backward" != e) throw new Gn.b("model-tree-walker-unknown-direction: Only `backward` and `forward` direction allowed.", t, {
          direction: e
        });
        this.direction = e, this.boundaries = t.boundaries || null, t.startPosition ? this.position = t.startPosition.clone() : this.position = $s._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t.singleCharacters, this.shallow = !!t.shallow, this.ignoreElementEnd = !!t.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
      }

      _createClass(qs, [{
        key: _Symbol$iterator6,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, i, o;

          do {
            var _this$next2;

            i = this.position, o = this._visitedParent, (_this$next2 = this.next(), e = _this$next2.done, n = _this$next2.value, _this$next2);
          } while (!e && t(n));

          e || (this.position = i, this._visitedParent = o);
        }
      }, {
        key: "next",
        value: function next() {
          return "forward" == this.direction ? this._next() : this._previous();
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position,
              e = this.position.clone(),
              n = this._visitedParent;
          if (null === n.parent && e.offset === n.maxOffset) return {
            done: !0
          };
          if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
            done: !0
          };
          var i = e.textNode ? e.textNode : e.nodeAfter;
          if (i instanceof Hs) return this.shallow ? e.offset++ : (e.path.push(0), this._visitedParent = i), this.position = e, Ws("elementStart", i, t, e, 1);

          if (i instanceof Bs) {
            var _o27;

            if (this.singleCharacters) _o27 = 1;else {
              var _t75 = i.endOffset;
              this._boundaryEndParent == n && this.boundaries.end.offset < _t75 && (_t75 = this.boundaries.end.offset), _o27 = _t75 - e.offset;
            }

            var _r11 = e.offset - i.startOffset,
                _s10 = new Fs(i, _r11, _o27);

            return e.offset += _o27, this.position = e, Ws("text", _s10, t, e, _o27);
          }

          return e.path.pop(), e.offset++, this.position = e, this._visitedParent = n.parent, this.ignoreElementEnd ? this._next() : Ws("elementEnd", n, t, e);
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position,
              e = this.position.clone(),
              n = this._visitedParent;
          if (null === n.parent && 0 === e.offset) return {
            done: !0
          };
          if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
            done: !0
          };
          var i = e.textNode ? e.textNode : e.nodeBefore;
          if (i instanceof Hs) return e.offset--, this.shallow ? (this.position = e, Ws("elementStart", i, t, e, 1)) : (e.path.push(i.maxOffset), this.position = e, this._visitedParent = i, this.ignoreElementEnd ? this._previous() : Ws("elementEnd", i, t, e));

          if (i instanceof Bs) {
            var _o28;

            if (this.singleCharacters) _o28 = 1;else {
              var _t76 = i.startOffset;
              this._boundaryStartParent == n && this.boundaries.start.offset > _t76 && (_t76 = this.boundaries.start.offset), _o28 = e.offset - _t76;
            }

            var _r12 = e.offset - i.startOffset,
                _s11 = new Fs(i, _r12 - _o28, _o28);

            return e.offset -= _o28, this.position = e, Ws("text", _s11, t, e, _o28);
          }

          return e.path.pop(), this.position = e, this._visitedParent = n.parent, Ws("elementStart", n, t, e, 1);
        }
      }]);

      return qs;
    }(Symbol.iterator);

    function Ws(t, e, n, i, o) {
      return {
        done: !1,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: i,
          length: o
        }
      };
    }

    var Ys = function Ys(t) {
      var e = null == t ? 0 : t.length;
      return e ? t[e - 1] : void 0;
    };

    var $s = /*#__PURE__*/function () {
      function $s(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, $s);

        if (!t.is("element") && !t.is("documentFragment")) throw new Gn.b("model-position-root-invalid: Position root invalid.", t);
        if (!(e instanceof Array) || 0 === e.length) throw new Gn.b("model-position-path-incorrect-format: Position path must be an array with at least one item.", t, {
          path: e
        });
        e = t.getPath().concat(e), t = t.root, this.root = t, this.path = e, this.stickiness = n;
      }

      _createClass($s, [{
        key: "offset",
        get: function get() {
          return Ys(this.path);
        },
        set: function set(t) {
          this.path[this.path.length - 1] = t;
        }
      }, {
        key: "parent",
        get: function get() {
          var t = this.root;

          for (var _e68 = 0; _e68 < this.path.length - 1; _e68++) {
            if (!(t = t.getChild(t.offsetToIndex(this.path[_e68])))) throw new Gn.b("model-position-path-incorrect: The position's path is incorrect.", this, {
              position: this
            });
          }

          if (t.is("text")) throw new Gn.b("model-position-path-incorrect: The position's path is incorrect.", this, {
            position: this
          });
          return t;
        }
      }, {
        key: "index",
        get: function get() {
          return this.parent.offsetToIndex(this.offset);
        }
      }, {
        key: "textNode",
        get: function get() {
          var t = this.parent.getChild(this.index);
          return t instanceof Bs && t.startOffset < this.offset ? t : null;
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          return null === this.textNode ? this.parent.getChild(this.index) : null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          return null === this.textNode ? this.parent.getChild(this.index - 1) : null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return 0 === this.offset;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          return this.offset == this.parent.maxOffset;
        }
      }, {
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root != t.root) return "different";
          var e = li(this.path, t.path);

          switch (e) {
            case "same":
              return "same";

            case "prefix":
              return "before";

            case "extension":
              return "after";

            default:
              return this.path[e] < t.path[e] ? "before" : "after";
          }
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new qs(e);
          return n.skip(t), n.position;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          return this.path.slice(0, -1);
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({
            includeSelf: !0
          });
        }
      }, {
        key: "getCommonPath",
        value: function getCommonPath(t) {
          if (this.root != t.root) return [];
          var e = li(this.path, t.path),
              n = "string" == typeof e ? Math.min(this.path.length, t.path.length) : e;
          return this.path.slice(0, n);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors(),
              n = t.getAncestors();
          var i = 0;

          for (; e[i] == n[i] && e[i];) {
            i++;
          }

          return 0 === i ? null : e[i - 1];
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = this.clone(),
              n = e.offset + t;
          return e.offset = n < 0 ? 0 : n, e;
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return "after" == this.compareWith(t);
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return "before" == this.compareWith(t);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return "same" == this.compareWith(t);
        }
      }, {
        key: "isTouching",
        value: function isTouching(t) {
          var e = null,
              n = null;

          switch (this.compareWith(t)) {
            case "same":
              return !0;

            case "before":
              e = $s._createAt(this), n = $s._createAt(t);
              break;

            case "after":
              e = $s._createAt(t), n = $s._createAt(this);
              break;

            default:
              return !1;
          }

          var i = e.parent;

          for (; e.path.length + n.path.length;) {
            if (e.isEqual(n)) return !0;

            if (e.path.length > n.path.length) {
              if (e.offset !== i.maxOffset) return !1;
              e.path = e.path.slice(0, -1), i = i.parent, e.offset++;
            } else {
              if (0 !== n.offset) return !1;
              n.path = n.path.slice(0, -1);
            }
          }
        }
      }, {
        key: "is",
        value: function is(t) {
          return "position" == t || "model:position" == t;
        }
      }, {
        key: "hasSameParentAs",
        value: function hasSameParentAs(t) {
          if (this.root !== t.root) return !1;
          return "same" == li(this.getParentPath(), t.getParentPath());
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          var e;

          switch (t.type) {
            case "insert":
              e = this._getTransformedByInsertOperation(t);
              break;

            case "move":
            case "remove":
            case "reinsert":
              e = this._getTransformedByMoveOperation(t);
              break;

            case "split":
              e = this._getTransformedBySplitOperation(t);
              break;

            case "merge":
              e = this._getTransformedByMergeOperation(t);
              break;

            default:
              e = $s._createAt(this);
          }

          return e;
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = t.movedRange;
          return e.containsPosition(this) || e.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t.splitPosition, t.moveTargetPosition) : t.graveyardPosition ? this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1) : this._getTransformedByInsertion(t.insertionPosition, 1);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          var e = t.movedRange;
          var n;
          return e.containsPosition(this) || e.start.isEqual(this) ? (n = this._getCombined(t.sourcePosition, t.targetPosition), t.sourcePosition.isBefore(t.targetPosition) && (n = n._getTransformedByDeletion(t.deletionPosition, 1))) : n = this.isEqual(t.deletionPosition) ? $s._createAt(t.deletionPosition) : this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1), n;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = $s._createAt(this);

          if (this.root != t.root) return n;

          if ("same" == li(t.getParentPath(), this.getParentPath())) {
            if (t.offset < this.offset) {
              if (t.offset + e > this.offset) return null;
              n.offset -= e;
            }
          } else if ("prefix" == li(t.getParentPath(), this.getParentPath())) {
            var _i45 = t.path.length - 1;

            if (t.offset <= this.path[_i45]) {
              if (t.offset + e > this.path[_i45]) return null;
              n.path[_i45] -= e;
            }
          }

          return n;
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = $s._createAt(this);

          if (this.root != t.root) return n;
          if ("same" == li(t.getParentPath(), this.getParentPath())) (t.offset < this.offset || t.offset == this.offset && "toPrevious" != this.stickiness) && (n.offset += e);else if ("prefix" == li(t.getParentPath(), this.getParentPath())) {
            var _i46 = t.path.length - 1;

            t.offset <= this.path[_i46] && (n.path[_i46] += e);
          }
          return n;
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          if (e = e._getTransformedByDeletion(t, n), t.isEqual(e)) return $s._createAt(this);

          var i = this._getTransformedByDeletion(t, n);

          return null === i || t.isEqual(this) && "toNext" == this.stickiness || t.getShiftedBy(n).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t, e) : i._getTransformedByInsertion(e, n);
        }
      }, {
        key: "_getCombined",
        value: function _getCombined(t, e) {
          var n = t.path.length - 1,
              i = $s._createAt(e);

          return i.stickiness = this.stickiness, i.offset = i.offset + this.path[n] - t.offset, i.path = i.path.concat(this.path.slice(n + 1)), i;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
          if (t instanceof $s) return new $s(t.root, t.path, t.stickiness);
          {
            var _i47 = t;
            if ("end" == e) e = _i47.maxOffset;else {
              if ("before" == e) return this._createBefore(_i47, n);
              if ("after" == e) return this._createAfter(_i47, n);
              if (0 !== e && !e) throw new Gn.b("model-createPositionAt-offset-required: Model#createPositionAt() requires the offset when the first parameter is a model item.", [this, t]);
            }
            if (!_i47.is("element") && !_i47.is("documentFragment")) throw new Gn.b("model-position-parent-incorrect: Position parent have to be a element or document fragment.", [this, t]);

            var _o29 = _i47.getPath();

            return _o29.push(e), new this(_i47.root, _o29, n);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t, e) {
          if (!t.parent) throw new Gn.b("model-position-after-root: You cannot make a position after root.", [this, t], {
            root: t
          });
          return this._createAt(t.parent, t.endOffset, e);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t, e) {
          if (!t.parent) throw new Gn.b("model-position-before-root: You cannot make a position before root.", t, {
            root: t
          });
          return this._createAt(t.parent, t.startOffset, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if ("$graveyard" === t.root) {
            var _n72 = new $s(e.graveyard, t.path);

            return _n72.stickiness = t.stickiness, _n72;
          }

          if (!e.getRoot(t.root)) throw new Gn.b("model-position-fromjson-no-root: Cannot create position for document. Root with specified name does not exist.", e, {
            rootName: t.root
          });
          return new $s(e.getRoot(t.root), t.path, t.stickiness);
        }
      }]);

      return $s;
    }();

    var Gs = /*#__PURE__*/function (_Symbol$iterator7) {
      function Gs(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        _classCallCheck(this, Gs);

        this.start = $s._createAt(t), this.end = e ? $s._createAt(e) : $s._createAt(t), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }

      _createClass(Gs, [{
        key: _Symbol$iterator7,
        value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
          return _regeneratorRuntime.wrap(function value$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  return _context11.delegateYield(new qs({
                    boundaries: this,
                    ignoreElementEnd: !0
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, value, this);
        })
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return "same" == li(this.start.getParentPath(), this.end.getParentPath());
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          t.isCollapsed && (e = !1);
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start),
              i = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && i;
        }
      }, {
        key: "containsItem",
        value: function containsItem(t) {
          var e = $s._createBefore(t);

          return this.containsPosition(e) || this.start.isEqual(e);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "range" == t || "model:range" == t;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          return this.isIntersecting(t) ? (this.containsPosition(t.start) && e.push(new Gs(this.start, t.start)), this.containsPosition(t.end) && e.push(new Gs(t.end, this.end))) : e.push(new Gs(this.start, this.end)), e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e69 = this.start,
                _n73 = this.end;
            return this.containsPosition(t.start) && (_e69 = t.start), this.containsPosition(t.end) && (_n73 = t.end), new Gs(_e69, _n73);
          }

          return null;
        }
      }, {
        key: "getMinimalFlatRanges",
        value: function getMinimalFlatRanges() {
          var t = [],
              e = this.start.getCommonPath(this.end).length,
              n = $s._createAt(this.start);

          var i = n.parent;

          for (; n.path.length > e + 1;) {
            var _e70 = i.maxOffset - n.offset;

            0 !== _e70 && t.push(new Gs(n, n.getShiftedBy(_e70))), n.path = n.path.slice(0, -1), n.offset++, i = i.parent;
          }

          for (; n.path.length <= this.end.path.length;) {
            var _e71 = this.end.path[n.path.length - 1],
                _i48 = _e71 - n.offset;

            0 !== _i48 && t.push(new Gs(n, n.getShiftedBy(_i48))), n.offset = _e71, n.path.push(0);
          }

          return t;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return t.boundaries = this, new qs(t);
        }
      }, {
        key: "getItems",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getItems() {
          var t,
              e,
              _iterator89,
              _step89,
              _t77,
              _args12 = arguments;

          return _regeneratorRuntime.wrap(function getItems$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  t = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : {};
                  t.boundaries = this, t.ignoreElementEnd = !0;
                  e = new qs(t);
                  _iterator89 = _createForOfIteratorHelper(e);
                  _context12.prev = 4;

                  _iterator89.s();

                case 6:
                  if ((_step89 = _iterator89.n()).done) {
                    _context12.next = 12;
                    break;
                  }

                  _t77 = _step89.value;
                  _context12.next = 10;
                  return _t77.item;

                case 10:
                  _context12.next = 6;
                  break;

                case 12:
                  _context12.next = 17;
                  break;

                case 14:
                  _context12.prev = 14;
                  _context12.t0 = _context12["catch"](4);

                  _iterator89.e(_context12.t0);

                case 17:
                  _context12.prev = 17;

                  _iterator89.f();

                  return _context12.finish(17);

                case 20:
                case "end":
                  return _context12.stop();
              }
            }
          }, getItems, this, [[4, 14, 17, 20]]);
        })
      }, {
        key: "getPositions",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getPositions() {
          var t,
              e,
              _iterator90,
              _step90,
              _t78,
              _args13 = arguments;

          return _regeneratorRuntime.wrap(function getPositions$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  t = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
                  t.boundaries = this;
                  e = new qs(t);
                  _context13.next = 5;
                  return e.position;

                case 5:
                  _iterator90 = _createForOfIteratorHelper(e);
                  _context13.prev = 6;

                  _iterator90.s();

                case 8:
                  if ((_step90 = _iterator90.n()).done) {
                    _context13.next = 14;
                    break;
                  }

                  _t78 = _step90.value;
                  _context13.next = 12;
                  return _t78.nextPosition;

                case 12:
                  _context13.next = 8;
                  break;

                case 14:
                  _context13.next = 19;
                  break;

                case 16:
                  _context13.prev = 16;
                  _context13.t0 = _context13["catch"](6);

                  _iterator90.e(_context13.t0);

                case 19:
                  _context13.prev = 19;

                  _iterator90.f();

                  return _context13.finish(19);

                case 22:
                case "end":
                  return _context13.stop();
              }
            }
          }, getPositions, this, [[6, 16, 19, 22]]);
        })
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          switch (t.type) {
            case "insert":
              return this._getTransformedByInsertOperation(t);

            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(t);

            case "split":
              return [this._getTransformedBySplitOperation(t)];

            case "merge":
              return [this._getTransformedByMergeOperation(t)];
          }

          return [new Gs(this.start, this.end)];
        }
      }, {
        key: "getTransformedByOperations",
        value: function getTransformedByOperations(t) {
          var e = [new Gs(this.start, this.end)];

          var _iterator91 = _createForOfIteratorHelper(t),
              _step91;

          try {
            for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
              var _n75 = _step91.value;

              for (var _t81 = 0; _t81 < e.length; _t81++) {
                var _i50 = e[_t81].getTransformedByOperation(_n75);

                e.splice.apply(e, [_t81, 1].concat(_toConsumableArray(_i50))), _t81 += _i50.length - 1;
              }
            }
          } catch (err) {
            _iterator91.e(err);
          } finally {
            _iterator91.f();
          }

          for (var _t79 = 0; _t79 < e.length; _t79++) {
            var _n74 = e[_t79];

            for (var _i49 = _t79 + 1; _i49 < e.length; _i49++) {
              var _t80 = e[_i49];
              (_n74.containsRange(_t80) || _t80.containsRange(_n74) || _n74.isEqual(_t80)) && e.splice(_i49, 1);
            }
          }

          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.start, this.end);
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return this._getTransformedByInsertion(t.position, t.howMany, e);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = t.sourcePosition,
              i = t.howMany,
              o = t.targetPosition;
          return this._getTransformedByMove(n, o, i, e);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = this.start._getTransformedBySplitOperation(t);

          var n = this.end._getTransformedBySplitOperation(t);

          return this.end.isEqual(t.insertionPosition) && (n = this.end.getShiftedBy(1)), e.root != n.root && (n = this.end.getShiftedBy(-1)), new Gs(e, n);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new Gs(this.start);

          var e = this.start._getTransformedByMergeOperation(t),
              n = this.end._getTransformedByMergeOperation(t);

          return e.root != n.root && (n = this.end.getShiftedBy(-1)), e.isAfter(n) ? (t.sourcePosition.isBefore(t.targetPosition) ? (e = $s._createAt(n)).offset = 0 : (t.deletionPosition.isEqual(e) || (n = t.deletionPosition), e = t.targetPosition), new Gs(e, n)) : new Gs(e, n);
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          if (n && this.containsPosition(t)) return [new Gs(this.start, t), new Gs(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
          {
            var _n76 = new Gs(this.start, this.end);

            return _n76.start = _n76.start._getTransformedByInsertion(t, e), _n76.end = _n76.end._getTransformedByInsertion(t, e), [_n76];
          }
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          if (this.isCollapsed) {
            var _i51 = this.start._getTransformedByMove(t, e, n);

            return [new Gs(_i51)];
          }

          var o = Gs._createFromPositionAndShift(t, n),
              r = e._getTransformedByDeletion(t, n);

          if (this.containsPosition(e) && !i && (o.containsPosition(this.start) || o.containsPosition(this.end))) {
            var _i52 = this.start._getTransformedByMove(t, e, n),
                _o30 = this.end._getTransformedByMove(t, e, n);

            return [new Gs(_i52, _o30)];
          }

          var s;
          var a = this.getDifference(o);
          var c = null;
          var l = this.getIntersection(o);

          if (1 == a.length ? c = new Gs(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n)) : 2 == a.length && (c = new Gs(this.start, this.end._getTransformedByDeletion(t, n))), s = c ? c._getTransformedByInsertion(r, n, null !== l || i) : [], l) {
            var _t82 = new Gs(l.start._getCombined(o.start, r), l.end._getCombined(o.start, r));

            2 == s.length ? s.splice(1, 0, _t82) : s.push(_t82);
          }

          return s;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = this.start._getTransformedByDeletion(t, e),
              i = this.end._getTransformedByDeletion(t, e);

          return null == n && null == i ? null : (null == n && (n = t), null == i && (i = t), new Gs(n, i));
        }
      }], [{
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t,
              i = t.getShiftedBy(e);
          return e > 0 ? new this(n, i) : new this(i, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return new this($s._createAt(t, 0), $s._createAt(t, t.maxOffset));
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          return this._createFromPositionAndShift($s._createBefore(t), t.offsetSize);
        }
      }, {
        key: "_createFromRanges",
        value: function _createFromRanges(t) {
          if (0 === t.length) throw new Gn.b("range-create-from-ranges-empty-array: At least one range has to be passed.", null);
          if (1 == t.length) return t[0].clone();
          var e = t[0];
          t.sort(function (t, e) {
            return t.start.isAfter(e.start) ? 1 : -1;
          });
          var n = t.indexOf(e),
              i = new this(e.start, e.end);
          if (n > 0) for (var _e72 = n - 1; t[_e72].end.isEqual(i.start); _e72++) {
            i.start = $s._createAt(t[_e72].start);
          }

          for (var _e73 = n + 1; _e73 < t.length && t[_e73].start.isEqual(i.end); _e73++) {
            i.end = $s._createAt(t[_e73].end);
          }

          return i;
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new this($s.fromJSON(t.start, e), $s.fromJSON(t.end, e));
        }
      }]);

      return Gs;
    }(Symbol.iterator);

    var Qs = /*#__PURE__*/function () {
      function Qs() {
        var _this41 = this;

        _classCallCheck(this, Qs);

        this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._viewToModelLengthCallbacks = new Map(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set(), this.on("modelToViewPosition", function (t, e) {
          if (e.viewPosition) return;

          var n = _this41._modelToViewMapping.get(e.modelPosition.parent);

          e.viewPosition = _this41._findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        }), this.on("viewToModelPosition", function (t, e) {
          if (e.modelPosition) return;

          var n = _this41.findMappedViewAncestor(e.viewPosition),
              i = _this41._viewToModelMapping.get(n),
              o = _this41._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);

          e.modelPosition = $s._createAt(i, o);
        }, {
          priority: "low"
        });
      }

      _createClass(Qs, [{
        key: "bindElements",
        value: function bindElements(t, e) {
          this._modelToViewMapping.set(t, e), this._viewToModelMapping.set(e, t);
        }
      }, {
        key: "unbindViewElement",
        value: function unbindViewElement(t) {
          var e = this.toModelElement(t);

          if (this._viewToModelMapping.delete(t), this._elementToMarkerNames.has(t)) {
            var _iterator92 = _createForOfIteratorHelper(this._elementToMarkerNames.get(t)),
                _step92;

            try {
              for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
                var _e74 = _step92.value;

                this._unboundMarkerNames.add(_e74);
              }
            } catch (err) {
              _iterator92.e(err);
            } finally {
              _iterator92.f();
            }
          }

          this._modelToViewMapping.get(e) == t && this._modelToViewMapping.delete(e);
        }
      }, {
        key: "unbindModelElement",
        value: function unbindModelElement(t) {
          var e = this.toViewElement(t);
          this._modelToViewMapping.delete(t), this._viewToModelMapping.get(e) == t && this._viewToModelMapping.delete(e);
        }
      }, {
        key: "bindElementToMarker",
        value: function bindElementToMarker(t, e) {
          var n = this._markerNameToElements.get(e) || new Set();
          n.add(t);
          var i = this._elementToMarkerNames.get(t) || new Set();
          i.add(e), this._markerNameToElements.set(e, n), this._elementToMarkerNames.set(t, i);
        }
      }, {
        key: "unbindElementFromMarkerName",
        value: function unbindElementFromMarkerName(t, e) {
          var n = this._markerNameToElements.get(e);

          n && (n.delete(t), 0 == n.size && this._markerNameToElements.delete(e));

          var i = this._elementToMarkerNames.get(t);

          i && (i.delete(e), 0 == i.size && this._elementToMarkerNames.delete(t));
        }
      }, {
        key: "flushUnboundMarkerNames",
        value: function flushUnboundMarkerNames() {
          var t = Array.from(this._unboundMarkerNames);
          return this._unboundMarkerNames.clear(), t;
        }
      }, {
        key: "clearBindings",
        value: function clearBindings() {
          this._modelToViewMapping = new WeakMap(), this._viewToModelMapping = new WeakMap(), this._markerNameToElements = new Map(), this._elementToMarkerNames = new Map(), this._unboundMarkerNames = new Set();
        }
      }, {
        key: "toModelElement",
        value: function toModelElement(t) {
          return this._viewToModelMapping.get(t);
        }
      }, {
        key: "toViewElement",
        value: function toViewElement(t) {
          return this._modelToViewMapping.get(t);
        }
      }, {
        key: "toModelRange",
        value: function toModelRange(t) {
          return new Gs(this.toModelPosition(t.start), this.toModelPosition(t.end));
        }
      }, {
        key: "toViewRange",
        value: function toViewRange(t) {
          return new Xi(this.toViewPosition(t.start), this.toViewPosition(t.end));
        }
      }, {
        key: "toModelPosition",
        value: function toModelPosition(t) {
          var e = {
            viewPosition: t,
            mapper: this
          };
          return this.fire("viewToModelPosition", e), e.modelPosition;
        }
      }, {
        key: "toViewPosition",
        value: function toViewPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            isPhantom: !1
          };
          var n = {
            modelPosition: t,
            mapper: this,
            isPhantom: e.isPhantom
          };
          return this.fire("modelToViewPosition", n), n.viewPosition;
        }
      }, {
        key: "markerNameToElements",
        value: function markerNameToElements(t) {
          var e = this._markerNameToElements.get(t);

          if (!e) return null;
          var n = new Set();

          var _iterator93 = _createForOfIteratorHelper(e),
              _step93;

          try {
            for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
              var _t83 = _step93.value;

              if (_t83.is("attributeElement")) {
                var _iterator94 = _createForOfIteratorHelper(_t83.getElementsWithSameId()),
                    _step94;

                try {
                  for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
                    var _e75 = _step94.value;
                    n.add(_e75);
                  }
                } catch (err) {
                  _iterator94.e(err);
                } finally {
                  _iterator94.f();
                }
              } else n.add(_t83);
            }
          } catch (err) {
            _iterator93.e(err);
          } finally {
            _iterator93.f();
          }

          return n;
        }
      }, {
        key: "registerViewToModelLength",
        value: function registerViewToModelLength(t, e) {
          this._viewToModelLengthCallbacks.set(t, e);
        }
      }, {
        key: "findMappedViewAncestor",
        value: function findMappedViewAncestor(t) {
          var e = t.parent;

          for (; !this._viewToModelMapping.has(e);) {
            e = e.parent;
          }

          return e;
        }
      }, {
        key: "_toModelOffset",
        value: function _toModelOffset(t, e, n) {
          if (n != t) {
            return this._toModelOffset(t.parent, t.index, n) + this._toModelOffset(t, e, t);
          }

          if (t.is("text")) return e;
          var i = 0;

          for (var _n77 = 0; _n77 < e; _n77++) {
            i += this.getModelLength(t.getChild(_n77));
          }

          return i;
        }
      }, {
        key: "getModelLength",
        value: function getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name)) {
            return this._viewToModelLengthCallbacks.get(t.name)(t);
          }

          if (this._viewToModelMapping.has(t)) return 1;
          if (t.is("text")) return t.data.length;
          if (t.is("uiElement")) return 0;
          {
            var _e76 = 0;

            var _iterator95 = _createForOfIteratorHelper(t.getChildren()),
                _step95;

            try {
              for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
                var _n78 = _step95.value;
                _e76 += this.getModelLength(_n78);
              }
            } catch (err) {
              _iterator95.e(err);
            } finally {
              _iterator95.f();
            }

            return _e76;
          }
        }
      }, {
        key: "_findPositionIn",
        value: function _findPositionIn(t, e) {
          var n,
              i = 0,
              o = 0,
              r = 0;
          if (t.is("text")) return new Zi(t, e);

          for (; o < e;) {
            n = t.getChild(r), o += i = this.getModelLength(n), r++;
          }

          return o == e ? this._moveViewPositionToTextNode(new Zi(t, r)) : this._findPositionIn(n, e - (o - i));
        }
      }, {
        key: "_moveViewPositionToTextNode",
        value: function _moveViewPositionToTextNode(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          return e instanceof fi ? new Zi(e, e.data.length) : n instanceof fi ? new Zi(n, 0) : t;
        }
      }]);

      return Qs;
    }();

    ci(Qs, ei);

    var Ks = /*#__PURE__*/function () {
      function Ks() {
        _classCallCheck(this, Ks);

        this._consumable = new Map(), this._textProxyRegistry = new Map();
      }

      _createClass(Ks, [{
        key: "add",
        value: function add(t, e) {
          e = Js(e), t instanceof Fs && (t = this._getSymbolForTextProxy(t)), this._consumable.has(t) || this._consumable.set(t, new Map()), this._consumable.get(t).set(e, !0);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return e = Js(e), t instanceof Fs && (t = this._getSymbolForTextProxy(t)), !!this.test(t, e) && (this._consumable.get(t).set(e, !1), !0);
        }
      }, {
        key: "test",
        value: function test(t, e) {
          e = Js(e), t instanceof Fs && (t = this._getSymbolForTextProxy(t));

          var n = this._consumable.get(t);

          if (void 0 === n) return null;
          var i = n.get(e);
          return void 0 === i ? null : i;
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          e = Js(e), t instanceof Fs && (t = this._getSymbolForTextProxy(t));
          var n = this.test(t, e);
          return !1 === n ? (this._consumable.get(t).set(e, !0), !0) : !0 !== n && null;
        }
      }, {
        key: "_getSymbolForTextProxy",
        value: function _getSymbolForTextProxy(t) {
          var e = null;

          var n = this._textProxyRegistry.get(t.startOffset);

          if (n) {
            var _i53 = n.get(t.endOffset);

            _i53 && (e = _i53.get(t.parent));
          }

          return e || (e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent)), e;
        }
      }, {
        key: "_addSymbolForTextProxy",
        value: function _addSymbolForTextProxy(t, e, n) {
          var i = Symbol("textProxySymbol");
          var o, r;
          return (o = this._textProxyRegistry.get(t)) || (o = new Map(), this._textProxyRegistry.set(t, o)), (r = o.get(e)) || (r = new Map(), o.set(e, r)), r.set(n, i), i;
        }
      }]);

      return Ks;
    }();

    function Js(t) {
      var e = t.split(":");
      return e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }

    var Zs = /*#__PURE__*/function () {
      function Zs(t) {
        _classCallCheck(this, Zs);

        this.conversionApi = Li({
          dispatcher: this
        }, t);
      }

      _createClass(Zs, [{
        key: "convertChanges",
        value: function convertChanges(t, e, n) {
          var _iterator96 = _createForOfIteratorHelper(t.getMarkersToRemove()),
              _step96;

          try {
            for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
              var _e77 = _step96.value;
              this.convertMarkerRemove(_e77.name, _e77.range, n);
            }
          } catch (err) {
            _iterator96.e(err);
          } finally {
            _iterator96.f();
          }

          var _iterator97 = _createForOfIteratorHelper(t.getChanges()),
              _step97;

          try {
            for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
              var _e78 = _step97.value;
              "insert" == _e78.type ? this.convertInsert(Gs._createFromPositionAndShift(_e78.position, _e78.length), n) : "remove" == _e78.type ? this.convertRemove(_e78.position, _e78.length, _e78.name, n) : this.convertAttribute(_e78.range, _e78.attributeKey, _e78.attributeOldValue, _e78.attributeNewValue, n);
            }
          } catch (err) {
            _iterator97.e(err);
          } finally {
            _iterator97.f();
          }

          var _iterator98 = _createForOfIteratorHelper(this.conversionApi.mapper.flushUnboundMarkerNames()),
              _step98;

          try {
            for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
              var _t84 = _step98.value;

              var _i54 = e.get(_t84).getRange();

              this.convertMarkerRemove(_t84, _i54, n), this.convertMarkerAdd(_t84, _i54, n);
            }
          } catch (err) {
            _iterator98.e(err);
          } finally {
            _iterator98.f();
          }

          var _iterator99 = _createForOfIteratorHelper(t.getMarkersToAdd()),
              _step99;

          try {
            for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
              var _e79 = _step99.value;
              this.convertMarkerAdd(_e79.name, _e79.range, n);
            }
          } catch (err) {
            _iterator99.e(err);
          } finally {
            _iterator99.f();
          }
        }
      }, {
        key: "convertInsert",
        value: function convertInsert(t, e) {
          this.conversionApi.writer = e, this.conversionApi.consumable = this._createInsertConsumable(t);

          var _iterator100 = _createForOfIteratorHelper(t),
              _step100;

          try {
            for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
              var _e80 = _step100.value;
              var _t85 = _e80.item,
                  _n79 = {
                item: _t85,
                range: Gs._createFromPositionAndShift(_e80.previousPosition, _e80.length)
              };

              this._testAndFire("insert", _n79);

              var _iterator101 = _createForOfIteratorHelper(_t85.getAttributeKeys()),
                  _step101;

              try {
                for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
                  var _e81 = _step101.value;
                  _n79.attributeKey = _e81, _n79.attributeOldValue = null, _n79.attributeNewValue = _t85.getAttribute(_e81), this._testAndFire("attribute:".concat(_e81), _n79);
                }
              } catch (err) {
                _iterator101.e(err);
              } finally {
                _iterator101.f();
              }
            }
          } catch (err) {
            _iterator100.e(err);
          } finally {
            _iterator100.f();
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertRemove",
        value: function convertRemove(t, e, n, i) {
          this.conversionApi.writer = i, this.fire("remove:" + n, {
            position: t,
            length: e
          }, this.conversionApi), this._clearConversionApi();
        }
      }, {
        key: "convertAttribute",
        value: function convertAttribute(t, e, n, i, o) {
          this.conversionApi.writer = o, this.conversionApi.consumable = this._createConsumableForRange(t, "attribute:".concat(e));

          var _iterator102 = _createForOfIteratorHelper(t),
              _step102;

          try {
            for (_iterator102.s(); !(_step102 = _iterator102.n()).done;) {
              var _o31 = _step102.value;
              var _t86 = {
                item: _o31.item,
                range: Gs._createFromPositionAndShift(_o31.previousPosition, _o31.length),
                attributeKey: e,
                attributeOldValue: n,
                attributeNewValue: i
              };

              this._testAndFire("attribute:".concat(e), _t86);
            }
          } catch (err) {
            _iterator102.e(err);
          } finally {
            _iterator102.f();
          }

          this._clearConversionApi();
        }
      }, {
        key: "convertSelection",
        value: function convertSelection(t, e, n) {
          var i = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));

          if (this.conversionApi.writer = n, this.conversionApi.consumable = this._createSelectionConsumable(t, i), this.fire("selection", {
            selection: t
          }, this.conversionApi), t.isCollapsed) {
            var _iterator103 = _createForOfIteratorHelper(i),
                _step103;

            try {
              for (_iterator103.s(); !(_step103 = _iterator103.n()).done;) {
                var _e82 = _step103.value;

                var _n80 = _e82.getRange();

                if (!Xs(t.getFirstPosition(), _e82, this.conversionApi.mapper)) continue;
                var _i55 = {
                  item: t,
                  markerName: _e82.name,
                  markerRange: _n80
                };
                this.conversionApi.consumable.test(t, "addMarker:" + _e82.name) && this.fire("addMarker:" + _e82.name, _i55, this.conversionApi);
              }
            } catch (err) {
              _iterator103.e(err);
            } finally {
              _iterator103.f();
            }

            var _iterator104 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step104;

            try {
              for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
                var _e83 = _step104.value;
                var _n81 = {
                  item: t,
                  range: t.getFirstRange(),
                  attributeKey: _e83,
                  attributeOldValue: null,
                  attributeNewValue: t.getAttribute(_e83)
                };
                this.conversionApi.consumable.test(t, "attribute:" + _n81.attributeKey) && this.fire("attribute:" + _n81.attributeKey + ":$text", _n81, this.conversionApi);
              }
            } catch (err) {
              _iterator104.e(err);
            } finally {
              _iterator104.f();
            }

            this._clearConversionApi();
          }
        }
      }, {
        key: "convertMarkerAdd",
        value: function convertMarkerAdd(t, e, n) {
          if (!e.root.document || "$graveyard" == e.root.rootName) return;
          this.conversionApi.writer = n;
          var i = "addMarker:" + t,
              o = new Ks();

          if (o.add(e, i), this.conversionApi.consumable = o, this.fire(i, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), o.test(e, i)) {
            this.conversionApi.consumable = this._createConsumableForRange(e, i);

            var _iterator105 = _createForOfIteratorHelper(e.getItems()),
                _step105;

            try {
              for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                var _n82 = _step105.value;
                if (!this.conversionApi.consumable.test(_n82, i)) continue;
                var _o32 = {
                  item: _n82,
                  range: Gs._createOn(_n82),
                  markerName: t,
                  markerRange: e
                };
                this.fire(i, _o32, this.conversionApi);
              }
            } catch (err) {
              _iterator105.e(err);
            } finally {
              _iterator105.f();
            }

            this._clearConversionApi();
          }
        }
      }, {
        key: "convertMarkerRemove",
        value: function convertMarkerRemove(t, e, n) {
          e.root.document && "$graveyard" != e.root.rootName && (this.conversionApi.writer = n, this.fire("removeMarker:" + t, {
            markerName: t,
            markerRange: e
          }, this.conversionApi), this._clearConversionApi());
        }
      }, {
        key: "_createInsertConsumable",
        value: function _createInsertConsumable(t) {
          var e = new Ks();

          var _iterator106 = _createForOfIteratorHelper(t),
              _step106;

          try {
            for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
              var _n83 = _step106.value;
              var _t87 = _n83.item;
              e.add(_t87, "insert");

              var _iterator107 = _createForOfIteratorHelper(_t87.getAttributeKeys()),
                  _step107;

              try {
                for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
                  var _n84 = _step107.value;
                  e.add(_t87, "attribute:" + _n84);
                }
              } catch (err) {
                _iterator107.e(err);
              } finally {
                _iterator107.f();
              }
            }
          } catch (err) {
            _iterator106.e(err);
          } finally {
            _iterator106.f();
          }

          return e;
        }
      }, {
        key: "_createConsumableForRange",
        value: function _createConsumableForRange(t, e) {
          var n = new Ks();

          var _iterator108 = _createForOfIteratorHelper(t.getItems()),
              _step108;

          try {
            for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
              var _i56 = _step108.value;
              n.add(_i56, e);
            }
          } catch (err) {
            _iterator108.e(err);
          } finally {
            _iterator108.f();
          }

          return n;
        }
      }, {
        key: "_createSelectionConsumable",
        value: function _createSelectionConsumable(t, e) {
          var n = new Ks();
          n.add(t, "selection");

          var _iterator109 = _createForOfIteratorHelper(e),
              _step109;

          try {
            for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
              var _i57 = _step109.value;
              n.add(t, "addMarker:" + _i57.name);
            }
          } catch (err) {
            _iterator109.e(err);
          } finally {
            _iterator109.f();
          }

          var _iterator110 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step110;

          try {
            for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
              var _e84 = _step110.value;
              n.add(t, "attribute:" + _e84);
            }
          } catch (err) {
            _iterator110.e(err);
          } finally {
            _iterator110.f();
          }

          return n;
        }
      }, {
        key: "_testAndFire",
        value: function _testAndFire(t, e) {
          if (!this.conversionApi.consumable.test(e.item, t)) return;
          var n = e.item.name || "$text";
          this.fire(t + ":" + n, e, this.conversionApi);
        }
      }, {
        key: "_clearConversionApi",
        value: function _clearConversionApi() {
          delete this.conversionApi.writer, delete this.conversionApi.consumable;
        }
      }]);

      return Zs;
    }();

    function Xs(t, e, n) {
      var i = e.getRange(),
          o = Array.from(t.getAncestors());
      return o.shift(), o.reverse(), !o.some(function (t) {
        if (i.containsItem(t)) {
          return !!n.toViewElement(t).getCustomProperty("addHighlight");
        }
      });
    }

    ci(Zs, ei);

    var ta = /*#__PURE__*/function () {
      function ta(t, e, n) {
        _classCallCheck(this, ta);

        this._lastRangeBackward = !1, this._ranges = [], this._attrs = new Map(), t && this.setTo(t, e, n);
      }

      _createClass(ta, [{
        key: "anchor",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t88 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t88.end : _t88.start;
          }

          return null;
        }
      }, {
        key: "focus",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t89 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t89.start : _t89.end;
          }

          return null;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return 1 === this._ranges.length && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          if (this.rangeCount != t.rangeCount) return !1;
          if (0 === this.rangeCount) return !0;
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return !1;

          var _iterator111 = _createForOfIteratorHelper(this._ranges),
              _step111;

          try {
            for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
              var _e85 = _step111.value;

              var _n85 = !1;

              var _iterator112 = _createForOfIteratorHelper(t._ranges),
                  _step112;

              try {
                for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
                  var _i58 = _step112.value;

                  if (_e85.isEqual(_i58)) {
                    _n85 = !0;
                    break;
                  }
                }
              } catch (err) {
                _iterator112.e(err);
              } finally {
                _iterator112.f();
              }

              if (!_n85) return !1;
            }
          } catch (err) {
            _iterator111.e(err);
          } finally {
            _iterator111.f();
          }

          return !0;
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
          var _iterator113, _step113, _t90;

          return _regeneratorRuntime.wrap(function getRanges$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _iterator113 = _createForOfIteratorHelper(this._ranges);
                  _context14.prev = 1;

                  _iterator113.s();

                case 3:
                  if ((_step113 = _iterator113.n()).done) {
                    _context14.next = 9;
                    break;
                  }

                  _t90 = _step113.value;
                  _context14.next = 7;
                  return new Gs(_t90.start, _t90.end);

                case 7:
                  _context14.next = 3;
                  break;

                case 9:
                  _context14.next = 14;
                  break;

                case 11:
                  _context14.prev = 11;
                  _context14.t0 = _context14["catch"](1);

                  _iterator113.e(_context14.t0);

                case 14:
                  _context14.prev = 14;

                  _iterator113.f();

                  return _context14.finish(14);

                case 17:
                case "end":
                  return _context14.stop();
              }
            }
          }, getRanges, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;

          var _iterator114 = _createForOfIteratorHelper(this._ranges),
              _step114;

          try {
            for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
              var _e86 = _step114.value;
              t && !_e86.start.isBefore(t.start) || (t = _e86);
            }
          } catch (err) {
            _iterator114.e(err);
          } finally {
            _iterator114.f();
          }

          return t ? new Gs(t.start, t.end) : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;

          var _iterator115 = _createForOfIteratorHelper(this._ranges),
              _step115;

          try {
            for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
              var _e87 = _step115.value;
              t && !_e87.end.isAfter(t.end) || (t = _e87);
            }
          } catch (err) {
            _iterator115.e(err);
          } finally {
            _iterator115.f();
          }

          return t ? new Gs(t.start, t.end) : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (null === t) this._setRanges([]);else if (t instanceof ta) this._setRanges(t.getRanges(), t.isBackward);else if (t && "function" == typeof t.getRanges) this._setRanges(t.getRanges(), t.isBackward);else if (t instanceof Gs) this._setRanges([t], !!e && !!e.backward);else if (t instanceof $s) this._setRanges([new Gs(t)]);else if (t instanceof zs) {
            var _i59 = !!n && !!n.backward;

            var _o33;

            if ("in" == e) _o33 = Gs._createIn(t);else if ("on" == e) _o33 = Gs._createOn(t);else {
              if (void 0 === e) throw new Gn.b("model-selection-setTo-required-second-parameter: selection.setTo requires the second parameter when the first parameter is a node.", [this, t]);
              _o33 = new Gs($s._createAt(t, e));
            }

            this._setRanges([_o33], _i59);
          } else {
            if (!pi(t)) throw new Gn.b("model-selection-setTo-not-selectable: Cannot set the selection to the given place.", [this, t]);

            this._setRanges(t, e && !!e.backward);
          }
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var _this42 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          var n = (t = Array.from(t)).some(function (e) {
            if (!(e instanceof Gs)) throw new Gn.b("model-selection-set-ranges-not-range: Selection range set to an object that is not an instance of model.Range.", [_this42, t]);
            return _this42._ranges.every(function (t) {
              return !t.isEqual(e);
            });
          });

          if (t.length !== this._ranges.length || n) {
            this._removeAllRanges();

            var _iterator116 = _createForOfIteratorHelper(t),
                _step116;

            try {
              for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
                var _e88 = _step116.value;

                this._pushRange(_e88);
              }
            } catch (err) {
              _iterator116.e(err);
            } finally {
              _iterator116.f();
            }

            this._lastRangeBackward = !!e, this.fire("change:range", {
              directChange: !0
            });
          }
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (null === this.anchor) throw new Gn.b("model-selection-setFocus-no-ranges: Cannot set selection focus if there are no ranges in selection.", [this, t]);

          var n = $s._createAt(t, e);

          if ("same" == n.compareWith(this.focus)) return;
          var i = this.anchor;
          this._ranges.length && this._popRange(), "before" == n.compareWith(i) ? (this._pushRange(new Gs(n, i)), this._lastRangeBackward = !0) : (this._pushRange(new Gs(i, n)), this._lastRangeBackward = !1), this.fire("change:range", {
            directChange: !0
          });
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          this.hasAttribute(t) && (this._attrs.delete(t), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          this.getAttribute(t) !== e && (this._attrs.set(t, e), this.fire("change:attribute", {
            attributeKeys: [t],
            directChange: !0
          }));
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (1 !== this.rangeCount) return null;
          var t = this.getFirstRange(),
              e = t.start.nodeAfter,
              n = t.end.nodeBefore;
          return e instanceof Hs && e == n ? e : null;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "model:selection" == t;
        }
      }, {
        key: "getSelectedBlocks",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getSelectedBlocks() {
          var t, _iterator117, _step117, _e89, _n86, _iterator118, _step118, _n87, _i60;

          return _regeneratorRuntime.wrap(function getSelectedBlocks$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  t = new WeakSet();
                  _iterator117 = _createForOfIteratorHelper(this.getRanges());
                  _context15.prev = 2;

                  _iterator117.s();

                case 4:
                  if ((_step117 = _iterator117.n()).done) {
                    _context15.next = 37;
                    break;
                  }

                  _e89 = _step117.value;
                  _n86 = na(_e89.start, t);
                  _context15.t0 = _n86;

                  if (!_context15.t0) {
                    _context15.next = 11;
                    break;
                  }

                  _context15.next = 11;
                  return _n86;

                case 11:
                  _iterator118 = _createForOfIteratorHelper(_e89.getWalker());
                  _context15.prev = 12;

                  _iterator118.s();

                case 14:
                  if ((_step118 = _iterator118.n()).done) {
                    _context15.next = 22;
                    break;
                  }

                  _n87 = _step118.value;
                  _context15.t1 = "elementEnd" == _n87.type && ea(_n87.item, t);

                  if (!_context15.t1) {
                    _context15.next = 20;
                    break;
                  }

                  _context15.next = 20;
                  return _n87.item;

                case 20:
                  _context15.next = 14;
                  break;

                case 22:
                  _context15.next = 27;
                  break;

                case 24:
                  _context15.prev = 24;
                  _context15.t2 = _context15["catch"](12);

                  _iterator118.e(_context15.t2);

                case 27:
                  _context15.prev = 27;

                  _iterator118.f();

                  return _context15.finish(27);

                case 30:
                  _i60 = na(_e89.end, t);
                  _context15.t3 = _i60 && !_e89.end.isTouching($s._createAt(_i60, 0));

                  if (!_context15.t3) {
                    _context15.next = 35;
                    break;
                  }

                  _context15.next = 35;
                  return _i60;

                case 35:
                  _context15.next = 4;
                  break;

                case 37:
                  _context15.next = 42;
                  break;

                case 39:
                  _context15.prev = 39;
                  _context15.t4 = _context15["catch"](2);

                  _iterator117.e(_context15.t4);

                case 42:
                  _context15.prev = 42;

                  _iterator117.f();

                  return _context15.finish(42);

                case 45:
                case "end":
                  return _context15.stop();
              }
            }
          }, getSelectedBlocks, this, [[2, 39, 42, 45], [12, 24, 27, 30]]);
        })
      }, {
        key: "getTopMostBlocks",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getTopMostBlocks() {
          var t, _i61, _t91, _e90, _n88;

          return _regeneratorRuntime.wrap(function getTopMostBlocks$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  t = Array.from(this.getSelectedBlocks());
                  _i61 = 0, _t91 = t;

                case 2:
                  if (!(_i61 < _t91.length)) {
                    _context16.next = 12;
                    break;
                  }

                  _e90 = _t91[_i61];
                  _n88 = ia(_e90);
                  _context16.t0 = _n88 && t.includes(_n88);

                  if (_context16.t0) {
                    _context16.next = 9;
                    break;
                  }

                  _context16.next = 9;
                  return _e90;

                case 9:
                  _i61++;
                  _context16.next = 2;
                  break;

                case 12:
                case "end":
                  return _context16.stop();
              }
            }
          }, getTopMostBlocks, this);
        })
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;

          var e = $s._createAt(t, 0),
              n = $s._createAt(t, "end");

          return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          this._checkRange(t), this._ranges.push(new Gs(t.start, t.end));
        }
      }, {
        key: "_checkRange",
        value: function _checkRange(t) {
          for (var _e91 = 0; _e91 < this._ranges.length; _e91++) {
            if (t.isIntersecting(this._ranges[_e91])) throw new Gn.b("model-selection-range-intersects: Trying to add a range that intersects with another range in the selection.", [this, t], {
              addedRange: t,
              intersectingRange: this._ranges[_e91]
            });
          }
        }
      }, {
        key: "_removeAllRanges",
        value: function _removeAllRanges() {
          for (; this._ranges.length > 0;) {
            this._popRange();
          }
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop();
        }
      }]);

      return ta;
    }();

    function ea(t, e) {
      return !e.has(t) && (e.add(t), t.document.model.schema.isBlock(t) && t.parent);
    }

    function na(t, e) {
      var n = t.parent.document.model.schema,
          i = t.parent.getAncestors({
        parentFirst: !0,
        includeSelf: !0
      });
      var o = !1;
      var r = i.find(function (t) {
        return !o && !(o = n.isLimit(t)) && ea(t, e);
      });
      return i.forEach(function (t) {
        return e.add(t);
      }), r;
    }

    function ia(t) {
      var e = t.document.model.schema;
      var n = t.parent;

      for (; n;) {
        if (e.isBlock(n)) return n;
        n = n.parent;
      }
    }

    ci(ta, ei);

    var oa = /*#__PURE__*/function (_Gs) {
      _inherits(oa, _Gs);

      var _super20 = _createSuper(oa);

      function oa(t, e) {
        var _this43;

        _classCallCheck(this, oa);

        _this43 = _super20.call(this, t, e), function () {
          var _this44 = this;

          this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && function (t) {
              var e = this.getTransformedByOperation(t),
                  n = Gs._createFromRanges(e),
                  i = !n.isEqual(this),
                  o = function (t, e) {
                switch (e.type) {
                  case "insert":
                    return t.containsPosition(e.position);

                  case "move":
                  case "remove":
                  case "reinsert":
                  case "merge":
                    return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);

                  case "split":
                    return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
                }

                return !1;
              }(this, t);

              var r = null;

              if (i) {
                "$graveyard" == n.root.rootName && (r = "remove" == t.type ? t.sourcePosition : t.deletionPosition);

                var _e92 = this.toRange();

                this.start = n.start, this.end = n.end, this.fire("change:range", _e92, {
                  deletionPosition: r
                });
              } else o && this.fire("change:content", this.toRange(), {
                deletionPosition: r
              });
            }.call(_this44, n);
          }, {
            priority: "low"
          });
        }.call(_assertThisInitialized(_this43));
        return _this43;
      }

      _createClass(oa, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "liveRange" == t || "model:liveRange" == t || _get(_getPrototypeOf(oa.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toRange",
        value: function toRange() {
          return new Gs(this.start, this.end);
        }
      }], [{
        key: "fromRange",
        value: function fromRange(t) {
          return new oa(t.start, t.end);
        }
      }]);

      return oa;
    }(Gs);

    ci(oa, ei);
    var ra = "selection:";

    var sa = /*#__PURE__*/function () {
      function sa(t) {
        _classCallCheck(this, sa);

        this._selection = new aa(t), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this);
      }

      _createClass(sa, [{
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._selection.hasOwnRange;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return this._selection.isGravityOverridden;
        }
      }, {
        key: "markers",
        get: function get() {
          return this._selection.markers;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }, {
        key: "getRanges",
        value: function getRanges() {
          return this._selection.getRanges();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getSelectedBlocks",
        value: function getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
      }, {
        key: "getTopMostBlocks",
        value: function getTopMostBlocks() {
          return this._selection.getTopMostBlocks();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent(t) {
          return this._selection.containsEntireContent(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._selection.destroy();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._selection.getAttributes();
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._selection.getAttribute(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._selection.hasAttribute(t);
        }
      }, {
        key: "refresh",
        value: function refresh() {
          this._selection._updateMarkers(), this._selection._updateAttributes(!1);
        }
      }, {
        key: "is",
        value: function is(t) {
          return "selection" == t || "model:selection" == t || "documentSelection" == t || "model:documentSelection" == t;
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._selection.setAttribute(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          this._selection.removeAttribute(t);
        }
      }, {
        key: "_getStoredAttributes",
        value: function _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          return this._selection.overrideGravity();
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity(t) {
          this._selection.restoreGravity(t);
        }
      }], [{
        key: "_getStoreAttributeKey",
        value: function _getStoreAttributeKey(t) {
          return ra + t;
        }
      }, {
        key: "_isStoreAttributeKey",
        value: function _isStoreAttributeKey(t) {
          return t.startsWith(ra);
        }
      }]);

      return sa;
    }();

    ci(sa, ei);

    var aa = /*#__PURE__*/function (_ta) {
      _inherits(aa, _ta);

      var _super21 = _createSuper(aa);

      function aa(t) {
        var _this45;

        _classCallCheck(this, aa);

        _this45 = _super21.call(this), _this45.markers = new oo({
          idProperty: "name"
        }), _this45._model = t.model, _this45._document = t, _this45._attributePriority = new Map(), _this45._fixGraveyardRangesData = [], _this45._hasChangedRange = !1, _this45._overriddenGravityRegister = new Set(), _this45.listenTo(_this45._model, "applyOperation", function (t, e) {
          var n = e[0];

          if (n.isDocumentOperation && "marker" != n.type && "rename" != n.type && "noop" != n.type) {
            for (; _this45._fixGraveyardRangesData.length;) {
              var _this45$_fixGraveyard = _this45._fixGraveyardRangesData.shift(),
                  _t92 = _this45$_fixGraveyard.liveRange,
                  _e93 = _this45$_fixGraveyard.sourcePosition;

              _this45._fixGraveyardSelection(_t92, _e93);
            }

            _this45._hasChangedRange && (_this45._hasChangedRange = !1, _this45.fire("change:range", {
              directChange: !1
            }));
          }
        }, {
          priority: "lowest"
        }), _this45.on("change:range", function () {
          var _iterator119 = _createForOfIteratorHelper(_this45.getRanges()),
              _step119;

          try {
            for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
              var _t93 = _step119.value;
              if (!_this45._document._validateSelectionRange(_t93)) throw new Gn.b("document-selection-wrong-position: Range from document selection starts or ends at incorrect position.", _assertThisInitialized(_this45), {
                range: _t93
              });
            }
          } catch (err) {
            _iterator119.e(err);
          } finally {
            _iterator119.f();
          }
        }), _this45.listenTo(_this45._model.markers, "update", function () {
          return _this45._updateMarkers();
        }), _this45.listenTo(_this45._document, "change", function (t, e) {
          !function (t, e) {
            var n = t.document.differ;

            var _iterator120 = _createForOfIteratorHelper(n.getChanges()),
                _step120;

            try {
              var _loop2 = function _loop2() {
                var i = _step120.value;
                if ("insert" != i.type) return "continue";
                var n = i.position.parent,
                    o = i.length === n.maxOffset;
                o && t.enqueueChange(e, function (t) {
                  var e = Array.from(n.getAttributeKeys()).filter(function (t) {
                    return t.startsWith(ra);
                  });

                  var _iterator121 = _createForOfIteratorHelper(e),
                      _step121;

                  try {
                    for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
                      var _i62 = _step121.value;
                      t.removeAttribute(_i62, n);
                    }
                  } catch (err) {
                    _iterator121.e(err);
                  } finally {
                    _iterator121.f();
                  }
                });
              };

              for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
                var _ret = _loop2();

                if (_ret === "continue") continue;
              }
            } catch (err) {
              _iterator120.e(err);
            } finally {
              _iterator120.f();
            }
          }(_this45._model, e);
        });
        return _this45;
      }

      _createClass(aa, [{
        key: "isCollapsed",
        get: function get() {
          return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(aa.prototype), "isCollapsed", this);
        }
      }, {
        key: "anchor",
        get: function get() {
          return _get(_getPrototypeOf(aa.prototype), "anchor", this) || this._document._getDefaultRange().start;
        }
      }, {
        key: "focus",
        get: function get() {
          return _get(_getPrototypeOf(aa.prototype), "focus", this) || this._document._getDefaultRange().end;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length ? this._ranges.length : 1;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._ranges.length > 0;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return !!this._overriddenGravityRegister.size;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          for (var _t94 = 0; _t94 < this._ranges.length; _t94++) {
            this._ranges[_t94].detach();
          }

          this.stopListening();
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getRanges() {
          return _regeneratorRuntime.wrap(function getRanges$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  if (!this._ranges.length) {
                    _context17.next = 4;
                    break;
                  }

                  return _context17.delegateYield(_get(_getPrototypeOf(aa.prototype), "getRanges", this).call(this), "t0", 2);

                case 2:
                  _context17.next = 6;
                  break;

                case 4:
                  _context17.next = 6;
                  return this._document._getDefaultRange();

                case 6:
                case "end":
                  return _context17.stop();
              }
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return _get(_getPrototypeOf(aa.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return _get(_getPrototypeOf(aa.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          _get(_getPrototypeOf(aa.prototype), "setTo", this).call(this, t, e, n), this._updateAttributes(!0);
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          _get(_getPrototypeOf(aa.prototype), "setFocus", this).call(this, t, e), this._updateAttributes(!0);
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          if (this._setAttribute(t, e)) {
            var _e94 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e94,
              directChange: !0
            });
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          if (this._removeAttribute(t)) {
            var _e95 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e95,
              directChange: !0
            });
          }
        }
      }, {
        key: "overrideGravity",
        value: function overrideGravity() {
          var t = Jn();
          return this._overriddenGravityRegister.add(t), 1 === this._overriddenGravityRegister.size && this._updateAttributes(!0), t;
        }
      }, {
        key: "restoreGravity",
        value: function restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t)) throw new Gn.b("document-selection-gravity-wrong-restore: Attempting to restore the selection gravity for an unknown UID.", this, {
            uid: t
          });
          this._overriddenGravityRegister.delete(t), this.isGravityOverridden || this._updateAttributes(!0);
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop().detach();
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var e = this._prepareRange(t);

          e && this._ranges.push(e);
        }
      }, {
        key: "_prepareRange",
        value: function _prepareRange(t) {
          var _this46 = this;

          if (this._checkRange(t), t.root == this._document.graveyard) return;
          var e = oa.fromRange(t);
          return e.on("change:range", function (t, n, i) {
            _this46._hasChangedRange = !0, e.root == _this46._document.graveyard && _this46._fixGraveyardRangesData.push({
              liveRange: e,
              sourcePosition: i.deletionPosition
            });
          }), e;
        }
      }, {
        key: "_updateMarkers",
        value: function _updateMarkers() {
          var t = [];

          var _iterator122 = _createForOfIteratorHelper(this._model.markers),
              _step122;

          try {
            for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
              var _e98 = _step122.value;

              var _n89 = _e98.getRange();

              var _iterator123 = _createForOfIteratorHelper(this.getRanges()),
                  _step123;

              try {
                for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
                  var _i65 = _step123.value;
                  _n89.containsRange(_i65, !_i65.isCollapsed) && t.push(_e98);
                }
              } catch (err) {
                _iterator123.e(err);
              } finally {
                _iterator123.f();
              }
            }
          } catch (err) {
            _iterator122.e(err);
          } finally {
            _iterator122.f();
          }

          for (var _i63 = 0, _t95 = t; _i63 < _t95.length; _i63++) {
            var _e96 = _t95[_i63];
            this.markers.has(_e96) || this.markers.add(_e96);
          }

          for (var _i64 = 0, _Array$from3 = Array.from(this.markers); _i64 < _Array$from3.length; _i64++) {
            var _e97 = _Array$from3[_i64];
            t.includes(_e97) || this.markers.remove(_e97);
          }
        }
      }, {
        key: "_updateAttributes",
        value: function _updateAttributes(t) {
          var e = Vs(this._getSurroundingAttributes()),
              n = Vs(this.getAttributes());
          if (t) this._attributePriority = new Map(), this._attrs = new Map();else {
            var _iterator124 = _createForOfIteratorHelper(this._attributePriority),
                _step124;

            try {
              for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
                var _ref25 = _step124.value;

                var _ref24 = _slicedToArray(_ref25, 2);

                var _t96 = _ref24[0];
                var _e99 = _ref24[1];
                "low" == _e99 && (this._attrs.delete(_t96), this._attributePriority.delete(_t96));
              }
            } catch (err) {
              _iterator124.e(err);
            } finally {
              _iterator124.f();
            }
          }

          this._setAttributesTo(e);

          var i = [];

          var _iterator125 = _createForOfIteratorHelper(this.getAttributes()),
              _step125;

          try {
            for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
              var _ref30 = _step125.value;

              var _ref27 = _slicedToArray(_ref30, 2);

              var _t97 = _ref27[0];
              var _e100 = _ref27[1];
              n.has(_t97) && n.get(_t97) === _e100 || i.push(_t97);
            }
          } catch (err) {
            _iterator125.e(err);
          } finally {
            _iterator125.f();
          }

          var _iterator126 = _createForOfIteratorHelper(n),
              _step126;

          try {
            for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
              var _ref31 = _step126.value;

              var _ref29 = _slicedToArray(_ref31, 1);

              var _t98 = _ref29[0];
              this.hasAttribute(_t98) || i.push(_t98);
            }
          } catch (err) {
            _iterator126.e(err);
          } finally {
            _iterator126.f();
          }

          i.length > 0 && this.fire("change:attribute", {
            attributeKeys: i,
            directChange: !1
          });
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
          var i = n ? "normal" : "low";
          return ("low" != i || "normal" != this._attributePriority.get(t)) && _get(_getPrototypeOf(aa.prototype), "getAttribute", this).call(this, t) !== e && (this._attrs.set(t, e), this._attributePriority.set(t, i), !0);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
          var n = e ? "normal" : "low";
          return ("low" != n || "normal" != this._attributePriority.get(t)) && (this._attributePriority.set(t, n), !!_get(_getPrototypeOf(aa.prototype), "hasAttribute", this).call(this, t) && (this._attrs.delete(t), !0));
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          var e = new Set();

          var _iterator127 = _createForOfIteratorHelper(this.getAttributes()),
              _step127;

          try {
            for (_iterator127.s(); !(_step127 = _iterator127.n()).done;) {
              var _ref36 = _step127.value;

              var _ref33 = _slicedToArray(_ref36, 2);

              var _e101 = _ref33[0];
              var _n90 = _ref33[1];
              t.get(_e101) !== _n90 && this._removeAttribute(_e101, !1);
            }
          } catch (err) {
            _iterator127.e(err);
          } finally {
            _iterator127.f();
          }

          var _iterator128 = _createForOfIteratorHelper(t),
              _step128;

          try {
            for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
              var _ref37 = _step128.value;

              var _ref35 = _slicedToArray(_ref37, 2);

              var _n91 = _ref35[0];
              var _i66 = _ref35[1];
              this._setAttribute(_n91, _i66, !1) && e.add(_n91);
            }
          } catch (err) {
            _iterator128.e(err);
          } finally {
            _iterator128.f();
          }

          return e;
        }
      }, {
        key: "_getStoredAttributes",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function _getStoredAttributes() {
          var t, _iterator129, _step129, _e102;

          return _regeneratorRuntime.wrap(function _getStoredAttributes$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  t = this.getFirstPosition().parent;

                  if (!(this.isCollapsed && t.isEmpty)) {
                    _context18.next = 20;
                    break;
                  }

                  _iterator129 = _createForOfIteratorHelper(t.getAttributeKeys());
                  _context18.prev = 3;

                  _iterator129.s();

                case 5:
                  if ((_step129 = _iterator129.n()).done) {
                    _context18.next = 12;
                    break;
                  }

                  _e102 = _step129.value;

                  if (!_e102.startsWith(ra)) {
                    _context18.next = 10;
                    break;
                  }

                  _context18.next = 10;
                  return [_e102.substr(ra.length), t.getAttribute(_e102)];

                case 10:
                  _context18.next = 5;
                  break;

                case 12:
                  _context18.next = 17;
                  break;

                case 14:
                  _context18.prev = 14;
                  _context18.t0 = _context18["catch"](3);

                  _iterator129.e(_context18.t0);

                case 17:
                  _context18.prev = 17;

                  _iterator129.f();

                  return _context18.finish(17);

                case 20:
                case "end":
                  return _context18.stop();
              }
            }
          }, _getStoredAttributes, this, [[3, 14, 17, 20]]);
        })
      }, {
        key: "_getSurroundingAttributes",
        value: function _getSurroundingAttributes() {
          var t = this.getFirstPosition(),
              e = this._model.schema;
          var n = null;

          if (this.isCollapsed) {
            var _e103 = t.textNode ? t.textNode : t.nodeBefore,
                _i67 = t.textNode ? t.textNode : t.nodeAfter;

            if (this.isGravityOverridden || (n = ca(_e103)), n || (n = ca(_i67)), !this.isGravityOverridden && !n) {
              var _t99 = _e103;

              for (; _t99 && !n;) {
                n = ca(_t99 = _t99.previousSibling);
              }
            }

            if (!n) {
              var _t100 = _i67;

              for (; _t100 && !n;) {
                n = ca(_t100 = _t100.nextSibling);
              }
            }

            n || (n = this._getStoredAttributes());
          } else {
            var _t101 = this.getFirstRange();

            var _iterator130 = _createForOfIteratorHelper(_t101),
                _step130;

            try {
              for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
                var _i68 = _step130.value;
                if (_i68.item.is("element") && e.isObject(_i68.item)) break;

                if ("text" == _i68.type) {
                  n = _i68.item.getAttributes();
                  break;
                }
              }
            } catch (err) {
              _iterator130.e(err);
            } finally {
              _iterator130.f();
            }
          }

          return n;
        }
      }, {
        key: "_fixGraveyardSelection",
        value: function _fixGraveyardSelection(t, e) {
          var n = e.clone(),
              i = this._model.schema.getNearestSelectionRange(n),
              o = this._ranges.indexOf(t);

          if (this._ranges.splice(o, 1), t.detach(), i) {
            var _t102 = this._prepareRange(i);

            this._ranges.splice(o, 0, _t102);
          }
        }
      }]);

      return aa;
    }(ta);

    function ca(t) {
      return t instanceof Fs || t instanceof Bs ? t.getAttributes() : null;
    }

    var la = /*#__PURE__*/function () {
      function la(t) {
        _classCallCheck(this, la);

        this._dispatchers = t;
      }

      _createClass(la, [{
        key: "add",
        value: function add(t) {
          var _iterator131 = _createForOfIteratorHelper(this._dispatchers),
              _step131;

          try {
            for (_iterator131.s(); !(_step131 = _iterator131.n()).done;) {
              var _e104 = _step131.value;
              t(_e104);
            }
          } catch (err) {
            _iterator131.e(err);
          } finally {
            _iterator131.f();
          }

          return this;
        }
      }]);

      return la;
    }();

    var da = 1,
        ha = 4;

    var ua = function ua(t) {
      return Fn(t, da | ha);
    };

    var fa = /*#__PURE__*/function (_la) {
      _inherits(fa, _la);

      var _super22 = _createSuper(fa);

      function fa() {
        _classCallCheck(this, fa);

        return _super22.apply(this, arguments);
      }

      _createClass(fa, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(function (t) {
            return (t = ua(t)).view = ga(t.view, "container"), function (e) {
              e.on("insert:" + t.model, function (t) {
                return function (e, n, i) {
                  var o = t(n.item, i.writer);
                  if (!o) return;
                  if (!i.consumable.consume(n.item, "insert")) return;
                  var r = i.mapper.toViewPosition(n.range.start);
                  i.mapper.bindElements(n.item, o), i.writer.insert(r, o);
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          return this.add(function (t) {
            var e = "attribute:" + ((t = ua(t)).model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);

            if (t.model.values) {
              var _iterator132 = _createForOfIteratorHelper(t.model.values),
                  _step132;

              try {
                for (_iterator132.s(); !(_step132 = _iterator132.n()).done;) {
                  var _e105 = _step132.value;
                  t.view[_e105] = ga(t.view[_e105], "attribute");
                }
              } catch (err) {
                _iterator132.e(err);
              } finally {
                _iterator132.f();
              }
            } else t.view = ga(t.view, "attribute");

            var n = pa(t);
            return function (i) {
              i.on(e, function (t) {
                return function (e, n, i) {
                  var o = t(n.attributeOldValue, i.writer),
                      r = t(n.attributeNewValue, i.writer);
                  if (!o && !r) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var s = i.writer,
                      a = s.document.selection;
                  if (n.item instanceof ta || n.item instanceof sa) s.wrap(a.getFirstRange(), r);else {
                    var _t103 = i.mapper.toViewRange(n.range);

                    null !== n.attributeOldValue && o && (_t103 = s.unwrap(_t103, o)), null !== n.attributeNewValue && r && s.wrap(_t103, r);
                  }
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            var e = "attribute:" + ((t = ua(t)).model.key ? t.model.key : t.model);
            t.model.name && (e += ":" + t.model.name);

            if (t.model.values) {
              var _iterator133 = _createForOfIteratorHelper(t.model.values),
                  _step133;

              try {
                for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
                  var _e106 = _step133.value;
                  t.view[_e106] = ba(t.view[_e106]);
                }
              } catch (err) {
                _iterator133.e(err);
              } finally {
                _iterator133.f();
              }
            } else t.view = ba(t.view);

            var n = pa(t);
            return function (i) {
              i.on(e, function (t) {
                return function (e, n, i) {
                  var o = t(n.attributeOldValue, n),
                      r = t(n.attributeNewValue, n);
                  if (!o && !r) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var s = i.mapper.toViewElement(n.item),
                      a = i.writer;
                  if (!s) throw new Gn.b("conversion-attribute-to-attribute-on-text: Trying to convert text node's attribute with attribute-to-attribute converter.", [n, i]);
                  if (null !== n.attributeOldValue && o) if ("class" == o.key) {
                    var _t104 = Array.isArray(o.value) ? o.value : [o.value];

                    var _iterator134 = _createForOfIteratorHelper(_t104),
                        _step134;

                    try {
                      for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
                        var _e107 = _step134.value;
                        a.removeClass(_e107, s);
                      }
                    } catch (err) {
                      _iterator134.e(err);
                    } finally {
                      _iterator134.f();
                    }
                  } else if ("style" == o.key) {
                    var _t105 = Object.keys(o.value);

                    for (var _i69 = 0, _t106 = _t105; _i69 < _t106.length; _i69++) {
                      var _e108 = _t106[_i69];
                      a.removeStyle(_e108, s);
                    }
                  } else a.removeAttribute(o.key, s);
                  if (null !== n.attributeNewValue && r) if ("class" == r.key) {
                    var _t107 = Array.isArray(r.value) ? r.value : [r.value];

                    var _iterator135 = _createForOfIteratorHelper(_t107),
                        _step135;

                    try {
                      for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
                        var _e109 = _step135.value;
                        a.addClass(_e109, s);
                      }
                    } catch (err) {
                      _iterator135.e(err);
                    } finally {
                      _iterator135.f();
                    }
                  } else if ("style" == r.key) {
                    var _t108 = Object.keys(r.value);

                    for (var _i70 = 0, _t109 = _t108; _i70 < _t109.length; _i70++) {
                      var _e110 = _t109[_i70];
                      a.setStyle(_e110, r.value[_e110], s);
                    }
                  } else a.setAttribute(r.key, r.value, s);
                };
              }(n), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToElement",
        value: function markerToElement(t) {
          return this.add(function (t) {
            return (t = ua(t)).view = ga(t.view, "ui"), function (e) {
              e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  n.isOpening = !0;
                  var o = t(n, i.writer);
                  n.isOpening = !1;
                  var r = t(n, i.writer);
                  if (!o || !r) return;
                  var s = n.markerRange;
                  if (s.isCollapsed && !i.consumable.consume(s, e.name)) return;

                  var _iterator136 = _createForOfIteratorHelper(s),
                      _step136;

                  try {
                    for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
                      var _t110 = _step136.value;
                      if (!i.consumable.consume(_t110.item, e.name)) return;
                    }
                  } catch (err) {
                    _iterator136.e(err);
                  } finally {
                    _iterator136.f();
                  }

                  var a = i.mapper,
                      c = i.writer;
                  c.insert(a.toViewPosition(s.start), o), i.mapper.bindElementToMarker(o, n.markerName), s.isCollapsed || (c.insert(a.toViewPosition(s.end), r), i.mapper.bindElementToMarker(r, n.markerName)), e.stop();
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, (t.view, function (t, e, n) {
                var i = n.mapper.markerNameToElements(e.markerName);

                if (i) {
                  var _iterator137 = _createForOfIteratorHelper(i),
                      _step137;

                  try {
                    for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
                      var _t111 = _step137.value;
                      n.mapper.unbindElementFromMarkerName(_t111, e.markerName), n.writer.clear(n.writer.createRangeOn(_t111), _t111);
                    }
                  } catch (err) {
                    _iterator137.e(err);
                  } finally {
                    _iterator137.f();
                  }

                  n.writer.clearClonedElementsGroup(e.markerName), t.stop();
                }
              }), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }, {
        key: "markerToHighlight",
        value: function markerToHighlight(t) {
          return this.add(function (t) {
            return function (e) {
              e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (!n.item) return;
                  if (!(n.item instanceof ta || n.item instanceof sa || n.item.is("textProxy"))) return;
                  var o = wa(t, n, i);
                  if (!o) return;
                  if (!i.consumable.consume(n.item, e.name)) return;
                  var r = ma(o),
                      s = i.writer,
                      a = s.document.selection;
                  if (n.item instanceof ta || n.item instanceof sa) s.wrap(a.getFirstRange(), r, a);else {
                    var _t112 = i.mapper.toViewRange(n.range),
                        _e111 = s.wrap(_t112, r);

                    var _iterator138 = _createForOfIteratorHelper(_e111.getItems()),
                        _step138;

                    try {
                      for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
                        var _t113 = _step138.value;

                        if (_t113.is("attributeElement") && _t113.isSimilar(r)) {
                          i.mapper.bindElementToMarker(_t113, n.markerName);
                          break;
                        }
                      }
                    } catch (err) {
                      _iterator138.e(err);
                    } finally {
                      _iterator138.f();
                    }
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("addMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (!n.item) return;
                  if (!(n.item instanceof Hs)) return;
                  var o = wa(t, n, i);
                  if (!o) return;
                  if (!i.consumable.test(n.item, e.name)) return;
                  var r = i.mapper.toViewElement(n.item);

                  if (r && r.getCustomProperty("addHighlight")) {
                    i.consumable.consume(n.item, e.name);

                    var _iterator139 = _createForOfIteratorHelper(Gs._createIn(n.item)),
                        _step139;

                    try {
                      for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
                        var _t114 = _step139.value;
                        i.consumable.consume(_t114.item, e.name);
                      }
                    } catch (err) {
                      _iterator139.e(err);
                    } finally {
                      _iterator139.f();
                    }

                    r.getCustomProperty("addHighlight")(r, o, i.writer), i.mapper.bindElementToMarker(r, n.markerName);
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              }), e.on("removeMarker:" + t.model, function (t) {
                return function (e, n, i) {
                  if (n.markerRange.isCollapsed) return;
                  var o = wa(t, n, i);
                  if (!o) return;
                  var r = ma(o),
                      s = i.mapper.markerNameToElements(n.markerName);

                  if (s) {
                    var _iterator140 = _createForOfIteratorHelper(s),
                        _step140;

                    try {
                      for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
                        var _t115 = _step140.value;
                        i.mapper.unbindElementFromMarkerName(_t115, n.markerName), _t115.is("attributeElement") ? i.writer.unwrap(i.writer.createRangeOn(_t115), r) : _t115.getCustomProperty("removeHighlight")(_t115, o.id, i.writer);
                      }
                    } catch (err) {
                      _iterator140.e(err);
                    } finally {
                      _iterator140.f();
                    }

                    i.writer.clearClonedElementsGroup(n.markerName), e.stop();
                  }
                };
              }(t.view), {
                priority: t.converterPriority || "normal"
              });
            };
          }(t));
        }
      }]);

      return fa;
    }(la);

    function ma(t) {
      var e = new ao("span", t.attributes);
      return t.classes && e._addClass(t.classes), t.priority && (e._priority = t.priority), e._id = t.id, e;
    }

    function ga(t, e) {
      return "function" == typeof t ? t : function (n, i) {
        return function (t, e, n) {
          "string" == typeof t && (t = {
            name: t
          });
          var i;
          var o = Object.assign({}, t.attributes);
          if ("container" == n) i = e.createContainerElement(t.name, o);else if ("attribute" == n) {
            var _n92 = {
              priority: t.priority || ao.DEFAULT_PRIORITY
            };
            i = e.createAttributeElement(t.name, o, _n92);
          } else i = e.createUIElement(t.name, o);

          if (t.styles) {
            var _n93 = Object.keys(t.styles);

            for (var _i71 = 0, _n94 = _n93; _i71 < _n94.length; _i71++) {
              var _o34 = _n94[_i71];
              e.setStyle(_o34, t.styles[_o34], i);
            }
          }

          if (t.classes) {
            var _n95 = t.classes;
            if ("string" == typeof _n95) e.addClass(_n95, i);else {
              var _iterator141 = _createForOfIteratorHelper(_n95),
                  _step141;

              try {
                for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
                  var _t116 = _step141.value;
                  e.addClass(_t116, i);
                }
              } catch (err) {
                _iterator141.e(err);
              } finally {
                _iterator141.f();
              }
            }
          }

          return i;
        }(t, i, e);
      };
    }

    function pa(t) {
      return t.model.values ? function (e, n) {
        var i = t.view[e];
        return i ? i(e, n) : null;
      } : t.view;
    }

    function ba(t) {
      return "string" == typeof t ? function (e) {
        return {
          key: t,
          value: e
        };
      } : "object" == _typeof(t) ? t.value ? function () {
        return t;
      } : function (e) {
        return {
          key: t.key,
          value: e
        };
      } : t;
    }

    function wa(t, e, n) {
      var i = "function" == typeof t ? t(e, n) : t;
      return i ? (i.priority || (i.priority = 10), i.id || (i.id = e.markerName), i) : null;
    }

    var ka = /*#__PURE__*/function (_la2) {
      _inherits(ka, _la2);

      var _super23 = _createSuper(ka);

      function ka() {
        _classCallCheck(this, ka);

        return _super23.apply(this, arguments);
      }

      _createClass(ka, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(_a(t));
        }
      }, {
        key: "elementToAttribute",
        value: function elementToAttribute(t) {
          return this.add(function (t) {
            ya(t = ua(t));
            var e = xa(t, !1),
                n = va(t),
                i = n ? "element:" + n : "element";
            return function (n) {
              n.on(i, e, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(function (t) {
            var e = null;
            ("string" == typeof (t = ua(t)).view || t.view.key) && (e = function (t) {
              "string" == typeof t.view && (t.view = {
                key: t.view
              });
              var e = t.view.key;
              var n;

              if ("class" == e || "style" == e) {
                var _i72 = "class" == e ? "classes" : "styles";

                n = _defineProperty({}, _i72, t.view.value);
              } else {
                var _i73 = void 0 === t.view.value ? /[\s\S]*/ : t.view.value;

                n = {
                  attributes: _defineProperty({}, e, _i73)
                };
              }

              t.view.name && (n.name = t.view.name);
              return t.view = n, e;
            }(t));
            ya(t, e);
            var n = xa(t, !0);
            return function (e) {
              e.on("element", n, {
                priority: t.converterPriority || "low"
              });
            };
          }(t));
        }
      }, {
        key: "elementToMarker",
        value: function elementToMarker(t) {
          return this.add(function (t) {
            return function (t) {
              var e = t.model;

              t.model = function (t, n) {
                var i = "string" == typeof e ? e : e(t);
                return n.createElement("$marker", {
                  "data-name": i
                });
              };
            }(t = ua(t)), _a(t);
          }(t));
        }
      }]);

      return ka;
    }(la);

    function _a(t) {
      var e = function (t) {
        var e = t.view ? new bi(t.view) : null;
        return function (n, i, o) {
          var r = {};

          if (e) {
            var _t117 = e.match(i.viewItem);

            if (!_t117) return;
            r = _t117.match;
          }

          r.name = !0;

          var s = function (t, e, n) {
            return t instanceof Function ? t(e, n) : n.createElement(t);
          }(t.model, i.viewItem, o.writer);

          if (!s) return;
          if (!o.consumable.test(i.viewItem, r)) return;
          var a = o.splitToAllowedParent(s, i.modelCursor);
          if (!a) return;
          o.writer.insert(s, a.position), o.convertChildren(i.viewItem, o.writer.createPositionAt(s, 0)), o.consumable.consume(i.viewItem, r);
          var c = o.getSplitParts(s);
          i.modelRange = new Gs(o.writer.createPositionBefore(s), o.writer.createPositionAfter(c[c.length - 1])), a.cursorParent ? i.modelCursor = o.writer.createPositionAt(a.cursorParent, 0) : i.modelCursor = i.modelRange.end;
        };
      }(t = ua(t)),
          n = va(t),
          i = n ? "element:" + n : "element";

      return function (n) {
        n.on(i, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }

    function va(t) {
      return "string" == typeof t.view ? t.view : "object" == _typeof(t.view) && "string" == typeof t.view.name ? t.view.name : null;
    }

    function ya(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var n = null === e || function (t) {
        return t.getAttribute(e);
      },
          i = "object" != _typeof(t.model) ? t.model : t.model.key,
          o = "object" != _typeof(t.model) || void 0 === t.model.value ? n : t.model.value;

      t.model = {
        key: i,
        value: o
      };
    }

    function xa(t, e) {
      var n = new bi(t.view);
      return function (i, o, r) {
        var s = n.match(o.viewItem);
        if (!s) return;
        var a = t.model.key,
            c = "function" == typeof t.model.value ? t.model.value(o.viewItem) : t.model.value;
        null !== c && (!function (t) {
          if ("object" == _typeof(t.view) && !va(t)) return !1;
          return !t.view.classes && !t.view.attributes && !t.view.styles;
        }(t) ? delete s.match.name : s.match.name = !0, r.consumable.test(o.viewItem, s.match) && (o.modelRange || (o = Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor))), function (t, e, n, i) {
          var o = !1;

          for (var _i74 = 0, _Array$from4 = Array.from(t.getItems({
            shallow: n
          })); _i74 < _Array$from4.length; _i74++) {
            var _r13 = _Array$from4[_i74];
            i.schema.checkAttribute(_r13, e.key) && (i.writer.setAttribute(e.key, e.value, _r13), o = !0);
          }

          return o;
        }(o.modelRange, {
          key: a,
          value: c
        }, e, r) && r.consumable.consume(o.viewItem, s.match)));
      };
    }

    var Aa = /*#__PURE__*/function () {
      function Aa(t) {
        var _this47 = this;

        _classCallCheck(this, Aa);

        this.model = t, this.view = new js(), this.mapper = new Qs(), this.downcastDispatcher = new Zs({
          mapper: this.mapper
        });
        var e = this.model.document,
            n = e.selection,
            i = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", function () {
          _this47.view._disableRendering(!0);
        }, {
          priority: "highest"
        }), this.listenTo(this.model, "_afterChanges", function () {
          _this47.view._disableRendering(!1);
        }, {
          priority: "lowest"
        }), this.listenTo(e, "change", function () {
          _this47.view.change(function (t) {
            _this47.downcastDispatcher.convertChanges(e.differ, i, t), _this47.downcastDispatcher.convertSelection(n, i, t);
          });
        }, {
          priority: "low"
        }), this.listenTo(this.view.document, "selectionChange", function (t, e) {
          return function (n, i) {
            var o = i.newSelection,
                r = new ta(),
                s = [];

            var _iterator142 = _createForOfIteratorHelper(o.getRanges()),
                _step142;

            try {
              for (_iterator142.s(); !(_step142 = _iterator142.n()).done;) {
                var _t118 = _step142.value;
                s.push(e.toModelRange(_t118));
              }
            } catch (err) {
              _iterator142.e(err);
            } finally {
              _iterator142.f();
            }

            r.setTo(s, {
              backward: o.isBackward
            }), r.isEqual(t.document.selection) || t.change(function (t) {
              t.setSelection(r);
            });
          };
        }(this.model, this.mapper)), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var i = n.writer,
              o = n.mapper.toViewPosition(e.range.start),
              r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.downcastDispatcher.on("remove", function (t, e, n) {
          var i = n.mapper.toViewPosition(e.position),
              o = e.position.getShiftedBy(e.length),
              r = n.mapper.toViewPosition(o, {
            isPhantom: !0
          }),
              s = n.writer.createRange(i, r),
              a = n.writer.remove(s.getTrimmed());

          var _iterator143 = _createForOfIteratorHelper(n.writer.createRangeIn(a).getItems()),
              _step143;

          try {
            for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
              var _t119 = _step143.value;
              n.mapper.unbindViewElement(_t119);
            }
          } catch (err) {
            _iterator143.e(err);
          } finally {
            _iterator143.f();
          }
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = n.writer,
              o = i.document.selection;

          var _iterator144 = _createForOfIteratorHelper(o.getRanges()),
              _step144;

          try {
            for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
              var _t120 = _step144.value;
              _t120.isCollapsed && _t120.end.parent.document && n.writer.mergeAttributes(_t120.start);
            }
          } catch (err) {
            _iterator144.e(err);
          } finally {
            _iterator144.f();
          }

          i.setSelection(null);
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = e.selection;
          if (i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          var o = [];

          var _iterator145 = _createForOfIteratorHelper(i.getRanges()),
              _step145;

          try {
            for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
              var _t121 = _step145.value;

              var _e112 = n.mapper.toViewRange(_t121);

              o.push(_e112);
            }
          } catch (err) {
            _iterator145.e(err);
          } finally {
            _iterator145.f();
          }

          n.writer.setSelection(o, {
            backward: i.isBackward
          });
        }, {
          priority: "low"
        }), this.downcastDispatcher.on("selection", function (t, e, n) {
          var i = e.selection;
          if (!i.isCollapsed) return;
          if (!n.consumable.consume(i, "selection")) return;
          var o = n.writer,
              r = i.getFirstPosition(),
              s = n.mapper.toViewPosition(r),
              a = o.breakAttributes(s);
          o.setSelection(a);
        }, {
          priority: "low"
        }), this.view.document.roots.bindTo(this.model.document.roots).using(function (t) {
          if ("$graveyard" == t.rootName) return null;
          var e = new Ki(t.name);
          return e.rootName = t.rootName, e._document = _this47.view.document, _this47.mapper.bindElements(t, e), e;
        });
      }

      _createClass(Aa, [{
        key: "destroy",
        value: function destroy() {
          this.view.destroy(), this.stopListening();
        }
      }]);

      return Aa;
    }();

    ci(Aa, Fi);

    var Ta = /*#__PURE__*/function (_Symbol$iterator8) {
      function Ta(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, Ta);

        this._editor = t, this._availablePlugins = new Map(), this._plugins = new Map();

        var _iterator146 = _createForOfIteratorHelper(e),
            _step146;

        try {
          for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
            var _t122 = _step146.value;
            this._availablePlugins.set(_t122, _t122), _t122.pluginName && this._availablePlugins.set(_t122.pluginName, _t122);
          }
        } catch (err) {
          _iterator146.e(err);
        } finally {
          _iterator146.f();
        }
      }

      _createClass(Ta, [{
        key: _Symbol$iterator8,
        value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
          var _iterator147, _step147, _t123;

          return _regeneratorRuntime.wrap(function value$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  _iterator147 = _createForOfIteratorHelper(this._plugins);
                  _context19.prev = 1;

                  _iterator147.s();

                case 3:
                  if ((_step147 = _iterator147.n()).done) {
                    _context19.next = 11;
                    break;
                  }

                  _t123 = _step147.value;
                  _context19.t0 = "function" == typeof _t123[0];

                  if (!_context19.t0) {
                    _context19.next = 9;
                    break;
                  }

                  _context19.next = 9;
                  return _t123;

                case 9:
                  _context19.next = 3;
                  break;

                case 11:
                  _context19.next = 16;
                  break;

                case 13:
                  _context19.prev = 13;
                  _context19.t1 = _context19["catch"](1);

                  _iterator147.e(_context19.t1);

                case 16:
                  _context19.prev = 16;

                  _iterator147.f();

                  return _context19.finish(16);

                case 19:
                case "end":
                  return _context19.stop();
              }
            }
          }, value, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "get",
        value: function get(t) {
          var e = this._plugins.get(t);

          if (!e) {
            var _e113 = "plugincollection-plugin-not-loaded: The requested plugin is not loaded.";
            var _n97 = t;
            throw "function" == typeof t && (_n97 = t.pluginName || t.name), new Gn.b(_e113, this._editor, {
              plugin: _n97
            });
          }

          return e;
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._plugins.has(t);
        }
      }, {
        key: "init",
        value: function init(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

          var n = this,
              i = this._editor,
              o = new Set(),
              r = [],
              s = u(t),
              a = u(e),
              c = function (t) {
            var e = [];

            var _iterator148 = _createForOfIteratorHelper(t),
                _step148;

            try {
              for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
                var _n98 = _step148.value;
                h(_n98) || e.push(_n98);
              }
            } catch (err) {
              _iterator148.e(err);
            } finally {
              _iterator148.f();
            }

            return e.length ? e : null;
          }(t);

          if (c) {
            var _t124 = "plugincollection-plugin-not-found: Some plugins are not available and could not be loaded.";
            return console.error(Object(Gn.a)(_t124), {
              plugins: c
            }), Promise.reject(new Gn.b(_t124, this._editor, {
              plugins: c
            }));
          }

          return Promise.all(s.map(l)).then(function () {
            return d(r, "init");
          }).then(function () {
            return d(r, "afterInit");
          }).then(function () {
            return r;
          });

          function l(t) {
            if (!a.includes(t) && !n._plugins.has(t) && !o.has(t)) return function (t) {
              return new Promise(function (s) {
                o.add(t), t.requires && t.requires.forEach(function (n) {
                  var o = h(n);
                  if (e.includes(o)) throw new Gn.b("plugincollection-required: Cannot load a plugin because one of its dependencies is listed inthe `removePlugins` option.", i, {
                    plugin: o,
                    requiredBy: t
                  });
                  l(o);
                });
                var a = new t(i);
                n._add(t, a), r.push(a), s();
              });
            }(t).catch(function (e) {
              throw console.error(Object(Gn.a)("plugincollection-load: It was not possible to load the plugin."), {
                plugin: t
              }), e;
            });
          }

          function d(t, e) {
            return t.reduce(function (t, n) {
              return n[e] ? t.then(n[e].bind(n)) : t;
            }, Promise.resolve());
          }

          function h(t) {
            return "function" == typeof t ? t : n._availablePlugins.get(t);
          }

          function u(t) {
            return t.map(function (t) {
              return h(t);
            }).filter(function (t) {
              return !!t;
            });
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = Array.from(this).map(function (_ref38) {
            var _ref39 = _slicedToArray(_ref38, 2),
                t = _ref39[1];

            return t;
          }).filter(function (t) {
            return "function" == typeof t.destroy;
          }).map(function (t) {
            return t.destroy();
          });
          return Promise.all(t);
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          this._plugins.set(t, e);

          var n = t.pluginName;

          if (n) {
            if (this._plugins.has(n)) throw new Gn.b("plugincollection-plugin-name-conflict: Two plugins with the same name were loaded.", null, {
              pluginName: n,
              plugin1: this._plugins.get(n).constructor,
              plugin2: t
            });

            this._plugins.set(n, e);
          }
        }
      }]);

      return Ta;
    }(Symbol.iterator);

    ci(Ta, ei);

    var Ca = /*#__PURE__*/function (_Symbol$iterator9) {
      function Ca() {
        _classCallCheck(this, Ca);

        this._commands = new Map();
      }

      _createClass(Ca, [{
        key: "add",
        value: function add(t, e) {
          this._commands.set(t, e);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._commands.get(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var n = this.get(t);
          if (!n) throw new Gn.b("commandcollection-command-not-found: Command does not exist.", this, {
            commandName: t
          });

          for (var _len16 = arguments.length, e = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
            e[_key16 - 1] = arguments[_key16];
          }

          n.execute.apply(n, e);
        }
      }, {
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function names() {
          return _regeneratorRuntime.wrap(function names$(_context20) {
            while (1) {
              switch (_context20.prev = _context20.next) {
                case 0:
                  return _context20.delegateYield(this._commands.keys(), "t0", 1);

                case 1:
                case "end":
                  return _context20.stop();
              }
            }
          }, names, this);
        })
      }, {
        key: "commands",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function commands() {
          return _regeneratorRuntime.wrap(function commands$(_context21) {
            while (1) {
              switch (_context21.prev = _context21.next) {
                case 0:
                  return _context21.delegateYield(this._commands.values(), "t0", 1);

                case 1:
                case "end":
                  return _context21.stop();
              }
            }
          }, commands, this);
        })
      }, {
        key: _Symbol$iterator9,
        value: function value() {
          return this._commands[Symbol.iterator]();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator149 = _createForOfIteratorHelper(this.commands()),
              _step149;

          try {
            for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
              var _t125 = _step149.value;

              _t125.destroy();
            }
          } catch (err) {
            _iterator149.e(err);
          } finally {
            _iterator149.f();
          }
        }
      }]);

      return Ca;
    }(Symbol.iterator);

    function Pa(t, e) {
      var n = Object.keys(window.CKEDITOR_TRANSLATIONS).length;
      return 1 === n && (t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0]), 0 !== n && function (t, e) {
        return t in window.CKEDITOR_TRANSLATIONS && e in window.CKEDITOR_TRANSLATIONS[t];
      }(t, e) ? window.CKEDITOR_TRANSLATIONS[t][e].replace(/ \[context: [^\]]+\]$/, "") : e.replace(/ \[context: [^\]]+\]$/, "");
    }

    window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {});
    var Sa = ["ar", "fa", "he", "ku", "ug"];

    var Ma = /*#__PURE__*/function () {
      function Ma() {
        var _this48 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Ma);

        this.uiLanguage = t.uiLanguage || "en", this.contentLanguage = t.contentLanguage || this.uiLanguage, this.uiLanguageDirection = Ea(this.uiLanguage), this.contentLanguageDirection = Ea(this.contentLanguage), this.t = function () {
          return _this48._t.apply(_this48, arguments);
        };
      }

      _createClass(Ma, [{
        key: "language",
        get: function get() {
          return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
        }
      }, {
        key: "_t",
        value: function _t(t, e) {
          var n = Pa(this.uiLanguage, t);
          return e && (n = n.replace(/%(\d+)/g, function (t, n) {
            return n < e.length ? e[n] : t;
          })), n;
        }
      }]);

      return Ma;
    }();

    function Ea(t) {
      return Sa.includes(t) ? "rtl" : "ltr";
    }

    var Ia = /*#__PURE__*/function () {
      function Ia() {
        _classCallCheck(this, Ia);

        this._consumables = new Map();
      }

      _createClass(Ia, [{
        key: "add",
        value: function add(t, e) {
          var n;
          t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !0) : (this._consumables.has(t) ? n = this._consumables.get(t) : (n = new Na(), this._consumables.set(t, n)), n.add(e));
        }
      }, {
        key: "test",
        value: function test(t, e) {
          var n = this._consumables.get(t);

          return void 0 === n ? null : t.is("text") || t.is("documentFragment") ? n : n.test(e);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          return !!this.test(t, e) && (t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !1) : this._consumables.get(t).consume(e), !0);
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          var n = this._consumables.get(t);

          void 0 !== n && (t.is("text") || t.is("documentFragment") ? this._consumables.set(t, !0) : n.revert(e));
        }
      }], [{
        key: "consumablesFromElement",
        value: function consumablesFromElement(t) {
          var e = {
            name: !0,
            attributes: [],
            classes: [],
            styles: []
          },
              n = t.getAttributeKeys();

          var _iterator150 = _createForOfIteratorHelper(n),
              _step150;

          try {
            for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
              var _t126 = _step150.value;
              "style" != _t126 && "class" != _t126 && e.attributes.push(_t126);
            }
          } catch (err) {
            _iterator150.e(err);
          } finally {
            _iterator150.f();
          }

          var i = t.getClassNames();

          var _iterator151 = _createForOfIteratorHelper(i),
              _step151;

          try {
            for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
              var _t127 = _step151.value;
              e.classes.push(_t127);
            }
          } catch (err) {
            _iterator151.e(err);
          } finally {
            _iterator151.f();
          }

          var o = t.getStyleNames();

          var _iterator152 = _createForOfIteratorHelper(o),
              _step152;

          try {
            for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
              var _t128 = _step152.value;
              e.styles.push(_t128);
            }
          } catch (err) {
            _iterator152.e(err);
          } finally {
            _iterator152.f();
          }

          return e;
        }
      }, {
        key: "createFrom",
        value: function createFrom(t, e) {
          if (e || (e = new Ia()), t.is("text")) return e.add(t), e;
          t.is("element") && e.add(t, Ia.consumablesFromElement(t)), t.is("documentFragment") && e.add(t);

          var _iterator153 = _createForOfIteratorHelper(t.getChildren()),
              _step153;

          try {
            for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
              var _n99 = _step153.value;
              e = Ia.createFrom(_n99, e);
            }
          } catch (err) {
            _iterator153.e(err);
          } finally {
            _iterator153.f();
          }

          return e;
        }
      }]);

      return Ia;
    }();

    var Na = /*#__PURE__*/function () {
      function Na() {
        _classCallCheck(this, Na);

        this._canConsumeName = null, this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }

      _createClass(Na, [{
        key: "add",
        value: function add(t) {
          t.name && (this._canConsumeName = !0);

          for (var _e114 in this._consumables) {
            _e114 in t && this._add(_e114, t[_e114]);
          }
        }
      }, {
        key: "test",
        value: function test(t) {
          if (t.name && !this._canConsumeName) return this._canConsumeName;

          for (var _e115 in this._consumables) {
            if (_e115 in t) {
              var _n100 = this._test(_e115, t[_e115]);

              if (!0 !== _n100) return _n100;
            }
          }

          return !0;
        }
      }, {
        key: "consume",
        value: function consume(t) {
          t.name && (this._canConsumeName = !1);

          for (var _e116 in this._consumables) {
            _e116 in t && this._consume(_e116, t[_e116]);
          }
        }
      }, {
        key: "revert",
        value: function revert(t) {
          t.name && (this._canConsumeName = !0);

          for (var _e117 in this._consumables) {
            _e117 in t && this._revert(_e117, t[_e117]);
          }
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];

          var _iterator154 = _createForOfIteratorHelper(n),
              _step154;

          try {
            for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
              var _e118 = _step154.value;
              if ("attributes" === t && ("class" === _e118 || "style" === _e118)) throw new Gn.b("viewconsumable-invalid-attribute: Classes and styles should be handled separately.", this);
              i.set(_e118, !0);
            }
          } catch (err) {
            _iterator154.e(err);
          } finally {
            _iterator154.f();
          }
        }
      }, {
        key: "_test",
        value: function _test(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];

          var _iterator155 = _createForOfIteratorHelper(n),
              _step155;

          try {
            for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
              var _e119 = _step155.value;

              if ("attributes" !== t || "class" !== _e119 && "style" !== _e119) {
                var _t129 = i.get(_e119);

                if (void 0 === _t129) return null;
                if (!_t129) return !1;
              } else {
                var _t130 = "class" == _e119 ? "classes" : "styles",
                    _n101 = this._test(_t130, _toConsumableArray(this._consumables[_t130].keys()));

                if (!0 !== _n101) return _n101;
              }
            }
          } catch (err) {
            _iterator155.e(err);
          } finally {
            _iterator155.f();
          }

          return !0;
        }
      }, {
        key: "_consume",
        value: function _consume(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];

          var _iterator156 = _createForOfIteratorHelper(n),
              _step156;

          try {
            for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
              var _e120 = _step156.value;
              if ("attributes" !== t || "class" !== _e120 && "style" !== _e120) i.set(_e120, !1);else {
                var _t131 = "class" == _e120 ? "classes" : "styles";

                this._consume(_t131, _toConsumableArray(this._consumables[_t131].keys()));
              }
            }
          } catch (err) {
            _iterator156.e(err);
          } finally {
            _iterator156.f();
          }
        }
      }, {
        key: "_revert",
        value: function _revert(t, e) {
          var n = Wt(e) ? e : [e],
              i = this._consumables[t];

          var _iterator157 = _createForOfIteratorHelper(n),
              _step157;

          try {
            for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
              var _e121 = _step157.value;

              if ("attributes" !== t || "class" !== _e121 && "style" !== _e121) {
                !1 === i.get(_e121) && i.set(_e121, !0);
              } else {
                var _t132 = "class" == _e121 ? "classes" : "styles";

                this._revert(_t132, _toConsumableArray(this._consumables[_t132].keys()));
              }
            }
          } catch (err) {
            _iterator157.e(err);
          } finally {
            _iterator157.f();
          }
        }
      }]);

      return Na;
    }();

    var Oa = /*#__PURE__*/function () {
      function Oa() {
        var _this49 = this;

        _classCallCheck(this, Oa);

        this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", function (t, e) {
          e[0] = new Ra(e[0]);
        }, {
          priority: "highest"
        }), this.on("checkChild", function (t, e) {
          e[0] = new Ra(e[0]), e[1] = _this49.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }

      _createClass(Oa, [{
        key: "register",
        value: function register(t, e) {
          if (this._sourceDefinitions[t]) throw new Gn.b("schema-cannot-register-item-twice: A single item cannot be registered twice in the schema.", this, {
            itemName: t
          });
          this._sourceDefinitions[t] = [Object.assign({}, e)], this._clearCache();
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (!this._sourceDefinitions[t]) throw new Gn.b("schema-cannot-extend-missing-item: Cannot extend an item which was not registered yet.", this, {
            itemName: t
          });
          this._sourceDefinitions[t].push(Object.assign({}, e)), this._clearCache();
        }
      }, {
        key: "getDefinitions",
        value: function getDefinitions() {
          return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
        }
      }, {
        key: "getDefinition",
        value: function getDefinition(t) {
          var e;
          return e = "string" == typeof t ? t : t.is && (t.is("text") || t.is("textProxy")) ? "$text" : t.name, this.getDefinitions()[e];
        }
      }, {
        key: "isRegistered",
        value: function isRegistered(t) {
          return !!this.getDefinition(t);
        }
      }, {
        key: "isBlock",
        value: function isBlock(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isBlock);
        }
      }, {
        key: "isLimit",
        value: function isLimit(t) {
          var e = this.getDefinition(t);
          return !!e && !(!e.isLimit && !e.isObject);
        }
      }, {
        key: "isObject",
        value: function isObject(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isObject);
        }
      }, {
        key: "isInline",
        value: function isInline(t) {
          var e = this.getDefinition(t);
          return !(!e || !e.isInline);
        }
      }, {
        key: "checkChild",
        value: function checkChild(t, e) {
          return !!e && this._checkContextMatch(e, t);
        }
      }, {
        key: "checkAttribute",
        value: function checkAttribute(t, e) {
          var n = this.getDefinition(t.last);
          return !!n && n.allowAttributes.includes(e);
        }
      }, {
        key: "checkMerge",
        value: function checkMerge(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

          if (t instanceof $s) {
            var _e122 = t.nodeBefore,
                _n102 = t.nodeAfter;
            if (!(_e122 instanceof Hs)) throw new Gn.b("schema-check-merge-no-element-before: The node before the merge position must be an element.", this);
            if (!(_n102 instanceof Hs)) throw new Gn.b("schema-check-merge-no-element-after: The node after the merge position must be an element.", this);
            return this.checkMerge(_e122, _n102);
          }

          var _iterator158 = _createForOfIteratorHelper(e.getChildren()),
              _step158;

          try {
            for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
              var _n103 = _step158.value;
              if (!this.checkChild(t, _n103)) return !1;
            }
          } catch (err) {
            _iterator158.e(err);
          } finally {
            _iterator158.f();
          }

          return !0;
        }
      }, {
        key: "addChildCheck",
        value: function addChildCheck(t) {
          this.on("checkChild", function (e, _ref40) {
            var _ref41 = _slicedToArray(_ref40, 2),
                n = _ref41[0],
                i = _ref41[1];

            if (!i) return;
            var o = t(n, i);
            "boolean" == typeof o && (e.stop(), e.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "addAttributeCheck",
        value: function addAttributeCheck(t) {
          this.on("checkAttribute", function (e, _ref42) {
            var _ref43 = _slicedToArray(_ref42, 2),
                n = _ref43[0],
                i = _ref43[1];

            var o = t(n, i);
            "boolean" == typeof o && (e.stop(), e.return = o);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "setAttributeProperties",
        value: function setAttributeProperties(t, e) {
          this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
        }
      }, {
        key: "getAttributeProperties",
        value: function getAttributeProperties(t) {
          return this._attributeProperties[t] || {};
        }
      }, {
        key: "getLimitElement",
        value: function getLimitElement(t) {
          var e;
          if (t instanceof $s) e = t.parent;else {
            e = (t instanceof Gs ? [t] : Array.from(t.getRanges())).reduce(function (t, e) {
              var n = e.getCommonAncestor();
              return t ? t.getCommonAncestor(n, {
                includeSelf: !0
              }) : n;
            }, null);
          }

          for (; !this.isLimit(e) && e.parent;) {
            e = e.parent;
          }

          return e;
        }
      }, {
        key: "checkAttributeInSelection",
        value: function checkAttributeInSelection(t, e) {
          if (t.isCollapsed) {
            var _n104 = [].concat(_toConsumableArray(t.getFirstPosition().getAncestors()), [new Bs("", t.getAttributes())]);

            return this.checkAttribute(_n104, e);
          }

          {
            var _n105 = t.getRanges();

            var _iterator159 = _createForOfIteratorHelper(_n105),
                _step159;

            try {
              for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
                var _t133 = _step159.value;

                var _iterator160 = _createForOfIteratorHelper(_t133),
                    _step160;

                try {
                  for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
                    var _n106 = _step160.value;
                    if (this.checkAttribute(_n106.item, e)) return !0;
                  }
                } catch (err) {
                  _iterator160.e(err);
                } finally {
                  _iterator160.f();
                }
              }
            } catch (err) {
              _iterator159.e(err);
            } finally {
              _iterator159.f();
            }
          }
          return !1;
        }
      }, {
        key: "getValidRanges",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getValidRanges(t, e) {
          var _iterator162, _step162, _n107;

          return _regeneratorRuntime.wrap(function getValidRanges$(_context23) {
            while (1) {
              switch (_context23.prev = _context23.next) {
                case 0:
                  t = /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
                    var _iterator161, _step161, _e123;

                    return _regeneratorRuntime.wrap(function _callee$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            _iterator161 = _createForOfIteratorHelper(t);
                            _context22.prev = 1;

                            _iterator161.s();

                          case 3:
                            if ((_step161 = _iterator161.n()).done) {
                              _context22.next = 8;
                              break;
                            }

                            _e123 = _step161.value;
                            return _context22.delegateYield(_e123.getMinimalFlatRanges(), "t0", 6);

                          case 6:
                            _context22.next = 3;
                            break;

                          case 8:
                            _context22.next = 13;
                            break;

                          case 10:
                            _context22.prev = 10;
                            _context22.t1 = _context22["catch"](1);

                            _iterator161.e(_context22.t1);

                          case 13:
                            _context22.prev = 13;

                            _iterator161.f();

                            return _context22.finish(13);

                          case 16:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee, null, [[1, 10, 13, 16]]);
                  })(t);
                  _iterator162 = _createForOfIteratorHelper(t);
                  _context23.prev = 2;

                  _iterator162.s();

                case 4:
                  if ((_step162 = _iterator162.n()).done) {
                    _context23.next = 9;
                    break;
                  }

                  _n107 = _step162.value;
                  return _context23.delegateYield(this._getValidRangesForRange(_n107, e), "t0", 7);

                case 7:
                  _context23.next = 4;
                  break;

                case 9:
                  _context23.next = 14;
                  break;

                case 11:
                  _context23.prev = 11;
                  _context23.t1 = _context23["catch"](2);

                  _iterator162.e(_context23.t1);

                case 14:
                  _context23.prev = 14;

                  _iterator162.f();

                  return _context23.finish(14);

                case 17:
                case "end":
                  return _context23.stop();
              }
            }
          }, getValidRanges, this, [[2, 11, 14, 17]]);
        })
      }, {
        key: "getNearestSelectionRange",
        value: function getNearestSelectionRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
          if (this.checkChild(t, "$text")) return new Gs(t);
          var n, i;
          "both" != e && "backward" != e || (n = new qs({
            startPosition: t,
            direction: "backward"
          })), "both" != e && "forward" != e || (i = new qs({
            startPosition: t
          }));

          var _iterator163 = _createForOfIteratorHelper( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e) {
            var n, _e124, _t134;

            return _regeneratorRuntime.wrap(function _callee2$(_context24) {
              while (1) {
                switch (_context24.prev = _context24.next) {
                  case 0:
                    n = !1;

                  case 1:
                    if (n) {
                      _context24.next = 18;
                      break;
                    }

                    if (!(n = !0, t)) {
                      _context24.next = 9;
                      break;
                    }

                    _e124 = t.next();
                    _context24.t0 = _e124.done;

                    if (_context24.t0) {
                      _context24.next = 9;
                      break;
                    }

                    n = !1;
                    _context24.next = 9;
                    return {
                      walker: t,
                      value: _e124.value
                    };

                  case 9:
                    if (!e) {
                      _context24.next = 16;
                      break;
                    }

                    _t134 = e.next();
                    _context24.t1 = _t134.done;

                    if (_context24.t1) {
                      _context24.next = 16;
                      break;
                    }

                    n = !1;
                    _context24.next = 16;
                    return {
                      walker: e,
                      value: _t134.value
                    };

                  case 16:
                    _context24.next = 1;
                    break;

                  case 18:
                  case "end":
                    return _context24.stop();
                }
              }
            }, _callee2);
          })(n, i)),
              _step163;

          try {
            for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
              var _t135 = _step163.value;

              var _e125 = _t135.walker == n ? "elementEnd" : "elementStart",
                  _i75 = _t135.value;

              if (_i75.type == _e125 && this.isObject(_i75.item)) return Gs._createOn(_i75.item);
              if (this.checkChild(_i75.nextPosition, "$text")) return new Gs(_i75.nextPosition);
            }
          } catch (err) {
            _iterator163.e(err);
          } finally {
            _iterator163.f();
          }

          return null;
        }
      }, {
        key: "findAllowedParent",
        value: function findAllowedParent(t, e) {
          var n = t.parent;

          for (; n;) {
            if (this.checkChild(n, e)) return n;
            if (this.isLimit(n)) return null;
            n = n.parent;
          }

          return null;
        }
      }, {
        key: "removeDisallowedAttributes",
        value: function removeDisallowedAttributes(t, e) {
          var _iterator164 = _createForOfIteratorHelper(t),
              _step164;

          try {
            for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
              var _n108 = _step164.value;

              var _iterator165 = _createForOfIteratorHelper(_n108.getAttributeKeys()),
                  _step165;

              try {
                for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
                  var _t136 = _step165.value;
                  this.checkAttribute(_n108, _t136) || e.removeAttribute(_t136, _n108);
                }
              } catch (err) {
                _iterator165.e(err);
              } finally {
                _iterator165.f();
              }

              _n108.is("element") && this.removeDisallowedAttributes(_n108.getChildren(), e);
            }
          } catch (err) {
            _iterator164.e(err);
          } finally {
            _iterator164.f();
          }
        }
      }, {
        key: "createContext",
        value: function createContext(t) {
          return new Ra(t);
        }
      }, {
        key: "_clearCache",
        value: function _clearCache() {
          this._compiledDefinitions = null;
        }
      }, {
        key: "_compile",
        value: function _compile() {
          var t = {},
              e = this._sourceDefinitions,
              n = Object.keys(e);

          for (var _i76 = 0, _n109 = n; _i76 < _n109.length; _i76++) {
            var _i77 = _n109[_i76];
            t[_i77] = Da(e[_i77], _i77);
          }

          for (var _i78 = 0, _n110 = n; _i78 < _n110.length; _i78++) {
            var _e126 = _n110[_i78];
            La(t, _e126);
          }

          for (var _i79 = 0, _n111 = n; _i79 < _n111.length; _i79++) {
            var _e127 = _n111[_i79];
            ja(t, _e127);
          }

          for (var _i80 = 0, _n112 = n; _i80 < _n112.length; _i80++) {
            var _e128 = _n112[_i80];
            Va(t, _e128), za(t, _e128);
          }

          for (var _i81 = 0, _n113 = n; _i81 < _n113.length; _i81++) {
            var _e129 = _n113[_i81];
            Ba(t, _e129), Fa(t, _e129);
          }

          this._compiledDefinitions = t;
        }
      }, {
        key: "_checkContextMatch",
        value: function _checkContextMatch(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
          var i = e.getItem(n);

          if (t.allowIn.includes(i.name)) {
            if (0 == n) return !0;
            {
              var _t137 = this.getDefinition(i);

              return this._checkContextMatch(_t137, e, n - 1);
            }
          }

          return !1;
        }
      }, {
        key: "_getValidRangesForRange",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function _getValidRangesForRange(t, e) {
          var n, i, _iterator166, _step166, _o35;

          return _regeneratorRuntime.wrap(function _getValidRangesForRange$(_context25) {
            while (1) {
              switch (_context25.prev = _context25.next) {
                case 0:
                  n = t.start, i = t.start;
                  _iterator166 = _createForOfIteratorHelper(t.getItems({
                    shallow: !0
                  }));
                  _context25.prev = 2;

                  _iterator166.s();

                case 4:
                  if ((_step166 = _iterator166.n()).done) {
                    _context25.next = 19;
                    break;
                  }

                  _o35 = _step166.value;
                  _context25.t0 = _o35.is("element");

                  if (!_context25.t0) {
                    _context25.next = 9;
                    break;
                  }

                  return _context25.delegateYield(this._getValidRangesForRange(Gs._createIn(_o35), e), "t1", 9);

                case 9:
                  _context25.t2 = this.checkAttribute(_o35, e);

                  if (_context25.t2) {
                    _context25.next = 16;
                    break;
                  }

                  _context25.t3 = n.isEqual(i);

                  if (_context25.t3) {
                    _context25.next = 15;
                    break;
                  }

                  _context25.next = 15;
                  return new Gs(n, i);

                case 15:
                  n = $s._createAfter(_o35);

                case 16:
                  i = $s._createAfter(_o35);

                case 17:
                  _context25.next = 4;
                  break;

                case 19:
                  _context25.next = 24;
                  break;

                case 21:
                  _context25.prev = 21;
                  _context25.t4 = _context25["catch"](2);

                  _iterator166.e(_context25.t4);

                case 24:
                  _context25.prev = 24;

                  _iterator166.f();

                  return _context25.finish(24);

                case 27:
                  _context25.t5 = n.isEqual(i);

                  if (_context25.t5) {
                    _context25.next = 31;
                    break;
                  }

                  _context25.next = 31;
                  return new Gs(n, i);

                case 31:
                case "end":
                  return _context25.stop();
              }
            }
          }, _getValidRangesForRange, this, [[2, 21, 24, 27]]);
        })
      }]);

      return Oa;
    }();

    ci(Oa, Fi);

    var Ra = /*#__PURE__*/function (_Symbol$iterator10) {
      function Ra(t) {
        _classCallCheck(this, Ra);

        if (t instanceof Ra) return t;
        "string" == typeof t ? t = [t] : Array.isArray(t) || (t = t.getAncestors({
          includeSelf: !0
        })), t[0] && "string" != typeof t[0] && t[0].is("documentFragment") && t.shift(), this._items = t.map(qa);
      }

      _createClass(Ra, [{
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this._items.length - 1];
        }
      }, {
        key: _Symbol$iterator10,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "push",
        value: function push(t) {
          var e = new Ra([t]);
          return e._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(e._items)), e;
        }
      }, {
        key: "getItem",
        value: function getItem(t) {
          return this._items[t];
        }
      }, {
        key: "getNames",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getNames() {
          return _regeneratorRuntime.wrap(function getNames$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  return _context26.delegateYield(this._items.map(function (t) {
                    return t.name;
                  }), "t0", 1);

                case 1:
                case "end":
                  return _context26.stop();
              }
            }
          }, getNames, this);
        })
      }, {
        key: "endsWith",
        value: function endsWith(t) {
          return Array.from(this.getNames()).join(" ").endsWith(t);
        }
      }]);

      return Ra;
    }(Symbol.iterator);

    function Da(t, e) {
      var n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        inheritTypesFrom: []
      };
      return function (t, e) {
        var _iterator167 = _createForOfIteratorHelper(t),
            _step167;

        try {
          for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
            var _n114 = _step167.value;

            var _t138 = Object.keys(_n114).filter(function (t) {
              return t.startsWith("is");
            });

            var _iterator168 = _createForOfIteratorHelper(_t138),
                _step168;

            try {
              for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
                var _i82 = _step168.value;
                e[_i82] = _n114[_i82];
              }
            } catch (err) {
              _iterator168.e(err);
            } finally {
              _iterator168.f();
            }
          }
        } catch (err) {
          _iterator167.e(err);
        } finally {
          _iterator167.f();
        }
      }(t, n), Ua(t, n, "allowIn"), Ua(t, n, "allowContentOf"), Ua(t, n, "allowWhere"), Ua(t, n, "allowAttributes"), Ua(t, n, "allowAttributesOf"), Ua(t, n, "inheritTypesFrom"), function (t, e) {
        var _iterator169 = _createForOfIteratorHelper(t),
            _step169;

        try {
          for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
            var _n115 = _step169.value;
            var _t139 = _n115.inheritAllFrom;
            _t139 && (e.allowContentOf.push(_t139), e.allowWhere.push(_t139), e.allowAttributesOf.push(_t139), e.inheritTypesFrom.push(_t139));
          }
        } catch (err) {
          _iterator169.e(err);
        } finally {
          _iterator169.f();
        }
      }(t, n), n;
    }

    function La(t, e) {
      var _iterator170 = _createForOfIteratorHelper(t[e].allowContentOf),
          _step170;

      try {
        for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
          var _n116 = _step170.value;

          if (t[_n116]) {
            Ha(t, _n116).forEach(function (t) {
              t.allowIn.push(e);
            });
          }
        }
      } catch (err) {
        _iterator170.e(err);
      } finally {
        _iterator170.f();
      }

      delete t[e].allowContentOf;
    }

    function ja(t, e) {
      var _iterator171 = _createForOfIteratorHelper(t[e].allowWhere),
          _step171;

      try {
        for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
          var _n117 = _step171.value;
          var _i83 = t[_n117];

          if (_i83) {
            var _t$e$allowIn;

            var _n118 = _i83.allowIn;

            (_t$e$allowIn = t[e].allowIn).push.apply(_t$e$allowIn, _toConsumableArray(_n118));
          }
        }
      } catch (err) {
        _iterator171.e(err);
      } finally {
        _iterator171.f();
      }

      delete t[e].allowWhere;
    }

    function Va(t, e) {
      var _iterator172 = _createForOfIteratorHelper(t[e].allowAttributesOf),
          _step172;

      try {
        for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
          var _n119 = _step172.value;
          var _i84 = t[_n119];

          if (_i84) {
            var _t$e$allowAttributes;

            var _n120 = _i84.allowAttributes;

            (_t$e$allowAttributes = t[e].allowAttributes).push.apply(_t$e$allowAttributes, _toConsumableArray(_n120));
          }
        }
      } catch (err) {
        _iterator172.e(err);
      } finally {
        _iterator172.f();
      }

      delete t[e].allowAttributesOf;
    }

    function za(t, e) {
      var n = t[e];

      var _iterator173 = _createForOfIteratorHelper(n.inheritTypesFrom),
          _step173;

      try {
        for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
          var _e130 = _step173.value;
          var _i85 = t[_e130];

          if (_i85) {
            var _t140 = Object.keys(_i85).filter(function (t) {
              return t.startsWith("is");
            });

            var _iterator174 = _createForOfIteratorHelper(_t140),
                _step174;

            try {
              for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
                var _e131 = _step174.value;
                _e131 in n || (n[_e131] = _i85[_e131]);
              }
            } catch (err) {
              _iterator174.e(err);
            } finally {
              _iterator174.f();
            }
          }
        }
      } catch (err) {
        _iterator173.e(err);
      } finally {
        _iterator173.f();
      }

      delete n.inheritTypesFrom;
    }

    function Ba(t, e) {
      var n = t[e],
          i = n.allowIn.filter(function (e) {
        return t[e];
      });
      n.allowIn = Array.from(new Set(i));
    }

    function Fa(t, e) {
      var n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }

    function Ua(t, e, n) {
      var _iterator175 = _createForOfIteratorHelper(t),
          _step175;

      try {
        for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
          var _e$n;

          var _i86 = _step175.value;
          "string" == typeof _i86[n] ? e[n].push(_i86[n]) : Array.isArray(_i86[n]) && (_e$n = e[n]).push.apply(_e$n, _toConsumableArray(_i86[n]));
        }
      } catch (err) {
        _iterator175.e(err);
      } finally {
        _iterator175.f();
      }
    }

    function Ha(t, e) {
      var n = t[e];
      return function (t) {
        return Object.keys(t).map(function (e) {
          return t[e];
        });
      }(t).filter(function (t) {
        return t.allowIn.includes(n.name);
      });
    }

    function qa(t) {
      return "string" == typeof t ? {
        name: t,
        getAttributeKeys: function getAttributeKeys() {
          return /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function _callee3$(_context27) {
              while (1) {
                switch (_context27.prev = _context27.next) {
                  case 0:
                  case "end":
                    return _context27.stop();
                }
              }
            }, _callee3);
          })();
        },
        getAttribute: function getAttribute() {}
      } : {
        name: t.is("element") ? t.name : "$text",
        getAttributeKeys: function getAttributeKeys() {
          return /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
            return _regeneratorRuntime.wrap(function _callee4$(_context28) {
              while (1) {
                switch (_context28.prev = _context28.next) {
                  case 0:
                    return _context28.delegateYield(t.getAttributeKeys(), "t0", 1);

                  case 1:
                  case "end":
                    return _context28.stop();
                }
              }
            }, _callee4);
          })();
        },
        getAttribute: function getAttribute(e) {
          return t.getAttribute(e);
        }
      };
    }

    var Wa = /*#__PURE__*/function () {
      function Wa() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Wa);

        this._splitParts = new Map(), this._modelCursor = null, this.conversionApi = Object.assign({}, t), this.conversionApi.convertItem = this._convertItem.bind(this), this.conversionApi.convertChildren = this._convertChildren.bind(this), this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this), this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
      }

      _createClass(Wa, [{
        key: "convert",
        value: function convert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
          this.fire("viewCleanup", t), this._modelCursor = function (t, e) {
            var n;

            var _iterator176 = _createForOfIteratorHelper(new Ra(t)),
                _step176;

            try {
              for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
                var _i87 = _step176.value;
                var _t141 = {};

                var _iterator177 = _createForOfIteratorHelper(_i87.getAttributeKeys()),
                    _step177;

                try {
                  for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
                    var _e132 = _step177.value;
                    _t141[_e132] = _i87.getAttribute(_e132);
                  }
                } catch (err) {
                  _iterator177.e(err);
                } finally {
                  _iterator177.f();
                }

                var _o36 = e.createElement(_i87.name, _t141);

                n && e.append(_o36, n), n = $s._createAt(_o36, 0);
              }
            } catch (err) {
              _iterator176.e(err);
            } finally {
              _iterator176.f();
            }

            return n;
          }(n, e), this.conversionApi.writer = e, this.conversionApi.consumable = Ia.createFrom(t), this.conversionApi.store = {};

          var _this$_convertItem = this._convertItem(t, this._modelCursor),
              i = _this$_convertItem.modelRange,
              o = e.createDocumentFragment();

          if (i) {
            this._removeEmptyElements();

            for (var _i88 = 0, _Array$from5 = Array.from(this._modelCursor.parent.getChildren()); _i88 < _Array$from5.length; _i88++) {
              var _t142 = _Array$from5[_i88];
              e.append(_t142, o);
            }

            o.markers = function (t, e) {
              var n = new Set(),
                  i = new Map(),
                  o = Gs._createIn(t).getItems();

              var _iterator178 = _createForOfIteratorHelper(o),
                  _step178;

              try {
                for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
                  var _t143 = _step178.value;
                  "$marker" == _t143.name && n.add(_t143);
                }
              } catch (err) {
                _iterator178.e(err);
              } finally {
                _iterator178.f();
              }

              var _iterator179 = _createForOfIteratorHelper(n),
                  _step179;

              try {
                for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
                  var _t144 = _step179.value;

                  var _n121 = _t144.getAttribute("data-name"),
                      _o37 = e.createPositionBefore(_t144);

                  i.has(_n121) ? i.get(_n121).end = _o37.clone() : i.set(_n121, new Gs(_o37.clone())), e.remove(_t144);
                }
              } catch (err) {
                _iterator179.e(err);
              } finally {
                _iterator179.f();
              }

              return i;
            }(o, e);
          }

          return this._modelCursor = null, this._splitParts.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, o;
        }
      }, {
        key: "_convertItem",
        value: function _convertItem(t, e) {
          var n = Object.assign({
            viewItem: t,
            modelCursor: e,
            modelRange: null
          });
          if (t.is("element") ? this.fire("element:" + t.name, n, this.conversionApi) : t.is("text") ? this.fire("text", n, this.conversionApi) : this.fire("documentFragment", n, this.conversionApi), n.modelRange && !(n.modelRange instanceof Gs)) throw new Gn.b("view-conversion-dispatcher-incorrect-result: Incorrect conversion result was dropped.", this);
          return {
            modelRange: n.modelRange,
            modelCursor: n.modelCursor
          };
        }
      }, {
        key: "_convertChildren",
        value: function _convertChildren(t, e) {
          var n = new Gs(e);
          var i = e;

          for (var _i89 = 0, _Array$from6 = Array.from(t.getChildren()); _i89 < _Array$from6.length; _i89++) {
            var _e133 = _Array$from6[_i89];

            var _t145 = this._convertItem(_e133, i);

            _t145.modelRange instanceof Gs && (n.end = _t145.modelRange.end, i = _t145.modelCursor);
          }

          return {
            modelRange: n,
            modelCursor: i
          };
        }
      }, {
        key: "_splitToAllowedParent",
        value: function _splitToAllowedParent(t, e) {
          var n = this.conversionApi.schema.findAllowedParent(e, t);
          if (!n) return null;
          if (n === e.parent) return {
            position: e
          };
          if (this._modelCursor.parent.getAncestors().includes(n)) return null;
          var i = this.conversionApi.writer.split(e, n),
              o = [];

          var _iterator180 = _createForOfIteratorHelper(i.range.getWalker()),
              _step180;

          try {
            for (_iterator180.s(); !(_step180 = _iterator180.n()).done;) {
              var _t146 = _step180.value;
              if ("elementEnd" == _t146.type) o.push(_t146.item);else {
                var _e134 = o.pop(),
                    _n122 = _t146.item;

                this._registerSplitPair(_e134, _n122);
              }
            }
          } catch (err) {
            _iterator180.e(err);
          } finally {
            _iterator180.f();
          }

          return {
            position: i.position,
            cursorParent: i.range.end.parent
          };
        }
      }, {
        key: "_registerSplitPair",
        value: function _registerSplitPair(t, e) {
          this._splitParts.has(t) || this._splitParts.set(t, [t]);

          var n = this._splitParts.get(t);

          this._splitParts.set(e, n), n.push(e);
        }
      }, {
        key: "_getSplitParts",
        value: function _getSplitParts(t) {
          var e;
          return e = this._splitParts.has(t) ? this._splitParts.get(t) : [t];
        }
      }, {
        key: "_removeEmptyElements",
        value: function _removeEmptyElements() {
          var t = !1;

          var _iterator181 = _createForOfIteratorHelper(this._splitParts.keys()),
              _step181;

          try {
            for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
              var _e135 = _step181.value;
              _e135.isEmpty && (this.conversionApi.writer.remove(_e135), this._splitParts.delete(_e135), t = !0);
            }
          } catch (err) {
            _iterator181.e(err);
          } finally {
            _iterator181.f();
          }

          t && this._removeEmptyElements();
        }
      }]);

      return Wa;
    }();

    ci(Wa, ei);

    var Ya = /*#__PURE__*/function () {
      function Ya(t, e) {
        var _this50 = this;

        _classCallCheck(this, Ya);

        this.model = t, this.processor = e, this.mapper = new Qs(), this.downcastDispatcher = new Zs({
          mapper: this.mapper
        }), this.downcastDispatcher.on("insert:$text", function (t, e, n) {
          if (!n.consumable.consume(e.item, "insert")) return;
          var i = n.writer,
              o = n.mapper.toViewPosition(e.range.start),
              r = i.createText(e.item.data);
          i.insert(o, r);
        }, {
          priority: "lowest"
        }), this.upcastDispatcher = new Wa({
          schema: t.schema
        }), this.upcastDispatcher.on("text", function (t, e, n) {
          if (n.schema.checkChild(e.modelCursor, "$text") && n.consumable.consume(e.viewItem)) {
            var _t147 = n.writer.createText(e.viewItem.data);

            n.writer.insert(_t147, e.modelCursor), e.modelRange = Gs._createFromPositionAndShift(e.modelCursor, _t147.offsetSize), e.modelCursor = e.modelRange.end;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("element", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren = n.convertChildren(e.viewItem, e.modelCursor),
                _t148 = _n$convertChildren.modelRange,
                _i90 = _n$convertChildren.modelCursor;

            e.modelRange = _t148, e.modelCursor = _i90;
          }
        }, {
          priority: "lowest"
        }), this.upcastDispatcher.on("documentFragment", function (t, e, n) {
          if (!e.modelRange && n.consumable.consume(e.viewItem, {
            name: !0
          })) {
            var _n$convertChildren2 = n.convertChildren(e.viewItem, e.modelCursor),
                _t149 = _n$convertChildren2.modelRange,
                _i91 = _n$convertChildren2.modelCursor;

            e.modelRange = _t149, e.modelCursor = _i91;
          }
        }, {
          priority: "lowest"
        }), this.decorate("init"), this.on("init", function () {
          _this50.fire("ready");
        }, {
          priority: "lowest"
        });
      }

      _createClass(Ya, [{
        key: "get",
        value: function get(t) {
          var _ref44 = t || {},
              _ref44$rootName = _ref44.rootName,
              e = _ref44$rootName === void 0 ? "main" : _ref44$rootName,
              _ref44$trim = _ref44.trim,
              n = _ref44$trim === void 0 ? "empty" : _ref44$trim;

          if (!this._checkIfRootsExists([e])) throw new Gn.b("datacontroller-get-non-existent-root: Attempting to get data from a non-existing root.", this);
          var i = this.model.document.getRoot(e);
          return "empty" !== n || this.model.hasContent(i, {
            ignoreWhitespaces: !0
          }) ? this.stringify(i) : "";
        }
      }, {
        key: "stringify",
        value: function stringify(t) {
          var e = this.toView(t);
          return this.processor.toData(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          this.mapper.clearBindings();

          var e = Gs._createIn(t),
              n = new Ao(),
              i = new To(new ro());

          if (this.mapper.bindElements(t, n), this.downcastDispatcher.convertInsert(e, i), !t.is("documentFragment")) {
            var _e136 = function (t) {
              var e = [],
                  n = t.root.document;
              if (!n) return [];

              var i = Gs._createIn(t);

              var _iterator182 = _createForOfIteratorHelper(n.model.markers),
                  _step182;

              try {
                for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
                  var _t150 = _step182.value;

                  var _n123 = i.getIntersection(_t150.getRange());

                  _n123 && e.push([_t150.name, _n123]);
                }
              } catch (err) {
                _iterator182.e(err);
              } finally {
                _iterator182.f();
              }

              return e;
            }(t);

            var _iterator183 = _createForOfIteratorHelper(_e136),
                _step183;

            try {
              for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
                var _ref47 = _step183.value;

                var _ref46 = _slicedToArray(_ref47, 2);

                var _t151 = _ref46[0];
                var _n124 = _ref46[1];
                this.downcastDispatcher.convertMarkerAdd(_t151, _n124, i);
              }
            } catch (err) {
              _iterator183.e(err);
            } finally {
              _iterator183.f();
            }
          }

          return n;
        }
      }, {
        key: "init",
        value: function init(t) {
          var _this51 = this;

          if (this.model.document.version) throw new Gn.b("datacontroller-init-document-not-empty: Trying to set initial data to not empty document.", this);
          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new Gn.b("datacontroller-init-non-existent-root: Attempting to init data on a non-existing root.", this);
          return this.model.enqueueChange("transparent", function (t) {
            for (var _i92 = 0, _Object$keys = Object.keys(e); _i92 < _Object$keys.length; _i92++) {
              var _n125 = _Object$keys[_i92];

              var _i93 = _this51.model.document.getRoot(_n125);

              t.insert(_this51.parse(e[_n125], _i93), _i93, 0);
            }
          }), Promise.resolve();
        }
      }, {
        key: "set",
        value: function set(t) {
          var _this52 = this;

          var e = {};
          if ("string" == typeof t ? e.main = t : e = t, !this._checkIfRootsExists(Object.keys(e))) throw new Gn.b("datacontroller-set-non-existent-root: Attempting to set data on a non-existing root.", this);
          this.model.enqueueChange("transparent", function (t) {
            t.setSelection(null), t.removeSelectionAttribute(_this52.model.document.selection.getAttributeKeys());

            for (var _i94 = 0, _Object$keys2 = Object.keys(e); _i94 < _Object$keys2.length; _i94++) {
              var _n126 = _Object$keys2[_i94];

              var _i95 = _this52.model.document.getRoot(_n126);

              t.remove(t.createRangeIn(_i95)), t.insert(_this52.parse(e[_n126], _i95), _i95, 0);
            }
          });
        }
      }, {
        key: "parse",
        value: function parse(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          var n = this.processor.toView(t);
          return this.toModel(n, e);
        }
      }, {
        key: "toModel",
        value: function toModel(t) {
          var _this53 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          return this.model.change(function (n) {
            return _this53.upcastDispatcher.convert(t, n, e);
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_checkIfRootsExists",
        value: function _checkIfRootsExists(t) {
          var _iterator184 = _createForOfIteratorHelper(t),
              _step184;

          try {
            for (_iterator184.s(); !(_step184 = _iterator184.n()).done;) {
              var _e137 = _step184.value;
              if (!this.model.document.getRootNames().includes(_e137)) return !1;
            }
          } catch (err) {
            _iterator184.e(err);
          } finally {
            _iterator184.f();
          }

          return !0;
        }
      }]);

      return Ya;
    }();

    ci(Ya, Fi);

    var $a = /*#__PURE__*/function () {
      function $a(t, e) {
        _classCallCheck(this, $a);

        this._helpers = new Map(), this._downcast = Array.isArray(t) ? t : [t], this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: !0
        }), this._upcast = Array.isArray(e) ? e : [e], this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: !1
        });
      }

      _createClass($a, [{
        key: "addAlias",
        value: function addAlias(t, e) {
          var n = this._downcast.includes(e);

          if (!this._upcast.includes(e) && !n) throw new Gn.b("conversion-add-alias-dispatcher-not-registered: Trying to register and alias for a dispatcher that nas not been registered.", this);

          this._createConversionHelpers({
            name: t,
            dispatchers: [e],
            isDowncast: n
          });
        }
      }, {
        key: "for",
        value: function _for(t) {
          if (!this._helpers.has(t)) throw new Gn.b("conversion-for-unknown-group: Trying to add a converter to an unknown dispatchers group.", this);
          return this._helpers.get(t);
        }
      }, {
        key: "elementToElement",
        value: function elementToElement(t) {
          this.for("downcast").elementToElement(t);

          var _iterator185 = _createForOfIteratorHelper(Ga(t)),
              _step185;

          try {
            for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
              var _ref49 = _step185.value;
              var _e138 = _ref49.model;
              var _n127 = _ref49.view;
              this.for("upcast").elementToElement({
                model: _e138,
                view: _n127,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _iterator185.e(err);
          } finally {
            _iterator185.f();
          }
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          this.for("downcast").attributeToElement(t);

          var _iterator186 = _createForOfIteratorHelper(Ga(t)),
              _step186;

          try {
            for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
              var _ref51 = _step186.value;
              var _e139 = _ref51.model;
              var _n128 = _ref51.view;
              this.for("upcast").elementToAttribute({
                view: _n128,
                model: _e139,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _iterator186.e(err);
          } finally {
            _iterator186.f();
          }
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          this.for("downcast").attributeToAttribute(t);

          var _iterator187 = _createForOfIteratorHelper(Ga(t)),
              _step187;

          try {
            for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
              var _ref53 = _step187.value;
              var _e140 = _ref53.model;
              var _n129 = _ref53.view;
              this.for("upcast").attributeToAttribute({
                view: _n129,
                model: _e140
              });
            }
          } catch (err) {
            _iterator187.e(err);
          } finally {
            _iterator187.f();
          }
        }
      }, {
        key: "_createConversionHelpers",
        value: function _createConversionHelpers(_ref54) {
          var t = _ref54.name,
              e = _ref54.dispatchers,
              n = _ref54.isDowncast;
          if (this._helpers.has(t)) throw new Gn.b("conversion-group-exists: Trying to register a group name that has already been registered.", this);
          var i = n ? new fa(e) : new ka(e);

          this._helpers.set(t, i);
        }
      }]);

      return $a;
    }();

    function Ga(t) {
      var _iterator188, _step188, _e141;

      return _regeneratorRuntime.wrap(function Ga$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              if (!t.model.values) {
                _context29.next = 19;
                break;
              }

              _iterator188 = _createForOfIteratorHelper(t.model.values);
              _context29.prev = 2;

              _iterator188.s();

            case 4:
              if ((_step188 = _iterator188.n()).done) {
                _context29.next = 9;
                break;
              }

              _e141 = _step188.value;
              return _context29.delegateYield(Qa({
                key: t.model.key,
                value: _e141
              }, t.view[_e141], t.upcastAlso ? t.upcastAlso[_e141] : void 0), "t0", 7);

            case 7:
              _context29.next = 4;
              break;

            case 9:
              _context29.next = 14;
              break;

            case 11:
              _context29.prev = 11;
              _context29.t1 = _context29["catch"](2);

              _iterator188.e(_context29.t1);

            case 14:
              _context29.prev = 14;

              _iterator188.f();

              return _context29.finish(14);

            case 17:
              _context29.next = 20;
              break;

            case 19:
              return _context29.delegateYield(Qa(t.model, t.view, t.upcastAlso), "t2", 20);

            case 20:
            case "end":
              return _context29.stop();
          }
        }
      }, _marked, null, [[2, 11, 14, 17]]);
    }

    function Qa(t, e, n) {
      var _iterator189, _step189, _e142;

      return _regeneratorRuntime.wrap(function Qa$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return {
                model: t,
                view: e
              };

            case 2:
              if (!n) {
                _context30.next = 21;
                break;
              }

              n = Array.isArray(n) ? n : [n];
              _iterator189 = _createForOfIteratorHelper(n);
              _context30.prev = 5;

              _iterator189.s();

            case 7:
              if ((_step189 = _iterator189.n()).done) {
                _context30.next = 13;
                break;
              }

              _e142 = _step189.value;
              _context30.next = 11;
              return {
                model: t,
                view: _e142
              };

            case 11:
              _context30.next = 7;
              break;

            case 13:
              _context30.next = 18;
              break;

            case 15:
              _context30.prev = 15;
              _context30.t0 = _context30["catch"](5);

              _iterator189.e(_context30.t0);

            case 18:
              _context30.prev = 18;

              _iterator189.f();

              return _context30.finish(18);

            case 21:
            case "end":
              return _context30.stop();
          }
        }
      }, _marked2, null, [[5, 15, 18, 21]]);
    }

    var Ka = /*#__PURE__*/function () {
      function Ka() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";

        _classCallCheck(this, Ka);

        this.operations = [], this.type = t;
      }

      _createClass(Ka, [{
        key: "baseVersion",
        get: function get() {
          var _iterator190 = _createForOfIteratorHelper(this.operations),
              _step190;

          try {
            for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
              var _t152 = _step190.value;
              if (null !== _t152.baseVersion) return _t152.baseVersion;
            }
          } catch (err) {
            _iterator190.e(err);
          } finally {
            _iterator190.f();
          }

          return null;
        }
      }, {
        key: "addOperation",
        value: function addOperation(t) {
          return t.batch = this, this.operations.push(t), t;
        }
      }]);

      return Ka;
    }();

    var Ja = /*#__PURE__*/function () {
      function Ja(t) {
        _classCallCheck(this, Ja);

        this.baseVersion = t, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
      }

      _createClass(Ja, [{
        key: "_validate",
        value: function _validate() {}
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = Object.assign({}, this);
          return t.__className = this.constructor.className, delete t.batch, delete t.isDocumentOperation, t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "Operation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t) {
          return new this(t.baseVersion);
        }
      }]);

      return Ja;
    }();

    var Za = /*#__PURE__*/function (_Symbol$iterator11) {
      function Za(t) {
        _classCallCheck(this, Za);

        this.markers = new Map(), this._children = new Us(), t && this._insertChild(0, t);
      }

      _createClass(Za, [{
        key: _Symbol$iterator11,
        value: function value() {
          return this.getChildren();
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return 0 === this.childCount;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }, {
        key: "is",
        value: function is(t) {
          return "documentFragment" == t || "model:documentFragment" == t;
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "getPath",
        value: function getPath() {
          return [];
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;

          var _iterator191 = _createForOfIteratorHelper(t),
              _step191;

          try {
            for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
              var _n130 = _step191.value;
              e = e.getChild(e.offsetToIndex(_n130));
            }
          } catch (err) {
            _iterator191.e(err);
          } finally {
            _iterator191.f();
          }

          return e;
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = [];

          var _iterator192 = _createForOfIteratorHelper(this._children),
              _step192;

          try {
            for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
              var _e143 = _step192.value;
              t.push(_e143.toJSON());
            }
          } catch (err) {
            _iterator192.e(err);
          } finally {
            _iterator192.f();
          }

          return t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = function (t) {
            if ("string" == typeof t) return [new Bs(t)];
            pi(t) || (t = [t]);
            return Array.from(t).map(function (t) {
              return "string" == typeof t ? new Bs(t) : t instanceof Fs ? new Bs(t.data, t.getAttributes()) : t;
            });
          }(e);

          var _iterator193 = _createForOfIteratorHelper(n),
              _step193;

          try {
            for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
              var _t153 = _step193.value;
              null !== _t153.parent && _t153._remove(), _t153.parent = this;
            }
          } catch (err) {
            _iterator193.e(err);
          } finally {
            _iterator193.f();
          }

          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

          var n = this._children._removeNodes(t, e);

          var _iterator194 = _createForOfIteratorHelper(n),
              _step194;

          try {
            for (_iterator194.s(); !(_step194 = _iterator194.n()).done;) {
              var _t154 = _step194.value;
              _t154.parent = null;
            }
          } catch (err) {
            _iterator194.e(err);
          } finally {
            _iterator194.f();
          }

          return n;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = [];

          var _iterator195 = _createForOfIteratorHelper(t),
              _step195;

          try {
            for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
              var _n131 = _step195.value;
              _n131.name ? e.push(Hs.fromJSON(_n131)) : e.push(Bs.fromJSON(_n131));
            }
          } catch (err) {
            _iterator195.e(err);
          } finally {
            _iterator195.f();
          }

          return new Za(e);
        }
      }]);

      return Za;
    }(Symbol.iterator);

    function Xa(t, e) {
      var n = (e = nc(e)).reduce(function (t, e) {
        return t + e.offsetSize;
      }, 0),
          i = t.parent;
      oc(t);
      var o = t.index;
      return i._insertChild(o, e), ic(i, o + e.length), ic(i, o), new Gs(t, t.getShiftedBy(n));
    }

    function tc(t) {
      if (!t.isFlat) throw new Gn.b("operation-utils-remove-range-not-flat: Trying to remove a range which starts and ends in different element.", this);
      var e = t.start.parent;
      oc(t.start), oc(t.end);

      var n = e._removeChildren(t.start.index, t.end.index - t.start.index);

      return ic(e, t.start.index), n;
    }

    function ec(t, e) {
      if (!t.isFlat) throw new Gn.b("operation-utils-move-range-not-flat: Trying to move a range which starts and ends in different element.", this);
      var n = tc(t);
      return Xa(e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset), n);
    }

    function nc(t) {
      var e = [];
      t instanceof Array || (t = [t]);

      for (var _n132 = 0; _n132 < t.length; _n132++) {
        if ("string" == typeof t[_n132]) e.push(new Bs(t[_n132]));else if (t[_n132] instanceof Fs) e.push(new Bs(t[_n132].data, t[_n132].getAttributes()));else if (t[_n132] instanceof Za || t[_n132] instanceof Us) {
          var _iterator196 = _createForOfIteratorHelper(t[_n132]),
              _step196;

          try {
            for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
              var _i96 = _step196.value;
              e.push(_i96);
            }
          } catch (err) {
            _iterator196.e(err);
          } finally {
            _iterator196.f();
          }
        } else t[_n132] instanceof zs && e.push(t[_n132]);
      }

      for (var _t155 = 1; _t155 < e.length; _t155++) {
        var _n133 = e[_t155],
            _i97 = e[_t155 - 1];
        _n133 instanceof Bs && _i97 instanceof Bs && rc(_n133, _i97) && (e.splice(_t155 - 1, 2, new Bs(_i97.data + _n133.data, _i97.getAttributes())), _t155--);
      }

      return e;
    }

    function ic(t, e) {
      var n = t.getChild(e - 1),
          i = t.getChild(e);

      if (n && i && n.is("text") && i.is("text") && rc(n, i)) {
        var _o38 = new Bs(n.data + i.data, n.getAttributes());

        t._removeChildren(e - 1, 2), t._insertChild(e - 1, _o38);
      }
    }

    function oc(t) {
      var e = t.textNode,
          n = t.parent;

      if (e) {
        var _i98 = t.offset - e.startOffset,
            _o39 = e.index;

        n._removeChildren(_o39, 1);

        var _r14 = new Bs(e.data.substr(0, _i98), e.getAttributes()),
            _s12 = new Bs(e.data.substr(_i98), e.getAttributes());

        n._insertChild(_o39, [_r14, _s12]);
      }
    }

    function rc(t, e) {
      var n = t.getAttributes(),
          i = e.getAttributes();

      var _iterator197 = _createForOfIteratorHelper(n),
          _step197;

      try {
        for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
          var _t156 = _step197.value;
          if (_t156[1] !== e.getAttribute(_t156[0])) return !1;
          i.next();
        }
      } catch (err) {
        _iterator197.e(err);
      } finally {
        _iterator197.f();
      }

      return i.next().done;
    }

    var sc = function sc(t, e) {
      return Kr(t, e);
    };

    var ac = /*#__PURE__*/function (_Ja) {
      _inherits(ac, _Ja);

      var _super24 = _createSuper(ac);

      function ac(t, e, n, i, o) {
        var _this54;

        _classCallCheck(this, ac);

        _this54 = _super24.call(this, o), _this54.range = t.clone(), _this54.key = e, _this54.oldValue = void 0 === n ? null : n, _this54.newValue = void 0 === i ? null : i;
        return _this54;
      }

      _createClass(ac, [{
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
        }
      }, {
        key: "clone",
        value: function clone() {
          return new ac(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new ac(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(ac.prototype), "toJSON", this).call(this);

          return t.range = this.range.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (!this.range.isFlat) throw new Gn.b("attribute-operation-range-not-flat: The range to change is not flat.", this);

          var _iterator198 = _createForOfIteratorHelper(this.range.getItems({
            shallow: !0
          })),
              _step198;

          try {
            for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
              var _t157 = _step198.value;
              if (null !== this.oldValue && !sc(_t157.getAttribute(this.key), this.oldValue)) throw new Gn.b("attribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, {
                item: _t157,
                key: this.key,
                value: this.oldValue
              });
              if (null === this.oldValue && null !== this.newValue && _t157.hasAttribute(this.key)) throw new Gn.b("attribute-operation-attribute-exists: The attribute with given key already exists.", this, {
                node: _t157,
                key: this.key
              });
            }
          } catch (err) {
            _iterator198.e(err);
          } finally {
            _iterator198.f();
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          sc(this.oldValue, this.newValue) || function (t, e, n) {
            oc(t.start), oc(t.end);

            var _iterator199 = _createForOfIteratorHelper(t.getItems({
              shallow: !0
            })),
                _step199;

            try {
              for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
                var _i99 = _step199.value;

                var _t158 = _i99.is("textProxy") ? _i99.textNode : _i99;

                null !== n ? _t158._setAttribute(e, n) : _t158._removeAttribute(e), ic(_t158.parent, _t158.index);
              }
            } catch (err) {
              _iterator199.e(err);
            } finally {
              _iterator199.f();
            }

            ic(t.end.parent, t.end.index);
          }(this.range, this.key, this.newValue);
        }
      }], [{
        key: "className",
        get: function get() {
          return "AttributeOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new ac(Gs.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }]);

      return ac;
    }(Ja);

    var cc = /*#__PURE__*/function (_Ja2) {
      _inherits(cc, _Ja2);

      var _super25 = _createSuper(cc);

      function cc(t, e) {
        var _this55;

        _classCallCheck(this, cc);

        _this55 = _super25.call(this, null), _this55.sourcePosition = t.clone(), _this55.howMany = e;
        return _this55;
      }

      _createClass(cc, [{
        key: "type",
        get: function get() {
          return "detach";
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(cc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = this.sourcePosition.toJSON(), t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.sourcePosition.root.document) throw new Gn.b("detach-operation-on-document-node: Cannot detach document node.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          tc(Gs._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
      }], [{
        key: "className",
        get: function get() {
          return "DetachOperation";
        }
      }]);

      return cc;
    }(Ja);

    var lc = /*#__PURE__*/function (_Ja3) {
      _inherits(lc, _Ja3);

      var _super26 = _createSuper(lc);

      function lc(t, e, n, i) {
        var _this56;

        _classCallCheck(this, lc);

        _this56 = _super26.call(this, i), _this56.sourcePosition = t.clone(), _this56.sourcePosition.stickiness = "toNext", _this56.howMany = e, _this56.targetPosition = n.clone(), _this56.targetPosition.stickiness = "toNone";
        return _this56;
      }

      _createClass(lc, [{
        key: "type",
        get: function get() {
          return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
      }, {
        key: "getMovedRangeStart",
        value: function getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);

          return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
              e = this.targetPosition.parent,
              n = this.sourcePosition.offset,
              i = this.targetPosition.offset;
          if (n + this.howMany > t.maxOffset) throw new Gn.b("move-operation-nodes-do-not-exist: The nodes which should be moved do not exist.", this);
          if (t === e && n < i && i < n + this.howMany) throw new Gn.b("move-operation-range-into-itself: Trying to move a range of nodes to the inside of that range.", this);

          if (this.sourcePosition.root == this.targetPosition.root && "prefix" == li(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
            var _t159 = this.sourcePosition.path.length - 1;

            if (this.targetPosition.path[_t159] >= n && this.targetPosition.path[_t159] < n + this.howMany) throw new Gn.b("move-operation-node-into-itself: Trying to move a range of nodes into one of nodes from that range.", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          ec(Gs._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(lc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = this.sourcePosition.toJSON(), t.targetPosition = this.targetPosition.toJSON(), t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "MoveOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = $s.fromJSON(t.sourcePosition, e),
              i = $s.fromJSON(t.targetPosition, e);
          return new this(n, t.howMany, i, t.baseVersion);
        }
      }]);

      return lc;
    }(Ja);

    var dc = /*#__PURE__*/function (_Ja4) {
      _inherits(dc, _Ja4);

      var _super27 = _createSuper(dc);

      function dc(t, e, n) {
        var _this57;

        _classCallCheck(this, dc);

        _this57 = _super27.call(this, n), _this57.position = t.clone(), _this57.position.stickiness = "toNone", _this57.nodes = new Us(nc(e)), _this57.shouldReceiveAttributes = !1;
        return _this57;
      }

      _createClass(dc, [{
        key: "type",
        get: function get() {
          return "insert";
        }
      }, {
        key: "howMany",
        get: function get() {
          return this.nodes.maxOffset;
        }
      }, {
        key: "clone",
        value: function clone() {
          var t = new Us(_toConsumableArray(this.nodes).map(function (t) {
            return t._clone(!0);
          })),
              e = new dc(this.position, t, this.baseVersion);
          return e.shouldReceiveAttributes = this.shouldReceiveAttributes, e;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.position.root.document.graveyard,
              e = new $s(t, [0]);
          return new lc(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.parent;
          if (!t || t.maxOffset < this.position.offset) throw new Gn.b("insert-operation-position-invalid: Insertion position is invalid.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.nodes;
          this.nodes = new Us(_toConsumableArray(t).map(function (t) {
            return t._clone(!0);
          })), Xa(this.position, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(dc.prototype), "toJSON", this).call(this);

          return t.position = this.position.toJSON(), t.nodes = this.nodes.toJSON(), t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "InsertOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = [];

          var _iterator200 = _createForOfIteratorHelper(t.nodes),
              _step200;

          try {
            for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
              var _e144 = _step200.value;
              _e144.name ? n.push(Hs.fromJSON(_e144)) : n.push(Bs.fromJSON(_e144));
            }
          } catch (err) {
            _iterator200.e(err);
          } finally {
            _iterator200.f();
          }

          var i = new dc($s.fromJSON(t.position, e), n, t.baseVersion);
          return i.shouldReceiveAttributes = t.shouldReceiveAttributes, i;
        }
      }]);

      return dc;
    }(Ja);

    var hc = /*#__PURE__*/function (_Ja5) {
      _inherits(hc, _Ja5);

      var _super28 = _createSuper(hc);

      function hc(t, e, n, i, o, r) {
        var _this58;

        _classCallCheck(this, hc);

        _this58 = _super28.call(this, r), _this58.name = t, _this58.oldRange = e ? e.clone() : null, _this58.newRange = n ? n.clone() : null, _this58.affectsData = o, _this58._markers = i;
        return _this58;
      }

      _createClass(hc, [{
        key: "type",
        get: function get() {
          return "marker";
        }
      }, {
        key: "clone",
        value: function clone() {
          return new hc(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new hc(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.newRange ? "_set" : "_remove";

          this._markers[t](this.name, this.newRange, !0, this.affectsData);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(hc.prototype), "toJSON", this).call(this);

          return this.oldRange && (t.oldRange = this.oldRange.toJSON()), this.newRange && (t.newRange = this.newRange.toJSON()), delete t._markers, t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "MarkerOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new hc(t.name, t.oldRange ? Gs.fromJSON(t.oldRange, e) : null, t.newRange ? Gs.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
        }
      }]);

      return hc;
    }(Ja);

    var uc = /*#__PURE__*/function (_Ja6) {
      _inherits(uc, _Ja6);

      var _super29 = _createSuper(uc);

      function uc(t, e, n, i) {
        var _this59;

        _classCallCheck(this, uc);

        _this59 = _super29.call(this, i), _this59.position = t, _this59.position.stickiness = "toNext", _this59.oldName = e, _this59.newName = n;
        return _this59;
      }

      _createClass(uc, [{
        key: "type",
        get: function get() {
          return "rename";
        }
      }, {
        key: "clone",
        value: function clone() {
          return new uc(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new uc(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.nodeAfter;
          if (!(t instanceof Hs)) throw new Gn.b("rename-operation-wrong-position: Given position is invalid or node after it is not an instance of Element.", this);
          if (t.name !== this.oldName) throw new Gn.b("rename-operation-wrong-name: Element to change has different name than operation's old name.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          this.position.nodeAfter.name = this.newName;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(uc.prototype), "toJSON", this).call(this);

          return t.position = this.position.toJSON(), t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "RenameOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new uc($s.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
        }
      }]);

      return uc;
    }(Ja);

    var fc = /*#__PURE__*/function (_Ja7) {
      _inherits(fc, _Ja7);

      var _super30 = _createSuper(fc);

      function fc(t, e, n, i, o) {
        var _this60;

        _classCallCheck(this, fc);

        _this60 = _super30.call(this, o), _this60.root = t, _this60.key = e, _this60.oldValue = n, _this60.newValue = i;
        return _this60;
      }

      _createClass(fc, [{
        key: "type",
        get: function get() {
          return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
        }
      }, {
        key: "clone",
        value: function clone() {
          return new fc(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new fc(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment")) throw new Gn.b("rootattribute-operation-not-a-root: The element to change is not a root element.", this, {
            root: this.root,
            key: this.key
          });
          if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue) throw new Gn.b("rootattribute-operation-wrong-old-value: Changed node has different attribute value than operation's old attribute value.", this, {
            root: this.root,
            key: this.key
          });
          if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key)) throw new Gn.b("rootattribute-operation-attribute-exists: The attribute with given key already exists.", this, {
            root: this.root,
            key: this.key
          });
        }
      }, {
        key: "_execute",
        value: function _execute() {
          null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(fc.prototype), "toJSON", this).call(this);

          return t.root = this.root.toJSON(), t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "RootAttributeOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if (!e.getRoot(t.root)) throw new Gn.b("rootattribute-operation-fromjson-no-root: Cannot create RootAttributeOperation. Root with specified name does not exist.", this, {
            rootName: t.root
          });
          return new fc(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }]);

      return fc;
    }(Ja);

    var mc = /*#__PURE__*/function (_Ja8) {
      _inherits(mc, _Ja8);

      var _super31 = _createSuper(mc);

      function mc(t, e, n, i, o) {
        var _this61;

        _classCallCheck(this, mc);

        _this61 = _super31.call(this, o), _this61.sourcePosition = t.clone(), _this61.sourcePosition.stickiness = "toPrevious", _this61.howMany = e, _this61.targetPosition = n.clone(), _this61.targetPosition.stickiness = "toNext", _this61.graveyardPosition = i.clone();
        return _this61;
      }

      _createClass(mc, [{
        key: "type",
        get: function get() {
          return "merge";
        }
      }, {
        key: "deletionPosition",
        get: function get() {
          return new $s(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new Gs(this.sourcePosition, t);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.targetPosition._getTransformedByMergeOperation(this),
              e = this.sourcePosition.path.slice(0, -1),
              n = new $s(this.sourcePosition.root, e)._getTransformedByMergeOperation(this),
              i = new gc(t, this.howMany, this.graveyardPosition, this.baseVersion + 1);

          return i.insertionPosition = n, i;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent,
              e = this.targetPosition.parent;
          if (!t.parent) throw new Gn.b("merge-operation-source-position-invalid: Merge source position is invalid.", this);
          if (!e.parent) throw new Gn.b("merge-operation-target-position-invalid: Merge target position is invalid.", this);
          if (this.howMany != t.maxOffset) throw new Gn.b("merge-operation-how-many-invalid: Merge operation specifies wrong number of nodes to move.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.sourcePosition.parent;
          ec(Gs._createIn(t), this.targetPosition), ec(Gs._createOn(t), this.graveyardPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(mc.prototype), "toJSON", this).call(this);

          return t.sourcePosition = t.sourcePosition.toJSON(), t.targetPosition = t.targetPosition.toJSON(), t.graveyardPosition = t.graveyardPosition.toJSON(), t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "MergeOperation";
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = $s.fromJSON(t.sourcePosition, e),
              i = $s.fromJSON(t.targetPosition, e),
              o = $s.fromJSON(t.graveyardPosition, e);
          return new this(n, t.howMany, i, o, t.baseVersion);
        }
      }]);

      return mc;
    }(Ja);

    var gc = /*#__PURE__*/function (_Ja9) {
      _inherits(gc, _Ja9);

      var _super32 = _createSuper(gc);

      function gc(t, e, n, i) {
        var _this62;

        _classCallCheck(this, gc);

        _this62 = _super32.call(this, i), _this62.splitPosition = t.clone(), _this62.splitPosition.stickiness = "toNext", _this62.howMany = e, _this62.insertionPosition = gc.getInsertionPosition(t), _this62.insertionPosition.stickiness = "toNone", _this62.graveyardPosition = n ? n.clone() : null, _this62.graveyardPosition && (_this62.graveyardPosition.stickiness = "toNext");
        return _this62;
      }

      _createClass(gc, [{
        key: "type",
        get: function get() {
          return "split";
        }
      }, {
        key: "moveTargetPosition",
        get: function get() {
          var t = this.insertionPosition.path.slice();
          return t.push(0), new $s(this.insertionPosition.root, t);
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new Gs(this.splitPosition, t);
        }
      }, {
        key: "clone",
        value: function clone() {
          var t = new this.constructor(this.splitPosition, this.howMany, this.graveyardPosition, this.baseVersion);
          return t.insertionPosition = this.insertionPosition, t;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.splitPosition.root.document.graveyard,
              e = new $s(t, [0]);
          return new mc(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.splitPosition.parent,
              e = this.splitPosition.offset;
          if (!t || t.maxOffset < e) throw new Gn.b("split-operation-position-invalid: Split position is invalid.", this);
          if (!t.parent) throw new Gn.b("split-operation-split-in-root: Cannot split root element.", this);
          if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new Gn.b("split-operation-how-many-invalid: Split operation specifies wrong number of nodes to move.", this);
          if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new Gn.b("split-operation-graveyard-position-invalid: Graveyard position invalid.", this);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.splitPosition.parent;
          if (this.graveyardPosition) ec(Gs._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);else {
            var _e145 = t._clone();

            Xa(this.insertionPosition, _e145);
          }
          ec(new Gs($s._createAt(t, this.splitPosition.offset), $s._createAt(t, t.maxOffset)), this.moveTargetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(gc.prototype), "toJSON", this).call(this);

          return t.splitPosition = this.splitPosition.toJSON(), t.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t.graveyardPosition = this.graveyardPosition.toJSON()), t;
        }
      }], [{
        key: "className",
        get: function get() {
          return "SplitOperation";
        }
      }, {
        key: "getInsertionPosition",
        value: function getInsertionPosition(t) {
          var e = t.path.slice(0, -1);
          return e[e.length - 1]++, new $s(t.root, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = $s.fromJSON(t.splitPosition, e),
              i = $s.fromJSON(t.insertionPosition, e),
              o = t.graveyardPosition ? $s.fromJSON(t.graveyardPosition, e) : null,
              r = new this(n, t.howMany, o, t.baseVersion);
          return r.insertionPosition = i, r;
        }
      }]);

      return gc;
    }(Ja);

    var pc = /*#__PURE__*/function (_Hs) {
      _inherits(pc, _Hs);

      var _super33 = _createSuper(pc);

      function pc(t, e) {
        var _this63;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";

        _classCallCheck(this, pc);

        _this63 = _super33.call(this, e), _this63._doc = t, _this63.rootName = n;
        return _this63;
      }

      _createClass(pc, [{
        key: "document",
        get: function get() {
          return this._doc;
        }
      }, {
        key: "is",
        value: function is(t, e) {
          var n = t.replace("model:", "");
          return e ? "rootElement" == n && e == this.name || _get(_getPrototypeOf(pc.prototype), "is", this).call(this, t, e) : "rootElement" == n || _get(_getPrototypeOf(pc.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this.rootName;
        }
      }]);

      return pc;
    }(Hs);

    var bc = /*#__PURE__*/function () {
      function bc(t, e) {
        _classCallCheck(this, bc);

        this.model = t, this.batch = e;
      }

      _createClass(bc, [{
        key: "createText",
        value: function createText(t, e) {
          return new Bs(t, e);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e) {
          return new Hs(t, e);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment() {
          return new Za();
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          if (this._assertWriterUsedCorrectly(), t instanceof Bs && "" == t.data) return;

          var i = $s._createAt(e, n);

          if (t.parent) {
            if (yc(t.root, i.root)) return void this.move(Gs._createOn(t), i);
            if (t.root.document) throw new Gn.b("model-writer-insert-forbidden-move: Cannot move a node from a document to a different tree. It is forbidden to move a node that was already in a document outside of it.", this);
            this.remove(t);
          }

          var o = i.root.document ? i.root.document.version : null,
              r = new dc(i, t, o);

          if (t instanceof Bs && (r.shouldReceiveAttributes = !0), this.batch.addOperation(r), this.model.applyOperation(r), t instanceof Za) {
            var _iterator201 = _createForOfIteratorHelper(t.markers),
                _step201;

            try {
              for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
                var _ref57 = _step201.value;

                var _ref56 = _slicedToArray(_ref57, 2);

                var _e146 = _ref56[0];
                var _n134 = _ref56[1];

                var _t160 = $s._createAt(_n134.root, 0),
                    _o40 = {
                  range: new Gs(_n134.start._getCombined(_t160, i), _n134.end._getCombined(_t160, i)),
                  usingOperation: !0,
                  affectsData: !0
                };

                this.model.markers.has(_e146) ? this.updateMarker(_e146, _o40) : this.addMarker(_e146, _o40);
              }
            } catch (err) {
              _iterator201.e(err);
            } finally {
              _iterator201.f();
            }
          }
        }
      }, {
        key: "insertText",
        value: function insertText(t, e, n, i) {
          e instanceof Za || e instanceof Hs || e instanceof $s ? this.insert(this.createText(t), e, n) : this.insert(this.createText(t, e), n, i);
        }
      }, {
        key: "insertElement",
        value: function insertElement(t, e, n, i) {
          e instanceof Za || e instanceof Hs || e instanceof $s ? this.insert(this.createElement(t), e, n) : this.insert(this.createElement(t, e), n, i);
        }
      }, {
        key: "append",
        value: function append(t, e) {
          this.insert(t, e, "end");
        }
      }, {
        key: "appendText",
        value: function appendText(t, e, n) {
          e instanceof Za || e instanceof Hs ? this.insert(this.createText(t), e, "end") : this.insert(this.createText(t, e), n, "end");
        }
      }, {
        key: "appendElement",
        value: function appendElement(t, e, n) {
          e instanceof Za || e instanceof Hs ? this.insert(this.createElement(t), e, "end") : this.insert(this.createElement(t, e), n, "end");
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          if (this._assertWriterUsedCorrectly(), n instanceof Gs) {
            var _i100 = n.getMinimalFlatRanges();

            var _iterator202 = _createForOfIteratorHelper(_i100),
                _step202;

            try {
              for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
                var _n135 = _step202.value;
                wc(this, t, e, _n135);
              }
            } catch (err) {
              _iterator202.e(err);
            } finally {
              _iterator202.f();
            }
          } else kc(this, t, e, n);
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(t, e) {
          var _iterator203 = _createForOfIteratorHelper(Vs(t)),
              _step203;

          try {
            for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
              var _ref60 = _step203.value;

              var _ref59 = _slicedToArray(_ref60, 2);

              var _n136 = _ref59[0];
              var _i101 = _ref59[1];
              this.setAttribute(_n136, _i101, e);
            }
          } catch (err) {
            _iterator203.e(err);
          } finally {
            _iterator203.f();
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), e instanceof Gs) {
            var _n137 = e.getMinimalFlatRanges();

            var _iterator204 = _createForOfIteratorHelper(_n137),
                _step204;

            try {
              for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
                var _e147 = _step204.value;
                wc(this, t, null, _e147);
              }
            } catch (err) {
              _iterator204.e(err);
            } finally {
              _iterator204.f();
            }
          } else kc(this, t, null, e);
        }
      }, {
        key: "clearAttributes",
        value: function clearAttributes(t) {
          var _this64 = this;

          this._assertWriterUsedCorrectly();

          var e = function e(t) {
            var _iterator205 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step205;

            try {
              for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
                var _e148 = _step205.value;

                _this64.removeAttribute(_e148, t);
              }
            } catch (err) {
              _iterator205.e(err);
            } finally {
              _iterator205.f();
            }
          };

          if (t instanceof Gs) {
            var _iterator206 = _createForOfIteratorHelper(t.getItems()),
                _step206;

            try {
              for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
                var _n138 = _step206.value;
                e(_n138);
              }
            } catch (err) {
              _iterator206.e(err);
            } finally {
              _iterator206.f();
            }
          } else e(t);
        }
      }, {
        key: "move",
        value: function move(t, e, n) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof Gs)) throw new Gn.b("writer-move-invalid-range: Invalid range to move.", this);
          if (!t.isFlat) throw new Gn.b("writer-move-range-not-flat: Range to move is not flat.", this);

          var i = $s._createAt(e, n);

          if (i.isEqual(t.start)) return;
          if (this._addOperationForAffectedMarkers("move", t), !yc(t.root, i.root)) throw new Gn.b("writer-move-different-document: Range is going to be moved between different documents.", this);
          var o = t.root.document ? t.root.document.version : null,
              r = new lc(t.start, t.end.offset - t.start.offset, i, o);
          this.batch.addOperation(r), this.model.applyOperation(r);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._assertWriterUsedCorrectly();

          var e = (t instanceof Gs ? t : Gs._createOn(t)).getMinimalFlatRanges().reverse();

          var _iterator207 = _createForOfIteratorHelper(e),
              _step207;

          try {
            for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
              var _t161 = _step207.value;
              this._addOperationForAffectedMarkers("move", _t161), vc(_t161.start, _t161.end.offset - _t161.start.offset, this.batch, this.model);
            }
          } catch (err) {
            _iterator207.e(err);
          } finally {
            _iterator207.f();
          }
        }
      }, {
        key: "merge",
        value: function merge(t) {
          this._assertWriterUsedCorrectly();

          var e = t.nodeBefore,
              n = t.nodeAfter;
          if (this._addOperationForAffectedMarkers("merge", t), !(e instanceof Hs)) throw new Gn.b("writer-merge-no-element-before: Node before merge position must be an element.", this);
          if (!(n instanceof Hs)) throw new Gn.b("writer-merge-no-element-after: Node after merge position must be an element.", this);
          t.root.document ? this._merge(t) : this._mergeDetached(t);
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return this.model.createPositionFromPath(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return this.model.createPositionAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return this.model.createPositionAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return this.model.createPositionBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return this.model.createRange(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return this.model.createRangeIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return this.model.createRangeOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return this.model.createSelection(t, e, n);
        }
      }, {
        key: "_mergeDetached",
        value: function _mergeDetached(t) {
          var e = t.nodeBefore,
              n = t.nodeAfter;
          this.move(Gs._createIn(n), $s._createAt(e, "end")), this.remove(n);
        }
      }, {
        key: "_merge",
        value: function _merge(t) {
          var e = $s._createAt(t.nodeBefore, "end"),
              n = $s._createAt(t.nodeAfter, 0),
              i = t.root.document.graveyard,
              o = new $s(i, [0]),
              r = t.root.document.version,
              s = new mc(n, t.nodeAfter.maxOffset, e, o, r);

          this.batch.addOperation(s), this.model.applyOperation(s);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          if (this._assertWriterUsedCorrectly(), !(t instanceof Hs)) throw new Gn.b("writer-rename-not-element-instance: Trying to rename an object which is not an instance of Element.", this);
          var n = t.root.document ? t.root.document.version : null,
              i = new uc($s._createBefore(t), t.name, e, n);
          this.batch.addOperation(i), this.model.applyOperation(i);
        }
      }, {
        key: "split",
        value: function split(t, e) {
          this._assertWriterUsedCorrectly();

          var n,
              i,
              o = t.parent;
          if (!o.parent) throw new Gn.b("writer-split-element-no-parent: Element with no parent can not be split.", this);
          if (e || (e = o.parent), !t.parent.getAncestors({
            includeSelf: !0
          }).includes(e)) throw new Gn.b("writer-split-invalid-limit-element: Limit element is not a position ancestor.", this);

          do {
            var _e149 = o.root.document ? o.root.document.version : null,
                _r15 = o.maxOffset - t.offset,
                _s13 = new gc(t, _r15, null, _e149);

            this.batch.addOperation(_s13), this.model.applyOperation(_s13), n || i || (n = o, i = t.parent.nextSibling), o = (t = this.createPositionAfter(t.parent)).parent;
          } while (o !== e);

          return {
            position: t,
            range: new Gs($s._createAt(n, "end"), $s._createAt(i, 0))
          };
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (this._assertWriterUsedCorrectly(), !t.isFlat) throw new Gn.b("writer-wrap-range-not-flat: Range to wrap is not flat.", this);
          var n = e instanceof Hs ? e : new Hs(e);
          if (n.childCount > 0) throw new Gn.b("writer-wrap-element-not-empty: Element to wrap with is not empty.", this);
          if (null !== n.parent) throw new Gn.b("writer-wrap-element-attached: Element to wrap with is already attached to tree model.", this);
          this.insert(n, t.start);
          var i = new Gs(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
          this.move(i, $s._createAt(n, 0));
        }
      }, {
        key: "unwrap",
        value: function unwrap(t) {
          if (this._assertWriterUsedCorrectly(), null === t.parent) throw new Gn.b("writer-unwrap-element-no-parent: Trying to unwrap an element which has no parent.", this);
          this.move(Gs._createIn(t), this.createPositionAfter(t)), this.remove(t);
        }
      }, {
        key: "addMarker",
        value: function addMarker(t, e) {
          if (this._assertWriterUsedCorrectly(), !e || "boolean" != typeof e.usingOperation) throw new Gn.b("writer-addMarker-no-usingOperation: The options.usingOperation parameter is required when adding a new marker.", this);
          var n = e.usingOperation,
              i = e.range,
              o = void 0 !== e.affectsData && e.affectsData;
          if (this.model.markers.has(t)) throw new Gn.b("writer-addMarker-marker-exists: Marker with provided name already exists.", this);
          if (!i) throw new Gn.b("writer-addMarker-no-range: Range parameter is required when adding a new marker.", this);
          return n ? (_c(this, t, null, i, o), this.model.markers.get(t)) : this.model.markers._set(t, i, n, o);
        }
      }, {
        key: "updateMarker",
        value: function updateMarker(t, e) {
          this._assertWriterUsedCorrectly();

          var n = "string" == typeof t ? t : t.name,
              i = this.model.markers.get(n);
          if (!i) throw new Gn.b("writer-updateMarker-marker-not-exists: Marker with provided name does not exists.", this);
          if (!e) return void this.model.markers._refresh(i);
          var o = "boolean" == typeof e.usingOperation,
              r = "boolean" == typeof e.affectsData,
              s = r ? e.affectsData : i.affectsData;
          if (!o && !e.range && !r) throw new Gn.b("writer-updateMarker-wrong-options: One of the options is required - provide range, usingOperations or affectsData.", this);
          var a = i.getRange(),
              c = e.range ? e.range : a;
          o && e.usingOperation !== i.managedUsingOperations ? e.usingOperation ? _c(this, n, null, c, s) : (_c(this, n, a, null, s), this.model.markers._set(n, c, void 0, s)) : i.managedUsingOperations ? _c(this, n, a, c, s) : this.model.markers._set(n, c, void 0, s);
        }
      }, {
        key: "removeMarker",
        value: function removeMarker(t) {
          this._assertWriterUsedCorrectly();

          var e = "string" == typeof t ? t : t.name;
          if (!this.model.markers.has(e)) throw new Gn.b("writer-removeMarker-no-marker: Trying to remove marker which does not exist.", this);
          var n = this.model.markers.get(e);
          n.managedUsingOperations ? _c(this, e, n.getRange(), null, n.affectsData) : this.model.markers._remove(e);
        }
      }, {
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t, e);
        }
      }, {
        key: "setSelectionAttribute",
        value: function setSelectionAttribute(t, e) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._setSelectionAttribute(t, e);else {
            var _iterator208 = _createForOfIteratorHelper(Vs(t)),
                _step208;

            try {
              for (_iterator208.s(); !(_step208 = _iterator208.n()).done;) {
                var _ref63 = _step208.value;

                var _ref62 = _slicedToArray(_ref63, 2);

                var _e150 = _ref62[0];
                var _n139 = _ref62[1];

                this._setSelectionAttribute(_e150, _n139);
              }
            } catch (err) {
              _iterator208.e(err);
            } finally {
              _iterator208.f();
            }
          }
        }
      }, {
        key: "removeSelectionAttribute",
        value: function removeSelectionAttribute(t) {
          if (this._assertWriterUsedCorrectly(), "string" == typeof t) this._removeSelectionAttribute(t);else {
            var _iterator209 = _createForOfIteratorHelper(t),
                _step209;

            try {
              for (_iterator209.s(); !(_step209 = _iterator209.n()).done;) {
                var _e151 = _step209.value;

                this._removeSelectionAttribute(_e151);
              }
            } catch (err) {
              _iterator209.e(err);
            } finally {
              _iterator209.f();
            }
          }
        }
      }, {
        key: "overrideSelectionGravity",
        value: function overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
      }, {
        key: "restoreSelectionGravity",
        value: function restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t);
        }
      }, {
        key: "_setSelectionAttribute",
        value: function _setSelectionAttribute(t, e) {
          var n = this.model.document.selection;

          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            var _i102 = sa._getStoreAttributeKey(t);

            this.setAttribute(_i102, e, n.anchor.parent);
          }

          n._setAttribute(t, e);
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute(t) {
          var e = this.model.document.selection;

          if (e.isCollapsed && e.anchor.parent.isEmpty) {
            var _n140 = sa._getStoreAttributeKey(t);

            this.removeAttribute(_n140, e.anchor.parent);
          }

          e._removeAttribute(t);
        }
      }, {
        key: "_assertWriterUsedCorrectly",
        value: function _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) throw new Gn.b("writer-incorrect-use: Trying to use a writer outside the change() block.", this);
        }
      }, {
        key: "_addOperationForAffectedMarkers",
        value: function _addOperationForAffectedMarkers(t, e) {
          var _iterator210 = _createForOfIteratorHelper(this.model.markers),
              _step210;

          try {
            for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
              var _n141 = _step210.value;
              if (!_n141.managedUsingOperations) continue;

              var _i103 = _n141.getRange();

              var _o41 = !1;

              if ("move" == t) _o41 = e.containsPosition(_i103.start) || e.start.isEqual(_i103.start) || e.containsPosition(_i103.end) || e.end.isEqual(_i103.end);else {
                var _t162 = e.nodeBefore,
                    _n142 = e.nodeAfter,
                    _r16 = _i103.start.parent == _t162 && _i103.start.isAtEnd,
                    _s14 = _i103.end.parent == _n142 && 0 == _i103.end.offset,
                    _a8 = _i103.end.nodeAfter == _n142,
                    _c3 = _i103.start.nodeAfter == _n142;

                _o41 = _r16 || _s14 || _a8 || _c3;
              }
              _o41 && this.updateMarker(_n141.name, {
                range: _i103
              });
            }
          } catch (err) {
            _iterator210.e(err);
          } finally {
            _iterator210.f();
          }
        }
      }]);

      return bc;
    }();

    function wc(t, e, n, i) {
      var o = t.model,
          r = o.document;
      var s,
          a,
          c,
          l = i.start;

      var _iterator211 = _createForOfIteratorHelper(i.getWalker({
        shallow: !0
      })),
          _step211;

      try {
        for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
          var _t163 = _step211.value;
          c = _t163.item.getAttribute(e), s && a != c && (a != n && d(), l = s), s = _t163.nextPosition, a = c;
        }
      } catch (err) {
        _iterator211.e(err);
      } finally {
        _iterator211.f();
      }

      function d() {
        var i = new Gs(l, s),
            c = i.root.document ? r.version : null,
            d = new ac(i, e, a, n, c);
        t.batch.addOperation(d), o.applyOperation(d);
      }

      s instanceof $s && s != l && a != n && d();
    }

    function kc(t, e, n, i) {
      var o = t.model,
          r = o.document,
          s = i.getAttribute(e);
      var a, c;

      if (s != n) {
        if (i.root === i) {
          var _t164 = i.document ? r.version : null;

          c = new fc(i, e, s, n, _t164);
        } else {
          var _o42 = (a = new Gs($s._createBefore(i), t.createPositionAfter(i))).root.document ? r.version : null;

          c = new ac(a, e, s, n, _o42);
        }

        t.batch.addOperation(c), o.applyOperation(c);
      }
    }

    function _c(t, e, n, i, o) {
      var r = t.model,
          s = r.document,
          a = new hc(e, n, i, r.markers, o, s.version);
      t.batch.addOperation(a), r.applyOperation(a);
    }

    function vc(t, e, n, i) {
      var o;

      if (t.root.document) {
        var _n143 = i.document,
            _r17 = new $s(_n143.graveyard, [0]);

        o = new lc(t, e, _r17, _n143.version);
      } else o = new cc(t, e);

      n.addOperation(o), i.applyOperation(o);
    }

    function yc(t, e) {
      return t === e || t instanceof pc && e instanceof pc;
    }

    var xc = /*#__PURE__*/function () {
      function xc(t) {
        _classCallCheck(this, xc);

        this._markerCollection = t, this._changesInElement = new Map(), this._elementSnapshots = new Map(), this._changedMarkers = new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null;
      }

      _createClass(xc, [{
        key: "isEmpty",
        get: function get() {
          return 0 == this._changesInElement.size && 0 == this._changedMarkers.size;
        }
      }, {
        key: "refreshItem",
        value: function refreshItem(t) {
          if (this._isInInsertedElement(t.parent)) return;
          this._markRemove(t.parent, t.startOffset, t.offsetSize), this._markInsert(t.parent, t.startOffset, t.offsetSize);

          var e = Gs._createOn(t);

          var _iterator212 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(e)),
              _step212;

          try {
            for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
              var _t165 = _step212.value;

              var _e152 = _t165.getRange();

              this.bufferMarkerChange(_t165.name, _e152, _e152, _t165.affectsData);
            }
          } catch (err) {
            _iterator212.e(err);
          } finally {
            _iterator212.f();
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferOperation",
        value: function bufferOperation(t) {
          switch (t.type) {
            case "insert":
              if (this._isInInsertedElement(t.position.parent)) return;

              this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);

              break;

            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              var _iterator213 = _createForOfIteratorHelper(t.range.getItems({
                shallow: !0
              })),
                  _step213;

              try {
                for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
                  var _e153 = _step213.value;
                  this._isInInsertedElement(_e153.parent) || this._markAttribute(_e153);
                }
              } catch (err) {
                _iterator213.e(err);
              } finally {
                _iterator213.f();
              }

              break;

            case "remove":
            case "move":
            case "reinsert":
              {
                if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) return;

                var _e154 = this._isInInsertedElement(t.sourcePosition.parent),
                    _n144 = this._isInInsertedElement(t.targetPosition.parent);

                _e154 || this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany), _n144 || this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                break;
              }

            case "rename":
              {
                if (this._isInInsertedElement(t.position.parent)) return;
                this._markRemove(t.position.parent, t.position.offset, 1), this._markInsert(t.position.parent, t.position.offset, 1);

                var _e155 = Gs._createFromPositionAndShift(t.position, 1);

                var _iterator214 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(_e155)),
                    _step214;

                try {
                  for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
                    var _t166 = _step214.value;

                    var _e156 = _t166.getRange();

                    this.bufferMarkerChange(_t166.name, _e156, _e156, _t166.affectsData);
                  }
                } catch (err) {
                  _iterator214.e(err);
                } finally {
                  _iterator214.f();
                }

                break;
              }

            case "split":
              {
                var _e157 = t.splitPosition.parent;
                this._isInInsertedElement(_e157) || this._markRemove(_e157, t.splitPosition.offset, t.howMany), this._isInInsertedElement(t.insertionPosition.parent) || this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1), t.graveyardPosition && this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                break;
              }

            case "merge":
              {
                var _e158 = t.sourcePosition.parent;
                this._isInInsertedElement(_e158.parent) || this._markRemove(_e158.parent, _e158.startOffset, 1);
                var _n145 = t.graveyardPosition.parent;

                this._markInsert(_n145, t.graveyardPosition.offset, 1);

                var _i104 = t.targetPosition.parent;
                this._isInInsertedElement(_i104) || this._markInsert(_i104, t.targetPosition.offset, _e158.maxOffset);
                break;
              }
          }

          this._cachedChanges = null;
        }
      }, {
        key: "bufferMarkerChange",
        value: function bufferMarkerChange(t, e, n, i) {
          var o = this._changedMarkers.get(t);

          o ? (o.newRange = n, o.affectsData = i, null == o.oldRange && null == o.newRange && this._changedMarkers.delete(t)) : this._changedMarkers.set(t, {
            oldRange: e,
            newRange: n,
            affectsData: i
          });
        }
      }, {
        key: "getMarkersToRemove",
        value: function getMarkersToRemove() {
          var t = [];

          var _iterator215 = _createForOfIteratorHelper(this._changedMarkers),
              _step215;

          try {
            for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
              var _ref66 = _step215.value;

              var _ref65 = _slicedToArray(_ref66, 2);

              var _e159 = _ref65[0];
              var _n146 = _ref65[1];
              null != _n146.oldRange && t.push({
                name: _e159,
                range: _n146.oldRange
              });
            }
          } catch (err) {
            _iterator215.e(err);
          } finally {
            _iterator215.f();
          }

          return t;
        }
      }, {
        key: "getMarkersToAdd",
        value: function getMarkersToAdd() {
          var t = [];

          var _iterator216 = _createForOfIteratorHelper(this._changedMarkers),
              _step216;

          try {
            for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
              var _ref69 = _step216.value;

              var _ref68 = _slicedToArray(_ref69, 2);

              var _e160 = _ref68[0];
              var _n147 = _ref68[1];
              null != _n147.newRange && t.push({
                name: _e160,
                range: _n147.newRange
              });
            }
          } catch (err) {
            _iterator216.e(err);
          } finally {
            _iterator216.f();
          }

          return t;
        }
      }, {
        key: "getChangedMarkers",
        value: function getChangedMarkers() {
          return Array.from(this._changedMarkers).map(function (t) {
            return {
              name: t[0],
              data: {
                oldRange: t[1].oldRange,
                newRange: t[1].newRange
              }
            };
          });
        }
      }, {
        key: "hasDataChanges",
        value: function hasDataChanges() {
          var _iterator217 = _createForOfIteratorHelper(this._changedMarkers),
              _step217;

          try {
            for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
              var _ref72 = _step217.value;

              var _ref71 = _slicedToArray(_ref72, 2);

              var _t167 = _ref71[1];
              if (_t167.affectsData) return !0;
            }
          } catch (err) {
            _iterator217.e(err);
          } finally {
            _iterator217.f();
          }

          return this._changesInElement.size > 0;
        }
      }, {
        key: "getChanges",
        value: function getChanges() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeChangesInGraveyard: !1
          };
          if (this._cachedChanges) return t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          var e = [];

          var _iterator218 = _createForOfIteratorHelper(this._changesInElement.keys()),
              _step218;

          try {
            for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
              var _t170 = _step218.value;

              var _n149 = this._changesInElement.get(_t170).sort(function (t, e) {
                return t.offset === e.offset ? t.type != e.type ? "remove" == t.type ? -1 : 1 : 0 : t.offset < e.offset ? -1 : 1;
              }),
                  _i107 = this._elementSnapshots.get(_t170),
                  _o44 = Ac(_t170.getChildren()),
                  _r19 = Tc(_i107.length, _n149);

              var _s16 = 0,
                  _a9 = 0;

              var _iterator219 = _createForOfIteratorHelper(_r19),
                  _step219;

              try {
                for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
                  var _n150 = _step219.value;
                  if ("i" === _n150) e.push(this._getInsertDiff(_t170, _s16, _o44[_s16].name)), _s16++;else if ("r" === _n150) e.push(this._getRemoveDiff(_t170, _s16, _i107[_a9].name)), _a9++;else if ("a" === _n150) {
                    var _n151 = _o44[_s16].attributes,
                        _r20 = _i107[_a9].attributes;

                    var _c4 = void 0;

                    if ("$text" == _o44[_s16].name) _c4 = new Gs($s._createAt(_t170, _s16), $s._createAt(_t170, _s16 + 1));else {
                      var _e162 = _t170.offsetToIndex(_s16);

                      _c4 = new Gs($s._createAt(_t170, _s16), $s._createAt(_t170.getChild(_e162), 0));
                    }
                    e.push.apply(e, _toConsumableArray(this._getAttributesDiff(_c4, _r20, _n151))), _s16++, _a9++;
                  } else _s16++, _a9++;
                }
              } catch (err) {
                _iterator219.e(err);
              } finally {
                _iterator219.f();
              }
            }
          } catch (err) {
            _iterator218.e(err);
          } finally {
            _iterator218.f();
          }

          e.sort(function (t, e) {
            return t.position.root != e.position.root ? t.position.root.rootName < e.position.root.rootName ? -1 : 1 : t.position.isEqual(e.position) ? t.changeCount - e.changeCount : t.position.isBefore(e.position) ? -1 : 1;
          });

          for (var _t168 = 1; _t168 < e.length; _t168++) {
            var _n148 = e[_t168 - 1],
                _i105 = e[_t168],
                _o43 = "remove" == _n148.type && "remove" == _i105.type && "$text" == _n148.name && "$text" == _i105.name && _n148.position.isEqual(_i105.position),
                _r18 = "insert" == _n148.type && "insert" == _i105.type && "$text" == _n148.name && "$text" == _i105.name && _n148.position.parent == _i105.position.parent && _n148.position.offset + _n148.length == _i105.position.offset,
                _s15 = "attribute" == _n148.type && "attribute" == _i105.type && _n148.position.parent == _i105.position.parent && _n148.range.isFlat && _i105.range.isFlat && _n148.position.offset + _n148.length == _i105.position.offset && _n148.attributeKey == _i105.attributeKey && _n148.attributeOldValue == _i105.attributeOldValue && _n148.attributeNewValue == _i105.attributeNewValue;

            (_o43 || _r18 || _s15) && (e[_t168 - 1].length++, _s15 && (e[_t168 - 1].range.end = e[_t168 - 1].range.end.getShiftedBy(1)), e.splice(_t168, 1), _t168--);
          }

          for (var _i106 = 0, _e161 = e; _i106 < _e161.length; _i106++) {
            var _t169 = _e161[_i106];
            delete _t169.changeCount, "attribute" == _t169.type && (delete _t169.position, delete _t169.length);
          }

          return this._changeCount = 0, this._cachedChangesWithGraveyard = e.slice(), this._cachedChanges = e.slice().filter(Cc), t.includeChangesInGraveyard ? this._cachedChangesWithGraveyard : this._cachedChanges;
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._cachedChanges = null;
        }
      }, {
        key: "_markInsert",
        value: function _markInsert(t, e, n) {
          var i = {
            type: "insert",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };

          this._markChange(t, i);
        }
      }, {
        key: "_markRemove",
        value: function _markRemove(t, e, n) {
          var i = {
            type: "remove",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, i), this._removeAllNestedChanges(t, e, n);
        }
      }, {
        key: "_markAttribute",
        value: function _markAttribute(t) {
          var e = {
            type: "attribute",
            offset: t.startOffset,
            howMany: t.offsetSize,
            count: this._changeCount++
          };

          this._markChange(t.parent, e);
        }
      }, {
        key: "_markChange",
        value: function _markChange(t, e) {
          this._makeSnapshot(t);

          var n = this._getChangesForElement(t);

          this._handleChange(e, n), n.push(e);

          for (var _t171 = 0; _t171 < n.length; _t171++) {
            n[_t171].howMany < 1 && (n.splice(_t171, 1), _t171--);
          }
        }
      }, {
        key: "_getChangesForElement",
        value: function _getChangesForElement(t) {
          var e;
          return this._changesInElement.has(t) ? e = this._changesInElement.get(t) : (e = [], this._changesInElement.set(t, e)), e;
        }
      }, {
        key: "_makeSnapshot",
        value: function _makeSnapshot(t) {
          this._elementSnapshots.has(t) || this._elementSnapshots.set(t, Ac(t.getChildren()));
        }
      }, {
        key: "_handleChange",
        value: function _handleChange(t, e) {
          t.nodesToHandle = t.howMany;

          var _iterator220 = _createForOfIteratorHelper(e),
              _step220;

          try {
            for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
              var _n152 = _step220.value;

              var _i108 = t.offset + t.howMany,
                  _o45 = _n152.offset + _n152.howMany;

              if ("insert" == t.type && ("insert" == _n152.type && (t.offset <= _n152.offset ? _n152.offset += t.howMany : t.offset < _o45 && (_n152.howMany += t.nodesToHandle, t.nodesToHandle = 0)), "remove" == _n152.type && t.offset < _n152.offset && (_n152.offset += t.howMany), "attribute" == _n152.type)) if (t.offset <= _n152.offset) _n152.offset += t.howMany;else if (t.offset < _o45) {
                var _o46 = _n152.howMany;
                _n152.howMany = t.offset - _n152.offset, e.unshift({
                  type: "attribute",
                  offset: _i108,
                  howMany: _o46 - _n152.howMany,
                  count: this._changeCount++
                });
              }

              if ("remove" == t.type) {
                if ("insert" == _n152.type) if (_i108 <= _n152.offset) _n152.offset -= t.howMany;else if (_i108 <= _o45) {
                  if (t.offset < _n152.offset) {
                    var _e163 = _i108 - _n152.offset;

                    _n152.offset = t.offset, _n152.howMany -= _e163, t.nodesToHandle -= _e163;
                  } else _n152.howMany -= t.nodesToHandle, t.nodesToHandle = 0;
                } else if (t.offset <= _n152.offset) t.nodesToHandle -= _n152.howMany, _n152.howMany = 0;else if (t.offset < _o45) {
                  var _e164 = _o45 - t.offset;

                  _n152.howMany -= _e164, t.nodesToHandle -= _e164;
                }
                if ("remove" == _n152.type && (_i108 <= _n152.offset ? _n152.offset -= t.howMany : t.offset < _n152.offset && (t.nodesToHandle += _n152.howMany, _n152.howMany = 0)), "attribute" == _n152.type) if (_i108 <= _n152.offset) _n152.offset -= t.howMany;else if (t.offset < _n152.offset) {
                  var _e165 = _i108 - _n152.offset;

                  _n152.offset = t.offset, _n152.howMany -= _e165;
                } else if (t.offset < _o45) if (_i108 <= _o45) {
                  var _i109 = _n152.howMany;
                  _n152.howMany = t.offset - _n152.offset;

                  var _o47 = _i109 - _n152.howMany - t.nodesToHandle;

                  e.unshift({
                    type: "attribute",
                    offset: t.offset,
                    howMany: _o47,
                    count: this._changeCount++
                  });
                } else _n152.howMany -= _o45 - t.offset;
              }

              if ("attribute" == t.type) {
                if ("insert" == _n152.type) if (t.offset < _n152.offset && _i108 > _n152.offset) {
                  if (_i108 > _o45) {
                    var _t172 = {
                      type: "attribute",
                      offset: _o45,
                      howMany: _i108 - _o45,
                      count: this._changeCount++
                    };
                    this._handleChange(_t172, e), e.push(_t172);
                  }

                  t.nodesToHandle = _n152.offset - t.offset, t.howMany = t.nodesToHandle;
                } else t.offset >= _n152.offset && t.offset < _o45 && (_i108 > _o45 ? (t.nodesToHandle = _i108 - _o45, t.offset = _o45) : t.nodesToHandle = 0);

                if ("remove" == _n152.type && t.offset < _n152.offset && _i108 > _n152.offset) {
                  var _o48 = {
                    type: "attribute",
                    offset: _n152.offset,
                    howMany: _i108 - _n152.offset,
                    count: this._changeCount++
                  };
                  this._handleChange(_o48, e), e.push(_o48), t.nodesToHandle = _n152.offset - t.offset, t.howMany = t.nodesToHandle;
                }

                "attribute" == _n152.type && (t.offset >= _n152.offset && _i108 <= _o45 ? (t.nodesToHandle = 0, t.howMany = 0, t.offset = 0) : t.offset <= _n152.offset && _i108 >= _o45 && (_n152.howMany = 0));
              }
            }
          } catch (err) {
            _iterator220.e(err);
          } finally {
            _iterator220.f();
          }

          t.howMany = t.nodesToHandle, delete t.nodesToHandle;
        }
      }, {
        key: "_getInsertDiff",
        value: function _getInsertDiff(t, e, n) {
          return {
            type: "insert",
            position: $s._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getRemoveDiff",
        value: function _getRemoveDiff(t, e, n) {
          return {
            type: "remove",
            position: $s._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getAttributesDiff",
        value: function _getAttributesDiff(t, e, n) {
          var i = [];
          n = new Map(n);

          var _iterator221 = _createForOfIteratorHelper(e),
              _step221;

          try {
            for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
              var _ref77 = _step221.value;

              var _ref74 = _slicedToArray(_ref77, 2);

              var _o49 = _ref74[0];
              var _r21 = _ref74[1];

              var _e166 = n.has(_o49) ? n.get(_o49) : null;

              _e166 !== _r21 && i.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _o49,
                attributeOldValue: _r21,
                attributeNewValue: _e166,
                changeCount: this._changeCount++
              }), n.delete(_o49);
            }
          } catch (err) {
            _iterator221.e(err);
          } finally {
            _iterator221.f();
          }

          var _iterator222 = _createForOfIteratorHelper(n),
              _step222;

          try {
            for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
              var _ref78 = _step222.value;

              var _ref76 = _slicedToArray(_ref78, 2);

              var _e167 = _ref76[0];
              var _o50 = _ref76[1];
              i.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _e167,
                attributeOldValue: null,
                attributeNewValue: _o50,
                changeCount: this._changeCount++
              });
            }
          } catch (err) {
            _iterator222.e(err);
          } finally {
            _iterator222.f();
          }

          return i;
        }
      }, {
        key: "_isInInsertedElement",
        value: function _isInInsertedElement(t) {
          var e = t.parent;
          if (!e) return !1;

          var n = this._changesInElement.get(e),
              i = t.startOffset;

          if (n) {
            var _iterator223 = _createForOfIteratorHelper(n),
                _step223;

            try {
              for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
                var _t173 = _step223.value;
                if ("insert" == _t173.type && i >= _t173.offset && i < _t173.offset + _t173.howMany) return !0;
              }
            } catch (err) {
              _iterator223.e(err);
            } finally {
              _iterator223.f();
            }
          }

          return this._isInInsertedElement(e);
        }
      }, {
        key: "_removeAllNestedChanges",
        value: function _removeAllNestedChanges(t, e, n) {
          var i = new Gs($s._createAt(t, e), $s._createAt(t, e + n));

          var _iterator224 = _createForOfIteratorHelper(i.getItems({
            shallow: !0
          })),
              _step224;

          try {
            for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
              var _t174 = _step224.value;
              _t174.is("element") && (this._elementSnapshots.delete(_t174), this._changesInElement.delete(_t174), this._removeAllNestedChanges(_t174, 0, _t174.maxOffset));
            }
          } catch (err) {
            _iterator224.e(err);
          } finally {
            _iterator224.f();
          }
        }
      }]);

      return xc;
    }();

    function Ac(t) {
      var e = [];

      var _iterator225 = _createForOfIteratorHelper(t),
          _step225;

      try {
        for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
          var _n153 = _step225.value;
          if (_n153.is("text")) for (var _t175 = 0; _t175 < _n153.data.length; _t175++) {
            e.push({
              name: "$text",
              attributes: new Map(_n153.getAttributes())
            });
          } else e.push({
            name: _n153.name,
            attributes: new Map(_n153.getAttributes())
          });
        }
      } catch (err) {
        _iterator225.e(err);
      } finally {
        _iterator225.f();
      }

      return e;
    }

    function Tc(t, e) {
      var n = [];
      var i = 0,
          o = 0;

      var _iterator226 = _createForOfIteratorHelper(e),
          _step226;

      try {
        for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
          var _t176 = _step226.value;

          if (_t176.offset > i) {
            for (var _e169 = 0; _e169 < _t176.offset - i; _e169++) {
              n.push("e");
            }

            o += _t176.offset - i;
          }

          if ("insert" == _t176.type) {
            for (var _e170 = 0; _e170 < _t176.howMany; _e170++) {
              n.push("i");
            }

            i = _t176.offset + _t176.howMany;
          } else if ("remove" == _t176.type) {
            for (var _e171 = 0; _e171 < _t176.howMany; _e171++) {
              n.push("r");
            }

            i = _t176.offset, o += _t176.howMany;
          } else n.push.apply(n, _toConsumableArray("a".repeat(_t176.howMany).split(""))), i = _t176.offset + _t176.howMany, o += _t176.howMany;
        }
      } catch (err) {
        _iterator226.e(err);
      } finally {
        _iterator226.f();
      }

      if (o < t) for (var _e168 = 0; _e168 < t - o - i; _e168++) {
        n.push("e");
      }
      return n;
    }

    function Cc(t) {
      var e = t.position && "$graveyard" == t.position.root.rootName,
          n = t.range && "$graveyard" == t.range.root.rootName;
      return !e && !n;
    }

    var Pc = /*#__PURE__*/function () {
      function Pc() {
        _classCallCheck(this, Pc);

        this._operations = [], this._undoPairs = new Map(), this._undoneOperations = new Set();
      }

      _createClass(Pc, [{
        key: "addOperation",
        value: function addOperation(t) {
          this._operations.includes(t) || this._operations.push(t);
        }
      }, {
        key: "getOperations",
        value: function getOperations() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
          return t < 0 ? [] : this._operations.slice(t, e);
        }
      }, {
        key: "getOperation",
        value: function getOperation(t) {
          return this._operations[t];
        }
      }, {
        key: "setOperationAsUndone",
        value: function setOperationAsUndone(t, e) {
          this._undoPairs.set(e, t), this._undoneOperations.add(t);
        }
      }, {
        key: "isUndoingOperation",
        value: function isUndoingOperation(t) {
          return this._undoPairs.has(t);
        }
      }, {
        key: "isUndoneOperation",
        value: function isUndoneOperation(t) {
          return this._undoneOperations.has(t);
        }
      }, {
        key: "getUndoneOperation",
        value: function getUndoneOperation(t) {
          return this._undoPairs.get(t);
        }
      }]);

      return Pc;
    }();

    function Sc(t, e) {
      return function (t) {
        return !!t && 1 == t.length && /[\ud800-\udbff]/.test(t);
      }(t.charAt(e - 1)) && function (t) {
        return !!t && 1 == t.length && /[\udc00-\udfff]/.test(t);
      }(t.charAt(e));
    }

    function Mc(t, e) {
      return function (t) {
        return !!t && 1 == t.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(t);
      }(t.charAt(e));
    }

    var Ec = "$graveyard";

    var Ic = /*#__PURE__*/function () {
      function Ic(t) {
        var _this65 = this;

        _classCallCheck(this, Ic);

        this.model = t, this.version = 0, this.history = new Pc(this), this.selection = new sa(this), this.roots = new oo({
          idProperty: "rootName"
        }), this.differ = new xc(t.markers), this._postFixers = new Set(), this._hasSelectionChangedFromTheLastChangeBlock = !1, this.createRoot("$root", Ec), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation && n.baseVersion !== _this65.version) throw new Gn.b("model-document-applyOperation-wrong-version: Only operations with matching versions can be applied.", _this65, {
            operation: n
          });
        }, {
          priority: "highest"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && _this65.differ.bufferOperation(n);
        }, {
          priority: "high"
        }), this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          n.isDocumentOperation && (_this65.version++, _this65.history.addOperation(n));
        }, {
          priority: "low"
        }), this.listenTo(this.selection, "change", function () {
          _this65._hasSelectionChangedFromTheLastChangeBlock = !0;
        }), this.listenTo(t.markers, "update", function (t, e, n, i) {
          _this65.differ.bufferMarkerChange(e.name, n, i, e.affectsData), null === n && e.on("change", function (t, n) {
            _this65.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData);
          });
        });
      }

      _createClass(Ic, [{
        key: "graveyard",
        get: function get() {
          return this.getRoot(Ec);
        }
      }, {
        key: "createRoot",
        value: function createRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          if (this.roots.get(e)) throw new Gn.b("model-document-createRoot-name-exists: Root with specified name already exists.", this, {
            name: e
          });
          var n = new pc(this, t, e);
          return this.roots.add(n), n;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.selection.destroy(), this.stopListening();
        }
      }, {
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "getRootNames",
        value: function getRootNames() {
          return Array.from(this.roots, function (t) {
            return t.rootName;
          }).filter(function (t) {
            return t != Ec;
          });
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = hi(this);
          return t.selection = "[engine.model.DocumentSelection]", t.model = "[engine.model.Model]", t;
        }
      }, {
        key: "_handleChangeBlock",
        value: function _handleChangeBlock(t) {
          this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t.batch) : this.fire("change", t.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = !1;
        }
      }, {
        key: "_hasDocumentChangedFromTheLastChangeBlock",
        value: function _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
      }, {
        key: "_getDefaultRoot",
        value: function _getDefaultRoot() {
          var _iterator227 = _createForOfIteratorHelper(this.roots),
              _step227;

          try {
            for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
              var _t177 = _step227.value;
              if (_t177 !== this.graveyard) return _t177;
            }
          } catch (err) {
            _iterator227.e(err);
          } finally {
            _iterator227.f();
          }

          return this.graveyard;
        }
      }, {
        key: "_getDefaultRange",
        value: function _getDefaultRange() {
          var t = this._getDefaultRoot(),
              e = this.model,
              n = e.schema,
              i = e.createPositionFromPath(t, [0]);

          return n.getNearestSelectionRange(i) || e.createRange(i);
        }
      }, {
        key: "_validateSelectionRange",
        value: function _validateSelectionRange(t) {
          return Nc(t.start) && Nc(t.end);
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = !1;

          do {
            var _iterator228 = _createForOfIteratorHelper(this._postFixers),
                _step228;

            try {
              for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
                var _n154 = _step228.value;
                if (this.selection.refresh(), e = _n154(t)) break;
              }
            } catch (err) {
              _iterator228.e(err);
            } finally {
              _iterator228.f();
            }
          } while (e);
        }
      }]);

      return Ic;
    }();

    function Nc(t) {
      var e = t.textNode;

      if (e) {
        var _n155 = e.data,
            _i110 = t.offset - e.startOffset;

        return !Sc(_n155, _i110) && !Mc(_n155, _i110);
      }

      return !0;
    }

    ci(Ic, ei);

    var Oc = /*#__PURE__*/function (_Symbol$iterator12) {
      function Oc() {
        _classCallCheck(this, Oc);

        this._markers = new Map();
      }

      _createClass(Oc, [{
        key: _Symbol$iterator12,
        value: function value() {
          return this._markers.values();
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._markers.has(t);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._markers.get(t) || null;
        }
      }, {
        key: "_set",
        value: function _set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;

          var o = t instanceof Rc ? t.name : t,
              r = this._markers.get(o);

          if (r) {
            var _t178 = r.getRange();

            var _s17 = !1;

            return _t178.isEqual(e) || (r._attachLiveRange(oa.fromRange(e)), _s17 = !0), n != r.managedUsingOperations && (r._managedUsingOperations = n, _s17 = !0), "boolean" == typeof i && i != r.affectsData && (r._affectsData = i, _s17 = !0), _s17 && this.fire("update:" + o, r, _t178, e), r;
          }

          var s = oa.fromRange(e),
              a = new Rc(o, s, n, i);
          return this._markers.set(o, a), this.fire("update:" + o, a, null, e), a;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e = t instanceof Rc ? t.name : t,
              n = this._markers.get(e);

          return !!n && (this._markers.delete(e), this.fire("update:" + e, n, n.getRange(), null), this._destroyMarker(n), !0);
        }
      }, {
        key: "_refresh",
        value: function _refresh(t) {
          var e = t instanceof Rc ? t.name : t,
              n = this._markers.get(e);

          if (!n) throw new Gn.b("markercollection-refresh-marker-not-exists: Marker with provided name does not exists.", this);
          var i = n.getRange();
          this.fire("update:" + e, n, i, i, n.managedUsingOperations, n.affectsData);
        }
      }, {
        key: "getMarkersAtPosition",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getMarkersAtPosition(t) {
          var _iterator229, _step229, _e172;

          return _regeneratorRuntime.wrap(function getMarkersAtPosition$(_context31) {
            while (1) {
              switch (_context31.prev = _context31.next) {
                case 0:
                  _iterator229 = _createForOfIteratorHelper(this);
                  _context31.prev = 1;

                  _iterator229.s();

                case 3:
                  if ((_step229 = _iterator229.n()).done) {
                    _context31.next = 11;
                    break;
                  }

                  _e172 = _step229.value;
                  _context31.t0 = _e172.getRange().containsPosition(t);

                  if (!_context31.t0) {
                    _context31.next = 9;
                    break;
                  }

                  _context31.next = 9;
                  return _e172;

                case 9:
                  _context31.next = 3;
                  break;

                case 11:
                  _context31.next = 16;
                  break;

                case 13:
                  _context31.prev = 13;
                  _context31.t1 = _context31["catch"](1);

                  _iterator229.e(_context31.t1);

                case 16:
                  _context31.prev = 16;

                  _iterator229.f();

                  return _context31.finish(16);

                case 19:
                case "end":
                  return _context31.stop();
              }
            }
          }, getMarkersAtPosition, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "getMarkersIntersectingRange",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getMarkersIntersectingRange(t) {
          var _iterator230, _step230, _e173;

          return _regeneratorRuntime.wrap(function getMarkersIntersectingRange$(_context32) {
            while (1) {
              switch (_context32.prev = _context32.next) {
                case 0:
                  _iterator230 = _createForOfIteratorHelper(this);
                  _context32.prev = 1;

                  _iterator230.s();

                case 3:
                  if ((_step230 = _iterator230.n()).done) {
                    _context32.next = 11;
                    break;
                  }

                  _e173 = _step230.value;
                  _context32.t0 = null !== _e173.getRange().getIntersection(t);

                  if (!_context32.t0) {
                    _context32.next = 9;
                    break;
                  }

                  _context32.next = 9;
                  return _e173;

                case 9:
                  _context32.next = 3;
                  break;

                case 11:
                  _context32.next = 16;
                  break;

                case 13:
                  _context32.prev = 13;
                  _context32.t1 = _context32["catch"](1);

                  _iterator230.e(_context32.t1);

                case 16:
                  _context32.prev = 16;

                  _iterator230.f();

                  return _context32.finish(16);

                case 19:
                case "end":
                  return _context32.stop();
              }
            }
          }, getMarkersIntersectingRange, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator231 = _createForOfIteratorHelper(this._markers.values()),
              _step231;

          try {
            for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
              var _t179 = _step231.value;

              this._destroyMarker(_t179);
            }
          } catch (err) {
            _iterator231.e(err);
          } finally {
            _iterator231.f();
          }

          this._markers = null, this.stopListening();
        }
      }, {
        key: "getMarkersGroup",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getMarkersGroup(t) {
          var _iterator232, _step232, _e174;

          return _regeneratorRuntime.wrap(function getMarkersGroup$(_context33) {
            while (1) {
              switch (_context33.prev = _context33.next) {
                case 0:
                  _iterator232 = _createForOfIteratorHelper(this._markers.values());
                  _context33.prev = 1;

                  _iterator232.s();

                case 3:
                  if ((_step232 = _iterator232.n()).done) {
                    _context33.next = 11;
                    break;
                  }

                  _e174 = _step232.value;
                  _context33.t0 = _e174.name.startsWith(t + ":");

                  if (!_context33.t0) {
                    _context33.next = 9;
                    break;
                  }

                  _context33.next = 9;
                  return _e174;

                case 9:
                  _context33.next = 3;
                  break;

                case 11:
                  _context33.next = 16;
                  break;

                case 13:
                  _context33.prev = 13;
                  _context33.t1 = _context33["catch"](1);

                  _iterator232.e(_context33.t1);

                case 16:
                  _context33.prev = 16;

                  _iterator232.f();

                  return _context33.finish(16);

                case 19:
                case "end":
                  return _context33.stop();
              }
            }
          }, getMarkersGroup, this, [[1, 13, 16, 19]]);
        })
      }, {
        key: "_destroyMarker",
        value: function _destroyMarker(t) {
          t.stopListening(), t._detachLiveRange();
        }
      }]);

      return Oc;
    }(Symbol.iterator);

    ci(Oc, ei);

    var Rc = /*#__PURE__*/function () {
      function Rc(t, e, n, i) {
        _classCallCheck(this, Rc);

        this.name = t, this._liveRange = this._attachLiveRange(e), this._managedUsingOperations = n, this._affectsData = i;
      }

      _createClass(Rc, [{
        key: "managedUsingOperations",
        get: function get() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._managedUsingOperations;
        }
      }, {
        key: "affectsData",
        get: function get() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._affectsData;
        }
      }, {
        key: "getStart",
        value: function getStart() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.start.clone();
        }
      }, {
        key: "getEnd",
        value: function getEnd() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.end.clone();
        }
      }, {
        key: "getRange",
        value: function getRange() {
          if (!this._liveRange) throw new Gn.b("marker-destroyed: Cannot use a destroyed marker instance.", this);
          return this._liveRange.toRange();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "marker" == t || "model:marker" == t;
        }
      }, {
        key: "_attachLiveRange",
        value: function _attachLiveRange(t) {
          return this._liveRange && this._detachLiveRange(), t.delegate("change:range").to(this), t.delegate("change:content").to(this), this._liveRange = t, t;
        }
      }, {
        key: "_detachLiveRange",
        value: function _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
        }
      }]);

      return Rc;
    }();

    ci(Rc, ei);

    var Dc = /*#__PURE__*/function (_$s) {
      _inherits(Dc, _$s);

      var _super34 = _createSuper(Dc);

      function Dc(t, e) {
        var _this66;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";

        _classCallCheck(this, Dc);

        if (_this66 = _super34.call(this, t, e, n), !_this66.root.is("rootElement")) throw new Gn.b("model-liveposition-root-not-rootelement: LivePosition's root has to be an instance of RootElement.", t);
        (function () {
          var _this67 = this;

          this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
            var n = e[0];
            n.isDocumentOperation && function (t) {
              var e = this.getTransformedByOperation(t);

              if (!this.isEqual(e)) {
                var _t180 = this.toPosition();

                this.path = e.path, this.root = e.root, this.fire("change", _t180);
              }
            }.call(_this67, n);
          }, {
            priority: "low"
          });
        }).call(_assertThisInitialized(_this66));
        return _possibleConstructorReturn(_this66);
      }

      _createClass(Dc, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return "livePosition" == t || "model:livePosition" == t || _get(_getPrototypeOf(Dc.prototype), "is", this).call(this, t);
        }
      }, {
        key: "toPosition",
        value: function toPosition() {
          return new $s(this.root, this.path.slice(), this.stickiness);
        }
      }], [{
        key: "fromPosition",
        value: function fromPosition(t, e) {
          return new this(t.root, t.path.slice(), e || t.stickiness);
        }
      }]);

      return Dc;
    }($s);

    ci(Dc, ei);

    var Lc = /*#__PURE__*/function () {
      function Lc(t, e, n) {
        _classCallCheck(this, Lc);

        this.model = t, this.writer = e, this.position = n, this.canMergeWith = new Set([this.position.parent]), this.schema = t.schema, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null;
      }

      _createClass(Lc, [{
        key: "handleNodes",
        value: function handleNodes(t, e) {
          t = Array.from(t);

          for (var _n156 = 0; _n156 < t.length; _n156++) {
            var _i111 = t[_n156];

            this._handleNode(_i111, {
              isFirst: 0 === _n156 && e.isFirst,
              isLast: _n156 === t.length - 1 && e.isLast
            });
          }

          this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
        }
      }, {
        key: "getSelectionRange",
        value: function getSelectionRange() {
          return this.nodeToSelect ? Gs._createOn(this.nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
        }
      }, {
        key: "getAffectedRange",
        value: function getAffectedRange() {
          return this._affectedStart ? new Gs(this._affectedStart, this._affectedEnd) : null;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
        }
      }, {
        key: "_handleNode",
        value: function _handleNode(t, e) {
          if (this.schema.isObject(t)) return void this._handleObject(t, e);
          this._checkAndSplitToAllowedPosition(t, e) ? (this._insert(t), this._mergeSiblingsOf(t, e)) : this._handleDisallowedNode(t, e);
        }
      }, {
        key: "_handleObject",
        value: function _handleObject(t, e) {
          this._checkAndSplitToAllowedPosition(t) ? this._insert(t) : this._tryAutoparagraphing(t, e);
        }
      }, {
        key: "_handleDisallowedNode",
        value: function _handleDisallowedNode(t, e) {
          t.is("element") ? this.handleNodes(t.getChildren(), e) : this._tryAutoparagraphing(t, e);
        }
      }, {
        key: "_insert",
        value: function _insert(t) {
          if (!this.schema.checkChild(this.position, t)) throw new Gn.b("insertcontent-wrong-position: Given node cannot be inserted on the given position.", this, {
            node: t,
            position: this.position
          });
          var e = Dc.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position), this.writer.insert(t, this.position), this.position = e.toPosition(), e.detach(), this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text") ? this.nodeToSelect = t : this.nodeToSelect = null, this._filterAttributesOf.push(t);
        }
      }, {
        key: "_setAffectedBoundaries",
        value: function _setAffectedBoundaries(t) {
          this._affectedStart || (this._affectedStart = Dc.fromPosition(t, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Dc.fromPosition(t, "toNext"));
        }
      }, {
        key: "_mergeSiblingsOf",
        value: function _mergeSiblingsOf(t, e) {
          if (!(t instanceof Hs)) return;

          var n = this._canMergeLeft(t, e),
              i = this._canMergeRight(t, e),
              o = Dc._createBefore(t);

          o.stickiness = "toNext";

          var r = Dc._createAfter(t);

          if (r.stickiness = "toNext", n) {
            var _t181 = Dc.fromPosition(this.position);

            _t181.stickiness = "toNext", this._affectedStart.isEqual(o) && (this._affectedStart.detach(), this._affectedStart = Dc._createAt(o.nodeBefore, "end", "toPrevious")), this.writer.merge(o), o.isEqual(this._affectedEnd) && e.isLast && (this._affectedEnd.detach(), this._affectedEnd = Dc._createAt(o.nodeBefore, "end", "toNext")), this.position = _t181.toPosition(), _t181.detach();
          }

          if (i) {
            if (!this.position.isEqual(r)) throw new Gn.b("insertcontent-invalid-insertion-position", this);
            this.position = $s._createAt(r.nodeBefore, "end");

            var _t182 = Dc.fromPosition(this.position, "toPrevious");

            this._affectedEnd.isEqual(r) && (this._affectedEnd.detach(), this._affectedEnd = Dc._createAt(r.nodeBefore, "end", "toNext")), this.writer.merge(r), r.getShiftedBy(-1).isEqual(this._affectedStart) && e.isFirst && (this._affectedStart.detach(), this._affectedStart = Dc._createAt(r.nodeBefore, 0, "toPrevious")), this.position = _t182.toPosition(), _t182.detach();
          }

          (n || i) && this._filterAttributesOf.push(this.position.parent), o.detach(), r.detach();
        }
      }, {
        key: "_canMergeLeft",
        value: function _canMergeLeft(t, e) {
          var n = t.previousSibling;
          return e.isFirst && n instanceof Hs && this.canMergeWith.has(n) && this.model.schema.checkMerge(n, t);
        }
      }, {
        key: "_canMergeRight",
        value: function _canMergeRight(t, e) {
          var n = t.nextSibling;
          return e.isLast && n instanceof Hs && this.canMergeWith.has(n) && this.model.schema.checkMerge(t, n);
        }
      }, {
        key: "_tryAutoparagraphing",
        value: function _tryAutoparagraphing(t, e) {
          var n = this.writer.createElement("paragraph");
          this._getAllowedIn(n, this.position.parent) && this.schema.checkChild(n, t) && (n._appendChild(t), this._handleNode(n, e));
        }
      }, {
        key: "_checkAndSplitToAllowedPosition",
        value: function _checkAndSplitToAllowedPosition(t) {
          var e = this._getAllowedIn(t, this.position.parent);

          if (!e) return !1;

          for (; e != this.position.parent;) {
            if (this.schema.isLimit(this.position.parent)) return !1;

            if (this.position.isAtStart) {
              var _t183 = this.position.parent;
              this.position = this.writer.createPositionBefore(_t183), _t183.isEmpty && _t183.parent === e && this.writer.remove(_t183);
            } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);else {
              var _t184 = this.writer.createPositionAfter(this.position.parent);

              this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = _t184, this.canMergeWith.add(this.position.nodeAfter);
            }
          }

          return !0;
        }
      }, {
        key: "_getAllowedIn",
        value: function _getAllowedIn(t, e) {
          return this.schema.checkChild(e, t) ? e : e.parent ? this._getAllowedIn(t, e.parent) : null;
        }
      }]);

      return Lc;
    }();

    function jc(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (e.isCollapsed) return;
      var i = e.getFirstRange();
      if ("$graveyard" == i.root.rootName) return;
      var o = t.schema;
      t.change(function (t) {
        if (!n.doNotResetEntireContent && function (t, e) {
          var n = t.getLimitElement(e);
          if (!e.containsEntireContent(n)) return !1;
          var i = e.getFirstRange();
          if (i.start.parent == i.end.parent) return !1;
          return t.checkChild(n, "paragraph");
        }(o, e)) return void function (t, e) {
          var n = t.model.schema.getLimitElement(e);
          t.remove(t.createRangeIn(n)), Vc(t, t.createPositionAt(n, 0), e);
        }(t, e);
        var r = i.start,
            s = Dc.fromPosition(i.end, "toNext");

        if (i.start.isTouching(i.end) || t.remove(i), n.leaveUnmerged || (!function t(e, n, i) {
          var o = n.parent;
          var r = i.parent;
          if (o == r) return;
          if (e.model.schema.isLimit(o) || e.model.schema.isLimit(r)) return;
          if (!function (t, e, n) {
            var i = new Gs(t, e);

            var _iterator233 = _createForOfIteratorHelper(i.getWalker()),
                _step233;

            try {
              for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
                var _t185 = _step233.value;
                if (n.isLimit(_t185.item)) return !1;
              }
            } catch (err) {
              _iterator233.e(err);
            } finally {
              _iterator233.f();
            }

            return !0;
          }(n, i, e.model.schema)) return;
          n = e.createPositionAfter(o);
          i = e.createPositionBefore(r);
          i.isEqual(n) || e.insert(r, n);
          e.merge(n);

          for (; i.parent.isEmpty;) {
            var _t186 = i.parent;
            i = e.createPositionBefore(_t186), e.remove(_t186);
          }

          t(e, n, i);
        }(t, r, s), o.removeDisallowedAttributes(r.parent.getChildren(), t)), zc(t, e, r), function (t, e) {
          var n = t.checkChild(e, "$text"),
              i = t.checkChild(e, "paragraph");
          return !n && i;
        }(o, r)) {
          var _i112 = o.getNearestSelectionRange(r);

          n.doNotAutoparagraph && _i112 ? zc(t, e, _i112) : Vc(t, r, e);
        }

        s.detach();
      });
    }

    function Vc(t, e, n) {
      var i = t.createElement("paragraph");
      t.insert(i, e), zc(t, n, t.createPositionAt(i, 0));
    }

    function zc(t, e, n) {
      e instanceof sa ? t.setSelection(n) : e.setTo(n);
    }

    var Bc = ' ,.?!:;"-()';

    function Fc(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.schema,
          o = "backward" != n.direction,
          r = n.unit ? n.unit : "character",
          s = e.focus,
          a = new qs({
        boundaries: function (t, e) {
          var n = t.root,
              i = $s._createAt(n, e ? "end" : 0);

          return e ? new Gs(t, i) : new Gs(i, t);
        }(s, o),
        singleCharacters: !0,
        direction: o ? "forward" : "backward"
      }),
          c = {
        walker: a,
        schema: i,
        isForward: o,
        unit: r
      };
      var l;

      var _loop3 = function _loop3() {
        if (l.done) return {
          v: void 0
        };
        var n = Uc(c, l.value);
        if (n) return {
          v: void (e instanceof sa ? t.change(function (t) {
            t.setSelectionFocus(n);
          }) : e.setFocus(n))
        };
      };

      for (; l = a.next();) {
        var _ret2 = _loop3();

        if (_typeof(_ret2) === "object") return _ret2.v;
      }
    }

    function Uc(t, e) {
      if ("text" == e.type) return "word" === t.unit ? function (t, e) {
        var n = t.position.textNode;

        if (n) {
          var _i113 = t.position.offset - n.startOffset;

          for (; !Hc(n.data, _i113, e) && !qc(n, _i113, e);) {
            t.next();

            var _o51 = e ? t.position.nodeAfter : t.position.nodeBefore;

            if (_o51 && _o51.is("text")) {
              var _i114 = _o51.data.charAt(e ? 0 : _o51.data.length - 1);

              Bc.includes(_i114) || (t.next(), n = t.position.textNode);
            }

            _i113 = t.position.offset - n.startOffset;
          }
        }

        return t.position;
      }(t.walker, t.isForward) : function (t, e) {
        var n = t.position.textNode;

        if (n) {
          var _i115 = n.data;

          var _o52 = t.position.offset - n.startOffset;

          for (; Sc(_i115, _o52) || "character" == e && Mc(_i115, _o52);) {
            t.next(), _o52 = t.position.offset - n.startOffset;
          }
        }

        return t.position;
      }(t.walker, t.unit, t.isForward);

      if (e.type == (t.isForward ? "elementStart" : "elementEnd")) {
        if (t.schema.isObject(e.item)) return $s._createAt(e.item, t.isForward ? "after" : "before");
        if (t.schema.checkChild(e.nextPosition, "$text")) return e.nextPosition;
      } else {
        if (t.schema.isLimit(e.item)) return void t.walker.skip(function () {
          return !0;
        });
        if (t.schema.checkChild(e.nextPosition, "$text")) return e.nextPosition;
      }
    }

    function Hc(t, e, n) {
      var i = e + (n ? 0 : -1);
      return Bc.includes(t.charAt(i));
    }

    function qc(t, e, n) {
      return e === (n ? t.endOffset : 0);
    }

    function Wc(t, e) {
      var n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(function (t) {
        return e.createRangeOn(t);
      }).filter(function (e) {
        return (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
      }).forEach(function (t) {
        n.push(t.start.parent), e.remove(t);
      }), n.forEach(function (t) {
        var n = t;

        for (; n.parent && n.isEmpty;) {
          var _t187 = e.createRangeOn(n);

          n = n.parent, e.remove(_t187);
        }
      });
    }

    function Yc(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.selection,
              i = e.schema,
              o = [];
          var r = !1;

          var _iterator234 = _createForOfIteratorHelper(n.getRanges()),
              _step234;

          try {
            for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
              var _t189 = _step234.value;

              var _e176 = $c(_t189, i);

              _e176 ? (o.push(_e176), r = !0) : o.push(_t189);
            }
          } catch (err) {
            _iterator234.e(err);
          } finally {
            _iterator234.f();
          }

          if (r) {
            var _e175 = o;

            if (o.length > 1) {
              var _t188 = o[0].start,
                  _n157 = o[o.length - 1].end;
              _e175 = [new Gs(_t188, _n157)];
            }

            t.setSelection(_e175, {
              backward: n.isBackward
            });
          }
        }(e, t);
      });
    }

    function $c(t, e) {
      return t.isCollapsed ? function (t, e) {
        var n = t.start,
            i = e.getNearestSelectionRange(n);
        if (!i) return null;
        var o = i.start;
        if (n.isEqual(o)) return null;
        if (o.nodeAfter && e.isLimit(o.nodeAfter)) return new Gs(o, $s._createAfter(o.nodeAfter));
        return new Gs(o);
      }(t, e) : function (t, e) {
        var n = t.start,
            i = t.end,
            o = e.checkChild(n, "$text"),
            r = e.checkChild(i, "$text"),
            s = e.getLimitElement(n),
            a = e.getLimitElement(i);

        if (s === a) {
          if (o && r) return null;

          if (function (t, e, n) {
            var i = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text"),
                o = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
            return i || o;
          }(n, i, e)) {
            var _t190 = n.nodeAfter && e.isObject(n.nodeAfter),
                _o53 = _t190 ? null : e.getNearestSelectionRange(n, "forward"),
                _r22 = i.nodeBefore && e.isObject(i.nodeBefore),
                _s18 = _r22 ? null : e.getNearestSelectionRange(i, "backward"),
                _a10 = _o53 ? _o53.start : n,
                _c5 = _s18 ? _s18.start : i;

            return new Gs(_a10, _c5);
          }
        }

        var c = s && !s.is("rootElement"),
            l = a && !a.is("rootElement");

        if (c || l) {
          var _t191 = n.nodeAfter && i.nodeBefore && n.nodeAfter.parent === i.nodeBefore.parent,
              _o54 = c && (!_t191 || !Qc(n.nodeAfter, e)),
              _r23 = l && (!_t191 || !Qc(i.nodeBefore, e));

          var _d2 = n,
              _h2 = i;
          return _o54 && (_d2 = $s._createBefore(Gc(s, e))), _r23 && (_h2 = $s._createAfter(Gc(a, e))), new Gs(_d2, _h2);
        }

        return null;
      }(t, e);
    }

    function Gc(t, e) {
      var n = t,
          i = n;

      for (; e.isLimit(i) && i.parent;) {
        n = i, i = i.parent;
      }

      return n;
    }

    function Qc(t, e) {
      return t && e.isObject(t);
    }

    var Kc = /*#__PURE__*/function () {
      function Kc() {
        var _this68 = this;

        _classCallCheck(this, Kc);

        this.markers = new Oc(), this.document = new Ic(this), this.schema = new Oa(), this._pendingChanges = [], this._currentWriter = null, ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (t) {
          return _this68.decorate(t);
        }), this.on("applyOperation", function (t, e) {
          e[0]._validate();
        }, {
          priority: "highest"
        }), this.schema.register("$root", {
          isLimit: !0
        }), this.schema.register("$block", {
          allowIn: "$root",
          isBlock: !0
        }), this.schema.register("$text", {
          allowIn: "$block",
          isInline: !0
        }), this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          isLimit: !0
        }), this.schema.extend("$text", {
          allowIn: "$clipboardHolder"
        }), this.schema.register("$marker"), this.schema.addChildCheck(function (t, e) {
          if ("$marker" === e.name) return !0;
        }), Yc(this);
      }

      _createClass(Kc, [{
        key: "change",
        value: function change(t) {
          return 0 === this._pendingChanges.length ? (this._pendingChanges.push({
            batch: new Ka(),
            callback: t
          }), this._runPendingChanges()[0]) : t(this._currentWriter);
        }
      }, {
        key: "enqueueChange",
        value: function enqueueChange(t, e) {
          "string" == typeof t ? t = new Ka(t) : "function" == typeof t && (e = t, t = new Ka()), this._pendingChanges.push({
            batch: t,
            callback: e
          }), 1 == this._pendingChanges.length && this._runPendingChanges();
        }
      }, {
        key: "applyOperation",
        value: function applyOperation(t) {
          t._execute();
        }
      }, {
        key: "insertContent",
        value: function insertContent(t, e, n) {
          return function (t, e, n, i) {
            return t.change(function (o) {
              var r;
              var s = (r = n ? n instanceof ta || n instanceof sa ? n : o.createSelection(n, i) : t.document.selection).getFirstPosition();
              r.isCollapsed || t.deleteContent(r, {
                doNotAutoparagraph: !0
              });
              var a = new Lc(t, o, s);
              var c;
              c = e.is("documentFragment") ? e.getChildren() : [e], a.handleNodes(c, {
                isFirst: !0,
                isLast: !0
              });
              var l = a.getSelectionRange();
              l && (r instanceof sa ? o.setSelection(l) : r.setTo(l));
              var d = a.getAffectedRange() || t.createRange(s);
              return a.destroy(), d;
            });
          }(this, t, e, n);
        }
      }, {
        key: "deleteContent",
        value: function deleteContent(t, e) {
          jc(this, t, e);
        }
      }, {
        key: "modifySelection",
        value: function modifySelection(t, e) {
          Fc(this, t, e);
        }
      }, {
        key: "getSelectedContent",
        value: function getSelectedContent(t) {
          return function (t, e) {
            return t.change(function (t) {
              var n = t.createDocumentFragment(),
                  i = e.getFirstRange();
              if (!i || i.isCollapsed) return n;
              var o = i.start.root,
                  r = i.start.getCommonPath(i.end),
                  s = o.getNodeByPath(r);
              var a;
              var c = (a = i.start.parent == i.end.parent ? i : t.createRange(t.createPositionAt(s, i.start.path[r.length]), t.createPositionAt(s, i.end.path[r.length] + 1))).end.offset - a.start.offset;

              var _iterator235 = _createForOfIteratorHelper(a.getItems({
                shallow: !0
              })),
                  _step235;

              try {
                for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
                  var _e178 = _step235.value;
                  _e178.is("textProxy") ? t.appendText(_e178.data, _e178.getAttributes(), n) : t.append(_e178._clone(!0), n);
                }
              } catch (err) {
                _iterator235.e(err);
              } finally {
                _iterator235.f();
              }

              if (a != i) {
                var _e177 = i._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0],
                    _o55 = t.createRange(t.createPositionAt(n, 0), _e177.start);

                Wc(t.createRange(_e177.end, t.createPositionAt(n, "end")), t), Wc(_o55, t);
              }

              return n;
            });
          }(this, t);
        }
      }, {
        key: "hasContent",
        value: function hasContent(t, e) {
          var n = t instanceof Hs ? Gs._createIn(t) : t;
          if (n.isCollapsed) return !1;

          var _iterator236 = _createForOfIteratorHelper(this.markers.getMarkersIntersectingRange(n)),
              _step236;

          try {
            for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
              var _t192 = _step236.value;
              if (_t192.affectsData) return !0;
            }
          } catch (err) {
            _iterator236.e(err);
          } finally {
            _iterator236.f();
          }

          var _ref79 = e || {},
              _ref79$ignoreWhitespa = _ref79.ignoreWhitespaces,
              i = _ref79$ignoreWhitespa === void 0 ? !1 : _ref79$ignoreWhitespa;

          var _iterator237 = _createForOfIteratorHelper(n.getItems()),
              _step237;

          try {
            for (_iterator237.s(); !(_step237 = _iterator237.n()).done;) {
              var _t193 = _step237.value;

              if (_t193.is("textProxy")) {
                if (!i) return !0;
                if (-1 !== _t193.data.search(/\S/)) return !0;
              } else if (this.schema.isObject(_t193)) return !0;
            }
          } catch (err) {
            _iterator237.e(err);
          } finally {
            _iterator237.f();
          }

          return !1;
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return new $s(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return $s._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return $s._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return $s._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Gs(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Gs._createIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Gs._createOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new ta(t, e, n);
        }
      }, {
        key: "createBatch",
        value: function createBatch(t) {
          return new Ka(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.document.destroy(), this.stopListening();
        }
      }, {
        key: "_runPendingChanges",
        value: function _runPendingChanges() {
          var t = [];

          for (this.fire("_beforeChanges"); this._pendingChanges.length;) {
            var _e179 = this._pendingChanges[0].batch;
            this._currentWriter = new bc(this, _e179);

            var _n158 = this._pendingChanges[0].callback(this._currentWriter);

            t.push(_n158), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
          }

          return this.fire("_afterChanges"), t;
        }
      }]);

      return Kc;
    }();

    ci(Kc, Fi);

    var Jc = /*#__PURE__*/function () {
      function Jc() {
        _classCallCheck(this, Jc);

        this._listener = Object.create(lr);
      }

      _createClass(Jc, [{
        key: "listenTo",
        value: function listenTo(t) {
          var _this69 = this;

          this._listener.listenTo(t, "keydown", function (t, e) {
            _this69._listener.fire("_keydown:" + wo(e), e);
          });
        }
      }, {
        key: "set",
        value: function set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var i = ko(t),
              o = n.priority;

          this._listener.listenTo(this._listener, "_keydown:" + i, function (t, n) {
            e(n, function () {
              n.preventDefault(), n.stopPropagation(), t.stop();
            }), t.return = !0;
          }, {
            priority: o
          });
        }
      }, {
        key: "press",
        value: function press(t) {
          return !!this._listener.fire("_keydown:" + wo(t), t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._listener.stopListening();
        }
      }]);

      return Jc;
    }();

    var Zc = /*#__PURE__*/function (_Jc) {
      _inherits(Zc, _Jc);

      var _super35 = _createSuper(Zc);

      function Zc(t) {
        var _this70;

        _classCallCheck(this, Zc);

        _this70 = _super35.call(this), _this70.editor = t;
        return _this70;
      }

      _createClass(Zc, [{
        key: "set",
        value: function set(t, e) {
          var _this71 = this;

          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if ("string" == typeof e) {
            var _t194 = e;

            e = function e(_e180, n) {
              _this71.editor.execute(_t194), n();
            };
          }

          _get(_getPrototypeOf(Zc.prototype), "set", this).call(this, t, e, n);
        }
      }]);

      return Zc;
    }(Jc);

    var Xc = /*#__PURE__*/function () {
      function Xc(t) {
        var _this72 = this;

        _classCallCheck(this, Xc);

        var e = this.constructor.builtinPlugins;
        this.config = new Yn(t, this.constructor.defaultConfig), this.config.define("plugins", e), this.plugins = new Ta(this, e), this.commands = new Ca();
        var n = this.config.get("language") || {};
        this.locale = new Ma({
          uiLanguage: "string" == typeof n ? n : n.ui,
          contentLanguage: this.config.get("language.content")
        }), this.t = this.locale.t, this.set("state", "initializing"), this.once("ready", function () {
          return _this72.state = "ready";
        }, {
          priority: "high"
        }), this.once("destroy", function () {
          return _this72.state = "destroyed";
        }, {
          priority: "high"
        }), this.set("isReadOnly", !1), this.model = new Kc(), this.data = new Ya(this.model), this.editing = new Aa(this.model), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new $a([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new Zc(this), this.keystrokes.listenTo(this.editing.view.document);
      }

      _createClass(Xc, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config,
              e = t.get("plugins") || [],
              n = t.get("removePlugins") || [],
              i = t.get("extraPlugins") || [];
          return this.plugins.init(e.concat(i), n);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this73 = this;

          var t = Promise.resolve();
          return "initializing" == this.state && (t = new Promise(function (t) {
            return _this73.once("ready", t);
          })), t.then(function () {
            _this73.fire("destroy"), _this73.stopListening(), _this73.commands.destroy();
          }).then(function () {
            return _this73.plugins.destroy();
          }).then(function () {
            _this73.model.destroy(), _this73.data.destroy(), _this73.editing.destroy(), _this73.keystrokes.destroy();
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this$commands;

          (_this$commands = this.commands).execute.apply(_this$commands, arguments);
        }
      }]);

      return Xc;
    }();

    ci(Xc, Fi);
    var tl = {
      setData: function setData(t) {
        this.data.set(t);
      },
      getData: function getData(t) {
        return this.data.get(t);
      }
    };
    var el = {
      updateSourceElement: function updateSourceElement() {
        if (!this.sourceElement) throw new Gn.b("editor-missing-sourceelement: Cannot update the source element of a detached editor.", this);
        !function (t, e) {
          t instanceof HTMLTextAreaElement && (t.value = e), t.innerHTML = e;
        }(this.sourceElement, this.data.get());
      }
    };

    var nl = /*#__PURE__*/function () {
      function nl() {
        _classCallCheck(this, nl);
      }

      _createClass(nl, [{
        key: "getHtml",
        value: function getHtml(t) {
          var e = document.implementation.createHTMLDocument("").createElement("div");
          return e.appendChild(t), e.innerHTML;
        }
      }]);

      return nl;
    }();

    var il = /*#__PURE__*/function () {
      function il() {
        _classCallCheck(this, il);

        this._domParser = new DOMParser(), this._domConverter = new rr({
          blockFiller: jo
        }), this._htmlWriter = new nl();
      }

      _createClass(il, [{
        key: "toData",
        value: function toData(t) {
          var e = this._domConverter.viewToDom(t, document);

          return this._htmlWriter.getHtml(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          var e = this._toDom(t);

          return this._domConverter.domToView(e);
        }
      }, {
        key: "_toDom",
        value: function _toDom(t) {
          var e = this._domParser.parseFromString(t, "text/html"),
              n = e.createDocumentFragment(),
              i = e.body.childNodes;

          for (; i.length > 0;) {
            n.appendChild(i[0]);
          }

          return n;
        }
      }]);

      return il;
    }();

    var ol = /*#__PURE__*/function () {
      function ol(t) {
        _classCallCheck(this, ol);

        this.editor = t, this._components = new Map();
      }

      _createClass(ol, [{
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function names() {
          var _iterator238, _step238, _t195;

          return _regeneratorRuntime.wrap(function names$(_context34) {
            while (1) {
              switch (_context34.prev = _context34.next) {
                case 0:
                  _iterator238 = _createForOfIteratorHelper(this._components.values());
                  _context34.prev = 1;

                  _iterator238.s();

                case 3:
                  if ((_step238 = _iterator238.n()).done) {
                    _context34.next = 9;
                    break;
                  }

                  _t195 = _step238.value;
                  _context34.next = 7;
                  return _t195.originalName;

                case 7:
                  _context34.next = 3;
                  break;

                case 9:
                  _context34.next = 14;
                  break;

                case 11:
                  _context34.prev = 11;
                  _context34.t0 = _context34["catch"](1);

                  _iterator238.e(_context34.t0);

                case 14:
                  _context34.prev = 14;

                  _iterator238.f();

                  return _context34.finish(14);

                case 17:
                case "end":
                  return _context34.stop();
              }
            }
          }, names, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "add",
        value: function add(t, e) {
          if (this.has(t)) throw new Gn.b("componentfactory-item-exists: The item already exists in the component factory.", this, {
            name: t
          });

          this._components.set(rl(t), {
            callback: e,
            originalName: t
          });
        }
      }, {
        key: "create",
        value: function create(t) {
          if (!this.has(t)) throw new Gn.b("componentfactory-item-missing: The required component is not registered in the factory.", this, {
            name: t
          });
          return this._components.get(rl(t)).callback(this.editor.locale);
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._components.has(rl(t));
        }
      }]);

      return ol;
    }();

    function rl(t) {
      return String(t).toLowerCase();
    }

    var sl = /*#__PURE__*/function () {
      function sl() {
        _classCallCheck(this, sl);

        this.set("isFocused", !1), this.set("focusedElement", null), this._elements = new Set(), this._nextEventLoopTimeout = null;
      }

      _createClass(sl, [{
        key: "add",
        value: function add(t) {
          var _this74 = this;

          if (this._elements.has(t)) throw new Gn.b("focusTracker-add-element-already-exist", this);
          this.listenTo(t, "focus", function () {
            return _this74._focus(t);
          }, {
            useCapture: !0
          }), this.listenTo(t, "blur", function () {
            return _this74._blur();
          }, {
            useCapture: !0
          }), this._elements.add(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          t === this.focusedElement && this._blur(t), this._elements.has(t) && (this.stopListening(t), this._elements.delete(t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t, this.isFocused = !0;
        }
      }, {
        key: "_blur",
        value: function _blur() {
          var _this75 = this;

          clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(function () {
            _this75.focusedElement = null, _this75.isFocused = !1;
          }, 0);
        }
      }]);

      return sl;
    }();

    ci(sl, lr), ci(sl, Fi);

    var al = /*#__PURE__*/function () {
      function al(t) {
        var _this76 = this;

        _classCallCheck(this, al);

        this.editor = t, this.componentFactory = new ol(t), this.focusTracker = new sl(), this._editableElementsMap = new Map(), this.listenTo(t.editing.view.document, "layoutChanged", function () {
          return _this76.update();
        });
      }

      _createClass(al, [{
        key: "element",
        get: function get() {
          return null;
        }
      }, {
        key: "update",
        value: function update() {
          this.fire("update");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this.focusTracker.destroy();

          var _iterator239 = _createForOfIteratorHelper(this._editableElementsMap.values()),
              _step239;

          try {
            for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
              var _t196 = _step239.value;
              _t196.ckeditorInstance = null;
            }
          } catch (err) {
            _iterator239.e(err);
          } finally {
            _iterator239.f();
          }

          this._editableElementsMap = new Map();
        }
      }, {
        key: "setEditableElement",
        value: function setEditableElement(t, e) {
          this._editableElementsMap.set(t, e), e.ckeditorInstance || (e.ckeditorInstance = this.editor);
        }
      }, {
        key: "getEditableElement",
        value: function getEditableElement() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this._editableElementsMap.get(t);
        }
      }, {
        key: "getEditableElementsNames",
        value: function getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
      }, {
        key: "_editableElements",
        get: function get() {
          return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
            editorUI: this
          }), this._editableElementsMap;
        }
      }]);

      return al;
    }();

    ci(al, ei);
    n(14);
    var cl = new WeakMap();

    function ll(t) {
      var e = t.view,
          n = t.element,
          i = t.text,
          _t$isDirectHost = t.isDirectHost,
          o = _t$isDirectHost === void 0 ? !0 : _t$isDirectHost,
          r = e.document;
      cl.has(r) || (cl.set(r, new Map()), r.registerPostFixer(function (t) {
        return hl(r, t);
      })), cl.get(r).set(n, {
        text: i,
        isDirectHost: o
      }), e.change(function (t) {
        return hl(r, t);
      });
    }

    function dl(t, e) {
      return !!e.hasClass("ck-placeholder") && (t.removeClass("ck-placeholder", e), !0);
    }

    function hl(t, e) {
      var n = cl.get(t);
      var i = !1;

      var _iterator240 = _createForOfIteratorHelper(n),
          _step240;

      try {
        for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
          var _ref82 = _step240.value;

          var _ref81 = _slicedToArray(_ref82, 2);

          var _t197 = _ref81[0];
          var _o56 = _ref81[1];
          ul(e, _t197, _o56) && (i = !0);
        }
      } catch (err) {
        _iterator240.e(err);
      } finally {
        _iterator240.f();
      }

      return i;
    }

    function ul(t, e, n) {
      var i = n.text,
          o = n.isDirectHost,
          r = o ? e : function (t) {
        if (1 === t.childCount) {
          var _e181 = t.getChild(0);

          if (_e181.is("element") && !_e181.is("uiElement")) return _e181;
        }

        return null;
      }(e);
      var s = !1;
      return !!r && (n.hostElement = r, r.getAttribute("data-placeholder") !== i && (t.setAttribute("data-placeholder", i, r), s = !0), !function (t) {
        var e = t.document;
        if (!e) return !1;
        var n = !Array.from(t.getChildren()).some(function (t) {
          return !t.is("uiElement");
        });
        if (!e.isFocused && n) return !0;
        var i = e.selection.anchor;
        return !(!n || !i || i.parent === t);
      }(r) ? dl(t, r) && (s = !0) : function (t, e) {
        return !e.hasClass("ck-placeholder") && (t.addClass("ck-placeholder", e), !0);
      }(t, r) && (s = !0), s);
    }

    var fl = /*#__PURE__*/function () {
      function fl() {
        _classCallCheck(this, fl);

        this._replacedElements = [];
      }

      _createClass(fl, [{
        key: "replace",
        value: function replace(t, e) {
          this._replacedElements.push({
            element: t,
            newElement: e
          }), t.style.display = "none", e && t.parentNode.insertBefore(e, t.nextSibling);
        }
      }, {
        key: "restore",
        value: function restore() {
          this._replacedElements.forEach(function (_ref83) {
            var t = _ref83.element,
                e = _ref83.newElement;
            t.style.display = "", e && e.remove();
          }), this._replacedElements = [];
        }
      }]);

      return fl;
    }();

    var ml = /*#__PURE__*/function (_al) {
      _inherits(ml, _al);

      var _super36 = _createSuper(ml);

      function ml(t, e) {
        var _this77;

        _classCallCheck(this, ml);

        _this77 = _super36.call(this, t), _this77.view = e, _this77._toolbarConfig = function (t) {
          return Array.isArray(t) ? {
            items: t
          } : t ? Object.assign({
            items: []
          }, t) : {
            items: []
          };
        }(t.config.get("toolbar")), _this77._elementReplacer = new fl();
        return _this77;
      }

      _createClass(ml, [{
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }, {
        key: "init",
        value: function init(t) {
          var e = this.editor,
              n = this.view,
              i = e.editing.view,
              o = n.editable,
              r = i.document.getRoot();
          o.name = r.rootName, n.render();
          var s = o.element;
          this.setEditableElement(o.name, s), this.focusTracker.add(s), n.editable.bind("isFocused").to(this.focusTracker), i.attachDomRoot(s), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.view,
              e = this.editor.editing.view;
          this._elementReplacer.restore(), e.detachDomRoot(t.editable.name), t.destroy(), _get(_getPrototypeOf(ml.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var t = this.editor,
              e = this.view,
              n = t.editing.view;
          e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), e.stickyPanel.limiterElement = e.element, this._toolbarConfig.viewportTopOffset && (e.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset), e.toolbar.fillFromConfig(this._toolbarConfig.items, this.componentFactory), function (_ref84) {
            var t = _ref84.origin,
                e = _ref84.originKeystrokeHandler,
                n = _ref84.originFocusTracker,
                i = _ref84.toolbar,
                o = _ref84.beforeFocus,
                r = _ref84.afterBlur;
            n.add(i.element), e.set("Alt+F10", function (t, e) {
              n.isFocused && !i.focusTracker.isFocused && (o && o(), i.focus(), e());
            }), i.keystrokes.set("Esc", function (e, n) {
              i.focusTracker.isFocused && (t.focus(), r && r(), n());
            });
          }({
            origin: n,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: t.keystrokes,
            toolbar: e.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document.getRoot(),
              i = t.sourceElement,
              o = t.config.get("placeholder") || i && "textarea" === i.tagName.toLowerCase() && i.getAttribute("placeholder");
          o && ll({
            view: e,
            element: n,
            text: o,
            isDirectHost: !1
          });
        }
      }]);

      return ml;
    }(al);

    var gl = /*#__PURE__*/function (_oo) {
      _inherits(gl, _oo);

      var _super37 = _createSuper(gl);

      function gl(t) {
        var _this78;

        _classCallCheck(this, gl);

        _this78 = _super37.call(this, {
          idProperty: "viewUid"
        }), _this78.on("add", function (t, e, n) {
          e.isRendered || e.render(), e.element && _this78._parentElement && _this78._parentElement.insertBefore(e.element, _this78._parentElement.children[n]);
        }), _this78.on("remove", function (t, e) {
          e.element && _this78._parentElement && e.element.remove();
        }), _this78.locale = t, _this78._parentElement = null;
        return _this78;
      }

      _createClass(gl, [{
        key: "destroy",
        value: function destroy() {
          this.map(function (t) {
            return t.destroy();
          });
        }
      }, {
        key: "setParent",
        value: function setParent(t) {
          this._parentElement = t;
        }
      }, {
        key: "delegate",
        value: function delegate() {
          var _this79 = this;

          for (var _len17 = arguments.length, t = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            t[_key17] = arguments[_key17];
          }

          if (!t.length || !function (t) {
            return t.every(function (t) {
              return "string" == typeof t;
            });
          }(t)) throw new Gn.b("ui-viewcollection-delegate-wrong-events: All event names must be strings.", this);
          return {
            to: function to(e) {
              var _iterator241 = _createForOfIteratorHelper(_this79),
                  _step241;

              try {
                for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
                  var _n161 = _step241.value;

                  var _iterator244 = _createForOfIteratorHelper(t),
                      _step244;

                  try {
                    for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
                      var _i116 = _step244.value;

                      _n161.delegate(_i116).to(e);
                    }
                  } catch (err) {
                    _iterator244.e(err);
                  } finally {
                    _iterator244.f();
                  }
                }
              } catch (err) {
                _iterator241.e(err);
              } finally {
                _iterator241.f();
              }

              _this79.on("add", function (n, i) {
                var _iterator242 = _createForOfIteratorHelper(t),
                    _step242;

                try {
                  for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
                    var _n159 = _step242.value;
                    i.delegate(_n159).to(e);
                  }
                } catch (err) {
                  _iterator242.e(err);
                } finally {
                  _iterator242.f();
                }
              }), _this79.on("remove", function (n, i) {
                var _iterator243 = _createForOfIteratorHelper(t),
                    _step243;

                try {
                  for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
                    var _n160 = _step243.value;
                    i.stopDelegating(_n160, e);
                  }
                } catch (err) {
                  _iterator243.e(err);
                } finally {
                  _iterator243.f();
                }
              });
            }
          };
        }
      }]);

      return gl;
    }(oo);

    var pl = "http://www.w3.org/1999/xhtml";

    var bl = /*#__PURE__*/function () {
      function bl(t) {
        _classCallCheck(this, bl);

        Object.assign(this, Cl(Tl(t))), this._isRendered = !1, this._revertData = null;
      }

      _createClass(bl, [{
        key: "render",
        value: function render() {
          var t = this._renderNode({
            intoFragment: !0
          });

          return this._isRendered = !0, t;
        }
      }, {
        key: "apply",
        value: function apply(t) {
          return this._revertData = {
            children: [],
            bindings: [],
            attributes: {}
          }, this._renderNode({
            node: t,
            isApplying: !0,
            revertData: this._revertData
          }), t;
        }
      }, {
        key: "revert",
        value: function revert(t) {
          if (!this._revertData) throw new Gn.b("ui-template-revert-not-applied: Attempting to revert a template which has not been applied yet.", [this, t]);

          this._revertTemplateFromNode(t, this._revertData);
        }
      }, {
        key: "getViews",
        value: /*#__PURE__*/_regeneratorRuntime.mark(function getViews() {
          return _regeneratorRuntime.wrap(function getViews$(_context36) {
            while (1) {
              switch (_context36.prev = _context36.next) {
                case 0:
                  return _context36.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function t(e) {
                    var _iterator245, _step245, _n162;

                    return _regeneratorRuntime.wrap(function t$(_context35) {
                      while (1) {
                        switch (_context35.prev = _context35.next) {
                          case 0:
                            if (!e.children) {
                              _context35.next = 24;
                              break;
                            }

                            _iterator245 = _createForOfIteratorHelper(e.children);
                            _context35.prev = 2;

                            _iterator245.s();

                          case 4:
                            if ((_step245 = _iterator245.n()).done) {
                              _context35.next = 16;
                              break;
                            }

                            _n162 = _step245.value;

                            if (!Il(_n162)) {
                              _context35.next = 11;
                              break;
                            }

                            _context35.next = 9;
                            return _n162;

                          case 9:
                            _context35.next = 14;
                            break;

                          case 11:
                            _context35.t0 = Nl(_n162);

                            if (!_context35.t0) {
                              _context35.next = 14;
                              break;
                            }

                            return _context35.delegateYield(t(_n162), "t1", 14);

                          case 14:
                            _context35.next = 4;
                            break;

                          case 16:
                            _context35.next = 21;
                            break;

                          case 18:
                            _context35.prev = 18;
                            _context35.t2 = _context35["catch"](2);

                            _iterator245.e(_context35.t2);

                          case 21:
                            _context35.prev = 21;

                            _iterator245.f();

                            return _context35.finish(21);

                          case 24:
                          case "end":
                            return _context35.stop();
                        }
                      }
                    }, t, null, [[2, 18, 21, 24]]);
                  })(this), "t0", 1);

                case 1:
                case "end":
                  return _context36.stop();
              }
            }
          }, getViews, this);
        })
      }, {
        key: "_renderNode",
        value: function _renderNode(t) {
          var e;
          if (e = t.node ? this.tag && this.text : this.tag ? this.text : !this.text) throw new Gn.b('ui-template-wrong-syntax: Node definition must have either "tag" or "text" when rendering a new Node.', this);
          return this.text ? this._renderText(t) : this._renderElement(t);
        }
      }, {
        key: "_renderElement",
        value: function _renderElement(t) {
          var e = t.node;
          return e || (e = t.node = document.createElementNS(this.ns || pl, this.tag)), this._renderAttributes(t), this._renderElementChildren(t), this._setUpListeners(t), e;
        }
      }, {
        key: "_renderText",
        value: function _renderText(t) {
          var e = t.node;
          return e ? t.revertData.text = e.textContent : e = t.node = document.createTextNode(""), vl(this.text) ? this._bindToObservable({
            schema: this.text,
            updater: function (t) {
              return {
                set: function set(e) {
                  t.textContent = e;
                },
                remove: function remove() {
                  t.textContent = "";
                }
              };
            }(e),
            data: t
          }) : e.textContent = this.text.join(""), e;
        }
      }, {
        key: "_renderAttributes",
        value: function _renderAttributes(t) {
          var e, n, i, o;
          if (!this.attributes) return;
          var r = t.node,
              s = t.revertData;

          for (e in this.attributes) {
            if (i = r.getAttribute(e), n = this.attributes[e], s && (s.attributes[e] = i), o = B(n[0]) && n[0].ns ? n[0].ns : null, vl(n)) {
              var _a11 = o ? n[0].value : n;

              s && Rl(e) && _a11.unshift(i), this._bindToObservable({
                schema: _a11,
                updater: xl(r, e, o),
                data: t
              });
            } else "style" == e && "string" != typeof n[0] ? this._renderStyleAttribute(n[0], t) : (s && i && Rl(e) && n.unshift(i), El(n = n.map(function (t) {
              return t && t.value || t;
            }).reduce(function (t, e) {
              return t.concat(e);
            }, []).reduce(Sl, "")) || r.setAttributeNS(o, e, n));
          }
        }
      }, {
        key: "_renderStyleAttribute",
        value: function _renderStyleAttribute(t, e) {
          var n = e.node;

          for (var _i117 in t) {
            var _o57 = t[_i117];
            vl(_o57) ? this._bindToObservable({
              schema: [_o57],
              updater: Al(n, _i117),
              data: e
            }) : n.style[_i117] = _o57;
          }
        }
      }, {
        key: "_renderElementChildren",
        value: function _renderElementChildren(t) {
          var e = t.node,
              n = t.intoFragment ? document.createDocumentFragment() : e,
              i = t.isApplying;
          var o = 0;

          var _iterator246 = _createForOfIteratorHelper(this.children),
              _step246;

          try {
            for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
              var _r24 = _step246.value;

              if (Ol(_r24)) {
                if (!i) {
                  _r24.setParent(e);

                  var _iterator247 = _createForOfIteratorHelper(_r24),
                      _step247;

                  try {
                    for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
                      var _t198 = _step247.value;
                      n.appendChild(_t198.element);
                    }
                  } catch (err) {
                    _iterator247.e(err);
                  } finally {
                    _iterator247.f();
                  }
                }
              } else if (Il(_r24)) i || (_r24.isRendered || _r24.render(), n.appendChild(_r24.element));else if (Zo(_r24)) n.appendChild(_r24);else if (i) {
                var _e182 = {
                  children: [],
                  bindings: [],
                  attributes: {}
                };
                t.revertData.children.push(_e182), _r24._renderNode({
                  node: n.childNodes[o++],
                  isApplying: !0,
                  revertData: _e182
                });
              } else n.appendChild(_r24.render());
            }
          } catch (err) {
            _iterator246.e(err);
          } finally {
            _iterator246.f();
          }

          t.intoFragment && e.appendChild(n);
        }
      }, {
        key: "_setUpListeners",
        value: function _setUpListeners(t) {
          var _this80 = this;

          if (this.eventListeners) {
            var _loop4 = function _loop4(_e183) {
              var n = _this80.eventListeners[_e183].map(function (n) {
                var _e183$split = _e183.split("@"),
                    _e183$split2 = _slicedToArray(_e183$split, 2),
                    i = _e183$split2[0],
                    o = _e183$split2[1];

                return n.activateDomEventListener(i, o, t);
              });

              t.revertData && t.revertData.bindings.push(n);
            };

            for (var _e183 in this.eventListeners) {
              _loop4(_e183);
            }
          }
        }
      }, {
        key: "_bindToObservable",
        value: function _bindToObservable(_ref85) {
          var t = _ref85.schema,
              e = _ref85.updater,
              n = _ref85.data;
          var i = n.revertData;
          yl(t, e, n);
          var o = t.filter(function (t) {
            return !El(t);
          }).filter(function (t) {
            return t.observable;
          }).map(function (i) {
            return i.activateAttributeListener(t, e, n);
          });
          i && i.bindings.push(o);
        }
      }, {
        key: "_revertTemplateFromNode",
        value: function _revertTemplateFromNode(t, e) {
          var _iterator248 = _createForOfIteratorHelper(e.bindings),
              _step248;

          try {
            for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
              var _t199 = _step248.value;

              var _iterator249 = _createForOfIteratorHelper(_t199),
                  _step249;

              try {
                for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
                  var _e184 = _step249.value;

                  _e184();
                }
              } catch (err) {
                _iterator249.e(err);
              } finally {
                _iterator249.f();
              }
            }
          } catch (err) {
            _iterator248.e(err);
          } finally {
            _iterator248.f();
          }

          if (e.text) t.textContent = e.text;else {
            for (var _n163 in e.attributes) {
              var _i118 = e.attributes[_n163];
              null === _i118 ? t.removeAttribute(_n163) : t.setAttribute(_n163, _i118);
            }

            for (var _n164 = 0; _n164 < e.children.length; ++_n164) {
              this._revertTemplateFromNode(t.childNodes[_n164], e.children[_n164]);
            }
          }
        }
      }], [{
        key: "bind",
        value: function bind(t, e) {
          return {
            to: function to(n, i) {
              return new kl({
                eventNameOrFunction: n,
                attribute: n,
                observable: t,
                emitter: e,
                callback: i
              });
            },
            if: function _if(n, i, o) {
              return new _l({
                observable: t,
                emitter: e,
                attribute: n,
                valueIfTrue: i,
                callback: o
              });
            }
          };
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (t._isRendered) throw new Gn.b("template-extend-render: Attempting to extend a template which has already been rendered.", [this, t]);
          !function t(e, n) {
            var _e$text;

            n.attributes && (e.attributes || (e.attributes = {}), Ml(e.attributes, n.attributes));
            n.eventListeners && (e.eventListeners || (e.eventListeners = {}), Ml(e.eventListeners, n.eventListeners));
            n.text && (_e$text = e.text).push.apply(_e$text, _toConsumableArray(n.text));

            if (n.children && n.children.length) {
              if (e.children.length != n.children.length) throw new Gn.b("ui-template-extend-children-mismatch: The number of children in extended definition does not match.", e);
              var _i119 = 0;

              var _iterator250 = _createForOfIteratorHelper(n.children),
                  _step250;

              try {
                for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                  var _o58 = _step250.value;
                  t(e.children[_i119++], _o58);
                }
              } catch (err) {
                _iterator250.e(err);
              } finally {
                _iterator250.f();
              }
            }
          }(t, Cl(Tl(e)));
        }
      }]);

      return bl;
    }();

    ci(bl, ei);

    var wl = /*#__PURE__*/function () {
      function wl(t) {
        _classCallCheck(this, wl);

        Object.assign(this, t);
      }

      _createClass(wl, [{
        key: "getValue",
        value: function getValue(t) {
          var e = this.observable[this.attribute];
          return this.callback ? this.callback(e, t) : e;
        }
      }, {
        key: "activateAttributeListener",
        value: function activateAttributeListener(t, e, n) {
          var _this81 = this;

          var i = function i() {
            return yl(t, e, n);
          };

          return this.emitter.listenTo(this.observable, "change:" + this.attribute, i), function () {
            _this81.emitter.stopListening(_this81.observable, "change:" + _this81.attribute, i);
          };
        }
      }]);

      return wl;
    }();

    var kl = /*#__PURE__*/function (_wl) {
      _inherits(kl, _wl);

      var _super38 = _createSuper(kl);

      function kl() {
        _classCallCheck(this, kl);

        return _super38.apply(this, arguments);
      }

      _createClass(kl, [{
        key: "activateDomEventListener",
        value: function activateDomEventListener(t, e, n) {
          var _this82 = this;

          var i = function i(t, n) {
            e && !n.target.matches(e) || ("function" == typeof _this82.eventNameOrFunction ? _this82.eventNameOrFunction(n) : _this82.observable.fire(_this82.eventNameOrFunction, n));
          };

          return this.emitter.listenTo(n.node, t, i), function () {
            _this82.emitter.stopListening(n.node, t, i);
          };
        }
      }]);

      return kl;
    }(wl);

    var _l = /*#__PURE__*/function (_wl2) {
      _inherits(_l, _wl2);

      var _super39 = _createSuper(_l);

      function _l() {
        _classCallCheck(this, _l);

        return _super39.apply(this, arguments);
      }

      _createClass(_l, [{
        key: "getValue",
        value: function getValue(t) {
          return !El(_get(_getPrototypeOf(_l.prototype), "getValue", this).call(this, t)) && (this.valueIfTrue || !0);
        }
      }]);

      return _l;
    }(wl);

    function vl(t) {
      return !!t && (t.value && (t = t.value), Array.isArray(t) ? t.some(vl) : t instanceof wl);
    }

    function yl(t, e, _ref86) {
      var n = _ref86.node;

      var i = function (t, e) {
        return t.map(function (t) {
          return t instanceof wl ? t.getValue(e) : t;
        });
      }(t, n);

      El(i = 1 == t.length && t[0] instanceof _l ? i[0] : i.reduce(Sl, "")) ? e.remove() : e.set(i);
    }

    function xl(t, e, n) {
      return {
        set: function set(i) {
          t.setAttributeNS(n, e, i);
        },
        remove: function remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }

    function Al(t, e) {
      return {
        set: function set(n) {
          t.style[e] = n;
        },
        remove: function remove() {
          t.style[e] = null;
        }
      };
    }

    function Tl(t) {
      return qn(t, function (t) {
        if (t && (t instanceof wl || Nl(t) || Il(t) || Ol(t))) return t;
      });
    }

    function Cl(t) {
      if ("string" == typeof t ? t = function (t) {
        return {
          text: [t]
        };
      }(t) : t.text && function (t) {
        Array.isArray(t.text) || (t.text = [t.text]);
      }(t), t.on && (t.eventListeners = function (t) {
        for (var _e185 in t) {
          Pl(t, _e185);
        }

        return t;
      }(t.on), delete t.on), !t.text) {
        t.attributes && function (t) {
          for (var _e187 in t) {
            t[_e187].value && (t[_e187].value = [].concat(t[_e187].value)), Pl(t, _e187);
          }
        }(t.attributes);
        var _e186 = [];
        if (t.children) if (Ol(t.children)) _e186.push(t.children);else {
          var _iterator251 = _createForOfIteratorHelper(t.children),
              _step251;

          try {
            for (_iterator251.s(); !(_step251 = _iterator251.n()).done;) {
              var _n165 = _step251.value;
              Nl(_n165) || Il(_n165) || Zo(_n165) ? _e186.push(_n165) : _e186.push(new bl(_n165));
            }
          } catch (err) {
            _iterator251.e(err);
          } finally {
            _iterator251.f();
          }
        }
        t.children = _e186;
      }

      return t;
    }

    function Pl(t, e) {
      Array.isArray(t[e]) || (t[e] = [t[e]]);
    }

    function Sl(t, e) {
      return El(e) ? t : El(t) ? e : "".concat(t, " ").concat(e);
    }

    function Ml(t, e) {
      for (var _n166 in e) {
        var _t$_n;

        t[_n166] ? (_t$_n = t[_n166]).push.apply(_t$_n, _toConsumableArray(e[_n166])) : t[_n166] = e[_n166];
      }
    }

    function El(t) {
      return !t && 0 !== t;
    }

    function Il(t) {
      return t instanceof Dl;
    }

    function Nl(t) {
      return t instanceof bl;
    }

    function Ol(t) {
      return t instanceof gl;
    }

    function Rl(t) {
      return "class" == t || "style" == t;
    }

    n(16);

    var Dl = /*#__PURE__*/function () {
      function Dl(t) {
        _classCallCheck(this, Dl);

        this.element = null, this.isRendered = !1, this.locale = t, this.t = t && t.t, this._viewCollections = new oo(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", function (e, n) {
          n.locale = t;
        }), this.decorate("render");
      }

      _createClass(Dl, [{
        key: "bindTemplate",
        get: function get() {
          return this._bindTemplate ? this._bindTemplate : this._bindTemplate = bl.bind(this, this);
        }
      }, {
        key: "createCollection",
        value: function createCollection() {
          var t = new gl();
          return this._viewCollections.add(t), t;
        }
      }, {
        key: "registerChild",
        value: function registerChild(t) {
          pi(t) || (t = [t]);

          var _iterator252 = _createForOfIteratorHelper(t),
              _step252;

          try {
            for (_iterator252.s(); !(_step252 = _iterator252.n()).done;) {
              var _e188 = _step252.value;

              this._unboundChildren.add(_e188);
            }
          } catch (err) {
            _iterator252.e(err);
          } finally {
            _iterator252.f();
          }
        }
      }, {
        key: "deregisterChild",
        value: function deregisterChild(t) {
          pi(t) || (t = [t]);

          var _iterator253 = _createForOfIteratorHelper(t),
              _step253;

          try {
            for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
              var _e189 = _step253.value;

              this._unboundChildren.remove(_e189);
            }
          } catch (err) {
            _iterator253.e(err);
          } finally {
            _iterator253.f();
          }
        }
      }, {
        key: "setTemplate",
        value: function setTemplate(t) {
          this.template = new bl(t);
        }
      }, {
        key: "extendTemplate",
        value: function extendTemplate(t) {
          bl.extend(this.template, t);
        }
      }, {
        key: "render",
        value: function render() {
          if (this.isRendered) throw new Gn.b("ui-view-render-already-rendered: This View has already been rendered.", this);
          this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = !0;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening(), this._viewCollections.map(function (t) {
            return t.destroy();
          }), this.template && this.template._revertData && this.template.revert(this.element);
        }
      }]);

      return Dl;
    }();

    ci(Dl, lr), ci(Dl, Fi);
    n(18);

    var Ll = /*#__PURE__*/function (_Dl) {
      _inherits(Ll, _Dl);

      var _super40 = _createSuper(Ll);

      function Ll(t) {
        var _this83;

        _classCallCheck(this, Ll);

        _this83 = _super40.call(this, t), _this83.body = _this83.createCollection();
        return _this83;
      }

      _createClass(Ll, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Ll.prototype), "render", this).call(this), this._renderBodyCollection();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          return this._bodyCollectionContainer.remove(), _get(_getPrototypeOf(Ll.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_renderBodyCollection",
        value: function _renderBodyCollection() {
          var t = this.locale,
              e = this._bodyCollectionContainer = new bl({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
              dir: t.uiLanguageDirection
            },
            children: this.body
          }).render();
          document.body.appendChild(e);
        }
      }]);

      return Ll;
    }(Dl);

    n(20);

    var jl = /*#__PURE__*/function (_Dl2) {
      _inherits(jl, _Dl2);

      var _super41 = _createSuper(jl);

      function jl(t) {
        var _this84;

        _classCallCheck(this, jl);

        _this84 = _super41.call(this, t), _this84.set("text"), _this84.set("for");
        var e = _this84.bindTemplate;

        _this84.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });

        return _this84;
      }

      return jl;
    }(Dl);

    var Vl = /*#__PURE__*/function (_Ll) {
      _inherits(Vl, _Ll);

      var _super42 = _createSuper(Vl);

      function Vl(t) {
        var _this85;

        _classCallCheck(this, Vl);

        _this85 = _super42.call(this, t);
        var e = Jn();
        _this85.top = _this85.createCollection(), _this85.main = _this85.createCollection(), _this85._voiceLabelView = _this85._createVoiceLabel(e), _this85.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: t.uiLanguageDirection,
            lang: t.uiLanguage,
            "aria-labelledby": "ck-editor__aria-label_".concat(e)
          },
          children: [_this85._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: _this85.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: _this85.main
          }]
        });
        return _this85;
      }

      _createClass(Vl, [{
        key: "_createVoiceLabel",
        value: function _createVoiceLabel(t) {
          var e = this.t,
              n = new jl();
          return n.text = e("bn"), n.extendTemplate({
            attributes: {
              id: "ck-editor__aria-label_".concat(t),
              class: "ck-voice-label"
            }
          }), n;
        }
      }]);

      return Vl;
    }(Ll);

    var zl = /*#__PURE__*/function (_Dl3) {
      _inherits(zl, _Dl3);

      var _super43 = _createSuper(zl);

      function zl(t, e, n) {
        var _this86;

        _classCallCheck(this, zl);

        _this86 = _super43.call(this, t), _this86.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: t.contentLanguage,
            dir: t.contentLanguageDirection
          }
        }), _this86.name = null, _this86.set("isFocused", !1), _this86._editableElement = n, _this86._hasExternalElement = !!_this86._editableElement, _this86._editingView = e;
        return _this86;
      }

      _createClass(zl, [{
        key: "render",
        value: function render() {
          var _this87 = this;

          _get(_getPrototypeOf(zl.prototype), "render", this).call(this), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", function () {
            return _this87._updateIsFocusedClasses();
          }), this._updateIsFocusedClasses();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._hasExternalElement && this.template.revert(this._editableElement), _get(_getPrototypeOf(zl.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_updateIsFocusedClasses",
        value: function _updateIsFocusedClasses() {
          var t = this._editingView;

          function e(e) {
            t.change(function (n) {
              var i = t.document.getRoot(e.name);
              n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", i), n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", i);
            });
          }

          t.isRenderingInProgress ? function n(i) {
            t.once("change:isRenderingInProgress", function (t, o, r) {
              r ? n(i) : e(i);
            });
          }(this) : e(this);
        }
      }]);

      return zl;
    }(Dl);

    var Bl = /*#__PURE__*/function (_zl) {
      _inherits(Bl, _zl);

      var _super44 = _createSuper(Bl);

      function Bl(t, e, n) {
        var _this88;

        _classCallCheck(this, Bl);

        _this88 = _super44.call(this, t, e, n), _this88.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        });
        return _this88;
      }

      _createClass(Bl, [{
        key: "render",
        value: function render() {
          var _this89 = this;

          _get(_getPrototypeOf(Bl.prototype), "render", this).call(this);

          var t = this._editingView,
              e = this.t;
          t.change(function (n) {
            var i = t.document.getRoot(_this89.name);
            n.setAttribute("aria-label", e("bm", [_this89.name]), i);
          });
        }
      }]);

      return Bl;
    }(zl);

    function Fl(t) {
      return function (e) {
        return e + t;
      };
    }

    n(22);
    var Ul = Fl("px");

    var Hl = /*#__PURE__*/function (_Dl4) {
      _inherits(Hl, _Dl4);

      var _super45 = _createSuper(Hl);

      function Hl(t) {
        var _this90;

        _classCallCheck(this, Hl);

        _this90 = _super45.call(this, t);
        var e = _this90.bindTemplate;
        _this90.set("isActive", !1), _this90.set("isSticky", !1), _this90.set("limiterElement", null), _this90.set("limiterBottomOffset", 50), _this90.set("viewportTopOffset", 0), _this90.set("_marginLeft", null), _this90.set("_isStickyToTheLimiter", !1), _this90.set("_hasViewportTopOffset", !1), _this90.content = _this90.createCollection(), _this90._contentPanelPlaceholder = new bl({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", function (t) {
                return t ? "block" : "none";
              }),
              height: e.to("isSticky", function (t) {
                return t ? Ul(_this90._panelRect.height) : null;
              })
            }
          }
        }).render(), _this90._contentPanel = new bl({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", function (t) {
                return t ? Ul(_this90._contentPanelPlaceholder.getBoundingClientRect().width) : null;
              }),
              top: e.to("_hasViewportTopOffset", function (t) {
                return t ? Ul(_this90.viewportTopOffset) : null;
              }),
              bottom: e.to("_isStickyToTheLimiter", function (t) {
                return t ? Ul(_this90.limiterBottomOffset) : null;
              }),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: _this90.content
        }).render(), _this90.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [_this90._contentPanelPlaceholder, _this90._contentPanel]
        });
        return _this90;
      }

      _createClass(Hl, [{
        key: "render",
        value: function render() {
          var _this91 = this;

          _get(_getPrototypeOf(Hl.prototype), "render", this).call(this), this._checkIfShouldBeSticky(), this.listenTo(nr.window, "scroll", function () {
            _this91._checkIfShouldBeSticky();
          }), this.listenTo(this, "change:isActive", function () {
            _this91._checkIfShouldBeSticky();
          });
        }
      }, {
        key: "_checkIfShouldBeSticky",
        value: function _checkIfShouldBeSticky() {
          var t = this._panelRect = this._contentPanel.getBoundingClientRect();

          var e;
          this.limiterElement ? (e = this._limiterRect = this.limiterElement.getBoundingClientRect(), this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height) : this.isSticky = !1, this.isSticky ? (this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset, this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset, this._marginLeft = this._isStickyToTheLimiter ? null : Ul(-nr.window.scrollX)) : (this._isStickyToTheLimiter = !1, this._hasViewportTopOffset = !1, this._marginLeft = null);
        }
      }]);

      return Hl;
    }(Dl);

    var ql = /*#__PURE__*/function () {
      function ql(t) {
        var _this92 = this;

        _classCallCheck(this, ql);

        if (Object.assign(this, t), t.actions && t.keystrokeHandler) {
          var _loop5 = function _loop5(_e190) {
            var n = t.actions[_e190];
            "string" == typeof n && (n = [n]);

            var _iterator254 = _createForOfIteratorHelper(n),
                _step254;

            try {
              for (_iterator254.s(); !(_step254 = _iterator254.n()).done;) {
                var _i120 = _step254.value;
                t.keystrokeHandler.set(_i120, function (t, n) {
                  _this92[_e190](), n();
                });
              }
            } catch (err) {
              _iterator254.e(err);
            } finally {
              _iterator254.f();
            }
          };

          for (var _e190 in t.actions) {
            _loop5(_e190);
          }
        }
      }

      _createClass(ql, [{
        key: "first",
        get: function get() {
          return this.focusables.find(Wl) || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this.focusables.filter(Wl).slice(-1)[0] || null;
        }
      }, {
        key: "next",
        get: function get() {
          return this._getFocusableItem(1);
        }
      }, {
        key: "previous",
        get: function get() {
          return this._getFocusableItem(-1);
        }
      }, {
        key: "current",
        get: function get() {
          var _this93 = this;

          var t = null;
          return null === this.focusTracker.focusedElement ? null : (this.focusables.find(function (e, n) {
            var i = e.element === _this93.focusTracker.focusedElement;
            return i && (t = n), i;
          }), t);
        }
      }, {
        key: "focusFirst",
        value: function focusFirst() {
          this._focus(this.first);
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focus(this.last);
        }
      }, {
        key: "focusNext",
        value: function focusNext() {
          this._focus(this.next);
        }
      }, {
        key: "focusPrevious",
        value: function focusPrevious() {
          this._focus(this.previous);
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          t && t.focus();
        }
      }, {
        key: "_getFocusableItem",
        value: function _getFocusableItem(t) {
          var e = this.current,
              n = this.focusables.length;
          if (!n) return null;
          if (null === e) return this[1 === t ? "first" : "last"];
          var i = (e + n + t) % n;

          do {
            var _e191 = this.focusables.get(i);

            if (Wl(_e191)) return _e191;
            i = (i + n + t) % n;
          } while (i !== e);

          return null;
        }
      }]);

      return ql;
    }();

    function Wl(t) {
      return !(!t.focus || "none" == nr.window.getComputedStyle(t.element).display);
    }

    var Yl = /*#__PURE__*/function (_Dl5) {
      _inherits(Yl, _Dl5);

      var _super46 = _createSuper(Yl);

      function Yl(t) {
        var _this94;

        _classCallCheck(this, Yl);

        _this94 = _super46.call(this, t), _this94.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
        return _this94;
      }

      return Yl;
    }(Dl);

    n(24);

    var $l = /*#__PURE__*/function (_Dl6) {
      _inherits($l, _Dl6);

      var _super47 = _createSuper($l);

      function $l(t) {
        var _this95;

        _classCallCheck(this, $l);

        _this95 = _super47.call(this, t);
        var e = _this95.bindTemplate,
            n = _this95.t;
        _this95.set("ariaLabel", n("bl")), _this95.items = _this95.createCollection(), _this95.focusTracker = new sl(), _this95.keystrokes = new Jc(), _this95.set("isVertical", !1), _this95.set("class"), _this95._focusCycler = new ql({
          focusables: _this95.items,
          focusTracker: _this95.focusTracker,
          keystrokeHandler: _this95.keystrokes,
          actions: {
            focusPrevious: ["arrowleft", "arrowup"],
            focusNext: ["arrowright", "arrowdown"]
          }
        }), _this95.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar", e.if("isVertical", "ck-toolbar_vertical"), e.to("class")],
            role: "toolbar",
            "aria-label": e.to("ariaLabel")
          },
          children: _this95.items,
          on: {
            mousedown: function (t) {
              return t.bindTemplate.to(function (e) {
                e.target === t.element && e.preventDefault();
              });
            }(_assertThisInitialized(_this95))
          }
        });
        return _this95;
      }

      _createClass($l, [{
        key: "render",
        value: function render() {
          var _this96 = this;

          _get(_getPrototypeOf($l.prototype), "render", this).call(this);

          var _iterator255 = _createForOfIteratorHelper(this.items),
              _step255;

          try {
            for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
              var _t200 = _step255.value;
              this.focusTracker.add(_t200.element);
            }
          } catch (err) {
            _iterator255.e(err);
          } finally {
            _iterator255.f();
          }

          this.items.on("add", function (t, e) {
            _this96.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this96.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "fillFromConfig",
        value: function fillFromConfig(t, e) {
          var _this97 = this;

          t.map(function (t) {
            "|" == t ? _this97.items.add(new Yl()) : e.has(t) ? _this97.items.add(e.create(t)) : console.warn(Object(Gn.a)("toolbarview-item-unavailable: The requested toolbar item is unavailable."), {
              name: t
            });
          });
        }
      }]);

      return $l;
    }(Dl);

    n(26);

    var Gl = /*#__PURE__*/function (_Vl) {
      _inherits(Gl, _Vl);

      var _super48 = _createSuper(Gl);

      function Gl(t, e) {
        var _this98;

        _classCallCheck(this, Gl);

        _this98 = _super48.call(this, t), _this98.stickyPanel = new Hl(t), _this98.toolbar = new $l(t), _this98.editable = new Bl(t, e);
        return _this98;
      }

      _createClass(Gl, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Gl.prototype), "render", this).call(this), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
        }
      }]);

      return Gl;
    }(Vl);

    var Ql = /*#__PURE__*/function (_Xc) {
      _inherits(Ql, _Xc);

      var _super49 = _createSuper(Ql);

      function Ql(t, e) {
        var _this99;

        _classCallCheck(this, Ql);

        _this99 = _super49.call(this, e), Wn(t) && (_this99.sourceElement = t), _this99.data.processor = new il(), _this99.model.document.createRoot(), _this99.ui = new ml(_assertThisInitialized(_this99), new Gl(_this99.locale, _this99.editing.view)), function (t) {
          if (!W(t.updateSourceElement)) throw new Gn.b("attachtoform-missing-elementapi-interface: Editor passed to attachToForm() must implement ElementApi.", t);
          var e = t.sourceElement;

          if (e && "textarea" === e.tagName.toLowerCase() && e.form) {
            var _n167;

            var _i121 = e.form,
                _o59 = function _o59() {
              return t.updateSourceElement();
            };

            W(_i121.submit) && (_n167 = _i121.submit, _i121.submit = function () {
              _o59(), _n167.apply(_i121);
            }), _i121.addEventListener("submit", _o59), t.on("destroy", function () {
              _i121.removeEventListener("submit", _o59), _n167 && (_i121.submit = _n167);
            });
          }
        }(_assertThisInitialized(_this99));
        return _this99;
      }

      _createClass(Ql, [{
        key: "destroy",
        value: function destroy() {
          return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _get(_getPrototypeOf(Ql.prototype), "destroy", this).call(this);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this100 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (n) {
            var i = new _this100(t, e);
            n(i.initPlugins().then(function () {
              return i.ui.init(Wn(t) ? t : null);
            }).then(function () {
              if (!Wn(t) && e.initialData) throw new Gn.b("editor-create-initial-data: The config.initialData option cannot be used together with initial data passed in Editor.create().", null);

              var n = e.initialData || function (t) {
                return Wn(t) ? function (t) {
                  return t instanceof HTMLTextAreaElement ? t.value : t.innerHTML;
                }(t) : t;
              }(t);

              return i.data.init(n);
            }).then(function () {
              return i.fire("ready");
            }).then(function () {
              return i;
            }));
          });
        }
      }]);

      return Ql;
    }(Xc);

    ci(Ql, tl), ci(Ql, el);

    var Kl = /*#__PURE__*/function () {
      function Kl(t) {
        _classCallCheck(this, Kl);

        this.editor = t;
      }

      _createClass(Kl, [{
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return Kl;
    }();

    ci(Kl, Fi);

    var Jl = /*#__PURE__*/function () {
      function Jl(t) {
        _classCallCheck(this, Jl);

        this.files = function (t) {
          var e = t.files ? Array.from(t.files) : [],
              n = t.items ? Array.from(t.items) : [];
          if (e.length) return e;
          return n.filter(function (t) {
            return "file" === t.kind;
          }).map(function (t) {
            return t.getAsFile();
          });
        }(t), this._native = t;
      }

      _createClass(Jl, [{
        key: "types",
        get: function get() {
          return this._native.types;
        }
      }, {
        key: "getData",
        value: function getData(t) {
          return this._native.getData(t);
        }
      }, {
        key: "setData",
        value: function setData(t, e) {
          this._native.setData(t, e);
        }
      }]);

      return Jl;
    }();

    var Zl = /*#__PURE__*/function (_ts5) {
      _inherits(Zl, _ts5);

      var _super50 = _createSuper(Zl);

      function Zl(t) {
        var _this101;

        _classCallCheck(this, Zl);

        _this101 = _super50.call(this, t);
        var e = _this101.document;

        function n(t, n) {
          n.preventDefault();
          var i = n.dropRange ? [n.dropRange] : Array.from(e.selection.getRanges()),
              o = new Kn(e, "clipboardInput");
          e.fire(o, {
            dataTransfer: n.dataTransfer,
            targetRanges: i
          }), o.stop.called && n.stopPropagation();
        }

        _this101.domEventType = ["paste", "copy", "cut", "drop", "dragover"], _this101.listenTo(e, "paste", n, {
          priority: "low"
        }), _this101.listenTo(e, "drop", n, {
          priority: "low"
        });
        return _this101;
      }

      _createClass(Zl, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          var e = {
            dataTransfer: new Jl(t.clipboardData ? t.clipboardData : t.dataTransfer)
          };
          "drop" == t.type && (e.dropRange = function (t, e) {
            var n = e.target.ownerDocument,
                i = e.clientX,
                o = e.clientY;
            var r;
            n.caretRangeFromPoint && n.caretRangeFromPoint(i, o) ? r = n.caretRangeFromPoint(i, o) : e.rangeParent && ((r = n.createRange()).setStart(e.rangeParent, e.rangeOffset), r.collapse(!0));
            return r ? t.domConverter.domRangeToView(r) : t.document.selection.getFirstRange();
          }(this.view, t)), this.fire(t.type, t, e);
        }
      }]);

      return Zl;
    }(ts);

    var Xl = ["figcaption", "li"];

    var td = /*#__PURE__*/function (_Kl) {
      _inherits(td, _Kl);

      var _super51 = _createSuper(td);

      function td() {
        _classCallCheck(this, td);

        return _super51.apply(this, arguments);
      }

      _createClass(td, [{
        key: "init",
        value: function init() {
          var _this102 = this;

          var t = this.editor,
              e = t.model.document,
              n = t.editing.view,
              i = n.document;

          function o(n, o) {
            var r = o.dataTransfer;
            o.preventDefault();
            var s = t.data.toView(t.model.getSelectedContent(e.selection));
            i.fire("clipboardOutput", {
              dataTransfer: r,
              content: s,
              method: n.name
            });
          }

          this._htmlDataProcessor = new il(), n.addObserver(Zl), this.listenTo(i, "clipboardInput", function (e) {
            t.isReadOnly && e.stop();
          }, {
            priority: "highest"
          }), this.listenTo(i, "clipboardInput", function (t, e) {
            var i = e.dataTransfer;
            var o = "";
            i.getData("text/html") ? o = function (t) {
              return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
                return 1 == e.length ? " " : e;
              });
            }(i.getData("text/html")) : i.getData("text/plain") && (o = function (t) {
              return (t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "</p><p>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).indexOf("</p><p>") > -1 && (t = "<p>".concat(t, "</p>")), t;
            }(i.getData("text/plain"))), o = _this102._htmlDataProcessor.toView(o), _this102.fire("inputTransformation", {
              content: o,
              dataTransfer: i
            }), n.scrollToTheSelection();
          }, {
            priority: "low"
          }), this.listenTo(this, "inputTransformation", function (t, e) {
            if (!e.content.isEmpty) {
              var _t201 = _this102.editor.data,
                  _n168 = _this102.editor.model,
                  _i122 = _t201.toModel(e.content, "$clipboardHolder");

              if (0 == _i122.childCount) return;

              _n168.insertContent(_i122);
            }
          }, {
            priority: "low"
          }), this.listenTo(i, "copy", o, {
            priority: "low"
          }), this.listenTo(i, "cut", function (e, n) {
            t.isReadOnly ? n.preventDefault() : o(e, n);
          }, {
            priority: "low"
          }), this.listenTo(i, "clipboardOutput", function (n, i) {
            i.content.isEmpty || (i.dataTransfer.setData("text/html", _this102._htmlDataProcessor.toData(i.content)), i.dataTransfer.setData("text/plain", function t(e) {
              var n = "";
              if (e.is("text") || e.is("textProxy")) n = e.data;else if (e.is("img") && e.hasAttribute("alt")) n = e.getAttribute("alt");else {
                var _i123 = null;

                var _iterator256 = _createForOfIteratorHelper(e.getChildren()),
                    _step256;

                try {
                  for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
                    var _o60 = _step256.value;

                    var _e192 = t(_o60);

                    _i123 && (_i123.is("containerElement") || _o60.is("containerElement")) && (Xl.includes(_i123.name) || Xl.includes(_o60.name) ? n += "\n" : n += "\n\n"), n += _e192, _i123 = _o60;
                  }
                } catch (err) {
                  _iterator256.e(err);
                } finally {
                  _iterator256.f();
                }
              }
              return n;
            }(i.content))), "cut" == i.method && t.model.deleteContent(e.selection);
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Clipboard";
        }
      }]);

      return td;
    }(Kl);

    var ed = /*#__PURE__*/function () {
      function ed(t) {
        var _this103 = this;

        _classCallCheck(this, ed);

        this.editor = t, this.set("value", void 0), this.set("isEnabled", !1), this._disableStack = new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", function () {
          _this103.refresh();
        }), this.on("execute", function (t) {
          _this103.isEnabled || t.stop();
        }, {
          priority: "high"
        }), this.listenTo(t, "change:isReadOnly", function (t, e, n) {
          n ? _this103.forceDisabled("readOnlyMode") : _this103.clearForceDisabled("readOnlyMode");
        });
      }

      _createClass(ed, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = !0;
        }
      }, {
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t), 1 == this._disableStack.size && (this.on("set:isEnabled", nd, {
            priority: "highest"
          }), this.isEnabled = !1);
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t), 0 == this._disableStack.size && (this.off("set:isEnabled", nd), this.refresh());
        }
      }, {
        key: "execute",
        value: function execute() {}
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);

      return ed;
    }();

    function nd(t) {
      t.return = !1, t.stop();
    }

    function id(t, e) {
      var _iterator257, _step257, _n169;

      return _regeneratorRuntime.wrap(function id$(_context37) {
        while (1) {
          switch (_context37.prev = _context37.next) {
            case 0:
              _iterator257 = _createForOfIteratorHelper(e);
              _context37.prev = 1;

              _iterator257.s();

            case 3:
              if ((_step257 = _iterator257.n()).done) {
                _context37.next = 11;
                break;
              }

              _n169 = _step257.value;
              _context37.t0 = _n169 && t.getAttributeProperties(_n169[0]).copyOnEnter;

              if (!_context37.t0) {
                _context37.next = 9;
                break;
              }

              _context37.next = 9;
              return _n169;

            case 9:
              _context37.next = 3;
              break;

            case 11:
              _context37.next = 16;
              break;

            case 13:
              _context37.prev = 13;
              _context37.t1 = _context37["catch"](1);

              _iterator257.e(_context37.t1);

            case 16:
              _context37.prev = 16;

              _iterator257.f();

              return _context37.finish(16);

            case 19:
            case "end":
              return _context37.stop();
          }
        }
      }, _marked3, null, [[1, 13, 16, 19]]);
    }

    ci(ed, Fi);

    var od = /*#__PURE__*/function (_ed) {
      _inherits(od, _ed);

      var _super52 = _createSuper(od);

      function od() {
        _classCallCheck(this, od);

        return _super52.apply(this, arguments);
      }

      _createClass(od, [{
        key: "execute",
        value: function execute() {
          var _this104 = this;

          var t = this.editor.model,
              e = t.document;
          t.change(function (n) {
            !function (t, e, n, i) {
              var o = n.isCollapsed,
                  r = n.getFirstRange(),
                  s = r.start.parent,
                  a = r.end.parent;
              if (i.isLimit(s) || i.isLimit(a)) return void (o || s != a || t.deleteContent(n));

              if (o) {
                var _t202 = id(e.model.schema, n.getAttributes());

                rd(e, r.start), e.setSelectionAttribute(_t202);
              } else {
                var _i124 = !(r.start.isAtStart && r.end.isAtEnd),
                    _o61 = s == a;

                t.deleteContent(n, {
                  leaveUnmerged: _i124
                }), _i124 && (_o61 ? rd(e, n.focus) : e.setSelection(a, 0));
              }
            }(_this104.editor.model, n, e.selection, t.schema), _this104.fire("afterExecute", {
              writer: n
            });
          });
        }
      }]);

      return od;
    }(ed);

    function rd(t, e) {
      t.split(e), t.setSelection(e.parent.nextSibling, 0);
    }

    var sd = /*#__PURE__*/function (_ur5) {
      _inherits(sd, _ur5);

      var _super53 = _createSuper(sd);

      function sd(t) {
        var _this105;

        _classCallCheck(this, sd);

        _this105 = _super53.call(this, t);
        var e = _this105.document;
        e.on("keydown", function (t, n) {
          if (_this105.isEnabled && n.keyCode == bo.enter) {
            var _i125;

            e.once("enter", function (t) {
              return _i125 = t;
            }, {
              priority: "highest"
            }), e.fire("enter", new Xr(e, n.domEvent, {
              isSoft: n.shiftKey
            })), _i125 && _i125.stop.called && t.stop();
          }
        });
        return _this105;
      }

      _createClass(sd, [{
        key: "observe",
        value: function observe() {}
      }]);

      return sd;
    }(ur);

    var ad = /*#__PURE__*/function (_Kl2) {
      _inherits(ad, _Kl2);

      var _super54 = _createSuper(ad);

      function ad() {
        _classCallCheck(this, ad);

        return _super54.apply(this, arguments);
      }

      _createClass(ad, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document;
          e.addObserver(sd), t.commands.add("enter", new od(t)), this.listenTo(n, "enter", function (n, i) {
            i.preventDefault(), i.isSoft || (t.execute("enter"), e.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Enter";
        }
      }]);

      return ad;
    }(Kl);

    var cd = /*#__PURE__*/function (_ed2) {
      _inherits(cd, _ed2);

      var _super55 = _createSuper(cd);

      function cd() {
        _classCallCheck(this, cd);

        return _super55.apply(this, arguments);
      }

      _createClass(cd, [{
        key: "execute",
        value: function execute() {
          var _this106 = this;

          var t = this.editor.model,
              e = t.document;
          t.change(function (n) {
            !function (t, e, n) {
              var i = n.isCollapsed,
                  o = n.getFirstRange(),
                  r = o.start.parent,
                  s = o.end.parent,
                  a = r == s;

              if (i) {
                var _i126 = id(t.schema, n.getAttributes());

                ld(e, o.end), e.removeSelectionAttribute(n.getAttributeKeys()), e.setSelectionAttribute(_i126);
              } else {
                var _i127 = !(o.start.isAtStart && o.end.isAtEnd);

                t.deleteContent(n, {
                  leaveUnmerged: _i127
                }), a ? ld(e, n.focus) : _i127 && e.setSelection(s, 0);
              }
            }(t, n, e.selection), _this106.fire("afterExecute", {
              writer: n
            });
          });
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;

          this.isEnabled = function (t, e) {
            if (e.rangeCount > 1) return !1;
            var n = e.anchor;
            if (!n || !t.checkChild(n, "softBreak")) return !1;
            var i = e.getFirstRange(),
                o = i.start.parent,
                r = i.end.parent;
            if ((dd(o, t) || dd(r, t)) && o !== r) return !1;
            return !0;
          }(t.schema, e.selection);
        }
      }]);

      return cd;
    }(ed);

    function ld(t, e) {
      var n = t.createElement("softBreak");
      t.insert(n, e), t.setSelection(n, "after");
    }

    function dd(t, e) {
      return !t.is("rootElement") && (e.isLimit(t) || dd(t.parent, e));
    }

    var hd = /*#__PURE__*/function (_Kl3) {
      _inherits(hd, _Kl3);

      var _super56 = _createSuper(hd);

      function hd() {
        _classCallCheck(this, hd);

        return _super56.apply(this, arguments);
      }

      _createClass(hd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.conversion,
              i = t.editing.view,
              o = i.document;
          e.register("softBreak", {
            allowWhere: "$text",
            isInline: !0
          }), n.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
          }), n.for("downcast").elementToElement({
            model: "softBreak",
            view: function view(t, e) {
              return e.createEmptyElement("br");
            }
          }), i.addObserver(sd), t.commands.add("shiftEnter", new cd(t)), this.listenTo(o, "enter", function (e, n) {
            n.preventDefault(), n.isSoft && (t.execute("shiftEnter"), i.scrollToTheSelection());
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ShiftEnter";
        }
      }]);

      return hd;
    }(Kl);

    var ud = /*#__PURE__*/function () {
      function ud(t) {
        var _this107 = this;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;

        _classCallCheck(this, ud);

        this.model = t, this.size = 0, this.limit = e, this.isLocked = !1, this._changeCallback = function (t, e) {
          "transparent" != e.type && e !== _this107._batch && _this107._reset(!0);
        }, this._selectionChangeCallback = function () {
          _this107._reset();
        }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }

      _createClass(ud, [{
        key: "batch",
        get: function get() {
          return this._batch || (this._batch = this.model.createBatch()), this._batch;
        }
      }, {
        key: "input",
        value: function input(t) {
          this.size += t, this.size >= this.limit && this._reset(!0);
        }
      }, {
        key: "lock",
        value: function lock() {
          this.isLocked = !0;
        }
      }, {
        key: "unlock",
        value: function unlock() {
          this.isLocked = !1;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
      }, {
        key: "_reset",
        value: function _reset(t) {
          this.isLocked && !t || (this._batch = null, this.size = 0);
        }
      }]);

      return ud;
    }();

    var fd = /*#__PURE__*/function (_ed3) {
      _inherits(fd, _ed3);

      var _super57 = _createSuper(fd);

      function fd(t, e) {
        var _this108;

        _classCallCheck(this, fd);

        _this108 = _super57.call(this, t), _this108._buffer = new ud(t.model, e), _this108._batches = new WeakSet();
        return _this108;
      }

      _createClass(fd, [{
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(fd.prototype), "destroy", this).call(this), this._buffer.destroy();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this109 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document,
              i = t.text || "",
              o = i.length,
              r = t.range || n.selection.getFirstRange(),
              s = t.resultRange;
          e.enqueueChange(this._buffer.batch, function (t) {
            var a = r.isCollapsed;
            _this109._buffer.lock(), e.deleteContent(e.createSelection(r)), i && e.insertContent(t.createText(i, n.selection.getAttributes()), r.start), s ? t.setSelection(s) : a && t.setSelection(r.start.getShiftedBy(o)), _this109._buffer.unlock(), _this109._buffer.input(o), _this109._batches.add(_this109._buffer.batch);
          });
        }
      }]);

      return fd;
    }(ed);

    function md(t) {
      var e = null;
      var n = t.model,
          i = t.editing.view,
          o = t.commands.get("input");

      function r(t) {
        var r = n.document,
            a = i.document.isComposing,
            c = e && e.isEqual(r.selection);
        e = null, o.isEnabled && (function (t) {
          if (t.ctrlKey) return !0;
          return gd.includes(t.keyCode);
        }(t) || r.selection.isCollapsed || a && 229 === t.keyCode || !a && 229 === t.keyCode && c || s());
      }

      function s() {
        var t = o.buffer;
        t.lock(), n.enqueueChange(t.batch, function () {
          n.deleteContent(n.document.selection);
        }), t.unlock();
      }

      mo.isAndroid ? i.document.on("beforeinput", function (t, e) {
        return r(e);
      }, {
        priority: "lowest"
      }) : i.document.on("keydown", function (t, e) {
        return r(e);
      }, {
        priority: "lowest"
      }), i.document.on("compositionstart", function () {
        var t = n.document,
            e = 1 !== t.selection.rangeCount || t.selection.getFirstRange().isFlat;
        if (t.selection.isCollapsed || e) return;
        s();
      }, {
        priority: "lowest"
      }), i.document.on("compositionend", function () {
        e = n.createSelection(n.document.selection);
      }, {
        priority: "lowest"
      });
    }

    var gd = [wo("arrowUp"), wo("arrowRight"), wo("arrowDown"), wo("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];

    for (var _t203 = 112; _t203 <= 135; _t203++) {
      gd.push(_t203);
    }

    function pd(t) {
      if (t.newChildren.length - t.oldChildren.length != 1) return;

      var e = function (t, e) {
        var n = [];
        var i,
            o = 0;
        return t.forEach(function (t) {
          "equal" == t ? (r(), o++) : "insert" == t ? (s("insert") ? i.values.push(e[o]) : (r(), i = {
            type: "insert",
            index: o,
            values: [e[o]]
          }), o++) : s("delete") ? i.howMany++ : (r(), i = {
            type: "delete",
            index: o,
            howMany: 1
          });
        }), r(), n;

        function r() {
          i && (n.push(i), i = null);
        }

        function s(t) {
          return i && i.type == t;
        }
      }(Qo(t.oldChildren, t.newChildren, bd), t.newChildren);

      if (e.length > 1) return;
      var n = e[0];
      return n.values[0] && n.values[0].is("text") ? n : void 0;
    }

    function bd(t, e) {
      return t && t.is("text") && e && e.is("text") ? t.data === e.data : t === e;
    }

    var wd = /*#__PURE__*/function () {
      function wd(t) {
        _classCallCheck(this, wd);

        this.editor = t, this.editing = this.editor.editing;
      }

      _createClass(wd, [{
        key: "handle",
        value: function handle(t, e) {
          if (function (t) {
            if (0 == t.length) return !1;

            var _iterator258 = _createForOfIteratorHelper(t),
                _step258;

            try {
              for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
                var _e193 = _step258.value;
                if ("children" === _e193.type && !pd(_e193)) return !0;
              }
            } catch (err) {
              _iterator258.e(err);
            } finally {
              _iterator258.f();
            }

            return !1;
          }(t)) this._handleContainerChildrenMutations(t, e);else {
            var _iterator259 = _createForOfIteratorHelper(t),
                _step259;

            try {
              for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
                var _n170 = _step259.value;
                this._handleTextMutation(_n170, e), this._handleTextNodeInsertion(_n170);
              }
            } catch (err) {
              _iterator259.e(err);
            } finally {
              _iterator259.f();
            }
          }
        }
      }, {
        key: "_handleContainerChildrenMutations",
        value: function _handleContainerChildrenMutations(t, e) {
          var n = function (t) {
            var e = t.map(function (t) {
              return t.node;
            }).reduce(function (t, e) {
              return t.getCommonAncestor(e, {
                includeSelf: !0
              });
            });
            if (!e) return;
            return e.getAncestors({
              includeSelf: !0,
              parentFirst: !0
            }).find(function (t) {
              return t.is("containerElement") || t.is("rootElement");
            });
          }(t);

          if (!n) return;
          var i = this.editor.editing.view.domConverter.mapViewToDom(n),
              o = new rr(),
              r = this.editor.data.toModel(o.domToView(i)).getChild(0),
              s = this.editor.editing.mapper.toModelElement(n);
          if (!s) return;
          var a = Array.from(r.getChildren()),
              c = Array.from(s.getChildren()),
              l = a[a.length - 1],
              d = c[c.length - 1];
          l && l.is("softBreak") && d && !d.is("softBreak") && a.pop();
          var h = this.editor.model.schema;
          if (!kd(a, h) || !kd(c, h)) return;
          var u = a.map(function (t) {
            return t.is("text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " "),
              f = c.map(function (t) {
            return t.is("text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " ");
          if (f === u) return;

          var m = Qo(f, u),
              _d3 = _d(m),
              g = _d3.firstChangeAt,
              p = _d3.insertions,
              b = _d3.deletions;

          var w = null;
          e && (w = this.editing.mapper.toModelRange(e.getFirstRange()));

          var k = u.substr(g, p),
              _ = this.editor.model.createRange(this.editor.model.createPositionAt(s, g), this.editor.model.createPositionAt(s, g + b));

          this.editor.execute("input", {
            text: k,
            range: _,
            resultRange: w
          });
        }
      }, {
        key: "_handleTextMutation",
        value: function _handleTextMutation(t, e) {
          if ("text" != t.type) return;
          var n = t.newText.replace(/\u00A0/g, " "),
              i = t.oldText.replace(/\u00A0/g, " ");
          if (i === n) return;

          var o = Qo(i, n),
              _d4 = _d(o),
              r = _d4.firstChangeAt,
              s = _d4.insertions,
              a = _d4.deletions;

          var c = null;
          e && (c = this.editing.mapper.toModelRange(e.getFirstRange()));
          var l = this.editing.view.createPositionAt(t.node, r),
              d = this.editing.mapper.toModelPosition(l),
              h = this.editor.model.createRange(d, d.getShiftedBy(a)),
              u = n.substr(r, s);
          this.editor.execute("input", {
            text: u,
            range: h,
            resultRange: c
          });
        }
      }, {
        key: "_handleTextNodeInsertion",
        value: function _handleTextNodeInsertion(t) {
          if ("children" != t.type) return;
          var e = pd(t),
              n = this.editing.view.createPositionAt(t.node, e.index),
              i = this.editing.mapper.toModelPosition(n),
              o = e.values[0].data;
          this.editor.execute("input", {
            text: o.replace(/\u00A0/g, " "),
            range: this.editor.model.createRange(i)
          });
        }
      }]);

      return wd;
    }();

    function kd(t, e) {
      return t.every(function (t) {
        return e.isInline(t);
      });
    }

    function _d(t) {
      var e = null,
          n = null;

      for (var _i128 = 0; _i128 < t.length; _i128++) {
        "equal" != t[_i128] && (e = null === e ? _i128 : e, n = _i128);
      }

      var i = 0,
          o = 0;

      for (var _r25 = e; _r25 <= n; _r25++) {
        "insert" != t[_r25] && i++, "delete" != t[_r25] && o++;
      }

      return {
        insertions: o,
        deletions: i,
        firstChangeAt: e
      };
    }

    var vd = /*#__PURE__*/function (_Kl4) {
      _inherits(vd, _Kl4);

      var _super58 = _createSuper(vd);

      function vd() {
        _classCallCheck(this, vd);

        return _super58.apply(this, arguments);
      }

      _createClass(vd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = new fd(t, t.config.get("typing.undoStep") || 20);
          t.commands.add("input", e), md(t), function (t) {
            t.editing.view.document.on("mutations", function (e, n, i) {
              new wd(t).handle(n, i);
            });
          }(t);
        }
      }, {
        key: "isInput",
        value: function isInput(t) {
          return this.editor.commands.get("input")._batches.has(t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Input";
        }
      }]);

      return vd;
    }(Kl);

    var yd = /*#__PURE__*/function (_ed4) {
      _inherits(yd, _ed4);

      var _super59 = _createSuper(yd);

      function yd(t, e) {
        var _this110;

        _classCallCheck(this, yd);

        _this110 = _super59.call(this, t), _this110.direction = e, _this110._buffer = new ud(t.model, t.config.get("typing.undoStep"));
        return _this110;
      }

      _createClass(yd, [{
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this111 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document;
          e.enqueueChange(this._buffer.batch, function (i) {
            _this111._buffer.lock();

            var o = i.createSelection(t.selection || n.selection),
                r = o.isCollapsed;
            if (o.isCollapsed && e.modifySelection(o, {
              direction: _this111.direction,
              unit: t.unit
            }), _this111._shouldEntireContentBeReplacedWithParagraph(t.sequence || 1)) return void _this111._replaceEntireContentWithParagraph(i);
            if (o.isCollapsed) return;
            var s = 0;
            o.getFirstRange().getMinimalFlatRanges().forEach(function (t) {
              s += eo(t.getWalker({
                singleCharacters: !0,
                ignoreElementEnd: !0,
                shallow: !0
              }));
            }), e.deleteContent(o, {
              doNotResetEntireContent: r
            }), _this111._buffer.input(s), i.setSelection(o), _this111._buffer.unlock();
          });
        }
      }, {
        key: "_shouldEntireContentBeReplacedWithParagraph",
        value: function _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1) return !1;
          var e = this.editor.model,
              n = e.document.selection,
              i = e.schema.getLimitElement(n);
          if (!(n.isCollapsed && n.containsEntireContent(i))) return !1;
          if (!e.schema.checkChild(i, "paragraph")) return !1;
          var o = i.getChild(0);
          return !o || "paragraph" !== o.name;
        }
      }, {
        key: "_replaceEntireContentWithParagraph",
        value: function _replaceEntireContentWithParagraph(t) {
          var e = this.editor.model,
              n = e.document.selection,
              i = e.schema.getLimitElement(n),
              o = t.createElement("paragraph");
          t.remove(t.createRangeIn(i)), t.insert(o, i), t.setSelection(o, 0);
        }
      }]);

      return yd;
    }(ed);

    var xd = /*#__PURE__*/function (_ur6) {
      _inherits(xd, _ur6);

      var _super60 = _createSuper(xd);

      function xd(t) {
        var _this112;

        _classCallCheck(this, xd);

        _this112 = _super60.call(this, t);
        var e = t.document;
        var n = 0;

        function i(t, n, i) {
          var o;
          e.once("delete", function (t) {
            return o = t;
          }, {
            priority: Number.POSITIVE_INFINITY
          }), e.fire("delete", new Xr(e, n, i)), o && o.stop.called && t.stop();
        }

        e.on("keyup", function (t, e) {
          e.keyCode != bo.delete && e.keyCode != bo.backspace || (n = 0);
        }), e.on("keydown", function (t, e) {
          var o = {};
          if (e.keyCode == bo.delete) o.direction = "forward", o.unit = "character";else {
            if (e.keyCode != bo.backspace) return;
            o.direction = "backward", o.unit = "codePoint";
          }
          var r = mo.isMac ? e.altKey : e.ctrlKey;
          o.unit = r ? "word" : o.unit, o.sequence = ++n, i(t, e.domEvent, o);
        }), mo.isAndroid && e.on("beforeinput", function (e, n) {
          if ("deleteContentBackward" != n.domEvent.inputType) return;
          var o = {
            unit: "codepoint",
            direction: "backward",
            sequence: 1
          },
              r = n.domTarget.ownerDocument.defaultView.getSelection();
          r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset && (o.selectionToRemove = t.domConverter.domSelectionToView(r)), i(e, n.domEvent, o);
        });
        return _this112;
      }

      _createClass(xd, [{
        key: "observe",
        value: function observe() {}
      }]);

      return xd;
    }(ur);

    var Ad = /*#__PURE__*/function (_Kl5) {
      _inherits(Ad, _Kl5);

      var _super61 = _createSuper(Ad);

      function Ad() {
        _classCallCheck(this, Ad);

        return _super61.apply(this, arguments);
      }

      _createClass(Ad, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.editing.view,
              n = e.document;

          if (e.addObserver(xd), t.commands.add("forwardDelete", new yd(t, "forward")), t.commands.add("delete", new yd(t, "backward")), this.listenTo(n, "delete", function (n, i) {
            var o = {
              unit: i.unit,
              sequence: i.sequence
            };

            if (i.selectionToRemove) {
              var _e194 = t.model.createSelection(),
                  _n171 = [];

              var _iterator260 = _createForOfIteratorHelper(i.selectionToRemove.getRanges()),
                  _step260;

              try {
                for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
                  var _e195 = _step260.value;

                  _n171.push(t.editing.mapper.toModelRange(_e195));
                }
              } catch (err) {
                _iterator260.e(err);
              } finally {
                _iterator260.f();
              }

              _e194.setTo(_n171), o.selection = _e194;
            }

            t.execute("forward" == i.direction ? "forwardDelete" : "delete", o), i.preventDefault(), e.scrollToTheSelection();
          }), mo.isAndroid) {
            var _t204 = null;
            this.listenTo(n, "delete", function (e, n) {
              var i = n.domTarget.ownerDocument.defaultView.getSelection();
              _t204 = {
                anchorNode: i.anchorNode,
                anchorOffset: i.anchorOffset,
                focusNode: i.focusNode,
                focusOffset: i.focusOffset
              };
            }, {
              priority: "lowest"
            }), this.listenTo(n, "keyup", function (e, n) {
              if (_t204) {
                var _e196 = n.domTarget.ownerDocument.defaultView.getSelection();

                _e196.collapse(_t204.anchorNode, _t204.anchorOffset), _e196.extend(_t204.focusNode, _t204.focusOffset), _t204 = null;
              }
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Delete";
        }
      }]);

      return Ad;
    }(Kl);

    var Td = /*#__PURE__*/function (_Kl6) {
      _inherits(Td, _Kl6);

      var _super62 = _createSuper(Td);

      function Td() {
        _classCallCheck(this, Td);

        return _super62.apply(this, arguments);
      }

      _createClass(Td, null, [{
        key: "requires",
        get: function get() {
          return [vd, Ad];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Typing";
        }
      }]);

      return Td;
    }(Kl);

    var Cd = /*#__PURE__*/function (_Ja10) {
      _inherits(Cd, _Ja10);

      var _super63 = _createSuper(Cd);

      function Cd() {
        _classCallCheck(this, Cd);

        return _super63.apply(this, arguments);
      }

      _createClass(Cd, [{
        key: "type",
        get: function get() {
          return "noop";
        }
      }, {
        key: "clone",
        value: function clone() {
          return new Cd(this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Cd(this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {}
      }], [{
        key: "className",
        get: function get() {
          return "NoOperation";
        }
      }]);

      return Cd;
    }(Ja);

    var Pd = new Map();

    function Sd(t, e, n) {
      var i = Pd.get(t);
      i || (i = new Map(), Pd.set(t, i)), i.set(e, n);
    }

    function Md(t) {
      return [t];
    }

    function Ed(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var i = function (t, e) {
        var n = Pd.get(t);
        return n && n.has(e) ? n.get(e) : Md;
      }(t.constructor, e.constructor);

      try {
        return i(t = t.clone(), e, n);
      } catch (t) {
        throw t;
      }
    }

    function Id(t, e, n) {
      t = t.slice(), e = e.slice();
      var i = new Nd(n.document, n.useRelations, n.forceWeakRemove);
      i.setOriginalOperations(t), i.setOriginalOperations(e);
      var o = i.originalOperations;
      if (0 == t.length || 0 == e.length) return {
        operationsA: t,
        operationsB: e,
        originalOperations: o
      };
      var r = new WeakMap();

      var _iterator261 = _createForOfIteratorHelper(t),
          _step261;

      try {
        for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
          var _e198 = _step261.value;
          r.set(_e198, 0);
        }
      } catch (err) {
        _iterator261.e(err);
      } finally {
        _iterator261.f();
      }

      var s = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      };
      var a = 0;

      for (; a < t.length;) {
        var _t205, _e197;

        var _n172 = t[a],
            _o62 = r.get(_n172);

        if (_o62 == e.length) {
          a++;
          continue;
        }

        var _s19 = e[_o62],
            _c6 = Ed(_n172, _s19, i.getContext(_n172, _s19, !0)),
            _l2 = Ed(_s19, _n172, i.getContext(_s19, _n172, !1));

        i.updateRelation(_n172, _s19), i.setOriginalOperations(_c6, _n172), i.setOriginalOperations(_l2, _s19);

        var _iterator262 = _createForOfIteratorHelper(_c6),
            _step262;

        try {
          for (_iterator262.s(); !(_step262 = _iterator262.n()).done;) {
            var _t206 = _step262.value;
            r.set(_t206, _o62 + _l2.length);
          }
        } catch (err) {
          _iterator262.e(err);
        } finally {
          _iterator262.f();
        }

        (_t205 = t).splice.apply(_t205, [a, 1].concat(_toConsumableArray(_c6))), (_e197 = e).splice.apply(_e197, [_o62, 1].concat(_toConsumableArray(_l2)));
      }

      if (n.padWithNoOps) {
        var _n173 = t.length - s.originalOperationsACount,
            _i129 = e.length - s.originalOperationsBCount;

        Rd(t, _i129 - _n173), Rd(e, _n173 - _i129);
      }

      return Od(t, s.nextBaseVersionB), Od(e, s.nextBaseVersionA), {
        operationsA: t,
        operationsB: e,
        originalOperations: o
      };
    }

    var Nd = /*#__PURE__*/function () {
      function Nd(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

        _classCallCheck(this, Nd);

        this.originalOperations = new Map(), this._history = t.history, this._useRelations = e, this._forceWeakRemove = !!n, this._relations = new Map();
      }

      _createClass(Nd, [{
        key: "setOriginalOperations",
        value: function setOriginalOperations(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = e ? this.originalOperations.get(e) : null;

          var _iterator263 = _createForOfIteratorHelper(t),
              _step263;

          try {
            for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
              var _e199 = _step263.value;
              this.originalOperations.set(_e199, n || _e199);
            }
          } catch (err) {
            _iterator263.e(err);
          } finally {
            _iterator263.f();
          }
        }
      }, {
        key: "updateRelation",
        value: function updateRelation(t, e) {
          switch (t.constructor) {
            case lc:
              switch (e.constructor) {
                case mc:
                  t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition) ? this._setRelation(t, e, "insertAtSource") : t.targetPosition.isEqual(e.deletionPosition) ? this._setRelation(t, e, "insertBetween") : t.targetPosition.isAfter(e.sourcePosition) && this._setRelation(t, e, "moveTargetAfter");
                  break;

                case lc:
                  t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition) ? this._setRelation(t, e, "insertBefore") : this._setRelation(t, e, "insertAfter");
              }

              break;

            case gc:
              switch (e.constructor) {
                case mc:
                  t.splitPosition.isBefore(e.sourcePosition) && this._setRelation(t, e, "splitBefore");
                  break;

                case lc:
                  (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) && this._setRelation(t, e, "splitBefore");
              }

              break;

            case mc:
              switch (e.constructor) {
                case mc:
                  t.targetPosition.isEqual(e.sourcePosition) || this._setRelation(t, e, "mergeTargetNotMoved"), t.sourcePosition.isEqual(e.targetPosition) && this._setRelation(t, e, "mergeSourceNotMoved"), t.sourcePosition.isEqual(e.sourcePosition) && this._setRelation(t, e, "mergeSameElement");
                  break;

                case gc:
                  t.sourcePosition.isEqual(e.splitPosition) && this._setRelation(t, e, "splitAtSource");
              }

              break;

            case hc:
              {
                var _n174 = t.newRange;
                if (!_n174) return;

                switch (e.constructor) {
                  case lc:
                    {
                      var _i130 = Gs._createFromPositionAndShift(e.sourcePosition, e.howMany),
                          _o63 = _i130.containsPosition(_n174.start) || _i130.start.isEqual(_n174.start),
                          _r26 = _i130.containsPosition(_n174.end) || _i130.end.isEqual(_n174.end);

                      !_o63 && !_r26 || _i130.containsRange(_n174) || this._setRelation(t, e, {
                        side: _o63 ? "left" : "right",
                        path: _o63 ? _n174.start.path.slice() : _n174.end.path.slice()
                      });
                      break;
                    }

                  case mc:
                    {
                      var _i131 = _n174.start.isEqual(e.targetPosition),
                          _o64 = _n174.start.isEqual(e.deletionPosition),
                          _r27 = _n174.end.isEqual(e.deletionPosition),
                          _s20 = _n174.end.isEqual(e.sourcePosition);

                      (_i131 || _o64 || _r27 || _s20) && this._setRelation(t, e, {
                        wasInLeftElement: _i131,
                        wasStartBeforeMergedElement: _o64,
                        wasEndBeforeMergedElement: _r27,
                        wasInRightElement: _s20
                      });
                      break;
                    }
                }

                break;
              }
          }
        }
      }, {
        key: "getContext",
        value: function getContext(t, e, n) {
          return {
            aIsStrong: n,
            aWasUndone: this._wasUndone(t),
            bWasUndone: this._wasUndone(e),
            abRelation: this._useRelations ? this._getRelation(t, e) : null,
            baRelation: this._useRelations ? this._getRelation(e, t) : null,
            forceWeakRemove: this._forceWeakRemove
          };
        }
      }, {
        key: "_wasUndone",
        value: function _wasUndone(t) {
          var e = this.originalOperations.get(t);
          return e.wasUndone || this._history.isUndoneOperation(e);
        }
      }, {
        key: "_getRelation",
        value: function _getRelation(t, e) {
          var n = this.originalOperations.get(e),
              i = this._history.getUndoneOperation(n);

          if (!i) return null;

          var o = this.originalOperations.get(t),
              r = this._relations.get(o);

          return r && r.get(i) || null;
        }
      }, {
        key: "_setRelation",
        value: function _setRelation(t, e, n) {
          var i = this.originalOperations.get(t),
              o = this.originalOperations.get(e);

          var r = this._relations.get(i);

          r || (r = new Map(), this._relations.set(i, r)), r.set(o, n);
        }
      }]);

      return Nd;
    }();

    function Od(t, e) {
      var _iterator264 = _createForOfIteratorHelper(t),
          _step264;

      try {
        for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
          var _n175 = _step264.value;
          _n175.baseVersion = e++;
        }
      } catch (err) {
        _iterator264.e(err);
      } finally {
        _iterator264.f();
      }
    }

    function Rd(t, e) {
      for (var _n176 = 0; _n176 < e; _n176++) {
        t.push(new Cd(0));
      }
    }

    function Dd(t, e, n) {
      var i = t.nodes.getNode(0).getAttribute(e);
      if (i == n) return null;
      var o = new Gs(t.position, t.position.getShiftedBy(t.howMany));
      return new ac(o, e, i, n, 0);
    }

    function Ld(t, e) {
      return null === t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
    }

    function jd(t, e) {
      var n = [];

      for (var _i132 = 0; _i132 < t.length; _i132++) {
        var _o65 = t[_i132],
            _r28 = new lc(_o65.start, _o65.end.offset - _o65.start.offset, e, 0);

        n.push(_r28);

        for (var _e200 = _i132 + 1; _e200 < t.length; _e200++) {
          t[_e200] = t[_e200]._getTransformedByMove(_r28.sourcePosition, _r28.targetPosition, _r28.howMany)[0];
        }

        e = e._getTransformedByMove(_r28.sourcePosition, _r28.targetPosition, _r28.howMany);
      }

      return n;
    }

    Sd(ac, ac, function (t, e, n) {
      if (t.key === e.key) {
        var _i133 = t.range.getDifference(e.range).map(function (e) {
          return new ac(e, t.key, t.oldValue, t.newValue, 0);
        }),
            _o66 = t.range.getIntersection(e.range);

        return _o66 && n.aIsStrong && _i133.push(new ac(_o66, e.key, e.newValue, t.newValue, 0)), 0 == _i133.length ? [new Cd(0)] : _i133;
      }

      return [t];
    }), Sd(ac, dc, function (t, e) {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        var _n177 = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes).map(function (e) {
          return new ac(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });

        if (e.shouldReceiveAttributes) {
          var _i134 = Dd(e, t.key, t.oldValue);

          _i134 && _n177.unshift(_i134);
        }

        return _n177;
      }

      return t.range = t.range._getTransformedByInsertion(e.position, e.howMany, !1)[0], [t];
    }), Sd(ac, mc, function (t, e) {
      var n = [];
      t.range.start.hasSameParentAs(e.deletionPosition) && (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) && n.push(Gs._createFromPositionAndShift(e.graveyardPosition, 1));

      var i = t.range._getTransformedByMergeOperation(e);

      return i.isCollapsed || n.push(i), n.map(function (e) {
        return new ac(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), Sd(ac, lc, function (t, e) {
      return function (t, e) {
        var n = Gs._createFromPositionAndShift(e.sourcePosition, e.howMany);

        var i = null,
            o = [];
        n.containsRange(t, !0) ? i = t : t.start.hasSameParentAs(n.start) ? (o = t.getDifference(n), i = t.getIntersection(n)) : o = [t];
        var r = [];

        var _iterator265 = _createForOfIteratorHelper(o),
            _step265;

        try {
          for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
            var _t207 = _step265.value;
            _t207 = _t207._getTransformedByDeletion(e.sourcePosition, e.howMany);

            var _n178 = e.getMovedRangeStart(),
                _i135 = _t207.start.hasSameParentAs(_n178);

            _t207 = _t207._getTransformedByInsertion(_n178, e.howMany, _i135), r.push.apply(r, _toConsumableArray(_t207));
          }
        } catch (err) {
          _iterator265.e(err);
        } finally {
          _iterator265.f();
        }

        i && r.push(i._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, !1)[0]);
        return r;
      }(t.range, e).map(function (e) {
        return new ac(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    }), Sd(ac, gc, function (t, e) {
      if (t.range.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.range.end.offset++, [t];

      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        var _n179 = t.clone();

        return _n179.range = new Gs(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)), t.range.end = e.splitPosition.clone(), t.range.end.stickiness = "toPrevious", [t, _n179];
      }

      return t.range = t.range._getTransformedBySplitOperation(e), [t];
    }), Sd(dc, ac, function (t, e) {
      var n = [t];

      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        var _i136 = Dd(t, e.key, e.newValue);

        _i136 && n.push(_i136);
      }

      return n;
    }), Sd(dc, dc, function (t, e, n) {
      return t.position.isEqual(e.position) && n.aIsStrong ? [t] : (t.position = t.position._getTransformedByInsertOperation(e), [t]);
    }), Sd(dc, lc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), Sd(dc, gc, function (t, e) {
      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), Sd(dc, mc, function (t, e) {
      return t.position = t.position._getTransformedByMergeOperation(e), [t];
    }), Sd(hc, dc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]), t.newRange && (t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]), [t];
    }), Sd(hc, hc, function (t, e, n) {
      if (t.name == e.name) {
        if (!n.aIsStrong) return [new Cd(0)];
        t.oldRange = e.newRange ? e.newRange.clone() : null;
      }

      return [t];
    }), Sd(hc, mc, function (t, e) {
      return t.oldRange && (t.oldRange = t.oldRange._getTransformedByMergeOperation(e)), t.newRange && (t.newRange = t.newRange._getTransformedByMergeOperation(e)), [t];
    }), Sd(hc, lc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = Gs._createFromRanges(t.oldRange._getTransformedByMoveOperation(e))), t.newRange) {
        if (n.abRelation) {
          var _i137 = Gs._createFromRanges(t.newRange._getTransformedByMoveOperation(e));

          if ("left" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.start)) return t.newRange.start.path = n.abRelation.path, t.newRange.end = _i137.end, [t];
          if ("right" == n.abRelation.side && e.targetPosition.isEqual(t.newRange.end)) return t.newRange.start = _i137.start, t.newRange.end.path = n.abRelation.path, [t];
        }

        t.newRange = Gs._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }

      return [t];
    }), Sd(hc, gc, function (t, e, n) {
      if (t.oldRange && (t.oldRange = t.oldRange._getTransformedBySplitOperation(e)), t.newRange) {
        if (n.abRelation) {
          var _i138 = t.newRange._getTransformedBySplitOperation(e);

          return t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement ? t.newRange.start = $s._createAt(e.insertionPosition) : t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement && (t.newRange.start = $s._createAt(e.moveTargetPosition)), t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement ? t.newRange.end = $s._createAt(e.moveTargetPosition) : t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement ? t.newRange.end = $s._createAt(e.insertionPosition) : t.newRange.end = _i138.end, [t];
        }

        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }

      return [t];
    }), Sd(mc, dc, function (t, e) {
      return t.sourcePosition.hasSameParentAs(e.position) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e), t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e), [t];
    }), Sd(mc, mc, function (t, e, n) {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (n.bWasUndone) {
          var _n180 = e.graveyardPosition.path.slice();

          return _n180.push(0), t.sourcePosition = new $s(e.graveyardPosition.root, _n180), t.howMany = 0, [t];
        }

        return [new Cd(0)];
      }

      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && "splitAtSource" != n.abRelation) {
        var _i139 = "$graveyard" == t.targetPosition.root.rootName,
            _o67 = "$graveyard" == e.targetPosition.root.rootName;

        if (_o67 && !_i139 || !(_i139 && !_o67) && n.aIsStrong) {
          var _n181 = e.targetPosition._getTransformedByMergeOperation(e),
              _i140 = t.targetPosition._getTransformedByMergeOperation(e);

          return [new lc(_n181, t.howMany, _i140, 0)];
        }

        return [new Cd(0)];
      }

      return t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), t.graveyardPosition.isEqual(e.graveyardPosition) && n.aIsStrong || (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), Sd(mc, lc, function (t, e, n) {
      var i = Gs._createFromPositionAndShift(e.sourcePosition, e.howMany);

      return "remove" == e.type && !n.bWasUndone && !n.forceWeakRemove && t.deletionPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.sourcePosition) ? [new Cd(0)] : (t.sourcePosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.sourcePosition.hasSameParentAs(e.sourcePosition) && (t.howMany -= e.howMany), t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e), t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e), t.graveyardPosition.isEqual(e.targetPosition) || (t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e)), [t]);
    }), Sd(mc, gc, function (t, e, n) {
      if (e.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1), t.deletionPosition.isEqual(e.graveyardPosition) && (t.howMany = e.howMany)), t.targetPosition.isEqual(e.splitPosition)) {
        var _i141 = 0 != e.howMany,
            _o68 = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);

        if (_i141 || _o68 || "mergeTargetNotMoved" == n.abRelation) return t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), [t];
      }

      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if ("mergeSourceNotMoved" == n.abRelation) return t.howMany = 0, t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
        if ("mergeSameElement" == n.abRelation || t.sourcePosition.offset > 0) return t.sourcePosition = e.moveTargetPosition.clone(), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
      }

      return t.sourcePosition.hasSameParentAs(e.splitPosition) && (t.howMany = e.splitPosition.offset), t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e), t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e), [t];
    }), Sd(lc, dc, function (t, e) {
      var n = Gs._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByInsertOperation(e, !1)[0];

      return t.sourcePosition = n.start, t.howMany = n.end.offset - n.start.offset, t.targetPosition.isEqual(e.position) || (t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)), [t];
    }), Sd(lc, lc, function (t, e, n) {
      var i = Gs._createFromPositionAndShift(t.sourcePosition, t.howMany),
          o = Gs._createFromPositionAndShift(e.sourcePosition, e.howMany);

      var r,
          s = n.aIsStrong,
          a = !n.aIsStrong;
      if ("insertBefore" == n.abRelation || "insertAfter" == n.baRelation ? a = !0 : "insertAfter" != n.abRelation && "insertBefore" != n.baRelation || (a = !1), r = t.targetPosition.isEqual(e.targetPosition) && a ? t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) : t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), Ld(t, e) && Ld(e, t)) return [e.getReversed()];
      if (i.containsPosition(e.targetPosition) && i.containsRange(o, !0)) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), jd([i], r);
      if (o.containsPosition(t.targetPosition) && o.containsRange(i, !0)) return i.start = i.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), i.end = i.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), jd([i], r);
      var c = li(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if ("prefix" == c || "extension" == c) return i.start = i.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), i.end = i.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany), jd([i], r);
      "remove" != t.type || "remove" == e.type || n.aWasUndone || n.forceWeakRemove ? "remove" == t.type || "remove" != e.type || n.bWasUndone || n.forceWeakRemove || (s = !1) : s = !0;
      var l = [],
          d = i.getDifference(o);

      var _iterator266 = _createForOfIteratorHelper(d),
          _step266;

      try {
        for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
          var _t208 = _step266.value;
          _t208.start = _t208.start._getTransformedByDeletion(e.sourcePosition, e.howMany), _t208.end = _t208.end._getTransformedByDeletion(e.sourcePosition, e.howMany);

          var _n182 = "same" == li(_t208.start.getParentPath(), e.getMovedRangeStart().getParentPath()),
              _i142 = _t208._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, _n182);

          l.push.apply(l, _toConsumableArray(_i142));
        }
      } catch (err) {
        _iterator266.e(err);
      } finally {
        _iterator266.f();
      }

      var h = i.getIntersection(o);
      return null !== h && s && (h.start = h.start._getCombined(e.sourcePosition, e.getMovedRangeStart()), h.end = h.end._getCombined(e.sourcePosition, e.getMovedRangeStart()), 0 === l.length ? l.push(h) : 1 == l.length ? o.start.isBefore(i.start) || o.start.isEqual(i.start) ? l.unshift(h) : l.push(h) : l.splice(1, 0, h)), 0 === l.length ? [new Cd(t.baseVersion)] : jd(l, r);
    }), Sd(lc, gc, function (t, e, n) {
      var i = t.targetPosition.clone();
      t.targetPosition.isEqual(e.insertionPosition) && e.graveyardPosition && "moveTargetAfter" != n.abRelation || (i = t.targetPosition._getTransformedBySplitOperation(e));

      var o = Gs._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (o.end.isEqual(e.insertionPosition)) return e.graveyardPosition || t.howMany++, t.targetPosition = i, [t];

      if (o.start.hasSameParentAs(e.splitPosition) && o.containsPosition(e.splitPosition)) {
        var _t209 = new Gs(e.splitPosition, o.end);

        return _t209 = _t209._getTransformedBySplitOperation(e), jd([new Gs(o.start, e.splitPosition), _t209], i);
      }

      t.targetPosition.isEqual(e.splitPosition) && "insertAtSource" == n.abRelation && (i = e.moveTargetPosition), t.targetPosition.isEqual(e.insertionPosition) && "insertBetween" == n.abRelation && (i = t.targetPosition);
      var r = [o._getTransformedBySplitOperation(e)];

      if (e.graveyardPosition) {
        var _i143 = o.start.isEqual(e.graveyardPosition) || o.containsPosition(e.graveyardPosition);

        t.howMany > 1 && _i143 && !n.aWasUndone && r.push(Gs._createFromPositionAndShift(e.insertionPosition, 1));
      }

      return jd(r, i);
    }), Sd(lc, mc, function (t, e, n) {
      var i = Gs._createFromPositionAndShift(t.sourcePosition, t.howMany);

      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && i.containsPosition(e.sourcePosition)) if ("remove" != t.type || n.forceWeakRemove) {
        if (1 == t.howMany) return n.bWasUndone ? (t.sourcePosition = e.graveyardPosition.clone(), t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t]) : [new Cd(0)];
      } else if (!n.aWasUndone) {
        var _n183 = [];

        var _i144 = e.graveyardPosition.clone(),
            _o69 = e.targetPosition._getTransformedByMergeOperation(e);

        t.howMany > 1 && (_n183.push(new lc(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)), _i144 = _i144._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1), _o69 = _o69._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1));

        var _r29 = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition),
            _s21 = new lc(_i144, 1, _r29, 0),
            _a12 = _s21.getMovedRangeStart().path.slice();

        _a12.push(0);

        var _c7 = new $s(_s21.targetPosition.root, _a12);

        _o69 = _o69._getTransformedByMove(_i144, _r29, 1);

        var _l3 = new lc(_o69, e.howMany, _c7, 0);

        return _n183.push(_s21), _n183.push(_l3), _n183;
      }

      var o = Gs._createFromPositionAndShift(t.sourcePosition, t.howMany)._getTransformedByMergeOperation(e);

      return t.sourcePosition = o.start, t.howMany = o.end.offset - o.start.offset, t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e), [t];
    }), Sd(uc, dc, function (t, e) {
      return t.position = t.position._getTransformedByInsertOperation(e), [t];
    }), Sd(uc, mc, function (t, e) {
      return t.position.isEqual(e.deletionPosition) ? (t.position = e.graveyardPosition.clone(), t.position.stickiness = "toNext", [t]) : (t.position = t.position._getTransformedByMergeOperation(e), [t]);
    }), Sd(uc, lc, function (t, e) {
      return t.position = t.position._getTransformedByMoveOperation(e), [t];
    }), Sd(uc, uc, function (t, e, n) {
      if (t.position.isEqual(e.position)) {
        if (!n.aIsStrong) return [new Cd(0)];
        t.oldName = e.newName;
      }

      return [t];
    }), Sd(uc, gc, function (t, e) {
      if ("same" == li(t.position.path, e.splitPosition.getParentPath()) && !e.graveyardPosition) {
        return [t, new uc(t.position.getShiftedBy(1), t.oldName, t.newName, 0)];
      }

      return t.position = t.position._getTransformedBySplitOperation(e), [t];
    }), Sd(fc, fc, function (t, e, n) {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) return [new Cd(0)];
        t.oldValue = e.newValue;
      }

      return [t];
    }), Sd(gc, dc, function (t, e) {
      return t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e), t.insertionPosition = gc.getInsertionPosition(t.splitPosition), [t];
    }), Sd(gc, mc, function (t, e, n) {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        var _n184 = e.graveyardPosition.path.slice();

        _n184.push(0);

        var _i145 = new $s(e.graveyardPosition.root, _n184),
            _o70 = gc.getInsertionPosition(new $s(e.graveyardPosition.root, _n184)),
            _r30 = new gc(_i145, 0, null, 0);

        return _r30.insertionPosition = _o70, t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = gc.getInsertionPosition(t.splitPosition), t.graveyardPosition = _r30.insertionPosition.clone(), t.graveyardPosition.stickiness = "toNext", [_r30, t];
      }

      return t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition) && t.howMany--, t.splitPosition.hasSameParentAs(e.targetPosition) && (t.howMany += e.howMany), t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e), t.insertionPosition = gc.getInsertionPosition(t.splitPosition), t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e)), [t];
    }), Sd(gc, lc, function (t, e, n) {
      var i = Gs._createFromPositionAndShift(e.sourcePosition, e.howMany);

      if (t.graveyardPosition) {
        var _o71 = i.start.isEqual(t.graveyardPosition) || i.containsPosition(t.graveyardPosition);

        if (!n.bWasUndone && _o71) {
          var _n185 = t.splitPosition._getTransformedByMoveOperation(e),
              _i146 = t.graveyardPosition._getTransformedByMoveOperation(e),
              _o72 = _i146.path.slice();

          _o72.push(0);

          var _r31 = new $s(_i146.root, _o72);

          return [new lc(_n185, t.howMany, _r31, 0)];
        }

        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }

      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && i.containsPosition(t.splitPosition)) {
        var _n186 = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);

        return t.howMany -= _n186, t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany), t.splitPosition = e.sourcePosition.clone(), t.insertionPosition = gc.getInsertionPosition(t.splitPosition), [t];
      }

      return !t.splitPosition.isEqual(e.targetPosition) || "insertAtSource" != n.baRelation && "splitBefore" != n.abRelation ? (e.sourcePosition.isEqual(e.targetPosition) || (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset && (t.howMany -= e.howMany), t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset && (t.howMany += e.howMany)), t.splitPosition.stickiness = "toNone", t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e), t.splitPosition.stickiness = "toNext", t.graveyardPosition ? t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e) : t.insertionPosition = gc.getInsertionPosition(t.splitPosition), [t]) : (t.howMany += e.howMany, t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany), t.insertionPosition = gc.getInsertionPosition(t.splitPosition), [t]);
    }), Sd(gc, gc, function (t, e, n) {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) return [new Cd(0)];
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [new Cd(0)];
        if ("splitBefore" == n.abRelation) return t.howMany = 0, t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e), [t];
      }

      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        var _i147 = "$graveyard" == t.splitPosition.root.rootName,
            _o73 = "$graveyard" == e.splitPosition.root.rootName;

        if (_o73 && !_i147 || !(_i147 && !_o73) && n.aIsStrong) {
          var _n187 = [];
          return e.howMany && _n187.push(new lc(e.moveTargetPosition, e.howMany, e.splitPosition, 0)), t.howMany && _n187.push(new lc(t.splitPosition, t.howMany, t.moveTargetPosition, 0)), _n187;
        }

        return [new Cd(0)];
      }

      if (t.graveyardPosition && (t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e)), t.splitPosition.isEqual(e.insertionPosition) && "splitBefore" == n.abRelation) return t.howMany++, [t];

      if (e.splitPosition.isEqual(t.insertionPosition) && "splitBefore" == n.baRelation) {
        var _n188 = e.insertionPosition.path.slice();

        _n188.push(0);

        var _i148 = new $s(e.insertionPosition.root, _n188);

        return [t, new lc(t.insertionPosition, 1, _i148, 0)];
      }

      return t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset && (t.howMany -= e.howMany), t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e), t.insertionPosition = gc.getInsertionPosition(t.splitPosition), [t];
    });

    var Vd = /*#__PURE__*/function (_ed5) {
      _inherits(Vd, _ed5);

      var _super64 = _createSuper(Vd);

      function Vd(t) {
        var _this113;

        _classCallCheck(this, Vd);

        _this113 = _super64.call(this, t), _this113._stack = [], _this113._createdBatches = new WeakSet(), _this113.refresh();
        return _this113;
      }

      _createClass(Vd, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._stack.length > 0;
        }
      }, {
        key: "addBatch",
        value: function addBatch(t) {
          var e = this.editor.model.document.selection,
              n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          };
          this._stack.push({
            batch: t,
            selection: n
          }), this.refresh();
        }
      }, {
        key: "clearStack",
        value: function clearStack() {
          this._stack = [], this.refresh();
        }
      }, {
        key: "_restoreSelection",
        value: function _restoreSelection(t, e, n) {
          var i = this.editor.model,
              o = i.document,
              r = [];

          var _iterator267 = _createForOfIteratorHelper(t),
              _step267;

          try {
            for (_iterator267.s(); !(_step267 = _iterator267.n()).done;) {
              var _e201 = _step267.value;

              var _t210 = zd(_e201, n).find(function (t) {
                return t.start.root != o.graveyard;
              });

              _t210 && r.push(_t210);
            }
          } catch (err) {
            _iterator267.e(err);
          } finally {
            _iterator267.f();
          }

          r.length && i.change(function (t) {
            t.setSelection(r, {
              backward: e
            });
          });
        }
      }, {
        key: "_undo",
        value: function _undo(t, e) {
          var n = this.editor.model,
              i = n.document;

          this._createdBatches.add(e);

          var o = t.operations.slice().filter(function (t) {
            return t.isDocumentOperation;
          });
          o.reverse();

          var _iterator268 = _createForOfIteratorHelper(o),
              _step268;

          try {
            for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
              var _t211 = _step268.value;

              var _o74 = _t211.baseVersion + 1,
                  _r32 = Array.from(i.history.getOperations(_o74)),
                  _s22 = Id([_t211.getReversed()], _r32, {
                useRelations: !0,
                document: this.editor.model.document,
                padWithNoOps: !1,
                forceWeakRemove: !0
              }).operationsA;

              var _iterator269 = _createForOfIteratorHelper(_s22),
                  _step269;

              try {
                for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
                  var _o75 = _step269.value;
                  e.addOperation(_o75), n.applyOperation(_o75), i.history.setOperationAsUndone(_t211, _o75);
                }
              } catch (err) {
                _iterator269.e(err);
              } finally {
                _iterator269.f();
              }
            }
          } catch (err) {
            _iterator268.e(err);
          } finally {
            _iterator268.f();
          }
        }
      }]);

      return Vd;
    }(ed);

    function zd(t, e) {
      var n = t.getTransformedByOperations(e);
      n.sort(function (t, e) {
        return t.start.isBefore(e.start) ? -1 : 1;
      });

      for (var _t212 = 1; _t212 < n.length; _t212++) {
        var _e202 = n[_t212 - 1],
            _i149 = n[_t212];
        _e202.end.isTouching(_i149.start) && (_e202.end = _i149.end, n.splice(_t212, 1), _t212--);
      }

      return n;
    }

    var Bd = /*#__PURE__*/function (_Vd) {
      _inherits(Bd, _Vd);

      var _super65 = _createSuper(Bd);

      function Bd() {
        _classCallCheck(this, Bd);

        return _super65.apply(this, arguments);
      }

      _createClass(Bd, [{
        key: "execute",
        value: function execute() {
          var _this114 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

          var e = t ? this._stack.findIndex(function (e) {
            return e.batch == t;
          }) : this._stack.length - 1,
              n = this._stack.splice(e, 1)[0],
              i = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(i, function () {
            _this114._undo(n.batch, i);

            var t = _this114.editor.model.document.history.getOperations(n.batch.baseVersion);

            _this114._restoreSelection(n.selection.ranges, n.selection.isBackward, t), _this114.fire("revert", n.batch, i);
          }), this.refresh();
        }
      }]);

      return Bd;
    }(Vd);

    var Fd = /*#__PURE__*/function (_Vd2) {
      _inherits(Fd, _Vd2);

      var _super66 = _createSuper(Fd);

      function Fd() {
        _classCallCheck(this, Fd);

        return _super66.apply(this, arguments);
      }

      _createClass(Fd, [{
        key: "execute",
        value: function execute() {
          var _this115 = this;

          var t = this._stack.pop(),
              e = this.editor.model.createBatch("transparent");

          this.editor.model.enqueueChange(e, function () {
            var n = t.batch.operations[t.batch.operations.length - 1].baseVersion + 1,
                i = _this115.editor.model.document.history.getOperations(n);

            _this115._restoreSelection(t.selection.ranges, t.selection.isBackward, i), _this115._undo(t.batch, e);
          }), this.refresh();
        }
      }]);

      return Fd;
    }(Vd);

    var Ud = /*#__PURE__*/function (_Kl7) {
      _inherits(Ud, _Kl7);

      var _super67 = _createSuper(Ud);

      function Ud(t) {
        var _this116;

        _classCallCheck(this, Ud);

        _this116 = _super67.call(this, t), _this116._batchRegistry = new WeakSet();
        return _this116;
      }

      _createClass(Ud, [{
        key: "init",
        value: function init() {
          var _this117 = this;

          var t = this.editor;
          this._undoCommand = new Bd(t), this._redoCommand = new Fd(t), t.commands.add("undo", this._undoCommand), t.commands.add("redo", this._redoCommand), this.listenTo(t.model, "applyOperation", function (t, e) {
            var n = e[0];
            if (!n.isDocumentOperation) return;

            var i = n.batch,
                o = _this117._redoCommand._createdBatches.has(i),
                r = _this117._undoCommand._createdBatches.has(i);

            _this117._batchRegistry.has(i) || "transparent" == i.type && !o && !r || (o ? _this117._undoCommand.addBatch(i) : r || (_this117._undoCommand.addBatch(i), _this117._redoCommand.clearStack()), _this117._batchRegistry.add(i));
          }, {
            priority: "highest"
          }), this.listenTo(this._undoCommand, "revert", function (t, e, n) {
            _this117._redoCommand.addBatch(n);
          }), t.keystrokes.set("CTRL+Z", "undo"), t.keystrokes.set("CTRL+Y", "redo"), t.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }]);

      return Ud;
    }(Kl);

    n(28);

    var Hd = /*#__PURE__*/function (_Dl7) {
      _inherits(Hd, _Dl7);

      var _super68 = _createSuper(Hd);

      function Hd() {
        var _this118;

        _classCallCheck(this, Hd);

        _this118 = _super68.call(this);
        var t = _this118.bindTemplate;
        _this118.set("content", ""), _this118.set("viewBox", "0 0 20 20"), _this118.set("fillColor", ""), _this118.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon"],
            viewBox: t.to("viewBox")
          }
        });
        return _this118;
      }

      _createClass(Hd, [{
        key: "render",
        value: function render() {
          var _this119 = this;

          _get(_getPrototypeOf(Hd.prototype), "render", this).call(this), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", function () {
            _this119._updateXMLContent(), _this119._colorFillPaths();
          }), this.on("change:fillColor", function () {
            _this119._colorFillPaths();
          });
        }
      }, {
        key: "_updateXMLContent",
        value: function _updateXMLContent() {
          if (this.content) {
            var _t213 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"),
                _e203 = _t213.getAttribute("viewBox");

            for (_e203 && (this.viewBox = _e203), this.element.innerHTML = ""; _t213.childNodes.length > 0;) {
              this.element.appendChild(_t213.childNodes[0]);
            }
          }
        }
      }, {
        key: "_colorFillPaths",
        value: function _colorFillPaths() {
          var _this120 = this;

          this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach(function (t) {
            t.style.fill = _this120.fillColor;
          });
        }
      }]);

      return Hd;
    }(Dl);

    n(30);

    var qd = /*#__PURE__*/function (_Dl8) {
      _inherits(qd, _Dl8);

      var _super69 = _createSuper(qd);

      function qd(t) {
        var _this121;

        _classCallCheck(this, qd);

        _this121 = _super69.call(this, t), _this121.set("text", ""), _this121.set("position", "s");
        var e = _this121.bindTemplate;

        _this121.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip", e.to("position", function (t) {
              return "ck-tooltip_" + t;
            }), e.if("text", "ck-hidden", function (t) {
              return !t.trim();
            })]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: e.to("text")
            }]
          }]
        });

        return _this121;
      }

      return qd;
    }(Dl);

    n(32);

    var Wd = /*#__PURE__*/function (_Dl9) {
      _inherits(Wd, _Dl9);

      var _super70 = _createSuper(Wd);

      function Wd(t) {
        var _this122;

        _classCallCheck(this, Wd);

        _this122 = _super70.call(this, t);
        var e = _this122.bindTemplate,
            n = Jn();
        _this122.set("class"), _this122.set("labelStyle"), _this122.set("icon"), _this122.set("isEnabled", !0), _this122.set("isOn", !1), _this122.set("isVisible", !0), _this122.set("isToggleable", !1), _this122.set("keystroke"), _this122.set("label"), _this122.set("tabindex", -1), _this122.set("tooltip"), _this122.set("tooltipPosition", "s"), _this122.set("type", "button"), _this122.set("withText", !1), _this122.children = _this122.createCollection(), _this122.tooltipView = _this122._createTooltipView(), _this122.labelView = _this122._createLabelView(n), _this122.iconView = new Hd(), _this122.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        }), _this122.bind("_tooltipString").to(_assertThisInitialized(_this122), "tooltip", _assertThisInitialized(_this122), "label", _assertThisInitialized(_this122), "keystroke", _this122._getTooltipString.bind(_assertThisInitialized(_this122))), _this122.setTemplate({
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), e.to("isOn", function (t) {
              return t ? "ck-on" : "ck-off";
            }), e.if("withText", "ck-button_with-text")],
            type: e.to("type", function (t) {
              return t || "button";
            }),
            tabindex: e.to("tabindex"),
            "aria-labelledby": "ck-editor__aria-label_".concat(n),
            "aria-disabled": e.if("isEnabled", !0, function (t) {
              return !t;
            }),
            "aria-pressed": e.to("isOn", function (t) {
              return !!_this122.isToggleable && String(t);
            })
          },
          children: _this122.children,
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function (t) {
              _this122.isEnabled ? _this122.fire("execute") : t.preventDefault();
            })
          }
        });
        return _this122;
      }

      _createClass(Wd, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Wd.prototype), "render", this).call(this), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.tooltipView), this.children.add(this.labelView);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_createTooltipView",
        value: function _createTooltipView() {
          var t = new qd();
          return t.bind("text").to(this, "_tooltipString"), t.bind("position").to(this, "tooltipPosition"), t;
        }
      }, {
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new Dl(),
              n = this.bindTemplate;
          return e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__label"],
              style: n.to("labelStyle"),
              id: "ck-editor__aria-label_".concat(t)
            },
            children: [{
              text: this.bindTemplate.to("label")
            }]
          }), e;
        }
      }, {
        key: "_getTooltipString",
        value: function _getTooltipString(t, e, n) {
          return t ? "string" == typeof t ? t : (n && (n = function (t) {
            return mo.isMac ? _o(t).map(function (t) {
              return po[t.toLowerCase()] || t;
            }).reduce(function (t, e) {
              return t.slice(-1) in go ? t + e : t + "+" + e;
            }) : t;
          }(n)), t instanceof Function ? t(e, n) : "".concat(e).concat(n ? " (".concat(n, ")") : "")) : "";
        }
      }]);

      return Wd;
    }(Dl);

    var Yd = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>',
        $d = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';

    var Gd = /*#__PURE__*/function (_Kl8) {
      _inherits(Gd, _Kl8);

      var _super71 = _createSuper(Gd);

      function Gd() {
        _classCallCheck(this, Gd);

        return _super71.apply(this, arguments);
      }

      _createClass(Gd, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.locale,
              n = t.t,
              i = "ltr" == e.uiLanguageDirection ? Yd : $d,
              o = "ltr" == e.uiLanguageDirection ? $d : Yd;
          this._addButton("undo", n("bj"), "CTRL+Z", i), this._addButton("redo", n("bk"), "CTRL+Y", o);
        }
      }, {
        key: "_addButton",
        value: function _addButton(t, e, n, i) {
          var _this123 = this;

          var o = this.editor;
          o.ui.componentFactory.add(t, function (r) {
            var s = o.commands.get(t),
                a = new Wd(r);
            return a.set({
              label: e,
              icon: i,
              keystroke: n,
              tooltip: !0
            }), a.bind("isEnabled").to(s, "isEnabled"), _this123.listenTo(a, "execute", function () {
              return o.execute(t);
            }), a;
          });
        }
      }]);

      return Gd;
    }(Kl);

    var Qd = /*#__PURE__*/function (_Kl9) {
      _inherits(Qd, _Kl9);

      var _super72 = _createSuper(Qd);

      function Qd() {
        _classCallCheck(this, Qd);

        return _super72.apply(this, arguments);
      }

      _createClass(Qd, null, [{
        key: "requires",
        get: function get() {
          return [Ud, Gd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Undo";
        }
      }]);

      return Qd;
    }(Kl);

    var Kd = /*#__PURE__*/function (_Kl10, _Symbol$iterator13) {
      _inherits(Kd, _Kl10);

      var _super73 = _createSuper(Kd);

      function Kd() {
        _classCallCheck(this, Kd);

        return _super73.apply(this, arguments);
      }

      _createClass(Kd, [{
        key: "init",
        value: function init() {
          this.set("hasAny", !1), this._actions = new oo({
            idProperty: "_id"
          }), this._actions.delegate("add", "remove").to(this);
        }
      }, {
        key: "add",
        value: function add(t) {
          if ("string" != typeof t) throw new Gn.b("pendingactions-add-invalid-message: The message must be a string.", this);
          var e = Object.create(Fi);
          return e.set("message", t), this._actions.add(e), this.hasAny = !0, e;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._actions.remove(t), this.hasAny = !!this._actions.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._actions.get(0);
        }
      }, {
        key: _Symbol$iterator13,
        value: function value() {
          return this._actions[Symbol.iterator]();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PendingActions";
        }
      }]);

      return Kd;
    }(Kl, Symbol.iterator);

    var Jd = /*#__PURE__*/function () {
      function Jd() {
        var _this124 = this;

        _classCallCheck(this, Jd);

        var t = new window.FileReader();
        this._reader = t, this._data = void 0, this.set("loaded", 0), t.onprogress = function (t) {
          _this124.loaded = t.loaded;
        };
      }

      _createClass(Jd, [{
        key: "error",
        get: function get() {
          return this._reader.error;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }, {
        key: "read",
        value: function read(t) {
          var _this125 = this;

          var e = this._reader;
          return this.total = t.size, new Promise(function (n, i) {
            e.onload = function () {
              var t = e.result;
              _this125._data = t, n(t);
            }, e.onerror = function () {
              i("error");
            }, e.onabort = function () {
              i("aborted");
            }, _this125._reader.readAsDataURL(t);
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this._reader.abort();
        }
      }]);

      return Jd;
    }();

    ci(Jd, Fi);

    var Zd = /*#__PURE__*/function (_Kl11) {
      _inherits(Zd, _Kl11);

      var _super74 = _createSuper(Zd);

      function Zd() {
        _classCallCheck(this, Zd);

        return _super74.apply(this, arguments);
      }

      _createClass(Zd, [{
        key: "init",
        value: function init() {
          var _this126 = this;

          this.loaders = new oo(), this.loaders.on("add", function () {
            return _this126._updatePendingAction();
          }), this.loaders.on("remove", function () {
            return _this126._updatePendingAction();
          }), this._loadersMap = new Map(), this._pendingAction = null, this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
            return e ? t / e * 100 : 0;
          });
        }
      }, {
        key: "getLoader",
        value: function getLoader(t) {
          return this._loadersMap.get(t) || null;
        }
      }, {
        key: "createLoader",
        value: function createLoader(t) {
          var _this127 = this;

          if (!this.createUploadAdapter) return console.warn(Object(Gn.a)("filerepository-no-upload-adapter: Upload adapter is not defined.")), null;
          var e = new Xd(Promise.resolve(t), this.createUploadAdapter);
          return this.loaders.add(e), this._loadersMap.set(t, e), t instanceof Promise && e.file.then(function (t) {
            _this127._loadersMap.set(t, e);
          }), e.file.catch(function () {}), e.on("change:uploaded", function () {
            var t = 0;

            var _iterator270 = _createForOfIteratorHelper(_this127.loaders),
                _step270;

            try {
              for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
                var _e204 = _step270.value;
                t += _e204.uploaded;
              }
            } catch (err) {
              _iterator270.e(err);
            } finally {
              _iterator270.f();
            }

            _this127.uploaded = t;
          }), e.on("change:uploadTotal", function () {
            var t = 0;

            var _iterator271 = _createForOfIteratorHelper(_this127.loaders),
                _step271;

            try {
              for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
                var _e205 = _step271.value;
                _e205.uploadTotal && (t += _e205.uploadTotal);
              }
            } catch (err) {
              _iterator271.e(err);
            } finally {
              _iterator271.f();
            }

            _this127.uploadTotal = t;
          }), e;
        }
      }, {
        key: "destroyLoader",
        value: function destroyLoader(t) {
          var _this128 = this;

          var e = t instanceof Xd ? t : this.getLoader(t);
          e._destroy(), this.loaders.remove(e), this._loadersMap.forEach(function (t, n) {
            t === e && _this128._loadersMap.delete(n);
          });
        }
      }, {
        key: "_updatePendingAction",
        value: function _updatePendingAction() {
          var t = this.editor.plugins.get(Kd);

          if (this.loaders.length) {
            if (!this._pendingAction) {
              var _e206 = this.editor.t,
                  _n189 = function _n189(t) {
                return "".concat(_e206("aw"), " ").concat(parseInt(t), "%.");
              };

              this._pendingAction = t.add(_n189(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", _n189);
            }
          } else t.remove(this._pendingAction), this._pendingAction = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FileRepository";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Kd];
        }
      }]);

      return Zd;
    }(Kl);

    ci(Zd, Fi);

    var Xd = /*#__PURE__*/function () {
      function Xd(t, e) {
        _classCallCheck(this, Xd);

        this.id = Jn(), this._filePromiseWrapper = this._createFilePromiseWrapper(t), this._adapter = e(this), this._reader = new Jd(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
          return e ? t / e * 100 : 0;
        }), this.set("uploadResponse", null);
      }

      _createClass(Xd, [{
        key: "file",
        get: function get() {
          var _this129 = this;

          return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then(function (t) {
            return _this129._filePromiseWrapper ? t : null;
          }) : Promise.resolve(null);
        }
      }, {
        key: "data",
        get: function get() {
          return this._reader.data;
        }
      }, {
        key: "read",
        value: function read() {
          var _this130 = this;

          if ("idle" != this.status) throw new Gn.b("filerepository-read-wrong-status: You cannot call read if the status is different than idle.", this);
          return this.status = "reading", this._filePromiseWrapper.promise.then(function (t) {
            return _this130._reader.read(t);
          }).then(function (t) {
            return _this130.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === t) throw _this130.status = "aborted", "aborted";
            throw _this130.status = "error", _this130._reader.error ? _this130._reader.error : t;
          });
        }
      }, {
        key: "upload",
        value: function upload() {
          var _this131 = this;

          if ("idle" != this.status) throw new Gn.b("filerepository-upload-wrong-status: You cannot call upload if the status is different than idle.", this);
          return this.status = "uploading", this._filePromiseWrapper.promise.then(function () {
            return _this131._adapter.upload();
          }).then(function (t) {
            return _this131.uploadResponse = t, _this131.status = "idle", t;
          }).catch(function (t) {
            if ("aborted" === _this131.status) throw "aborted";
            throw _this131.status = "error", t;
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          var t = this.status;
          this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t ? this._reader.abort() : "uploading" == t && this._adapter.abort && this._adapter.abort() : this._filePromiseWrapper.rejecter("aborted"), this._destroy();
        }
      }, {
        key: "_destroy",
        value: function _destroy() {
          this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
        }
      }, {
        key: "_createFilePromiseWrapper",
        value: function _createFilePromiseWrapper(t) {
          var e = {};
          return e.promise = new Promise(function (n, i) {
            e.resolver = n, e.rejecter = i, e.isFulfilled = !1, t.then(function (t) {
              e.isFulfilled = !0, n(t);
            }).catch(function (t) {
              e.isFulfilled = !0, i(t);
            });
          }), e;
        }
      }]);

      return Xd;
    }();

    ci(Xd, Fi);
    var th = "ckCsrfToken",
        eh = 40,
        nh = "abcdefghijklmnopqrstuvwxyz0123456789";

    function ih() {
      var t = function (t) {
        t = t.toLowerCase();
        var e = document.cookie.split(";");

        var _iterator272 = _createForOfIteratorHelper(e),
            _step272;

        try {
          for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
            var _n190 = _step272.value;

            var _e207 = _n190.split("="),
                _i150 = decodeURIComponent(_e207[0].trim().toLowerCase());

            if (_i150 === t) return decodeURIComponent(_e207[1]);
          }
        } catch (err) {
          _iterator272.e(err);
        } finally {
          _iterator272.f();
        }

        return null;
      }(th);

      return t && t.length == eh || (t = function (t) {
        var e = "";
        var n = new Uint8Array(t);
        window.crypto.getRandomValues(n);

        for (var _t214 = 0; _t214 < n.length; _t214++) {
          var _i151 = nh.charAt(n[_t214] % nh.length);

          e += Math.random() > .5 ? _i151.toUpperCase() : _i151;
        }

        return e;
      }(eh), function (t, e) {
        document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(e) + ";path=/";
      }(th, t)), t;
    }

    var oh = /*#__PURE__*/function (_Kl12) {
      _inherits(oh, _Kl12);

      var _super75 = _createSuper(oh);

      function oh() {
        _classCallCheck(this, oh);

        return _super75.apply(this, arguments);
      }

      _createClass(oh, [{
        key: "init",
        value: function init() {
          var _this132 = this;

          var t = this.editor.config.get("ckfinder.uploadUrl");
          t && (this.editor.plugins.get(Zd).createUploadAdapter = function (e) {
            return new rh(e, t, _this132.editor.t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Zd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "CKFinderUploadAdapter";
        }
      }]);

      return oh;
    }(Kl);

    var rh = /*#__PURE__*/function () {
      function rh(t, e, n) {
        _classCallCheck(this, rh);

        this.loader = t, this.url = e, this.t = n;
      }

      _createClass(rh, [{
        key: "upload",
        value: function upload() {
          var _this133 = this;

          return this.loader.file.then(function (t) {
            return new Promise(function (e, n) {
              _this133._initRequest(), _this133._initListeners(e, n, t), _this133._sendRequest(t);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr && this.xhr.abort();
        }
      }, {
        key: "_initRequest",
        value: function _initRequest() {
          var t = this.xhr = new XMLHttpRequest();
          t.open("POST", this.url, !0), t.responseType = "json";
        }
      }, {
        key: "_initListeners",
        value: function _initListeners(t, e, n) {
          var i = this.xhr,
              o = this.loader,
              r = (0, this.t)("a") + " ".concat(n.name, ".");
          i.addEventListener("error", function () {
            return e(r);
          }), i.addEventListener("abort", function () {
            return e();
          }), i.addEventListener("load", function () {
            var n = i.response;
            if (!n || !n.uploaded) return e(n && n.error && n.error.message ? n.error.message : r);
            t({
              default: n.url
            });
          }), i.upload && i.upload.addEventListener("progress", function (t) {
            t.lengthComputable && (o.uploadTotal = t.total, o.uploaded = t.loaded);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest(t) {
          var e = new FormData();
          e.append("upload", t), e.append("ckCsrfToken", ih()), this.xhr.send(e);
        }
      }]);

      return rh;
    }();

    var sh = function sh(t, e, n) {
      _classCallCheck(this, sh);

      var i,
          o = null;
      "function" == typeof n ? i = n : (o = t.commands.get(n), i = function i() {
        t.execute(n);
      }), t.model.document.on("change", function (n, r) {
        if (o && !o.isEnabled) return;
        if ("transparent" == r.type) return;
        var s = Array.from(t.model.document.differ.getChanges()),
            a = s[0];
        if (1 != s.length || "insert" !== a.type || "$text" != a.name || 1 != a.length) return;
        var c = a.position.textNode || a.position.nodeAfter;
        if (!c.parent.is("paragraph")) return;
        var l = e.exec(c.data);
        l && t.model.enqueueChange(function (t) {
          var e = t.createPositionAt(c.parent, 0),
              n = t.createPositionAt(c.parent, l[0].length),
              o = new oa(e, n);
          !1 !== i({
            match: l
          }) && t.remove(o), o.detach();
        });
      });
    };

    var ah = function ah(t, e, n) {
      _classCallCheck(this, ah);

      var i, o, r, s;
      e instanceof RegExp ? i = e : r = e, "string" == typeof n ? o = n : s = n, r = r || function (t) {
        var e;
        var n = [],
            o = [];

        for (; null !== (e = i.exec(t)) && !(e && e.length < 4);) {
          var _e208 = e,
              _t215 = _e208.index,
              _i152 = _e208[1],
              _r33 = _e208[2],
              _s23 = _e208[3];

          var _a13 = _i152 + _r33 + _s23,
              _c8 = [_t215 += e[0].length - _a13.length, _t215 + _i152.length],
              _l4 = [_t215 + _i152.length + _r33.length, _t215 + _i152.length + _r33.length + _s23.length];

          n.push(_c8), n.push(_l4), o.push([_t215 + _i152.length, _t215 + _i152.length + _r33.length]);
        }

        return {
          remove: n,
          format: o
        };
      }, s = s || function (e, n) {
        var i = t.model.schema.getValidRanges(n, o);

        var _iterator273 = _createForOfIteratorHelper(i),
            _step273;

        try {
          for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
            var _t216 = _step273.value;
            e.setAttribute(o, !0, _t216);
          }
        } catch (err) {
          _iterator273.e(err);
        } finally {
          _iterator273.f();
        }

        e.removeSelectionAttribute(o);
      }, t.model.document.on("change", function (e, n) {
        if ("transparent" == n.type) return;
        var i = t.model.document.selection;
        if (!i.isCollapsed) return;
        var o = Array.from(t.model.document.differ.getChanges()),
            a = o[0];
        if (1 != o.length || "insert" !== a.type || "$text" != a.name || 1 != a.length) return;

        var c = i.focus.parent,
            l = function (t) {
          return Array.from(t.getChildren()).reduce(function (t, e) {
            return t + e.data;
          }, "");
        }(c).slice(0, i.focus.offset),
            d = r(l),
            h = ch(c, d.format, t.model),
            u = ch(c, d.remove, t.model);

        h.length && u.length && t.model.enqueueChange(function (t) {
          if (!1 !== s(t, h)) {
            var _iterator274 = _createForOfIteratorHelper(u.reverse()),
                _step274;

            try {
              for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
                var _e209 = _step274.value;
                t.remove(_e209);
              }
            } catch (err) {
              _iterator274.e(err);
            } finally {
              _iterator274.f();
            }
          }
        });
      });
    };

    function ch(t, e, n) {
      return e.filter(function (t) {
        return void 0 !== t[0] && void 0 !== t[1];
      }).map(function (e) {
        return n.createRange(n.createPositionAt(t, e[0]), n.createPositionAt(t, e[1]));
      });
    }

    function lh(t, e) {
      return function (n, i) {
        if (!t.commands.get(e).isEnabled) return !1;
        var o = t.model.schema.getValidRanges(i, e);

        var _iterator275 = _createForOfIteratorHelper(o),
            _step275;

        try {
          for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
            var _t217 = _step275.value;
            n.setAttribute(e, !0, _t217);
          }
        } catch (err) {
          _iterator275.e(err);
        } finally {
          _iterator275.f();
        }

        n.removeSelectionAttribute(e);
      };
    }

    var dh = /*#__PURE__*/function (_ed6) {
      _inherits(dh, _ed6);

      var _super76 = _createSuper(dh);

      function dh(t, e) {
        var _this134;

        _classCallCheck(this, dh);

        _this134 = _super76.call(this, t), _this134.attributeKey = e;
        return _this134;
      }

      _createClass(dh, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;
          this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this135 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document.selection,
              i = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (n.isCollapsed) i ? t.setSelectionAttribute(_this135.attributeKey, !0) : t.removeSelectionAttribute(_this135.attributeKey);else {
              var _o76 = e.schema.getValidRanges(n.getRanges(), _this135.attributeKey);

              var _iterator276 = _createForOfIteratorHelper(_o76),
                  _step276;

              try {
                for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
                  var _e210 = _step276.value;
                  i ? t.setAttribute(_this135.attributeKey, i, _e210) : t.removeAttribute(_this135.attributeKey, _e210);
                }
              } catch (err) {
                _iterator276.e(err);
              } finally {
                _iterator276.f();
              }
            }
          });
        }
      }, {
        key: "_getValueFromFirstAllowedNode",
        value: function _getValueFromFirstAllowedNode() {
          var t = this.editor.model,
              e = t.schema,
              n = t.document.selection;
          if (n.isCollapsed) return n.hasAttribute(this.attributeKey);

          var _iterator277 = _createForOfIteratorHelper(n.getRanges()),
              _step277;

          try {
            for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
              var _t218 = _step277.value;

              var _iterator278 = _createForOfIteratorHelper(_t218.getItems()),
                  _step278;

              try {
                for (_iterator278.s(); !(_step278 = _iterator278.n()).done;) {
                  var _n191 = _step278.value;
                  if (e.checkAttribute(_n191, this.attributeKey)) return _n191.hasAttribute(this.attributeKey);
                }
              } catch (err) {
                _iterator278.e(err);
              } finally {
                _iterator278.f();
              }
            }
          } catch (err) {
            _iterator277.e(err);
          } finally {
            _iterator277.f();
          }

          return !1;
        }
      }]);

      return dh;
    }(ed);

    var hh = "bold";

    var uh = /*#__PURE__*/function (_Kl13) {
      _inherits(uh, _Kl13);

      var _super77 = _createSuper(uh);

      function uh() {
        _classCallCheck(this, uh);

        return _super77.apply(this, arguments);
      }

      _createClass(uh, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: hh
          }), t.model.schema.setAttributeProperties(hh, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: hh,
            view: "strong",
            upcastAlso: ["b", {
              styles: {
                "font-weight": "bold"
              }
            }]
          }), t.commands.add(hh, new dh(t, hh)), t.keystrokes.set("CTRL+B", hh);
        }
      }]);

      return uh;
    }(Kl);

    var fh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
    var mh = "bold";

    var gh = /*#__PURE__*/function (_Kl14) {
      _inherits(gh, _Kl14);

      var _super78 = _createSuper(gh);

      function gh() {
        _classCallCheck(this, gh);

        return _super78.apply(this, arguments);
      }

      _createClass(gh, [{
        key: "init",
        value: function init() {
          var _this136 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(mh, function (n) {
            var i = t.commands.get(mh),
                o = new Wd(n);
            return o.set({
              label: e("d"),
              icon: fh,
              keystroke: "CTRL+B",
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this136.listenTo(o, "execute", function () {
              return t.execute(mh);
            }), o;
          });
        }
      }]);

      return gh;
    }(Kl);

    var ph = "italic";

    var bh = /*#__PURE__*/function (_Kl15) {
      _inherits(bh, _Kl15);

      var _super79 = _createSuper(bh);

      function bh() {
        _classCallCheck(this, bh);

        return _super79.apply(this, arguments);
      }

      _createClass(bh, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: ph
          }), t.model.schema.setAttributeProperties(ph, {
            isFormatting: !0,
            copyOnEnter: !0
          }), t.conversion.attributeToElement({
            model: ph,
            view: "i",
            upcastAlso: ["em", {
              styles: {
                "font-style": "italic"
              }
            }]
          }), t.commands.add(ph, new dh(t, ph)), t.keystrokes.set("CTRL+I", ph);
        }
      }]);

      return bh;
    }(Kl);

    var wh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
    var kh = "italic";

    var _h = /*#__PURE__*/function (_Kl16) {
      _inherits(_h, _Kl16);

      var _super80 = _createSuper(_h);

      function _h() {
        _classCallCheck(this, _h);

        return _super80.apply(this, arguments);
      }

      _createClass(_h, [{
        key: "init",
        value: function init() {
          var _this137 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add(kh, function (n) {
            var i = t.commands.get(kh),
                o = new Wd(n);
            return o.set({
              label: e("e"),
              icon: wh,
              keystroke: "CTRL+I",
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this137.listenTo(o, "execute", function () {
              return t.execute(kh);
            }), o;
          });
        }
      }]);

      return _h;
    }(Kl);

    function vh(t) {
      var e = t.next();
      return e.done ? null : e.value;
    }

    var yh = /*#__PURE__*/function (_ed7) {
      _inherits(yh, _ed7);

      var _super81 = _createSuper(yh);

      function yh() {
        _classCallCheck(this, yh);

        return _super81.apply(this, arguments);
      }

      _createClass(yh, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this138 = this;

          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = Array.from(i.getTopMostBlocks()),
              r = void 0 === t.forceValue ? !this.value : t.forceValue;
          e.change(function (t) {
            if (r) {
              var _e211 = o.filter(function (t) {
                return xh(t) || Th(n, t);
              });

              _this138._applyQuote(t, _e211);
            } else _this138._removeQuote(t, o.filter(xh));
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = vh(this.editor.model.document.selection.getTopMostBlocks());
          return !(!t || !xh(t));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              n = vh(t.getSelectedBlocks());
          return !!n && Th(e, n);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(t, e) {
          Ah(t, e).reverse().forEach(function (e) {
            if (e.start.isAtStart && e.end.isAtEnd) return void t.unwrap(e.start.parent);

            if (e.start.isAtStart) {
              var _n192 = t.createPositionBefore(e.start.parent);

              return void t.move(e, _n192);
            }

            e.end.isAtEnd || t.split(e.end);
            var n = t.createPositionAfter(e.end.parent);
            t.move(e, n);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(t, e) {
          var n = [];
          Ah(t, e).reverse().forEach(function (e) {
            var i = xh(e.start);
            i || (i = t.createElement("blockQuote"), t.wrap(e, i)), n.push(i);
          }), n.reverse().reduce(function (e, n) {
            return e.nextSibling == n ? (t.merge(t.createPositionAfter(e)), e) : n;
          });
        }
      }]);

      return yh;
    }(ed);

    function xh(t) {
      return "blockQuote" == t.parent.name ? t.parent : null;
    }

    function Ah(t, e) {
      var n,
          i = 0;
      var o = [];

      for (; i < e.length;) {
        var _r34 = e[i],
            _s24 = e[i + 1];
        n || (n = t.createPositionBefore(_r34)), _s24 && _r34.nextSibling == _s24 || (o.push(t.createRange(n, t.createPositionAfter(_r34))), n = null), i++;
      }

      return o;
    }

    function Th(t, e) {
      var n = t.checkChild(e.parent, "blockQuote"),
          i = t.checkChild(["$root", "blockQuote"], e);
      return n && i;
    }

    var Ch = /*#__PURE__*/function (_Kl17) {
      _inherits(Ch, _Kl17);

      var _super82 = _createSuper(Ch);

      function Ch() {
        _classCallCheck(this, Ch);

        return _super82.apply(this, arguments);
      }

      _createClass(Ch, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema;
          t.commands.add("blockQuote", new yh(t)), e.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          }), e.addChildCheck(function (t, e) {
            if (t.endsWith("blockQuote") && "blockQuote" == e.name) return !1;
          }), t.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          }), t.model.document.registerPostFixer(function (n) {
            var i = t.model.document.differ.getChanges();

            var _iterator279 = _createForOfIteratorHelper(i),
                _step279;

            try {
              for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
                var _t219 = _step279.value;

                if ("insert" == _t219.type) {
                  var _i153 = _t219.position.nodeAfter;
                  if (!_i153) continue;
                  if (_i153.is("blockQuote") && _i153.isEmpty) return n.remove(_i153), !0;
                  if (_i153.is("blockQuote") && !e.checkChild(_t219.position, _i153)) return n.unwrap(_i153), !0;

                  if (_i153.is("element")) {
                    var _t220 = n.createRangeIn(_i153);

                    var _iterator280 = _createForOfIteratorHelper(_t220.getItems()),
                        _step280;

                    try {
                      for (_iterator280.s(); !(_step280 = _iterator280.n()).done;) {
                        var _i154 = _step280.value;
                        if (_i154.is("blockQuote") && !e.checkChild(n.createPositionBefore(_i154), _i154)) return n.unwrap(_i154), !0;
                      }
                    } catch (err) {
                      _iterator280.e(err);
                    } finally {
                      _iterator280.f();
                    }
                  }
                } else if ("remove" == _t219.type) {
                  var _e212 = _t219.position.parent;
                  if (_e212.is("blockQuote") && _e212.isEmpty) return n.remove(_e212), !0;
                }
              }
            } catch (err) {
              _iterator279.e(err);
            } finally {
              _iterator279.f();
            }

            return !1;
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var _this139 = this;

          var t = this.editor.commands.get("blockQuote");
          this.listenTo(this.editor.editing.view.document, "enter", function (e, n) {
            var i = _this139.editor.model.document,
                o = i.selection.getLastPosition().parent;
            i.selection.isCollapsed && o.isEmpty && t.value && (_this139.editor.execute("blockQuote"), _this139.editor.editing.view.scrollToTheSelection(), n.preventDefault(), e.stop());
          });
        }
      }]);

      return Ch;
    }(Kl);

    var Ph = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
    n(34);

    var Sh = /*#__PURE__*/function (_Kl18) {
      _inherits(Sh, _Kl18);

      var _super83 = _createSuper(Sh);

      function Sh() {
        _classCallCheck(this, Sh);

        return _super83.apply(this, arguments);
      }

      _createClass(Sh, [{
        key: "init",
        value: function init() {
          var _this140 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("blockQuote", function (n) {
            var i = t.commands.get("blockQuote"),
                o = new Wd(n);
            return o.set({
              label: e("f"),
              icon: Ph,
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isOn", "isEnabled").to(i, "value", "isEnabled"), _this140.listenTo(o, "execute", function () {
              return t.execute("blockQuote");
            }), o;
          });
        }
      }]);

      return Sh;
    }(Kl);

    var Mh = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>';

    var Eh = /*#__PURE__*/function (_Kl19) {
      _inherits(Eh, _Kl19);

      var _super84 = _createSuper(Eh);

      function Eh() {
        _classCallCheck(this, Eh);

        return _super84.apply(this, arguments);
      }

      _createClass(Eh, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.ui.componentFactory,
              n = t.t;
          e.add("ckfinder", function (e) {
            var i = t.commands.get("ckfinder"),
                o = new Wd(e);
            return o.set({
              label: n("g"),
              icon: Mh,
              tooltip: !0
            }), o.bind("isEnabled").to(i), o.on("execute", function () {
              t.execute("ckfinder"), t.editing.view.focus();
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderUI";
        }
      }]);

      return Eh;
    }(Kl);

    var Ih = /*#__PURE__*/function (_Kl20) {
      _inherits(Ih, _Kl20);

      var _super85 = _createSuper(Ih);

      function Ih() {
        _classCallCheck(this, Ih);

        return _super85.apply(this, arguments);
      }

      _createClass(Ih, [{
        key: "init",
        value: function init() {
          this.on("show:warning", function (t, e) {
            window.alert(e.message);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "showSuccess",
        value: function showSuccess(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "success",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showInfo",
        value: function showInfo(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "info",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showWarning",
        value: function showWarning(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          this._showNotification({
            message: t,
            type: "warning",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "_showNotification",
        value: function _showNotification(t) {
          var e = "show:".concat(t.type) + (t.namespace ? ":".concat(t.namespace) : "");
          this.fire(e, {
            message: t.message,
            type: t.type,
            title: t.title || ""
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Notification";
        }
      }]);

      return Ih;
    }(Kl);

    var Nh = /*#__PURE__*/function (_ed8) {
      _inherits(Nh, _ed8);

      var _super86 = _createSuper(Nh);

      function Nh(t) {
        var _this141;

        _classCallCheck(this, Nh);

        _this141 = _super86.call(this, t), _this141.stopListening(_this141.editor.model.document, "change"), _this141.listenTo(_this141.editor.model.document, "change", function () {
          return _this141.refresh();
        }, {
          priority: "low"
        });
        return _this141;
      }

      _createClass(Nh, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.commands.get("imageUpload"),
              e = this.editor.commands.get("link");
          this.isEnabled = t && e && (t.isEnabled || e.isEnabled);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if ("popup" != e && "modal" != e) throw new Gn.b('ckfinder-unknown-openerMethod: The openerMethod config option must by "popup" or "modal".', t);
          var n = this.editor.config.get("ckfinder.options") || {};
          n.chooseFiles = !0;
          var i = n.onInit;
          n.language || (n.language = t.locale.uiLanguage), n.onInit = function (e) {
            i && i(e), e.on("files:choose", function (n) {
              var i = n.data.files.toArray(),
                  o = i.filter(function (t) {
                return !t.isImage();
              }),
                  r = i.filter(function (t) {
                return t.isImage();
              });

              var _iterator281 = _createForOfIteratorHelper(o),
                  _step281;

              try {
                for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
                  var _e213 = _step281.value;
                  t.execute("link", _e213.getUrl());
                }
              } catch (err) {
                _iterator281.e(err);
              } finally {
                _iterator281.f();
              }

              var s = [];

              var _iterator282 = _createForOfIteratorHelper(r),
                  _step282;

              try {
                for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
                  var _t221 = _step282.value;

                  var _n193 = _t221.getUrl();

                  s.push(_n193 || e.request("file:getProxyUrl", {
                    file: _t221
                  }));
                }
              } catch (err) {
                _iterator282.e(err);
              } finally {
                _iterator282.f();
              }

              s.length && Oh(t, s);
            }), e.on("file:choose:resizedImage", function (e) {
              var n = e.data.resizedUrl;
              if (n) Oh(t, [n]);else {
                var _e214 = t.plugins.get("Notification"),
                    _n194 = t.locale.t;

                _e214.showWarning(_n194("ar"), {
                  title: _n194("as"),
                  namespace: "ckfinder"
                });
              }
            });
          }, window.CKFinder[e](n);
        }
      }]);

      return Nh;
    }(ed);

    function Oh(t, e) {
      if (t.commands.get("imageUpload").isEnabled) t.execute("imageInsert", {
        source: e
      });else {
        var _e215 = t.plugins.get("Notification"),
            _n195 = t.locale.t;

        _e215.showWarning(_n195("at"), {
          title: _n195("au"),
          namespace: "ckfinder"
        });
      }
    }

    var Rh = /*#__PURE__*/function (_Kl21) {
      _inherits(Rh, _Kl21);

      var _super87 = _createSuper(Rh);

      function Rh() {
        _classCallCheck(this, Rh);

        return _super87.apply(this, arguments);
      }

      _createClass(Rh, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("ckfinder", new Nh(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Ih];
        }
      }]);

      return Rh;
    }(Kl);

    var Dh = /^data:(\S*?);base64,/;

    var Lh = /*#__PURE__*/function () {
      function Lh(t, e, n) {
        _classCallCheck(this, Lh);

        if (!t) throw new Gn.b("fileuploader-missing-file: File must be provided as the first argument", null);
        if (!e) throw new Gn.b("fileuploader-missing-token: Token must be provided as the second argument.", null);
        if (!n) throw new Gn.b("fileuploader-missing-api-address: Api address must be provided as the third argument.", null);
        this.file = function (t) {
          if ("string" != typeof t) return !1;
          var e = t.match(Dh);
          return !(!e || !e.length);
        }(t) ? function (t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;

          try {
            var _n196 = t.match(Dh)[1],
                _i155 = atob(t.replace(Dh, "")),
                _o77 = [];

            for (var _t222 = 0; _t222 < _i155.length; _t222 += e) {
              var _n197 = _i155.slice(_t222, _t222 + e),
                  _r35 = new Array(_n197.length);

              for (var _t223 = 0; _t223 < _n197.length; _t223++) {
                _r35[_t223] = _n197.charCodeAt(_t223);
              }

              _o77.push(new Uint8Array(_r35));
            }

            return new Blob(_o77, {
              type: _n196
            });
          } catch (t) {
            throw new Gn.b("fileuploader-decoding-image-data-error: Problem with decoding Base64 image data.", null);
          }
        }(t) : t, this._token = e, this._apiAddress = n;
      }

      _createClass(Lh, [{
        key: "onProgress",
        value: function onProgress(t) {
          return this.on("progress", function (e, n) {
            return t(n);
          }), this;
        }
      }, {
        key: "onError",
        value: function onError(t) {
          return this.once("error", function (e, n) {
            return t(n);
          }), this;
        }
      }, {
        key: "abort",
        value: function abort() {
          this.xhr.abort();
        }
      }, {
        key: "send",
        value: function send() {
          return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
        }
      }, {
        key: "_prepareRequest",
        value: function _prepareRequest() {
          var t = new XMLHttpRequest();
          t.open("POST", this._apiAddress), t.setRequestHeader("Authorization", this._token.value), t.responseType = "json", this.xhr = t;
        }
      }, {
        key: "_attachXHRListeners",
        value: function _attachXHRListeners() {
          var _this142 = this;

          var t = this,
              e = this.xhr;

          function n(e) {
            return function () {
              return t.fire("error", e);
            };
          }

          e.addEventListener("error", n("Network Error")), e.addEventListener("abort", n("Abort")), e.upload && e.upload.addEventListener("progress", function (t) {
            t.lengthComputable && _this142.fire("progress", {
              total: t.total,
              uploaded: t.loaded
            });
          }), e.addEventListener("load", function () {
            var t = e.status,
                n = e.response;
            if (t < 200 || t > 299) return _this142.fire("error", n.message || n.error);
          });
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest() {
          var _this143 = this;

          var t = new FormData(),
              e = this.xhr;
          return t.append("file", this.file), new Promise(function (n, i) {
            e.addEventListener("load", function () {
              var t = e.status,
                  o = e.response;
              return t < 200 || t > 299 ? o.message ? i(new Gn.b("fileuploader-uploading-data-failed: Uploading file failed.", _this143, {
                message: o.message
              })) : i(o.error) : n(o);
            }), e.addEventListener("error", function () {
              return i(new Error("Network Error"));
            }), e.addEventListener("abort", function () {
              return i(new Error("Abort"));
            }), e.send(t);
          });
        }
      }]);

      return Lh;
    }();

    ci(Lh, ei);
    var jh = {
      refreshInterval: 36e5,
      autoRefresh: !0
    };

    var Vh = /*#__PURE__*/function () {
      function Vh(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jh;

        _classCallCheck(this, Vh);

        if (!t) throw new Gn.b("token-missing-token-url: A `tokenUrl` must be provided as the first constructor argument.", this);
        this.set("value", e.initValue), this._refresh = "function" == typeof t ? t : function () {
          return function (t) {
            return new Promise(function (e, n) {
              var i = new XMLHttpRequest();
              i.open("GET", t), i.addEventListener("load", function () {
                var t = i.status,
                    o = i.response;
                return t < 200 || t > 299 ? n(new Gn.b("token-cannot-download-new-token: Cannot download new token from the provided url.", null)) : e(o);
              }), i.addEventListener("error", function () {
                return n(new Error("Network Error"));
              }), i.addEventListener("abort", function () {
                return n(new Error("Abort"));
              }), i.send();
            });
          }(t);
        }, this._options = Object.assign({}, jh, e);
      }

      _createClass(Vh, [{
        key: "init",
        value: function init() {
          var _this144 = this;

          return new Promise(function (t, e) {
            _this144._options.autoRefresh && _this144._startRefreshing(), _this144.value ? t(_this144) : _this144._refreshToken().then(t).catch(e);
          });
        }
      }, {
        key: "_refreshToken",
        value: function _refreshToken() {
          var _this145 = this;

          return this._refresh().then(function (t) {
            return _this145.set("value", t);
          }).then(function () {
            return _this145;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._stopRefreshing();
        }
      }, {
        key: "_startRefreshing",
        value: function _startRefreshing() {
          var _this146 = this;

          this._refreshInterval = setInterval(function () {
            return _this146._refreshToken();
          }, this._options.refreshInterval);
        }
      }, {
        key: "_stopRefreshing",
        value: function _stopRefreshing() {
          clearInterval(this._refreshInterval);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : jh;
          return new Vh(t, e).init();
        }
      }]);

      return Vh;
    }();

    ci(Vh, Fi);
    var zh = Vh;

    var Bh = /*#__PURE__*/function (_Kl22) {
      _inherits(Bh, _Kl22);

      var _super88 = _createSuper(Bh);

      function Bh() {
        _classCallCheck(this, Bh);

        return _super88.apply(this, arguments);
      }

      _createClass(Bh, [{
        key: "init",
        value: function init() {
          var t = this.editor.config.get("cloudServices") || {};

          for (var _e216 in t) {
            this[_e216] = t[_e216];
          }

          if (this.tokenUrl) return this.token = new Bh.Token(this.tokenUrl), this.token.init();
          this.token = null;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CloudServices";
        }
      }]);

      return Bh;
    }(Kl);

    Bh.Token = zh;

    var Fh = /*#__PURE__*/function (_Kl23) {
      _inherits(Fh, _Kl23);

      var _super89 = _createSuper(Fh);

      function Fh() {
        _classCallCheck(this, Fh);

        return _super89.apply(this, arguments);
      }

      _createClass(Fh, [{
        key: "init",
        value: function init() {
          var _this147 = this;

          var t = this.editor,
              e = t.plugins.get(Bh),
              n = e.token,
              i = e.uploadUrl;
          n && (this._uploadGateway = new Fh._UploadGateway(n, i), t.plugins.get(Zd).createUploadAdapter = function (t) {
            return new Uh(_this147._uploadGateway, t);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Zd, Bh];
        }
      }]);

      return Fh;
    }(Kl);

    var Uh = /*#__PURE__*/function () {
      function Uh(t, e) {
        _classCallCheck(this, Uh);

        this.uploadGateway = t, this.loader = e;
      }

      _createClass(Uh, [{
        key: "upload",
        value: function upload() {
          var _this148 = this;

          return this.loader.file.then(function (t) {
            return _this148.fileUploader = _this148.uploadGateway.upload(t), _this148.fileUploader.on("progress", function (t, e) {
              _this148.loader.uploadTotal = e.total, _this148.loader.uploaded = e.uploaded;
            }), _this148.fileUploader.send();
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this.fileUploader.abort();
        }
      }]);

      return Uh;
    }();

    Fh._UploadGateway = /*#__PURE__*/function () {
      function _class(t, e) {
        _classCallCheck(this, _class);

        if (!t) throw new Gn.b("uploadgateway-missing-token: Token must be provided.", null);
        if (!e) throw new Gn.b("uploadgateway-missing-api-address: Api address must be provided.", null);
        this._token = t, this._apiAddress = e;
      }

      _createClass(_class, [{
        key: "upload",
        value: function upload(t) {
          return new Lh(t, this._token, this._apiAddress);
        }
      }]);

      return _class;
    }();

    var Hh = /*#__PURE__*/function (_ur7) {
      _inherits(Hh, _ur7);

      var _super90 = _createSuper(Hh);

      function Hh(t) {
        var _this149;

        _classCallCheck(this, Hh);

        _this149 = _super90.call(this, t), _this149._observedElements = new Set();
        return _this149;
      }

      _createClass(Hh, [{
        key: "observe",
        value: function observe(t, e) {
          var _this150 = this;

          this.document.getRoot(e).on("change:children", function (e, n) {
            _this150.view.once("render", function () {
              return _this150._updateObservedElements(t, n);
            });
          });
        }
      }, {
        key: "_updateObservedElements",
        value: function _updateObservedElements(t, e) {
          var _this151 = this;

          if (!e.is("element") || e.is("attributeElement")) return;
          var n = this.view.domConverter.mapViewToDom(e);

          if (n) {
            var _iterator283 = _createForOfIteratorHelper(n.querySelectorAll("img")),
                _step283;

            try {
              for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
                var _t224 = _step283.value;
                this._observedElements.has(_t224) || (this.listenTo(_t224, "load", function (t, e) {
                  return _this151._fireEvents(e);
                }), this._observedElements.add(_t224));
              }
            } catch (err) {
              _iterator283.e(err);
            } finally {
              _iterator283.f();
            }

            var _iterator284 = _createForOfIteratorHelper(this._observedElements),
                _step284;

            try {
              for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
                var _e217 = _step284.value;
                t.contains(_e217) || (this.stopListening(_e217), this._observedElements.delete(_e217));
              }
            } catch (err) {
              _iterator284.e(err);
            } finally {
              _iterator284.f();
            }
          }
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(t) {
          this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t));
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._observedElements.clear(), _get(_getPrototypeOf(Hh.prototype), "destroy", this).call(this);
        }
      }]);

      return Hh;
    }(ur);

    function qh(t) {
      return function (n) {
        n.on("attribute:".concat(t, ":image"), e);
      };

      function e(t, e, n) {
        if (!n.consumable.consume(e.item, t.name)) return;
        var i = n.writer,
            o = n.mapper.toViewElement(e.item).getChild(0);
        null !== e.attributeNewValue ? i.setAttribute(e.attributeKey, e.attributeNewValue, o) : i.removeAttribute(e.attributeKey, o);
      }
    }

    var Wh = /*#__PURE__*/function () {
      function Wh() {
        _classCallCheck(this, Wh);

        this._stack = [];
      }

      _createClass(Wh, [{
        key: "add",
        value: function add(t, e) {
          var n = this._stack,
              i = n[0];

          this._insertDescriptor(t);

          var o = n[0];
          i === o || Yh(i, o) || this.fire("change:top", {
            oldDescriptor: i,
            newDescriptor: o,
            writer: e
          });
        }
      }, {
        key: "remove",
        value: function remove(t, e) {
          var n = this._stack,
              i = n[0];

          this._removeDescriptor(t);

          var o = n[0];
          i === o || Yh(i, o) || this.fire("change:top", {
            oldDescriptor: i,
            newDescriptor: o,
            writer: e
          });
        }
      }, {
        key: "_insertDescriptor",
        value: function _insertDescriptor(t) {
          var e = this._stack,
              n = e.findIndex(function (e) {
            return e.id === t.id;
          });
          if (Yh(t, e[n])) return;
          n > -1 && e.splice(n, 1);
          var i = 0;

          for (; e[i] && $h(e[i], t);) {
            i++;
          }

          e.splice(i, 0, t);
        }
      }, {
        key: "_removeDescriptor",
        value: function _removeDescriptor(t) {
          var e = this._stack,
              n = e.findIndex(function (e) {
            return e.id === t;
          });
          n > -1 && e.splice(n, 1);
        }
      }]);

      return Wh;
    }();

    function Yh(t, e) {
      return t && e && t.priority == e.priority && Gh(t.classes) == Gh(e.classes);
    }

    function $h(t, e) {
      return t.priority > e.priority || !(t.priority < e.priority) && Gh(t.classes) > Gh(e.classes);
    }

    function Gh(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }

    ci(Wh, ei);
    var Qh = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
    var Kh = "ck-widget",
        Jh = "ck-widget_selected";

    function Zh(t) {
      return !!t.is("element") && !!t.getCustomProperty("widget");
    }

    function Xh(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return mo.isEdge || e.setAttribute("contenteditable", "false", t), e.addClass(Kh, t), e.setCustomProperty("widget", !0, t), t.getFillerOffset = iu, n.label && function (t, e, n) {
        n.setCustomProperty("widgetLabel", e, t);
      }(t, n.label, e), n.hasSelectionHandler && function (t, e) {
        var n = e.createUIElement("div", {
          class: "ck ck-widget__selection-handler"
        }, function (t) {
          var e = this.toDomElement(t),
              n = new Hd();
          return n.set("content", Qh), n.render(), e.appendChild(n.element), e;
        });
        e.insert(e.createPositionAt(t, 0), n), e.addClass(["ck-widget_with-selection-handler"], t);
      }(t, e), function (t, e, n, i) {
        var o = new Wh();
        o.on("change:top", function (e, o) {
          o.oldDescriptor && i(t, o.oldDescriptor, o.writer), o.newDescriptor && n(t, o.newDescriptor, o.writer);
        }), e.setCustomProperty("addHighlight", function (t, e, n) {
          return o.add(e, n);
        }, t), e.setCustomProperty("removeHighlight", function (t, e, n) {
          return o.remove(e, n);
        }, t);
      }(t, e, function (t, e, n) {
        return n.addClass(i(e.classes), t);
      }, function (t, e, n) {
        return n.removeClass(i(e.classes), t);
      }), t;

      function i(t) {
        return Array.isArray(t) ? t : [t];
      }
    }

    function tu(t) {
      var e = t.getCustomProperty("widgetLabel");
      return e ? "function" == typeof e ? e() : e : "";
    }

    function eu(t, e) {
      return e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t), mo.isEdge || (e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t), t.on("change:isReadOnly", function (n, i, o) {
        e.setAttribute("contenteditable", o ? "false" : "true", t);
      })), t.on("change:isFocused", function (n, i, o) {
        o ? e.addClass("ck-editor__nested-editable_focused", t) : e.removeClass("ck-editor__nested-editable_focused", t);
      }), t;
    }

    function nu(t, e) {
      var n = t.getSelectedElement();
      if (n && e.schema.isBlock(n)) return e.createPositionAfter(n);
      var i = t.getSelectedBlocks().next().value;

      if (i) {
        if (i.isEmpty) return e.createPositionAt(i, 0);

        var _n198 = e.createPositionAfter(i);

        return t.focus.isTouching(_n198) ? _n198 : e.createPositionBefore(i);
      }

      return t.focus;
    }

    function iu() {
      return null;
    }

    function ou(t) {
      var e = t.getSelectedElement();
      return e && function (t) {
        return !!t.getCustomProperty("image") && Zh(t);
      }(e) ? e : null;
    }

    function ru(t) {
      return !!t && t.is("image");
    }

    function su(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.createElement("image", n),
          o = nu(e.document.selection, e);
      e.insertContent(i, o), i.parent && t.setSelection(i, "on");
    }

    function au(t) {
      var e = t.schema,
          n = t.document.selection;
      return function (t, e, n) {
        var i = function (t, e) {
          var n = nu(t, e).parent;
          if (n.isEmpty && !n.is("$root")) return n.parent;
          return n;
        }(t, n);

        return e.checkChild(i, "image");
      }(n, e, t) && !function (t, e) {
        var n = t.getSelectedElement();
        return n && e.isObject(n);
      }(n, e) && function (t) {
        return _toConsumableArray(t.focus.getAncestors()).every(function (t) {
          return !t.is("image");
        });
      }(n);
    }

    var cu = /*#__PURE__*/function (_ed9) {
      _inherits(cu, _ed9);

      var _super91 = _createSuper(cu);

      function cu() {
        _classCallCheck(this, cu);

        return _super91.apply(this, arguments);
      }

      _createClass(cu, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = au(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          e.change(function (n) {
            var i = Array.isArray(t.source) ? t.source : [t.source];

            var _iterator285 = _createForOfIteratorHelper(i),
                _step285;

            try {
              for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
                var _t225 = _step285.value;
                su(n, e, {
                  src: _t225
                });
              }
            } catch (err) {
              _iterator285.e(err);
            } finally {
              _iterator285.f();
            }
          });
        }
      }]);

      return cu;
    }(ed);

    var lu = /*#__PURE__*/function (_Kl24) {
      _inherits(lu, _Kl24);

      var _super92 = _createSuper(lu);

      function lu() {
        _classCallCheck(this, lu);

        return _super92.apply(this, arguments);
      }

      _createClass(lu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.t,
              i = t.conversion;
          t.editing.view.addObserver(Hh), e.register("image", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["alt", "src", "srcset"]
          }), i.for("dataDowncast").elementToElement({
            model: "image",
            view: function view(t, e) {
              return du(e);
            }
          }), i.for("editingDowncast").elementToElement({
            model: "image",
            view: function view(t, e) {
              return function (t, e, n) {
                return e.setCustomProperty("image", !0, t), Xh(t, e, {
                  label: function label() {
                    var e = t.getChild(0).getAttribute("alt");
                    return e ? "".concat(e, " ").concat(n) : n;
                  }
                });
              }(du(e), e, n("j"));
            }
          }), i.for("downcast").add(qh("src")).add(qh("alt")).add(function () {
            return function (e) {
              e.on("attribute:srcset:image", t);
            };

            function t(t, e, n) {
              if (!n.consumable.consume(e.item, t.name)) return;
              var i = n.writer,
                  o = n.mapper.toViewElement(e.item).getChild(0);

              if (null === e.attributeNewValue) {
                var _t226 = e.attributeOldValue;
                _t226.data && (i.removeAttribute("srcset", o), i.removeAttribute("sizes", o), _t226.width && i.removeAttribute("width", o));
              } else {
                var _t227 = e.attributeNewValue;
                _t227.data && (i.setAttribute("srcset", _t227.data, o), i.setAttribute("sizes", "100vw", o), _t227.width && i.setAttribute("width", _t227.width, o));
              }
            }
          }()), i.for("upcast").elementToElement({
            view: {
              name: "img",
              attributes: {
                src: !0
              }
            },
            model: function model(t, e) {
              return e.createElement("image", {
                src: t.getAttribute("src")
              });
            }
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "alt"
            },
            model: "alt"
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "srcset"
            },
            model: {
              key: "srcset",
              value: function value(t) {
                var e = {
                  data: t.getAttribute("srcset")
                };
                return t.hasAttribute("width") && (e.width = t.getAttribute("width")), e;
              }
            }
          }).add(function () {
            return function (e) {
              e.on("element:figure", t);
            };

            function t(t, e, n) {
              if (!n.consumable.test(e.viewItem, {
                name: !0,
                classes: "image"
              })) return;
              var i = Array.from(e.viewItem.getChildren()).find(function (t) {
                return t.is("img");
              });
              if (!i || !i.hasAttribute("src") || !n.consumable.test(i, {
                name: !0
              })) return;
              var o = n.convertItem(i, e.modelCursor),
                  r = vh(o.modelRange.getItems());
              r && (n.convertChildren(e.viewItem, n.writer.createPositionAt(r, 0)), e.modelRange = o.modelRange, e.modelCursor = o.modelCursor);
            }
          }()), t.commands.add("imageInsert", new cu(t));
        }
      }]);

      return lu;
    }(Kl);

    function du(t) {
      var e = t.createEmptyElement("img"),
          n = t.createContainerElement("figure", {
        class: "image"
      });
      return t.insert(t.createPositionAt(n, 0), e), n;
    }

    var hu = /*#__PURE__*/function (_ts6) {
      _inherits(hu, _ts6);

      var _super93 = _createSuper(hu);

      function hu(t) {
        var _this152;

        _classCallCheck(this, hu);

        _this152 = _super93.call(this, t), _this152.domEventType = "mousedown";
        return _this152;
      }

      _createClass(hu, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return hu;
    }(ts);

    n(36);
    var uu = ko("Ctrl+A");

    var fu = /*#__PURE__*/function (_Kl25) {
      _inherits(fu, _Kl25);

      var _super94 = _createSuper(fu);

      function fu() {
        _classCallCheck(this, fu);

        return _super94.apply(this, arguments);
      }

      _createClass(fu, [{
        key: "init",
        value: function init() {
          var _this153 = this;

          var t = this.editor.editing.view,
              e = t.document;
          this._previouslySelected = new Set(), this.editor.editing.downcastDispatcher.on("selection", function (t, e, n) {
            _this153._clearPreviouslySelectedWidgets(n.writer);

            var i = n.writer,
                o = i.document.selection,
                r = o.getSelectedElement();
            var s = null;

            var _iterator286 = _createForOfIteratorHelper(o.getRanges()),
                _step286;

            try {
              for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
                var _t228 = _step286.value;

                var _iterator287 = _createForOfIteratorHelper(_t228),
                    _step287;

                try {
                  for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
                    var _e218 = _step287.value;
                    var _t229 = _e218.item;
                    Zh(_t229) && !mu(_t229, s) && (i.addClass(Jh, _t229), _this153._previouslySelected.add(_t229), s = _t229, _t229 == r && i.setSelection(o.getRanges(), {
                      fake: !0,
                      label: tu(r)
                    }));
                  }
                } catch (err) {
                  _iterator287.e(err);
                } finally {
                  _iterator287.f();
                }
              }
            } catch (err) {
              _iterator286.e(err);
            } finally {
              _iterator286.f();
            }
          }, {
            priority: "low"
          }), t.addObserver(hu), this.listenTo(e, "mousedown", function () {
            return _this153._onMousedown.apply(_this153, arguments);
          }), this.listenTo(e, "keydown", function () {
            return _this153._onKeydown.apply(_this153, arguments);
          }, {
            priority: "high"
          }), this.listenTo(e, "delete", function (t, e) {
            _this153._handleDelete("forward" == e.direction) && (e.preventDefault(), t.stop());
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_onMousedown",
        value: function _onMousedown(t, e) {
          var n = this.editor,
              i = n.editing.view,
              o = i.document;
          var r = e.target;

          if (function (t) {
            for (; t;) {
              if (t.is("editableElement") && !t.is("rootElement")) return !0;
              if (Zh(t)) return !1;
              t = t.parent;
            }

            return !1;
          }(r)) {
            if (mo.isSafari && e.domEvent.detail >= 3) {
              var _t230 = n.editing.mapper.toModelElement(r);

              this.editor.model.change(function (n) {
                e.preventDefault(), n.setSelection(_t230, "in");
              });
            }

            return;
          }

          if (!Zh(r) && !(r = r.findAncestor(Zh))) return;
          e.preventDefault(), o.isFocused || i.focus();
          var s = n.editing.mapper.toModelElement(r);

          this._setSelectionOverElement(s);
        }
      }, {
        key: "_onKeydown",
        value: function _onKeydown(t, e) {
          var n = e.keyCode,
              i = n == bo.arrowdown || n == bo.arrowright;
          var o = !1;
          !function (t) {
            return t == bo.arrowright || t == bo.arrowleft || t == bo.arrowup || t == bo.arrowdown;
          }(n) ? !function (t) {
            return wo(t) == uu;
          }(e) ? n === bo.enter && (o = this._handleEnterKey(e.shiftKey)) : o = this._selectAllNestedEditableContent() || this._selectAllContent() : o = this._handleArrowKeys(i), o && (e.preventDefault(), t.stop());
        }
      }, {
        key: "_handleDelete",
        value: function _handleDelete(t) {
          var _this154 = this;

          if (this.editor.isReadOnly) return;
          var e = this.editor.model.document.selection;
          if (!e.isCollapsed) return;

          var n = this._getObjectElementNextToSelection(t);

          return n ? (this.editor.model.change(function (t) {
            var i = e.anchor.parent;

            for (; i.isEmpty;) {
              var _e219 = i;
              i = _e219.parent, t.remove(_e219);
            }

            _this154._setSelectionOverElement(n);
          }), !0) : void 0;
        }
      }, {
        key: "_handleArrowKeys",
        value: function _handleArrowKeys(t) {
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = i.getSelectedElement();

          if (o && n.isObject(o)) {
            var _o78 = t ? i.getLastPosition() : i.getFirstPosition(),
                _r36 = n.getNearestSelectionRange(_o78, t ? "forward" : "backward");

            return _r36 && e.change(function (t) {
              t.setSelection(_r36);
            }), !0;
          }

          if (!i.isCollapsed) return;

          var r = this._getObjectElementNextToSelection(t);

          return r && n.isObject(r) ? (this._setSelectionOverElement(r), !0) : void 0;
        }
      }, {
        key: "_handleEnterKey",
        value: function _handleEnterKey(t) {
          var e = this.editor.model,
              n = e.document.selection.getSelectedElement();
          if (function (t, e) {
            return t && e.isObject(t) && !e.isInline(t);
          }(n, e.schema)) return e.change(function (i) {
            var o = i.createPositionAt(n, t ? "before" : "after");
            var r = i.createElement("paragraph");

            if (e.schema.isBlock(n.parent)) {
              var _t231 = e.schema.findAllowedParent(o, r);

              o = i.split(o, _t231).position;
            }

            i.insert(r, o), i.setSelection(r, "in");
          }), !0;
        }
      }, {
        key: "_selectAllNestedEditableContent",
        value: function _selectAllNestedEditableContent() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema.getLimitElement(e);
          return e.getFirstRange().root != n && (t.change(function (t) {
            t.setSelection(t.createRangeIn(n));
          }), !0);
        }
      }, {
        key: "_selectAllContent",
        value: function _selectAllContent() {
          var t = this.editor.model,
              e = this.editor.editing,
              n = e.view.document.selection.getSelectedElement();

          if (n && Zh(n)) {
            var _i156 = e.mapper.toModelElement(n.parent);

            return t.change(function (t) {
              t.setSelection(t.createRangeIn(_i156));
            }), !0;
          }

          return !1;
        }
      }, {
        key: "_setSelectionOverElement",
        value: function _setSelectionOverElement(t) {
          this.editor.model.change(function (e) {
            e.setSelection(e.createRangeOn(t));
          });
        }
      }, {
        key: "_getObjectElementNextToSelection",
        value: function _getObjectElementNextToSelection(t) {
          var e = this.editor.model,
              n = e.schema,
              i = e.document.selection,
              o = e.createSelection(i);
          e.modifySelection(o, {
            direction: t ? "forward" : "backward"
          });
          var r = t ? o.focus.nodeBefore : o.focus.nodeAfter;
          return r && n.isObject(r) ? r : null;
        }
      }, {
        key: "_clearPreviouslySelectedWidgets",
        value: function _clearPreviouslySelectedWidgets(t) {
          var _iterator288 = _createForOfIteratorHelper(this._previouslySelected),
              _step288;

          try {
            for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
              var _e220 = _step288.value;
              t.removeClass(Jh, _e220);
            }
          } catch (err) {
            _iterator288.e(err);
          } finally {
            _iterator288.f();
          }

          this._previouslySelected.clear();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Widget";
        }
      }]);

      return fu;
    }(Kl);

    function mu(t, e) {
      return !!e && Array.from(t.getAncestors()).includes(e);
    }

    var gu = /*#__PURE__*/function (_ed10) {
      _inherits(gu, _ed10);

      var _super95 = _createSuper(gu);

      function gu() {
        _classCallCheck(this, gu);

        return _super95.apply(this, arguments);
      }

      _createClass(gu, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = ru(t), ru(t) && t.hasAttribute("alt") ? this.value = t.getAttribute("alt") : this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document.selection.getSelectedElement();
          e.change(function (e) {
            e.setAttribute("alt", t.newValue, n);
          });
        }
      }]);

      return gu;
    }(ed);

    var pu = /*#__PURE__*/function (_Kl26) {
      _inherits(pu, _Kl26);

      var _super96 = _createSuper(pu);

      function pu() {
        _classCallCheck(this, pu);

        return _super96.apply(this, arguments);
      }

      _createClass(pu, [{
        key: "init",
        value: function init() {
          this.editor.commands.add("imageTextAlternative", new gu(this.editor));
        }
      }]);

      return pu;
    }(Kl);

    function bu(_ref87) {
      var t = _ref87.emitter,
          e = _ref87.activator,
          n = _ref87.callback,
          i = _ref87.contextElements;
      t.listenTo(document, "mousedown", function (t, _ref88) {
        var o = _ref88.target;

        if (e()) {
          var _iterator289 = _createForOfIteratorHelper(i),
              _step289;

          try {
            for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
              var _t232 = _step289.value;
              if (_t232.contains(o)) return;
            }
          } catch (err) {
            _iterator289.e(err);
          } finally {
            _iterator289.f();
          }

          n();
        }
      });
    }

    n(38);

    var wu = /*#__PURE__*/function (_Dl10) {
      _inherits(wu, _Dl10);

      var _super97 = _createSuper(wu);

      function wu(t, e) {
        var _this155;

        _classCallCheck(this, wu);

        _this155 = _super97.call(this, t);
        var n = "ck-input-".concat(Jn()),
            i = "ck-status-".concat(Jn());
        _this155.set("label"), _this155.set("value"), _this155.set("isReadOnly", !1), _this155.set("errorText", null), _this155.set("infoText", null), _this155.labelView = _this155._createLabelView(n), _this155.inputView = _this155._createInputView(e, n, i), _this155.statusView = _this155._createStatusView(i), _this155.bind("_statusText").to(_assertThisInitialized(_this155), "errorText", _assertThisInitialized(_this155), "infoText", function (t, e) {
          return t || e;
        });
        var o = _this155.bindTemplate;

        _this155.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-input", o.if("isReadOnly", "ck-disabled")]
          },
          children: [_this155.labelView, _this155.inputView, _this155.statusView]
        });

        return _this155;
      }

      _createClass(wu, [{
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new jl(this.locale);
          return e.for = t, e.bind("text").to(this, "label"), e;
        }
      }, {
        key: "_createInputView",
        value: function _createInputView(t, e, n) {
          var _this156 = this;

          var i = new t(this.locale, n);
          return i.id = e, i.ariaDescribedById = n, i.bind("value").to(this), i.bind("isReadOnly").to(this), i.bind("hasError").to(this, "errorText", function (t) {
            return !!t;
          }), i.on("input", function () {
            _this156.errorText = null;
          }), i;
        }
      }, {
        key: "_createStatusView",
        value: function _createStatusView(t) {
          var e = new Dl(this.locale),
              n = this.bindTemplate;
          return e.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-input__status", n.if("errorText", "ck-labeled-input__status_error"), n.if("_statusText", "ck-hidden", function (t) {
                return !t;
              })],
              id: t,
              role: n.if("errorText", "alert")
            },
            children: [{
              text: n.to("_statusText")
            }]
          }), e;
        }
      }, {
        key: "select",
        value: function select() {
          this.inputView.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.inputView.focus();
        }
      }]);

      return wu;
    }(Dl);

    n(40);

    var ku = /*#__PURE__*/function (_Dl11) {
      _inherits(ku, _Dl11);

      var _super98 = _createSuper(ku);

      function ku(t) {
        var _this157;

        _classCallCheck(this, ku);

        _this157 = _super98.call(this, t), _this157.set("value"), _this157.set("id"), _this157.set("placeholder"), _this157.set("isReadOnly", !1), _this157.set("hasError", !1), _this157.set("ariaDescribedById");
        var e = _this157.bindTemplate;

        _this157.setTemplate({
          tag: "input",
          attributes: {
            type: "text",
            class: ["ck", "ck-input", "ck-input-text", e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", !0),
            "aria-describedby": e.to("ariaDescribedById")
          },
          on: {
            input: e.to("input")
          }
        });

        return _this157;
      }

      _createClass(ku, [{
        key: "render",
        value: function render() {
          var _this158 = this;

          _get(_getPrototypeOf(ku.prototype), "render", this).call(this);

          var t = function t(_t233) {
            _this158.element.value = _t233 || 0 === _t233 ? _t233 : "";
          };

          t(this.value), this.on("change:value", function (e, n, i) {
            t(i);
          });
        }
      }, {
        key: "select",
        value: function select() {
          this.element.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }]);

      return ku;
    }(Dl);

    function _u(_ref89) {
      var t = _ref89.view;
      t.listenTo(t.element, "submit", function (e, n) {
        n.preventDefault(), t.fire("submit");
      }, {
        useCapture: !0
      });
    }

    var vu = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>',
        yu = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
    n(42);

    var xu = /*#__PURE__*/function (_Dl12) {
      _inherits(xu, _Dl12);

      var _super99 = _createSuper(xu);

      function xu(t) {
        var _this159;

        _classCallCheck(this, xu);

        _this159 = _super99.call(this, t);
        var e = _this159.locale.t;
        _this159.focusTracker = new sl(), _this159.keystrokes = new Jc(), _this159.labeledInput = _this159._createLabeledInputView(), _this159.saveButtonView = _this159._createButton(e("bd"), vu, "ck-button-save"), _this159.saveButtonView.type = "submit", _this159.cancelButtonView = _this159._createButton(e("be"), yu, "ck-button-cancel", "cancel"), _this159._focusables = new gl(), _this159._focusCycler = new ql({
          focusables: _this159._focusables,
          focusTracker: _this159.focusTracker,
          keystrokeHandler: _this159.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this159.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form"],
            tabindex: "-1"
          },
          children: [_this159.labeledInput, _this159.saveButtonView, _this159.cancelButtonView]
        });
        return _this159;
      }

      _createClass(xu, [{
        key: "render",
        value: function render() {
          var _this160 = this;

          _get(_getPrototypeOf(xu.prototype), "render", this).call(this), this.keystrokes.listenTo(this.element), _u({
            view: this
          }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this160._focusables.add(t), _this160.focusTracker.add(t.element);
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new Wd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "_createLabeledInputView",
        value: function _createLabeledInputView() {
          var t = this.locale.t,
              e = new wu(this.locale, ku);
          return e.label = t("ca"), e.inputView.placeholder = t("ca"), e;
        }
      }]);

      return xu;
    }(Dl);

    function Au(_ref90) {
      var t = _ref90.element,
          e = _ref90.target,
          n = _ref90.positions,
          i = _ref90.limiter,
          o = _ref90.fitInViewport;
      W(e) && (e = e()), W(i) && (i = i());

      var r = function (t) {
        for (; t && "html" != t.tagName.toLowerCase();) {
          if ("static" != nr.window.getComputedStyle(t).position) return t;
          t = t.parentElement;
        }

        return null;
      }(t.parentElement),
          s = new As(t),
          a = new As(e);

      var c, l;

      if (i || o) {
        var _t234 = i && new As(i).getVisible(),
            _e221 = o && new As(nr.window);

        var _ref91 = function (t, e, n, i, o) {
          var r,
              s,
              a = 0,
              c = 0;
          var l = n.getArea();
          return t.some(function (t) {
            var _Tu = Tu(t, e, n),
                _Tu2 = _slicedToArray(_Tu, 2),
                d = _Tu2[0],
                h = _Tu2[1];

            var u, f;
            if (i) if (o) {
              var _t235 = i.getIntersection(o);

              u = _t235 ? _t235.getIntersectionArea(h) : 0;
            } else u = i.getIntersectionArea(h);

            function m() {
              c = f, a = u, r = h, s = d;
            }

            return o && (f = o.getIntersectionArea(h)), o && !i ? f > c && m() : !o && i ? u > a && m() : f > c && u >= a ? m() : f >= c && u > a && m(), u === l;
          }), r ? [s, r] : null;
        }(n, a, s, _t234, _e221) || Tu(n[0], a, s);

        var _ref92 = _slicedToArray(_ref91, 2);

        l = _ref92[0];
        c = _ref92[1];
      } else {
        var _Tu3 = Tu(n[0], a, s);

        var _Tu4 = _slicedToArray(_Tu3, 2);

        l = _Tu4[0];
        c = _Tu4[1];
      }

      var _Cu = Cu(c),
          d = _Cu.left,
          h = _Cu.top;

      if (r) {
        var _t236 = Cu(new As(r)),
            _e222 = ys(r);

        d -= _t236.left, h -= _t236.top, d += r.scrollLeft, h += r.scrollTop, d -= _e222.left, h -= _e222.top;
      }

      return {
        left: d,
        top: h,
        name: l
      };
    }

    function Tu(t, e, n) {
      var _t237 = t(e, n),
          i = _t237.left,
          o = _t237.top,
          r = _t237.name;

      return [r, n.clone().moveTo(i, o)];
    }

    function Cu(_ref93) {
      var t = _ref93.left,
          e = _ref93.top;
      var _nr$window2 = nr.window,
          n = _nr$window2.scrollX,
          i = _nr$window2.scrollY;
      return {
        left: t + n,
        top: e + i
      };
    }

    n(44);
    var Pu = Fl("px"),
        Su = nr.document.body;

    var Mu = /*#__PURE__*/function (_Dl13) {
      _inherits(Mu, _Dl13);

      var _super100 = _createSuper(Mu);

      function Mu(t) {
        var _this161;

        _classCallCheck(this, Mu);

        _this161 = _super100.call(this, t);
        var e = _this161.bindTemplate;
        _this161.set("top", 0), _this161.set("left", 0), _this161.set("position", "arrow_nw"), _this161.set("isVisible", !1), _this161.set("withArrow", !0), _this161.set("class"), _this161.content = _this161.createCollection(), _this161.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", e.to("position", function (t) {
              return "ck-balloon-panel_".concat(t);
            }), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
            style: {
              top: e.to("top", Pu),
              left: e.to("left", Pu)
            }
          },
          children: _this161.content
        });
        return _this161;
      }

      _createClass(Mu, [{
        key: "show",
        value: function show() {
          this.isVisible = !0;
        }
      }, {
        key: "hide",
        value: function hide() {
          this.isVisible = !1;
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          this.show();

          var e = Mu.defaultPositions,
              n = Object.assign({}, {
            element: this.element,
            positions: [e.southArrowNorth, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthWest, e.northArrowSouthEast],
            limiter: Su,
            fitInViewport: !0
          }, t),
              i = Mu._getOptimalPosition(n),
              o = parseInt(i.left),
              r = parseInt(i.top),
              s = i.name;

          Object.assign(this, {
            top: r,
            left: o,
            position: s
          });
        }
      }, {
        key: "pin",
        value: function pin(t) {
          var _this162 = this;

          this.unpin(), this._pinWhenIsVisibleCallback = function () {
            _this162.isVisible ? _this162._startPinning(t) : _this162._stopPinning();
          }, this._startPinning(t), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
      }, {
        key: "unpin",
        value: function unpin() {
          this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
        }
      }, {
        key: "_startPinning",
        value: function _startPinning(t) {
          var _this163 = this;

          this.attachTo(t);
          var e = Eu(t.target),
              n = t.limiter ? Eu(t.limiter) : Su;
          this.listenTo(nr.document, "scroll", function (i, o) {
            var r = o.target,
                s = e && r.contains(e),
                a = n && r.contains(n);
            !s && !a && e && n || _this163.attachTo(t);
          }, {
            useCapture: !0
          }), this.listenTo(nr.window, "resize", function () {
            _this163.attachTo(t);
          });
        }
      }, {
        key: "_stopPinning",
        value: function _stopPinning() {
          this.stopListening(nr.document, "scroll"), this.stopListening(nr.window, "resize");
        }
      }]);

      return Mu;
    }(Dl);

    function Eu(t) {
      return Wn(t) ? t : vs(t) ? t.commonAncestorContainer : "function" == typeof t ? Eu(t()) : null;
    }

    function Iu(t, e) {
      return t.top - e.height - Mu.arrowVerticalOffset;
    }

    function Nu(t) {
      return t.bottom + Mu.arrowVerticalOffset;
    }

    Mu.arrowHorizontalOffset = 25, Mu.arrowVerticalOffset = 10, Mu._getOptimalPosition = Au, Mu.defaultPositions = {
      northArrowSouth: function northArrowSouth(t, e) {
        return {
          top: Iu(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s"
        };
      },
      northArrowSouthEast: function northArrowSouthEast(t, e) {
        return {
          top: Iu(t, e),
          left: t.left + t.width / 2 - e.width + Mu.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northArrowSouthWest: function northArrowSouthWest(t, e) {
        return {
          top: Iu(t, e),
          left: t.left + t.width / 2 - Mu.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouth: function northWestArrowSouth(t, e) {
        return {
          top: Iu(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s"
        };
      },
      northWestArrowSouthWest: function northWestArrowSouthWest(t, e) {
        return {
          top: Iu(t, e),
          left: t.left - Mu.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouthEast: function northWestArrowSouthEast(t, e) {
        return {
          top: Iu(t, e),
          left: t.left - e.width + Mu.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouth: function northEastArrowSouth(t, e) {
        return {
          top: Iu(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s"
        };
      },
      northEastArrowSouthEast: function northEastArrowSouthEast(t, e) {
        return {
          top: Iu(t, e),
          left: t.right - e.width + Mu.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouthWest: function northEastArrowSouthWest(t, e) {
        return {
          top: Iu(t, e),
          left: t.right - Mu.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      southArrowNorth: function southArrowNorth(t, e) {
        return {
          top: Nu(t),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n"
        };
      },
      southArrowNorthEast: function southArrowNorthEast(t, e) {
        return {
          top: Nu(t),
          left: t.left + t.width / 2 - e.width + Mu.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southArrowNorthWest: function southArrowNorthWest(t, e) {
        return {
          top: Nu(t),
          left: t.left + t.width / 2 - Mu.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorth: function southWestArrowNorth(t, e) {
        return {
          top: Nu(t),
          left: t.left - e.width / 2,
          name: "arrow_n"
        };
      },
      southWestArrowNorthWest: function southWestArrowNorthWest(t, e) {
        return {
          top: Nu(t),
          left: t.left - Mu.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorthEast: function southWestArrowNorthEast(t, e) {
        return {
          top: Nu(t),
          left: t.left - e.width + Mu.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorth: function southEastArrowNorth(t, e) {
        return {
          top: Nu(t),
          left: t.right - e.width / 2,
          name: "arrow_n"
        };
      },
      southEastArrowNorthEast: function southEastArrowNorthEast(t, e) {
        return {
          top: Nu(t),
          left: t.right - e.width + Mu.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorthWest: function southEastArrowNorthWest(t, e) {
        return {
          top: Nu(t),
          left: t.right - Mu.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      }
    };
    var Ou = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z" /></svg>\n',
        Ru = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>\n';
    n(46), n(48);
    var Du = Fl("px");

    var Lu = /*#__PURE__*/function (_Kl27) {
      _inherits(Lu, _Kl27);

      var _super101 = _createSuper(Lu);

      function Lu(t) {
        var _this164;

        _classCallCheck(this, Lu);

        _this164 = _super101.call(this, t), _this164.positionLimiter = function () {
          var t = _this164.editor.editing.view,
              e = t.document.selection.editableElement;
          return e ? t.domConverter.mapViewToDom(e.root) : null;
        }, _this164.set("visibleView", null), _this164.view = new Mu(t.locale), t.ui.view.body.add(_this164.view), t.ui.focusTracker.add(_this164.view.element), _this164._viewToStack = new Map(), _this164._idToStack = new Map(), _this164.set("_numberOfStacks", 0), _this164.set("_singleViewMode", !1), _this164._rotatorView = _this164._createRotatorView(), _this164._fakePanelsView = _this164._createFakePanelsView();
        return _this164;
      }

      _createClass(Lu, [{
        key: "hasView",
        value: function hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t);
        }
      }, {
        key: "add",
        value: function add(t) {
          if (this.hasView(t.view)) throw new Gn.b("contextualballoon-add-view-exist: Cannot add configuration of the same view twice.", [this, t]);
          var e = t.stackId || "main";
          if (!this._idToStack.has(e)) return this._idToStack.set(e, new Map([[t.view, t]])), this._viewToStack.set(t.view, this._idToStack.get(e)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t.singleViewMode || this.showStack(e));

          var n = this._idToStack.get(e);

          t.singleViewMode && this.showStack(e), n.set(t.view, t), this._viewToStack.set(t.view, n), n === this._visibleStack && this._showView(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          if (!this.hasView(t)) throw new Gn.b("contextualballoon-remove-view-not-exist: Cannot remove the configuration of a non-existent view.", [this, t]);

          var e = this._viewToStack.get(t);

          this._singleViewMode && this.visibleView === t && (this._singleViewMode = !1), this.visibleView === t && (1 === e.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e.values())[e.size - 2])), 1 === e.size ? (this._idToStack.delete(this._getStackId(e)), this._numberOfStacks = this._idToStack.size) : e.delete(t), this._viewToStack.delete(t);
        }
      }, {
        key: "updatePosition",
        value: function updatePosition(t) {
          t && (this._visibleStack.get(this.visibleView).position = t), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
        }
      }, {
        key: "showStack",
        value: function showStack(t) {
          this.visibleStack = t;

          var e = this._idToStack.get(t);

          if (!e) throw new Gn.b("contextualballoon-showstack-stack-not-exist: Cannot show a stack that does not exist.", this);
          this._visibleStack !== e && this._showView(Array.from(e.values()).pop());
        }
      }, {
        key: "_visibleStack",
        get: function get() {
          return this._viewToStack.get(this.visibleView);
        }
      }, {
        key: "_getStackId",
        value: function _getStackId(t) {
          return Array.from(this._idToStack.entries()).find(function (e) {
            return e[1] === t;
          })[0];
        }
      }, {
        key: "_showNextStack",
        value: function _showNextStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) + 1;
          t[e] || (e = 0), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_showPrevStack",
        value: function _showPrevStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) - 1;
          t[e] || (e = t.length - 1), this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_createRotatorView",
        value: function _createRotatorView() {
          var _this165 = this;

          var t = new ju(this.editor.locale),
              e = this.editor.locale.t;
          return this.view.content.add(t), t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t > 1;
          }), t.on("change:isNavigationVisible", function () {
            return _this165.updatePosition();
          }, {
            priority: "low"
          }), t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (t, n) {
            if (n < 2) return "";
            var i = Array.from(_this165._idToStack.values()).indexOf(_this165._visibleStack) + 1;
            return e("bp", [i, n]);
          }), t.buttonNextView.on("execute", function () {
            t.focusTracker.isFocused && _this165.editor.editing.view.focus(), _this165._showNextStack();
          }), t.buttonPrevView.on("execute", function () {
            t.focusTracker.isFocused && _this165.editor.editing.view.focus(), _this165._showPrevStack();
          }), t;
        }
      }, {
        key: "_createFakePanelsView",
        value: function _createFakePanelsView() {
          var t = new Vu(this.editor.locale, this.view);
          return t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t >= 2 ? Math.min(t - 1, 2) : 0;
          }), t.listenTo(this.view, "change:top", function () {
            return t.updatePosition();
          }), t.listenTo(this.view, "change:left", function () {
            return t.updatePosition();
          }), this.editor.ui.view.body.add(t), t;
        }
      }, {
        key: "_showView",
        value: function _showView(_ref94) {
          var t = _ref94.view,
              _ref94$balloonClassNa = _ref94.balloonClassName,
              e = _ref94$balloonClassNa === void 0 ? "" : _ref94$balloonClassNa,
              _ref94$withArrow = _ref94.withArrow,
              n = _ref94$withArrow === void 0 ? !0 : _ref94$withArrow,
              _ref94$singleViewMode = _ref94.singleViewMode,
              i = _ref94$singleViewMode === void 0 ? !1 : _ref94$singleViewMode;
          this.view.class = e, this.view.withArrow = n, this._rotatorView.showView(t), this.visibleView = t, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), i && (this._singleViewMode = !0);
        }
      }, {
        key: "_getBalloonPosition",
        value: function _getBalloonPosition() {
          var t = Array.from(this._visibleStack.values()).pop().position;
          return t && !t.limiter && (t = Object.assign({}, t, {
            limiter: this.positionLimiter
          })), t;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ContextualBalloon";
        }
      }]);

      return Lu;
    }(Kl);

    var ju = /*#__PURE__*/function (_Dl14) {
      _inherits(ju, _Dl14);

      var _super102 = _createSuper(ju);

      function ju(t) {
        var _this166;

        _classCallCheck(this, ju);

        _this166 = _super102.call(this, t);
        var e = t.t,
            n = _this166.bindTemplate;
        _this166.set("isNavigationVisible", !0), _this166.focusTracker = new sl(), _this166.buttonPrevView = _this166._createButtonView(e("bq"), Ou), _this166.buttonNextView = _this166._createButtonView(e("br"), Ru), _this166.content = _this166.createCollection(), _this166.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", function (t) {
                return t ? "" : "ck-hidden";
              })]
            },
            children: [_this166.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, _this166.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: _this166.content
          }]
        });
        return _this166;
      }

      _createClass(ju, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(ju.prototype), "render", this).call(this), this.focusTracker.add(this.element);
        }
      }, {
        key: "showView",
        value: function showView(t) {
          this.hideView(), this.content.add(t);
        }
      }, {
        key: "hideView",
        value: function hideView() {
          this.content.clear();
        }
      }, {
        key: "_createButtonView",
        value: function _createButtonView(t, e) {
          var n = new Wd(this.locale);
          return n.set({
            label: t,
            icon: e,
            tooltip: !0
          }), n;
        }
      }]);

      return ju;
    }(Dl);

    var Vu = /*#__PURE__*/function (_Dl15) {
      _inherits(Vu, _Dl15);

      var _super103 = _createSuper(Vu);

      function Vu(t, e) {
        var _this167;

        _classCallCheck(this, Vu);

        _this167 = _super103.call(this, t);
        var n = _this167.bindTemplate;
        _this167.set("top", 0), _this167.set("left", 0), _this167.set("height", 0), _this167.set("width", 0), _this167.set("numberOfPanels", 0), _this167.content = _this167.createCollection(), _this167._balloonPanelView = e, _this167.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", function (t) {
              return t ? "" : "ck-hidden";
            })],
            style: {
              top: n.to("top", Du),
              left: n.to("left", Du),
              width: n.to("width", Du),
              height: n.to("height", Du)
            }
          },
          children: _this167.content
        }), _this167.on("change:numberOfPanels", function (t, e, n, i) {
          n > i ? _this167._addPanels(n - i) : _this167._removePanels(i - n), _this167.updatePosition();
        });
        return _this167;
      }

      _createClass(Vu, [{
        key: "_addPanels",
        value: function _addPanels(t) {
          for (; t--;) {
            var _t238 = new Dl();

            _t238.setTemplate({
              tag: "div"
            }), this.content.add(_t238), this.registerChild(_t238);
          }
        }
      }, {
        key: "_removePanels",
        value: function _removePanels(t) {
          for (; t--;) {
            var _t239 = this.content.last;
            this.content.remove(_t239), this.deregisterChild(_t239), _t239.destroy();
          }
        }
      }, {
        key: "updatePosition",
        value: function updatePosition() {
          if (this.numberOfPanels) {
            var _this$_balloonPanelVi = this._balloonPanelView,
                _t240 = _this$_balloonPanelVi.top,
                _e223 = _this$_balloonPanelVi.left,
                _As = new As(this._balloonPanelView.element),
                _n199 = _As.width,
                _i157 = _As.height;

            Object.assign(this, {
              top: _t240,
              left: _e223,
              width: _n199,
              height: _i157
            });
          }
        }
      }]);

      return Vu;
    }(Dl);

    var zu = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';

    function Bu(t) {
      var e = t.editing.view,
          n = Mu.defaultPositions;
      return {
        target: e.domConverter.viewToDom(e.document.selection.getSelectedElement()),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast]
      };
    }

    var Fu = /*#__PURE__*/function (_Kl28) {
      _inherits(Fu, _Kl28);

      var _super104 = _createSuper(Fu);

      function Fu() {
        _classCallCheck(this, Fu);

        return _super104.apply(this, arguments);
      }

      _createClass(Fu, [{
        key: "init",
        value: function init() {
          this._createButton(), this._createForm();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Fu.prototype), "destroy", this).call(this), this._form.destroy();
        }
      }, {
        key: "_createButton",
        value: function _createButton() {
          var _this168 = this;

          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("imageTextAlternative", function (n) {
            var i = t.commands.get("imageTextAlternative"),
                o = new Wd(n);
            return o.set({
              label: e("bs"),
              icon: zu,
              tooltip: !0
            }), o.bind("isEnabled").to(i, "isEnabled"), _this168.listenTo(o, "execute", function () {
              return _this168._showForm();
            }), o;
          });
        }
      }, {
        key: "_createForm",
        value: function _createForm() {
          var _this169 = this;

          var t = this.editor,
              e = t.editing.view.document;
          this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new xu(t.locale), this._form.render(), this.listenTo(this._form, "submit", function () {
            t.execute("imageTextAlternative", {
              newValue: _this169._form.labeledInput.inputView.element.value
            }), _this169._hideForm(!0);
          }), this.listenTo(this._form, "cancel", function () {
            _this169._hideForm(!0);
          }), this._form.keystrokes.set("Esc", function (t, e) {
            _this169._hideForm(!0), e();
          }), this.listenTo(t.ui, "update", function () {
            ou(e.selection) ? _this169._isVisible && function (t) {
              var e = t.plugins.get("ContextualBalloon");

              if (ou(t.editing.view.document.selection)) {
                var _n200 = Bu(t);

                e.updatePosition(_n200);
              }
            }(t) : _this169._hideForm(!0);
          }), bu({
            emitter: this._form,
            activator: function activator() {
              return _this169._isVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this169._hideForm();
            }
          });
        }
      }, {
        key: "_showForm",
        value: function _showForm() {
          if (this._isVisible) return;
          var t = this.editor,
              e = t.commands.get("imageTextAlternative"),
              n = this._form.labeledInput;
          this._isInBalloon || this._balloon.add({
            view: this._form,
            position: Bu(t)
          }), n.value = n.inputView.element.value = e.value || "", this._form.labeledInput.select();
        }
      }, {
        key: "_hideForm",
        value: function _hideForm(t) {
          this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t && this.editor.editing.view.focus());
        }
      }, {
        key: "_isVisible",
        get: function get() {
          return this._balloon.visibleView === this._form;
        }
      }, {
        key: "_isInBalloon",
        get: function get() {
          return this._balloon.hasView(this._form);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Lu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeUI";
        }
      }]);

      return Fu;
    }(Kl);

    var Uu = /*#__PURE__*/function (_Kl29) {
      _inherits(Uu, _Kl29);

      var _super105 = _createSuper(Uu);

      function Uu() {
        _classCallCheck(this, Uu);

        return _super105.apply(this, arguments);
      }

      _createClass(Uu, null, [{
        key: "requires",
        get: function get() {
          return [pu, Fu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternative";
        }
      }]);

      return Uu;
    }(Kl);

    n(50);

    var Hu = /*#__PURE__*/function (_Kl30) {
      _inherits(Hu, _Kl30);

      var _super106 = _createSuper(Hu);

      function Hu() {
        _classCallCheck(this, Hu);

        return _super106.apply(this, arguments);
      }

      _createClass(Hu, null, [{
        key: "requires",
        get: function get() {
          return [lu, fu, Uu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Image";
        }
      }]);

      return Hu;
    }(Kl);

    var qu = /*#__PURE__*/function (_Dl16) {
      _inherits(qu, _Dl16);

      var _super107 = _createSuper(qu);

      function qu(t) {
        var _this170;

        _classCallCheck(this, qu);

        _this170 = _super107.call(this, t), _this170.buttonView = new Wd(t), _this170._fileInputView = new Wu(t), _this170._fileInputView.bind("acceptedType").to(_assertThisInitialized(_this170)), _this170._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_this170)), _this170._fileInputView.delegate("done").to(_assertThisInitialized(_this170)), _this170.setTemplate({
          tag: "span",
          attributes: {
            class: "ck-file-dialog-button"
          },
          children: [_this170.buttonView, _this170._fileInputView]
        }), _this170.buttonView.on("execute", function () {
          _this170._fileInputView.open();
        });
        return _this170;
      }

      _createClass(qu, [{
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);

      return qu;
    }(Dl);

    var Wu = /*#__PURE__*/function (_Dl17) {
      _inherits(Wu, _Dl17);

      var _super108 = _createSuper(Wu);

      function Wu(t) {
        var _this171;

        _classCallCheck(this, Wu);

        _this171 = _super108.call(this, t), _this171.set("acceptedType"), _this171.set("allowMultipleFiles", !1);
        var e = _this171.bindTemplate;

        _this171.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(function () {
              _this171.element && _this171.element.files && _this171.element.files.length && _this171.fire("done", _this171.element.files), _this171.element.value = "";
            })
          }
        });

        return _this171;
      }

      _createClass(Wu, [{
        key: "open",
        value: function open() {
          this.element.click();
        }
      }]);

      return Wu;
    }(Dl);

    var Yu = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';

    function $u(t) {
      return /^image\/(jpeg|png|gif|bmp)$/.test(t.type);
    }

    function Gu(t) {
      return new Promise(function (e, n) {
        var i = t.getAttribute("src");
        fetch(i).then(function (t) {
          return t.blob();
        }).then(function (t) {
          var o = function (t, e) {
            return t.type ? t.type : e.match(/data:(image\/\w+);base64/) ? e.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
          }(t, i),
              r = function (t, e, n) {
            try {
              return new File([t], e, {
                type: n
              });
            } catch (t) {
              return null;
            }
          }(t, "image.".concat(o.replace("image/", "")), o);

          r ? e(r) : n();
        }).catch(n);
      });
    }

    var Qu = /*#__PURE__*/function (_Kl31) {
      _inherits(Qu, _Kl31);

      var _super109 = _createSuper(Qu);

      function Qu() {
        _classCallCheck(this, Qu);

        return _super109.apply(this, arguments);
      }

      _createClass(Qu, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.t;
          t.ui.componentFactory.add("imageUpload", function (n) {
            var i = new qu(n),
                o = t.commands.get("imageUpload");
            return i.set({
              acceptedType: "image/*",
              allowMultipleFiles: !0
            }), i.buttonView.set({
              label: e("p"),
              icon: Yu,
              tooltip: !0
            }), i.buttonView.bind("isEnabled").to(o), i.on("done", function (e, n) {
              var i = Array.from(n).filter($u);
              i.length && t.execute("imageUpload", {
                file: i
              });
            }), i;
          });
        }
      }]);

      return Qu;
    }(Kl);

    var Ku = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
    n(52), n(54), n(56);

    var Ju = /*#__PURE__*/function (_Kl32) {
      _inherits(Ju, _Kl32);

      var _super110 = _createSuper(Ju);

      function Ju(t) {
        var _this172;

        _classCallCheck(this, Ju);

        _this172 = _super110.call(this, t), _this172.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent(Ku);
        return _this172;
      }

      _createClass(Ju, [{
        key: "init",
        value: function init() {
          var _this173 = this;

          this.editor.editing.downcastDispatcher.on("attribute:uploadStatus:image", function () {
            return _this173.uploadStatusChange.apply(_this173, arguments);
          });
        }
      }, {
        key: "uploadStatusChange",
        value: function uploadStatusChange(t, e, n) {
          var i = this.editor,
              o = e.item,
              r = o.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) return;
          var s = i.plugins.get(Zd),
              a = r ? e.attributeNewValue : null,
              c = this.placeholder,
              l = i.editing.mapper.toViewElement(o),
              d = n.writer;
          if ("reading" == a) return Zu(l, d), void Xu(c, l, d);

          if ("uploading" == a) {
            var _t241 = s.loaders.get(r);

            return Zu(l, d), void (_t241 ? (tf(l, d), function (t, e, n, i) {
              var o = function (t) {
                var e = t.createUIElement("div", {
                  class: "ck-progress-bar"
                });
                return t.setCustomProperty("progressBar", !0, e), e;
              }(e);

              e.insert(e.createPositionAt(t, "end"), o), n.on("change:uploadedPercent", function (t, e, n) {
                i.change(function (t) {
                  t.setStyle("width", n + "%", o);
                });
              });
            }(l, d, _t241, i.editing.view), function (t, e, n) {
              if (n.data) {
                var _i158 = t.getChild(0);

                e.setAttribute("src", n.data, _i158);
              }
            }(l, d, _t241)) : Xu(c, l, d));
          }

          "complete" == a && s.loaders.get(r) && !mo.isEdge && function (t, e, n) {
            var i = e.createUIElement("div", {
              class: "ck-image-upload-complete-icon"
            });
            e.insert(e.createPositionAt(t, "end"), i), setTimeout(function () {
              n.change(function (t) {
                return t.remove(t.createRangeOn(i));
              });
            }, 3e3);
          }(l, d, i.editing.view), function (t, e) {
            nf(t, e, "progressBar");
          }(l, d), tf(l, d), function (t, e) {
            e.removeClass("ck-appear", t);
          }(l, d);
        }
      }]);

      return Ju;
    }(Kl);

    function Zu(t, e) {
      t.hasClass("ck-appear") || e.addClass("ck-appear", t);
    }

    function Xu(t, e, n) {
      e.hasClass("ck-image-upload-placeholder") || n.addClass("ck-image-upload-placeholder", e);
      var i = e.getChild(0);
      i.getAttribute("src") !== t && n.setAttribute("src", t, i), ef(e, "placeholder") || n.insert(n.createPositionAfter(i), function (t) {
        var e = t.createUIElement("div", {
          class: "ck-upload-placeholder-loader"
        });
        return t.setCustomProperty("placeholder", !0, e), e;
      }(n));
    }

    function tf(t, e) {
      t.hasClass("ck-image-upload-placeholder") && e.removeClass("ck-image-upload-placeholder", t), nf(t, e, "placeholder");
    }

    function ef(t, e) {
      var _iterator290 = _createForOfIteratorHelper(t.getChildren()),
          _step290;

      try {
        for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
          var _n201 = _step290.value;
          if (_n201.getCustomProperty(e)) return _n201;
        }
      } catch (err) {
        _iterator290.e(err);
      } finally {
        _iterator290.f();
      }
    }

    function nf(t, e, n) {
      var i = ef(t, n);
      i && e.remove(e.createRangeOn(i));
    }

    var of = /*#__PURE__*/function () {
      function of() {
        _classCallCheck(this, of);
      }

      _createClass(of, [{
        key: "createDocumentFragment",
        value: function createDocumentFragment(t) {
          return new Ao(t);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e, n) {
          return new ki(t, e, n);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new fi(t);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
          return t._clone(e);
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, e) {
          return e._appendChild(t);
        }
      }, {
        key: "insertChild",
        value: function insertChild(t, e, n) {
          return n._insertChild(t, e);
        }
      }, {
        key: "removeChildren",
        value: function removeChildren(t, e, n) {
          return n._removeChildren(t, e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t.parent;
          return e ? this.removeChildren(e.getChildIndex(t), 1, e) : [];
        }
      }, {
        key: "replace",
        value: function replace(t, e) {
          var n = t.parent;

          if (n) {
            var _i159 = n.getChildIndex(t);

            return this.removeChildren(_i159, 1, n), this.insertChild(_i159, e, n), !0;
          }

          return !1;
        }
      }, {
        key: "unwrapElement",
        value: function unwrapElement(t) {
          var e = t.parent;

          if (e) {
            var _n202 = e.getChildIndex(t);

            this.remove(t), this.insertChild(_n202, t.getChildren(), e);
          }
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new ki(t, e.getAttributes(), e.getChildren());
          return this.replace(e, n) ? n : null;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          T(t) && void 0 === n && (n = e), n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zi._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zi._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zi._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new Xi(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return Xi._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return Xi._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new no(t, e, n);
        }
      }]);

      return of;
    }();

    var rf = /*#__PURE__*/function (_ed11) {
      _inherits(rf, _ed11);

      var _super111 = _createSuper(rf);

      function rf() {
        _classCallCheck(this, rf);

        return _super111.apply(this, arguments);
      }

      _createClass(rf, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = au(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor,
              n = e.model,
              i = e.plugins.get(Zd);
          n.change(function (e) {
            var o = Array.isArray(t.file) ? t.file : [t.file];

            var _iterator291 = _createForOfIteratorHelper(o),
                _step291;

            try {
              for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
                var _t242 = _step291.value;
                sf(e, n, i, _t242);
              }
            } catch (err) {
              _iterator291.e(err);
            } finally {
              _iterator291.f();
            }
          });
        }
      }]);

      return rf;
    }(ed);

    function sf(t, e, n, i) {
      var o = n.createLoader(i);
      o && su(t, e, {
        uploadId: o.id
      });
    }

    var af = /*#__PURE__*/function (_Kl33) {
      _inherits(af, _Kl33);

      var _super112 = _createSuper(af);

      function af() {
        _classCallCheck(this, af);

        return _super112.apply(this, arguments);
      }

      _createClass(af, [{
        key: "init",
        value: function init() {
          var _this174 = this;

          var t = this.editor,
              e = t.model.document,
              n = t.model.schema,
              i = t.conversion,
              o = t.plugins.get(Zd);
          n.extend("image", {
            allowAttributes: ["uploadId", "uploadStatus"]
          }), t.commands.add("imageUpload", new rf(t)), i.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "uploadId"
            },
            model: "uploadId"
          }), this.listenTo(t.editing.view.document, "clipboardInput", function (e, n) {
            if (function (t) {
              return Array.from(t.types).includes("text/html") && "" !== t.getData("text/html");
            }(n.dataTransfer)) return;
            var i = Array.from(n.dataTransfer.files).filter(function (t) {
              return !!t && $u(t);
            }),
                o = n.targetRanges.map(function (e) {
              return t.editing.mapper.toModelRange(e);
            });
            t.model.change(function (n) {
              n.setSelection(o), i.length && (e.stop(), t.model.enqueueChange("default", function () {
                t.execute("imageUpload", {
                  file: i
                });
              }));
            });
          }), t.plugins.has("Clipboard") && this.listenTo(t.plugins.get("Clipboard"), "inputTransformation", function (e, n) {
            var i = Array.from(t.editing.view.createRangeIn(n.content)).filter(function (t) {
              return function (t) {
                return !(!t.is("element", "img") || !t.getAttribute("src")) && (t.getAttribute("src").match(/^data:image\/\w+;base64,/g) || t.getAttribute("src").match(/^blob:/g));
              }(t.item) && !t.item.getAttribute("uploadProcessed");
            }).map(function (t) {
              return {
                promise: Gu(t.item),
                imageElement: t.item
              };
            });
            if (!i.length) return;
            var r = new of();

            var _iterator292 = _createForOfIteratorHelper(i),
                _step292;

            try {
              for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
                var _t243 = _step292.value;
                r.setAttribute("uploadProcessed", !0, _t243.imageElement);

                var _e224 = o.createLoader(_t243.promise);

                _e224 && (r.setAttribute("src", "", _t243.imageElement), r.setAttribute("uploadId", _e224.id, _t243.imageElement));
              }
            } catch (err) {
              _iterator292.e(err);
            } finally {
              _iterator292.f();
            }
          }), t.editing.view.document.on("dragover", function (t, e) {
            e.preventDefault();
          }), e.on("change", function () {
            var n = e.differ.getChanges({
              includeChangesInGraveyard: !0
            });

            var _iterator293 = _createForOfIteratorHelper(n),
                _step293;

            try {
              for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
                var _e225 = _step293.value;

                if ("insert" == _e225.type && "$text" != _e225.name) {
                  var _n203 = _e225.position.nodeAfter,
                      _i160 = "$graveyard" == _e225.position.root.rootName;

                  var _iterator294 = _createForOfIteratorHelper(cf(t, _n203)),
                      _step294;

                  try {
                    for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
                      var _e226 = _step294.value;

                      var _t244 = _e226.getAttribute("uploadId");

                      if (!_t244) continue;

                      var _n204 = o.loaders.get(_t244);

                      _n204 && (_i160 ? _n204.abort() : "idle" == _n204.status && _this174._readAndUpload(_n204, _e226));
                    }
                  } catch (err) {
                    _iterator294.e(err);
                  } finally {
                    _iterator294.f();
                  }
                }
              }
            } catch (err) {
              _iterator293.e(err);
            } finally {
              _iterator293.f();
            }
          });
        }
      }, {
        key: "_readAndUpload",
        value: function _readAndUpload(t, e) {
          var _this175 = this;

          var n = this.editor,
              i = n.model,
              o = n.locale.t,
              r = n.plugins.get(Zd),
              s = n.plugins.get(Ih);
          return i.enqueueChange("transparent", function (t) {
            t.setAttribute("uploadStatus", "reading", e);
          }), t.read().then(function () {
            var o = t.upload();

            if (mo.isSafari) {
              var _t245 = n.editing.mapper.toViewElement(e).getChild(0);

              n.editing.view.once("render", function () {
                if (!_t245.parent) return;
                var e = n.editing.view.domConverter.mapViewToDom(_t245.parent);
                if (!e) return;
                var i = e.style.display;
                e.style.display = "none", e._ckHack = e.offsetHeight, e.style.display = i;
              });
            }

            return i.enqueueChange("transparent", function (t) {
              t.setAttribute("uploadStatus", "uploading", e);
            }), o;
          }).then(function (t) {
            i.enqueueChange("transparent", function (n) {
              n.setAttributes({
                uploadStatus: "complete",
                src: t.default
              }, e), _this175._parseAndSetSrcsetAttributeOnImage(t, e, n);
            }), a();
          }).catch(function (n) {
            if ("error" !== t.status && "aborted" !== t.status) throw n;
            "error" == t.status && n && s.showWarning(n, {
              title: o("al"),
              namespace: "upload"
            }), a(), i.enqueueChange("transparent", function (t) {
              t.remove(e);
            });
          });

          function a() {
            i.enqueueChange("transparent", function (t) {
              t.removeAttribute("uploadId", e), t.removeAttribute("uploadStatus", e);
            }), r.destroyLoader(t);
          }
        }
      }, {
        key: "_parseAndSetSrcsetAttributeOnImage",
        value: function _parseAndSetSrcsetAttributeOnImage(t, e, n) {
          var i = 0;
          var o = Object.keys(t).filter(function (t) {
            var e = parseInt(t, 10);
            if (!isNaN(e)) return i = Math.max(i, e), !0;
          }).map(function (e) {
            return "".concat(t[e], " ").concat(e, "w");
          }).join(", ");
          "" != o && n.setAttribute("srcset", {
            data: o,
            width: i
          }, e);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Zd, Ih];
        }
      }]);

      return af;
    }(Kl);

    function cf(t, e) {
      return Array.from(t.model.createRangeOn(e)).filter(function (t) {
        return t.item.is("image");
      }).map(function (t) {
        return t.item;
      });
    }

    var lf = /*#__PURE__*/function (_Kl34) {
      _inherits(lf, _Kl34);

      var _super113 = _createSuper(lf);

      function lf() {
        _classCallCheck(this, lf);

        return _super113.apply(this, arguments);
      }

      _createClass(lf, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUpload";
        }
      }, {
        key: "requires",
        get: function get() {
          return [af, Qu, Ju];
        }
      }]);

      return lf;
    }(Kl);

    var df = /*#__PURE__*/function (_ed12) {
      _inherits(df, _ed12);

      var _super114 = _createSuper(df);

      function df() {
        _classCallCheck(this, df);

        return _super114.apply(this, arguments);
      }

      _createClass(df, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = vh(t.document.selection.getSelectedBlocks());
          this.value = !!e && e.is("paragraph"), this.isEnabled = !!e && hf(e, t.schema);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document;
          e.change(function (i) {
            var o = (t.selection || n.selection).getSelectedBlocks();

            var _iterator295 = _createForOfIteratorHelper(o),
                _step295;

            try {
              for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
                var _t246 = _step295.value;
                !_t246.is("paragraph") && hf(_t246, e.schema) && i.rename(_t246, "paragraph");
              }
            } catch (err) {
              _iterator295.e(err);
            } finally {
              _iterator295.f();
            }
          });
        }
      }]);

      return df;
    }(ed);

    function hf(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }

    var uf = /*#__PURE__*/function (_Kl35) {
      _inherits(uf, _Kl35);

      var _super115 = _createSuper(uf);

      function uf() {
        _classCallCheck(this, uf);

        return _super115.apply(this, arguments);
      }

      _createClass(uf, [{
        key: "init",
        value: function init() {
          var _this176 = this;

          var t = this.editor,
              e = t.model,
              n = t.data;
          t.commands.add("paragraph", new df(t)), e.schema.register("paragraph", {
            inheritAllFrom: "$block"
          }), t.conversion.elementToElement({
            model: "paragraph",
            view: "p"
          }), t.conversion.for("upcast").elementToElement({
            model: function model(t, e) {
              return uf.paragraphLikeElements.has(t.name) ? t.isEmpty ? null : e.createElement("paragraph") : null;
            },
            converterPriority: "low"
          }), n.upcastDispatcher.on("element", function (t, e, n) {
            n.consumable.test(e.viewItem, {
              name: e.viewItem.name
            }) && mf(e.viewItem, e.modelCursor, n.schema) && Object.assign(e, ff(e.viewItem, e.modelCursor, n));
          }, {
            priority: "low"
          }), n.upcastDispatcher.on("text", function (t, e, n) {
            e.modelRange || mf(e.viewItem, e.modelCursor, n.schema) && Object.assign(e, ff(e.viewItem, e.modelCursor, n));
          }, {
            priority: "lowest"
          }), e.document.registerPostFixer(function (t) {
            return _this176._autoparagraphEmptyRoots(t);
          }), t.data.on("ready", function () {
            e.enqueueChange("transparent", function (t) {
              return _this176._autoparagraphEmptyRoots(t);
            });
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "_autoparagraphEmptyRoots",
        value: function _autoparagraphEmptyRoots(t) {
          var e = this.editor.model;

          var _iterator296 = _createForOfIteratorHelper(e.document.getRootNames()),
              _step296;

          try {
            for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
              var _n205 = _step296.value;

              var _i161 = e.document.getRoot(_n205);

              if (_i161.isEmpty && "$graveyard" != _i161.rootName && e.schema.checkChild(_i161, "paragraph")) return t.insertElement("paragraph", _i161), !0;
            }
          } catch (err) {
            _iterator296.e(err);
          } finally {
            _iterator296.f();
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Paragraph";
        }
      }]);

      return uf;
    }(Kl);

    function ff(t, e, n) {
      var i = n.writer.createElement("paragraph");
      return n.writer.insert(i, e), n.convertItem(t, n.writer.createPositionAt(i, 0));
    }

    function mf(t, e, n) {
      var i = n.createContext(e);
      return !!n.checkChild(i, "paragraph") && !!n.checkChild(i.push("paragraph"), t);
    }

    uf.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td"]);

    var gf = /*#__PURE__*/function (_ed13) {
      _inherits(gf, _ed13);

      var _super116 = _createSuper(gf);

      function gf(t, e) {
        var _this177;

        _classCallCheck(this, gf);

        _this177 = _super116.call(this, t), _this177.modelElements = e;
        return _this177;
      }

      _createClass(gf, [{
        key: "refresh",
        value: function refresh() {
          var _this178 = this;

          var t = vh(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!t && this.modelElements.includes(t.name) && t.name, this.isEnabled = !!t && this.modelElements.some(function (e) {
            return pf(t, e, _this178.editor.model.schema);
          });
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document,
              i = t.value;
          e.change(function (t) {
            var o = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return pf(t, i, e.schema);
            });

            var _iterator297 = _createForOfIteratorHelper(o),
                _step297;

            try {
              for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
                var _e227 = _step297.value;
                _e227.is(i) || t.rename(_e227, i);
              }
            } catch (err) {
              _iterator297.e(err);
            } finally {
              _iterator297.f();
            }
          });
        }
      }]);

      return gf;
    }(ed);

    function pf(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }

    var bf = "paragraph";

    var wf = /*#__PURE__*/function (_Kl36) {
      _inherits(wf, _Kl36);

      var _super117 = _createSuper(wf);

      function wf(t) {
        var _this179;

        _classCallCheck(this, wf);

        _this179 = _super117.call(this, t), t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
        return _this179;
      }

      _createClass(wf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.config.get("heading.options"),
              n = [];

          var _iterator298 = _createForOfIteratorHelper(e),
              _step298;

          try {
            for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
              var _i162 = _step298.value;
              _i162.model !== bf && (t.model.schema.register(_i162.model, {
                inheritAllFrom: "$block"
              }), t.conversion.elementToElement(_i162), n.push(_i162.model));
            }
          } catch (err) {
            _iterator298.e(err);
          } finally {
            _iterator298.f();
          }

          this._addDefaultH1Conversion(t), t.commands.add("heading", new gf(t, n));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.commands.get("enter"),
              n = t.config.get("heading.options");
          e && this.listenTo(e, "afterExecute", function (e, i) {
            var o = t.model.document.selection.getFirstPosition().parent;
            n.some(function (t) {
              return o.is(t.model);
            }) && !o.is(bf) && 0 === o.childCount && i.writer.rename(o, bf);
          });
        }
      }, {
        key: "_addDefaultH1Conversion",
        value: function _addDefaultH1Conversion(t) {
          t.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: Zn.get("low") + 1
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [uf];
        }
      }]);

      return wf;
    }(Kl);

    var kf = function kf(t, e) {
      _classCallCheck(this, kf);

      e && Li(this, e), t && this.set(t);
    };

    ci(kf, Fi);

    var _f = /*#__PURE__*/function (_Dl18) {
      _inherits(_f, _Dl18);

      var _super118 = _createSuper(_f);

      function _f(t) {
        var _this180;

        _classCallCheck(this, _f);

        _this180 = _super118.call(this, t);
        var e = _this180.bindTemplate;
        _this180.set("isVisible", !1), _this180.set("position", "se"), _this180.children = _this180.createCollection(), _this180.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", function (t) {
              return "ck-dropdown__panel_".concat(t);
            }), e.if("isVisible", "ck-dropdown__panel-visible")]
          },
          children: _this180.children,
          on: {
            selectstart: e.to(function (t) {
              return t.preventDefault();
            })
          }
        });
        return _this180;
      }

      _createClass(_f, [{
        key: "focus",
        value: function focus() {
          this.children.length && this.children.first.focus();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          if (this.children.length) {
            var _t247 = this.children.last;
            "function" == typeof _t247.focusLast ? _t247.focusLast() : _t247.focus();
          }
        }
      }]);

      return _f;
    }(Dl);

    n(58);

    var vf = /*#__PURE__*/function (_Dl19) {
      _inherits(vf, _Dl19);

      var _super119 = _createSuper(vf);

      function vf(t, e, n) {
        var _this181;

        _classCallCheck(this, vf);

        _this181 = _super119.call(this, t);
        var i = _this181.bindTemplate;
        _this181.buttonView = e, _this181.panelView = n, _this181.set("isOpen", !1), _this181.set("isEnabled", !0), _this181.set("class"), _this181.set("panelPosition", "auto"), _this181.focusTracker = new sl(), _this181.keystrokes = new Jc(), _this181.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", i.to("class"), i.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            })]
          },
          children: [e, n]
        }), e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"]
          }
        });
        return _this181;
      }

      _createClass(vf, [{
        key: "render",
        value: function render() {
          var _this182 = this;

          _get(_getPrototypeOf(vf.prototype), "render", this).call(this), this.listenTo(this.buttonView, "open", function () {
            _this182.isOpen = !_this182.isOpen;
          }), this.panelView.bind("isVisible").to(this, "isOpen"), this.on("change:isOpen", function () {
            _this182.isOpen && ("auto" === _this182.panelPosition ? _this182.panelView.position = vf._getOptimalPosition({
              element: _this182.panelView.element,
              target: _this182.buttonView.element,
              fitInViewport: !0,
              positions: _this182._panelPositions
            }).name : _this182.panelView.position = _this182.panelPosition);
          }), this.keystrokes.listenTo(this.element), this.focusTracker.add(this.element);

          var t = function t(_t248, e) {
            _this182.isOpen && (_this182.buttonView.focus(), _this182.isOpen = !1, e());
          };

          this.keystrokes.set("arrowdown", function (t, e) {
            _this182.buttonView.isEnabled && !_this182.isOpen && (_this182.isOpen = !0, e());
          }), this.keystrokes.set("arrowright", function (t, e) {
            _this182.isOpen && e();
          }), this.keystrokes.set("arrowleft", t), this.keystrokes.set("esc", t);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }, {
        key: "_panelPositions",
        get: function get() {
          var _vf$defaultPanelPosit = vf.defaultPanelPositions,
              t = _vf$defaultPanelPosit.southEast,
              e = _vf$defaultPanelPosit.southWest,
              n = _vf$defaultPanelPosit.northEast,
              i = _vf$defaultPanelPosit.northWest;
          return "ltr" === this.locale.uiLanguageDirection ? [t, e, n, i] : [e, t, i, n];
        }
      }]);

      return vf;
    }(Dl);

    vf.defaultPanelPositions = {
      southEast: function southEast(t) {
        return {
          top: t.bottom,
          left: t.left,
          name: "se"
        };
      },
      southWest: function southWest(t, e) {
        return {
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        };
      },
      northEast: function northEast(t, e) {
        return {
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        };
      },
      northWest: function northWest(t, e) {
        return {
          top: t.bottom - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        };
      }
    }, vf._getOptimalPosition = Au;
    var yf = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';

    var xf = /*#__PURE__*/function (_Wd) {
      _inherits(xf, _Wd);

      var _super120 = _createSuper(xf);

      function xf(t) {
        var _this183;

        _classCallCheck(this, xf);

        _this183 = _super120.call(this, t), _this183.arrowView = _this183._createArrowView(), _this183.extendTemplate({
          attributes: {
            "aria-haspopup": !0
          }
        }), _this183.delegate("execute").to(_assertThisInitialized(_this183), "open");
        return _this183;
      }

      _createClass(xf, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(xf.prototype), "render", this).call(this), this.children.add(this.arrowView);
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new Hd();
          return t.content = yf, t.extendTemplate({
            attributes: {
              class: "ck-dropdown__arrow"
            }
          }), t;
        }
      }]);

      return xf;
    }(Wd);

    n(60);

    var Af = /*#__PURE__*/function (_Dl20) {
      _inherits(Af, _Dl20);

      var _super121 = _createSuper(Af);

      function Af() {
        var _this184;

        _classCallCheck(this, Af);

        _this184 = _super121.call(this), _this184.items = _this184.createCollection(), _this184.focusTracker = new sl(), _this184.keystrokes = new Jc(), _this184._focusCycler = new ql({
          focusables: _this184.items,
          focusTracker: _this184.focusTracker,
          keystrokeHandler: _this184.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        }), _this184.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"]
          },
          children: _this184.items
        });
        return _this184;
      }

      _createClass(Af, [{
        key: "render",
        value: function render() {
          var _this185 = this;

          _get(_getPrototypeOf(Af.prototype), "render", this).call(this);

          var _iterator299 = _createForOfIteratorHelper(this.items),
              _step299;

          try {
            for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
              var _t249 = _step299.value;
              this.focusTracker.add(_t249.element);
            }
          } catch (err) {
            _iterator299.e(err);
          } finally {
            _iterator299.f();
          }

          this.items.on("add", function (t, e) {
            _this185.focusTracker.add(e.element);
          }), this.items.on("remove", function (t, e) {
            _this185.focusTracker.remove(e.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }]);

      return Af;
    }(Dl);

    var Tf = /*#__PURE__*/function (_Dl21) {
      _inherits(Tf, _Dl21);

      var _super122 = _createSuper(Tf);

      function Tf(t) {
        var _this186;

        _classCallCheck(this, Tf);

        _this186 = _super122.call(this, t), _this186.children = _this186.createCollection(), _this186.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item"]
          },
          children: _this186.children
        });
        return _this186;
      }

      _createClass(Tf, [{
        key: "focus",
        value: function focus() {
          this.children.first.focus();
        }
      }]);

      return Tf;
    }(Dl);

    var Cf = /*#__PURE__*/function (_Dl22) {
      _inherits(Cf, _Dl22);

      var _super123 = _createSuper(Cf);

      function Cf(t) {
        var _this187;

        _classCallCheck(this, Cf);

        _this187 = _super123.call(this, t), _this187.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
        return _this187;
      }

      return Cf;
    }(Dl);

    n(62);

    var Pf = /*#__PURE__*/function (_Wd2) {
      _inherits(Pf, _Wd2);

      var _super124 = _createSuper(Pf);

      function Pf(t) {
        var _this188;

        _classCallCheck(this, Pf);

        _this188 = _super124.call(this, t), _this188.isToggleable = !0, _this188.toggleSwitchView = _this188._createToggleView(), _this188.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
        return _this188;
      }

      _createClass(Pf, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Pf.prototype), "render", this).call(this), this.children.add(this.toggleSwitchView);
        }
      }, {
        key: "_createToggleView",
        value: function _createToggleView() {
          var t = new Dl();
          return t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle"]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle__inner"]
              }
            }]
          }), t;
        }
      }]);

      return Pf;
    }(Wd);

    n(64), n(66);

    function Sf(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : xf;
      var n = new e(t),
          i = new _f(t),
          o = new vf(t, n, i);
      return n.bind("isEnabled").to(o), n instanceof xf ? n.bind("isOn").to(o, "isOpen") : n.arrowView.bind("isOn").to(o, "isOpen"), function (t) {
        (function (t) {
          t.on("render", function () {
            bu({
              emitter: t,
              activator: function activator() {
                return t.isOpen;
              },
              callback: function callback() {
                t.isOpen = !1;
              },
              contextElements: [t.element]
            });
          });
        })(t), function (t) {
          t.on("execute", function (e) {
            e.source instanceof Pf || (t.isOpen = !1);
          });
        }(t), function (t) {
          t.keystrokes.set("arrowdown", function (e, n) {
            t.isOpen && (t.panelView.focus(), n());
          }), t.keystrokes.set("arrowup", function (e, n) {
            t.isOpen && (t.panelView.focusLast(), n());
          });
        }(t);
      }(o), o;
    }

    function Mf(t, e) {
      var n = t.locale,
          i = t.listView = new Af(n);
      i.items.bindTo(e).using(function (_ref95) {
        var t = _ref95.type,
            e = _ref95.model;
        if ("separator" === t) return new Cf(n);

        if ("button" === t || "switchbutton" === t) {
          var _o80;

          var _i163 = new Tf(n);

          var _o79;

          return (_o80 = _o79 = "button" === t ? new Wd(n) : new Pf(n)).bind.apply(_o80, _toConsumableArray(Object.keys(e))).to(e), _o79.delegate("execute").to(_i163), _i163.children.add(_o79), _i163;
        }
      }), t.panelView.children.add(i), i.items.delegate("execute").to(t);
    }

    n(10);

    var Ef = /*#__PURE__*/function (_Kl37) {
      _inherits(Ef, _Kl37);

      var _super125 = _createSuper(Ef);

      function Ef() {
        _classCallCheck(this, Ef);

        return _super125.apply(this, arguments);
      }

      _createClass(Ef, [{
        key: "init",
        value: function init() {
          var _this189 = this;

          var t = this.editor,
              e = t.t,
              n = function (t) {
            var e = t.t,
                n = {
              Paragraph: e("bt"),
              "Heading 1": e("bu"),
              "Heading 2": e("bv"),
              "Heading 3": e("bw"),
              "Heading 4": e("bx"),
              "Heading 5": e("by"),
              "Heading 6": e("bz")
            };
            return t.config.get("heading.options").map(function (t) {
              var e = n[t.title];
              return e && e != t.title && (t.title = e), t;
            });
          }(t),
              i = e("h"),
              o = e("i");

          t.ui.componentFactory.add("heading", function (e) {
            var r = {},
                s = new oo(),
                a = t.commands.get("heading"),
                c = t.commands.get("paragraph"),
                l = [a];

            var _iterator300 = _createForOfIteratorHelper(n),
                _step300;

            try {
              var _loop6 = function _loop6() {
                var t = _step300.value;
                var e = {
                  type: "button",
                  model: new kf({
                    label: t.title,
                    class: t.class,
                    withText: !0
                  })
                };
                "paragraph" === t.model ? (e.model.bind("isOn").to(c, "value"), e.model.set("commandName", "paragraph"), l.push(c)) : (e.model.bind("isOn").to(a, "value", function (e) {
                  return e === t.model;
                }), e.model.set({
                  commandName: "heading",
                  commandValue: t.model
                })), s.add(e), r[t.model] = t.title;
              };

              for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
                _loop6();
              }
            } catch (err) {
              _iterator300.e(err);
            } finally {
              _iterator300.f();
            }

            var d = Sf(e);
            return Mf(d, s), d.buttonView.set({
              isOn: !1,
              withText: !0,
              tooltip: o
            }), d.extendTemplate({
              attributes: {
                class: ["ck-heading-dropdown"]
              }
            }), d.bind("isEnabled").toMany(l, "isEnabled", function () {
              for (var _len18 = arguments.length, t = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
                t[_key18] = arguments[_key18];
              }

              return t.some(function (t) {
                return t;
              });
            }), d.buttonView.bind("label").to(a, "value", c, "value", function (t, e) {
              var n = t || e && "paragraph";
              return r[n] ? r[n] : i;
            }), _this189.listenTo(d, "execute", function (e) {
              t.execute(e.source.commandName, e.source.commandValue ? {
                value: e.source.commandValue
              } : void 0), t.editing.view.focus();
            }), d;
          });
        }
      }]);

      return Ef;
    }(Kl);

    function If(t) {
      var _iterator301 = _createForOfIteratorHelper(t.getChildren()),
          _step301;

      try {
        for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
          var _e228 = _step301.value;
          if (_e228 && _e228.is("caption")) return _e228;
        }
      } catch (err) {
        _iterator301.e(err);
      } finally {
        _iterator301.f();
      }

      return null;
    }

    function Nf(t) {
      var e = t.parent;
      return "figcaption" == t.name && e && "figure" == e.name && e.hasClass("image") ? {
        name: !0
      } : null;
    }

    var Of = /*#__PURE__*/function (_Kl38) {
      _inherits(Of, _Kl38);

      var _super126 = _createSuper(Of);

      function Of() {
        _classCallCheck(this, Of);

        return _super126.apply(this, arguments);
      }

      _createClass(Of, [{
        key: "init",
        value: function init() {
          var _this190 = this;

          var t = this.editor,
              e = t.editing.view,
              n = t.model.schema,
              i = t.data,
              o = t.editing,
              r = t.t;
          n.register("caption", {
            allowIn: "image",
            allowContentOf: "$block",
            isLimit: !0
          }), t.model.document.registerPostFixer(function (t) {
            return _this190._insertMissingModelCaptionElement(t);
          }), t.conversion.for("upcast").elementToElement({
            view: Nf,
            model: "caption"
          });
          i.downcastDispatcher.on("insert:caption", Rf(function (t) {
            return t.createContainerElement("figcaption");
          }, !1));

          var s = function (t, e) {
            return function (n) {
              var i = n.createEditableElement("figcaption");
              return n.setCustomProperty("imageCaption", !0, i), ll({
                view: t,
                element: i,
                text: e
              }), eu(i, n);
            };
          }(e, r("ak"));

          o.downcastDispatcher.on("insert:caption", Rf(s)), o.downcastDispatcher.on("insert", this._fixCaptionVisibility(function (t) {
            return t.item;
          }), {
            priority: "high"
          }), o.downcastDispatcher.on("remove", this._fixCaptionVisibility(function (t) {
            return t.position.parent;
          }), {
            priority: "high"
          }), e.document.registerPostFixer(function (t) {
            return _this190._updateCaptionVisibility(t);
          });
        }
      }, {
        key: "_updateCaptionVisibility",
        value: function _updateCaptionVisibility(t) {
          var e = this.editor.editing.mapper,
              n = this._lastSelectedCaption;
          var i;
          var o = this.editor.model.document.selection,
              r = o.getSelectedElement();

          if (r && r.is("image")) {
            var _t250 = If(r);

            i = e.toViewElement(_t250);
          }

          var s = Df(o.getFirstPosition().parent);
          if (s && (i = e.toViewElement(s)), i) return n ? n === i ? jf(i, t) : (Lf(n, t), this._lastSelectedCaption = i, jf(i, t)) : (this._lastSelectedCaption = i, jf(i, t));

          if (n) {
            var _e229 = Lf(n, t);

            return this._lastSelectedCaption = null, _e229;
          }

          return !1;
        }
      }, {
        key: "_fixCaptionVisibility",
        value: function _fixCaptionVisibility(t) {
          var _this191 = this;

          return function (e, n, i) {
            var o = Df(t(n)),
                r = _this191.editor.editing.mapper,
                s = i.writer;

            if (o) {
              var _t251 = r.toViewElement(o);

              _t251 && (o.childCount ? s.removeClass("ck-hidden", _t251) : s.addClass("ck-hidden", _t251));
            }
          };
        }
      }, {
        key: "_insertMissingModelCaptionElement",
        value: function _insertMissingModelCaptionElement(t) {
          var e = this.editor.model,
              n = e.document.differ.getChanges(),
              i = [];

          var _iterator302 = _createForOfIteratorHelper(n),
              _step302;

          try {
            for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
              var _t252 = _step302.value;

              if ("insert" == _t252.type && "$text" != _t252.name) {
                var _n206 = _t252.position.nodeAfter;

                if (_n206.is("image") && !If(_n206) && i.push(_n206), !_n206.is("image") && _n206.childCount) {
                  var _iterator303 = _createForOfIteratorHelper(e.createRangeIn(_n206).getItems()),
                      _step303;

                  try {
                    for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
                      var _t253 = _step303.value;
                      _t253.is("image") && !If(_t253) && i.push(_t253);
                    }
                  } catch (err) {
                    _iterator303.e(err);
                  } finally {
                    _iterator303.f();
                  }
                }
              }
            }
          } catch (err) {
            _iterator302.e(err);
          } finally {
            _iterator302.f();
          }

          for (var _i165 = 0, _i164 = i; _i165 < _i164.length; _i165++) {
            var _e230 = _i164[_i165];
            t.appendElement("caption", _e230);
          }

          return !!i.length;
        }
      }]);

      return Of;
    }(Kl);

    function Rf(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return function (n, i, o) {
        var r = i.item;

        if ((r.childCount || e) && ru(r.parent)) {
          if (!o.consumable.consume(i.item, "insert")) return;

          var _e231 = o.mapper.toViewElement(i.range.start.parent),
              _n207 = t(o.writer),
              _s25 = o.writer;

          r.childCount || _s25.addClass("ck-hidden", _n207), function (t, e, n, i) {
            var o = i.writer.createPositionAt(n, "end");
            i.writer.insert(o, t), i.mapper.bindElements(e, t);
          }(_n207, i.item, _e231, o);
        }
      };
    }

    function Df(t) {
      var e = t.getAncestors({
        includeSelf: !0
      }).find(function (t) {
        return "caption" == t.name;
      });
      return e && e.parent && "image" == e.parent.name ? e : null;
    }

    function Lf(t, e) {
      return !t.childCount && !t.hasClass("ck-hidden") && (e.addClass("ck-hidden", t), !0);
    }

    function jf(t, e) {
      return !!t.hasClass("ck-hidden") && (e.removeClass("ck-hidden", t), !0);
    }

    n(69);

    var Vf = /*#__PURE__*/function (_ed14) {
      _inherits(Vf, _ed14);

      var _super127 = _createSuper(Vf);

      function Vf(t, e) {
        var _this192;

        _classCallCheck(this, Vf);

        _this192 = _super127.call(this, t), _this192.defaultStyle = !1, _this192.styles = e.reduce(function (t, e) {
          return t[e.name] = e, e.isDefault && (_this192.defaultStyle = e.name), t;
        }, {});
        return _this192;
      }

      _createClass(Vf, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          if (this.isEnabled = ru(t), t) {
            if (t.hasAttribute("imageStyle")) {
              var _e232 = t.getAttribute("imageStyle");

              this.value = !!this.styles[_e232] && _e232;
            } else this.value = this.defaultStyle;
          } else this.value = !1;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this193 = this;

          var e = t.value,
              n = this.editor.model,
              i = n.document.selection.getSelectedElement();
          n.change(function (t) {
            _this193.styles[e].isDefault ? t.removeAttribute("imageStyle", i) : t.setAttribute("imageStyle", e, i);
          });
        }
      }]);

      return Vf;
    }(ed);

    function zf(t, e) {
      var _iterator304 = _createForOfIteratorHelper(e),
          _step304;

      try {
        for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
          var _n208 = _step304.value;
          if (_n208.name === t) return _n208;
        }
      } catch (err) {
        _iterator304.e(err);
      } finally {
        _iterator304.f();
      }
    }

    var Bf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>',
        Ff = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>',
        Uf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>',
        Hf = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
    var qf = {
      full: {
        name: "full",
        title: "Full size image",
        icon: Bf,
        isDefault: !0
      },
      side: {
        name: "side",
        title: "Side image",
        icon: Hf,
        className: "image-style-side"
      },
      alignLeft: {
        name: "alignLeft",
        title: "Left aligned image",
        icon: Ff,
        className: "image-style-align-left"
      },
      alignCenter: {
        name: "alignCenter",
        title: "Centered image",
        icon: Uf,
        className: "image-style-align-center"
      },
      alignRight: {
        name: "alignRight",
        title: "Right aligned image",
        icon: Hf,
        className: "image-style-align-right"
      }
    },
        Wf = {
      full: Bf,
      left: Ff,
      right: Hf,
      center: Uf
    };

    function Yf() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return t.map($f);
    }

    function $f(t) {
      if ("string" == typeof t) {
        var _e233 = t;
        qf[_e233] ? t = Object.assign({}, qf[_e233]) : (console.warn(Object(Gn.a)("image-style-not-found: There is no such image style of given name."), {
          name: _e233
        }), t = {
          name: _e233
        });
      } else if (qf[t.name]) {
        var _e234 = qf[t.name],
            _n209 = Object.assign({}, t);

        for (var _i166 in _e234) {
          t.hasOwnProperty(_i166) || (_n209[_i166] = _e234[_i166]);
        }

        t = _n209;
      }

      return "string" == typeof t.icon && Wf[t.icon] && (t.icon = Wf[t.icon]), t;
    }

    var Gf = /*#__PURE__*/function (_Kl39) {
      _inherits(Gf, _Kl39);

      var _super128 = _createSuper(Gf);

      function Gf() {
        _classCallCheck(this, Gf);

        return _super128.apply(this, arguments);
      }

      _createClass(Gf, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.data,
              i = t.editing;
          t.config.define("image.styles", ["full", "side"]);
          var o = Yf(t.config.get("image.styles"));
          e.extend("image", {
            allowAttributes: "imageStyle"
          });

          var r = function (t) {
            return function (e, n, i) {
              if (!i.consumable.consume(n.item, e.name)) return;
              var o = zf(n.attributeNewValue, t),
                  r = zf(n.attributeOldValue, t),
                  s = i.mapper.toViewElement(n.item),
                  a = i.writer;
              r && a.removeClass(r.className, s), o && a.addClass(o.className, s);
            };
          }(o);

          i.downcastDispatcher.on("attribute:imageStyle:image", r), n.downcastDispatcher.on("attribute:imageStyle:image", r), n.upcastDispatcher.on("element:figure", function (t) {
            var e = t.filter(function (t) {
              return !t.isDefault;
            });
            return function (t, n, i) {
              if (!n.modelRange) return;
              var o = n.viewItem,
                  r = vh(n.modelRange.getItems());

              if (i.schema.checkAttribute(r, "imageStyle")) {
                var _iterator305 = _createForOfIteratorHelper(e),
                    _step305;

                try {
                  for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
                    var _t254 = _step305.value;
                    i.consumable.consume(o, {
                      classes: _t254.className
                    }) && i.writer.setAttribute("imageStyle", _t254.name, r);
                  }
                } catch (err) {
                  _iterator305.e(err);
                } finally {
                  _iterator305.f();
                }
              }
            };
          }(o), {
            priority: "low"
          }), t.commands.add("imageStyle", new Vf(t, o));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleEditing";
        }
      }]);

      return Gf;
    }(Kl);

    n(71);

    var Qf = /*#__PURE__*/function (_Kl40) {
      _inherits(Qf, _Kl40);

      var _super129 = _createSuper(Qf);

      function Qf() {
        _classCallCheck(this, Qf);

        return _super129.apply(this, arguments);
      }

      _createClass(Qf, [{
        key: "localizedDefaultStylesTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            "Full size image": t("k"),
            "Side image": t("l"),
            "Left aligned image": t("m"),
            "Centered image": t("n"),
            "Right aligned image": t("o")
          };
        }
      }, {
        key: "init",
        value: function init() {
          var t = function (t, e) {
            var _iterator306 = _createForOfIteratorHelper(t),
                _step306;

            try {
              for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
                var _n210 = _step306.value;
                e[_n210.title] && (_n210.title = e[_n210.title]);
              }
            } catch (err) {
              _iterator306.e(err);
            } finally {
              _iterator306.f();
            }

            return t;
          }(Yf(this.editor.config.get("image.styles")), this.localizedDefaultStylesTitles);

          var _iterator307 = _createForOfIteratorHelper(t),
              _step307;

          try {
            for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
              var _e235 = _step307.value;

              this._createButton(_e235);
            }
          } catch (err) {
            _iterator307.e(err);
          } finally {
            _iterator307.f();
          }
        }
      }, {
        key: "_createButton",
        value: function _createButton(t) {
          var _this194 = this;

          var e = this.editor,
              n = "imageStyle:".concat(t.name);
          e.ui.componentFactory.add(n, function (n) {
            var i = e.commands.get("imageStyle"),
                o = new Wd(n);
            return o.set({
              label: t.title,
              icon: t.icon,
              tooltip: !0,
              isToggleable: !0
            }), o.bind("isEnabled").to(i, "isEnabled"), o.bind("isOn").to(i, "value", function (e) {
              return e === t.name;
            }), _this194.listenTo(o, "execute", function () {
              return e.execute("imageStyle", {
                value: t.name
              });
            }), o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleUI";
        }
      }]);

      return Qf;
    }(Kl);

    var Kf = /*#__PURE__*/function (_Kl41) {
      _inherits(Kf, _Kl41);

      var _super130 = _createSuper(Kf);

      function Kf() {
        _classCallCheck(this, Kf);

        return _super130.apply(this, arguments);
      }

      _createClass(Kf, [{
        key: "init",
        value: function init() {
          var _this195 = this;

          var t = this.editor;

          if (t.plugins.has("BalloonToolbar")) {
            var _e236 = t.plugins.get("BalloonToolbar");

            this.listenTo(_e236, "show", function (e) {
              (function (t) {
                var e = t.getSelectedElement();
                return !(!e || !Zh(e));
              })(t.editing.view.document.selection) && e.stop();
            }, {
              priority: "high"
            });
          }

          this._toolbarDefinitions = new Map(), this._balloon = this.editor.plugins.get("ContextualBalloon"), this.listenTo(t.ui, "update", function () {
            _this195._updateToolbarsVisibility();
          }), this.listenTo(t.ui.focusTracker, "change:isFocused", function () {
            _this195._updateToolbarsVisibility();
          }, {
            priority: "low"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Kf.prototype), "destroy", this).call(this);

          var _iterator308 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
              _step308;

          try {
            for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
              var _t255 = _step308.value;

              _t255.view.destroy();
            }
          } catch (err) {
            _iterator308.e(err);
          } finally {
            _iterator308.f();
          }
        }
      }, {
        key: "register",
        value: function register(t, _ref96) {
          var e = _ref96.ariaLabel,
              n = _ref96.items,
              i = _ref96.getRelatedElement,
              _ref96$balloonClassNa = _ref96.balloonClassName,
              o = _ref96$balloonClassNa === void 0 ? "ck-toolbar-container" : _ref96$balloonClassNa;
          var r = this.editor,
              s = r.t,
              a = new $l(r.locale);
          if (a.ariaLabel = e || s("av"), this._toolbarDefinitions.has(t)) throw new Gn.b("widget-toolbar-duplicated: Toolbar with the given id was already added.", this, {
            toolbarId: t
          });
          a.fillFromConfig(n, r.ui.componentFactory), this._toolbarDefinitions.set(t, {
            view: a,
            getRelatedElement: i,
            balloonClassName: o
          });
        }
      }, {
        key: "_updateToolbarsVisibility",
        value: function _updateToolbarsVisibility() {
          var t = 0,
              e = null,
              n = null;

          var _iterator309 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
              _step309;

          try {
            for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
              var _i167 = _step309.value;

              var _o81 = _i167.getRelatedElement(this.editor.editing.view.document.selection);

              if (this.editor.ui.focusTracker.isFocused) {
                if (_o81) {
                  var _r37 = _o81.getAncestors().length;

                  _r37 > t && (t = _r37, e = _o81, n = _i167);
                } else this._isToolbarInBalloon(_i167) && this._hideToolbar(_i167);
              } else this._isToolbarVisible(_i167) && this._hideToolbar(_i167);
            }
          } catch (err) {
            _iterator309.e(err);
          } finally {
            _iterator309.f();
          }

          n && this._showToolbar(n, e);
        }
      }, {
        key: "_hideToolbar",
        value: function _hideToolbar(t) {
          this._balloon.remove(t.view), this.stopListening(this._balloon, "change:visibleView");
        }
      }, {
        key: "_showToolbar",
        value: function _showToolbar(t, e) {
          var _this196 = this;

          this._isToolbarVisible(t) ? Jf(this.editor, e) : this._isToolbarInBalloon(t) || (this._balloon.add({
            view: t.view,
            position: Zf(this.editor, e),
            balloonClassName: t.balloonClassName
          }), this.listenTo(this._balloon, "change:visibleView", function () {
            var _iterator310 = _createForOfIteratorHelper(_this196._toolbarDefinitions.values()),
                _step310;

            try {
              for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
                var _t256 = _step310.value;

                if (_this196._isToolbarVisible(_t256)) {
                  var _e237 = _t256.getRelatedElement(_this196.editor.editing.view.document.selection);

                  Jf(_this196.editor, _e237);
                }
              }
            } catch (err) {
              _iterator310.e(err);
            } finally {
              _iterator310.f();
            }
          }));
        }
      }, {
        key: "_isToolbarVisible",
        value: function _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view;
        }
      }, {
        key: "_isToolbarInBalloon",
        value: function _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Lu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "WidgetToolbarRepository";
        }
      }]);

      return Kf;
    }(Kl);

    function Jf(t, e) {
      var n = t.plugins.get("ContextualBalloon"),
          i = Zf(t, e);
      n.updatePosition(i);
    }

    function Zf(t, e) {
      var n = t.editing.view,
          i = Mu.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast]
      };
    }

    function Xf(t, e, n) {
      return n.createRange(tm(t, e, !0, n), tm(t, e, !1, n));
    }

    function tm(t, e, n, i) {
      var o = t.textNode || (n ? t.nodeBefore : t.nodeAfter),
          r = null;

      for (; o && o.getAttribute("linkHref") == e;) {
        r = o, o = n ? o.previousSibling : o.nextSibling;
      }

      return r ? i.createPositionAt(r, n ? "before" : "after") : t;
    }

    var em = /*#__PURE__*/function (_ed15) {
      _inherits(em, _ed15);

      var _super131 = _createSuper(em);

      function em(t) {
        var _this197;

        _classCallCheck(this, em);

        _this197 = _super131.call(this, t), _this197.manualDecorators = new oo();
        return _this197;
      }

      _createClass(em, [{
        key: "restoreManualDecoratorStates",
        value: function restoreManualDecoratorStates() {
          var _iterator311 = _createForOfIteratorHelper(this.manualDecorators),
              _step311;

          try {
            for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
              var _t257 = _step311.value;
              _t257.value = this._getDecoratorStateFromModel(_t257.id);
            }
          } catch (err) {
            _iterator311.e(err);
          } finally {
            _iterator311.f();
          }
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document;
          this.value = e.selection.getAttribute("linkHref");

          var _iterator312 = _createForOfIteratorHelper(this.manualDecorators),
              _step312;

          try {
            for (_iterator312.s(); !(_step312 = _iterator312.n()).done;) {
              var _t258 = _step312.value;
              _t258.value = this._getDecoratorStateFromModel(_t258.id);
            }
          } catch (err) {
            _iterator312.e(err);
          } finally {
            _iterator312.f();
          }

          this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = n.document.selection,
              o = [],
              r = [];

          for (var _t259 in e) {
            e[_t259] ? o.push(_t259) : r.push(_t259);
          }

          n.change(function (e) {
            if (i.isCollapsed) {
              var _s26 = i.getFirstPosition();

              if (i.hasAttribute("linkHref")) {
                var _a14 = Xf(_s26, i.getAttribute("linkHref"), n);

                e.setAttribute("linkHref", t, _a14), o.forEach(function (t) {
                  e.setAttribute(t, !0, _a14);
                }), r.forEach(function (t) {
                  e.removeAttribute(t, _a14);
                }), e.setSelection(_a14);
              } else if ("" !== t) {
                var _r38 = Vs(i.getAttributes());

                _r38.set("linkHref", t), o.forEach(function (t) {
                  _r38.set(t, !0);
                });

                var _a15 = e.createText(t, _r38);

                n.insertContent(_a15, _s26), e.setSelection(e.createRangeOn(_a15));
              }
            } else {
              var _s27 = n.schema.getValidRanges(i.getRanges(), "linkHref");

              var _iterator313 = _createForOfIteratorHelper(_s27),
                  _step313;

              try {
                var _loop7 = function _loop7() {
                  var n = _step313.value;
                  e.setAttribute("linkHref", t, n), o.forEach(function (t) {
                    e.setAttribute(t, !0, n);
                  }), r.forEach(function (t) {
                    e.removeAttribute(t, n);
                  });
                };

                for (_iterator313.s(); !(_step313 = _iterator313.n()).done;) {
                  _loop7();
                }
              } catch (err) {
                _iterator313.e(err);
              } finally {
                _iterator313.f();
              }
            }
          });
        }
      }, {
        key: "_getDecoratorStateFromModel",
        value: function _getDecoratorStateFromModel(t) {
          return this.editor.model.document.selection.getAttribute(t) || !1;
        }
      }]);

      return em;
    }(ed);

    var nm = /*#__PURE__*/function (_ed16) {
      _inherits(nm, _ed16);

      var _super132 = _createSuper(nm);

      function nm() {
        _classCallCheck(this, nm);

        return _super132.apply(this, arguments);
      }

      _createClass(nm, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this.editor.model.document.selection.hasAttribute("linkHref");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = this.editor.model,
              n = e.document.selection,
              i = t.commands.get("link");
          e.change(function (t) {
            var o = n.isCollapsed ? [Xf(n.getFirstPosition(), n.getAttribute("linkHref"), e)] : n.getRanges();

            var _iterator314 = _createForOfIteratorHelper(o),
                _step314;

            try {
              for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
                var _e238 = _step314.value;

                if (t.removeAttribute("linkHref", _e238), i) {
                  var _iterator315 = _createForOfIteratorHelper(i.manualDecorators),
                      _step315;

                  try {
                    for (_iterator315.s(); !(_step315 = _iterator315.n()).done;) {
                      var _n211 = _step315.value;
                      t.removeAttribute(_n211.id, _e238);
                    }
                  } catch (err) {
                    _iterator315.e(err);
                  } finally {
                    _iterator315.f();
                  }
                }
              }
            } catch (err) {
              _iterator314.e(err);
            } finally {
              _iterator314.f();
            }
          });
        }
      }]);

      return nm;
    }(ed);

    var im = function im(t, e, n) {
      var i = -1,
          o = t.length;
      e < 0 && (e = -e > o ? 0 : o + e), (n = n > o ? o : n) < 0 && (n += o), o = e > n ? 0 : n - e >>> 0, e >>>= 0;

      for (var r = Array(o); ++i < o;) {
        r[i] = t[i + e];
      }

      return r;
    };

    var om = function om(t, e, n) {
      var i = t.length;
      return n = void 0 === n ? i : n, !e && n >= i ? t : im(t, e, n);
    },
        rm = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");

    var sm = function sm(t) {
      return rm.test(t);
    };

    var am = function am(t) {
      return t.split("");
    },
        cm = "[\\ud800-\\udfff]",
        lm = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]",
        dm = "\\ud83c[\\udffb-\\udfff]",
        hm = "[^\\ud800-\\udfff]",
        um = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        fm = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        mm = "(?:" + lm + "|" + dm + ")" + "?",
        gm = "[\\ufe0e\\ufe0f]?" + mm + ("(?:\\u200d(?:" + [hm, um, fm].join("|") + ")[\\ufe0e\\ufe0f]?" + mm + ")*"),
        pm = "(?:" + [hm + lm + "?", lm, um, fm, cm].join("|") + ")",
        bm = RegExp(dm + "(?=" + dm + ")|" + pm + gm, "g");

    var wm = function wm(t) {
      return t.match(bm) || [];
    };

    var km = function km(t) {
      return sm(t) ? wm(t) : am(t);
    };

    var _m = function _m(t, e) {
      for (var n = -1, i = null == t ? 0 : t.length, o = Array(i); ++n < i;) {
        o[n] = e(t[n], n, t);
      }

      return o;
    },
        vm = 1 / 0,
        ym = o ? o.prototype : void 0,
        xm = ym ? ym.toString : void 0;

    var Am = function t(e) {
      if ("string" == typeof e) return e;
      if (Wt(e)) return _m(e, t) + "";
      if (os(e)) return xm ? xm.call(e) : "";
      var n = e + "";
      return "0" == n && 1 / e == -vm ? "-0" : n;
    };

    var Tm = function Tm(t) {
      return null == t ? "" : Am(t);
    };

    var Cm = function (t) {
      return function (e) {
        e = Tm(e);
        var n = sm(e) ? km(e) : void 0,
            i = n ? n[0] : e.charAt(0),
            o = n ? om(n, 1).join("") : e.slice(1);
        return i[t]() + o;
      };
    }("toUpperCase");

    var Pm = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,
        Sm = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;

    function Mm(t, e) {
      var n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      return e.setCustomProperty("link", !0, n), n;
    }

    function Em(t) {
      return function (t) {
        return t.replace(Pm, "").match(Sm);
      }(t = String(t)) ? t : "#";
    }

    var Im = /*#__PURE__*/function () {
      function Im() {
        _classCallCheck(this, Im);

        this._definitions = new Set();
      }

      _createClass(Im, [{
        key: "length",
        get: function get() {
          return this._definitions.size;
        }
      }, {
        key: "add",
        value: function add(t) {
          var _this198 = this;

          Array.isArray(t) ? t.forEach(function (t) {
            return _this198._definitions.add(t);
          }) : this._definitions.add(t);
        }
      }, {
        key: "getDispatcher",
        value: function getDispatcher() {
          var _this199 = this;

          return function (t) {
            t.on("attribute:linkHref", function (t, e, n) {
              if (!n.consumable.test(e.item, "attribute:linkHref")) return;
              var i = n.writer,
                  o = i.document.selection;

              var _iterator316 = _createForOfIteratorHelper(_this199._definitions),
                  _step316;

              try {
                for (_iterator316.s(); !(_step316 = _iterator316.n()).done;) {
                  var _t260 = _step316.value;

                  var _r39 = i.createAttributeElement("a", _t260.attributes, {
                    priority: 5
                  });

                  i.setCustomProperty("link", !0, _r39), _t260.callback(e.attributeNewValue) ? e.item.is("selection") ? i.wrap(o.getFirstRange(), _r39) : i.wrap(n.mapper.toViewRange(e.range), _r39) : i.unwrap(n.mapper.toViewRange(e.range), _r39);
                }
              } catch (err) {
                _iterator316.e(err);
              } finally {
                _iterator316.f();
              }
            }, {
              priority: "high"
            });
          };
        }
      }]);

      return Im;
    }();

    var Nm = function Nm(_ref97) {
      var t = _ref97.id,
          e = _ref97.label,
          n = _ref97.attributes;

      _classCallCheck(this, Nm);

      this.id = t, this.set("value"), this.label = e, this.attributes = n;
    };

    ci(Nm, Fi);

    var Om = /*#__PURE__*/function () {
      function Om(t, e, n) {
        var _this200 = this;

        _classCallCheck(this, Om);

        this.model = t, this.attribute = n, this._modelSelection = t.document.selection, this._overrideUid = null, this._isNextGravityRestorationSkipped = !1, e.listenTo(this._modelSelection, "change:range", function (t, e) {
          _this200._isNextGravityRestorationSkipped ? _this200._isNextGravityRestorationSkipped = !1 : _this200._isGravityOverridden && (!e.directChange && Rm(_this200._modelSelection.getFirstPosition(), n) || _this200._restoreGravity());
        });
      }

      _createClass(Om, [{
        key: "handleForwardMovement",
        value: function handleForwardMovement(t, e) {
          var n = this.attribute;
          if (!(this._isGravityOverridden || t.isAtStart && this._hasSelectionAttribute)) return jm(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._removeSelectionAttribute(), !0) : Dm(t, n) ? (this._preventCaretMovement(e), this._overrideGravity(), !0) : Lm(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._overrideGravity(), !0) : void 0;
        }
      }, {
        key: "handleBackwardMovement",
        value: function handleBackwardMovement(t, e) {
          var n = this.attribute;
          return this._isGravityOverridden ? jm(t, n) && this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._restoreGravity(), this._removeSelectionAttribute(), !0) : (this._preventCaretMovement(e), this._restoreGravity(), t.isAtStart && this._removeSelectionAttribute(), !0) : jm(t, n) && !this._hasSelectionAttribute ? (this._preventCaretMovement(e), this._setSelectionAttributeFromTheNodeBefore(t), !0) : t.isAtEnd && Lm(t, n) ? this._hasSelectionAttribute ? void (Vm(t, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity())) : (this._preventCaretMovement(e), this._setSelectionAttributeFromTheNodeBefore(t), !0) : t.isAtStart ? this._hasSelectionAttribute ? (this._removeSelectionAttribute(), this._preventCaretMovement(e), !0) : void 0 : void (Vm(t, n) && (this._skipNextAutomaticGravityRestoration(), this._overrideGravity()));
        }
      }, {
        key: "_isGravityOverridden",
        get: function get() {
          return !!this._overrideUid;
        }
      }, {
        key: "_hasSelectionAttribute",
        get: function get() {
          return this._modelSelection.hasAttribute(this.attribute);
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          this._overrideUid = this.model.change(function (t) {
            return t.overrideSelectionGravity();
          });
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity() {
          var _this201 = this;

          this.model.change(function (t) {
            t.restoreSelectionGravity(_this201._overrideUid), _this201._overrideUid = null;
          });
        }
      }, {
        key: "_preventCaretMovement",
        value: function _preventCaretMovement(t) {
          t.preventDefault();
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute() {
          var _this202 = this;

          this.model.change(function (t) {
            t.removeSelectionAttribute(_this202.attribute);
          });
        }
      }, {
        key: "_setSelectionAttributeFromTheNodeBefore",
        value: function _setSelectionAttributeFromTheNodeBefore(t) {
          var _this203 = this;

          var e = this.attribute;
          this.model.change(function (n) {
            n.setSelectionAttribute(_this203.attribute, t.nodeBefore.getAttribute(e));
          });
        }
      }, {
        key: "_skipNextAutomaticGravityRestoration",
        value: function _skipNextAutomaticGravityRestoration() {
          this._isNextGravityRestorationSkipped = !0;
        }
      }]);

      return Om;
    }();

    function Rm(t, e) {
      return Dm(t, e) || Lm(t, e);
    }

    function Dm(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e);
      return !!i && i.hasAttribute(e) && (!o || n.getAttribute(e) !== i.getAttribute(e));
    }

    function Lm(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e),
          r = !!i && i.hasAttribute(e);
      return o && (!r || n.getAttribute(e) !== i.getAttribute(e));
    }

    function jm(t, e) {
      var n = t.nodeBefore,
          i = t.nodeAfter,
          o = !!n && n.hasAttribute(e);
      if (!!i && i.hasAttribute(e) && o) return i.getAttribute(e) !== n.getAttribute(e);
    }

    function Vm(t, e) {
      return Rm(t.getShiftedBy(-1), e);
    }

    n(73);
    var zm = "ck-link_selected",
        Bm = "automatic",
        Fm = "manual",
        Um = /^(https?:)?\/\//;

    var Hm = /*#__PURE__*/function (_Kl42) {
      _inherits(Hm, _Kl42);

      var _super133 = _createSuper(Hm);

      function Hm(t) {
        var _this204;

        _classCallCheck(this, Hm);

        _this204 = _super133.call(this, t), t.config.define("link", {
          addTargetToExternalLinks: !1
        });
        return _this204;
      }

      _createClass(Hm, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.locale;
          t.model.schema.extend("$text", {
            allowAttributes: "linkHref"
          }), t.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: Mm
          }), t.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: function view(t, e) {
              return Mm(Em(t), e);
            }
          }), t.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              attributes: {
                href: !0
              }
            },
            model: {
              key: "linkHref",
              value: function value(t) {
                return t.getAttribute("href");
              }
            }
          }), t.commands.add("link", new em(t)), t.commands.add("unlink", new nm(t));

          var n = function (t, e) {
            var n = {
              "Open in a new tab": t("ax"),
              Downloadable: t("ay")
            };
            return e.forEach(function (t) {
              return t.label && n[t.label] && (t.label = n[t.label]), t;
            }), e;
          }(t.t, function (t) {
            var e = [];
            if (t) for (var _i168 = 0, _Object$entries = Object.entries(t); _i168 < _Object$entries.length; _i168++) {
              var _ref100 = _Object$entries[_i168];

              var _ref99 = _slicedToArray(_ref100, 2);

              var _n212 = _ref99[0];
              var _i169 = _ref99[1];

              var _t261 = Object.assign({}, _i169, {
                id: "link".concat(Cm(_n212))
              });

              e.push(_t261);
            }
            return e;
          }(t.config.get("link.decorators")));

          this._enableAutomaticDecorators(n.filter(function (t) {
            return t.mode === Bm;
          })), this._enableManualDecorators(n.filter(function (t) {
            return t.mode === Fm;
          })), function (_ref101) {
            var t = _ref101.view,
                e = _ref101.model,
                n = _ref101.emitter,
                i = _ref101.attribute,
                o = _ref101.locale;
            var r = new Om(e, n, i),
                s = e.document.selection;
            n.listenTo(t.document, "keydown", function (t, e) {
              if (!s.isCollapsed) return;
              if (e.shiftKey || e.altKey || e.ctrlKey) return;
              var n = e.keyCode == bo.arrowright,
                  i = e.keyCode == bo.arrowleft;
              if (!n && !i) return;
              var a = s.getFirstPosition(),
                  c = o.contentLanguageDirection;
              var l;
              (l = "ltr" === c && n || "rtl" === c && i ? r.handleForwardMovement(a, e) : r.handleBackwardMovement(a, e)) && t.stop();
            }, {
              priority: Zn.get("high") + 1
            });
          }({
            view: t.editing.view,
            model: t.model,
            emitter: this,
            attribute: "linkHref",
            locale: e
          }), this._setupLinkHighlight();
        }
      }, {
        key: "_enableAutomaticDecorators",
        value: function _enableAutomaticDecorators(t) {
          var e = this.editor,
              n = new Im();
          e.config.get("link.addTargetToExternalLinks") && n.add({
            id: "linkIsExternal",
            mode: Bm,
            callback: function callback(t) {
              return Um.test(t);
            },
            attributes: {
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }), n.add(t), n.length && e.conversion.for("downcast").add(n.getDispatcher());
        }
      }, {
        key: "_enableManualDecorators",
        value: function _enableManualDecorators(t) {
          if (!t.length) return;
          var e = this.editor,
              n = e.commands.get("link").manualDecorators;
          t.forEach(function (t) {
            e.model.schema.extend("$text", {
              allowAttributes: t.id
            }), n.add(new Nm(t)), e.conversion.for("downcast").attributeToElement({
              model: t.id,
              view: function view(e, i) {
                if (e) {
                  var _e239 = n.get(t.id).attributes,
                      _o82 = i.createAttributeElement("a", _e239, {
                    priority: 5
                  });

                  return i.setCustomProperty("link", !0, _o82), _o82;
                }
              }
            }), e.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: n.get(t.id).attributes
              },
              model: {
                key: t.id
              }
            });
          });
        }
      }, {
        key: "_setupLinkHighlight",
        value: function _setupLinkHighlight() {
          var t = this.editor,
              e = t.editing.view,
              n = new Set();
          e.document.registerPostFixer(function (e) {
            var i = t.model.document.selection;
            var o = !1;

            if (i.hasAttribute("linkHref")) {
              var _r40 = Xf(i.getFirstPosition(), i.getAttribute("linkHref"), t.model),
                  _s28 = t.editing.mapper.toViewRange(_r40);

              var _iterator317 = _createForOfIteratorHelper(_s28.getItems()),
                  _step317;

              try {
                for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
                  var _t262 = _step317.value;
                  _t262.is("a") && !_t262.hasClass(zm) && (e.addClass(zm, _t262), n.add(_t262), o = !0);
                }
              } catch (err) {
                _iterator317.e(err);
              } finally {
                _iterator317.f();
              }
            }

            return o;
          }), t.conversion.for("editingDowncast").add(function (t) {
            function i() {
              e.change(function (t) {
                var _iterator318 = _createForOfIteratorHelper(n.values()),
                    _step318;

                try {
                  for (_iterator318.s(); !(_step318 = _iterator318.n()).done;) {
                    var _e240 = _step318.value;
                    t.removeClass(zm, _e240), n.delete(_e240);
                  }
                } catch (err) {
                  _iterator318.e(err);
                } finally {
                  _iterator318.f();
                }
              });
            }

            t.on("insert", i, {
              priority: "highest"
            }), t.on("remove", i, {
              priority: "highest"
            }), t.on("attribute", i, {
              priority: "highest"
            }), t.on("selection", i, {
              priority: "highest"
            });
          });
        }
      }]);

      return Hm;
    }(Kl);

    var qm = /*#__PURE__*/function (_ts7) {
      _inherits(qm, _ts7);

      var _super134 = _createSuper(qm);

      function qm(t) {
        var _this205;

        _classCallCheck(this, qm);

        _this205 = _super134.call(this, t), _this205.domEventType = "click";
        return _this205;
      }

      _createClass(qm, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);

      return qm;
    }(ts);

    n(75);

    var Wm = /*#__PURE__*/function (_Dl23) {
      _inherits(Wm, _Dl23);

      var _super135 = _createSuper(Wm);

      function Wm(t) {
        var _this206;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        _classCallCheck(this, Wm);

        _this206 = _super135.call(this, t);
        var n = t.t;
        _this206.focusTracker = new sl(), _this206.keystrokes = new Jc(), _this206.urlInputView = _this206._createUrlInput(), _this206.saveButtonView = _this206._createButton(n("bd"), vu, "ck-button-save"), _this206.saveButtonView.type = "submit", _this206.cancelButtonView = _this206._createButton(n("be"), yu, "ck-button-cancel", "cancel"), _this206._manualDecoratorSwitches = _this206._createManualDecoratorSwitches(e), _this206.children = _this206._createFormChildren(e), _this206._focusables = new gl(), _this206._focusCycler = new ql({
          focusables: _this206._focusables,
          focusTracker: _this206.focusTracker,
          keystrokeHandler: _this206.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        var i = ["ck", "ck-link-form"];
        e.length && i.push("ck-link-form_layout-vertical"), _this206.setTemplate({
          tag: "form",
          attributes: {
            class: i,
            tabindex: "-1"
          },
          children: _this206.children
        });
        return _this206;
      }

      _createClass(Wm, [{
        key: "getDecoratorSwitchesState",
        value: function getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce(function (t, e) {
            return t[e.name] = e.isOn, t;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this207 = this;

          _get(_getPrototypeOf(Wm.prototype), "render", this).call(this), _u({
            view: this
          }), [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]).forEach(function (t) {
            _this207._focusables.add(t), _this207.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var t = this.locale.t,
              e = new wu(this.locale, ku);
          return e.label = t("bf"), e.inputView.placeholder = "https://example.com", e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new Wd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }, {
        key: "_createManualDecoratorSwitches",
        value: function _createManualDecoratorSwitches(t) {
          var _this208 = this;

          var e = this.createCollection();

          var _iterator319 = _createForOfIteratorHelper(t),
              _step319;

          try {
            var _loop8 = function _loop8() {
              var n = _step319.value;
              var t = new Pf(_this208.locale);
              t.set({
                name: n.id,
                label: n.label,
                withText: !0
              }), t.bind("isOn").to(n, "value"), t.on("execute", function () {
                n.set("value", !t.isOn);
              }), e.add(t);
            };

            for (_iterator319.s(); !(_step319 = _iterator319.n()).done;) {
              _loop8();
            }
          } catch (err) {
            _iterator319.e(err);
          } finally {
            _iterator319.f();
          }

          return e;
        }
      }, {
        key: "_createFormChildren",
        value: function _createFormChildren(t) {
          var e = this.createCollection();

          if (e.add(this.urlInputView), t.length) {
            var _t263 = new Dl();

            _t263.setTemplate({
              tag: "ul",
              children: this._manualDecoratorSwitches.map(function (t) {
                return {
                  tag: "li",
                  children: [t],
                  attributes: {
                    class: ["ck", "ck-list__item"]
                  }
                };
              }),
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              }
            }), e.add(_t263);
          }

          return e.add(this.saveButtonView), e.add(this.cancelButtonView), e;
        }
      }]);

      return Wm;
    }(Dl);

    var Ym = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>',
        $m = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>';
    n(77);

    var Gm = /*#__PURE__*/function (_Dl24) {
      _inherits(Gm, _Dl24);

      var _super136 = _createSuper(Gm);

      function Gm(t) {
        var _this209;

        _classCallCheck(this, Gm);

        _this209 = _super136.call(this, t);
        var e = t.t;
        _this209.focusTracker = new sl(), _this209.keystrokes = new Jc(), _this209.previewButtonView = _this209._createPreviewButton(), _this209.unlinkButtonView = _this209._createButton(e("az"), Ym, "unlink"), _this209.editButtonView = _this209._createButton(e("ba"), $m, "edit"), _this209.set("href"), _this209._focusables = new gl(), _this209._focusCycler = new ql({
          focusables: _this209._focusables,
          focusTracker: _this209.focusTracker,
          keystrokeHandler: _this209.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this209.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions"],
            tabindex: "-1"
          },
          children: [_this209.previewButtonView, _this209.editButtonView, _this209.unlinkButtonView]
        });
        return _this209;
      }

      _createClass(Gm, [{
        key: "render",
        value: function render() {
          var _this210 = this;

          _get(_getPrototypeOf(Gm.prototype), "render", this).call(this), [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach(function (t) {
            _this210._focusables.add(t), _this210.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n) {
          var i = new Wd(this.locale);
          return i.set({
            label: t,
            icon: e,
            tooltip: !0
          }), i.delegate("execute").to(this, n), i;
        }
      }, {
        key: "_createPreviewButton",
        value: function _createPreviewButton() {
          var t = new Wd(this.locale),
              e = this.bindTemplate,
              n = this.t;
          return t.set({
            withText: !0,
            tooltip: n("bb")
          }), t.extendTemplate({
            attributes: {
              class: ["ck", "ck-link-actions__preview"],
              href: e.to("href", function (t) {
                return t && Em(t);
              }),
              target: "_blank"
            }
          }), t.bind("label").to(this, "href", function (t) {
            return t || n("bc");
          }), t.bind("isEnabled").to(this, "href", function (t) {
            return !!t;
          }), t.template.tag = "a", t.template.eventListeners = {}, t;
        }
      }]);

      return Gm;
    }(Dl);

    var Qm = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
    var Km = "Ctrl+K";

    var Jm = /*#__PURE__*/function (_Kl43) {
      _inherits(Jm, _Kl43);

      var _super137 = _createSuper(Jm);

      function Jm() {
        _classCallCheck(this, Jm);

        return _super137.apply(this, arguments);
      }

      _createClass(Jm, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.editing.view.addObserver(qm), this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._balloon = t.plugins.get(Lu), this._createToolbarLinkButton(), this._enableUserBalloonInteractions();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Jm.prototype), "destroy", this).call(this), this.formView.destroy();
        }
      }, {
        key: "_createActionsView",
        value: function _createActionsView() {
          var _this211 = this;

          var t = this.editor,
              e = new Gm(t.locale),
              n = t.commands.get("link"),
              i = t.commands.get("unlink");
          return e.bind("href").to(n, "value"), e.editButtonView.bind("isEnabled").to(n), e.unlinkButtonView.bind("isEnabled").to(i), this.listenTo(e, "edit", function () {
            _this211._addFormView();
          }), this.listenTo(e, "unlink", function () {
            t.execute("unlink"), _this211._hideUI();
          }), e.keystrokes.set("Esc", function (t, e) {
            _this211._hideUI(), e();
          }), e.keystrokes.set(Km, function (t, e) {
            _this211._addFormView(), e();
          }), e;
        }
      }, {
        key: "_createFormView",
        value: function _createFormView() {
          var _this212 = this;

          var t = this.editor,
              e = t.commands.get("link"),
              n = new Wm(t.locale, e.manualDecorators);
          return n.urlInputView.bind("value").to(e, "value"), n.urlInputView.bind("isReadOnly").to(e, "isEnabled", function (t) {
            return !t;
          }), n.saveButtonView.bind("isEnabled").to(e), this.listenTo(n, "submit", function () {
            t.execute("link", n.urlInputView.inputView.element.value, n.getDecoratorSwitchesState()), _this212._closeFormView();
          }), this.listenTo(n, "cancel", function () {
            _this212._closeFormView();
          }), n.keystrokes.set("Esc", function (t, e) {
            _this212._closeFormView(), e();
          }), n;
        }
      }, {
        key: "_createToolbarLinkButton",
        value: function _createToolbarLinkButton() {
          var _this213 = this;

          var t = this.editor,
              e = t.commands.get("link"),
              n = t.t;
          t.keystrokes.set(Km, function (t, n) {
            n(), e.isEnabled && _this213._showUI(!0);
          }), t.ui.componentFactory.add("link", function (t) {
            var i = new Wd(t);
            return i.isEnabled = !0, i.label = n("aq"), i.icon = Qm, i.keystroke = Km, i.tooltip = !0, i.isToggleable = !0, i.bind("isEnabled").to(e, "isEnabled"), i.bind("isOn").to(e, "value", function (t) {
              return !!t;
            }), _this213.listenTo(i, "execute", function () {
              return _this213._showUI(!0);
            }), i;
          });
        }
      }, {
        key: "_enableUserBalloonInteractions",
        value: function _enableUserBalloonInteractions() {
          var _this214 = this;

          var t = this.editor.editing.view.document;
          this.listenTo(t, "click", function () {
            _this214._getSelectedLinkElement() && _this214._showUI();
          }), this.editor.keystrokes.set("Tab", function (t, e) {
            _this214._areActionsVisible && !_this214.actionsView.focusTracker.isFocused && (_this214.actionsView.focus(), e());
          }, {
            priority: "high"
          }), this.editor.keystrokes.set("Esc", function (t, e) {
            _this214._isUIVisible && (_this214._hideUI(), e());
          }), bu({
            emitter: this.formView,
            activator: function activator() {
              return _this214._isUIInPanel;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this214._hideUI();
            }
          });
        }
      }, {
        key: "_addActionsView",
        value: function _addActionsView() {
          this._areActionsInPanel || this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          });
        }
      }, {
        key: "_addFormView",
        value: function _addFormView() {
          if (this._isFormInPanel) return;
          var t = this.editor.commands.get("link");
          this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          }), this._balloon.visibleView === this.formView && this.formView.urlInputView.select(), this.formView.urlInputView.inputView.element.value = t.value || "";
        }
      }, {
        key: "_closeFormView",
        value: function _closeFormView() {
          var t = this.editor.commands.get("link");
          t.restoreManualDecoratorStates(), void 0 !== t.value ? this._removeFormView() : this._hideUI();
        }
      }, {
        key: "_removeFormView",
        value: function _removeFormView() {
          this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus());
        }
      }, {
        key: "_showUI",
        value: function _showUI() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
          this.editor.commands.get("link").isEnabled && (this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t && this._balloon.showStack("main")) : (this._addActionsView(), t && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI());
        }
      }, {
        key: "_hideUI",
        value: function _hideUI() {
          if (!this._isUIInPanel) return;
          var t = this.editor;
          this.stopListening(t.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView);
        }
      }, {
        key: "_startUpdatingUI",
        value: function _startUpdatingUI() {
          var _this215 = this;

          var t = this.editor,
              e = t.editing.view.document;

          var n = this._getSelectedLinkElement(),
              i = r();

          var o = function o() {
            var t = _this215._getSelectedLinkElement(),
                e = r();

            n && !t || !n && e !== i ? _this215._hideUI() : _this215._isUIVisible && _this215._balloon.updatePosition(_this215._getBalloonPositionData()), n = t, i = e;
          };

          function r() {
            return e.selection.focus.getAncestors().reverse().find(function (t) {
              return t.is("element");
            });
          }

          this.listenTo(t.ui, "update", o), this.listenTo(this._balloon, "change:visibleView", o);
        }
      }, {
        key: "_isFormInPanel",
        get: function get() {
          return this._balloon.hasView(this.formView);
        }
      }, {
        key: "_areActionsInPanel",
        get: function get() {
          return this._balloon.hasView(this.actionsView);
        }
      }, {
        key: "_areActionsVisible",
        get: function get() {
          return this._balloon.visibleView === this.actionsView;
        }
      }, {
        key: "_isUIInPanel",
        get: function get() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          return this._balloon.visibleView == this.formView || this._areActionsVisible;
        }
      }, {
        key: "_getBalloonPositionData",
        value: function _getBalloonPositionData() {
          var t = this.editor.editing.view,
              e = t.document,
              n = this._getSelectedLinkElement();

          return {
            target: n ? t.domConverter.mapViewToDom(n) : t.domConverter.viewRangeToDom(e.selection.getFirstRange())
          };
        }
      }, {
        key: "_getSelectedLinkElement",
        value: function _getSelectedLinkElement() {
          var t = this.editor.editing.view,
              e = t.document.selection;
          if (e.isCollapsed) return Zm(e.getFirstPosition());
          {
            var _n213 = e.getFirstRange().getTrimmed(),
                _i170 = Zm(_n213.start),
                _o83 = Zm(_n213.end);

            return _i170 && _i170 == _o83 && t.createRangeIn(_i170).getTrimmed().isEqual(_n213) ? _i170 : null;
          }
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Lu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "LinkUI";
        }
      }]);

      return Jm;
    }(Kl);

    function Zm(t) {
      return t.getAncestors().find(function (t) {
        return function (t) {
          return t.is("attributeElement") && !!t.getCustomProperty("link");
        }(t);
      });
    }

    var Xm = /*#__PURE__*/function (_ed17) {
      _inherits(Xm, _ed17);

      var _super138 = _createSuper(Xm);

      function Xm(t, e) {
        var _this216;

        _classCallCheck(this, Xm);

        _this216 = _super138.call(this, t), _this216.type = e;
        return _this216;
      }

      _createClass(Xm, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this217 = this;

          var t = this.editor.model,
              e = t.document,
              n = Array.from(e.selection.getSelectedBlocks()).filter(function (e) {
            return eg(e, t.schema);
          }),
              i = !0 === this.value;
          t.change(function (t) {
            if (i) {
              var _e241 = n[n.length - 1].nextSibling,
                  _i171 = Number.POSITIVE_INFINITY,
                  _o84 = [];

              for (; _e241 && "listItem" == _e241.name && 0 !== _e241.getAttribute("listIndent");) {
                var _t264 = _e241.getAttribute("listIndent");

                _t264 < _i171 && (_i171 = _t264);

                var _n214 = _t264 - _i171;

                _o84.push({
                  element: _e241,
                  listIndent: _n214
                }), _e241 = _e241.nextSibling;
              }

              _o84 = _o84.reverse();

              var _iterator320 = _createForOfIteratorHelper(_o84),
                  _step320;

              try {
                for (_iterator320.s(); !(_step320 = _iterator320.n()).done;) {
                  var _e242 = _step320.value;
                  t.setAttribute("listIndent", _e242.listIndent, _e242.element);
                }
              } catch (err) {
                _iterator320.e(err);
              } finally {
                _iterator320.f();
              }
            }

            if (!i) {
              var _t265 = Number.POSITIVE_INFINITY;

              var _iterator321 = _createForOfIteratorHelper(n),
                  _step321;

              try {
                for (_iterator321.s(); !(_step321 = _iterator321.n()).done;) {
                  var _e243 = _step321.value;
                  _e243.is("listItem") && _e243.getAttribute("listIndent") < _t265 && (_t265 = _e243.getAttribute("listIndent"));
                }
              } catch (err) {
                _iterator321.e(err);
              } finally {
                _iterator321.f();
              }

              tg(n, !0, _t265 = 0 === _t265 ? 1 : _t265), tg(n, !1, _t265);
            }

            var _iterator322 = _createForOfIteratorHelper(n.reverse()),
                _step322;

            try {
              for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
                var _e244 = _step322.value;
                i && "listItem" == _e244.name ? t.rename(_e244, "paragraph") : i || "listItem" == _e244.name ? i || "listItem" != _e244.name || _e244.getAttribute("listType") == _this217.type || t.setAttribute("listType", _this217.type, _e244) : (t.setAttributes({
                  listType: _this217.type,
                  listIndent: 0
                }, _e244), t.rename(_e244, "listItem"));
              }
            } catch (err) {
              _iterator322.e(err);
            } finally {
              _iterator322.f();
            }
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = vh(this.editor.model.document.selection.getSelectedBlocks());
          return !!t && t.is("listItem") && t.getAttribute("listType") == this.type;
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var t = this.editor.model.document.selection,
              e = this.editor.model.schema,
              n = vh(t.getSelectedBlocks());
          return !!n && eg(n, e);
        }
      }]);

      return Xm;
    }(ed);

    function tg(t, e, n) {
      var i = e ? t[0] : t[t.length - 1];

      if (i.is("listItem")) {
        var _o85 = i[e ? "previousSibling" : "nextSibling"],
            _r41 = i.getAttribute("listIndent");

        for (; _o85 && _o85.is("listItem") && _o85.getAttribute("listIndent") >= n;) {
          _r41 > _o85.getAttribute("listIndent") && (_r41 = _o85.getAttribute("listIndent")), _o85.getAttribute("listIndent") == _r41 && t[e ? "unshift" : "push"](_o85), _o85 = _o85[e ? "previousSibling" : "nextSibling"];
        }
      }
    }

    function eg(t, e) {
      return e.checkChild(t.parent, "listItem") && !e.isObject(t);
    }

    var ng = /*#__PURE__*/function (_ed18) {
      _inherits(ng, _ed18);

      var _super139 = _createSuper(ng);

      function ng(t, e) {
        var _this218;

        _classCallCheck(this, ng);

        _this218 = _super139.call(this, t), _this218._indentBy = "forward" == e ? 1 : -1;
        return _this218;
      }

      _createClass(ng, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this219 = this;

          var t = this.editor.model,
              e = t.document;
          var n = Array.from(e.selection.getSelectedBlocks());
          t.change(function (t) {
            var e = n[n.length - 1];
            var i = e.nextSibling;

            for (; i && "listItem" == i.name && i.getAttribute("listIndent") > e.getAttribute("listIndent");) {
              n.push(i), i = i.nextSibling;
            }

            _this219._indentBy < 0 && (n = n.reverse());

            var _iterator323 = _createForOfIteratorHelper(n),
                _step323;

            try {
              for (_iterator323.s(); !(_step323 = _iterator323.n()).done;) {
                var _e245 = _step323.value;

                var _n215 = _e245.getAttribute("listIndent") + _this219._indentBy;

                _n215 < 0 ? t.rename(_e245, "paragraph") : t.setAttribute("listIndent", _n215, _e245);
              }
            } catch (err) {
              _iterator323.e(err);
            } finally {
              _iterator323.f();
            }
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var t = vh(this.editor.model.document.selection.getSelectedBlocks());
          if (!t || !t.is("listItem")) return !1;

          if (this._indentBy > 0) {
            var _e246 = t.getAttribute("listIndent"),
                _n216 = t.getAttribute("listType");

            var _i172 = t.previousSibling;

            for (; _i172 && _i172.is("listItem") && _i172.getAttribute("listIndent") >= _e246;) {
              if (_i172.getAttribute("listIndent") == _e246) return _i172.getAttribute("listType") == _n216;
              _i172 = _i172.previousSibling;
            }

            return !1;
          }

          return !0;
        }
      }]);

      return ng;
    }(ed);

    function ig(t, e) {
      var n = e.mapper,
          i = e.writer,
          o = "numbered" == t.getAttribute("listType") ? "ol" : "ul",
          r = function (t) {
        var e = t.createContainerElement("li");
        return e.getFillerOffset = lg, e;
      }(i),
          s = i.createContainerElement(o, null);

      return i.insert(i.createPositionAt(s, 0), r), n.bindElements(t, r), r;
    }

    function og(t, e, n, i) {
      var o = e.parent,
          r = n.mapper,
          s = n.writer;
      var a = r.toViewPosition(i.createPositionBefore(t));
      var c = ag(t.previousSibling, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: t.getAttribute("listIndent")
      }),
          l = t.previousSibling;

      if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
        var _t266 = r.toViewElement(c);

        a = s.breakContainer(s.createPositionAfter(_t266));
      } else a = l && "listItem" == l.name ? r.toViewPosition(i.createPositionAt(l, "end")) : r.toViewPosition(i.createPositionBefore(t));

      if (a = sg(a), s.insert(a, o), l && "listItem" == l.name) {
        var _t267 = r.toViewElement(l),
            _n217 = s.createRange(s.createPositionAt(_t267, 0), a).getWalker({
          ignoreElementEnd: !0
        });

        var _iterator324 = _createForOfIteratorHelper(_n217),
            _step324;

        try {
          for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
            var _t268 = _step324.value;

            if (_t268.item.is("li")) {
              var _i173 = s.breakContainer(s.createPositionBefore(_t268.item)),
                  _o86 = _t268.item.parent,
                  _r42 = s.createPositionAt(e, "end");

              rg(s, _r42.nodeBefore, _r42.nodeAfter), s.move(s.createRangeOn(_o86), _r42), _n217.position = _i173;
            }
          }
        } catch (err) {
          _iterator324.e(err);
        } finally {
          _iterator324.f();
        }
      } else {
        var _n218 = o.nextSibling;

        if (_n218 && (_n218.is("ul") || _n218.is("ol"))) {
          var _i174 = null;

          var _iterator325 = _createForOfIteratorHelper(_n218.getChildren()),
              _step325;

          try {
            for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
              var _e247 = _step325.value;

              var _n219 = r.toModelElement(_e247);

              if (!(_n219 && _n219.getAttribute("listIndent") > t.getAttribute("listIndent"))) break;
              _i174 = _e247;
            }
          } catch (err) {
            _iterator325.e(err);
          } finally {
            _iterator325.f();
          }

          _i174 && (s.breakContainer(s.createPositionAfter(_i174)), s.move(s.createRangeOn(_i174.parent), s.createPositionAt(e, "end")));
        }
      }

      rg(s, o, o.nextSibling), rg(s, o.previousSibling, o);
    }

    function rg(t, e, n) {
      return !e || !n || "ul" != e.name && "ol" != e.name ? null : e.name != n.name || e.getAttribute("class") !== n.getAttribute("class") ? null : t.mergeContainers(t.createPositionAfter(e));
    }

    function sg(t) {
      return t.getLastMatchingPosition(function (t) {
        return t.item.is("uiElement");
      });
    }

    function ag(t, e) {
      var n = !!e.sameIndent,
          i = !!e.smallerIndent,
          o = e.listIndent;
      var r = t;

      for (; r && "listItem" == r.name;) {
        var _t269 = r.getAttribute("listIndent");

        if (n && o == _t269 || i && o > _t269) return r;
        r = r.previousSibling;
      }

      return null;
    }

    function cg(t, e, n, i) {
      t.ui.componentFactory.add(e, function (o) {
        var r = t.commands.get(e),
            s = new Wd(o);
        return s.set({
          label: n,
          icon: i,
          tooltip: !0,
          isToggleable: !0
        }), s.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), s.on("execute", function () {
          return t.execute(e);
        }), s;
      });
    }

    function lg() {
      var t = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
      return this.isEmpty || t ? 0 : xi.call(this);
    }

    function dg(t) {
      return function (e, n, i) {
        var o = i.consumable;
        if (!o.test(n.item, "insert") || !o.test(n.item, "attribute:listType") || !o.test(n.item, "attribute:listIndent")) return;
        o.consume(n.item, "insert"), o.consume(n.item, "attribute:listType"), o.consume(n.item, "attribute:listIndent");
        var r = n.item;
        og(r, ig(r, i), i, t);
      };
    }

    function hg(t, e, n) {
      if (!n.consumable.consume(e.item, "attribute:listType")) return;
      var i = n.mapper.toViewElement(e.item),
          o = n.writer;
      o.breakContainer(o.createPositionBefore(i)), o.breakContainer(o.createPositionAfter(i));
      var r = i.parent,
          s = "numbered" == e.attributeNewValue ? "ol" : "ul";
      o.rename(s, r);
    }

    function ug(t, e, n) {
      var i = n.mapper.toViewElement(e.item).parent,
          o = n.writer;
      rg(o, i, i.nextSibling), rg(o, i.previousSibling, i);

      var _iterator326 = _createForOfIteratorHelper(e.item.getChildren()),
          _step326;

      try {
        for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
          var _t270 = _step326.value;
          n.consumable.consume(_t270, "insert");
        }
      } catch (err) {
        _iterator326.e(err);
      } finally {
        _iterator326.f();
      }
    }

    function fg(t, e, n) {
      if ("listItem" != e.item.name) {
        var _t271 = n.mapper.toViewPosition(e.range.start);

        var _i175 = n.writer,
            _o87 = [];

        for (; ("ul" == _t271.parent.name || "ol" == _t271.parent.name) && "li" == (_t271 = _i175.breakContainer(_t271)).parent.name;) {
          var _e248 = _t271,
              _n220 = _i175.createPositionAt(_t271.parent, "end");

          if (!_e248.isEqual(_n220)) {
            var _t272 = _i175.remove(_i175.createRange(_e248, _n220));

            _o87.push(_t272);
          }

          _t271 = _i175.createPositionAfter(_t271.parent);
        }

        if (_o87.length > 0) {
          for (var _e249 = 0; _e249 < _o87.length; _e249++) {
            var _n221 = _t271.nodeBefore;

            if (_t271 = _i175.insert(_t271, _o87[_e249]).end, _e249 > 0) {
              var _e250 = rg(_i175, _n221, _n221.nextSibling);

              _e250 && _e250.parent == _n221 && _t271.offset--;
            }
          }

          rg(_i175, _t271.nodeBefore, _t271.nodeAfter);
        }
      }
    }

    function mg(t, e, n) {
      var i = n.mapper.toViewPosition(e.position),
          o = i.nodeBefore,
          r = i.nodeAfter;
      rg(n.writer, o, r);
    }

    function gg(t, e, n) {
      if (n.consumable.consume(e.viewItem, {
        name: !0
      })) {
        var _t273 = n.writer,
            _i176 = this.conversionApi.store,
            _o88 = _t273.createElement("listItem");

        _i176.indent = _i176.indent || 0, _t273.setAttribute("listIndent", _i176.indent, _o88);

        var _r43 = e.viewItem.parent && "ol" == e.viewItem.parent.name ? "numbered" : "bulleted";

        _t273.setAttribute("listType", _r43, _o88), _i176.indent++;

        var _s29 = n.splitToAllowedParent(_o88, e.modelCursor);

        if (!_s29) return;

        _t273.insert(_o88, _s29.position);

        var _a16 = function (t, e, n) {
          var i = n.writer,
              o = n.schema;
          var r = i.createPositionAfter(t);

          var _iterator327 = _createForOfIteratorHelper(e),
              _step327;

          try {
            for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
              var _s30 = _step327.value;
              if ("ul" == _s30.name || "ol" == _s30.name) r = n.convertItem(_s30, r).modelCursor;else {
                var _e251 = n.convertItem(_s30, i.createPositionAt(t, "end")),
                    _a17 = _e251.modelRange.start.nodeAfter,
                    _c9 = _a17 && _a17.is("element") && !o.checkChild(t, _a17.name);

                _c9 && (t = _e251.modelCursor.parent.is("listItem") ? _e251.modelCursor.parent : _g(_e251.modelCursor), r = i.createPositionAfter(t));
              }
            }
          } catch (err) {
            _iterator327.e(err);
          } finally {
            _iterator327.f();
          }

          return r;
        }(_o88, e.viewItem.getChildren(), n);

        _i176.indent--, e.modelRange = _t273.createRange(e.modelCursor, _a16), _s29.cursorParent ? e.modelCursor = _t273.createPositionAt(_s29.cursorParent, 0) : e.modelCursor = e.modelRange.end;
      }
    }

    function pg(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        var _t274 = Array.from(e.viewItem.getChildren());

        for (var _i177 = 0, _t275 = _t274; _i177 < _t275.length; _i177++) {
          var _e252 = _t275[_i177];
          _e252.is("li") || _e252._remove();
        }
      }
    }

    function bg(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: !0
      })) {
        if (0 === e.viewItem.childCount) return;

        var _t276 = _toConsumableArray(e.viewItem.getChildren());

        var _n222 = !1,
            _i178 = !0;

        var _iterator328 = _createForOfIteratorHelper(_t276),
            _step328;

        try {
          for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
            var _e253 = _step328.value;
            !_n222 || _e253.is("ul") || _e253.is("ol") || _e253._remove(), _e253.is("text") ? (_i178 && (_e253._data = _e253.data.replace(/^\s+/, "")), (!_e253.nextSibling || _e253.nextSibling.is("ul") || _e253.nextSibling.is("ol")) && (_e253._data = _e253.data.replace(/\s+$/, ""))) : (_e253.is("ul") || _e253.is("ol")) && (_n222 = !0), _i178 = !1;
          }
        } catch (err) {
          _iterator328.e(err);
        } finally {
          _iterator328.f();
        }
      }
    }

    function wg(t) {
      return function (e, n) {
        if (n.isPhantom) return;
        var i = n.modelPosition.nodeBefore;

        if (i && i.is("listItem")) {
          var _e254 = n.mapper.toViewElement(i),
              _o89 = _e254.getAncestors().find(function (t) {
            return t.is("ul") || t.is("ol");
          }),
              _r44 = t.createPositionAt(_e254, 0).getWalker();

          var _iterator329 = _createForOfIteratorHelper(_r44),
              _step329;

          try {
            for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
              var _t277 = _step329.value;

              if ("elementStart" == _t277.type && _t277.item.is("li")) {
                n.viewPosition = _t277.previousPosition;
                break;
              }

              if ("elementEnd" == _t277.type && _t277.item == _o89) {
                n.viewPosition = _t277.nextPosition;
                break;
              }
            }
          } catch (err) {
            _iterator329.e(err);
          } finally {
            _iterator329.f();
          }
        }
      };
    }

    function kg(t, _ref102) {
      var _ref103 = _slicedToArray(_ref102, 2),
          e = _ref103[0],
          n = _ref103[1];

      var i,
          o = e.is("documentFragment") ? e.getChild(0) : e;

      if (i = n ? this.createSelection(n) : this.document.selection, o && o.is("listItem")) {
        var _t278 = i.getFirstPosition();

        var _e255 = null;

        if (_t278.parent.is("listItem") ? _e255 = _t278.parent : _t278.nodeBefore && _t278.nodeBefore.is("listItem") && (_e255 = _t278.nodeBefore), _e255) {
          var _t279 = _e255.getAttribute("listIndent");

          if (_t279 > 0) for (; o && o.is("listItem");) {
            o._setAttribute("listIndent", o.getAttribute("listIndent") + _t279), o = o.nextSibling;
          }
        }
      }
    }

    function _g(t) {
      var e = new qs({
        startPosition: t
      });
      var n;

      do {
        n = e.next();
      } while (!n.value.item.is("listItem"));

      return n.value.item;
    }

    function vg(t, e, n, i, o, r) {
      var s = ag(e.nodeBefore, {
        sameIndent: !0,
        smallerIndent: !0,
        listIndent: t,
        foo: "b"
      }),
          a = o.mapper,
          c = o.writer,
          l = s ? s.getAttribute("listIndent") : null;
      var d;
      if (s) {
        if (l == t) {
          var _t280 = a.toViewElement(s).parent;
          d = c.createPositionAfter(_t280);
        } else {
          var _t281 = r.createPositionAt(s, "end");

          d = a.toViewPosition(_t281);
        }
      } else d = n;
      d = sg(d);

      for (var _i179 = 0, _arr2 = _toConsumableArray(i.getChildren()); _i179 < _arr2.length; _i179++) {
        var _t282 = _arr2[_i179];
        (_t282.is("ul") || _t282.is("ol")) && (d = c.move(c.createRangeOn(_t282), d).end, rg(c, _t282, _t282.nextSibling), rg(c, _t282.previousSibling, _t282));
      }
    }

    var yg = /*#__PURE__*/function (_Kl44) {
      _inherits(yg, _Kl44);

      var _super140 = _createSuper(yg);

      function yg() {
        _classCallCheck(this, yg);

        return _super140.apply(this, arguments);
      }

      _createClass(yg, [{
        key: "init",
        value: function init() {
          var _this220 = this;

          var t = this.editor;
          t.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: ["listType", "listIndent"]
          });
          var e = t.data,
              n = t.editing;
          t.model.document.registerPostFixer(function (e) {
            return function (t, e) {
              var n = t.document.differ.getChanges(),
                  i = new Map();
              var o = !1;

              var _iterator330 = _createForOfIteratorHelper(n),
                  _step330;

              try {
                for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
                  var _t283 = _step330.value;
                  if ("insert" == _t283.type && "listItem" == _t283.name) r(_t283.position);else if ("insert" == _t283.type && "listItem" != _t283.name) {
                    if ("$text" != _t283.name) {
                      var _n224 = _t283.position.nodeAfter;
                      _n224.hasAttribute("listIndent") && (e.removeAttribute("listIndent", _n224), o = !0), _n224.hasAttribute("listType") && (e.removeAttribute("listType", _n224), o = !0);
                    }

                    r(_t283.position.getShiftedBy(_t283.length));
                  } else "remove" == _t283.type && "listItem" == _t283.name ? r(_t283.position) : "attribute" == _t283.type && "listIndent" == _t283.attributeKey ? r(_t283.range.start) : "attribute" == _t283.type && "listType" == _t283.attributeKey && r(_t283.range.start);
                }
              } catch (err) {
                _iterator330.e(err);
              } finally {
                _iterator330.f();
              }

              var _iterator331 = _createForOfIteratorHelper(i.values()),
                  _step331;

              try {
                for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
                  var _t284 = _step331.value;
                  s(_t284), a(_t284);
                }
              } catch (err) {
                _iterator331.e(err);
              } finally {
                _iterator331.f();
              }

              return o;

              function r(t) {
                var e = t.nodeBefore;

                if (e && e.is("listItem")) {
                  var _n223 = e;
                  if (i.has(_n223)) return;

                  for (; _n223.previousSibling && _n223.previousSibling.is("listItem");) {
                    if (_n223 = _n223.previousSibling, i.has(_n223)) return;
                  }

                  i.set(t.nodeBefore, _n223);
                } else {
                  var _e256 = t.nodeAfter;
                  _e256 && _e256.is("listItem") && i.set(_e256, _e256);
                }
              }

              function s(t) {
                var n = 0,
                    i = null;

                for (; t && t.is("listItem");) {
                  var _r45 = t.getAttribute("listIndent");

                  if (_r45 > n) {
                    var _s31 = void 0;

                    null === i ? (i = _r45 - n, _s31 = n) : (i > _r45 && (i = _r45), _s31 = _r45 - i), e.setAttribute("listIndent", _s31, t), o = !0;
                  } else i = null, n = t.getAttribute("listIndent") + 1;

                  t = t.nextSibling;
                }
              }

              function a(t) {
                var n = [],
                    i = null;

                for (; t && t.is("listItem");) {
                  var _r46 = t.getAttribute("listIndent");

                  if (i && i.getAttribute("listIndent") > _r46 && (n = n.slice(0, _r46 + 1)), 0 != _r46) if (n[_r46]) {
                    var _i180 = n[_r46];
                    t.getAttribute("listType") != _i180 && (e.setAttribute("listType", _i180, t), o = !0);
                  } else n[_r46] = t.getAttribute("listType");
                  i = t, t = t.nextSibling;
                }
              }
            }(t.model, e);
          }), n.mapper.registerViewToModelLength("li", xg), e.mapper.registerViewToModelLength("li", xg), n.mapper.on("modelToViewPosition", wg(n.view)), n.mapper.on("viewToModelPosition", function (t) {
            return function (e, n) {
              var i = n.viewPosition,
                  o = i.parent,
                  r = n.mapper;

              if ("ul" == o.name || "ol" == o.name) {
                if (i.isAtEnd) {
                  var _e257 = r.toModelElement(i.nodeBefore),
                      _o90 = r.getModelLength(i.nodeBefore);

                  n.modelPosition = t.createPositionBefore(_e257).getShiftedBy(_o90);
                } else {
                  var _e258 = r.toModelElement(i.nodeAfter);

                  n.modelPosition = t.createPositionBefore(_e258);
                }

                e.stop();
              } else if ("li" == o.name && i.nodeBefore && ("ul" == i.nodeBefore.name || "ol" == i.nodeBefore.name)) {
                var _s32 = r.toModelElement(o);

                var _a18 = 1,
                    _c10 = i.nodeBefore;

                for (; _c10 && (_c10.is("ul") || _c10.is("ol"));) {
                  _a18 += r.getModelLength(_c10), _c10 = _c10.previousSibling;
                }

                n.modelPosition = t.createPositionBefore(_s32).getShiftedBy(_a18), e.stop();
              }
            };
          }(t.model)), e.mapper.on("modelToViewPosition", wg(n.view)), n.downcastDispatcher.on("insert", fg, {
            priority: "high"
          }), n.downcastDispatcher.on("insert:listItem", dg(t.model)), e.downcastDispatcher.on("insert", fg, {
            priority: "high"
          }), e.downcastDispatcher.on("insert:listItem", dg(t.model)), n.downcastDispatcher.on("attribute:listType:listItem", hg, {
            priority: "high"
          }), n.downcastDispatcher.on("attribute:listType:listItem", ug, {
            priority: "low"
          }), n.downcastDispatcher.on("attribute:listIndent:listItem", function (t) {
            return function (e, n, i) {
              if (!i.consumable.consume(n.item, "attribute:listIndent")) return;
              var o = i.mapper.toViewElement(n.item),
                  r = i.writer;
              r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
              var s = o.parent,
                  a = s.previousSibling,
                  c = r.createRangeOn(s);
              r.remove(c), a && a.nextSibling && rg(r, a, a.nextSibling), vg(n.attributeOldValue + 1, n.range.start, c.start, o, i, t), og(n.item, o, i, t);

              var _iterator332 = _createForOfIteratorHelper(n.item.getChildren()),
                  _step332;

              try {
                for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
                  var _t285 = _step332.value;
                  i.consumable.consume(_t285, "insert");
                }
              } catch (err) {
                _iterator332.e(err);
              } finally {
                _iterator332.f();
              }
            };
          }(t.model)), n.downcastDispatcher.on("remove:listItem", function (t) {
            return function (e, n, i) {
              var o = i.mapper.toViewPosition(n.position).getLastMatchingPosition(function (t) {
                return !t.item.is("li");
              }).nodeAfter,
                  r = i.writer;
              r.breakContainer(r.createPositionBefore(o)), r.breakContainer(r.createPositionAfter(o));
              var s = o.parent,
                  a = s.previousSibling,
                  c = r.createRangeOn(s),
                  l = r.remove(c);
              a && a.nextSibling && rg(r, a, a.nextSibling), vg(i.mapper.toModelElement(o).getAttribute("listIndent") + 1, n.position, c.start, o, i, t);

              var _iterator333 = _createForOfIteratorHelper(r.createRangeIn(l).getItems()),
                  _step333;

              try {
                for (_iterator333.s(); !(_step333 = _iterator333.n()).done;) {
                  var _t286 = _step333.value;
                  i.mapper.unbindViewElement(_t286);
                }
              } catch (err) {
                _iterator333.e(err);
              } finally {
                _iterator333.f();
              }

              e.stop();
            };
          }(t.model)), n.downcastDispatcher.on("remove", mg, {
            priority: "low"
          }), e.upcastDispatcher.on("element:ul", pg, {
            priority: "high"
          }), e.upcastDispatcher.on("element:ol", pg, {
            priority: "high"
          }), e.upcastDispatcher.on("element:li", bg, {
            priority: "high"
          }), e.upcastDispatcher.on("element:li", gg), t.model.on("insertContent", kg, {
            priority: "high"
          }), t.commands.add("numberedList", new Xm(t, "numbered")), t.commands.add("bulletedList", new Xm(t, "bulleted")), t.commands.add("indentList", new ng(t, "forward")), t.commands.add("outdentList", new ng(t, "backward"));
          var i = n.view.document;
          this.listenTo(i, "enter", function (t, e) {
            var n = _this220.editor.model.document,
                i = n.selection.getLastPosition().parent;
            n.selection.isCollapsed && "listItem" == i.name && i.isEmpty && (_this220.editor.execute("outdentList"), e.preventDefault(), t.stop());
          }), this.listenTo(i, "delete", function (t, e) {
            if ("backward" !== e.direction) return;
            var n = _this220.editor.model.document.selection;
            if (!n.isCollapsed) return;
            var i = n.getFirstPosition();
            if (!i.isAtStart) return;
            var o = i.parent;
            "listItem" === o.name && (o.previousSibling && "listItem" === o.previousSibling.name || (_this220.editor.execute("outdentList"), e.preventDefault(), t.stop()));
          }, {
            priority: "high"
          });

          var o = function o(t) {
            return function (e, n) {
              _this220.editor.commands.get(t).isEnabled && (_this220.editor.execute(t), n());
            };
          };

          t.keystrokes.set("Tab", o("indentList")), t.keystrokes.set("Shift+Tab", o("outdentList"));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor.commands,
              e = t.get("indent"),
              n = t.get("outdent");
          e && e.registerChildCommand(t.get("indentList")), n && n.registerChildCommand(t.get("outdentList"));
        }
      }], [{
        key: "requires",
        get: function get() {
          return [uf];
        }
      }]);

      return yg;
    }(Kl);

    function xg(t) {
      var e = 1;

      var _iterator334 = _createForOfIteratorHelper(t.getChildren()),
          _step334;

      try {
        for (_iterator334.s(); !(_step334 = _iterator334.n()).done;) {
          var _n225 = _step334.value;

          if ("ul" == _n225.name || "ol" == _n225.name) {
            var _iterator335 = _createForOfIteratorHelper(_n225.getChildren()),
                _step335;

            try {
              for (_iterator335.s(); !(_step335 = _iterator335.n()).done;) {
                var _t287 = _step335.value;
                e += xg(_t287);
              }
            } catch (err) {
              _iterator335.e(err);
            } finally {
              _iterator335.f();
            }
          }
        }
      } catch (err) {
        _iterator334.e(err);
      } finally {
        _iterator334.f();
      }

      return e;
    }

    var Ag = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>',
        Tg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';

    var Cg = /*#__PURE__*/function (_Kl45) {
      _inherits(Cg, _Kl45);

      var _super141 = _createSuper(Cg);

      function Cg() {
        _classCallCheck(this, Cg);

        return _super141.apply(this, arguments);
      }

      _createClass(Cg, [{
        key: "init",
        value: function init() {
          var t = this.editor.t;
          cg(this.editor, "numberedList", t("q"), Ag), cg(this.editor, "bulletedList", t("r"), Tg);
        }
      }]);

      return Cg;
    }(Kl);

    function Pg(t, e) {
      return function (t) {
        t.on("attribute:url:media", n);
      };

      function n(n, i, o) {
        if (!o.consumable.consume(i.item, n.name)) return;
        var r = i.attributeNewValue,
            s = o.writer,
            a = o.mapper.toViewElement(i.item);
        s.remove(s.createRangeIn(a));
        var c = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), c);
      }
    }

    function Sg(t, e, n, i) {
      var o = t.createContainerElement("figure", {
        class: "media"
      });
      return o.getFillerOffset = Ig, t.insert(t.createPositionAt(o, 0), e.getMediaViewElement(t, n, i)), o;
    }

    function Mg(t) {
      var e = t.getSelectedElement();
      return e && e.is("media") ? e : null;
    }

    function Eg(t, e, n) {
      t.change(function (i) {
        var o = i.createElement("media", {
          url: e
        });
        t.insertContent(o, n), i.setSelection(o, "on");
      });
    }

    function Ig() {
      return null;
    }

    var Ng = /*#__PURE__*/function (_ed19) {
      _inherits(Ng, _ed19);

      var _super142 = _createSuper(Ng);

      function Ng() {
        _classCallCheck(this, Ng);

        return _super142.apply(this, arguments);
      }

      _createClass(Ng, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema,
              i = e.getFirstPosition(),
              o = Mg(e);
          var r = i.parent;
          r != r.root && (r = r.parent), this.value = o ? o.getAttribute("url") : null, this.isEnabled = n.checkChild(r, "media");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model,
              n = e.document.selection,
              i = Mg(n);
          if (i) e.change(function (e) {
            e.setAttribute("url", t, i);
          });else {
            var _i181 = nu(n, e);

            Eg(e, t, _i181);
          }
        }
      }]);

      return Ng;
    }(ed);

    var Og = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>';
    var Rg = "0 0 64 42";

    var Dg = /*#__PURE__*/function () {
      function Dg(t, e) {
        _classCallCheck(this, Dg);

        var n = e.providers,
            i = e.extraProviders || [],
            o = new Set(e.removeProviders),
            r = n.concat(i).filter(function (t) {
          var e = t.name;
          return e ? !o.has(e) : (console.warn(Object(Gn.a)("media-embed-no-provider-name: The configured media provider has no name and cannot be used."), {
            provider: t
          }), !1);
        });
        this.locale = t, this.providerDefinitions = r;
      }

      _createClass(Dg, [{
        key: "hasMedia",
        value: function hasMedia(t) {
          return !!this._getMedia(t);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(t, e, n) {
          return this._getMedia(e).getViewElement(t, n);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(t) {
          if (!t) return new Lg(this.locale);
          t = t.trim();

          var _iterator336 = _createForOfIteratorHelper(this.providerDefinitions),
              _step336;

          try {
            for (_iterator336.s(); !(_step336 = _iterator336.n()).done;) {
              var _e259 = _step336.value;
              var _n226 = _e259.html;
              var _i182 = _e259.url;
              Array.isArray(_i182) || (_i182 = [_i182]);

              var _iterator337 = _createForOfIteratorHelper(_i182),
                  _step337;

              try {
                for (_iterator337.s(); !(_step337 = _iterator337.n()).done;) {
                  var _e260 = _step337.value;

                  var _i183 = this._getUrlMatches(t, _e260);

                  if (_i183) return new Lg(this.locale, t, _i183, _n226);
                }
              } catch (err) {
                _iterator337.e(err);
              } finally {
                _iterator337.f();
              }
            }
          } catch (err) {
            _iterator336.e(err);
          } finally {
            _iterator336.f();
          }

          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(t, e) {
          var n = t.match(e);
          if (n) return n;
          var i = t.replace(/^https?:\/\//, "");
          return (n = i.match(e)) ? n : (n = (i = i.replace(/^www\./, "")).match(e)) || null;
        }
      }]);

      return Dg;
    }();

    var Lg = /*#__PURE__*/function () {
      function Lg(t, e, n, i) {
        _classCallCheck(this, Lg);

        this.url = this._getValidUrl(e), this._t = t.t, this._match = n, this._previewRenderer = i;
      }

      _createClass(Lg, [{
        key: "getViewElement",
        value: function getViewElement(t, e) {
          var n = {};

          if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
            this.url && (n["data-oembed-url"] = this.url), e.renderForEditingView && (n.class = "ck-media__wrapper");

            var _i184 = this._getPreviewHtml(e);

            return t.createUIElement("div", n, function (t) {
              var e = this.toDomElement(t);
              return e.innerHTML = _i184, e;
            });
          }

          return this.url && (n.url = this.url), t.createEmptyElement("oembed", n);
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(t) {
          return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t.renderForEditingView ? this._getPlaceholderHtml() : "";
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var t = new qd(),
              e = new Hd();
          return t.text = this._t("Open media in new tab"), e.content = Og, e.viewBox = Rg, new bl({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [e]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, t]
            }]
          }).render().outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(t) {
          return t ? t.match(/^https?/) ? t : "https://" + t : null;
        }
      }]);

      return Lg;
    }();

    n(79);

    var jg = /*#__PURE__*/function (_Kl46) {
      _inherits(jg, _Kl46);

      var _super143 = _createSuper(jg);

      function jg(t) {
        var _this221;

        _classCallCheck(this, jg);

        _this221 = _super143.call(this, t), t.config.define("mediaEmbed", {
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; ">' + "<iframe src=\"https://www.dailymotion.com/embed/video/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>';
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' + "<iframe src=\"https://open.spotify.com/embed/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>';
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://www.youtube.com/embed/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>';
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(t) {
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://player.vimeo.com/video/".concat(t[1], "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: /^google\.com\/maps/
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        }), _this221.registry = new Dg(t.locale, t.config.get("mediaEmbed"));
        return _this221;
      }

      _createClass(jg, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = t.model.schema,
              n = t.t,
              i = t.conversion,
              o = t.config.get("mediaEmbed.previewsInData"),
              r = this.registry;
          t.commands.add("mediaEmbed", new Ng(t)), e.register("media", {
            isObject: !0,
            isBlock: !0,
            allowWhere: "$block",
            allowAttributes: ["url"]
          }), i.for("dataDowncast").elementToElement({
            model: "media",
            view: function view(t, e) {
              var n = t.getAttribute("url");
              return Sg(e, r, n, {
                renderMediaPreview: n && o
              });
            }
          }), i.for("dataDowncast").add(Pg(r, {
            renderMediaPreview: o
          })), i.for("editingDowncast").elementToElement({
            model: "media",
            view: function view(t, e) {
              var i = t.getAttribute("url");
              return function (t, e, n) {
                return e.setCustomProperty("media", !0, t), Xh(t, e, {
                  label: n
                });
              }(Sg(e, r, i, {
                renderForEditingView: !0
              }), e, n("am"));
            }
          }), i.for("editingDowncast").add(Pg(r, {
            renderForEditingView: !0
          })), i.for("upcast").elementToElement({
            view: {
              name: "oembed",
              attributes: {
                url: !0
              }
            },
            model: function model(t, e) {
              var n = t.getAttribute("url");
              if (r.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": !0
              }
            },
            model: function model(t, e) {
              var n = t.getAttribute("data-oembed-url");
              if (r.hasMedia(n)) return e.createElement("media", {
                url: n
              });
            }
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);

      return jg;
    }(Kl);

    var Vg = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]+$/;

    var zg = /*#__PURE__*/function (_Kl47) {
      _inherits(zg, _Kl47);

      var _super144 = _createSuper(zg);

      function zg(t) {
        var _this222;

        _classCallCheck(this, zg);

        _this222 = _super144.call(this, t), _this222._timeoutId = null, _this222._positionToInsert = null;
        return _this222;
      }

      _createClass(zg, [{
        key: "init",
        value: function init() {
          var _this223 = this;

          var t = this.editor,
              e = t.model.document;
          this.listenTo(t.plugins.get(td), "inputTransformation", function () {
            var t = e.selection.getFirstRange(),
                n = Dc.fromPosition(t.start);
            n.stickiness = "toPrevious";
            var i = Dc.fromPosition(t.end);
            i.stickiness = "toNext", e.once("change:data", function () {
              _this223._embedMediaBetweenPositions(n, i), n.detach(), i.detach();
            }, {
              priority: "high"
            });
          }), t.commands.get("undo").on("execute", function () {
            _this223._timeoutId && (nr.window.clearTimeout(_this223._timeoutId), _this223._positionToInsert.detach(), _this223._timeoutId = null, _this223._positionToInsert = null);
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(t, e) {
          var _this224 = this;

          var n = this.editor,
              i = n.plugins.get(jg).registry,
              o = new oa(t, e),
              r = o.getWalker({
            ignoreElementEnd: !0
          });
          var s = "";

          var _iterator338 = _createForOfIteratorHelper(r),
              _step338;

          try {
            for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
              var _t288 = _step338.value;
              _t288.item.is("textProxy") && (s += _t288.item.data);
            }
          } catch (err) {
            _iterator338.e(err);
          } finally {
            _iterator338.f();
          }

          if (!(s = s.trim()).match(Vg)) return;
          if (!i.hasMedia(s)) return;
          n.commands.get("mediaEmbed").isEnabled && (this._positionToInsert = Dc.fromPosition(t), this._timeoutId = nr.window.setTimeout(function () {
            n.model.change(function (t) {
              var e;
              _this224._timeoutId = null, t.remove(o), "$graveyard" !== _this224._positionToInsert.root.rootName && (e = _this224._positionToInsert), Eg(n.model, s, e), _this224._positionToInsert.detach(), _this224._positionToInsert = null;
            });
          }, 100));
        }
      }], [{
        key: "requires",
        get: function get() {
          return [td, Qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);

      return zg;
    }(Kl);

    n(81);

    var Bg = /*#__PURE__*/function (_Dl25) {
      _inherits(Bg, _Dl25);

      var _super145 = _createSuper(Bg);

      function Bg(t, e) {
        var _this225;

        _classCallCheck(this, Bg);

        _this225 = _super145.call(this, e);
        var n = e.t;
        _this225.focusTracker = new sl(), _this225.keystrokes = new Jc(), _this225.urlInputView = _this225._createUrlInput(), _this225.saveButtonView = _this225._createButton(n("bd"), vu, "ck-button-save"), _this225.saveButtonView.type = "submit", _this225.cancelButtonView = _this225._createButton(n("be"), yu, "ck-button-cancel", "cancel"), _this225._focusables = new gl(), _this225._focusCycler = new ql({
          focusables: _this225._focusables,
          focusTracker: _this225.focusTracker,
          keystrokeHandler: _this225.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        }), _this225._validators = t, _this225.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form"],
            tabindex: "-1"
          },
          children: [_this225.urlInputView, _this225.saveButtonView, _this225.cancelButtonView]
        });
        return _this225;
      }

      _createClass(Bg, [{
        key: "render",
        value: function render() {
          var _this226 = this;

          _get(_getPrototypeOf(Bg.prototype), "render", this).call(this), _u({
            view: this
          }), [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this226._focusables.add(t), _this226.focusTracker.add(t.element);
          }), this.keystrokes.listenTo(this.element);

          var t = function t(_t289) {
            return _t289.stopPropagation();
          };

          this.keystrokes.set("arrowright", t), this.keystrokes.set("arrowleft", t), this.keystrokes.set("arrowup", t), this.keystrokes.set("arrowdown", t), this.listenTo(this.urlInputView.element, "selectstart", function (t, e) {
            e.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.inputView.element.value.trim();
        },
        set: function set(t) {
          this.urlInputView.inputView.element.value = t.trim();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();

          var _iterator339 = _createForOfIteratorHelper(this._validators),
              _step339;

          try {
            for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
              var _t290 = _step339.value;

              var _e261 = _t290(this);

              if (_e261) return this.urlInputView.errorText = _e261, !1;
            }
          } catch (err) {
            _iterator339.e(err);
          } finally {
            _iterator339.f();
          }

          return !0;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this227 = this;

          var t = this.locale.t,
              e = new wu(this.locale, ku),
              n = e.inputView;
          return this._urlInputViewInfoDefault = t("bg"), this._urlInputViewInfoTip = t("bh"), e.label = t("bi"), e.infoText = this._urlInputViewInfoDefault, n.placeholder = "https://example.com", n.on("input", function () {
            e.infoText = n.element.value ? _this227._urlInputViewInfoTip : _this227._urlInputViewInfoDefault;
          }), e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, i) {
          var o = new Wd(this.locale);
          return o.set({
            label: t,
            icon: e,
            tooltip: !0
          }), o.extendTemplate({
            attributes: {
              class: n
            }
          }), i && o.delegate("execute").to(this, i), o;
        }
      }]);

      return Bg;
    }(Dl);

    var Fg = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18.68 2.53c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.08c0-.58-.01-.55.6-.55h17.38zM15.77 14.5v-10H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 6.677a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V6.676z"/></svg>';

    var Ug = /*#__PURE__*/function (_Kl48) {
      _inherits(Ug, _Kl48);

      var _super146 = _createSuper(Ug);

      function Ug() {
        _classCallCheck(this, Ug);

        return _super146.apply(this, arguments);
      }

      _createClass(Ug, [{
        key: "init",
        value: function init() {
          var _this228 = this;

          var t = this.editor,
              e = t.commands.get("mediaEmbed"),
              n = t.plugins.get(jg).registry;
          this.form = new Bg(function (t, e) {
            return [function (e) {
              if (!e.url.length) return t("ao");
            }, function (n) {
              if (!e.hasMedia(n.url)) return t("ap");
            }];
          }(t.t, n), t.locale), t.ui.componentFactory.add("mediaEmbed", function (n) {
            var i = Sf(n);
            return _this228._setUpDropdown(i, _this228.form, e, t), _this228._setUpForm(_this228.form, i, e), i;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(t, e, n) {
          var i = this.editor,
              o = i.t,
              r = t.buttonView;

          function s() {
            i.editing.view.focus(), t.isOpen = !1;
          }

          t.bind("isEnabled").to(n), t.panelView.children.add(e), r.set({
            label: o("an"),
            icon: Fg,
            tooltip: !0
          }), r.on("open", function () {
            e.url = n.value || "", e.urlInputView.select(), e.focus();
          }, {
            priority: "low"
          }), t.on("submit", function () {
            e.isValid() && (i.execute("mediaEmbed", e.url), s());
          }), t.on("change:isOpen", function () {
            return e.resetFormStatus();
          }), t.on("cancel", function () {
            return s();
          });
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(t, e, n) {
          t.delegate("submit", "cancel").to(e), t.urlInputView.bind("value").to(n, "value"), t.urlInputView.bind("isReadOnly").to(n, "isEnabled", function (t) {
            return !t;
          }), t.saveButtonView.bind("isEnabled").to(n);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [jg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);

      return Ug;
    }(Kl);

    n(83);

    function Hg(t, e) {
      if (!t.childCount) return;

      var n = new of(),
          i = function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: /^p|h\d+$/,
          styles: {
            "mso-list": /.*/
          }
        }),
            o = [];

        var _iterator340 = _createForOfIteratorHelper(n),
            _step340;

        try {
          for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
            var _t291 = _step340.value;

            if ("elementStart" === _t291.type && i.match(_t291.item)) {
              var _e262 = qg(_t291.item);

              o.push({
                element: _t291.item,
                id: _e262.id,
                order: _e262.order,
                indent: _e262.indent
              });
            }
          }
        } catch (err) {
          _iterator340.e(err);
        } finally {
          _iterator340.f();
        }

        return o;
      }(t, n);

      if (!i.length) return;
      var o = null;
      i.forEach(function (t, r) {
        if (!o || function (t, e) {
          if (t.id !== e.id) return !0;
          var n = e.element.previousSibling;
          if (!n) return !0;
          return !Wg(n);
        }(i[r - 1], t)) {
          var _i185 = function (t, e) {
            var n = /mso-level-number-format:([^;]*);/gi,
                i = new RegExp("@list l".concat(t.id, ":level").concat(t.indent, "\\s*({[^}]*)"), "gi").exec(e);
            var o = "decimal";

            if (i && i[1]) {
              var _t292 = n.exec(i[1]);

              _t292 && _t292[1] && (o = _t292[1].trim());
            }

            return {
              type: "bullet" !== o && "image" !== o ? "ol" : "ul",
              style: o
            };
          }(t, e);

          o = function (t, e, n) {
            var i = new ki(t.type),
                o = e.parent.getChildIndex(e);
            return n.insertChild(o, i, e.parent), i;
          }(_i185, t.element, n);
        }

        var s = function (t, e) {
          return function (t, e) {
            var n = new bi({
              name: "span",
              styles: {
                "mso-list": "Ignore"
              }
            }),
                i = e.createRangeIn(t);

            var _iterator341 = _createForOfIteratorHelper(i),
                _step341;

            try {
              for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
                var _t293 = _step341.value;
                "elementStart" === _t293.type && n.match(_t293.item) && e.remove(_t293.item);
              }
            } catch (err) {
              _iterator341.e(err);
            } finally {
              _iterator341.f();
            }
          }(t, e), e.rename("li", t);
        }(t.element, n);

        n.appendChild(s, o);
      });
    }

    function qg(t) {
      var e = {},
          n = t.getStyle("mso-list");
      return n && (e.id = parseInt(n.match(/(^|\s+)l(\d+)/i)[2]), e.order = parseInt(n.match(/\s*lfo(\d+)/i)[1]), e.indent = parseInt(n.match(/\s*level(\d+)/i)[1])), e;
    }

    function Wg(t) {
      return t.is("ol") || t.is("ul");
    }

    var Yg = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;

    var $g = /*#__PURE__*/function () {
      function $g() {
        _classCallCheck(this, $g);
      }

      _createClass($g, [{
        key: "isActive",
        value: function isActive(t) {
          return Yg.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = new of();
          !function (t, e) {
            var _iterator342 = _createForOfIteratorHelper(t.getChildren()),
                _step342;

            try {
              for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
                var _n227 = _step342.value;

                if (_n227.is("b") && "normal" === _n227.getStyle("font-weight")) {
                  var _i186 = t.getChildIndex(_n227);

                  e.remove(_n227), e.insertChild(_i186, _n227.getChildren(), t);
                }
              }
            } catch (err) {
              _iterator342.e(err);
            } finally {
              _iterator342.f();
            }
          }(t.content, e), function (t, e) {
            var _iterator343 = _createForOfIteratorHelper(e.createRangeIn(t)),
                _step343;

            try {
              for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
                var _n228 = _step343.value;
                var _t294 = _n228.item;

                if (_t294.is("li")) {
                  var _n229 = _t294.nextSibling;
                  _n229 && Wg(_n229) && (e.remove(_n229), e.insertChild(_t294.childCount, _n229, _t294));
                }

                if (Wg(_t294)) {
                  var _n230 = _t294.getChild(0);

                  for (; Wg(_n230);) {
                    e.unwrapElement(_n230), _n230 = _t294.getChild(0);
                  }
                }
              }
            } catch (err) {
              _iterator343.e(err);
            } finally {
              _iterator343.f();
            }
          }(t.content, e), function (t, e) {
            var _iterator344 = _createForOfIteratorHelper(e.createRangeIn(t)),
                _step344;

            try {
              for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                var _n231 = _step344.value;
                var _t295 = _n231.item;

                if (_t295.is("li")) {
                  var _n232 = _t295.getChild(0);

                  _n232.is("p") && e.unwrapElement(_n232);
                }
              }
            } catch (err) {
              _iterator344.e(err);
            } finally {
              _iterator344.f();
            }
          }(t.content, e);
        }
      }]);

      return $g;
    }();

    function Gg(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
        return 1 === e.length ? " " : Array(e.length + 1).join("  ").substr(0, e.length);
      });
    }

    function Qg(t) {
      var e = new DOMParser(),
          n = function (t) {
        return Gg(Gg(t)).replace(/(<span style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g, "$1$2").replace(/<span style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/>(\s*[\r\n]\s*)</g, "><");
      }(function (t) {
        var e = t.match(/<\/body>(.*?)(<\/html>|$)/);
        e && e[1] && (t = t.slice(0, e.index) + t.slice(e.index).replace(e[1], ""));
        return t;
      }(t = t.replace(/<!--\[if gte vml 1]>/g, ""))),
          i = e.parseFromString(n, "text/html");

      !function (t) {
        t.querySelectorAll("span[style*=spacerun]").forEach(function (t) {
          var e = t.childNodes[0].data.length;
          t.innerHTML = Array(e + 1).join("  ").substr(0, e);
        });
      }(i);

      var o = i.body.innerHTML,
          r = function (t) {
        var e = new rr({
          blockFiller: jo
        }),
            n = t.createDocumentFragment(),
            i = t.body.childNodes;

        for (; i.length > 0;) {
          n.appendChild(i[0]);
        }

        return e.domToView(n);
      }(i),
          s = function (t) {
        var e = [],
            n = [],
            i = Array.from(t.getElementsByTagName("style"));

        for (var _i188 = 0, _i187 = i; _i188 < _i187.length; _i188++) {
          var _t296 = _i187[_i188];
          _t296.sheet && _t296.sheet.cssRules && _t296.sheet.cssRules.length && (e.push(_t296.sheet), n.push(_t296.innerHTML));
        }

        return {
          styles: e,
          stylesString: n.join(" ")
        };
      }(i);

      return {
        body: r,
        bodyString: o,
        styles: s.styles,
        stylesString: s.stylesString
      };
    }

    function Kg(t, e) {
      if (!t.childCount) return;
      var n = new of();
      !function (t, e, n) {
        var i = n.createRangeIn(e),
            o = new bi({
          name: "img"
        }),
            r = [];

        var _iterator345 = _createForOfIteratorHelper(i),
            _step345;

        try {
          for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
            var _e263 = _step345.value;

            if (o.match(_e263.item)) {
              var _n233 = _e263.item,
                  _i190 = _n233.getAttribute("v:shapes") ? _n233.getAttribute("v:shapes").split(" ") : [];

              _i190.length && _i190.every(function (e) {
                return t.indexOf(e) > -1;
              }) ? r.push(_n233) : _n233.getAttribute("src") || r.push(_n233);
            }
          }
        } catch (err) {
          _iterator345.e(err);
        } finally {
          _iterator345.f();
        }

        for (var _i189 = 0, _r47 = r; _i189 < _r47.length; _i189++) {
          var _t297 = _r47[_i189];
          n.remove(_t297);
        }
      }(function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: /v:(.+)/
        }),
            o = [];

        var _iterator346 = _createForOfIteratorHelper(n),
            _step346;

        try {
          for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
            var _t298 = _step346.value;

            var _e264 = _t298.item,
                _n234 = _e264.previousSibling && _e264.previousSibling.name || null;

            i.match(_e264) && _e264.getAttribute("o:gfxdata") && "v:shapetype" !== _n234 && o.push(_t298.item.getAttribute("id"));
          }
        } catch (err) {
          _iterator346.e(err);
        } finally {
          _iterator346.f();
        }

        return o;
      }(t, n), t, n), function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: /v:(.+)/
        }),
            o = [];

        var _iterator347 = _createForOfIteratorHelper(n),
            _step347;

        try {
          for (_iterator347.s(); !(_step347 = _iterator347.n()).done;) {
            var _t300 = _step347.value;
            i.match(_t300.item) && o.push(_t300.item);
          }
        } catch (err) {
          _iterator347.e(err);
        } finally {
          _iterator347.f();
        }

        for (var _i191 = 0, _o91 = o; _i191 < _o91.length; _i191++) {
          var _t299 = _o91[_i191];
          e.remove(_t299);
        }
      }(t, n);

      var i = function (t, e) {
        var n = e.createRangeIn(t),
            i = new bi({
          name: "img"
        }),
            o = [];

        var _iterator348 = _createForOfIteratorHelper(n),
            _step348;

        try {
          for (_iterator348.s(); !(_step348 = _iterator348.n()).done;) {
            var _t301 = _step348.value;
            i.match(_t301.item) && _t301.item.getAttribute("src").startsWith("file://") && o.push(_t301.item);
          }
        } catch (err) {
          _iterator348.e(err);
        } finally {
          _iterator348.f();
        }

        return o;
      }(t, n);

      i.length && function (t, e, n) {
        if (t.length === e.length) for (var _i192 = 0; _i192 < t.length; _i192++) {
          var _o92 = "data:".concat(e[_i192].type, ";base64,").concat(Jg(e[_i192].hex));

          n.setAttribute("src", _o92, t[_i192]);
        }
      }(i, function (t) {
        if (!t) return [];
        var e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/,
            n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g"),
            i = t.match(n),
            o = [];

        if (i) {
          var _iterator349 = _createForOfIteratorHelper(i),
              _step349;

          try {
            for (_iterator349.s(); !(_step349 = _iterator349.n()).done;) {
              var _t302 = _step349.value;

              var _n235 = !1;

              _t302.includes("\\pngblip") ? _n235 = "image/png" : _t302.includes("\\jpegblip") && (_n235 = "image/jpeg"), _n235 && o.push({
                hex: _t302.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                type: _n235
              });
            }
          } catch (err) {
            _iterator349.e(err);
          } finally {
            _iterator349.f();
          }
        }

        return o;
      }(e), n);
    }

    function Jg(t) {
      return btoa(t.match(/\w{2}/g).map(function (t) {
        return String.fromCharCode(parseInt(t, 16));
      }).join(""));
    }

    var Zg = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i,
        Xg = /xmlns:o="urn:schemas-microsoft-com/i;

    var tp = /*#__PURE__*/function () {
      function tp() {
        _classCallCheck(this, tp);
      }

      _createClass(tp, [{
        key: "isActive",
        value: function isActive(t) {
          return Zg.test(t) || Xg.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _Qg = Qg(t.dataTransfer.getData("text/html")),
              e = _Qg.body,
              n = _Qg.stylesString;

          Hg(e, n), Kg(e, t.dataTransfer.getData("text/rtf")), t.content = e;
        }
      }]);

      return tp;
    }();

    function ep(t, e) {
      var n = e.parent;

      for (; n;) {
        if (n.name === t) return n;
        n = n.parent;
      }
    }

    function np(t, e, n, i) {
      var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      e > o ? i.setAttribute(t, e, n) : i.removeAttribute(t, n);
    }

    function ip(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var i = t.createElement("tableCell", n);
      t.insertElement("paragraph", i), t.insert(i, e);
    }

    function op() {
      return function (t) {
        t.on("element:table", function (t, e, n) {
          var i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;

          var _ref104 = function (t) {
            var e = {
              headingRows: 0,
              headingColumns: 0
            },
                n = [],
                i = [];
            var o;

            for (var _i193 = 0, _Array$from7 = Array.from(t.getChildren()); _i193 < _Array$from7.length; _i193++) {
              var _r48 = _Array$from7[_i193];

              if ("tbody" === _r48.name || "thead" === _r48.name || "tfoot" === _r48.name) {
                "thead" !== _r48.name || o || (o = _r48);

                var _t303 = Array.from(_r48.getChildren()).filter(function (t) {
                  return t.is("element", "tr");
                });

                var _iterator350 = _createForOfIteratorHelper(_t303),
                    _step350;

                try {
                  for (_iterator350.s(); !(_step350 = _iterator350.n()).done;) {
                    var _r49 = _step350.value;
                    if ("thead" === _r49.parent.name && _r49.parent === o) e.headingRows++, n.push(_r49);else {
                      i.push(_r49);

                      var _t304 = sp(_r49);

                      _t304 > e.headingColumns && (e.headingColumns = _t304);
                    }
                  }
                } catch (err) {
                  _iterator350.e(err);
                } finally {
                  _iterator350.f();
                }
              }
            }

            return e.rows = [].concat(n, i), e;
          }(i),
              o = _ref104.rows,
              r = _ref104.headingRows,
              s = _ref104.headingColumns,
              a = {};

          s && (a.headingColumns = s), r && (a.headingRows = r);
          var c = n.writer.createElement("table", a),
              l = n.splitToAllowedParent(c, e.modelCursor);

          if (l) {
            if (n.writer.insert(c, l.position), n.consumable.consume(i, {
              name: !0
            }), o.length) o.forEach(function (t) {
              return n.convertItem(t, n.writer.createPositionAt(c, "end"));
            });else {
              var _t305 = n.writer.createElement("tableRow");

              n.writer.insert(_t305, n.writer.createPositionAt(c, "end")), ip(n.writer, n.writer.createPositionAt(_t305, "end"));
            }
            e.modelRange = n.writer.createRange(n.writer.createPositionBefore(c), n.writer.createPositionAfter(c)), l.cursorParent ? e.modelCursor = n.writer.createPositionAt(l.cursorParent, 0) : e.modelCursor = e.modelRange.end;
          }
        });
      };
    }

    function rp(t) {
      return function (e) {
        e.on("element:".concat(t), function (t, e, n) {
          var i = e.viewItem;
          if (!n.consumable.test(i, {
            name: !0
          })) return;
          var o = n.writer.createElement("tableCell"),
              r = n.splitToAllowedParent(o, e.modelCursor);
          if (!r) return;
          n.writer.insert(o, r.position), n.consumable.consume(i, {
            name: !0
          });
          var s = n.writer.createPositionAt(o, 0);
          n.convertChildren(i, s), o.childCount || n.writer.insertElement("paragraph", s), e.modelRange = n.writer.createRange(n.writer.createPositionBefore(o), n.writer.createPositionAfter(o)), e.modelCursor = e.modelRange.end;
        });
      };
    }

    function sp(t) {
      var e = 0,
          n = 0;
      var i = Array.from(t.getChildren()).filter(function (t) {
        return "th" === t.name || "td" === t.name;
      });

      for (; n < i.length && "th" === i[n].name;) {
        var _t306 = i[n];
        e += parseInt(_t306.getAttribute("colspan") || 1), n++;
      }

      return e;
    }

    var ap = /*#__PURE__*/function (_Symbol$iterator14) {
      function ap(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, ap);

        this.table = t, this.startRow = e.startRow || 0, this.endRow = "number" == typeof e.endRow ? e.endRow : void 0, this.includeSpanned = !!e.includeSpanned, this.column = "number" == typeof e.column ? e.column : void 0, this._skipRows = new Set(), this._row = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = new Map(), this._nextCellAtColumn = -1;
      }

      _createClass(ap, [{
        key: _Symbol$iterator14,
        value: function value() {
          return this;
        }
      }, {
        key: "next",
        value: function next() {
          var t = this.table.getChild(this._row);
          if (!t || this._isOverEndRow()) return {
            done: !0
          };
          var e, n, i;
          if (this._isSpanned(this._row, this._column)) e = this._getSpanned(this._row, this._column), n = !this.includeSpanned || this._shouldSkipRow() || this._shouldSkipColumn(), i = this._formatOutValue(e, this._column, !0);else {
            if (!(e = t.getChild(this._cellIndex))) return this._row++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();

            var _o93 = parseInt(e.getAttribute("colspan") || 1),
                _r50 = parseInt(e.getAttribute("rowspan") || 1);

            (_o93 > 1 || _r50 > 1) && this._recordSpans(this._row, this._column, _r50, _o93, e), this._nextCellAtColumn = this._column + _o93, n = this._shouldSkipRow() || this._shouldSkipColumn(), i = this._formatOutValue(e, this._column, !1, _r50, _o93);
          }
          return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, n ? this.next() : i;
        }
      }, {
        key: "skipRow",
        value: function skipRow(t) {
          this._skipRows.add(t);
        }
      }, {
        key: "_isOverEndRow",
        value: function _isOverEndRow() {
          return void 0 !== this.endRow && this._row > this.endRow;
        }
      }, {
        key: "_formatOutValue",
        value: function _formatOutValue(t, e, n) {
          var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
          var o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
          return {
            done: !1,
            value: {
              cell: t,
              row: this._row,
              column: e,
              isSpanned: n,
              rowspan: i,
              colspan: o,
              cellIndex: this._cellIndex
            }
          };
        }
      }, {
        key: "_shouldSkipRow",
        value: function _shouldSkipRow() {
          var t = this._row < this.startRow,
              e = this._skipRows.has(this._row);

          return t || e;
        }
      }, {
        key: "_shouldSkipColumn",
        value: function _shouldSkipColumn() {
          return void 0 !== this.column && this.column != this._column;
        }
      }, {
        key: "_isSpanned",
        value: function _isSpanned(t, e) {
          if (!this._spannedCells.has(t)) return !1;
          return this._spannedCells.get(t).has(e);
        }
      }, {
        key: "_getSpanned",
        value: function _getSpanned(t, e) {
          return this._spannedCells.get(t).get(e);
        }
      }, {
        key: "_recordSpans",
        value: function _recordSpans(t, e, n, i, o) {
          for (var _n236 = e + 1; _n236 <= e + i - 1; _n236++) {
            this._markSpannedCell(t, _n236, o);
          }

          for (var _r51 = t + 1; _r51 < t + n; _r51++) {
            for (var _t307 = e; _t307 <= e + i - 1; _t307++) {
              this._markSpannedCell(_r51, _t307, o);
            }
          }
        }
      }, {
        key: "_markSpannedCell",
        value: function _markSpannedCell(t, e, n) {
          this._spannedCells.has(t) || this._spannedCells.set(t, new Map()), this._spannedCells.get(t).set(e, n);
        }
      }]);

      return ap;
    }(Symbol.iterator);

    function cp(t) {
      return !!t.getCustomProperty("table") && Zh(t);
    }

    function lp(t) {
      var e = t.getSelectedElement();
      return e && cp(e) ? e : null;
    }

    function dp(t) {
      var e = ep("table", t.getFirstPosition());
      return e && cp(e.parent) ? e.parent : null;
    }

    function hp() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:table", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          i.consumable.consume(o, "attribute:headingRows:table"), i.consumable.consume(o, "attribute:headingColumns:table");
          var r = t && t.asWidget,
              s = i.writer.createContainerElement("figure", {
            class: "table"
          }),
              a = i.writer.createContainerElement("table");
          var c;
          i.writer.insert(i.writer.createPositionAt(s, 0), a), r && (c = function (t, e) {
            return e.setCustomProperty("table", !0, t), Xh(t, e, {
              hasSelectionHandler: !0
            });
          }(s, i.writer));
          var l = new ap(o),
              d = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              h = new Map();

          var _iterator351 = _createForOfIteratorHelper(l),
              _step351;

          try {
            for (_iterator351.s(); !(_step351 = _iterator351.n()).done;) {
              var _e265 = _step351.value;

              var _n237 = _e265.row,
                  _r52 = _e265.cell,
                  _s33 = yp(vp(_n237, d), a, i),
                  _c11 = o.getChild(_n237),
                  _l5 = h.get(_n237) || kp(_c11, _n237, _s33, i);

              h.set(_n237, _l5), i.consumable.consume(_r52, "insert"), wp(_e265, d, i.writer.createPositionAt(_l5, "end"), i, t);
            }
          } catch (err) {
            _iterator351.e(err);
          } finally {
            _iterator351.f();
          }

          var u = i.mapper.toViewPosition(n.range.start);
          i.mapper.bindElements(o, r ? c : s), i.writer.insert(u, r ? c : s);
        });
      };
    }

    function up() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:tableRow", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          var r = o.parent,
              s = Cp(i.mapper.toViewElement(r)),
              a = r.getChildIndex(o),
              c = new ap(r, {
            startRow: a,
            endRow: a
          }),
              l = {
            headingRows: r.getAttribute("headingRows") || 0,
            headingColumns: r.getAttribute("headingColumns") || 0
          },
              d = new Map();

          var _iterator352 = _createForOfIteratorHelper(c),
              _step352;

          try {
            for (_iterator352.s(); !(_step352 = _iterator352.n()).done;) {
              var _e266 = _step352.value;

              var _n238 = yp(vp(a, l), s, i),
                  _r53 = d.get(a) || kp(o, a, _n238, i);

              d.set(a, _r53), i.consumable.consume(_e266.cell, "insert"), wp(_e266, l, i.writer.createPositionAt(_r53, "end"), i, t);
            }
          } catch (err) {
            _iterator352.e(err);
          } finally {
            _iterator352.f();
          }
        });
      };
    }

    function fp() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:tableCell", function (e, n, i) {
          var o = n.item;
          if (!i.consumable.consume(o, "insert")) return;
          var r = o.parent,
              s = r.parent,
              a = s.getChildIndex(r),
              c = new ap(s, {
            startRow: a,
            endRow: a
          }),
              l = {
            headingRows: s.getAttribute("headingRows") || 0,
            headingColumns: s.getAttribute("headingColumns") || 0
          };

          var _iterator353 = _createForOfIteratorHelper(c),
              _step353;

          try {
            for (_iterator353.s(); !(_step353 = _iterator353.n()).done;) {
              var _e267 = _step353.value;

              if (_e267.cell === o) {
                var _n239 = i.mapper.toViewElement(r);

                return void wp(_e267, l, i.writer.createPositionAt(_n239, r.getChildIndex(o)), i, t);
              }
            }
          } catch (err) {
            _iterator353.e(err);
          } finally {
            _iterator353.f();
          }
        });
      };
    }

    function mp() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.asWidget;
      return function (t) {
        return t.on("attribute:headingRows:table", function (t, n, i) {
          var o = n.item;
          if (!i.consumable.consume(n.item, t.name)) return;
          var r = Cp(i.mapper.toViewElement(o)),
              s = n.attributeOldValue,
              a = n.attributeNewValue;

          if (a > s) {
            var _t308 = Array.from(o.getChildren()).filter(function (_ref105) {
              var t = _ref105.index;
              return c(t, s - 1, a);
            });

            Tp(_t308, yp("thead", r, i), i, "end");

            var _iterator354 = _createForOfIteratorHelper(_t308),
                _step354;

            try {
              for (_iterator354.s(); !(_step354 = _iterator354.n()).done;) {
                var _n240 = _step354.value;

                var _iterator355 = _createForOfIteratorHelper(_n240.getChildren()),
                    _step355;

                try {
                  for (_iterator355.s(); !(_step355 = _iterator355.n()).done;) {
                    var _t309 = _step355.value;
                    pp(_t309, "th", i, e);
                  }
                } catch (err) {
                  _iterator355.e(err);
                } finally {
                  _iterator355.f();
                }
              }
            } catch (err) {
              _iterator354.e(err);
            } finally {
              _iterator354.f();
            }

            Ap("tbody", r, i);
          } else {
            Tp(Array.from(o.getChildren()).filter(function (_ref106) {
              var t = _ref106.index;
              return c(t, a - 1, s);
            }).reverse(), yp("tbody", r, i), i, 0);

            var _t310 = new ap(o, {
              startRow: a ? a - 1 : a,
              endRow: s - 1
            }),
                _n241 = {
              headingRows: o.getAttribute("headingRows") || 0,
              headingColumns: o.getAttribute("headingColumns") || 0
            };

            var _iterator356 = _createForOfIteratorHelper(_t310),
                _step356;

            try {
              for (_iterator356.s(); !(_step356 = _iterator356.n()).done;) {
                var _o94 = _step356.value;
                bp(_o94, _n241, i, e);
              }
            } catch (err) {
              _iterator356.e(err);
            } finally {
              _iterator356.f();
            }

            Ap("thead", r, i);
          }

          function c(t, e, n) {
            return t > e && t < n;
          }
        });
      };
    }

    function gp() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = !!t.asWidget;
      return function (t) {
        return t.on("attribute:headingColumns:table", function (t, n, i) {
          var o = n.item;
          if (!i.consumable.consume(n.item, t.name)) return;
          var r = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          },
              s = n.attributeOldValue,
              a = n.attributeNewValue,
              c = (s > a ? s : a) - 1;

          var _iterator357 = _createForOfIteratorHelper(new ap(o)),
              _step357;

          try {
            for (_iterator357.s(); !(_step357 = _iterator357.n()).done;) {
              var _t311 = _step357.value;
              _t311.column > c || bp(_t311, r, i, e);
            }
          } catch (err) {
            _iterator357.e(err);
          } finally {
            _iterator357.f();
          }
        });
      };
    }

    function pp(t, e, n, i) {
      var o = n.writer,
          r = n.mapper.toViewElement(t);
      if (!r) return;
      var s;

      if (i) {
        s = eu(o.createEditableElement(e, r.getAttributes()), o), o.insert(o.createPositionAfter(r), s), o.move(o.createRangeIn(r), o.createPositionAt(s, 0)), o.remove(o.createRangeOn(r));
      } else s = o.rename(e, r);

      n.mapper.unbindViewElement(r), n.mapper.bindElements(t, s);
    }

    function bp(t, e, n, i) {
      var o = t.cell,
          r = _p(t, e),
          s = n.mapper.toViewElement(o);

      s && s.name !== r && pp(o, r, n, i);
    }

    function wp(t, e, n, i, o) {
      var r = o && o.asWidget,
          s = _p(t, e),
          a = r ? eu(i.writer.createEditableElement(s), i.writer) : i.writer.createContainerElement(s),
          c = t.cell,
          l = c.getChild(0),
          d = 1 === c.childCount && "paragraph" === l.name;

      if (i.writer.insert(n, a), d && !function (t) {
        return !!_toConsumableArray(t.getAttributeKeys()).length;
      }(l)) {
        var _t312 = c.getChild(0),
            _e268 = i.writer.createPositionAt(a, "end");

        if (i.consumable.consume(_t312, "insert"), o.asWidget) {
          var _n242 = i.writer.createContainerElement("span");

          i.mapper.bindElements(_t312, _n242), i.writer.insert(_e268, _n242), i.mapper.bindElements(c, a);
        } else i.mapper.bindElements(c, a), i.mapper.bindElements(_t312, a);
      } else i.mapper.bindElements(c, a);
    }

    function kp(t, e, n, i) {
      i.consumable.consume(t, "insert");
      var o = i.writer.createContainerElement("tr");
      i.mapper.bindElements(t, o);
      var r = t.parent.getAttribute("headingRows") || 0,
          s = r > 0 && e >= r ? e - r : e,
          a = i.writer.createPositionAt(n, s);
      return i.writer.insert(a, o), o;
    }

    function _p(t, e) {
      var n = t.row,
          i = t.column,
          o = e.headingColumns,
          r = e.headingRows;
      return r && r > n ? "th" : o && o > i ? "th" : "td";
    }

    function vp(t, e) {
      return t < e.headingRows ? "thead" : "tbody";
    }

    function yp(t, e, n) {
      var i = xp(t, e);
      return i || function (t, e, n) {
        var i = n.writer.createContainerElement(t),
            o = n.writer.createPositionAt(e, "tbody" == t ? "end" : 0);
        return n.writer.insert(o, i), i;
      }(t, e, n);
    }

    function xp(t, e) {
      var _iterator358 = _createForOfIteratorHelper(e.getChildren()),
          _step358;

      try {
        for (_iterator358.s(); !(_step358 = _iterator358.n()).done;) {
          var _n243 = _step358.value;
          if (_n243.name == t) return _n243;
        }
      } catch (err) {
        _iterator358.e(err);
      } finally {
        _iterator358.f();
      }
    }

    function Ap(t, e, n) {
      var i = xp(t, e);
      i && 0 === i.childCount && n.writer.remove(n.writer.createRangeOn(i));
    }

    function Tp(t, e, n, i) {
      var _iterator359 = _createForOfIteratorHelper(t),
          _step359;

      try {
        for (_iterator359.s(); !(_step359 = _iterator359.n()).done;) {
          var _o95 = _step359.value;

          var _t313 = n.mapper.toViewElement(_o95);

          _t313 && n.writer.move(n.writer.createRangeOn(_t313), n.writer.createPositionAt(e, i));
        }
      } catch (err) {
        _iterator359.e(err);
      } finally {
        _iterator359.f();
      }
    }

    function Cp(t) {
      var _iterator360 = _createForOfIteratorHelper(t.getChildren()),
          _step360;

      try {
        for (_iterator360.s(); !(_step360 = _iterator360.n()).done;) {
          var _e269 = _step360.value;
          if ("table" === _e269.name) return _e269;
        }
      } catch (err) {
        _iterator360.e(err);
      } finally {
        _iterator360.f();
      }
    }

    var Pp = /*#__PURE__*/function (_ed20) {
      _inherits(Pp, _ed20);

      var _super147 = _createSuper(Pp);

      function Pp() {
        _classCallCheck(this, Pp);

        return _super147.apply(this, arguments);
      }

      _createClass(Pp, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
              e = t.document.selection,
              n = t.schema,
              i = function (t) {
            var e = t.parent;
            return e === e.root ? e : e.parent;
          }(e.getFirstPosition());

          this.isEnabled = n.checkChild(i, "table");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = e.document.selection,
              i = this.editor.plugins.get("TableUtils"),
              o = parseInt(t.rows) || 2,
              r = parseInt(t.columns) || 2,
              s = nu(n, e);
          e.change(function (t) {
            var n = i.createTable(t, o, r);
            e.insertContent(n, s), t.setSelection(t.createPositionAt(n.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }]);

      return Pp;
    }(ed);

    var Sp = /*#__PURE__*/function (_ed21) {
      _inherits(Sp, _ed21);

      var _super148 = _createSuper(Sp);

      function Sp(t) {
        var _this229;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Sp);

        _this229 = _super148.call(this, t), _this229.order = e.order || "below";
        return _this229;
      }

      _createClass(Sp, [{
        key: "refresh",
        value: function refresh() {
          var t = ep("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = ep("tableCell", e.getFirstPosition()).parent,
              o = i.parent,
              r = o.getChildIndex(i),
              s = "below" === this.order ? r + 1 : r;
          n.insertRows(o, {
            rows: 1,
            at: s
          });
        }
      }]);

      return Sp;
    }(ed);

    var Mp = /*#__PURE__*/function (_ed22) {
      _inherits(Mp, _ed22);

      var _super149 = _createSuper(Mp);

      function Mp(t) {
        var _this230;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Mp);

        _this230 = _super149.call(this, t), _this230.order = e.order || "right";
        return _this230;
      }

      _createClass(Mp, [{
        key: "refresh",
        value: function refresh() {
          var t = ep("table", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = ep("tableCell", e.getFirstPosition()),
              o = i.parent.parent,
              _n$getCellLocation = n.getCellLocation(i),
              r = _n$getCellLocation.column,
              s = "right" === this.order ? r + 1 : r;

          n.insertColumns(o, {
            columns: 1,
            at: s
          });
        }
      }]);

      return Mp;
    }(ed);

    var Ep = /*#__PURE__*/function (_ed23) {
      _inherits(Ep, _ed23);

      var _super150 = _createSuper(Ep);

      function Ep(t) {
        var _this231;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Ep);

        _this231 = _super150.call(this, t), _this231.direction = e.direction || "horizontally";
        return _this231;
      }

      _createClass(Ep, [{
        key: "refresh",
        value: function refresh() {
          var t = ep("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = ep("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = "horizontally" === this.direction,
              n = this.editor.plugins.get("TableUtils");
          e ? n.splitCellHorizontally(t, 2) : n.splitCellVertically(t, 2);
        }
      }]);

      return Ep;
    }(ed);

    var Ip = /*#__PURE__*/function (_ed24) {
      _inherits(Ip, _ed24);

      var _super151 = _createSuper(Ip);

      function Ip(t, e) {
        var _this232;

        _classCallCheck(this, Ip);

        _this232 = _super151.call(this, t), _this232.direction = e.direction, _this232.isHorizontal = "right" == _this232.direction || "left" == _this232.direction;
        return _this232;
      }

      _createClass(Ip, [{
        key: "refresh",
        value: function refresh() {
          var t = this._getMergeableCell();

          this.isEnabled = !!t, this.value = t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this233 = this;

          var t = this.editor.model,
              e = ep("tableCell", t.document.selection.getFirstPosition()),
              n = this.value,
              i = this.direction;
          t.change(function (t) {
            var o = "right" == i || "down" == i,
                r = o ? e : n,
                s = o ? n : e,
                a = s.parent;
            !function (t, e, n) {
              Np(t) || (Np(e) && n.remove(n.createRangeIn(e)), n.move(n.createRangeIn(t), n.createPositionAt(e, "end")));
              n.remove(t);
            }(s, r, t);
            var c = _this233.isHorizontal ? "colspan" : "rowspan",
                l = parseInt(e.getAttribute(c) || 1),
                d = parseInt(n.getAttribute(c) || 1);
            t.setAttribute(c, l + d, r), t.setSelection(t.createRangeIn(r)), a.childCount || function (t, e) {
              var n = t.parent,
                  i = n.getChildIndex(t);

              var _iterator361 = _createForOfIteratorHelper(new ap(n, {
                endRow: i
              })),
                  _step361;

              try {
                for (_iterator361.s(); !(_step361 = _iterator361.n()).done;) {
                  var _ref108 = _step361.value;
                  var _t314 = _ref108.cell;
                  var _o96 = _ref108.row;
                  var _r54 = _ref108.rowspan;

                  var _n244 = _o96 + _r54 - 1 >= i;

                  _n244 && np("rowspan", _r54 - 1, _t314, e);
                }
              } catch (err) {
                _iterator361.e(err);
              } finally {
                _iterator361.f();
              }

              e.remove(t);
            }(a, t);
          });
        }
      }, {
        key: "_getMergeableCell",
        value: function _getMergeableCell() {
          var t = ep("tableCell", this.editor.model.document.selection.getFirstPosition());
          if (!t) return;
          var e = this.editor.plugins.get("TableUtils"),
              n = this.isHorizontal ? function (t, e, n) {
            var i = "right" == e ? t.nextSibling : t.previousSibling;
            if (!i) return;

            var o = "right" == e ? t : i,
                r = "right" == e ? i : t,
                _n$getCellLocation2 = n.getCellLocation(o),
                s = _n$getCellLocation2.column,
                _n$getCellLocation3 = n.getCellLocation(r),
                a = _n$getCellLocation3.column,
                c = parseInt(o.getAttribute("colspan") || 1);

            return s + c === a ? i : void 0;
          }(t, this.direction, e) : function (t, e) {
            var n = t.parent,
                i = n.parent,
                o = i.getChildIndex(n);
            if ("down" == e && o === i.childCount - 1 || "up" == e && 0 === o) return;
            var r = parseInt(t.getAttribute("rowspan") || 1),
                s = i.getAttribute("headingRows") || 0;
            if (s && ("down" == e && o + r === s || "up" == e && o === s)) return;

            var a = parseInt(t.getAttribute("rowspan") || 1),
                c = "down" == e ? o + a : o,
                l = _toConsumableArray(new ap(i, {
              endRow: c
            })),
                d = l.find(function (e) {
              return e.cell === t;
            }).column,
                h = l.find(function (_ref109) {
              var t = _ref109.row,
                  n = _ref109.rowspan,
                  i = _ref109.column;
              return i === d && ("down" == e ? t === c : c === t + n);
            });

            return h && h.cell;
          }(t, this.direction);
          if (!n) return;
          var i = this.isHorizontal ? "rowspan" : "colspan",
              o = parseInt(t.getAttribute(i) || 1);
          return parseInt(n.getAttribute(i) || 1) === o ? n : void 0;
        }
      }]);

      return Ip;
    }(ed);

    function Np(t) {
      return 1 == t.childCount && t.getChild(0).is("paragraph") && t.getChild(0).isEmpty;
    }

    var Op = /*#__PURE__*/function (_ed25) {
      _inherits(Op, _ed25);

      var _super152 = _createSuper(Op);

      function Op() {
        _classCallCheck(this, Op);

        return _super152.apply(this, arguments);
      }

      _createClass(Op, [{
        key: "refresh",
        value: function refresh() {
          var t = ep("tableCell", this.editor.model.document.selection.getFirstPosition());
          this.isEnabled = !!t && t.parent.parent.childCount > 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = ep("tableCell", t.document.selection.getFirstPosition()).parent,
              n = e.parent,
              i = n.getChildIndex(e),
              o = n.getAttribute("headingRows") || 0;
          t.change(function (t) {
            o && i <= o && np("headingRows", o - 1, n, t, 0);

            var r = _toConsumableArray(new ap(n, {
              endRow: i
            })),
                s = new Map();

            r.filter(function (_ref110) {
              var t = _ref110.row,
                  e = _ref110.rowspan;
              return t === i && e > 1;
            }).forEach(function (_ref111) {
              var t = _ref111.column,
                  e = _ref111.cell,
                  n = _ref111.rowspan;
              return s.set(t, {
                cell: e,
                rowspanToSet: n - 1
              });
            }), r.filter(function (_ref112) {
              var t = _ref112.row,
                  e = _ref112.rowspan;
              return t <= i - 1 && t + e > i;
            }).forEach(function (_ref113) {
              var e = _ref113.cell,
                  n = _ref113.rowspan;
              return np("rowspan", n - 1, e, t);
            });
            var a = i + 1,
                c = new ap(n, {
              includeSpanned: !0,
              startRow: a,
              endRow: a
            });
            var l;

            for (var _i194 = 0, _arr3 = _toConsumableArray(c); _i194 < _arr3.length; _i194++) {
              var _ref115 = _arr3[_i194];
              var _e270 = _ref115.row;
              var _i195 = _ref115.column;
              var _o97 = _ref115.cell;

              if (s.has(_i195)) {
                var _s$get = s.get(_i195),
                    _o98 = _s$get.cell,
                    _r55 = _s$get.rowspanToSet,
                    _a19 = l ? t.createPositionAfter(l) : t.createPositionAt(n.getChild(_e270), 0);

                t.move(t.createRangeOn(_o98), _a19), np("rowspan", _r55, _o98, t), l = _o98;
              } else l = _o97;
            }

            t.remove(e);
          });
        }
      }]);

      return Op;
    }(ed);

    var Rp = /*#__PURE__*/function (_ed26) {
      _inherits(Rp, _ed26);

      var _super153 = _createSuper(Rp);

      function Rp() {
        _classCallCheck(this, Rp);

        return _super153.apply(this, arguments);
      }

      _createClass(Rp, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor,
              e = t.model.document.selection,
              n = t.plugins.get("TableUtils"),
              i = ep("tableCell", e.getFirstPosition());
          this.isEnabled = !!i && n.getColumns(i.parent.parent) > 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model,
              e = ep("tableCell", t.document.selection.getFirstPosition()),
              n = e.parent,
              i = n.parent,
              o = i.getAttribute("headingColumns") || 0,
              r = i.getChildIndex(n),
              s = _toConsumableArray(new ap(i)),
              a = s.find(function (t) {
            return t.cell === e;
          }).column;

          t.change(function (t) {
            o && r <= o && t.setAttribute("headingColumns", o - 1, i);

            var _iterator362 = _createForOfIteratorHelper(s),
                _step362;

            try {
              for (_iterator362.s(); !(_step362 = _iterator362.n()).done;) {
                var _ref117 = _step362.value;
                var _e271 = _ref117.cell;
                var _n245 = _ref117.column;
                var _i196 = _ref117.colspan;
                _n245 <= a && _i196 > 1 && _n245 + _i196 > a ? np("colspan", _i196 - 1, _e271, t) : _n245 === a && t.remove(_e271);
              }
            } catch (err) {
              _iterator362.e(err);
            } finally {
              _iterator362.f();
            }
          });
        }
      }]);

      return Rp;
    }(ed);

    var Dp = /*#__PURE__*/function (_ed27) {
      _inherits(Dp, _ed27);

      var _super154 = _createSuper(Dp);

      function Dp() {
        _classCallCheck(this, Dp);

        return _super154.apply(this, arguments);
      }

      _createClass(Dp, [{
        key: "refresh",
        value: function refresh() {
          var t = ep("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = !!t;
          this.isEnabled = e, this.value = e && this._isInHeading(t, t.parent.parent);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model,
              n = ep("tableCell", e.document.selection.getFirstPosition()).parent,
              i = n.parent,
              o = i.getAttribute("headingRows") || 0,
              r = n.index;
          if (t.forceValue === this.value) return;
          var s = this.value ? r : r + 1;
          e.change(function (t) {
            if (s) {
              var _e272 = function (t, e, n) {
                var i = [],
                    o = new ap(t, {
                  startRow: e > n ? n : 0,
                  endRow: e - 1
                });

                var _iterator363 = _createForOfIteratorHelper(o),
                    _step363;

                try {
                  for (_iterator363.s(); !(_step363 = _iterator363.n()).done;) {
                    var _ref119 = _step363.value;
                    var _t315 = _ref119.row;
                    var _n246 = _ref119.rowspan;
                    var _r56 = _ref119.cell;
                    _n246 > 1 && _t315 + _n246 > e && i.push(_r56);
                  }
                } catch (err) {
                  _iterator363.e(err);
                } finally {
                  _iterator363.f();
                }

                return i;
              }(i, s, o);

              var _iterator364 = _createForOfIteratorHelper(_e272),
                  _step364;

              try {
                for (_iterator364.s(); !(_step364 = _iterator364.n()).done;) {
                  var _n247 = _step364.value;
                  Lp(_n247, s, t);
                }
              } catch (err) {
                _iterator364.e(err);
              } finally {
                _iterator364.f();
              }
            }

            np("headingRows", s, i, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingRows") || 0);
          return !!n && t.parent.index < n;
        }
      }]);

      return Dp;
    }(ed);

    function Lp(t, e, n) {
      var i = t.parent,
          o = i.parent,
          r = e - i.index,
          s = {},
          a = parseInt(t.getAttribute("rowspan")) - r;
      a > 1 && (s.rowspan = a);
      var c = parseInt(t.getAttribute("colspan") || 1);
      c > 1 && (s.colspan = c);

      var l = o.getChildIndex(i),
          d = l + r,
          h = _toConsumableArray(new ap(o, {
        startRow: l,
        endRow: d,
        includeSpanned: !0
      }));

      var u;

      var _iterator365 = _createForOfIteratorHelper(h),
          _step365;

      try {
        for (_iterator365.s(); !(_step365 = _iterator365.n()).done;) {
          var _ref121 = _step365.value;
          var _e273 = _ref121.row;
          var _i197 = _ref121.column;
          var _r57 = _ref121.cell;
          var _a20 = _ref121.cellIndex;

          if (_r57 === t && void 0 === u && (u = _i197), void 0 !== u && u === _i197 && _e273 === d) {
            var _t316 = o.getChild(_e273);

            ip(n, n.createPositionAt(_t316, _a20), s);
          }
        }
      } catch (err) {
        _iterator365.e(err);
      } finally {
        _iterator365.f();
      }

      np("rowspan", r, t, n);
    }

    var jp = /*#__PURE__*/function (_ed28) {
      _inherits(jp, _ed28);

      var _super155 = _createSuper(jp);

      function jp() {
        _classCallCheck(this, jp);

        return _super155.apply(this, arguments);
      }

      _createClass(jp, [{
        key: "refresh",
        value: function refresh() {
          var t = ep("tableCell", this.editor.model.document.selection.getFirstPosition()),
              e = !!t;
          this.isEnabled = e, this.value = e && this._isInHeading(t, t.parent.parent);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var e = this.editor.model,
              n = e.document.selection,
              i = this.editor.plugins.get("TableUtils"),
              o = ep("tableCell", n.getFirstPosition()),
              r = o.parent.parent,
              _i$getCellLocation = i.getCellLocation(o),
              s = _i$getCellLocation.column;

          if (t.forceValue === this.value) return;
          var a = this.value ? s : s + 1;
          e.change(function (t) {
            np("headingColumns", a, r, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingColumns") || 0),
              i = this.editor.plugins.get("TableUtils"),
              _i$getCellLocation2 = i.getCellLocation(t),
              o = _i$getCellLocation2.column;

          return !!n && o < n;
        }
      }]);

      return jp;
    }(ed);

    var Vp = /*#__PURE__*/function (_Kl49) {
      _inherits(Vp, _Kl49);

      var _super156 = _createSuper(Vp);

      function Vp() {
        _classCallCheck(this, Vp);

        return _super156.apply(this, arguments);
      }

      _createClass(Vp, [{
        key: "getCellLocation",
        value: function getCellLocation(t) {
          var e = t.parent,
              n = e.parent,
              i = n.getChildIndex(e),
              o = new ap(n, {
            startRow: i,
            endRow: i
          });

          var _iterator366 = _createForOfIteratorHelper(o),
              _step366;

          try {
            for (_iterator366.s(); !(_step366 = _iterator366.n()).done;) {
              var _ref123 = _step366.value;
              var _e274 = _ref123.cell;
              var _n248 = _ref123.row;
              var _i198 = _ref123.column;
              if (_e274 === t) return {
                row: _n248,
                column: _i198
              };
            }
          } catch (err) {
            _iterator366.e(err);
          } finally {
            _iterator366.f();
          }
        }
      }, {
        key: "createTable",
        value: function createTable(t, e, n) {
          var i = t.createElement("table");
          return zp(t, i, 0, e, n), i;
        }
      }, {
        key: "insertRows",
        value: function insertRows(t) {
          var _this234 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = e.at || 0,
              o = e.rows || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingRows") || 0;
            if (n > i && e.setAttribute("headingRows", n + o, t), 0 === i || i === t.childCount) return void zp(e, t, i, o, _this234.getColumns(t));
            var r = new ap(t, {
              endRow: i
            });
            var s = 0;

            var _iterator367 = _createForOfIteratorHelper(r),
                _step367;

            try {
              for (_iterator367.s(); !(_step367 = _iterator367.n()).done;) {
                var _ref125 = _step367.value;
                var _t317 = _ref125.row;
                var _n249 = _ref125.rowspan;
                var _a21 = _ref125.colspan;
                var _c12 = _ref125.cell;
                _t317 < i && _t317 + _n249 > i && e.setAttribute("rowspan", _n249 + o, _c12), _t317 === i && (s += _a21);
              }
            } catch (err) {
              _iterator367.e(err);
            } finally {
              _iterator367.f();
            }

            zp(e, t, i, o, s);
          });
        }
      }, {
        key: "insertColumns",
        value: function insertColumns(t) {
          var _this235 = this;

          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model,
              i = e.at || 0,
              o = e.columns || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingColumns");
            i < n && e.setAttribute("headingColumns", n + o, t);

            var r = _this235.getColumns(t);

            if (0 === i || r === i) {
              var _iterator368 = _createForOfIteratorHelper(t.getChildren()),
                  _step368;

              try {
                for (_iterator368.s(); !(_step368 = _iterator368.n()).done;) {
                  var _n250 = _step368.value;
                  Bp(o, e, e.createPositionAt(_n250, i ? "end" : 0));
                }
              } catch (err) {
                _iterator368.e(err);
              } finally {
                _iterator368.f();
              }

              return;
            }

            var s = new ap(t, {
              column: i,
              includeSpanned: !0
            });

            var _iterator369 = _createForOfIteratorHelper(s),
                _step369;

            try {
              for (_iterator369.s(); !(_step369 = _iterator369.n()).done;) {
                var _ref127 = _step369.value;
                var _n251 = _ref127.row;
                var _r58 = _ref127.cell;
                var _a22 = _ref127.cellIndex;

                var _c13 = parseInt(_r58.getAttribute("rowspan") || 1),
                    _l6 = parseInt(_r58.getAttribute("colspan") || 1);

                if (_r58.index !== i && _l6 > 1) {
                  if (e.setAttribute("colspan", _l6 + o, _r58), s.skipRow(_n251), _c13 > 1) for (var _t318 = _n251 + 1; _t318 < _n251 + _c13; _t318++) {
                    s.skipRow(_t318);
                  }
                } else {
                  var _i199 = e.createPositionAt(t.getChild(_n251), _a22);

                  Bp(o, e, _i199);
                }
              }
            } catch (err) {
              _iterator369.e(err);
            } finally {
              _iterator369.f();
            }
          });
        }
      }, {
        key: "splitCellVertically",
        value: function splitCellVertically(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
              i = t.parent.parent,
              o = parseInt(t.getAttribute("rowspan") || 1),
              r = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (r > 1) {
              var _Fp = Fp(r, e),
                  _i200 = _Fp.newCellsSpan,
                  _s34 = _Fp.updatedSpan;

              np("colspan", _s34, t, n);
              var _a23 = {};
              _i200 > 1 && (_a23.colspan = _i200), o > 1 && (_a23.rowspan = o), Bp(r > e ? e - 1 : r - 1, n, n.createPositionAfter(t), _a23);
            }

            if (r < e) {
              var _s35 = e - r,
                  _a24 = _toConsumableArray(new ap(i)),
                  _a24$find = _a24.find(function (_ref128) {
                var e = _ref128.cell;
                return e === t;
              }),
                  _c14 = _a24$find.column,
                  _l7 = _a24.filter(function (_ref129) {
                var e = _ref129.cell,
                    n = _ref129.colspan,
                    i = _ref129.column;
                return e !== t && i === _c14 || i < _c14 && i + n > _c14;
              });

              var _iterator370 = _createForOfIteratorHelper(_l7),
                  _step370;

              try {
                for (_iterator370.s(); !(_step370 = _iterator370.n()).done;) {
                  var _ref131 = _step370.value;
                  var _t319 = _ref131.cell;
                  var _e275 = _ref131.colspan;
                  n.setAttribute("colspan", _e275 + _s35, _t319);
                }
              } catch (err) {
                _iterator370.e(err);
              } finally {
                _iterator370.f();
              }

              var _d5 = {};
              o > 1 && (_d5.rowspan = o), Bp(_s35, n, n.createPositionAfter(t), _d5);

              var _h3 = i.getAttribute("headingColumns") || 0;

              _h3 > _c14 && np("headingColumns", _h3 + _s35, i, n);
            }
          });
        }
      }, {
        key: "splitCellHorizontally",
        value: function splitCellHorizontally(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model,
              i = t.parent,
              o = i.parent,
              r = o.getChildIndex(i),
              s = parseInt(t.getAttribute("rowspan") || 1),
              a = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (s > 1) {
              var _i201 = _toConsumableArray(new ap(o, {
                startRow: r,
                endRow: r + s - 1,
                includeSpanned: !0
              })),
                  _Fp2 = Fp(s, e),
                  _c15 = _Fp2.newCellsSpan,
                  _l8 = _Fp2.updatedSpan;

              np("rowspan", _l8, t, n);

              var _i201$find = _i201.find(function (_ref132) {
                var e = _ref132.cell;
                return e === t;
              }),
                  _d6 = _i201$find.column,
                  _h4 = {};

              _c15 > 1 && (_h4.rowspan = _c15), a > 1 && (_h4.colspan = a);

              for (var _i203 = 0, _i202 = _i201; _i203 < _i202.length; _i203++) {
                var _ref134 = _i202[_i203];
                var _t320 = _ref134.column;
                var _e276 = _ref134.row;
                var _s36 = _ref134.cellIndex;

                if (_e276 >= r + _l8 && _t320 === _d6 && (_e276 + r + _l8) % _c15 == 0) {
                  Bp(1, n, n.createPositionAt(o.getChild(_e276), _s36), _h4);
                }
              }
            }

            if (s < e) {
              var _i204 = e - s,
                  _c16 = _toConsumableArray(new ap(o, {
                startRow: 0,
                endRow: r
              }));

              var _iterator371 = _createForOfIteratorHelper(_c16),
                  _step371;

              try {
                for (_iterator371.s(); !(_step371 = _iterator371.n()).done;) {
                  var _ref136 = _step371.value;
                  var _e277 = _ref136.cell;
                  var _o99 = _ref136.rowspan;
                  var _s37 = _ref136.row;

                  if (_e277 !== t && _s37 + _o99 > r) {
                    var _t321 = _o99 + _i204;

                    n.setAttribute("rowspan", _t321, _e277);
                  }
                }
              } catch (err) {
                _iterator371.e(err);
              } finally {
                _iterator371.f();
              }

              var _l9 = {};
              a > 1 && (_l9.colspan = a), zp(n, o, r + 1, _i204, 1, _l9);

              var _d7 = o.getAttribute("headingRows") || 0;

              _d7 > r && np("headingRows", _d7 + _i204, o, n);
            }
          });
        }
      }, {
        key: "getColumns",
        value: function getColumns(t) {
          return _toConsumableArray(t.getChild(0).getChildren()).reduce(function (t, e) {
            return t + parseInt(e.getAttribute("colspan") || 1);
          }, 0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUtils";
        }
      }]);

      return Vp;
    }(Kl);

    function zp(t, e, n, i, o) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      for (var _s38 = 0; _s38 < i; _s38++) {
        var _i205 = t.createElement("tableRow");

        t.insert(_i205, e, n), Bp(o, t, t.createPositionAt(_i205, "end"), r);
      }
    }

    function Bp(t, e, n) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      for (var _o100 = 0; _o100 < t; _o100++) {
        ip(e, n, i);
      }
    }

    function Fp(t, e) {
      if (t < e) return {
        newCellsSpan: 1,
        updatedSpan: 1
      };
      var n = Math.floor(t / e);
      return {
        newCellsSpan: n,
        updatedSpan: t - n * e + n
      };
    }

    function Up(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var i = !1;
          var o = new Set();

          var _iterator372 = _createForOfIteratorHelper(n),
              _step372;

          try {
            for (_iterator372.s(); !(_step372 = _iterator372.n()).done;) {
              var _e278 = _step372.value;

              var _n252 = void 0;

              "table" == _e278.name && "insert" == _e278.type && (_n252 = _e278.position.nodeAfter), "tableRow" != _e278.name && "tableCell" != _e278.name || (_n252 = ep("table", _e278.position)), Wp(_e278) && (_n252 = ep("table", _e278.range.start)), _n252 && !o.has(_n252) && (i = Hp(_n252, t) || i, i = qp(_n252, t) || i, o.add(_n252));
            }
          } catch (err) {
            _iterator372.e(err);
          } finally {
            _iterator372.f();
          }

          return i;
        }(e, t);
      });
    }

    function Hp(t, e) {
      var n = !1;

      var i = function (t) {
        var e = parseInt(t.getAttribute("headingRows") || 0),
            n = t.childCount,
            i = [];

        var _iterator373 = _createForOfIteratorHelper(new ap(t)),
            _step373;

        try {
          for (_iterator373.s(); !(_step373 = _iterator373.n()).done;) {
            var _ref138 = _step373.value;
            var _o101 = _ref138.row;
            var _r59 = _ref138.rowspan;
            var _s39 = _ref138.cell;
            if (_r59 < 2) continue;

            var _t322 = _o101 < e,
                _a25 = _t322 ? e : n;

            if (_o101 + _r59 > _a25) {
              var _t323 = _a25 - _o101;

              i.push({
                cell: _s39,
                rowspan: _t323
              });
            }
          }
        } catch (err) {
          _iterator373.e(err);
        } finally {
          _iterator373.f();
        }

        return i;
      }(t);

      if (i.length) {
        n = !0;

        var _iterator374 = _createForOfIteratorHelper(i),
            _step374;

        try {
          for (_iterator374.s(); !(_step374 = _iterator374.n()).done;) {
            var _t324 = _step374.value;
            np("rowspan", _t324.rowspan, _t324.cell, e, 1);
          }
        } catch (err) {
          _iterator374.e(err);
        } finally {
          _iterator374.f();
        }
      }

      return n;
    }

    function qp(t, e) {
      var n = !1;

      var i = function (t) {
        var e = {};

        var _iterator375 = _createForOfIteratorHelper(new ap(t, {
          includeSpanned: !0
        })),
            _step375;

        try {
          for (_iterator375.s(); !(_step375 = _iterator375.n()).done;) {
            var _ref140 = _step375.value;
            var _n253 = _ref140.row;
            e[_n253] || (e[_n253] = 0), e[_n253] += 1;
          }
        } catch (err) {
          _iterator375.e(err);
        } finally {
          _iterator375.f();
        }

        return e;
      }(t),
          o = i[0];

      if (!Object.values(i).every(function (t) {
        return t === o;
      })) {
        var _o102 = Object.values(i).reduce(function (t, e) {
          return e > t ? e : t;
        }, 0);

        for (var _i206 = 0, _Object$entries2 = Object.entries(i); _i206 < _Object$entries2.length; _i206++) {
          var _ref143 = _Object$entries2[_i206];

          var _ref142 = _slicedToArray(_ref143, 2);

          var _r60 = _ref142[0];
          var _s40 = _ref142[1];

          var _i207 = _o102 - _s40;

          if (_i207) {
            for (var _n254 = 0; _n254 < _i207; _n254++) {
              ip(e, e.createPositionAt(t.getChild(_r60), "end"));
            }

            n = !0;
          }
        }
      }

      return n;
    }

    function Wp(t) {
      var e = "attribute" === t.type,
          n = t.attributeKey;
      return e && ("headingRows" === n || "colspan" === n || "rowspan" === n);
    }

    function Yp(t) {
      t.document.registerPostFixer(function (e) {
        return function (t, e) {
          var n = e.document.differ.getChanges();
          var i = !1;

          var _iterator376 = _createForOfIteratorHelper(n),
              _step376;

          try {
            for (_iterator376.s(); !(_step376 = _iterator376.n()).done;) {
              var _e279 = _step376.value;
              "insert" == _e279.type && "table" == _e279.name && (i = $p(_e279.position.nodeAfter, t) || i), "insert" == _e279.type && "tableRow" == _e279.name && (i = Gp(_e279.position.nodeAfter, t) || i), "insert" == _e279.type && "tableCell" == _e279.name && (i = Qp(_e279.position.nodeAfter, t) || i), Kp(_e279) && (i = Qp(_e279.position.parent, t) || i);
            }
          } catch (err) {
            _iterator376.e(err);
          } finally {
            _iterator376.f();
          }

          return i;
        }(e, t);
      });
    }

    function $p(t, e) {
      var n = !1;

      var _iterator377 = _createForOfIteratorHelper(t.getChildren()),
          _step377;

      try {
        for (_iterator377.s(); !(_step377 = _iterator377.n()).done;) {
          var _i208 = _step377.value;
          n = Gp(_i208, e) || n;
        }
      } catch (err) {
        _iterator377.e(err);
      } finally {
        _iterator377.f();
      }

      return n;
    }

    function Gp(t, e) {
      var n = !1;

      var _iterator378 = _createForOfIteratorHelper(t.getChildren()),
          _step378;

      try {
        for (_iterator378.s(); !(_step378 = _iterator378.n()).done;) {
          var _i209 = _step378.value;
          n = Qp(_i209, e) || n;
        }
      } catch (err) {
        _iterator378.e(err);
      } finally {
        _iterator378.f();
      }

      return n;
    }

    function Qp(t, e) {
      if (0 == t.childCount) return e.insertElement("paragraph", t), !0;
      var n = Array.from(t.getChildren()).filter(function (t) {
        return t.is("text");
      });

      var _iterator379 = _createForOfIteratorHelper(n),
          _step379;

      try {
        for (_iterator379.s(); !(_step379 = _iterator379.n()).done;) {
          var _t325 = _step379.value;
          e.wrap(e.createRangeOn(_t325), "paragraph");
        }
      } catch (err) {
        _iterator379.e(err);
      } finally {
        _iterator379.f();
      }

      return !!n.length;
    }

    function Kp(t) {
      return !(!t.position || !t.position.parent.is("tableCell")) && ("insert" == t.type && "$text" == t.name || "remove" == t.type);
    }

    function Jp(t) {
      t.document.registerPostFixer(function () {
        return function (t) {
          var e = t.document.differ,
              n = new Set();

          var _iterator380 = _createForOfIteratorHelper(e.getChanges()),
              _step380;

          try {
            for (_iterator380.s(); !(_step380 = _iterator380.n()).done;) {
              var _t327 = _step380.value;

              var _e280 = "insert" == _t327.type || "remove" == _t327.type ? _t327.position.parent : _t327.range.start.parent;

              _e280.is("tableCell") && Zp(_e280, _t327.type) && n.add(_e280);
            }
          } catch (err) {
            _iterator380.e(err);
          } finally {
            _iterator380.f();
          }

          if (n.size) {
            var _iterator381 = _createForOfIteratorHelper(n.values()),
                _step381;

            try {
              for (_iterator381.s(); !(_step381 = _iterator381.n()).done;) {
                var _t326 = _step381.value;
                e.refreshItem(_t326);
              }
            } catch (err) {
              _iterator381.e(err);
            } finally {
              _iterator381.f();
            }

            return !0;
          }

          return !1;
        }(t);
      });
    }

    function Zp(t, e) {
      if (!Array.from(t.getChildren()).some(function (t) {
        return t.is("paragraph");
      })) return !1;

      if ("attribute" == e) {
        var _e281 = Array.from(t.getChild(0).getAttributeKeys()).length;
        return 1 === t.childCount && _e281 < 2;
      }

      return t.childCount <= ("insert" == e ? 2 : 1);
    }

    n(85);

    var Xp = /*#__PURE__*/function (_Kl50) {
      _inherits(Xp, _Kl50);

      var _super157 = _createSuper(Xp);

      function Xp() {
        _classCallCheck(this, Xp);

        return _super157.apply(this, arguments);
      }

      _createClass(Xp, [{
        key: "init",
        value: function init() {
          var _this236 = this;

          var t = this.editor,
              e = t.model,
              n = e.schema,
              i = t.conversion;
          n.register("table", {
            allowWhere: "$block",
            allowAttributes: ["headingRows", "headingColumns"],
            isLimit: !0,
            isObject: !0,
            isBlock: !0
          }), n.register("tableRow", {
            allowIn: "table",
            isLimit: !0
          }), n.register("tableCell", {
            allowIn: "tableRow",
            allowAttributes: ["colspan", "rowspan"],
            isLimit: !0
          }), n.extend("$block", {
            allowIn: "tableCell"
          }), n.addChildCheck(function (t, e) {
            if ("table" == e.name && Array.from(t.getNames()).includes("table")) return !1;
          }), i.for("upcast").add(op()), i.for("editingDowncast").add(hp({
            asWidget: !0
          })), i.for("dataDowncast").add(hp()), i.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
          }), i.for("editingDowncast").add(up({
            asWidget: !0
          })), i.for("dataDowncast").add(up()), i.for("downcast").add(function (t) {
            return t.on("remove:tableRow", function (t, e, n) {
              t.stop();
              var i = n.writer,
                  o = n.mapper,
                  r = o.toViewPosition(e.position).getLastMatchingPosition(function (t) {
                return !t.item.is("tr");
              }).nodeAfter,
                  s = r.parent,
                  a = i.createRangeOn(r),
                  c = i.remove(a);

              var _iterator382 = _createForOfIteratorHelper(i.createRangeIn(c).getItems()),
                  _step382;

              try {
                for (_iterator382.s(); !(_step382 = _iterator382.n()).done;) {
                  var _t328 = _step382.value;
                  o.unbindViewElement(_t328);
                }
              } catch (err) {
                _iterator382.e(err);
              } finally {
                _iterator382.f();
              }

              s.childCount || i.remove(i.createRangeOn(s));
            }, {
              priority: "higher"
            });
          }), i.for("upcast").add(rp("td")), i.for("upcast").add(rp("th")), i.for("editingDowncast").add(fp({
            asWidget: !0
          })), i.for("dataDowncast").add(fp()), i.attributeToAttribute({
            model: "colspan",
            view: "colspan"
          }), i.attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
          }), i.for("editingDowncast").add(gp({
            asWidget: !0
          })), i.for("dataDowncast").add(gp()), i.for("editingDowncast").add(mp({
            asWidget: !0
          })), i.for("dataDowncast").add(mp()), t.commands.add("insertTable", new Pp(t)), t.commands.add("insertTableRowAbove", new Sp(t, {
            order: "above"
          })), t.commands.add("insertTableRowBelow", new Sp(t, {
            order: "below"
          })), t.commands.add("insertTableColumnLeft", new Mp(t, {
            order: "left"
          })), t.commands.add("insertTableColumnRight", new Mp(t, {
            order: "right"
          })), t.commands.add("removeTableRow", new Op(t)), t.commands.add("removeTableColumn", new Rp(t)), t.commands.add("splitTableCellVertically", new Ep(t, {
            direction: "vertically"
          })), t.commands.add("splitTableCellHorizontally", new Ep(t, {
            direction: "horizontally"
          })), t.commands.add("mergeTableCellRight", new Ip(t, {
            direction: "right"
          })), t.commands.add("mergeTableCellLeft", new Ip(t, {
            direction: "left"
          })), t.commands.add("mergeTableCellDown", new Ip(t, {
            direction: "down"
          })), t.commands.add("mergeTableCellUp", new Ip(t, {
            direction: "up"
          })), t.commands.add("setTableColumnHeader", new jp(t)), t.commands.add("setTableRowHeader", new Dp(t)), Up(e), Jp(e), Yp(e), this.editor.keystrokes.set("Tab", function () {
            return _this236._handleTabOnSelectedTable.apply(_this236, arguments);
          }, {
            priority: "low"
          }), this.editor.keystrokes.set("Tab", this._getTabHandler(!0), {
            priority: "low"
          }), this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(!1), {
            priority: "low"
          });
        }
      }, {
        key: "_handleTabOnSelectedTable",
        value: function _handleTabOnSelectedTable(t, e) {
          var n = this.editor,
              i = n.model.document.selection;

          if (!i.isCollapsed && 1 === i.rangeCount && i.getFirstRange().isFlat) {
            var _t329 = i.getSelectedElement();

            if (!_t329 || !_t329.is("table")) return;
            e(), n.model.change(function (e) {
              e.setSelection(e.createRangeIn(_t329.getChild(0).getChild(0)));
            });
          }
        }
      }, {
        key: "_getTabHandler",
        value: function _getTabHandler(t) {
          var e = this.editor;
          return function (n, i) {
            var o = ep("tableCell", e.model.document.selection.getFirstPosition());
            if (!o) return;
            i();
            var r = o.parent,
                s = r.parent,
                a = s.getChildIndex(r),
                c = r.getChildIndex(o),
                l = 0 === c;
            if (!t && l && 0 === a) return;
            var d = c === r.childCount - 1,
                h = a === s.childCount - 1;
            if (t && h && d && (e.execute("insertTableRowBelow"), a === s.childCount - 1)) return;
            var u;

            if (t && d) {
              var _t330 = s.getChild(a + 1);

              u = _t330.getChild(0);
            } else if (!t && l) {
              var _t331 = s.getChild(a - 1);

              u = _t331.getChild(_t331.childCount - 1);
            } else u = r.getChild(c + (t ? 1 : -1));

            e.model.change(function (t) {
              t.setSelection(t.createRangeIn(u));
            });
          };
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Vp];
        }
      }]);

      return Xp;
    }(Kl);

    n(87);

    var tb = /*#__PURE__*/function (_Dl26) {
      _inherits(tb, _Dl26);

      var _super158 = _createSuper(tb);

      function tb(t) {
        var _this237;

        _classCallCheck(this, tb);

        _this237 = _super158.call(this, t);
        var e = _this237.bindTemplate;
        _this237.items = _this237.createCollection(), _this237.set("rows", 0), _this237.set("columns", 0), _this237.bind("label").to(_assertThisInitialized(_this237), "columns", _assertThisInitialized(_this237), "rows", function (t, e) {
          return "".concat(e, " \xD7 ").concat(t);
        }), _this237.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            children: _this237.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__label"]
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function () {
              _this237.fire("execute");
            })
          }
        });

        var _loop9 = function _loop9(_t332) {
          var e = new eb();
          e.on("over", function () {
            var e = Math.floor(_t332 / 10),
                n = _t332 % 10;
            _this237.set("rows", e + 1), _this237.set("columns", n + 1);
          }), _this237.items.add(e);
        };

        for (var _t332 = 0; _t332 < 100; _t332++) {
          _loop9(_t332);
        }

        _this237.on("change:columns", function () {
          _this237._highlightGridBoxes();
        }), _this237.on("change:rows", function () {
          _this237._highlightGridBoxes();
        });
        return _this237;
      }

      _createClass(tb, [{
        key: "focus",
        value: function focus() {}
      }, {
        key: "focusLast",
        value: function focusLast() {}
      }, {
        key: "_highlightGridBoxes",
        value: function _highlightGridBoxes() {
          var t = this.rows,
              e = this.columns;
          this.items.map(function (n, i) {
            var o = Math.floor(i / 10) < t && i % 10 < e;
            n.set("isOn", o);
          });
        }
      }]);

      return tb;
    }(Dl);

    var eb = /*#__PURE__*/function (_Dl27) {
      _inherits(eb, _Dl27);

      var _super159 = _createSuper(eb);

      function eb(t) {
        var _this238;

        _classCallCheck(this, eb);

        _this238 = _super159.call(this, t);
        var e = _this238.bindTemplate;
        _this238.set("isOn", !1), _this238.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-insert-table-dropdown-grid-box", e.if("isOn", "ck-on")]
          },
          on: {
            mouseover: e.to("over")
          }
        });
        return _this238;
      }

      return eb;
    }(Dl);

    var nb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>',
        ib = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>',
        ob = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>',
        rb = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>';

    var sb = /*#__PURE__*/function (_Kl51) {
      _inherits(sb, _Kl51);

      var _super160 = _createSuper(sb);

      function sb() {
        _classCallCheck(this, sb);

        return _super160.apply(this, arguments);
      }

      _createClass(sb, [{
        key: "init",
        value: function init() {
          var _this239 = this;

          var t = this.editor,
              e = this.editor.t;
          t.ui.componentFactory.add("insertTable", function (n) {
            var i = t.commands.get("insertTable"),
                o = Sf(n);
            o.bind("isEnabled").to(i), o.buttonView.set({
              icon: nb,
              label: e("s"),
              tooltip: !0
            });
            var r = new tb(n);
            return o.panelView.children.add(r), r.delegate("execute").to(o), o.buttonView.on("open", function () {
              r.rows = 0, r.columns = 0;
            }), o.on("execute", function () {
              t.execute("insertTable", {
                rows: r.rows,
                columns: r.columns
              }), t.editing.view.focus();
            }), o;
          }), t.ui.componentFactory.add("tableColumn", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableColumnHeader",
                label: e("t"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableColumnLeft",
                label: e("u")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableColumnRight",
                label: e("v")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableColumn",
                label: e("w")
              }
            }];
            return _this239._prepareDropdown(e("x"), ib, n, t);
          }), t.ui.componentFactory.add("tableRow", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableRowHeader",
                label: e("y"),
                bindIsOn: !0
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowBelow",
                label: e("z")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowAbove",
                label: e("aa")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableRow",
                label: e("ab")
              }
            }];
            return _this239._prepareDropdown(e("ac"), ob, n, t);
          }), t.ui.componentFactory.add("mergeTableCells", function (t) {
            var n = [{
              type: "button",
              model: {
                commandName: "mergeTableCellUp",
                label: e("ad")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellRight",
                label: e("ae")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellDown",
                label: e("af")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellLeft",
                label: e("ag")
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellVertically",
                label: e("ah")
              }
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellHorizontally",
                label: e("ai")
              }
            }];
            return _this239._prepareDropdown(e("aj"), rb, n, t);
          });
        }
      }, {
        key: "_prepareDropdown",
        value: function _prepareDropdown(t, e, n, i) {
          var o = this.editor,
              r = Sf(i),
              s = [],
              a = new oo();

          var _iterator383 = _createForOfIteratorHelper(n),
              _step383;

          try {
            for (_iterator383.s(); !(_step383 = _iterator383.n()).done;) {
              var _t333 = _step383.value;
              ab(_t333, o, s, a);
            }
          } catch (err) {
            _iterator383.e(err);
          } finally {
            _iterator383.f();
          }

          return Mf(r, a), r.buttonView.set({
            label: t,
            icon: e,
            tooltip: !0
          }), r.bind("isEnabled").toMany(s, "isEnabled", function () {
            for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
              t[_key19] = arguments[_key19];
            }

            return t.some(function (t) {
              return t;
            });
          }), this.listenTo(r, "execute", function (t) {
            o.execute(t.source.commandName), o.editing.view.focus();
          }), r;
        }
      }]);

      return sb;
    }(Kl);

    function ab(t, e, n, i) {
      var o = t.model = new kf(t.model),
          _t$model = t.model,
          r = _t$model.commandName,
          s = _t$model.bindIsOn;

      if ("separator" !== t.type) {
        var _t334 = e.commands.get(r);

        n.push(_t334), o.set({
          commandName: r
        }), o.bind("isEnabled").to(_t334), s && o.bind("isOn").to(_t334, "value");
      }

      o.set({
        withText: !0
      }), i.add(t);
    }

    n(89);
    n.d(e, "default", function () {
      return cb;
    });

    var cb = /*#__PURE__*/function (_Ql) {
      _inherits(cb, _Ql);

      var _super161 = _createSuper(cb);

      function cb() {
        _classCallCheck(this, cb);

        return _super161.apply(this, arguments);
      }

      return cb;
    }(Ql);

    cb.builtinPlugins = [/*#__PURE__*/function (_Kl52) {
      _inherits(_class2, _Kl52);

      var _super162 = _createSuper(_class2);

      function _class2() {
        _classCallCheck(this, _class2);

        return _super162.apply(this, arguments);
      }

      _createClass(_class2, null, [{
        key: "requires",
        get: function get() {
          return [td, ad, hd, Td, Qd];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Essentials";
        }
      }]);

      return _class2;
    }(Kl), oh, /*#__PURE__*/function (_Kl53) {
      _inherits(_class3, _Kl53);

      var _super163 = _createSuper(_class3);

      function _class3() {
        _classCallCheck(this, _class3);

        return _super163.apply(this, arguments);
      }

      _createClass(_class3, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var t = this.editor.commands;
          t.get("bulletedList") && new sh(this.editor, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && new sh(this.editor, /^1[.|)]\s$/, "numberedList");
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var t = this.editor.commands;

          if (t.get("bold")) {
            var _t335 = lh(this.editor, "bold");

            new ah(this.editor, /(\*\*)([^*]+)(\*\*)$/g, _t335), new ah(this.editor, /(__)([^_]+)(__)$/g, _t335);
          }

          if (t.get("italic")) {
            var _t336 = lh(this.editor, "italic");

            new ah(this.editor, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, _t336), new ah(this.editor, /(?:^|[^_])(_)([^_]+)(_)$/g, _t336);
          }

          if (t.get("code")) {
            var _t337 = lh(this.editor, "code");

            new ah(this.editor, /(`)([^`]+)(`)$/g, _t337);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this240 = this;

          var t = this.editor.commands.get("heading");
          t && t.modelElements.filter(function (t) {
            return t.match(/^heading[1-6]$/);
          }).forEach(function (e) {
            var n = e[7],
                i = new RegExp("^(#{".concat(n, "})\\s$"));
            new sh(_this240.editor, i, function () {
              if (!t.isEnabled) return !1;

              _this240.editor.execute("heading", {
                value: e
              });
            });
          });
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && new sh(this.editor, /^>\s$/, "blockQuote");
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);

      return _class3;
    }(Kl), /*#__PURE__*/function (_Kl54) {
      _inherits(_class4, _Kl54);

      var _super164 = _createSuper(_class4);

      function _class4() {
        _classCallCheck(this, _class4);

        return _super164.apply(this, arguments);
      }

      _createClass(_class4, null, [{
        key: "requires",
        get: function get() {
          return [uh, gh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Bold";
        }
      }]);

      return _class4;
    }(Kl), /*#__PURE__*/function (_Kl55) {
      _inherits(_class5, _Kl55);

      var _super165 = _createSuper(_class5);

      function _class5() {
        _classCallCheck(this, _class5);

        return _super165.apply(this, arguments);
      }

      _createClass(_class5, null, [{
        key: "requires",
        get: function get() {
          return [bh, _h];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Italic";
        }
      }]);

      return _class5;
    }(Kl), /*#__PURE__*/function (_Kl56) {
      _inherits(_class6, _Kl56);

      var _super166 = _createSuper(_class6);

      function _class6() {
        _classCallCheck(this, _class6);

        return _super166.apply(this, arguments);
      }

      _createClass(_class6, null, [{
        key: "requires",
        get: function get() {
          return [Ch, Sh];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);

      return _class6;
    }(Kl), /*#__PURE__*/function (_Kl57) {
      _inherits(_class7, _Kl57);

      var _super167 = _createSuper(_class7);

      function _class7() {
        _classCallCheck(this, _class7);

        return _super167.apply(this, arguments);
      }

      _createClass(_class7, null, [{
        key: "pluginName",
        get: function get() {
          return "CKFinder";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Rh, Eh, oh];
        }
      }]);

      return _class7;
    }(Kl), /*#__PURE__*/function (_Kl58) {
      _inherits(_class8, _Kl58);

      var _super168 = _createSuper(_class8);

      function _class8() {
        _classCallCheck(this, _class8);

        return _super168.apply(this, arguments);
      }

      _createClass(_class8, null, [{
        key: "requires",
        get: function get() {
          return [Fh, Hu, lf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "EasyImage";
        }
      }]);

      return _class8;
    }(Kl), /*#__PURE__*/function (_Kl59) {
      _inherits(_class9, _Kl59);

      var _super169 = _createSuper(_class9);

      function _class9() {
        _classCallCheck(this, _class9);

        return _super169.apply(this, arguments);
      }

      _createClass(_class9, null, [{
        key: "requires",
        get: function get() {
          return [wf, Ef];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Heading";
        }
      }]);

      return _class9;
    }(Kl), Hu, /*#__PURE__*/function (_Kl60) {
      _inherits(_class10, _Kl60);

      var _super170 = _createSuper(_class10);

      function _class10() {
        _classCallCheck(this, _class10);

        return _super170.apply(this, arguments);
      }

      _createClass(_class10, null, [{
        key: "requires",
        get: function get() {
          return [Of];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaption";
        }
      }]);

      return _class10;
    }(Kl), /*#__PURE__*/function (_Kl61) {
      _inherits(_class11, _Kl61);

      var _super171 = _createSuper(_class11);

      function _class11() {
        _classCallCheck(this, _class11);

        return _super171.apply(this, arguments);
      }

      _createClass(_class11, null, [{
        key: "requires",
        get: function get() {
          return [Gf, Qf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyle";
        }
      }]);

      return _class11;
    }(Kl), /*#__PURE__*/function (_Kl62) {
      _inherits(_class12, _Kl62);

      var _super172 = _createSuper(_class12);

      function _class12() {
        _classCallCheck(this, _class12);

        return _super172.apply(this, arguments);
      }

      _createClass(_class12, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.t;
          t.plugins.get(Kf).register("image", {
            ariaLabel: e("b"),
            items: t.config.get("image.toolbar") || [],
            getRelatedElement: ou
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Kf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageToolbar";
        }
      }]);

      return _class12;
    }(Kl), lf, /*#__PURE__*/function (_Kl63) {
      _inherits(_class13, _Kl63);

      var _super173 = _createSuper(_class13);

      function _class13() {
        _classCallCheck(this, _class13);

        return _super173.apply(this, arguments);
      }

      _createClass(_class13, null, [{
        key: "requires",
        get: function get() {
          return [Hm, Jm];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Link";
        }
      }]);

      return _class13;
    }(Kl), /*#__PURE__*/function (_Kl64) {
      _inherits(_class14, _Kl64);

      var _super174 = _createSuper(_class14);

      function _class14() {
        _classCallCheck(this, _class14);

        return _super174.apply(this, arguments);
      }

      _createClass(_class14, null, [{
        key: "requires",
        get: function get() {
          return [yg, Cg];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "List";
        }
      }]);

      return _class14;
    }(Kl), /*#__PURE__*/function (_Kl65) {
      _inherits(_class15, _Kl65);

      var _super175 = _createSuper(_class15);

      function _class15() {
        _classCallCheck(this, _class15);

        return _super175.apply(this, arguments);
      }

      _createClass(_class15, null, [{
        key: "requires",
        get: function get() {
          return [jg, Ug, zg, fu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);

      return _class15;
    }(Kl), uf, /*#__PURE__*/function (_Kl66) {
      _inherits(_class16, _Kl66);

      var _super176 = _createSuper(_class16);

      function _class16() {
        _classCallCheck(this, _class16);

        return _super176.apply(this, arguments);
      }

      _createClass(_class16, [{
        key: "init",
        value: function init() {
          var t = this.editor,
              e = [];
          e.push(new tp()), e.push(new $g()), t.plugins.get("Clipboard").on("inputTransformation", function (t, n) {
            if (n.isTransformedWithPasteFromOffice) return;
            var i = n.dataTransfer.getData("text/html"),
                o = e.find(function (t) {
              return t.isActive(i);
            });
            o && (o.execute(n), n.isTransformedWithPasteFromOffice = !0);
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }, {
        key: "requires",
        get: function get() {
          return [td];
        }
      }]);

      return _class16;
    }(Kl), /*#__PURE__*/function (_Kl67) {
      _inherits(_class17, _Kl67);

      var _super177 = _createSuper(_class17);

      function _class17() {
        _classCallCheck(this, _class17);

        return _super177.apply(this, arguments);
      }

      _createClass(_class17, null, [{
        key: "requires",
        get: function get() {
          return [Xp, sb, fu];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Table";
        }
      }]);

      return _class17;
    }(Kl), /*#__PURE__*/function (_Kl68) {
      _inherits(_class18, _Kl68);

      var _super178 = _createSuper(_class18);

      function _class18() {
        _classCallCheck(this, _class18);

        return _super178.apply(this, arguments);
      }

      _createClass(_class18, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
              e = t.t,
              n = t.plugins.get(Kf),
              i = t.config.get("table.contentToolbar"),
              o = t.config.get("table.tableToolbar");
          i && n.register("tableContent", {
            ariaLabel: e("c"),
            items: i,
            getRelatedElement: dp
          }), o && n.register("table", {
            ariaLabel: e("c"),
            items: o,
            getRelatedElement: lp
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [Kf];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "TableToolbar";
        }
      }]);

      return _class18;
    }(Kl)], cb.defaultConfig = {
      toolbar: {
        items: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "imageUpload", "blockQuote", "insertTable", "mediaEmbed", "undo", "redo"]
      },
      image: {
        toolbar: ["imageStyle:full", "imageStyle:side", "|", "imageTextAlternative"]
      },
      table: {
        contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"]
      },
      language: "en"
    };
  }]).default;
});